import gql from 'graphql-tag';
import * as React from 'react';
import * as ReactApollo from 'react-apollo';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  AddressId: any,
  UserId: any,
  CategoryId: any,
  AttributeSchemaId: any,
  SessionId: any,
  AnyId: any,
  BrandId: any,
  MediaId: any,
  ContactId: any,
  MerchantId: any,
  BusinessAccountId: any,
  OperatorId: any,
  PathFlowId: any,
  DealRequestId: any,
  /** Date and time component in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601 */
  Date: any,
  /** Long type */
  Long: any,
  /** Built-in java.math.BigDecimal */
  BigDecimal: any,
  /** Only time in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601#Times */
  Time: any,
  ConversationId: any,
  LeadId: any,
  LeadLabelId: any,
  BroadcastOfferId: any,
  OrderId: any,
  /** javax.money.CurrencyUnit stored in ISO 4217 currency code standard, which use 3 letter codes */
  CurrencyUnit: any,
  ShippingCarrierId: any,
  TransactionId: any,
  PaymentSourceId: any,
  PaymentProcessorAccountId: any,
  OrderLineItemId: any,
  SellableTermsId: any,
  ExpertCuratedItemId: any,
  SellableId: any,
  SellablePriceSourceId: any,
  SavedSellableId: any,
  DepartmentId: any,
  BusinessUserTeamId: any,
  ConsumerExpertReviewId: any,
  ConsumerSellableReactionId: any,
  ExpertCuratedItemNoteId: any,
  ScheduledPaymentId: any,
  PromotionId: any,
  PromotionRuleReferenceId: any,
  PromotionActionReferenceId: any,
  SimpleCuratedOrderId: any,
  BusinessUserId: any,
  OrderEscalationId: any,
  SupportConversationId: any,
  PostCartOrderActivityId: any,
  DealId: any,
  LeadNoteId: any,
  ExpertRecommendationId: any,
  LeadCampaignId: any,
  SystemCuratedItemSurveyId: any,
  SystemCuratedItemId: any,
  LeadEscalationId: any,
  LeadActivityId: any,
  SupportTaskActivityId: any,
  SupportTaskId: any,
  SystemId: any,
  ExpertApplicationId: any,
  ExpertProfileId: any,
  ProfileHighlightTypeId: any,
  PathFlowPageId: any,
  UserActivityId: any,
  BusinessUserActivityId: any,
  PayStructureId: any,
  PayStructureRevisionId: any,
  CommTemplateId: any,
  CommTemplateTypeId: any,
  CommTemplateFragmentId: any,
  PendingAccessContactId: any,
  FrontendTaskId: any,
  CallActivityId: any,
  GuestConversationSequenceId: any,
  TagId: any,
  ExpertApplicationFolderId: any,
  ExpertReferralId: any,
  SellableResearchLinkId: any,
  QuickReplyId: any,
  ExpertLeadFolderId: any,
  PredictedLifeTimeValueId: any,
  TriggerId: any,
  TriggerNodeId: any,
  LeadCampaignRecipientId: any,
  SavedSearchId: any,
  AirportId: any,
  ReportId: any,
  ExpertCuratedItemActivationId: any,
  ExpertCuratedOrderId: any,
  FlightPlanId: any,
  FlightPlanLegId: any,
  /** Date only component in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates */
  LocalDate: any,
  ExpertCuratedOrderListActivationId: any,
  ExpertCuratedActivityFeedItemId: any,
  SavedExpertCuratedItemsId: any,
  RecommendedListDefinitionId: any,
  ConfigEntryId: any,
  ExternalAdCampaignId: any,
  ExternalAdGroupId: any,
  SupportTaskFolderId: any,
  SellableInventoryItemId: any,
  FulfillmentCenterId: any,
  PayoutId: any,
  PayLineItemId: any,
  RawSellableSourceId: any,
  RawSellableId: any,
  StandardizedSellableId: any,
  StandardizedSellableGroupId: any,
  RawSellableStandardizationRuleId: any,
  SchedulingTypeId: any,
  SchedulingDemandForecastId: any,
  SchedulingUserAvailabilityId: any,
  ShiftId: any,
  PathSchemaId: any,
  /** The scalar type for multipart file uploads. It should be used for input only. */
  Upload: any,
};


export type AcceptEscalationInput = {
  id: Scalars['LeadEscalationId'],
};

export type AcceptEscalationResult = {
  __typename: 'AcceptEscalationResult',
  status: AcceptEscalationResultStatus,
  escalation: LeadEscalation,
};

export enum AcceptEscalationResultStatus {
  ACCEPTED = 'ACCEPTED',
  ALREADY_CLAIMED = 'ALREADY_CLAIMED',
  ESCALATION_CLOSED = 'ESCALATION_CLOSED'
}

export enum AcceptRequestMode {
  ALWAYS = 'ALWAYS',
  WHEN_ACTIVATED = 'WHEN_ACTIVATED',
  WHEN_ACTIVATED_AND_AS_BACKUP = 'WHEN_ACTIVATED_AND_AS_BACKUP'
}

export type AcceptShiftPayload = {
  __typename: 'AcceptShiftPayload',
  error?: Maybe<Scalars['String']>,
  shift?: Maybe<Shift>,
};

export type ActivateExpertCuratedOrderAsBookableInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type ActivateExpertCuratedOrderAsBookablePayload = {
  __typename: 'ActivateExpertCuratedOrderAsBookablePayload',
  /** The expert curated order that was activated if `hasError` is `false`, or the latest state of the still draft expert
   * curated order
 */
  expertCuratedOrder: ExpertCuratedOrder,
  /** If there was an error activating the curated order */
  hasError: Scalars['Boolean'],
  /** User displayable message for why the activation failed */
  errorMessage?: Maybe<Scalars['String']>,
};

export type ActivateExpertCuratedOrdersForLeadInput = {
  leadId: Scalars['LeadId'],
};

export type ActivateExpertCuratedOrdersForLeadPayload = {
  __typename: 'ActivateExpertCuratedOrdersForLeadPayload',
  /** If successful, hasError will be false, and activation will be present */
  activation?: Maybe<ExpertCuratedOrderListActivation>,
  /** If there were any errors encountered while activating the curated orders. If true, `errors` will be non empty,
   * and/or errorMessage will have a top level error message
 */
  hasError: Scalars['Boolean'],
  /** Individual errors for each expert curated order */
  errors: Array<ExpertCuratedOrderActivationError>,
  /** Top level error that's not associated with a particular ExpertCuratedOrder. This is mutually exclusive with
   * `errors` that contain errors for particular expert curated orders.
 */
  errorMessage?: Maybe<Scalars['String']>,
};

export type ActivateFlightPlanInput = {
  id: Scalars['FlightPlanId'],
};

export type ActivateFlightPlanPayload = {
  __typename: 'ActivateFlightPlanPayload',
  flightPlan: FlightPlan,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type ActivateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'],
};

export type ActivateGuestConversationSequencePayload = {
  __typename: 'ActivateGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type ActivatePayStructureRevisionInput = {
  id: Scalars['PayStructureRevisionId'],
};

export type ActivatePromotionInput = {
  id: Scalars['PromotionId'],
};

export type ActivatePromotionPayload = {
  __typename: 'ActivatePromotionPayload',
  promotion: Promotion,
  /** The promotion that was previously active with the same promotion code, but was deactivated as a result of
   * `promotion` being activated.
 */
  replacedPromotion?: Maybe<Promotion>,
};

export type AddAddressInput = {
  userId: Scalars['UserId'],
  addressFieldInput?: Maybe<AddressFieldInput>,
};

export type AddAddresssPayload = {
  __typename: 'AddAddresssPayload',
  address?: Maybe<Address>,
  error?: Maybe<Scalars['String']>,
};

export type AddBlacklistChannelAddressInput = {
  type: MessagingChannelType,
  address: Scalars['String'],
};

export type AddBlacklistChannelAddressPayload = {
  __typename: 'AddBlacklistChannelAddressPayload',
  hasError: Scalars['Boolean'],
};

export type AddChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  channelType: ChannelType,
};

export type AddEscalationOperatorNoteInput = {
  escalationId: Scalars['OrderEscalationId'],
  note: Scalars['String'],
};

export type AddExpertApplicationNoteInput = {
  applicationId: Scalars['ExpertApplicationId'],
  note: Scalars['String'],
};

export type AddExpertApplicationReviewInput = {
  applicationId: Scalars['ExpertApplicationId'],
  rating: ExpertApplicationRating,
  reason?: Maybe<Scalars['String']>,
};

export type AddExpertApplicationReviewPayload = {
  __typename: 'AddExpertApplicationReviewPayload',
  application: ExpertApplication,
};

export type AddExpertCuratedItemToCartInput = {
  id: Scalars['ExpertCuratedItemId'],
};

export type AddExpertCuratedItemToCartPayload = {
  __typename: 'AddExpertCuratedItemToCartPayload',
  expertCuratedItem: ExpertCuratedItem,
  order: Order,
};

export type AddGuestConversationSequenceMessageInput = {
  sequenceId: Scalars['GuestConversationSequenceId'],
  templateName: Scalars['String'],
};

export type AddGuestConversationSequenceMessagePayload = {
  __typename: 'AddGuestConversationSequenceMessagePayload',
  sequence: GuestConversationSequence,
};

export type AddItemsToOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  /** Simplified API that only adds sellables */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>,
  sellables?: Maybe<Array<AddItemsToOrderSellableInput>>,
};

export type AddItemsToOrderPayload = {
  __typename: 'AddItemsToOrderPayload',
  order: Order,
};

export type AddItemsToOrderSellableInput = {
  sellableId: Scalars['SellableId'],
  /** Quantity of items to add; defaults to 1 if omitted */
  quantity?: Maybe<Scalars['Int']>,
  /** Expert only property; if this line item is explicitly marked as not taxable.
   * Note that by this being `false` does not mean this line item is guaranteed to be taxed - it just means the
   * natural taxation logic will apply to this item.
 */
  nonTaxable?: Maybe<Scalars['Boolean']>,
  /** Expert only property; override the sellable price with a custom one */
  priceOverride?: Maybe<MonetaryAmountInput>,
};

export type AddManualAdjustmentPayLineItemInput = {
  payoutId: Scalars['PayoutId'],
  amount: MonetaryAmountInput,
  reason: Scalars['String'],
};

export type AddOfferToCartInput = {
  id: Scalars['BroadcastOfferId'],
};

export type AddOfferToCartPayload = {
  __typename: 'AddOfferToCartPayload',
  order: Order,
};

export type AddOperatorNoteInput = {
  orderId: Scalars['OrderId'],
  title?: Maybe<Scalars['String']>,
  note: Scalars['String'],
  emailSupport?: Maybe<Scalars['Boolean']>,
};

export type AddProfileHighlightInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  highlight: ProfileHighlightInput,
};

export type AddPromotionToOrderInput = {
  id: Scalars['OrderId'],
  promotionCode: Scalars['String'],
};

export type AddPromotionToOrderPayload = {
  __typename: 'AddPromotionToOrderPayload',
  order: Order,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

/** Use Address if you want to save Address data in a separate collection vs PostalAddress,
 * which is used as an embeddable object
 * All new implementations should prefer Address going forward as they allows reusablity of Addresses
 */
export type Address = AddressFields & {
  __typename: 'Address',
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryDetails?: Maybe<Country>,
  postalCode: Scalars['String'],
  securityCode?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
  id: Scalars['AddressId'],
  userId: Scalars['UserId'],
  active: Scalars['Boolean'],
  userFriendlyName?: Maybe<Scalars['String']>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type AddressFieldInput = {
  reusableAddress?: Maybe<Scalars['Boolean']>,
  addresseeName: Scalars['String'],
  businessName?: Maybe<Scalars['String']>,
  line1: Scalars['String'],
  line2?: Maybe<Scalars['String']>,
  city: Scalars['String'],
  state?: Maybe<Scalars['String']>,
  country: Scalars['String'],
  postalCode: Scalars['String'],
  securityCode?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
  userFriendlyName?: Maybe<Scalars['String']>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type AddressFields = {
  __typename: 'AddressFields',
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryDetails?: Maybe<Country>,
  postalCode: Scalars['String'],
};


/** Either addressId or addressFieldInput must be provided */
export type AddressInput = {
  addressId?: Maybe<Scalars['AddressId']>,
  addressFieldInput?: Maybe<AddressFieldInput>,
};

export type AddScheduleReportInput = {
  reportId: Scalars['ReportId'],
  refreshIntervalInMinutes: Scalars['Int'],
  runImmediately: Scalars['Boolean'],
};

export type AddTipToOrderInput = {
  id: Scalars['OrderId'],
  tip: MonetaryAmountInput,
  /** It is required to indicate which expert receives the tip. All entries in this array must add up to 100%.
   * Use `recommendTipPercentagesForOrder` to get recommended experts and tip percentages
 */
  tipPercentages: Array<ExpertTipPercentageInput>,
};

export type AddTipToOrderPayload = {
  __typename: 'AddTipToOrderPayload',
  order: Order,
};

export type AddUserInfoForLeadInput = {
  leadId: Scalars['LeadId'],
  firstName: Scalars['String'],
  lastName?: Maybe<Scalars['String']>,
  emailAddress?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
};

export type AddUserInfoForLeadPayload = {
  __typename: 'AddUserInfoForLeadPayload',
  lead: Lead,
};

export type AdministrativeArea = {
  __typename: 'AdministrativeArea',
  /** country code this administrative area is associated with, e.g.: "US", "AU", etc */
  countryCode: Scalars['String'],
  /** the code for this administrative area, e.g.: "CA" for California in US */
  code: Scalars['String'],
  /** the display name for this administrative area, e.g.: "California" */
  displayName: Scalars['String'],
};

export type AffirmAccount = PaymentProcessorAccount & {
  __typename: 'AffirmAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt?: Maybe<Scalars['Date']>,
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources: Array<PaymentSource>,
  /** This is same as email but with Affirm prefix, as the Affirm doesn't return an Id in the response. */
  externalAccountId: Scalars['String'],
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type AffirmPaymentSource = PaymentSource & {
  __typename: 'AffirmPaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt?: Maybe<Scalars['Date']>,
  updatedAt?: Maybe<Scalars['Date']>,
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
};

export type AfterPayAccount = PaymentProcessorAccount & {
  __typename: 'AfterPayAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt?: Maybe<Scalars['Date']>,
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources: Array<PaymentSource>,
  /** This is same as email but with Afterpay prefix, as the Afterpay doesn't return an Id in the response. */
  externalAccountId: Scalars['String'],
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type AfterpayPaymentSource = PaymentSource & {
  __typename: 'AfterpayPaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt?: Maybe<Scalars['Date']>,
  updatedAt?: Maybe<Scalars['Date']>,
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
};

export type AggregateExpertReport = {
  __typename: 'AggregateExpertReport',
  globalStats: GlobalStatsAggregateExpertReport,
  categoryBrandStats: Array<BrandStatsAggregateExpertReport>,
  categoryGroupedBrandStats: CategoryGroupedBrandStatsAggregateExpertReport,
  departmentBrandStats: Array<BrandStatsAggregateExpertReport>,
};


export type AggregateExpertReportCategoryBrandStatsArgs = {
  categoryId: Scalars['CategoryId'],
  limit: Scalars['Int']
};


export type AggregateExpertReportCategoryGroupedBrandStatsArgs = {
  departmentId: Scalars['DepartmentId']
};


export type AggregateExpertReportDepartmentBrandStatsArgs = {
  departmentId: Scalars['DepartmentId'],
  limit: Scalars['Int']
};

export type Airport = {
  __typename: 'Airport',
  id: Scalars['AirportId'],
  type: AirportType,
  active: Scalars['Boolean'],
  name: Scalars['String'],
  latitudeDegree: Scalars['Float'],
  longitudeDegree: Scalars['Float'],
  continentCode: Scalars['String'],
  countryCode: Scalars['String'],
  zoneId: Scalars['String'],
  dataSourceCode: Scalars['String'],
  iataCode?: Maybe<Scalars['String']>,
  icaoCode?: Maybe<Scalars['String']>,
  displayCode: Scalars['String'],
};


export enum AirportType {
  LARGE_AIRPORT = 'LARGE_AIRPORT',
  MEDIUM_AIRPORT = 'MEDIUM_AIRPORT',
  SMALL_AIRPORT = 'SMALL_AIRPORT'
}

export type AirportTypeaheadHit = {
  __typename: 'AirportTypeaheadHit',
  id: Scalars['AirportId'],
  /** The matched text string in the indexed keywords */
  text: Scalars['String'],
  /** The airport name */
  name: Scalars['String'],
  dataSourceCode: Scalars['String'],
  iataCode?: Maybe<Scalars['String']>,
  icaoCode?: Maybe<Scalars['String']>,
  displayCode: Scalars['String'],
  airport: Airport,
};

export type AirportTypeaheadPayload = {
  __typename: 'AirportTypeaheadPayload',
  hits: Array<AirportTypeaheadHit>,
};

export type AirportTypeaheadQuery = {
  prefixSearch?: Maybe<Scalars['String']>,
};

export type AmazonSellablePriceSource = SellablePriceSource & {
  __typename: 'AmazonSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  asin: Scalars['String'],
};

/** Flat amount taken off the order. This is implemented by taking the amount off of line items that meet
 * `Promotion.rules` criteria. If the amount off is more than the cost of the line items, the promotion will not be
 * applied as its assumed it's an error in defining the promotion action.
 */
export type AmountOffOrderPromotionActionReference = PromotionActionReference & {
  __typename: 'AmountOffOrderPromotionActionReference',
  id: Scalars['PromotionActionReferenceId'],
  type: PromotionActionType,
  /** Total amount off order; amount greater than zero */
  amountOff: MonetaryAmount,
};

/** See `AmountOffOrderPromotionActionReference` for documentation */
export type AmountOffOrderPromotionActionReferenceInput = {
  /** Total amount off order; amount greater than zero */
  amountOff: MonetaryAmountInput,
};


export type ApplyExternalAdBudgetInput = {
  categoryId: Scalars['CategoryId'],
};

export type ApplyExternalAdBudgetPayload = {
  __typename: 'ApplyExternalAdBudgetPayload',
  hasError: Scalars['Boolean'],
};

export type ApproveExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'],
};

export type ApproveExpertApplicationPayload = {
  __typename: 'ApproveExpertApplicationPayload',
  application: ExpertApplication,
};

export type AssignEscalationInput = {
  escalationId: Scalars['OrderEscalationId'],
  assignedToId: Scalars['OperatorId'],
};

export type AssignFulfillmentOperatorInput = {
  orderId: Scalars['OrderId'],
  operatorId: Scalars['OperatorId'],
};

export type AssignSupportTaskActivity = SupportTaskActivity & {
  __typename: 'AssignSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  assignedTo: Operator,
};

export type AssignSupportTaskInput = {
  supportTaskId: Scalars['SupportTaskId'],
  assigneeId?: Maybe<Scalars['OperatorId']>,
};

export type AssignSupportTaskPayload = {
  __typename: 'AssignSupportTaskPayload',
  supportTask: SupportTask,
  error?: Maybe<Scalars['String']>,
};

export type AssumeBusinessUserIdentityInput = {
  businessUserId: Scalars['BusinessUserId'],
};

export type AssumeBusinessUserIdentityPayload = {
  __typename: 'AssumeBusinessUserIdentityPayload',
  myself?: Maybe<Myself>,
};

export type AssumeConsumerIdentityInput = {
  userId: Scalars['UserId'],
};

export type AssumeConsumerIdentityPayload = {
  __typename: 'AssumeConsumerIdentityPayload',
  user?: Maybe<User>,
  myself?: Maybe<Myself>,
};

export type AssumeOperatorIdentityInput = {
  operatorId: Scalars['OperatorId'],
};

export type AssumeOperatorIdentityPayload = {
  __typename: 'AssumeOperatorIdentityPayload',
  operator?: Maybe<Operator>,
  myself?: Maybe<Myself>,
};

export type Attribute = {
  __typename: 'Attribute',
  schema: AttributeSchema,
  values: Array<AttributeValue>,
  formatted?: Maybe<FormattedAttribute>,
};

export type AttributedHtmlTextViewModel = {
  __typename: 'AttributedHtmlTextViewModel',
  /** This text can be HTML so the client shouldn't escape it (will be pre-sanitized by the server)
   * Text can have placeholders in the form of <%Key%>, where "Key" is present in attributes key
   * property.
 */
  text: Scalars['String'],
  attributes?: Maybe<Array<AttributedHtmlTextViewModelAttribute>>,
};

export type AttributedHtmlTextViewModelAttribute = {
  __typename: 'AttributedHtmlTextViewModelAttribute',
  key: Scalars['String'],
  type: AttributedHtmlTextViewModelAttributeType,
  image?: Maybe<ImageViewModel>,
};

export enum AttributedHtmlTextViewModelAttributeType {
  /** Denotes this attribute is an image view model */
  IMAGE = 'IMAGE'
}

export type AttributeEnumerationMapping = {
  __typename: 'AttributeEnumerationMapping',
  value: Scalars['String'],
  description?: Maybe<Scalars['String']>,
};

/** Exploded union of attribute values.
 * See corresponding AttributeValue* types that correspond with AttributeType to see which fields to fill out
 * depending on which enum type is used
 */
export type AttributeInput = {
  name: Scalars['String'],
  type: AttributeType,
  decimal?: Maybe<Scalars['BigDecimal']>,
  integer?: Maybe<Scalars['Long']>,
  minInteger?: Maybe<Scalars['Long']>,
  maxInteger?: Maybe<Scalars['Long']>,
  minDecimal?: Maybe<Scalars['BigDecimal']>,
  maxDecimal?: Maybe<Scalars['BigDecimal']>,
  text?: Maybe<Scalars['String']>,
  enumerationValue?: Maybe<Scalars['String']>,
};

export type AttributeSchema = {
  __typename: 'AttributeSchema',
  id: Scalars['AttributeSchemaId'],
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: AttributeType,
  validations?: Maybe<Array<AttributeValidation>>,
  /** Only present for enumeration types */
  enumerationMappings?: Maybe<Array<AttributeEnumerationMapping>>,
};


export type AttributeSchemasByCategoriesConnection = {
  __typename: 'AttributeSchemasByCategoriesConnection',
  edges?: Maybe<Array<Maybe<AttributeSchemasByCategoriesEdge>>>,
  pageInfo?: Maybe<PageInfo>,
};

export type AttributeSchemasByCategoriesEdge = {
  __typename: 'AttributeSchemasByCategoriesEdge',
  node: AttributeSchema,
  cursor: Scalars['String'],
};

/** There is a 1:1 correlation between AttributeType and a GraphQL type.
 * The corresponding GraphQL type declaration name is ("AttributeValue" + pascalCaseOf(AttributeType))
 */
export enum AttributeType {
  INTEGER = 'INTEGER',
  INTEGER_RANGE = 'INTEGER_RANGE',
  DECIMAL = 'DECIMAL',
  DECIMAL_RANGE = 'DECIMAL_RANGE',
  TEXT = 'TEXT',
  ENUMERATION = 'ENUMERATION',
  LOCAL_DATE = 'LOCAL_DATE',
  LOCAL_DATE_RANGE = 'LOCAL_DATE_RANGE',
  LOCAL_TIME = 'LOCAL_TIME',
  LOCAL_TIME_RANGE = 'LOCAL_TIME_RANGE',
  LOCAL_DATE_TIME = 'LOCAL_DATE_TIME',
  LOCAL_DATE_TIME_RANGE = 'LOCAL_DATE_TIME_RANGE',
  ZONE_ID = 'ZONE_ID',
  ID = 'ID'
}

export type AttributeValidation = {
  __typename: 'AttributeValidation',
  type: AttributeValidationType,
};

export type AttributeValidationRegex = AttributeValidation & {
  __typename: 'AttributeValidationRegex',
  type: AttributeValidationType,
  /** Regular expression used for validation */
  regex: Scalars['String'],
  /** Error message that should be displayed if the regular expression match fails */
  errorMessage: Scalars['String'],
};

export enum AttributeValidationType {
  /** Text value must conform to a regular expression
   * Validates TEXT attribute types
 */
  REGEX = 'REGEX',
  /** Ensure the amount of attribute values falls between a specified range.
   * Validates all attribute types.
 */
  VALUE_AMOUNT = 'VALUE_AMOUNT'
}

export type AttributeValidationValueAmount = AttributeValidation & {
  __typename: 'AttributeValidationValueAmount',
  type: AttributeValidationType,
  /** Mimumum amount of values that can be provided, inclusive. If omitted, there is no minumum enforced. */
  min?: Maybe<Scalars['Long']>,
  /** Maximum amount of values that can be provided, inclusive. If omitted, there is no maxmimum enforced. */
  max?: Maybe<Scalars['Long']>,
};

export type AttributeValue = AttributeValueInteger | AttributeValueIntegerRange | AttributeValueDecimal | AttributeValueDecimalRange | AttributeValueText | AttributeValueEnumeration | AttributeValueDate | AttributeValueDateRange | AttributeValueTime | AttributeValueTimeRange | AttributeValueDateTime | AttributeValueDateTimeRange | AttributeValueZoneId | AttributeValueId;

export type AttributeValueDate = {
  __typename: 'AttributeValueDate',
  date: Scalars['Date'],
};

export type AttributeValueDateRange = {
  __typename: 'AttributeValueDateRange',
  minDate?: Maybe<Scalars['Date']>,
  maxDate?: Maybe<Scalars['Date']>,
};

export type AttributeValueDateTime = {
  __typename: 'AttributeValueDateTime',
  dateTime: Scalars['Date'],
};

export type AttributeValueDateTimeRange = {
  __typename: 'AttributeValueDateTimeRange',
  minDateTime?: Maybe<Scalars['Date']>,
  maxDateTime?: Maybe<Scalars['Date']>,
};

export type AttributeValueDecimal = {
  __typename: 'AttributeValueDecimal',
  decimal: Scalars['BigDecimal'],
};

export type AttributeValueDecimalRange = {
  __typename: 'AttributeValueDecimalRange',
  minDecimal?: Maybe<Scalars['BigDecimal']>,
  maxDecimal?: Maybe<Scalars['BigDecimal']>,
};

export type AttributeValueEnumeration = {
  __typename: 'AttributeValueEnumeration',
  enumerationValue: Scalars['String'],
  enumerationValueDescription: Scalars['String'],
};

export type AttributeValueId = {
  __typename: 'AttributeValueId',
  id?: Maybe<Scalars['AnyId']>,
};

export type AttributeValueInteger = {
  __typename: 'AttributeValueInteger',
  integer: Scalars['Long'],
};

export type AttributeValueIntegerRange = {
  __typename: 'AttributeValueIntegerRange',
  minInteger?: Maybe<Scalars['Long']>,
  maxInteger?: Maybe<Scalars['Long']>,
};

export type AttributeValueText = {
  __typename: 'AttributeValueText',
  text: Scalars['String'],
};

export type AttributeValueTime = {
  __typename: 'AttributeValueTime',
  time: Scalars['Time'],
};

export type AttributeValueTimeRange = {
  __typename: 'AttributeValueTimeRange',
  minTime?: Maybe<Scalars['Time']>,
  maxTime?: Maybe<Scalars['Time']>,
};

export type AttributeValueZoneId = {
  __typename: 'AttributeValueZoneId',
  zoneId?: Maybe<Scalars['String']>,
};

export type AuthenticateByExternalOAuthTokenInput = {
  type: OAuthType,
  token: Scalars['String'],
};

export type AuthenticateByExternalOAuthTokenPayload = {
  __typename: 'AuthenticateByExternalOAuthTokenPayload',
  result: AuthenticationResult,
  user?: Maybe<User>,
  message?: Maybe<Scalars['String']>,
};

export type AuthenticationInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  handleId?: Maybe<Scalars['AnyId']>,
  challenge: Scalars['String'],
};

export enum AuthenticationMethod {
  NO_PASSWORD = 'NO_PASSWORD',
  PASSWORD = 'PASSWORD',
  CHALLENGE = 'CHALLENGE',
  LOGIN_TOKEN = 'LOGIN_TOKEN',
  EXTERNAL_OAUTH = 'EXTERNAL_OAUTH'
}

export enum AuthenticationResult {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  CHALLENGE = 'CHALLENGE'
}

export type AuthenticationResultPayload = {
  __typename: 'AuthenticationResultPayload',
  result: AuthenticationResult,
  user?: Maybe<User>,
  message?: Maybe<Scalars['String']>,
};

export type AuthenticationSessionState = {
  __typename: 'AuthenticationSessionState',
  handle?: Maybe<Scalars['String']>,
  handleId?: Maybe<Scalars['AnyId']>,
  loginChallengeType?: Maybe<ChallengeType>,
  resetPasswordChallengeVerified: Scalars['Boolean'],
};

export type AvailabilityByFulfillmentCenter = {
  __typename: 'AvailabilityByFulfillmentCenter',
  fulfillmentCenter: FulfillmentCenter,
  /** Items available to order on our site from this Fulfillment Center */
  count: Scalars['Int'],
};

export type BackgroundFacetImageMetadata = FacetImageMetadata & {
  __typename: 'BackgroundFacetImageMetadata',
  type: FacetImageType,
  imageUrl: Scalars['String'],
};

export type BasicPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'BasicPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};


export type Brand = {
  __typename: 'Brand',
  id: Scalars['BrandId'],
  name: Scalars['String'],
  displayName: Scalars['String'],
  active: Scalars['Boolean'],
  logo?: Maybe<MediaFile>,
};

export type BrandConnection = {
  __typename: 'BrandConnection',
  edges: Array<BrandEdge>,
  pageInfo: PageInfo,
};

export type BrandEdge = {
  __typename: 'BrandEdge',
  node: Brand,
  cursor: Scalars['String'],
};


export type BrandStatsAggregateExpertReport = {
  __typename: 'BrandStatsAggregateExpertReport',
  category: Category,
  brand: Brand,
  recommendedThisWeek: Scalars['Int'],
  recommendedLastWeek: Scalars['Int'],
  rankLast7Days: Scalars['Int'],
  rankLastWeek7Days: Scalars['Int'],
};

export type BrandUploadTaskPayload = {
  __typename: 'BrandUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numBrandsCreated: Scalars['Int'],
  numBrandsUpdated: Scalars['Int'],
  errorRows: Array<Scalars['Int']>,
  googleSpreadsheetId: Scalars['String'],
};

export type BridgeExpertApplicantPhoneCallInput = {
  fromMessagingUserId: Scalars['AnyId'],
  applicationId: Scalars['ExpertApplicationId'],
};

export type BridgeLeadPhoneCallInput = {
  fromMessagingUserId: Scalars['AnyId'],
  leadId: Scalars['LeadId'],
};

export type BridgePhoneCallInput = {
  conversationId: Scalars['ConversationId'],
  fromMessagingUserId: Scalars['AnyId'],
  toMessagingUserId: Scalars['AnyId'],
};

export type BridgePhoneCallPayload = {
  __typename: 'BridgePhoneCallPayload',
  success: Scalars['Boolean'],
};

export type BroadcastOffer = {
  __typename: 'BroadcastOffer',
  id: Scalars['BroadcastOfferId'],
  conversation?: Maybe<Conversation>,
  type?: Maybe<BroadcastOfferType>,
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  state: OfferState,
  createdBy: BusinessUser,
  createdFor: User,
  expiresAt?: Maybe<Scalars['Date']>,
  price: Money,
  originalPrice?: Maybe<Money>,
  originalPriceSource?: Maybe<Scalars['String']>,
  tax?: Maybe<Money>,
  freeAddOns: Array<OfferAddOn>,
  images: Array<MediaFile>,
  videos: Array<MediaFile>,
  publicOffer: Scalars['Boolean'],
  publicOfferUrl?: Maybe<Scalars['String']>,
  terms?: Maybe<OfferTerms>,
  brand?: Maybe<Brand>,
  comments?: Maybe<Scalars['String']>,
  order?: Maybe<Order>,
  totalCost: Money,
  shippingCost?: Maybe<Money>,
  discount?: Maybe<Scalars['Float']>,
  deal?: Maybe<Deal>,
  sellable?: Maybe<Sellable>,
  lastViewedAt?: Maybe<Scalars['Date']>,
  userDocuments: Array<MediaFile>,
  consumerUrl: Scalars['String'],
  canAddToCart: Scalars['Boolean'],
};


export enum BroadcastOfferType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

/** Buckets of values and counts that are individually selectable */
export type BucketedDisplayFacet = DisplayFacet & {
  __typename: 'BucketedDisplayFacet',
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 */
  alias?: Maybe<Scalars['String']>,
  /** Facet buckets */
  buckets: Array<IndividualBucketedDisplayFacet>,
};

/** Display facet for buckets with range values */
export type BucketedRangeDisplayFacet = DisplayFacet & {
  __typename: 'BucketedRangeDisplayFacet',
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 */
  alias?: Maybe<Scalars['String']>,
  /** Facet buckets */
  buckets: Array<IndividualBucketedRangeDisplayFacet>,
};

export type BulkUpdatePayoutPayload = {
  __typename: 'BulkUpdatePayoutPayload',
  results: Array<UpdatePayoutPayload>,
};

export type BusinessAccount = {
  __typename: 'BusinessAccount',
  id: Scalars['BusinessAccountId'],
  name: Scalars['String'],
  merchant?: Maybe<Merchant>,
};


export type BusinessUser = {
  __typename: 'BusinessUser',
  /** This needs to AnyId instead of BusinessUserId since it is used with other identity objects such as User
   * in a few union type.  Graphql will complain if the same field return different types
 */
  id: Scalars['AnyId'],
  facetValue: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  user: User,
  contacts: Array<Contact>,
  messagingUserId: Scalars['AnyId'],
  messagingUser: MessagingUser,
  permissions: Array<Permission>,
  roles: Array<Scalars['String']>,
  isExpert: Scalars['Boolean'],
  isOverloaded: Scalars['Boolean'],
  expertAttributes?: Maybe<BusinessUserExpertAttributes>,
  expertProfile?: Maybe<ExpertProfile>,
  presence: PresenceStatus,
  active: Scalars['Boolean'],
  state: BusinessUserState,
  team?: Maybe<BusinessUserTeam>,
  profileUrl: Scalars['String'],
  profileSetupUrl: Scalars['String'],
  profileShareUrl: Scalars['String'],
  consumerReviewUrl: Scalars['String'],
  assignedAddresses: Array<ChannelAddress>,
  assignedAddress?: Maybe<Scalars['String']>,
  department: Department,
  existingLeadForConsumer?: Maybe<Lead>,
  onCallCapable: Scalars['Boolean'],
  featured: Scalars['Boolean'],
  contactCardUrl: Scalars['String'],
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  vanityId?: Maybe<Scalars['String']>,
  expertStats?: Maybe<ExpertStats>,
  expertApplicationReviewEnabled: Scalars['Boolean'],
  expertApplication?: Maybe<ExpertApplication>,
  activityConnection: BusinessUserActivityConnection,
  payStructure?: Maybe<PayStructure>,
};


export type BusinessUserAssignedAddressArgs = {
  type: MessagingChannelType
};


export type BusinessUserConsumerExpertReviewConnectionArgs = {
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type BusinessUserActivityConnectionArgs = {
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};

export type BusinessUserActivity = {
  __typename: 'BusinessUserActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type BusinessUserActivityConnection = {
  __typename: 'BusinessUserActivityConnection',
  edges: Array<BusinessUserActivityEdge>,
  pageInfo: PageInfo,
};

export type BusinessUserActivityEdge = {
  __typename: 'BusinessUserActivityEdge',
  node: BusinessUserActivity,
  cursor: Scalars['String'],
};


export enum BusinessUserActivityType {
  START_RECEIVING_LEADS = 'START_RECEIVING_LEADS',
  STOP_RECEIVING_LEADS = 'STOP_RECEIVING_LEADS',
  START_ON_CALL = 'START_ON_CALL',
  STOP_ON_CALL = 'STOP_ON_CALL'
}

export type BusinessUserExpertAttributes = {
  __typename: 'BusinessUserExpertAttributes',
  categories: Array<Category>,
  category: Category,
  specialtyCategory?: Maybe<Category>,
  acceptingNewRequests: Scalars['Boolean'],
  acceptRequestMode: AcceptRequestMode,
  alwaysAcceptNewRequests: Scalars['Boolean'],
  newMessageNotificationMode: ExpertNewMessageNotificationMode,
  maxActivationDurationInMinutes?: Maybe<Scalars['Int']>,
  assistExpert: Scalars['Boolean'],
  placeholderExpert: Scalars['Boolean'],
  onCallExpert: Scalars['Boolean'],
};


export enum BusinessUserState {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  PENDING = 'PENDING'
}

export type BusinessUserTeam = {
  __typename: 'BusinessUserTeam',
  id: Scalars['BusinessUserTeamId'],
  department: Department,
  name: Scalars['String'],
  members: Array<BusinessUser>,
  leaders: Array<BusinessUser>,
};


export type CallActivity = {
  __typename: 'CallActivity',
  id: Scalars['CallActivityId'],
  fromNumber: Scalars['String'],
  toNumber: Scalars['String'],
  forwardedToNumber?: Maybe<Scalars['String']>,
  callee: CallParticipant,
  caller?: Maybe<CallParticipant>,
  calledAt: Scalars['Date'],
  durationInSeconds?: Maybe<Scalars['Int']>,
  status: CallStatus,
  type: CallType,
};

export type CallActivityConnection = {
  __typename: 'CallActivityConnection',
  edges: Array<CallActivityEdge>,
  pageInfo: PageInfo,
};

export type CallActivityEdge = {
  __typename: 'CallActivityEdge',
  node: CallActivity,
  cursor: Scalars['String'],
};

export type CallActivityFilterInput = {
  expertId: Scalars['BusinessUserId'],
  from?: Maybe<Scalars['Date']>,
  to?: Maybe<Scalars['Date']>,
};


export type CallParticipant = BusinessUser | User;

export enum CallStatus {
  QUEUED = 'QUEUED',
  INITIATED = 'INITIATED',
  RINGING = 'RINGING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  BUSY = 'BUSY',
  NO_ANSWER = 'NO_ANSWER',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  OTHER = 'OTHER'
}

export enum CallType {
  EXPERT_TO_CONSUMER = 'EXPERT_TO_CONSUMER',
  CONSUMER_TO_EXPERT = 'CONSUMER_TO_EXPERT'
}

export type Campaign = LeadCampaign;

export type CampaignRecipient = {
  __typename: 'CampaignRecipient',
  id: Scalars['LeadCampaignRecipientId'],
  lead: Lead,
  campaign: LeadCampaign,
};

export type CancelExpertApplicationSnoozeInput = {
  applicationId: Scalars['ExpertApplicationId'],
};

export type CancelLeadSnoozeInput = {
  leadId: Scalars['LeadId'],
};

export type CancelPaymentRequestForOrderInput = {
  orderId: Scalars['OrderId'],
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentProcessorType: PaymentProcessorType,
};

export type CancelPaymentRequestForOrderPayload = {
  __typename: 'CancelPaymentRequestForOrderPayload',
  order: Order,
};

export type CancelSubmittedOrderInput = {
  orderId: Scalars['OrderId'],
};

export type CancelSubmittedOrderPayload = {
  __typename: 'CancelSubmittedOrderPayload',
  order: Order,
};

export enum CardFieldValidationStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  UNAVAILABLE = 'UNAVAILABLE',
  UNCHECKED = 'UNCHECKED'
}

export enum CardFundingType {
  UNKNOWN = 'UNKNOWN',
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  PREPAID = 'PREPAID'
}

export enum CartSyncUseCase {
  /** Syncing to display the cart */
  CART_VIEW = 'CART_VIEW',
  /** Syncing to display during the checkout flow */
  CHECKOUT = 'CHECKOUT'
}

export type CategoriesConnection = {
  __typename: 'CategoriesConnection',
  edges: Array<CategoriesEdge>,
  pageInfo?: Maybe<PageInfo>,
};

export type CategoriesEdge = {
  __typename: 'CategoriesEdge',
  node: Category,
  cursor: Scalars['String'],
};

export type Category = {
  __typename: 'Category',
  id: Scalars['CategoryId'],
  name: Scalars['String'],
  singularDisplayName: Scalars['String'],
  pluralDisplayName: Scalars['String'],
  type?: Maybe<CategoryType>,
  slug: Scalars['String'],
  /** Faq slugs are referenced in Contentful */
  faqSlug?: Maybe<Scalars['String']>,
  externalCategoryCode?: Maybe<Scalars['String']>,
  /** Parent categories listed in order of root to this category.
   * (e.g.: ["Product", "Winter Sports", "Skiing"] if this category is "Skis")
   * Args: last - depth of the parent hierarchy to walk up the hierarchy chain.
   * For example if the category was "Skis", last = 1 will return the parent ["Skiing'], last = 2 will return
   * the parent and grandparent, ["Winter Sports", "Skiing"]
 */
  parents: Array<Category>,
  /** Builds a list of children of the requested Category.
   * 
   * If recursive it finds all children in the Category Hierarchy that are flattened into a single list
 */
  children: Array<Category>,
  /** List of all brands associated with this category */
  brands: Array<Brand>,
  /** Addresses of all Merchants's associated with this Category if its of CategoryType SERVICE */
  serviceLocations: Array<SellableServiceLocation>,
  /** The category itself or its ancestor which has a path defined */
  ancestorWithPath?: Maybe<Category>,
  /** browse url.  null if the category is not list or has no slug */
  browseUrl?: Maybe<Scalars['String']>,
  /** start path url. null if the category is not listed or has no slug */
  startPathUrl?: Maybe<Scalars['String']>,
  /** Experts assigned to this or parent categories */
  experts: Array<BusinessUser>,
  expertCategories: Array<Category>,
  contentAssets: CategoryContentAssets,
  accessory: Scalars['Boolean'],
  department?: Maybe<Department>,
  /** Get sellable search facets associated with this category, by default only brands and first primary attribute
   * of the category are returned as facets. Additionally, it excludes out of stock sellables when building the facets.
 */
  sellableSearchFacets: Array<DisplayFacetSelection>,
  recommendExpertForConsumer: RecommendExpertPayload,
};


export type CategoryParentsArgs = {
  last?: Maybe<Scalars['Int']>
};


export type CategoryChildrenArgs = {
  recurse: Scalars['Boolean']
};


export type CategoryBrandsArgs = {
  activeOnly: Scalars['Boolean']
};


export type CategoryServiceLocationsArgs = {
  displayType: SellableServiceLocationDisplayType
};


export type CategoryExpertsArgs = {
  limit: Scalars['Int']
};


export type CategorySellableSearchFacetsArgs = {
  query: CategorySellableSearchFacetQuery
};

export type CategoryContentAssets = {
  __typename: 'CategoryContentAssets',
  bannerImages: Array<ContentAsset>,
  posterImages: Array<ContentAsset>,
  fixedBarDesktop?: Maybe<ContentAsset>,
  fullPageTakeover?: Maybe<ContentAsset>,
  communityPoster?: Maybe<ContentAsset>,
  modalHeader?: Maybe<ContentAsset>,
  callout?: Maybe<ContentAsset>,
};

export type CategoryGroupedBrandStatsAggregateExpertReport = {
  __typename: 'CategoryGroupedBrandStatsAggregateExpertReport',
  id: Scalars['DepartmentId'],
  department: Department,
  departmentStats: Array<BrandStatsAggregateExpertReport>,
  categories: Array<SingleCategoryGroupedBrandStatsAggregateExpertReport>,
};


export type CategoryGroupedBrandStatsAggregateExpertReportDepartmentStatsArgs = {
  limit: Scalars['Int']
};


export type CategoryGroupedBrandStatsAggregateExpertReportCategoriesArgs = {
  limit: Scalars['Int']
};


export type CategorySellableSearchFacetQuery = {
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>,
  facetFilters?: Maybe<Array<SellableSearchFacetsQueryFilter>>,
  maxFacets?: Maybe<Scalars['Int']>,
  maxFacetTerms?: Maybe<Scalars['Int']>,
  expandToChildCategories?: Maybe<Scalars['Boolean']>,
};

export enum CategoryType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export enum ChallengeType {
  OTP = 'OTP',
  PASSWORD = 'PASSWORD'
}

export type ChangePasswordInput = {
  oldPassword: Scalars['String'],
  newPassword: Scalars['String'],
};

export type ChangePasswordPayload = {
  __typename: 'ChangePasswordPayload',
  result: AuthenticationResult,
  message?: Maybe<Scalars['String']>,
};

export type ChannelAddress = {
  __typename: 'ChannelAddress',
  type: MessagingChannelType,
  address: Scalars['String'],
};

export type ChannelTemplate = {
  __typename: 'ChannelTemplate',
  channelType: ChannelType,
};

export enum ChannelType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  INAPP = 'INAPP',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SLACK = 'SLACK'
}

export type ChargeInfoInput = {
  paymentSourceChargeAmount: MonetaryAmountInput,
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentSourceType: PaymentProcessorType,
  paymentSourceUsage: PaymentSourceUsage,
  billingAddress?: Maybe<AddressInput>,
};

export type CheckoutStartedUserActivity = UserActivity & {
  __typename: 'CheckoutStartedUserActivity',
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  occurredAt: Scalars['Date'],
};

export type ClaimOrderLineItemInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  merchantId: Scalars['MerchantId'],
  merchantQuote?: Maybe<MonetaryAmountInput>,
  merchantOrderId?: Maybe<Scalars['String']>,
  merchantEta?: Maybe<Scalars['Date']>,
  merchantMaxEta?: Maybe<Scalars['Date']>,
};

export type ClaimOrderLineItemPayload = {
  __typename: 'ClaimOrderLineItemPayload',
  order: Order,
};

export type CloseExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type CloseExpertCuratedOrderPayload = {
  __typename: 'CloseExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type CommTemplateDataModelInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  variables: Array<RenderCommTemplateVariableInput>,
};

export type CommTemplateDataModelPayload = {
  __typename: 'CommTemplateDataModelPayload',
  error?: Maybe<Scalars['String']>,
  dataJson?: Maybe<Scalars['String']>,
};

export type CommTemplateFragment = {
  __typename: 'CommTemplateFragment',
  id: Scalars['CommTemplateFragmentId'],
  active: Scalars['Boolean'],
  title: Scalars['String'],
  description: Scalars['String'],
  content: Scalars['String'],
  usage: Scalars['String'],
  updatedAt: Scalars['Date'],
};

export type CommTemplateFragmentFilter = {
  active?: Maybe<Scalars['Boolean']>,
};



export type CommTemplateQueryVariable = {
  __typename: 'CommTemplateQueryVariable',
  name: Scalars['String'],
  type: Scalars['String'],
};

export type CommTemplateType = {
  __typename: 'CommTemplateType',
  id: Scalars['CommTemplateTypeId'],
  name: Scalars['String'],
  displayName: Scalars['String'],
  group: TemplateTypeGroup,
  groupName: Scalars['String'],
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  entityName: Scalars['String'],
  description: Scalars['String'],
  templates: Array<MultiLocaleTemplateSet>,
  requiredChannels: Array<ChannelType>,
  queryVariables: Array<CommTemplateQueryVariable>,
  experimentSupported: Scalars['Boolean'],
  categorySupported: Scalars['Boolean'],
  categoryTypeRequired: Scalars['Boolean'],
  activeTemplateCount: Scalars['Int'],
  internal: Scalars['Boolean'],
  hardcoded: Scalars['Boolean'],
  richCardType?: Maybe<MessageRichCardType>,
  optionalChannelSupported: Scalars['Boolean'],
  dataModel: TemplateDataModel,
};


export type CommTemplateTypeTemplatesArgs = {
  active?: Maybe<Scalars['Boolean']>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  categoryId?: Maybe<Scalars['CategoryId']>
};

export type CommTemplateTypeFilter = {
  internal?: Maybe<Scalars['Boolean']>,
  hardcoded?: Maybe<Scalars['Boolean']>,
};


export type CompleteEscalationInput = {
  escalationId: Scalars['OrderEscalationId'],
};

export type CompleteLeadSupportTaskAssignLeadActionsInput = {
  supportTaskId: Scalars['SupportTaskId'],
  actions: Array<SuggestedActionType>,
};

export type CompleteLeadSupportTaskAssignLeadActionsPayload = {
  __typename: 'CompleteLeadSupportTaskAssignLeadActionsPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskDelegateLeadInput = {
  supportTaskId: Scalars['SupportTaskId'],
  expertId: Scalars['BusinessUserId'],
};

export type CompleteLeadSupportTaskDelegateLeadPayload = {
  __typename: 'CompleteLeadSupportTaskDelegateLeadPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskEscalateForReassignmentInput = {
  supportTaskId: Scalars['SupportTaskId'],
};

export type CompleteLeadSupportTaskEscalateForReassignmentPayload = {
  __typename: 'CompleteLeadSupportTaskEscalateForReassignmentPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskEscalateToTeamForDelegationInput = {
  supportTaskId: Scalars['SupportTaskId'],
};

export type CompleteLeadSupportTaskEscalateToTeamForDelegationPayload = {
  __typename: 'CompleteLeadSupportTaskEscalateToTeamForDelegationPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskReassignLeadInput = {
  supportTaskId: Scalars['SupportTaskId'],
  expertId: Scalars['BusinessUserId'],
};

export type CompleteLeadSupportTaskReassignLeadPayload = {
  __typename: 'CompleteLeadSupportTaskReassignLeadPayload',
  supportTask: LeadSupportTask,
};

export type CompleteLeadSupportTaskRequestOrderSupportInput = {
  supportTaskId: Scalars['SupportTaskId'],
  note: Scalars['String'],
};

export type CompleteLeadSupportTaskRequestOrderSupportPayload = {
  __typename: 'CompleteLeadSupportTaskRequestOrderSupportPayload',
  supportTask: LeadSupportTask,
};

export type CompleteSupportTaskNoActionNeededInput = {
  supportTaskId: Scalars['SupportTaskId'],
};

export type CompleteSupportTaskNoActionNeededPayload = {
  __typename: 'CompleteSupportTaskNoActionNeededPayload',
  supportTask: SupportTask,
};

export type CompleteSupportTaskSnoozeInput = {
  supportTaskId: Scalars['SupportTaskId'],
  wakeAt: Scalars['Date'],
};

export type CompleteSupportTaskSnoozePayload = {
  __typename: 'CompleteSupportTaskSnoozePayload',
  supportTask: SupportTask,
};

export type Config = {
  __typename: 'Config',
  id: Scalars['ConfigEntryId'],
  domain: Scalars['String'],
  key: Scalars['String'],
  value?: Maybe<Scalars['String']>,
};

export type ConfigDomain = {
  __typename: 'ConfigDomain',
  name: Scalars['String'],
  displayName: Scalars['String'],
};


export type ConsumerCalledActivity = LeadActivity & {
  __typename: 'ConsumerCalledActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
};

export type ConsumerExpertReview = {
  __typename: 'ConsumerExpertReview',
  id: Scalars['ConsumerExpertReviewId'],
  expert: BusinessUser,
  /** only admin have access to this */
  consumer: User,
  rating: Scalars['Int'],
  headline?: Maybe<Scalars['String']>,
  comments?: Maybe<Scalars['String']>,
  goodQualities: Array<Scalars['String']>,
  createdAt: Scalars['Date'],
  reviewedAt: Scalars['Date'],
  consumerName?: Maybe<Scalars['String']>,
  consumerLocation?: Maybe<Scalars['String']>,
  source: ConsumerReviewSource,
  verifiedPurchases: Array<Sellable>,
  featured: Scalars['Boolean'],
};


export type ConsumerExpertReviewVerifiedPurchasesArgs = {
  limit: Scalars['Int']
};

export type ConsumerExpertReviewConnection = {
  __typename: 'ConsumerExpertReviewConnection',
  facets: Array<DisplayFacet>,
  edges: Array<ConsumerExpertReviewEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type ConsumerExpertReviewEdge = {
  __typename: 'ConsumerExpertReviewEdge',
  node: ConsumerExpertReview,
  cursor: Scalars['String'],
};

export type ConsumerExpertReviewFilter = {
  source?: Maybe<ConsumerReviewSource>,
  rating?: Maybe<Scalars['Int']>,
};


export type ConsumerFirstMessageSentActivity = LeadActivity & {
  __typename: 'ConsumerFirstMessageSentActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
};

export enum ConsumerInitialLeadAction {
  BROWSE = 'BROWSE',
  CHAT = 'CHAT'
}

export type ConsumerReviewAddedActivity = LeadActivity & {
  __typename: 'ConsumerReviewAddedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  rating: Scalars['Int'],
  headline?: Maybe<Scalars['String']>,
  comments?: Maybe<Scalars['String']>,
  goodQualities: Array<Scalars['String']>,
};

export type ConsumerReviewSearchQuery = {
  expertIds?: Maybe<Array<Scalars['BusinessUserId']>>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  facetedSearch?: Maybe<Scalars['Boolean']>,
  facets?: Maybe<Array<FacetSelection>>,
};

export enum ConsumerReviewSearchSort {
  RELEVANCE = 'RELEVANCE',
  REVIEWED_AT = 'REVIEWED_AT'
}

export enum ConsumerReviewSource {
  CURATED = 'CURATED',
  SHOPPER_APPROVED = 'SHOPPER_APPROVED'
}

export type ConsumerSellableReaction = {
  __typename: 'ConsumerSellableReaction',
  id: Scalars['ConsumerSellableReactionId'],
  ratingWithDisplayName: ConsumerSellableReactionRatingWithDisplayName,
  reasonsWithDisplayName: Array<ConsumerSellableReactionReasonWithDisplayName>,
  additionalReason?: Maybe<Scalars['String']>,
  sellable: Sellable,
  systemRecommended: Scalars['Boolean'],
  /** the BusinessUser if it was recommended by an expert */
  recommendedBy?: Maybe<BusinessUser>,
  /** Logical Component on the UI that triggered this reaction */
  reactionSource?: Maybe<ConsumerSellableReactionSource>,
};

export type ConsumerSellableReactionConnection = {
  __typename: 'ConsumerSellableReactionConnection',
  edges: Array<ConsumerSellableReactionEdge>,
  pageInfo: PageInfo,
};

export type ConsumerSellableReactionEdge = {
  __typename: 'ConsumerSellableReactionEdge',
  node: ConsumerSellableReaction,
  cursor: Scalars['String'],
};


export enum ConsumerSellableReactionRating {
  SKIP = 'SKIP',
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  LOVE = 'LOVE'
}

export type ConsumerSellableReactionRatingStats = {
  __typename: 'ConsumerSellableReactionRatingStats',
  rating: SystemCuratedConsumerSellableReactionRating,
  displayName: Scalars['String'],
  count: Scalars['Int'],
};

export type ConsumerSellableReactionRatingWithDisplayName = {
  __typename: 'ConsumerSellableReactionRatingWithDisplayName',
  rating: ConsumerSellableReactionRating,
  displayName: Scalars['String'],
};

export enum ConsumerSellableReactionReason {
  PRICE = 'PRICE',
  BRAND = 'BRAND',
  STYLE = 'STYLE',
  FEATURES = 'FEATURES'
}

export type ConsumerSellableReactionReasonWithDisplayName = {
  __typename: 'ConsumerSellableReactionReasonWithDisplayName',
  reason: ConsumerSellableReactionReason,
  displayName: Scalars['String'],
};

export type ConsumerSellableReactionRecommendationSourceInput = {
  expertCuratedItemId?: Maybe<Scalars['ExpertCuratedItemId']>,
  recommendedListDefinitionId?: Maybe<Scalars['RecommendedListDefinitionId']>,
  systemCuratedItemId?: Maybe<Scalars['SystemCuratedItemId']>,
};

export enum ConsumerSellableReactionSource {
  SYSTEM_CURATED_ITEM_SURVEY = 'SYSTEM_CURATED_ITEM_SURVEY',
  FAVORITES_PAGE = 'FAVORITES_PAGE',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS'
}

export type ConsumerSellableReactionsQuery = {
  /** The user whose reviews are needed */
  reviewedBy: Scalars['UserId'],
  /** Reactions for specific sellables by a user */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>,
  /** Reactions for sellables recommended by the specified Expert Id */
  recommendedBy?: Maybe<Scalars['BusinessUserId']>,
};

export type Contact = {
  __typename: 'Contact',
  id: Scalars['ContactId'],
  type: ContactType,
  value: Scalars['String'],
  /** The value as email address, if type is EMAIL */
  emailAddress?: Maybe<Scalars['String']>,
  /** The value as phone number, if type is PHONE */
  phoneNumber?: Maybe<Scalars['String']>,
  verified: Scalars['Boolean'],
};


export type ContactPrivacyMetadata = PathFlowPageMetadata & {
  __typename: 'ContactPrivacyMetadata',
  type: PathFlowPageMetadataType,
};

export type ContactTcpaComplianceMetadata = PathFlowPageMetadata & {
  __typename: 'ContactTCPAComplianceMetadata',
  type: PathFlowPageMetadataType,
};

export enum ContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
}

export type ContentAsset = {
  __typename: 'ContentAsset',
  title: Scalars['String'],
  url: Scalars['String'],
  mimeType: Scalars['String'],
  imageUrl?: Maybe<Scalars['String']>,
};

export type ContentBooleanValue = {
  __typename: 'ContentBooleanValue',
  booleanValue: Scalars['Boolean'],
};

export type ContentFloatValue = {
  __typename: 'ContentFloatValue',
  floatValue: Scalars['Float'],
};

export type ContentIntValue = {
  __typename: 'ContentIntValue',
  intValue: Scalars['Int'],
};

export type ContentObject = {
  __typename: 'ContentObject',
  entries: Array<ContentObjectEntry>,
};

export type ContentObjectEntry = {
  __typename: 'ContentObjectEntry',
  key: Scalars['String'],
  value: ContentValue,
};

export type ContentStringValue = {
  __typename: 'ContentStringValue',
  stringValue: Scalars['String'],
};

export type ContentValue = ContentBooleanValue | ContentStringValue | ContentIntValue | ContentFloatValue | ContentAsset | ContentValueArray | ContentObject;

export type ContentValueArray = {
  __typename: 'ContentValueArray',
  values: Array<ContentValue>,
};

export type Conversation = {
  __typename: 'Conversation',
  id: Scalars['ConversationId'],
  externalId: Scalars['String'],
  title: Scalars['String'],
  active: Scalars['Boolean'],
  participants: Array<MessagingUser>,
  unreadCount: Scalars['Int'],
  lead?: Maybe<Lead>,
  owner?: Maybe<MessagingUser>,
  message: Message,
};


export type ConversationUnreadCountArgs = {
  participantId: Scalars['AnyId']
};


export type ConversationMessageArgs = {
  id?: Maybe<Scalars['String']>
};


export type ConversationMessagePart = {
  __typename: 'ConversationMessagePart',
  type: Scalars['String'],
  body: Scalars['String'],
};

export type ConversationMessagePartInput = {
  type: Scalars['String'],
  body: Scalars['String'],
};

export type ConversationMetrics = {
  __typename: 'ConversationMetrics',
  initialSentAt?: Maybe<Scalars['Date']>,
  firstManualMessageSentAt?: Maybe<Scalars['Date']>,
  lastSentAt?: Maybe<Scalars['Date']>,
  lastManualMessageSentAt?: Maybe<Scalars['Date']>,
  messageCount?: Maybe<Scalars['Int']>,
  manualMessageCount?: Maybe<Scalars['Int']>,
  unreadMessageCount?: Maybe<Scalars['Int']>,
  lastMessageSummary?: Maybe<MessageSummary>,
};

export type CopyFlightPlanAsDraftInput = {
  id: Scalars['FlightPlanId'],
};

export type CopyFlightPlanAsDraftPayload = {
  __typename: 'CopyFlightPlanAsDraftPayload',
  flightPlan: FlightPlan,
};

export type CopyFromExpertCuratedItemsInput = {
  leadId: Scalars['LeadId'],
  /** Suggested ExpertCuratedItemId's used to copy data into the new ExpertCuratedItem */
  sourceExpertCuratedItemIds: Array<Scalars['ExpertCuratedItemId']>,
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>,
  /** Relevance metadata passed in the SuggestedExpertCuratedItems response if this */
  suggestExpertCuratedItemRelevanceMetadata?: Maybe<Scalars['String']>,
  /** If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular tag used with the underlying Sellable
 */
  fillWithMostPopularTag?: Maybe<Scalars['Boolean']>,
  /** If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular note used with the underlying Sellable
 */
  fillWithMostPopularNote?: Maybe<Scalars['Boolean']>,
};

export type CopyFromExpertCuratedItemsPayload = {
  __typename: 'CopyFromExpertCuratedItemsPayload',
  expertCuratedItems: Array<ExpertCuratedItem>,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type CopyItemsFromExpertCuratedOrderInput = {
  sourceId: Scalars['ExpertCuratedOrderId'],
  destinationId: Scalars['ExpertCuratedOrderId'],
};

export type CopyItemsFromExpertCuratedOrderPayload = {
  __typename: 'CopyItemsFromExpertCuratedOrderPayload',
  source: ExpertCuratedOrder,
  destination: ExpertCuratedOrder,
};

export type CopyLeadCampaignInput = {
  id: Scalars['LeadCampaignId'],
};

export type CopyPromotionInput = {
  id: Scalars['PromotionId'],
};

export type CopyPromotionPayload = {
  __typename: 'CopyPromotionPayload',
  promotion: Promotion,
};

export type CopyTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'],
};

export type CopyTemplateFragmentPayload = {
  __typename: 'CopyTemplateFragmentPayload',
  fragment: CommTemplateFragment,
};

export type CopyTemplateInput = {
  templateId: Scalars['CommTemplateId'],
};

export type CopyTemplateTypeInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  group: TemplateTypeGroup,
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  displayName: Scalars['String'],
  description: Scalars['String'],
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  parameterName: Scalars['String'],
  richCardType?: Maybe<MessageRichCardType>,
  dataModel: TemplateDataModelInput,
};

export type CopyTemplateTypePayload = {
  __typename: 'CopyTemplateTypePayload',
  trigger: Trigger,
  templateType: CommTemplateType,
};

export type CopyTriggerInput = {
  triggerId: Scalars['TriggerId'],
};

export type CopyTriggerPayload = {
  __typename: 'CopyTriggerPayload',
  trigger: Trigger,
};

export type Country = {
  __typename: 'Country',
  /** country code, e.g.: "US", "AU", etc */
  countryCode: Scalars['String'],
  /** country display name, e.g.: "United States", "Australia", etc */
  displayCountry: Scalars['String'],
  /** Depending on country, this will be things like "State", "Territory", "Province", etc. If null, the user shouldn't
   * be prompted for first administrative area
 */
  displayFirstAdministrativeAreaLabel?: Maybe<Scalars['String']>,
  /** Depending on country, this will be "Zip code", "Postcode", etc */
  displayPostalCodeLabel: Scalars['String'],
  /** Depending on country, this will be "City", "Suburb & City", etc */
  displayCityLabel: Scalars['String'],
  /** First administrative area corresponds to things like states, territories, provinces, etc. See
   * https://en.wikipedia.org/wiki/Administrative_division for more information.
 */
  firstAdministrativeAreas: Array<AdministrativeArea>,
  /** If we support shipping to addresses in this country */
  shippingSupported: Scalars['Boolean'],
  /** If we support billing address in this country */
  billingSupported: Scalars['Boolean'],
};

export type CountryFilter = {
  shippingSupported?: Maybe<Scalars['Boolean']>,
  billingSupported?: Maybe<Scalars['Boolean']>,
};

export type CreateAdhocSellableFromEBayItemInput = {
  eBayItemId: Scalars['String'],
  categoryId: Scalars['CategoryId'],
};

export type CreateAdhocSellableFromEBayItemPayload = {
  __typename: 'CreateAdhocSellableFromEBayItemPayload',
  sellable: Sellable,
};

export type CreateBlankExpertApplicationInput = {
  userId: Scalars['UserId'],
  departmentId: Scalars['DepartmentId'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
};

export type CreateBlankExpertApplicationPayload = {
  __typename: 'CreateBlankExpertApplicationPayload',
  error?: Maybe<Scalars['String']>,
  application?: Maybe<ExpertApplication>,
};

export type CreateBusinessAccountInput = {
  merchantId?: Maybe<Scalars['MerchantId']>,
  name: Scalars['String'],
};

export type CreateBusinessAccountPayload = {
  __typename: 'CreateBusinessAccountPayload',
  businessAccount: BusinessAccount,
};

export type CreateBusinessUserInput = {
  departmentId: Scalars['DepartmentId'],
  userId: Scalars['UserId'],
  roles: Array<Scalars['String']>,
  teamId?: Maybe<Scalars['BusinessUserTeamId']>,
};

export type CreateBusinessUserPayload = {
  __typename: 'CreateBusinessUserPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  businessUser?: Maybe<BusinessUser>,
};

export type CreateBusinessUserTeamInput = {
  departmentId: Scalars['DepartmentId'],
  name: Scalars['String'],
};

export type CreateBusinessUserTeamPayload = {
  __typename: 'CreateBusinessUserTeamPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  businessUserTeam?: Maybe<BusinessUserTeam>,
};

export type CreateDealRequestInput = {
  /** To identify what kind of lead we want, we can also use path slug if that's easier */
  categoryId: Scalars['CategoryId'],
  /** These are all the current available params in create path flow input */
  charterLocation?: Maybe<Scalars['String']>,
  charterSpecificDates?: Maybe<Scalars['String']>,
  charterLocalDateRange?: Maybe<DateRangeInput>,
  diamondOrSetting?: Maybe<Scalars['String']>,
  durationRangeHours?: Maybe<LongRangeInput>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  numGuests?: Maybe<LongRangeInput>,
  partyOccasion?: Maybe<Scalars['String']>,
  priceRangeUSD?: Maybe<LongRangeInput>,
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>,
};

export type CreateDealRequestPayload = {
  __typename: 'CreateDealRequestPayload',
  dealRequest?: Maybe<DealRequest>,
  lead?: Maybe<Lead>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type CreateDraftExpertProfileInput = {
  expertId: Scalars['BusinessUserId'],
};

export type CreateDraftGuestConversationSequenceInput = {
  name: Scalars['String'],
};

export type CreateDraftGuestConversationSequencePayload = {
  __typename: 'CreateDraftGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type CreateDraftPromotionInput = {
  code: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  template?: Maybe<Scalars['Boolean']>,
  usageLimit?: Maybe<Scalars['Int']>,
  expiresAt?: Maybe<Scalars['Date']>,
};

export type CreateDraftPromotionPayload = {
  __typename: 'CreateDraftPromotionPayload',
  promotion: Promotion,
};

export type CreateExpertConsultationFeeOrderInput = {
  leadId: Scalars['LeadId'],
  price: MonetaryAmountInput,
};

export type CreateExpertConsultationFeeOrderPayload = {
  __typename: 'CreateExpertConsultationFeeOrderPayload',
  curatedOrder: SimpleCuratedOrder,
};

export type CreateExpertCuratedItemInput = {
  leadId: Scalars['LeadId'],
  sellableId: Scalars['SellableId'],
  priceOverride?: Maybe<MonetaryAmountInput>,
  tag?: Maybe<ExpertCuratedItemTagInput>,
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>,
  isBuiltFromRecommendation?: Maybe<Scalars['Boolean']>,
  draftNote?: Maybe<Scalars['String']>,
  noteId?: Maybe<Scalars['ExpertCuratedItemNoteId']>,
  /** If this ExpertCuratedItem is being built from a suggested ExpertCuratedItem, the id of the original ExpertCuratedItem */
  sourceExpertCuratedItemId?: Maybe<Scalars['ExpertCuratedItemId']>,
  /** Relevance metadata passed in the SuggestedExpertCuratedItems listing */
  suggestExpertCuratedItemRelevanceMetadata?: Maybe<Scalars['String']>,
  /** If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular tag used with the underlying Sellable
 */
  fillWithMostPopularTag?: Maybe<Scalars['Boolean']>,
  /** If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular note used with the underlying Sellable
 */
  fillWithMostPopularNote?: Maybe<Scalars['Boolean']>,
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>,
};

export type CreateExpertCuratedItemPayload = {
  __typename: 'CreateExpertCuratedItemPayload',
  expertCuratedItem: ExpertCuratedItem,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type CreateExpertCuratedOrderInput = {
  /** The parent sellable or child variant - this will discover the child or sibling variants automatically */
  sellableId: Scalars['SellableId'],
  leadId: Scalars['LeadId'],
  serviceStartsAt?: Maybe<Scalars['Date']>,
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>,
  minimumDepositPercent?: Maybe<Scalars['Int']>,
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>,
  flightPlanId?: Maybe<Scalars['FlightPlanId']>,
  inPreview?: Maybe<Scalars['Boolean']>,
  custom?: Maybe<Scalars['Boolean']>,
};

export type CreateExpertCuratedOrderPayload = {
  __typename: 'CreateExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type CreateExpertFromApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'],
};

export type CreateExpertFromApplicationPayload = {
  __typename: 'CreateExpertFromApplicationPayload',
  expert: BusinessUser,
};

export type CreateExpertProfilePayload = {
  __typename: 'CreateExpertProfilePayload',
  expertProfile?: Maybe<ExpertProfile>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateFirebaseTokenInput = {
  messagingUserId: Scalars['AnyId'],
};

export type CreateFirebaseTokenPayload = {
  __typename: 'CreateFirebaseTokenPayload',
  identityToken: Scalars['String'],
};

export type CreateFlightPlanInput = {
  consumerId?: Maybe<Scalars['UserId']>,
  state: FlightPlanState,
  legs?: Maybe<Array<FlightPlanLegUpsertRequestInput>>,
};

export type CreateFlightPlanPayload = {
  __typename: 'CreateFlightPlanPayload',
  flightPlan?: Maybe<FlightPlan>,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type CreateLeadCampaignInput = {
  name: Scalars['String'],
};

export type CreateLeadCampaignPayload = {
  __typename: 'CreateLeadCampaignPayload',
  error?: Maybe<Scalars['String']>,
  campaign?: Maybe<LeadCampaign>,
};

export type CreateLeadCampaignTriggerInput = {
  id: Scalars['LeadCampaignId'],
};

export type CreateLeadNote = {
  leadId: Scalars['LeadId'],
  text: Scalars['String'],
  messageId?: Maybe<Scalars['String']>,
};

export type CreateLeadNotePayload = {
  __typename: 'CreateLeadNotePayload',
  note: SavedLeadNote,
};

export type CreateMediaInput = {
  url: Scalars['String'],
  persist?: Maybe<Scalars['Boolean']>,
};

export type CreateMediaPayload = {
  __typename: 'CreateMediaPayload',
  mediaFile?: Maybe<MediaFile>,
};

export type CreateMerchantInput = {
  name: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  address?: Maybe<PostalAddressInput>,
  reviewRating?: Maybe<Scalars['Int']>,
  googlePlaceId?: Maybe<Scalars['String']>,
  logoUrl?: Maybe<Scalars['String']>,
  socialProfileUrls?: Maybe<Array<Scalars['String']>>,
  longitude?: Maybe<Scalars['Float']>,
  latitude?: Maybe<Scalars['Float']>,
  shippingNotificationsEmail?: Maybe<Scalars['String']>,
};

export type CreateMerchantPayload = {
  __typename: 'CreateMerchantPayload',
  merchant: Merchant,
  alreadyExists: Scalars['Boolean'],
};

export type CreateMerchantsPayload = {
  __typename: 'CreateMerchantsPayload',
  merchants?: Maybe<Array<CreateMerchantPayload>>,
};

export type CreateOfferForSelfCheckoutInput = {
  sellableId: Scalars['SellableId'],
};

export type CreateOfferFromSellableInput = {
  leadId?: Maybe<Scalars['LeadId']>,
  sellableId: Scalars['SellableId'],
  expertComments?: Maybe<Scalars['String']>,
  price?: Maybe<Scalars['Float']>,
  tax?: Maybe<Scalars['Float']>,
  shippingCost?: Maybe<Scalars['Float']>,
  freeAddOns?: Maybe<Array<Maybe<OfferAddOnInput>>>,
  productOfferTerms?: Maybe<ProductOfferTermsInput>,
  serviceOfferTerms?: Maybe<ServiceOfferTermsInput>,
};

export type CreateOfferInput = {
  leadId?: Maybe<Scalars['LeadId']>,
  merchantId?: Maybe<Scalars['MerchantId']>,
  price: Scalars['Float'],
  originalPrice?: Maybe<Scalars['Float']>,
  originalPriceSource?: Maybe<Scalars['String']>,
  tax?: Maybe<Scalars['Float']>,
  shippingCost?: Maybe<Scalars['Float']>,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  imageUrls?: Maybe<Array<Scalars['String']>>,
  videoUrls?: Maybe<Array<Scalars['String']>>,
  expirationDate?: Maybe<Scalars['Date']>,
  comments?: Maybe<Scalars['String']>,
  offerType?: Maybe<BroadcastOfferType>,
  freeAddOns?: Maybe<Array<Maybe<OfferAddOnInput>>>,
  productOfferTerms?: Maybe<ProductOfferTermsInput>,
  serviceOfferTerms?: Maybe<ServiceOfferTermsInput>,
  merchantName?: Maybe<Scalars['String']>,
  merchantImageUrl?: Maybe<Scalars['String']>,
  publicOfferUrl?: Maybe<Scalars['String']>,
  brandId?: Maybe<Scalars['BrandId']>,
  privateOffer?: Maybe<Scalars['Boolean']>,
  dealTemplate?: Maybe<DealTemplateInput>,
  sellableId?: Maybe<Scalars['SellableId']>,
  merchantPostalAddress?: Maybe<PostalAddressInput>,
};

export type CreateOfferPayload = {
  __typename: 'CreateOfferPayload',
  error?: Maybe<Scalars['String']>,
  offer?: Maybe<BroadcastOffer>,
};

export type CreateOperatorsInput = {
  userIds: Array<Scalars['UserId']>,
  active: Scalars['Boolean'],
};

export type CreateOperatorsPayload = {
  __typename: 'CreateOperatorsPayload',
  operators?: Maybe<Array<Operator>>,
};

export type CreateOrderEscalationInput = {
  userId: Scalars['UserId'],
  orderId: Scalars['OrderId'],
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>,
  leadId?: Maybe<Scalars['LeadId']>,
  type: OrderEscalationType,
  reason?: Maybe<Scalars['String']>,
  dueDate?: Maybe<Scalars['Date']>,
  assignedToId?: Maybe<Scalars['OperatorId']>,
  priority?: Maybe<OrderEscalationPriority>,
  preferredContactMethod?: Maybe<ContactType>,
};

export type CreateOrderEscalationsPayload = {
  __typename: 'CreateOrderEscalationsPayload',
  orderEscalation: OrderEscalation,
};

export type CreateOrderFromOfferInput = {
  id: Scalars['BroadcastOfferId'],
};

export type CreateOrderFromOfferPayload = {
  __typename: 'CreateOrderFromOfferPayload',
  order: Order,
};

export type CreatePasswordInput = {
  password: Scalars['String'],
};

export type CreatePasswordPayload = {
  __typename: 'CreatePasswordPayload',
  success: Scalars['Boolean'],
};

/** pathSchemaId, pathSchemaSlug, or categorySlug must be specified to locate a path to create. The remaining input is
 * optional, and mostly provided as prefilled information into the path.
 */
export type CreatePathFlowInput = {
  /** (Primary) If specified, the path will be created from a specific schema id */
  pathSchemaId?: Maybe<Scalars['PathSchemaId']>,
  /** (Secondary) If specified, the path will be created from a specific schema that has this unique slug */
  pathSchemaSlug?: Maybe<Scalars['String']>,
  /** (Tertiary) If specified, the path will be created through the following process:
   * 1) Assert the category slug is valid, and if so, locate a split experiment in the format of `{categorySlug}-path`.
   *    For example, for "skis" the experiment would be "skis-path".
   * 2) If the variation of the split experiment is not `control`, it is interpreted as a `pathSchemaSlug`, and will
   *    lookup the path by slug.
   * 3) In the case of #2 failing due to the split variation returning "control", this entire process from step 1 will
   *    be retried with the parent category (with the "skis" example, "winter-sports" will be tried next).
   * If there are any errors (including failure to discover) the category, split experiment (all fallback category
   * resolutions fail), or invalid path flow slug specified as the treatment for a split experiment, the path won't be
   * created and an error will be returned.
 */
  categorySlug?: Maybe<Scalars['String']>,
  charterLocation?: Maybe<Scalars['String']>,
  charterSpecificDates?: Maybe<Scalars['String']>,
  charterLocalDateRange?: Maybe<DateRangeInput>,
  countryCode?: Maybe<Scalars['String']>,
  diamondShape?: Maybe<Scalars['String']>,
  diamondOrSetting?: Maybe<Scalars['String']>,
  durationRangeHours?: Maybe<LongRangeInput>,
  expertCategory?: Maybe<Scalars['String']>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertStarRating?: Maybe<Scalars['Int']>,
  facebookMessengerChecked?: Maybe<Scalars['String']>,
  facebookUserRef?: Maybe<Scalars['String']>,
  flightPlanId?: Maybe<Scalars['FlightPlanId']>,
  flightDepartureCity?: Maybe<Scalars['String']>,
  flightDepartureDate?: Maybe<DateRangeInput>,
  flightArrivalCity?: Maybe<Scalars['String']>,
  flightReturnDate?: Maybe<DateRangeInput>,
  jetPassengers?: Maybe<LongRangeInput>,
  jetTripType?: Maybe<Scalars['String']>,
  aircraftType?: Maybe<Scalars['String']>,
  charterCapacity?: Maybe<Scalars['Int']>,
  numGuests?: Maybe<LongRangeInput>,
  partyOccasion?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
  priceRangeUSD?: Maybe<LongRangeInput>,
  /** deprecated: ignored.  referrerId is fetched from cookie */
  referrerId?: Maybe<Scalars['UserId']>,
  referredByExpertId?: Maybe<Scalars['BusinessUserId']>,
  settingRingStyle?: Maybe<Scalars['String']>,
  shoppedWithUsBefore?: Maybe<Scalars['String']>,
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>,
  viewedSellableIds?: Maybe<Array<Scalars['SellableId']>>,
  zipCode?: Maybe<Scalars['String']>,
  uniqueDeviceId?: Maybe<Scalars['String']>,
  applicationId?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  golfShoppingGoal?: Maybe<Scalars['String']>,
};

export type CreatePathFlowPayload = {
  __typename: 'CreatePathFlowPayload',
  /** Either flow will be provided, or a list of validation errors will be provided. */
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
  /** If a new user is registered as part of this path flow page creation */
  newUserRegistered: Scalars['Boolean'],
  /** If a new deal request is created as part of this path flow page creation */
  newRequestCreated: Scalars['Boolean'],
};

export type CreatePaymentSourceInput = {
  paymentProcessorPlatformSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage?: Maybe<PaymentSourceUsage>,
  billingAddress?: Maybe<AddressInput>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type CreatePaymentSourcePayload = {
  __typename: 'CreatePaymentSourcePayload',
  paymentSource: PaymentSource,
};

export type CreatePayStructureInput = {
  name: Scalars['String'],
  description: Scalars['String'],
  departmentId?: Maybe<Scalars['DepartmentId']>,
};

export type CreatePayStructurePayload = {
  __typename: 'CreatePayStructurePayload',
  error?: Maybe<Scalars['String']>,
  payStructure?: Maybe<PayStructure>,
};

export type CreatePayStructureRevisionInput = {
  payStructureId: Scalars['PayStructureId'],
};

export type CreatePendingAccessContactInput = {
  type: ContactType,
  value: Scalars['String'],
  interest: Scalars['String'],
};

export type CreatePendingAccessContactPayload = {
  __typename: 'CreatePendingAccessContactPayload',
  pendingAccessContact: PendingAccessContact,
};

export type CreateQuickReplyInput = {
  name: Scalars['String'],
  text: Scalars['String'],
  leadId?: Maybe<Scalars['LeadId']>,
};

export type CreateQuickReplyPayload = {
  __typename: 'CreateQuickReplyPayload',
  quickReply: QuickReply,
};

export type CreateQuickReplyWithLeadInput = {
  name: Scalars['String'],
  text: Scalars['String'],
  leadId: Scalars['LeadId'],
};

export type CreateQuickReplyWithoutLeadInput = {
  expertId: Scalars['BusinessUserId'],
  name: Scalars['String'],
  text: Scalars['String'],
};

export type CreateRawSellableSourceInput = {
  name: Scalars['String'],
  type: RawSellableSourceType,
  spider?: Maybe<RawSellableSourceSpiderInput>,
};

export type CreateRawSellableSourcePayload = {
  __typename: 'CreateRawSellableSourcePayload',
  source?: Maybe<RawSellableSource>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateRawSellableStandardizationRuleInput = {
  name: Scalars['String'],
  sourceId?: Maybe<Scalars['RawSellableSourceId']>,
  priority: Scalars['Int'],
  condition: RawSellableStandardizationRuleConditionInput,
  actions: Array<RawSellableStandardizationActionInput>,
};

export type CreateRawSellableStandardizationRulePayload = {
  __typename: 'CreateRawSellableStandardizationRulePayload',
  rule?: Maybe<RawSellableStandardizationRule>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateRecommendedListDefinitionInput = {
  /** User friendly name for this recommended list definition */
  name: Scalars['String'],
  /** The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
 */
  titleTemplate: Scalars['String'],
  /** The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
 */
  subTitleTemplate?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  /** The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
 */
  rank: Scalars['Int'],
  /** The categories for which this RecommendedListDefinition is being built. */
  categoryIds: Array<Scalars['CategoryId']>,
  /** The filtering facets to refine recommended list results */
  queryFacets: Array<RecommendedListFacetSelectionInput>,
  /** defaults to relevance based sorting */
  sortOptions: Array<RecommendedListSortOrderInput>,
};

export type CreateRecommendedListDefinitionPayload = {
  __typename: 'CreateRecommendedListDefinitionPayload',
  recommendedListDefinition: RecommendedListDefinition,
};

export type CreateReportInput = {
  title: Scalars['String'],
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>,
  query: Scalars['String'],
  columns?: Maybe<Array<ReportColumnInput>>,
  scope: ReportAccessScope,
  /** If specified, the columns from the schema are automatically added to the columns */
  schemaType?: Maybe<ReportSchemaType>,
};

export type CreateSavedExpertCuratedItemsInput = {
  name: Scalars['String'],
  /** Optional description for this curation */
  description?: Maybe<Scalars['String']>,
  /** Expert Curated Items being saved in this curation */
  expertCuratedItemIds: Array<Scalars['ExpertCuratedItemId']>,
  taggedRequestAttributes?: Maybe<Array<AttributeInput>>,
};

export type CreateSavedExpertCuratedItemsPayload = {
  __typename: 'CreateSavedExpertCuratedItemsPayload',
  savedExpertCuratedItems: SavedExpertCuratedItems,
};

export type CreateSchedulingDemandForecastInput = {
  typeId: Scalars['SchedulingTypeId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  maximumShiftUnits: Scalars['BigDecimal'],
};

export type CreateSchedulingDemandForecastPayload = {
  __typename: 'CreateSchedulingDemandForecastPayload',
  error?: Maybe<Scalars['String']>,
  forecast?: Maybe<SchedulingDemandForecast>,
};

export type CreateSchedulingTypeInput = {
  name: Scalars['String'],
  role: SchedulingUserRole,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  categoryId?: Maybe<Scalars['CategoryId']>,
};

export type CreateSchedulingTypePayload = {
  __typename: 'CreateSchedulingTypePayload',
  error?: Maybe<Scalars['String']>,
  type?: Maybe<SchedulingType>,
};

export type CreateSchedulingUserAvailabilityInput = {
  userId: Scalars['AnyId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
};

export type CreateSchedulingUserAvailabilityPayload = {
  __typename: 'CreateSchedulingUserAvailabilityPayload',
  error?: Maybe<Scalars['String']>,
  availability?: Maybe<SchedulingUserAvailability>,
};

export type CreateSellableInput = {
  /** Title of the product or service */
  title: Scalars['String'],
  /** Plain text description */
  descriptionText?: Maybe<Scalars['String']>,
  /** Description in GitHub-flavored Markdown format
   * See https://github.github.com/gfm/
 */
  descriptionMarkdown?: Maybe<Scalars['String']>,
  /** Categories this sellable is associated with */
  categoryIds: Array<Scalars['CategoryId']>,
  /** If this sellable is a product or service */
  type: SellableType,
  /** MSRP price of this sellable; omittied if not applicable/available. Note that this is not what the consumer pays for
   * the product on Deal.com; salePrice is the actual price paid for the product.
 */
  originalPrice?: Maybe<MonetaryAmountInput>,
  /** Price we sell to the consumer for without tax */
  salePrice: MonetaryAmountInput,
  /** Standardized brand this sellable is associated with */
  brandId?: Maybe<Scalars['BrandId']>,
  /** Images for this sellable */
  imageIds?: Maybe<Array<Scalars['MediaId']>>,
  /** Merchant that provides this service sellable.
   * This is required for sellables of `type` == `SERVICE`, and is prohibited for `PRODUCT`.
 */
  serviceProviderMerchantId?: Maybe<Scalars['MerchantId']>,
  /** Raw unstructured attributes; simple key value pairs. This will be displayed in the sellable specifications table. */
  rawAttributes?: Maybe<Array<RawAttributeInput>>,
  /** If this sellable is created ad-hoc for single use (e.g.: created for a single customer).
   * Ad-hoc sellables are not surfaced in search, and are primarily used for experts to sell items we don't have a
   * proper standardized sellable for, but have some means to fulfill.
 */
  adHoc: Scalars['Boolean'],
};

export type CreateSellablePayload = {
  __typename: 'CreateSellablePayload',
  sellable: Sellable,
};

export type CreateSellableResearchLinkInput = {
  sellableId: Scalars['SellableId'],
  url: Scalars['String'],
};

export type CreateSellableResearchLinkPayload = {
  __typename: 'CreateSellableResearchLinkPayload',
  researchLink: SellableResearchLink,
};

export type CreateSellableTermsInput = {
  orderLineItemId: Scalars['OrderLineItemId'],
  type: SellableType,
  /** Required for Services */
  startAt?: Maybe<Scalars['Date']>,
};

export type CreateSellableTermsPayload = {
  __typename: 'CreateSellableTermsPayload',
  sellableTerms: SellableTerms,
};

export type CreateShiftInput = {
  userId: Scalars['AnyId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  typeId: Scalars['SchedulingTypeId'],
  state: ShiftState,
};

export type CreateShiftPayload = {
  __typename: 'CreateShiftPayload',
  error?: Maybe<Scalars['String']>,
  shift?: Maybe<Shift>,
};

export type CreateTagInput = {
  type: TagType,
  name: Scalars['String'],
};

export type CreateTagPayload = {
  __typename: 'CreateTagPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  tag?: Maybe<Tag>,
};

export type CreateTemplateFragmentInput = {
  title: Scalars['String'],
  description: Scalars['String'],
  content: Scalars['String'],
  usage: Scalars['String'],
};

export type CreateTemplateFragmentPayload = {
  __typename: 'CreateTemplateFragmentPayload',
  fragment: CommTemplateFragment,
};

export type CreateTemplateInput = {
  title: Scalars['String'],
  locale: Scalars['String'],
  typeId: Scalars['CommTemplateTypeId'],
  emailTemplate?: Maybe<EmailTemplateInput>,
  inAppBody?: Maybe<Scalars['String']>,
  smsBody?: Maybe<Scalars['String']>,
  facebookBody?: Maybe<Scalars['String']>,
  pushNotificationTemplate?: Maybe<PushNotificationTemplateInput>,
  slackTemplate?: Maybe<SlackTemplateInput>,
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryType?: Maybe<CategoryType>,
  experimentKey?: Maybe<Scalars['String']>,
  treatments?: Maybe<Array<Scalars['String']>>,
  tagSyntax?: Maybe<TemplateTagSyntax>,
  emailFromAddress?: Maybe<Scalars['String']>,
};

export type CreateTemplatePayload = {
  __typename: 'CreateTemplatePayload',
  multiLocaleTemplate?: Maybe<MultiLocaleTemplateSet>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type CreateTemplateTypeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  parameterName: Scalars['String'],
  group: TemplateTypeGroup,
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  displayName: Scalars['String'],
  description: Scalars['String'],
  richCardType?: Maybe<MessageRichCardType>,
  optionalChannelSupported?: Maybe<Scalars['Boolean']>,
  requiredChannels?: Maybe<Array<ChannelType>>,
  dataModel: TemplateDataModelInput,
};

export type CreateTemplateTypePayload = {
  __typename: 'CreateTemplateTypePayload',
  error?: Maybe<Scalars['String']>,
  trigger?: Maybe<Trigger>,
  templateType?: Maybe<CommTemplateType>,
};

export type CreateTriggerInput = {
  name: Scalars['String'],
  groupName: Scalars['String'],
  description: Scalars['String'],
  eventName: Scalars['String'],
};

export type CreateTriggerNodeInput = {
  triggerId: Scalars['TriggerId'],
  type: TriggerNodeType,
  /** if null, the node will be insert as the first element */
  insertAfter?: Maybe<Scalars['TriggerNodeId']>,
  insertAsEdgeType: TriggerNodeEdgeType,
  actionName?: Maybe<Scalars['String']>,
};

export type CreateTriggerPayload = {
  __typename: 'CreateTriggerPayload',
  trigger: Trigger,
};

export type CreateUserInput = {
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  roles?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type CreateUserPayload = {
  __typename: 'CreateUserPayload',
  user?: Maybe<User>,
  errorCode?: Maybe<UserEditErrorCode>,
  hasError: Scalars['Boolean'],
  errors: Array<Scalars['String']>,
};

export type CurationSummary = {
  __typename: 'CurationSummary',
  lastOfferSentAt?: Maybe<Scalars['Date']>,
  lastCuratedOrderSentAt?: Maybe<Scalars['Date']>,
  lastCuratedItemSentAt?: Maybe<Scalars['Date']>,
  lastOrderCompletedAt?: Maybe<Scalars['Date']>,
  lastCurationSentAt?: Maybe<Scalars['Date']>,
  lastSystemCuratedItemSentAt?: Maybe<Scalars['Date']>,
};


export type CustomerRequestExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type CustomerRequestExpertCuratedOrderPayload = {
  __typename: 'CustomerRequestExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};


/** ====== DatePathFlowQuestion */
export type DatePathFlowQuestion = PathFlowQuestion & {
  __typename: 'DatePathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  type: DatePathFlowQuestionType,
  /** If reloading a question answered by the user, this is their previous input */
  dateUserInput: SubmitDatePathFlowQuestionInputTypeCopy,
};


/** ====== DatePathFlowQuestion */
export type DatePathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum DatePathFlowQuestionType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export type DateRange = {
  __typename: 'DateRange',
  from?: Maybe<Scalars['Date']>,
  to?: Maybe<Scalars['Date']>,
};

export type DateRangeFilter = {
  __typename: 'DateRangeFilter',
  /** the filter will be ignored if both minDateTime and maxDateTime are null */
  field: DateRangeFilterField,
  displayName: Scalars['String'],
  negativeFilter: Scalars['Boolean'],
  minDateTime?: Maybe<Scalars['Date']>,
  maxDateTime?: Maybe<Scalars['Date']>,
};

export enum DateRangeFilterField {
  LAST_PAID_DATE = 'LAST_PAID_DATE',
  CREATED_DATE = 'CREATED_DATE',
  LAST_ACTIVITY_DATE = 'LAST_ACTIVITY_DATE',
  ORDER_PAID_DATE = 'ORDER_PAID_DATE',
  STARTED_DATE = 'STARTED_DATE',
  COMPLETED_DATE = 'COMPLETED_DATE'
}

export type DateRangeFilterInput = {
  minDateTime?: Maybe<Scalars['Date']>,
  maxDateTime?: Maybe<Scalars['Date']>,
  negativeFilter: Scalars['Boolean'],
  field: DateRangeFilterField,
};

export type DateRangeInput = {
  from?: Maybe<Scalars['Date']>,
  to?: Maybe<Scalars['Date']>,
};

/** ====== DateRangePathFlowQuestion */
export type DateRangePathFlowQuestion = PathFlowQuestion & {
  __typename: 'DateRangePathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  startRequired: Scalars['Boolean'],
  endRequired: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  type: DateRangePathFlowQuestionType,
  /** If reloading a question answered by the user, this is their previous input */
  dateRangeUserInput: SubmitDateRangePathFlowQuestionInputTypeCopy,
};


/** ====== DateRangePathFlowQuestion */
export type DateRangePathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum DateRangePathFlowQuestionType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export type DeactivateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'],
};

export type DeactivateGuestConversationSequencePayload = {
  __typename: 'DeactivateGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type DeactivateSellableInput = {
  id: Scalars['SellableId'],
  /** If all of the linked variations of the sellable should also be deactivated. Defaults to false. */
  variationHierarchy?: Maybe<Scalars['Boolean']>,
};

export type DeactivateSellablePayload = {
  __typename: 'DeactivateSellablePayload',
  updatedSellableCount: Scalars['Int'],
};

export type DeactivateSellablePriceSourceInput = {
  id: Scalars['SellablePriceSourceId'],
};

export type DeactivateSellablePriceSourcePayload = {
  __typename: 'DeactivateSellablePriceSourcePayload',
  sellablePriceSource: SellablePriceSource,
};

export type DeactivateTriggerInput = {
  triggerId: Scalars['TriggerId'],
};

export type DeactivateTriggerPayload = {
  __typename: 'DeactivateTriggerPayload',
  trigger: Trigger,
};

export type Deal = {
  __typename: 'Deal',
  id: Scalars['DealId'],
  category: Category,
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  expiresAt?: Maybe<Scalars['Date']>,
  price: Money,
  originalPrice?: Maybe<Money>,
  originalPriceSource?: Maybe<Scalars['String']>,
  freeAddOns: Array<DealAddOn>,
  images: Array<MediaFile>,
  videos: Array<MediaFile>,
  terms: DealTerms,
  comments?: Maybe<Scalars['String']>,
  brand?: Maybe<Brand>,
  createdBy: DealCreatedByUnion,
  discount?: Maybe<Scalars['Float']>,
  interestedByViewer?: Maybe<Scalars['Boolean']>,
  state: DealState,
  sellable?: Maybe<Sellable>,
};

export type DealAddOn = {
  __typename: 'DealAddOn',
  title: Scalars['String'],
  retailPrice: Money,
};

export type DealCreatedByUnion = Operator | Merchant;


export type DealInventoryRawSellableSource = RawSellableSource & {
  __typename: 'DealInventoryRawSellableSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  state: RawSellableSourceState,
  sellableInventoryItem: SellableInventoryItem,
};

export type DealInventorySellablePriceSource = SellablePriceSource & {
  __typename: 'DealInventorySellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  rawSellableSource: RawSellableSource,
};

export type DealRequest = {
  __typename: 'DealRequest',
  id: Scalars['DealRequestId'],
  createdAt: Scalars['Date'],
  requester: User,
  createdBy: User,
  updatedAt: Scalars['Date'],
  isActive: Scalars['Boolean'],
  formattedAttributes: Array<FormattedAttribute>,
  attributes: Array<Attribute>,
  inlineFormattedAttributes: Scalars['String'],
  formattedPrimaryAttributes: Array<FormattedAttribute>,
  category?: Maybe<Category>,
  zipCode?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  followUpPathFlow?: Maybe<PathFlow>,
  /** Sellables that were viewed by the user that resulted in this deal request being created */
  viewedSellables: Array<Sellable>,
};

export type DealRequestFilter = {
  requesterId: Scalars['UserId'],
};


export type DealSellablePriceSource = SellablePriceSource & {
  __typename: 'DealSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
};

export enum DealState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type DealTemplateInput = {
  dealId: Scalars['DealId'],
  /** If this Offer is created by re-using an existing Deal Template and has
   * updates, whether to propogae them to existnig Deals.
 */
  updateExistingDeal?: Maybe<Scalars['Boolean']>,
};

export type DealTerms = ProductDealTerms | ServiceDealTerms | EmptyDealTerms;

export enum DealTermsType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type DealUploadTaskPayload = {
  __typename: 'DealUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numDealsCreated: Scalars['Int'],
  numDealsUpdated: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  googleSpreadsheetId: Scalars['String'],
};

export type DeclineShiftPayload = {
  __typename: 'DeclineShiftPayload',
  error?: Maybe<Scalars['String']>,
  shift?: Maybe<Shift>,
};

export type DeclineVideoChatInput = {
  messagingUserId: Scalars['AnyId'],
  externalConversationId: Scalars['String'],
};

export type DeclineVideoChatPayload = {
  __typename: 'DeclineVideoChatPayload',
  success: Scalars['Boolean'],
};

export type DecoratedRecommendedListConnection = {
  __typename: 'DecoratedRecommendedListConnection',
  edges: Array<RecommendedListEdge>,
  facets: Array<RecommendedListDisplayFacet>,
  pageInfo: PageInfo,
};

export type DelegateExpertChangedActivity = LeadActivity & {
  __typename: 'DelegateExpertChangedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  previousDelegateExpert?: Maybe<BusinessUser>,
  currentDelegateExpert?: Maybe<BusinessUser>,
};

export type DelegateLeadInput = {
  leadId: Scalars['LeadId'],
  /** When the delegate expert ID is not specified, it means undelegate */
  delegateExpertId?: Maybe<Scalars['BusinessUserId']>,
};

export type DelegateLeadSupportTaskActivity = SupportTaskActivity & {
  __typename: 'DelegateLeadSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  delegatedTo: BusinessUser,
};

export type DeleteAddressInput = {
  addressId: Scalars['AddressId'],
  userId: Scalars['UserId'],
};

export type DeleteAddressPayload = {
  __typename: 'DeleteAddressPayload',
  success?: Maybe<Scalars['Boolean']>,
  error?: Maybe<Scalars['String']>,
};

export type DeleteExpertCuratedLeadItineraryInput = {
  id: Scalars['LeadId'],
};

export type DeleteExpertCuratedLeadItineraryPayload = {
  __typename: 'DeleteExpertCuratedLeadItineraryPayload',
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'],
};

export type DeletePaymentSourcePayload = {
  __typename: 'DeletePaymentSourcePayload',
  success?: Maybe<Scalars['Boolean']>,
  error?: Maybe<Scalars['String']>,
};

export type DeleteRecommendedListDefinitionIdPayload = {
  __typename: 'DeleteRecommendedListDefinitionIdPayload',
  success: Scalars['Boolean'],
};

export type DeleteSavedExpertCuratedItemsPayload = {
  __typename: 'DeleteSavedExpertCuratedItemsPayload',
  data?: Maybe<SavedExpertCuratedItems>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type DeleteSellableResearchLinkInput = {
  id: Scalars['SellableResearchLinkId'],
};

export type DeleteSellableResearchLinkPayload = {
  __typename: 'DeleteSellableResearchLinkPayload',
  success: Scalars['Boolean'],
};

export type Department = {
  __typename: 'Department',
  id: Scalars['DepartmentId'],
  slug: Scalars['String'],
  type: DepartmentType,
  displayName: Scalars['String'],
  topLevelCategories: Array<Category>,
  topLevelCategory: Category,
  acceptingRequests: Scalars['Boolean'],
  launched: Scalars['Boolean'],
  test: Scalars['Boolean'],
  /** Get sellable search facets associated with this department.
   * By default only brands of the all categories including children are returned as facets.
   * Additionally, it excludes out of stock sellables when building the facets.
 */
  sellableSearchFacets: Array<DisplayFacetSelection>,
  mostRecentLeadForConsumer?: Maybe<Lead>,
  navigation: DepartmentNavigation,
  expertTeams: Array<BusinessUserTeam>,
  expertSpecialtyCategories: Array<Category>,
  emailCuratedBannerUrl: Scalars['String'],
  emailCuratedLogoUrl: Scalars['String'],
  consumerUrl: Scalars['String'],
  placeholderExpert: BusinessUser,
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  reviewSummary: ReviewSummary,
};


export type DepartmentSellableSearchFacetsArgs = {
  query: CategorySellableSearchFacetQuery
};


export type DepartmentMostRecentLeadForConsumerArgs = {
  hasRequest: Scalars['Boolean']
};


export type DepartmentConsumerExpertReviewConnectionArgs = {
  filter: ConsumerExpertReviewFilter,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type DepartmentNavigation = {
  __typename: 'DepartmentNavigation',
  /** Top most level items shown, usually displayed inline on the page */
  topLevelItems: Array<DepartmentNavigationTopLevelItem>,
};

export type DepartmentNavigationCategoryLink = {
  __typename: 'DepartmentNavigationCategoryLink',
  category: Category,
};

export type DepartmentNavigationCreatePathLink = {
  __typename: 'DepartmentNavigationCreatePathLink',
  pathSlug: Scalars['String'],
};

export type DepartmentNavigationExpertCommunityLink = {
  __typename: 'DepartmentNavigationExpertCommunityLink',
  departmentSlug: Scalars['String'],
};

export type DepartmentNavigationExpertSubSection = DepartmentNavigationSubSection & DepartmentNavigationResponsiveMixin & {
  __typename: 'DepartmentNavigationExpertSubSection',
  id: Scalars['String'],
  title: Scalars['String'],
  titleLink?: Maybe<DepartmentNavigationLink>,
  showIfFullSize: Scalars['Boolean'],
  showIfSmallSize: Scalars['Boolean'],
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  /** Find a recommended expert for this category */
  expertCategoryId: Scalars['CategoryId'],
};

export enum DepartmentNavigationLabelStyle {
  BOLD = 'BOLD'
}

export type DepartmentNavigationLink = DepartmentNavigationCategoryLink | DepartmentNavigationSearchLink | DepartmentNavigationCreatePathLink | DepartmentNavigationExpertCommunityLink;

export type DepartmentNavigationListSubSection = DepartmentNavigationSubSection & DepartmentNavigationResponsiveMixin & {
  __typename: 'DepartmentNavigationListSubSection',
  id: Scalars['String'],
  title: Scalars['String'],
  titleLink?: Maybe<DepartmentNavigationLink>,
  showIfFullSize: Scalars['Boolean'],
  showIfSmallSize: Scalars['Boolean'],
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  items: Array<DepartmentNavigationListSubSectionItem>,
};

export type DepartmentNavigationListSubSectionItem = {
  __typename: 'DepartmentNavigationListSubSectionItem',
  id: Scalars['String'],
  label: Scalars['String'],
  imagePath?: Maybe<Scalars['String']>,
  imageUrl?: Maybe<Scalars['String']>,
  link: DepartmentNavigationLink,
  labelStyles: Array<DepartmentNavigationLabelStyle>,
};

export enum DepartmentNavigationResponsiveFullSizeOptions {
  SHOW = 'SHOW'
}

export type DepartmentNavigationResponsiveMixin = {
  __typename: 'DepartmentNavigationResponsiveMixin',
  /** Options for showing this element for smaller screens (e.g.: mobile) */
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  /** Options for showing this element for full sized screens (e.g.: desktop) */
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  /** If this element should be shown for smaller screens (e.g.: mobile) */
  showIfSmallSize: Scalars['Boolean'],
  /** If this element should be shown for full sized screens (e.g.: desktop) */
  showIfFullSize: Scalars['Boolean'],
};

export enum DepartmentNavigationResponsiveSmallSizeOptions {
  /** Show element in persistent element attached to the chrome. */
  SHOW_IN_PERSISTENT_HEADER = 'SHOW_IN_PERSISTENT_HEADER',
  /** Show element in flyout panel that expands from the side of the page */
  SHOW_IN_FLYOUT_PANEL = 'SHOW_IN_FLYOUT_PANEL'
}

export type DepartmentNavigationSearchLink = {
  __typename: 'DepartmentNavigationSearchLink',
  category: Category,
  facets: Array<FacetSelectionPayload>,
};

export type DepartmentNavigationSubSection = {
  __typename: 'DepartmentNavigationSubSection',
  id: Scalars['String'],
  title: Scalars['String'],
  titleLink?: Maybe<DepartmentNavigationLink>,
};

export type DepartmentNavigationTopLevelItem = DepartmentNavigationResponsiveMixin & {
  __typename: 'DepartmentNavigationTopLevelItem',
  id: Scalars['String'],
  showIfFullSize: Scalars['Boolean'],
  showIfSmallSize: Scalars['Boolean'],
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>,
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>,
  label: Scalars['String'],
  labelLink?: Maybe<DepartmentNavigationLink>,
  imagePath?: Maybe<Scalars['String']>,
  imageUrl?: Maybe<Scalars['String']>,
  subSections: Array<DepartmentNavigationSubSection>,
};

/** Best effort enumeration of available departments for easy type safe comparisons.
 * There is no guarantee all departments will have a department type. The departments that are not assigned an
 * explicit type will be assigned `OTHER`.
 */
export enum DepartmentType {
  WINTER_SPORTS = 'WINTER_SPORTS',
  YACHT_CHARTERS = 'YACHT_CHARTERS',
  JET_CHARTERS = 'JET_CHARTERS',
  CYCLING = 'CYCLING',
  GOLF = 'GOLF',
  JEWELRY = 'JEWELRY',
  CURATED_INTERNAL = 'CURATED_INTERNAL',
  OTHER = 'OTHER'
}

export type DevTools = {
  __typename: 'DevTools',
  idEncodeToExternal: Scalars['String'],
  idDecodeFromExternal: Scalars['String'],
  decodeId: IdCodecPayload,
  geocoding?: Maybe<GeocodingResponse>,
  frontendTask: FrontendTask,
  messageSummary: Array<Maybe<MessageSummary>>,
};


export type DevToolsIdEncodeToExternalArgs = {
  urn: Scalars['String']
};


export type DevToolsIdDecodeFromExternalArgs = {
  externalId: Scalars['String']
};


export type DevToolsDecodeIdArgs = {
  id: Scalars['String']
};


export type DevToolsGeocodingArgs = {
  address: Scalars['String']
};


export type DevToolsFrontendTaskArgs = {
  id: Scalars['FrontendTaskId']
};


export type DevToolsMessageSummaryArgs = {
  conversationId: Scalars['ConversationId']
};

export type DevToolsMutation = {
  __typename: 'DevToolsMutation',
  createDevData: Scalars['Boolean'],
  resetPaymentFailedOffer: BroadcastOffer,
  uploadMerchants: UploadMerchantsPayload,
  uploadSellables: UploadSellablesPayload,
  uploadSellablePrice: UploadSellablePricePayload,
  firePathStartedEvent: Scalars['Boolean'],
  uploadBrands: UploadBrandsPayload,
  createCheckoutStartedEvent: UserActivity,
  createViewSellableEvent: UserActivity,
  createVoiceCallEvent: UserActivity,
  syncFirebaseConversationParticpants: Scalars['Boolean'],
  syncLeadTeam: Lead,
  createShiftAssignments: Scalars['Boolean'],
};


export type DevToolsMutationResetPaymentFailedOfferArgs = {
  offerId: Scalars['BroadcastOfferId']
};


export type DevToolsMutationUploadMerchantsArgs = {
  googleSpreadsheetId: Scalars['String'],
  categorySlug: Scalars['String']
};


export type DevToolsMutationUploadSellablesArgs = {
  googleSpreadsheetId: Scalars['String'],
  categorySlug: Scalars['String'],
  rows?: Maybe<Scalars['Float']>
};


export type DevToolsMutationUploadSellablePriceArgs = {
  googleSpreadsheetId: Scalars['String'],
  categorySlug: Scalars['String']
};


export type DevToolsMutationFirePathStartedEventArgs = {
  pathFlowId: Scalars['PathFlowId'],
  userId: Scalars['UserId']
};


export type DevToolsMutationUploadBrandsArgs = {
  input: UploadBrandsInput
};


export type DevToolsMutationCreateCheckoutStartedEventArgs = {
  orderId: Scalars['OrderId'],
  userId: Scalars['UserId']
};


export type DevToolsMutationCreateViewSellableEventArgs = {
  sellableId: Scalars['SellableId'],
  userId: Scalars['UserId']
};


export type DevToolsMutationCreateVoiceCallEventArgs = {
  userId: Scalars['UserId'],
  expertId: Scalars['BusinessUserId'],
  userPhoneNumber: Scalars['String'],
  status: Scalars['String'],
  callId: Scalars['String']
};


export type DevToolsMutationSyncFirebaseConversationParticpantsArgs = {
  leadId: Scalars['LeadId']
};


export type DevToolsMutationSyncLeadTeamArgs = {
  leadId: Scalars['LeadId']
};


export type DevToolsMutationCreateShiftAssignmentsArgs = {
  typeId: Scalars['SchedulingTypeId'],
  start?: Maybe<Scalars['LocalDate']>,
  end: Scalars['LocalDate']
};

export type DisablePromotionInput = {
  id: Scalars['PromotionId'],
};

export type DisablePromotionPayload = {
  __typename: 'DisablePromotionPayload',
  promotion: Promotion,
};

export type DismissLeadSuggestedActionInput = {
  leadId: Scalars['LeadId'],
  type: SuggestedActionType,
};

export type DismissOrderMessagesInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
};

export type DismissOrderMessagesPayload = {
  __typename: 'DismissOrderMessagesPayload',
  order: Order,
};

export type DismissSupportTaskActivity = SupportTaskActivity & {
  __typename: 'DismissSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};

export type DisplayFacet = {
  __typename: 'DisplayFacet',
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 */
  alias?: Maybe<Scalars['String']>,
};

/** A display facet selection encodes a top level Facet with selection for individual values.
 * This could either be a flattened list of Facet selections or a combination of multiple facets
 * The individual selections encodes all information needed to unique identify a bucket value.
 * Use case: Chrome/Navigation link for Categories and departments.
 */
export type DisplayFacetSelection = {
  __typename: 'DisplayFacetSelection',
  /** internal name */
  name: Scalars['String'],
  /** Display name to use on UI */
  displayName: Scalars['String'],
  /** A list of individual selection that can be directly transformed as input RawFacetSelection for the search */
  selections: Array<FacetSelectionPayload>,
};

export type Duration = {
  __typename: 'Duration',
  amount: Scalars['Long'],
  unit: DurationUnit,
};

export type DurationInput = {
  amount: Scalars['Long'],
  unit: DurationUnit,
};

export enum DurationUnit {
  NANOS = 'NANOS',
  MILLIS = 'MILLIS',
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}

export type EBayItem = {
  __typename: 'EBayItem',
  id: Scalars['String'],
  title: Scalars['String'],
  shortDescription?: Maybe<Scalars['String']>,
  condition?: Maybe<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  url: Scalars['String'],
  price: MonetaryAmount,
  specifications: Array<EBayItemSpecification>,
  group?: Maybe<EBayItemGroup>,
  quantity?: Maybe<Scalars['Int']>,
  isNew?: Maybe<Scalars['Boolean']>,
  outOfStock: Scalars['Boolean'],
};

export type EBayItemDimension = {
  __typename: 'EBayItemDimension',
  name: Scalars['String'],
  vectors: Array<EbayItemDimensionVector>,
};

export type EbayItemDimensionVector = {
  __typename: 'EbayItemDimensionVector',
  value: Scalars['String'],
  itemIds: Array<Scalars['String']>,
};

export type EBayItemGroup = {
  __typename: 'EBayItemGroup',
  id: Scalars['String'],
  dimensions: Array<EBayItemDimension>,
  items: Array<EBayItem>,
};

export type EBayItemSearchConnection = {
  __typename: 'EBayItemSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<EBayItemSearchEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type EBayItemSearchEdge = {
  __typename: 'EBayItemSearchEdge',
  node: EBayItem,
  cursor: Scalars['String'],
};

export type EBayItemSearchQuery = {
  facets?: Maybe<Array<FacetSelection>>,
  categoryId?: Maybe<Scalars['CategoryId']>,
  keywords?: Maybe<Scalars['String']>,
  price?: Maybe<MonetaryAmountRangeInput>,
  /** If categoryId and/or keywords are not specified, the sellable's category as well as its title would be
   * used as the categoryId and/or keywords
 */
  sellableId?: Maybe<Scalars['SellableId']>,
};

export type EBayItemSpecification = {
  __typename: 'EBayItemSpecification',
  /** Display name for the specification */
  name: Scalars['String'],
  /** Display text value for the specification */
  value: Scalars['String'],
};

export type EBaySellablePriceSource = SellablePriceSource & {
  __typename: 'EBaySellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  url: Scalars['String'],
  title: Scalars['String'],
};

export enum EditableUserSourceType {
  ORGANIC = 'ORGANIC',
  INVESTOR = 'INVESTOR'
}

export type EditorialReview = {
  __typename: 'EditorialReview',
  /** Brand associated with the editorial review site */
  brand: Brand,
  /** URL linking back to the specific review */
  url?: Maybe<Scalars['String']>,
  /** Short snippet extracted from the review to display */
  snippet?: Maybe<Scalars['String']>,
  /** Rating assigned to this review */
  rating?: Maybe<EditorialReviewRating>,
  /** The price the product was when the review was performed */
  testedAtPrice?: Maybe<MonetaryAmount>,
  /** The award the review gave this product/service */
  awardLabel?: Maybe<Scalars['String']>,
};

export type EditorialReviewRating = EditorialReviewRatingFiveStar;

export type EditorialReviewRatingFiveStar = {
  __typename: 'EditorialReviewRatingFiveStar',
  /** Between 0 and 5, inclusive */
  stars: Scalars['Int'],
};

export type EmailTemplate = ChannelTemplate & {
  __typename: 'EmailTemplate',
  channelType: ChannelType,
  subject: Scalars['String'],
  htmlBody: Scalars['String'],
  textBody: Scalars['String'],
};

export type EmailTemplateInput = {
  subject: Scalars['String'],
  htmlBody: Scalars['String'],
  textBody: Scalars['String'],
};

/** Re-usable by other questions types that embed text fields as well */
export type EmbeddedInputTextPathFlowQuestion = InputTextPathFlowQuestionMixin & {
  __typename: 'EmbeddedInputTextPathFlowQuestion',
  required: Scalars['Boolean'],
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>,
  fieldType: InputTextPathFlowQuestionFieldType,
  placeholder?: Maybe<Scalars['String']>,
  questionSubText?: Maybe<TextViewModel>,
};

export type EmptyDealTerms = {
  __typename: 'EmptyDealTerms',
  type: DealTermsType,
};

export type EscalateLeadForDelegationSupportTaskActivity = SupportTaskActivity & {
  __typename: 'EscalateLeadForDelegationSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  escalation: LeadEscalation,
};

export type EscalateLeadForReassignmentSupportTaskActivity = SupportTaskActivity & {
  __typename: 'EscalateLeadForReassignmentSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  escalation: LeadEscalation,
};

export type EscalationClosedActivity = OrderActivityDetail & {
  __typename: 'EscalationClosedActivity',
  type: OrderActivityDetailType,
  closedBy: Operator,
  escalation: OrderEscalation,
};

export type EscalationFacetCountsPayload = {
  __typename: 'EscalationFacetCountsPayload',
  displayFacets: Array<DisplayFacet>,
};

export type EscalationUser = User | Operator | BusinessUser;

/** Compute sales tax using one of these 3 location inputs. */
export type EstimatedTaxLocationInput = {
  /** Estimate sales tax using the address of the user */
  userId?: Maybe<Scalars['UserId']>,
  /** Estimate sales tax using this stored address */
  addressId?: Maybe<Scalars['AddressId']>,
  /** Estimate sales tax using the country and state. If only state is provided, the country will default to US */
  country?: Maybe<Scalars['String']>,
  /** Estimate sales tax using the country and state. If only state is provided, the country will default to US */
  state?: Maybe<Scalars['String']>,
};

export type ExpertApplication = {
  __typename: 'ExpertApplication',
  id: Scalars['ExpertApplicationId'],
  state: ExpertApplicationState,
  stateDisplayName: Scalars['String'],
  user: User,
  category: Category,
  attributes: Array<Attribute>,
  rejectReason?: Maybe<Scalars['String']>,
  createdAt: Scalars['Date'],
  submittedAt: Scalars['Date'],
  approvedAt?: Maybe<Scalars['Date']>,
  rejectedAt?: Maybe<Scalars['Date']>,
  approvedBy?: Maybe<ExpertApplicationApprover>,
  expertAccount?: Maybe<BusinessUser>,
  expertProfile?: Maybe<ExpertProfile>,
  department: Department,
  claimStatus?: Maybe<ExpertApplicationClaimStatus>,
  reviews: Array<ExpertApplicationReview>,
  conversation?: Maybe<Conversation>,
  notes: Array<ExpertApplicationNote>,
  pastTasks: Array<ExpertApplicationTaskStatus>,
  currentTasks: Array<ExpertApplicationTaskStatus>,
  futureTasks: Array<ExpertApplicationTaskStatus>,
  snooze?: Maybe<ExpertApplicationSnooze>,
  archived: Scalars['Boolean'],
  lastActivityTime: Scalars['Date'],
  referredByExpertId?: Maybe<Scalars['BusinessUserId']>,
};

export type ExpertApplicationApprover = BusinessUser | Operator;

export type ExpertApplicationClaimStatus = {
  __typename: 'ExpertApplicationClaimStatus',
  claimedAt: Scalars['Date'],
  claimedByTeam: BusinessUserTeam,
  claimedByExpert: BusinessUser,
};

export type ExpertApplicationEdge = {
  __typename: 'ExpertApplicationEdge',
  node: ExpertApplication,
  cursor: Scalars['String'],
};

export type ExpertApplicationFolder = {
  __typename: 'ExpertApplicationFolder',
  id: Scalars['ExpertApplicationFolderId'],
  slug: Scalars['String'],
  displayName: Scalars['String'],
  totalCount?: Maybe<Scalars['Int']>,
  unreadCount?: Maybe<Scalars['Int']>,
  countSubscriptionAvailable: Scalars['Boolean'],
};

export type ExpertApplicationFolderGroup = {
  __typename: 'ExpertApplicationFolderGroup',
  type: ExpertApplicationFolderType,
  folders: Array<ExpertApplicationFolder>,
  displayName: Scalars['String'],
};


export type ExpertApplicationFolderItemChange = {
  __typename: 'ExpertApplicationFolderItemChange',
  application: ExpertApplication,
  type: ExpertApplicationFolderItemChangeType,
};

export enum ExpertApplicationFolderItemChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export type ExpertApplicationFolderItemsPayload = {
  __typename: 'ExpertApplicationFolderItemsPayload',
  items: ExpertApplicationsConnection,
};

export enum ExpertApplicationFolderType {
  PIPELINE = 'PIPELINE',
  FOLDERS = 'FOLDERS'
}


export type ExpertApplicationNote = {
  __typename: 'ExpertApplicationNote',
  text: Scalars['String'],
  createdAt?: Maybe<Scalars['Date']>,
  createdBy: Operator,
};

export type ExpertApplicationQuery = {
  states: Array<ExpertApplicationState>,
};

export enum ExpertApplicationRating {
  YES = 'YES',
  NO = 'NO'
}

export type ExpertApplicationReview = {
  __typename: 'ExpertApplicationReview',
  reviewedAt: Scalars['Date'],
  reviewedBy: BusinessUser,
  rating: ExpertApplicationRating,
  reason?: Maybe<Scalars['String']>,
};

export type ExpertApplicationsConnection = {
  __typename: 'ExpertApplicationsConnection',
  facets: Array<DisplayFacet>,
  edges: Array<ExpertApplicationEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type ExpertApplicationSearchQueryInput = {
  keywords?: Maybe<Scalars['String']>,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  facets?: Maybe<Array<FacetSelection>>,
  facetedSearch: Scalars['Boolean'],
};

export enum ExpertApplicationSearchSort {
  DEFAULT = 'DEFAULT',
  APPLICATION_SUBMITTED_AT = 'APPLICATION_SUBMITTED_AT'
}

export type ExpertApplicationSnooze = {
  __typename: 'ExpertApplicationSnooze',
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  cancelMessageOnReply: Scalars['Boolean'],
};

export type ExpertApplicationsPagination = {
  __typename: 'ExpertApplicationsPagination',
  applications: Array<ExpertApplication>,
  count: Scalars['Long'],
};

export enum ExpertApplicationState {
  REJECTED = 'REJECTED',
  ONBOARDED = 'ONBOARDED',
  SCHEDULING = 'SCHEDULING',
  ONBOARDING = 'ONBOARDING',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export type ExpertApplicationSubscriptionChange = {
  __typename: 'ExpertApplicationSubscriptionChange',
  application: ExpertApplication,
  type: ExpertApplicationSubscriptionChangeType,
};

export enum ExpertApplicationSubscriptionChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export enum ExpertApplicationTaskState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED'
}

export type ExpertApplicationTaskStatus = {
  __typename: 'ExpertApplicationTaskStatus',
  type: ExpertApplicationTaskType,
  displayName: Scalars['String'],
  automated: Scalars['Boolean'],
  state: ExpertApplicationTaskState,
  externalId?: Maybe<Scalars['String']>,
  updates: Array<ExpertApplicationTaskStatusUpdate>,
};

export type ExpertApplicationTaskStatusUpdate = {
  __typename: 'ExpertApplicationTaskStatusUpdate',
  status: Scalars['String'],
  updatedAt: Scalars['Date'],
};

export enum ExpertApplicationTaskType {
  CALL_APPLICANT = 'CALL_APPLICANT',
  APPROVE_PROFILE = 'APPROVE_PROFILE',
  SIGN_CONTRACT = 'SIGN_CONTRACT',
  SETUP_PAYROLL = 'SETUP_PAYROLL',
  COMPLETE_TRAINING = 'COMPLETE_TRAINING',
  SETUP_7SHIFT = 'SETUP_7SHIFT',
  SETUP_SLACK = 'SETUP_SLACK',
  COMPLETE_HOMEWORK = 'COMPLETE_HOMEWORK',
  ADD_AVAILABILITY = 'ADD_AVAILABILITY',
  SCHEDULE_SHIFT = 'SCHEDULE_SHIFT',
  COMPLETE_FIRST_SHIFT = 'COMPLETE_FIRST_SHIFT'
}

export type ExpertAttributeInput = {
  specialtyCategoryId?: Maybe<Scalars['CategoryId']>,
  acceptRequestMode: AcceptRequestMode,
  newMessageNotificationMode?: Maybe<ExpertNewMessageNotificationMode>,
  maxActivationDurationInMinutes?: Maybe<Scalars['Int']>,
  assistExpert?: Maybe<Scalars['Boolean']>,
  workloadCapacity?: Maybe<Scalars['Float']>,
};

export type ExpertCategoryTopRecommendedSellable = {
  __typename: 'ExpertCategoryTopRecommendedSellable',
  category: Category,
  displayTitle: Scalars['String'],
  topRecommendedSellables: Array<ExpertTopRecommendedSellable>,
};

export type ExpertCuratedActivityFeedItem = {
  __typename: 'ExpertCuratedActivityFeedItem',
  id: Scalars['ExpertCuratedActivityFeedItemId'],
  occurredAt: Scalars['Date'],
  expert: BusinessUser,
};

export type ExpertCuratedActivityFeedItemConnection = {
  __typename: 'ExpertCuratedActivityFeedItemConnection',
  edges: Array<ExpertCuratedActivityFeedItemEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedActivityFeedItemEdge = {
  __typename: 'ExpertCuratedActivityFeedItemEdge',
  node: ExpertCuratedActivityFeedItem,
  cursor: Scalars['String'],
};


export type ExpertCuratedActivityFeedOrderItem = ExpertCuratedActivityFeedItem & {
  __typename: 'ExpertCuratedActivityFeedOrderItem',
  id: Scalars['ExpertCuratedActivityFeedItemId'],
  occurredAt: Scalars['Date'],
  expert: BusinessUser,
  consumerFirstName: Scalars['String'],
  review?: Maybe<ConsumerExpertReview>,
  sellables: Array<ExpertCuratedActivityFeedOrderSellableItem>,
};

export type ExpertCuratedActivityFeedOrderSellableItem = {
  __typename: 'ExpertCuratedActivityFeedOrderSellableItem',
  sellable: Sellable,
  note?: Maybe<ExpertCuratedItemNote>,
};

export type ExpertCuratedItem = {
  __typename: 'ExpertCuratedItem',
  id: Scalars['ExpertCuratedItemId'],
  /** Date at which this expert curated item was created */
  createdAt: Scalars['Date'],
  /** The lead this curated item is associated with. */
  lead: Lead,
  /** User this curated item was created for; de-normalized from the `lead`. */
  createdFor: User,
  /** Expert that created this curated item */
  createdBy: BusinessUser,
  /** The first category of the sellable that's being recommended; de-normalized from the `sellable` */
  category: Category,
  /** The sellable that's being recommended as part of this curated item. */
  sellable: Sellable,
  /** If this curated item is added to the cart via the `addExpertCuratedItemToCart` mutation, this price will be used for
   * the item instead of the sellable's natural sale price.
 */
  priceOverride?: Maybe<MonetaryAmount>,
  /** The sale price for this item; will use priceOverride if provided, else fallback to the natural sellable salePrice */
  salePrice: MonetaryAmount,
  /** Tag for this curated item. */
  tag?: Maybe<ExpertCuratedItemTag>,
  /** If this curated item is in draft state.
   * Curated items in draft state are exclusively to be used by the expert to incrementally build up multiple
   * recommendations without it being viewable by the consumer. As such, drafts are never view-able by the consumer.
   * In order to remove the draft flag from all items associated with a lead, invoke the
   * `makeExpertCuratedItemDraftsActive` mutation.
 */
  draft: Scalars['Boolean'],
  /** If this curated item is active (currently being considered, and displayed to the consumer by default). */
  active: Scalars['Boolean'],
  /** If present, represents that this item has been dismissed/removed. */
  removedState?: Maybe<ExpertCuratedItemRemovedState>,
  /** If set, this curated item will be added to the user associated with the lead's cart when this item is converted
   * from a draft to non draft and active state via `makeExpertCuratedItemDraftsActive`.
 */
  shouldAddToCartOnActive: Scalars['Boolean'],
  /** The line item in the user's cart associated with this expert curated item. */
  lineItemInCart?: Maybe<OrderLineItem>,
  /** Custom expert notes associated with this item for the consumer */
  notes?: Maybe<Scalars['String']>,
  /** Custom expert notes associated with this item, that should be published when this item is activated.
   * When this note is activated, this draft note is transferred into a new `ExpertCuratedItemNote` that's set to the
   * `note` field, and this property is cleared. As such, this property is only valid for creating new notes on items
   * in draft state.
 */
  draftNote?: Maybe<Scalars['String']>,
  /** Custom expert note associated with this item for the consumer */
  note?: Maybe<ExpertCuratedItemNote>,
  /** Expert only field to view a pending draft update for this record */
  pendingDraftUpdate?: Maybe<ExpertCuratedItem>,
  /** Previous item this item is replacing (if state is draft) / replaced (if state is not draft) */
  supersededItem?: Maybe<ExpertCuratedItem>,
  /** Indicates that the changes made to this item introduce no material changes to the item it's replacing
   * (referenced by `supersededItem`). If the item is activated in this state (via `makeExpertCuratedItemDraftsActive`),
   * this draft will be deleted with no modifications being made to the existing item.
 */
  noChangesFromSupersededItem: Scalars['Boolean'],
  /** Indicates whether this ExpertCuratedItem was built from a system recommendation. */
  systemRecommended?: Maybe<Scalars['Boolean']>,
  /** various notes only visible by the expert and fulfillment team */
  fulfillmentNotes: ExpertCuratedItemFulfillmentNotes,
  /** Priced (including free) add-ons that are bundled together with this curated item. When added to the user's cart,
   * these customizations are also forcefully added as a grouped line item.
 */
  customizations: Array<ExpertCuratedItemCustomization>,
};

export type ExpertCuratedItemActivation = {
  __typename: 'ExpertCuratedItemActivation',
  id: Scalars['ExpertCuratedItemActivationId'],
  activated: Array<ExpertCuratedItem>,
  removed: Array<ExpertCuratedItem>,
  items: Array<ExpertCuratedItem>,
  lead: Lead,
  activatedBy: BusinessUser,
  createdFor: User,
  previousActivation?: Maybe<ExpertCuratedItemActivation>,
  numItemsActivated: Scalars['Int'],
  numItemsRemoved: Scalars['Int'],
  createdAt: Scalars['Date'],
  createdBySystem: Scalars['Boolean'],
  /** used for trigger entity only to avoid unnecessary look up of Business User */
  activatedById: Scalars['BusinessUserId'],
};


export type ExpertCuratedItemActivationItemsArgs = {
  first: Scalars['Int']
};


export type ExpertCuratedItemActivationsConnection = {
  __typename: 'ExpertCuratedItemActivationsConnection',
  edges: Array<ExpertCuratedItemActivationsEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedItemActivationsEdge = {
  __typename: 'ExpertCuratedItemActivationsEdge',
  node: ExpertCuratedItemActivation,
  cursor: Scalars['String'],
};

export type ExpertCuratedItemCustomization = {
  __typename: 'ExpertCuratedItemCustomization',
  sellable: Sellable,
  createdAt: Scalars['Date'],
  title: Scalars['String'],
  price: MonetaryAmount,
};

export type ExpertCuratedItemFulfillmentNotes = {
  __typename: 'ExpertCuratedItemFulfillmentNotes',
  /** The reason why a custom priceOverride was set */
  priceOverrideReason?: Maybe<ExpertCuratedItemPriceOverrideReason>,
  /** If this curated item was sourced from a different site, the url of the product */
  externalProductUrl?: Maybe<Scalars['String']>,
  /** Additional notes for the fulfillment team (e.g.: special customer requests) */
  notes?: Maybe<Scalars['String']>,
};

export type ExpertCuratedItemFulfillmentNotesInput = {
  priceOverrideReasonType?: Maybe<ExpertCuratedItemPriceOverrideReasonType>,
  externalProductUrl?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
};

/** ExpertCuratedItemGroup is a container for ExpertCuratedItem's that were part of the curation recommended to a lead
 * It also includes other decorations like the request attributes of the lead to who this curation was recommended.
 */
export type ExpertCuratedItemGroup = {
  __typename: 'ExpertCuratedItemGroup',
  expertCuratedItems: Array<ExpertCuratedItem>,
  modifiedAt: Scalars['Date'],
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>,
};


export type ExpertCuratedItemNote = {
  __typename: 'ExpertCuratedItemNote',
  id: Scalars['ExpertCuratedItemNoteId'],
  /** sellable variant this note is for */
  sellable: Sellable,
  /** the parent sellable of `sellable`, or `sellable` if it's already the parent */
  parentSellable: Sellable,
  /** expert that created this note */
  createdBy: BusinessUser,
  /** Note text */
  text: Scalars['String'],
  /** the amount of purchased orders that contain line items added from expert curated items containing this note */
  purchaseCount: Scalars['Int'],
  /** the amount of active (non draft, non-replaced) expert curated items that expectedReference this note */
  useCount: Scalars['Int'],
  /** Between 0 and 1 */
  purchaseRate: Scalars['Float'],
};


export type ExpertCuratedItemPriceOverrideReason = {
  __typename: 'ExpertCuratedItemPriceOverrideReason',
  reasonType: ExpertCuratedItemPriceOverrideReasonType,
  displayLabel: Scalars['String'],
  /** If `externalProductUrl` is required for this `reasonType` */
  externalProductUrlRequired: Scalars['Boolean'],
  /** If `notesRequired` is required for this `reasonType` */
  notesRequired: Scalars['Boolean'],
};

export enum ExpertCuratedItemPriceOverrideReasonType {
  PRICE_MATCH = 'PRICE_MATCH',
  SPECIAL_DISCOUNT = 'SPECIAL_DISCOUNT',
  OTHER = 'OTHER'
}

export type ExpertCuratedItemRemovedBy = User | BusinessUser;

export enum ExpertCuratedItemRemovedReason {
  /** Internal reason used when an item is replaced/updated */
  REPLACED = 'REPLACED',
  /** Should be provided by experts to indicate they removed the item (no further reason is required for them) */
  REMOVED_BY_EXPERT = 'REMOVED_BY_EXPERT',
  /** Default reason that should be used if the user isn't prompted for the remaining reasons */
  NOT_INTERESTED = 'NOT_INTERESTED',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  LOW_QUALITY = 'LOW_QUALITY',
  UGLY = 'UGLY',
  DONT_NEED = 'DONT_NEED',
  BOUGHT_ELSEWHERE = 'BOUGHT_ELSEWHERE',
  OTHER = 'OTHER'
}

export type ExpertCuratedItemRemovedState = {
  __typename: 'ExpertCuratedItemRemovedState',
  by?: Maybe<ExpertCuratedItemRemovedBy>,
  reason: ExpertCuratedItemRemovedReason,
  otherReason?: Maybe<Scalars['String']>,
};

export type ExpertCuratedItemsByCategories = {
  __typename: 'ExpertCuratedItemsByCategories',
  /** Note that this is primarily here to be used as a cache key, not as actual data */
  id: Scalars['LeadId'],
  /** If omitted, defaults to only including ACTIVE */
  categories: Array<ExpertCuratedItemsByCategory>,
  /** All business users that are responsible for the curations */
  experts: Array<BusinessUser>,
};


export type ExpertCuratedItemsByCategoriesCategoriesArgs = {
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>
};

export type ExpertCuratedItemsByCategory = {
  __typename: 'ExpertCuratedItemsByCategory',
  /** This is an opaque token to be used as a cache key for this grouping of data; it has no meaning else wise */
  id: Scalars['String'],
  category: Category,
  items: Array<ExpertCuratedItem>,
};


export type ExpertCuratedItemsByCategoryItemsArgs = {
  sort?: Maybe<ExpertCuratedItemSort>
};

export type ExpertCuratedItemsByCategoryChangedPayload = {
  __typename: 'ExpertCuratedItemsByCategoryChangedPayload',
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type ExpertCuratedItemsForLeadPayload = {
  __typename: 'ExpertCuratedItemsForLeadPayload',
  /** If filter is omitted, defaults to only including ACTIVE */
  items: Array<ExpertCuratedItem>,
  byCategories: ExpertCuratedItemsByCategories,
  activationsConnection: ExpertCuratedItemActivationsConnection,
};


export type ExpertCuratedItemsForLeadPayloadItemsArgs = {
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>,
  first: Scalars['Int'],
  sort?: Maybe<ExpertCuratedItemSort>
};


export type ExpertCuratedItemsForLeadPayloadActivationsConnectionArgs = {
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};

export enum ExpertCuratedItemSort {
  /** Use the default sorting; this is the default, and should always be used in the consumer use case. */
  DEFAULT = 'DEFAULT',
  /** Sort only by createdAt which guarantees consistent sorting when the expert is modifying expert curated items
   * (e.g.: changing the tags, which typically changes sort order)
 */
  CREATED_AT = 'CREATED_AT'
}

/** Basic filters based on state. When multiple filters are applied, they are OR-ed together. */
export enum ExpertCuratedItemStateFilter {
  /** Include items that are in draft state (only valid for experts) */
  DRAFT = 'DRAFT',
  /** Include items that are active (not in draft state, not removed) */
  ACTIVE = 'ACTIVE',
  /** Include items that are removed */
  REMOVED = 'REMOVED',
  /** Include items that not removed */
  NOT_REMOVED = 'NOT_REMOVED'
}

export type ExpertCuratedItemTag = {
  __typename: 'ExpertCuratedItemTag',
  type: ExpertCuratedItemTagType,
  /** Display Label */
  displayLabel: Scalars['String'],
};

export type ExpertCuratedItemTagInput = {
  type: ExpertCuratedItemTagType,
  /** Required for CUSTOM; natural defaults for EXPERT_PICK and BUDGET_PICK */
  displayLabel?: Maybe<Scalars['String']>,
};

export enum ExpertCuratedItemTagType {
  SPECIAL_OFFER = 'SPECIAL_OFFER',
  THE_ALTERNATIVE = 'THE_ALTERNATIVE',
  SALE_PRICE = 'SALE_PRICE',
  EXPERT_PICK = 'EXPERT_PICK',
  BUDGET_PICK = 'BUDGET_PICK',
  CUSTOM = 'CUSTOM',
  OTHER = 'OTHER'
}

export type ExpertCuratedLeadItinerary = {
  __typename: 'ExpertCuratedLeadItinerary',
  id: Scalars['LeadId'],
  contentfulVariation: Scalars['String'],
  /** Convienence resolver that's the equivalent of invoking `findContentByTemplate` with `contentfulVariation` as
   * the variation on the itinerary space, and "itineraryPage" template.
 */
  contentfulObject?: Maybe<ContentObject>,
};

/** An order curated (created by) an expert */
export type ExpertCuratedOrder = {
  __typename: 'ExpertCuratedOrder',
  id: Scalars['ExpertCuratedOrderId'],
  createdAt: Scalars['Date'],
  /** The lead between the user and expert this curation was made for */
  lead: Lead,
  /** Expert that created this curation */
  curator: BusinessUser,
  /** Only for trigger entity to avoid unnecessary look up of BusinessUser */
  curatorId: Scalars['BusinessUserId'],
  /** The user this curated order is for */
  curatedFor: User,
  /** Order that was curated */
  order: Order,
  /** The date at which this order started to be available (entered ACTIVE) state */
  availableAt?: Maybe<Scalars['Date']>,
  /** if and when this curated order will expire */
  expiresAt?: Maybe<Scalars['Date']>,
  /** if `state` == `CLOSED`, this is the date it became closed (no longer available for purchase by the consumer) */
  closedAt?: Maybe<Scalars['Date']>,
  /** Reason the order was closed */
  closedReason?: Maybe<ExpertCuratedOrderClosedReason>,
  /** If and when this curated order was last viewed */
  viewedAt?: Maybe<Scalars['Date']>,
  /** Current state of the order */
  state: ExpertCuratedOrderState,
  /** The available variations for the order. The consumer can select between available variations. */
  variationOptions: Array<ExpertCuratedOrderVariationOption>,
  /** Extra line items that are part of the order, but aren't backed by `items`. e.g.: gratuity. Only for display. */
  readOnlyLineItems: Array<ExpertCuratedOrderLineItem>,
  /** Add-on items, where optional items can be unselected (removed from the final order) by the user */
  items: Array<ExpertCuratedOrderItem>,
  /** The total amount of time this order is set to be available for purchase by the consumer */
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>,
  /** The date the service is scheduled for the user */
  serviceStartAt?: Maybe<Scalars['Date']>,
  /** If specified, the percent (between 1 and 99) of the total order value (before taxes and promotions) that is required
   * as an initial deposit
 */
  minimumDepositPercent?: Maybe<Scalars['Int']>,
  /** When deposit is used, this is the days betfore `serviceStartAt` the remaining payment is due. */
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>,
  /** Derived payment due date from `fullPaymentDueBeforeServiceStartDays` */
  fullPaymentDueAt?: Maybe<Scalars['Date']>,
  consumerUrl: Scalars['String'],
  /** Custom service orders are unique in that the actual curated experience is not purchase-able, but rather only
   * additional `items` are. The sellable service is still used as a parent line item to identify
   * what the extra addons are for, and for taxing the new items correctly, but the actual price of the service isn't
   * added in (and similarly, gratuity and such aren't added). This allows experts to extend a curated order of
   * arbitrary content after extending an initial curated order.
 */
  custom: Scalars['Boolean'],
  /** If the curated order is in preview state; in other words, view-able by the consumer, but not purchase-able.
   * Curated orders in preview state cannot be purchased, and as such have lighter data requirements (e.g.: no
   * service start time is required). This allows surfacing curated orders to the customer to discuss, without the
   * expert having to have all the inventory secured while just discussing options.
 */
  inPreview: Scalars['Boolean'],
  /** Expert only field to view a pending draft update for this record */
  pendingDraftUpdate?: Maybe<ExpertCuratedOrder>,
  /** Previous expert curated order this order is replacing (if state is draft) / replaced (if state is not draft) */
  supersededOrder?: Maybe<ExpertCuratedOrder>,
  /** If this expert curated order has been replaced by an updated order, this is the latest active expert curated order.
   * for example, if curated order A was replaced by A1, and A1 was replaced by A2, and A2 is active, this property for A
   * and A1 would resolve to A2. If there is no active replacement order, this will return null.
 */
  activeReplacementOrder?: Maybe<ExpertCuratedOrder>,
  /** The address which this service will be performed */
  serviceLocation?: Maybe<PostalAddress>,
  /** Based on the `serviceLocation` and service being offered, if we support automatic tax computation. If not, it's
   * expected the expert will manually enter the tax.
 */
  taxWillBeAutomaticallyComputed: Scalars['Boolean'],
  /** For services that involve flight (e.g.: jet charters), the flight plan associated with this service. */
  flightPlan?: Maybe<FlightPlan>,
  defaultManualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>,
  category: Category,
};

export type ExpertCuratedOrderActivationError = {
  __typename: 'ExpertCuratedOrderActivationError',
  expertCuratedOrder: ExpertCuratedOrder,
  errorMessage?: Maybe<Scalars['String']>,
};

export type ExpertCuratedOrderChangedPayload = {
  __typename: 'ExpertCuratedOrderChangedPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export enum ExpertCuratedOrderClosedReason {
  MANUAL = 'MANUAL',
  REPLACED = 'REPLACED'
}


export type ExpertCuratedOrderItem = {
  __typename: 'ExpertCuratedOrderItem',
  id: Scalars['SellableId'],
  title: Scalars['String'],
  price: MonetaryAmount,
  sellable: Sellable,
  taxable: Scalars['Boolean'],
  optional: Scalars['Boolean'],
  selected: Scalars['Boolean'],
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>,
};

/** References existing line items from the underlying order that aren't reified by this expert curated order */
export type ExpertCuratedOrderLineItem = {
  __typename: 'ExpertCuratedOrderLineItem',
  id: Scalars['OrderLineItemId'],
  title: Scalars['String'],
  price: MonetaryAmount,
  orderLineItem: OrderLineItem,
};

export type ExpertCuratedOrderListActivation = {
  __typename: 'ExpertCuratedOrderListActivation',
  id: Scalars['ExpertCuratedOrderListActivationId'],
  createdAt: Scalars['Date'],
  /** expert that activated these curated orders */
  activatedBy: BusinessUser,
  /** user these curated orders were created for; de-normalized from the lead */
  createdFor: User,
  /** the lead associated with this curated list activation */
  lead: Lead,
  /** expert curated orders that were just activated as part of this activation */
  activated: Array<ExpertCuratedOrder>,
  /** expert curated orders that were previously activated, and still active as part of this activation */
  existingActive: Array<ExpertCuratedOrder>,
  /** get all active curated orders as part of this activation */
  active: Array<ExpertCuratedOrder>,
  /** expert curated order ids that were previously activated, but closed (removed) due to being superseded by the orders
   * in `activated`.
 */
  closed: Array<ExpertCuratedOrder>,
  consumerUrl: Scalars['String'],
  previousActivation?: Maybe<ExpertCuratedOrderListActivation>,
  /** used for trigger entity only to avoid unnecessary look up of Business User */
  activatedById: Scalars['BusinessUserId'],
};

export type ExpertCuratedOrderListActivationConnection = {
  __typename: 'ExpertCuratedOrderListActivationConnection',
  edges: Array<ExpertCuratedOrderListActivationEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedOrderListActivationEdge = {
  __typename: 'ExpertCuratedOrderListActivationEdge',
  node: ExpertCuratedOrderListActivation,
  cursor: Scalars['String'],
};


export type ExpertCuratedOrderManualTaxAdjustment = {
  __typename: 'ExpertCuratedOrderManualTaxAdjustment',
  taxRate?: Maybe<Scalars['BigDecimal']>,
  amount?: Maybe<MonetaryAmount>,
  computedFromAmount?: Maybe<MonetaryAmount>,
};

export type ExpertCuratedOrderManualTaxAdjustmentInput = {
  taxRate?: Maybe<Scalars['BigDecimal']>,
  amount?: Maybe<MonetaryAmountInput>,
  computedFromAmount?: Maybe<MonetaryAmountInput>,
};

export enum ExpertCuratedOrderSelectErrorCode {
  /** Expert curated order is not in an active state. This may be due to the curated order being replaced, or manually
   * closed. If being replaced, {@link #getActiveReplacement()} will have the updated curated order.
 */
  NOT_ACTIVE = 'NOT_ACTIVE'
}

export enum ExpertCuratedOrderServiceLocationErrorCode {
  /** An invalid address was supplied. */
  INVALID_ADDRESS = 'INVALID_ADDRESS'
}

export type ExpertCuratedOrdersForLeadConnection = {
  __typename: 'ExpertCuratedOrdersForLeadConnection',
  edges: Array<ExpertCuratedOrdersForLeadEdge>,
  pageInfo: PageInfo,
};

export type ExpertCuratedOrdersForLeadConnectionChangedPayload = {
  __typename: 'ExpertCuratedOrdersForLeadConnectionChangedPayload',
  connection: ExpertCuratedOrdersForLeadConnection,
};

export type ExpertCuratedOrdersForLeadEdge = {
  __typename: 'ExpertCuratedOrdersForLeadEdge',
  node: ExpertCuratedOrder,
  cursor: Scalars['String'],
};

export enum ExpertCuratedOrdersForLeadQueryCustomFilter {
  /** Show custom and not custom */
  INCLUDE = 'INCLUDE',
  /** Only show custom */
  ONLY = 'ONLY',
  /** Show no custom; only non custom */
  NONE = 'NONE'
}

export enum ExpertCuratedOrdersForLeadQueryDraftFilter {
  /** Show all drafts and non drafts */
  INCLUDE = 'INCLUDE',
  /** Show drafts that are newly created (not from replacing an existing curated order) and non drafts */
  INCLUDE_CREATED_DRAFT = 'INCLUDE_CREATED_DRAFT',
  /** Only show drafts (and no non drafts) */
  ONLY = 'ONLY',
  /** Show no drafts; only non drafts */
  NONE = 'NONE'
}

export type ExpertCuratedOrdersForLeadQueryInput = {
  leadId: Scalars['LeadId'],
  /** Defaults to `NONE` */
  draftFilter?: Maybe<ExpertCuratedOrdersForLeadQueryDraftFilter>,
  /** Defaults to `NONE` */
  customFilter?: Maybe<ExpertCuratedOrdersForLeadQueryCustomFilter>,
  /** Show curated orders that are in state EXPIRED or CLOSED, defaults to false */
  showClosed?: Maybe<Scalars['Boolean']>,
};

export enum ExpertCuratedOrderState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  EXPIRED = 'EXPIRED'
}

export type ExpertCuratedOrderVariationOption = {
  __typename: 'ExpertCuratedOrderVariationOption',
  sellable: Sellable,
  price: MonetaryAmount,
  enabled: Scalars['Boolean'],
  selected: Scalars['Boolean'],
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>,
};

export enum ExpertGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER'
}

export type ExpertLeadFolder = {
  __typename: 'ExpertLeadFolder',
  id: Scalars['ExpertLeadFolderId'],
  totalCount?: Maybe<Scalars['Int']>,
  revenue?: Maybe<MonetaryAmount>,
  slug: Scalars['String'],
  displayName: Scalars['String'],
};

export type ExpertLeadFolderGroup = {
  __typename: 'ExpertLeadFolderGroup',
  type: ExpertLeadFolderGroupType,
  displayName: Scalars['String'],
  folders: Array<ExpertLeadFolder>,
};

export enum ExpertLeadFolderGroupType {
  INBOX = 'INBOX',
  INBOX_ASSISTANT = 'INBOX_ASSISTANT',
  SALES_PIPELINE = 'SALES_PIPELINE',
  FOLDERS = 'FOLDERS'
}


export type ExpertLeadFolderItemChange = {
  __typename: 'ExpertLeadFolderItemChange',
  lead: Lead,
  type: ExpertLeadFolderItemChangeType,
};

export enum ExpertLeadFolderItemChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export enum ExpertNewMessageNotificationMode {
  NONE = 'NONE',
  ALWAYS = 'ALWAYS',
  WHEN_NOT_ACTIVATED = 'WHEN_NOT_ACTIVATED',
  WHEN_NOT_ONLINE = 'WHEN_NOT_ONLINE'
}

export type ExpertNotification = {
  __typename: 'ExpertNotification',
  type: ExpertNotificationType,
};

export type ExpertNotificationLeadEscalation = ExpertNotification & {
  __typename: 'ExpertNotificationLeadEscalation',
  type: ExpertNotificationType,
  leadEscalation: LeadEscalation,
};

export enum ExpertNotificationType {
  LEAD_ESCALATION = 'LEAD_ESCALATION'
}

export enum ExpertPerformanceRating {
  NEW = 'NEW',
  PLATINUM = 'PLATINUM',
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  BRONZE = 'BRONZE'
}

export type ExpertProfile = {
  __typename: 'ExpertProfile',
  id: Scalars['ExpertProfileId'],
  user: User,
  headline: Scalars['String'],
  background: Scalars['String'],
  backgroundRichText?: Maybe<Scalars['String']>,
  location?: Maybe<Scalars['String']>,
  profilePhoto?: Maybe<MediaFile>,
  gallery: Array<MediaFileWithCaption>,
  recentArticles: Array<ExternalContent>,
  quotes: Array<Scalars['String']>,
  isDraft: Scalars['Boolean'],
  socialMediaUrls: Array<Scalars['String']>,
  socialMediaLinks: Array<SocialMediaLink>,
  highlights: Array<ProfileHighlight>,
  editableHighlightTypes: Array<ProfileHighlightType>,
  state: ExpertProfileState,
  businessUser: BusinessUser,
  submittedAt?: Maybe<Scalars['Date']>,
  publishedAt?: Maybe<Scalars['Date']>,
  changeRequestedAt?: Maybe<Scalars['Date']>,
  changeRequestNotes?: Maybe<Scalars['String']>,
  introductionVideoUrl?: Maybe<Scalars['String']>,
  socialMediaAccessTokens: Array<SocialMediaAccessToken>,
  currentGears: Array<Sellable>,
  favoriteBrands: Array<Brand>,
  gender?: Maybe<ExpertGender>,
};


export type ExpertProfileQuery = {
  states: Array<ExpertProfileState>,
};

export type ExpertProfileRequestChangesInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  notes?: Maybe<Scalars['String']>,
};

export type ExpertProfilesPagination = {
  __typename: 'ExpertProfilesPagination',
  profiles: Array<ExpertProfile>,
  count: Scalars['Long'],
};

export enum ExpertProfileState {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  PUBLISHED = 'PUBLISHED'
}

export type ExpertRecommendationByLeastWorkloadRecord = ExpertRecommendationRecord & {
  __typename: 'ExpertRecommendationByLeastWorkloadRecord',
  id: Scalars['ExpertRecommendationId'],
  strategy: ExpertRecommendationStrategy,
  occurredAt: Scalars['Date'],
  consumer: User,
  assignedTo?: Maybe<BusinessUser>,
  resultingLead?: Maybe<Lead>,
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>,
  primaryExperts: Array<BusinessUser>,
  backupExperts: Array<BusinessUser>,
  expertWorkloads: Array<ExpertWorkloadForRecommendation>,
  fallbackExpertUsed: Scalars['Boolean'],
};

export type ExpertRecommendationByPerformanceWeightCandidate = {
  __typename: 'ExpertRecommendationByPerformanceWeightCandidate',
  expert: BusinessUser,
  rating: ExpertPerformanceRating,
  externalMarketingBudget: MonetaryAmount,
  workload: Scalars['Float'],
  capacity: Scalars['Float'],
  acceptingNewLead: Scalars['Boolean'],
};

export type ExpertRecommendationByPerformanceWeightRecord = ExpertRecommendationRecord & {
  __typename: 'ExpertRecommendationByPerformanceWeightRecord',
  id: Scalars['ExpertRecommendationId'],
  strategy: ExpertRecommendationStrategy,
  occurredAt: Scalars['Date'],
  consumer: User,
  assignedTo?: Maybe<BusinessUser>,
  resultingLead?: Maybe<Lead>,
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>,
  fallbackExpertUsed: Scalars['Boolean'],
  expertCandidates: Array<ExpertRecommendationByPerformanceWeightCandidate>,
  newRelationship: Scalars['Boolean'],
};


export type ExpertRecommendationRecord = {
  __typename: 'ExpertRecommendationRecord',
  id: Scalars['ExpertRecommendationId'],
  strategy: ExpertRecommendationStrategy,
  occurredAt: Scalars['Date'],
  consumer: User,
  assignedTo?: Maybe<BusinessUser>,
  resultingLead?: Maybe<Lead>,
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>,
};

export enum ExpertRecommendationStrategy {
  LEAST_WORKLOAD = 'LEAST_WORKLOAD',
  PERFORMANCE_WEIGHTED = 'PERFORMANCE_WEIGHTED'
}

export type ExpertReferral = {
  __typename: 'ExpertReferral',
  id: Scalars['ExpertReferralId'],
  expert: BusinessUser,
  referrer: User,
  note: Scalars['String'],
  referralUrl: Scalars['String'],
  fromExpert: Scalars['Boolean'],
  contactType: ContactType,
  contactValue: Scalars['String'],
};


export type ExpertSearchConnection = {
  __typename: 'ExpertSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<ExpertSearchEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type ExpertSearchEdge = {
  __typename: 'ExpertSearchEdge',
  node: BusinessUser,
  cursor: Scalars['String'],
};

export type ExpertSearchQuery = {
  name?: Maybe<Scalars['String']>,
  keywords?: Maybe<Scalars['String']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  facetedSearch: Scalars['Boolean'],
  facets?: Maybe<Array<FacetSelection>>,
  includePlaceHolderExpert?: Maybe<Scalars['Boolean']>,
  featuredOnly?: Maybe<Scalars['Boolean']>,
};

export enum ExpertSearchSort {
  DEFAULT = 'DEFAULT',
  PERFORMANCE = 'PERFORMANCE',
  FEATURED = 'FEATURED'
}

export type ExpertStats = {
  __typename: 'ExpertStats',
  totalMessages: Scalars['Int'],
  totalLeads: Scalars['Int'],
  averageRating?: Maybe<Scalars['Float']>,
  totalReviews: Scalars['Int'],
  topGoodQualities: Array<Scalars['String']>,
};

export type ExpertTipPercentage = {
  __typename: 'ExpertTipPercentage',
  expert: BusinessUser,
  /** Value between 1 and 100 */
  percentOfTip: Scalars['Int'],
};

export type ExpertTipPercentageInput = {
  expertId: Scalars['BusinessUserId'],
  /** Value between 1 and 100 */
  percentOfTip: Scalars['Int'],
};

export type ExpertTopRecommendedBrand = {
  __typename: 'ExpertTopRecommendedBrand',
  brand: Brand,
  timesRecommended?: Maybe<Scalars['Int']>,
};

export type ExpertTopRecommendedBrandsInput = {
  expertId: Scalars['BusinessUserId'],
  departmentId: Scalars['DepartmentId'],
  topN?: Maybe<Scalars['Int']>,
};

export type ExpertTopRecommendedBrandsPayload = {
  __typename: 'ExpertTopRecommendedBrandsPayload',
  topRecommendedBrands: Array<ExpertTopRecommendedBrand>,
};

export type ExpertTopRecommendedSellable = {
  __typename: 'ExpertTopRecommendedSellable',
  sellable: Sellable,
  timesRecommended?: Maybe<Scalars['Int']>,
};

export type ExpertTopRecommendedSellablesInput = {
  expertId: Scalars['BusinessUserId'],
  departmentId: Scalars['DepartmentId'],
  maxRecommendationsPerCategory?: Maybe<Scalars['Int']>,
  recommendedAfter?: Maybe<Scalars['Date']>,
};

export type ExpertTopRecommendedSellablesPayload = {
  __typename: 'ExpertTopRecommendedSellablesPayload',
  categoryTopRecommendedSellables: Array<ExpertCategoryTopRecommendedSellable>,
};

export type ExpertTypeaheadPayload = {
  __typename: 'ExpertTypeaheadPayload',
  experts: Array<BusinessUser>,
};

export type ExpertTypeaheadQuery = {
  prefixSearch: Scalars['String'],
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
};

export type ExpertWorkloadForRecommendation = {
  __typename: 'ExpertWorkloadForRecommendation',
  expert: BusinessUser,
  workload: Scalars['Float'],
  capacity: Scalars['Float'],
};

export type ExternalAdCampaign = {
  __typename: 'ExternalAdCampaign',
  id: Scalars['ExternalAdCampaignId'],
  name: Scalars['String'],
  adPlatform: ExternalAdPlatform,
  category: Category,
  externalId: Scalars['String'],
  status: ExternalAdStatus,
  /** The normalized budget allocated to this campaign. The value here means assuming the total budget is 100, what would
   * be the budget allocated for this campaign. For example, if the value is 30, and the total budget is 150, the actual
   * budget for this campaign is 45.
 */
  normalizedBudget: Scalars['BigDecimal'],
  adGroups: Array<ExternalAdGroup>,
};


export type ExternalAdGroup = {
  __typename: 'ExternalAdGroup',
  id: Scalars['ExternalAdGroupId'],
  adCampaign: ExternalAdCampaign,
  name: Scalars['String'],
  adPlatform: ExternalAdPlatform,
  externalId: Scalars['String'],
  status: ExternalAdStatus,
  /** The normalized budget allocated to this ad group. The value here means assuming the total budget is 100, what would
   * be the budget allocated for this ad group. For example, if the value is 30, and the total budget is 150, the actual
   * budget for this ad group is 45.
 */
  normalizedBudget?: Maybe<Scalars['BigDecimal']>,
  /** The campaign normalized budget allocated to this ad group. The value here means assuming the campaign budget is
   * 100, what would be the budget allocated for this ad group. This value is used to calculate the normalized budget.
 */
  campaignNormalizedBudget?: Maybe<Scalars['BigDecimal']>,
};


export enum ExternalAdPlatform {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export enum ExternalAdStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  DELETED = 'DELETED'
}

export type ExternalContent = {
  __typename: 'ExternalContent',
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  url: Scalars['String'],
  imageUrl?: Maybe<Scalars['String']>,
};

export type ExternalContentInput = {
  title: Scalars['String'],
  url: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  imageUrl?: Maybe<Scalars['String']>,
};

export type ExternalInventoryItemSource = {
  __typename: 'ExternalInventoryItemSource',
  /** The external id of the inventory item if managed by a third party managment tool like Shopify */
  externalId: Scalars['String'],
  type: ExternalInventoryItemSourceType,
};

export enum ExternalInventoryItemSourceType {
  SHOPIFY = 'SHOPIFY'
}

export type ExternalProfile = {
  __typename: 'ExternalProfile',
  type: ExternalProfileType,
};

export enum ExternalProfileType {
  FACEBOOK_MESSENGER = 'FACEBOOK_MESSENGER',
  PIPL = 'PIPL'
}

export type ExternalVideo = {
  __typename: 'ExternalVideo',
  /** ID for the video. This can be extracted from the url, for example, url `https://www.youtube.com/watch?v=0tHH0BNH0Sc`
   * has an id of `0tHH0BNH0Sc`
 */
  id: Scalars['String'],
  /** Video type */
  idType: ExternalVideoIdType,
  /** This is the url to view the video on the website for idType */
  destinationUrl: Scalars['String'],
};

export enum ExternalVideoIdType {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO'
}

export type FacebookMessengerPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'FacebookMessengerPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};

export type FacebookMessengerProfile = ExternalProfile & {
  __typename: 'FacebookMessengerProfile',
  id: Scalars['String'],
  type: ExternalProfileType,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
  locale?: Maybe<Scalars['String']>,
  timezone?: Maybe<Scalars['String']>,
  gender?: Maybe<Scalars['String']>,
};

export type FacebookTcpaComplianceMetadata = PathFlowPageMetadata & {
  __typename: 'FacebookTCPAComplianceMetadata',
  type: PathFlowPageMetadataType,
};

export type FacebookTemplate = ChannelTemplate & {
  __typename: 'FacebookTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type FacebookTemplateInput = {
  body: Scalars['String'],
};

export type FacetImageMetadata = {
  __typename: 'FacetImageMetadata',
  type: FacetImageType,
};

export enum FacetImageType {
  /** Facets that are shown as Icons on the UI */
  ICON = 'ICON',
  /** BACKGROUND */
  BACKGROUND = 'BACKGROUND'
}

export type FacetSelection = {
  /** Internal name or alias for facet that's being selected, typically from DisplayFacet.name or DisplayFacet.alias */
  name: Scalars['String'],
  /** If this facet is a BucketedDisplayFacet, the `IndividualBucketedDisplayFacet.value`s that were selected. */
  bucketValues?: Maybe<Array<Scalars['String']>>,
  /** If this facet is a NumericRangeDisplayFacet, the unscaled lower bound that's being set. */
  lower?: Maybe<Scalars['Long']>,
  /** If this facet is a NumericRangeDisplayFacet, the unscaled upper bound that's being set. */
  upper?: Maybe<Scalars['Long']>,
  /** The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value.
   * Defaults to 0 (which makes unscaled value == scaled value).
 */
  scale?: Maybe<Scalars['Int']>,
};

export type FacetSelectionPayload = {
  __typename: 'FacetSelectionPayload',
  name: Scalars['String'],
  displayName: Scalars['String'],
  alias?: Maybe<Scalars['String']>,
  bucketValues?: Maybe<Array<Scalars['String']>>,
  lower?: Maybe<Scalars['Long']>,
  upper?: Maybe<Scalars['Long']>,
  scale?: Maybe<Scalars['Int']>,
};

/** Featured rich content from various sites (e.g.: YouTube, Instagram, review sites, etc) */
export type FeaturedSellableContent = {
  __typename: 'FeaturedSellableContent',
  id: Scalars['SellableId'],
  /** ID portion of instagram url. */
  instagramPostIds: Array<Scalars['String']>,
  /** Relevant instagram hash tag */
  instagramHashTag?: Maybe<Scalars['String']>,
  /** Videos hosted by sites like YouTube */
  externalVideos: Array<ExternalVideo>,
  /** Reviews */
  editorialReviews: Array<EditorialReview>,
};

export type FeaturedSellableContentUploadTaskPayload = {
  __typename: 'FeaturedSellableContentUploadTaskPayload',
  numEntriesProcessed: Scalars['Int'],
  numEntriesIgnored: Scalars['Int'],
  numEntriesCreated: Scalars['Int'],
  numEntriesUpdated: Scalars['Int'],
  errorEntries: Array<Scalars['String']>,
  mediaId: Scalars['MediaId'],
};

export type FindOrCreateReplacementExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type FindOrCreateReplacementExpertCuratedOrderPayload = {
  __typename: 'FindOrCreateReplacementExpertCuratedOrderPayload',
  /** The expert curated order that's being replaced */
  superseded: ExpertCuratedOrder,
  /** The found or newly created draft expert curated order that can be modified, and subsequently activated */
  draft: ExpertCuratedOrder,
};

export type FlightPlan = {
  __typename: 'FlightPlan',
  id: Scalars['FlightPlanId'],
  consumer?: Maybe<User>,
  state: FlightPlanState,
  legs: Array<FlightPlanLeg>,
};

export enum FlightPlanEditErrorCode {
  EMPTY_LEGS = 'EMPTY_LEGS',
  NO_SUCH_LEG = 'NO_SUCH_LEG',
  MISSING_AIRPORT = 'MISSING_AIRPORT',
  SAME_AIRPORT = 'SAME_AIRPORT',
  OVERLAPPING_LEGS = 'OVERLAPPING_LEGS',
  NOT_DRAFT = 'NOT_DRAFT'
}


export type FlightPlanLeg = {
  __typename: 'FlightPlanLeg',
  id: Scalars['FlightPlanLegId'],
  /** One or the other will be specified */
  departAt?: Maybe<Scalars['Date']>,
  departOn?: Maybe<Scalars['LocalDate']>,
  arriveAt?: Maybe<Scalars['Date']>,
  durationInMinutes?: Maybe<Scalars['Int']>,
  flightOperator?: Maybe<Scalars['String']>,
  /** Required for ACTIVE */
  departureAirport?: Maybe<Airport>,
  /** Required for ACTIVE */
  arrivalAirport?: Maybe<Airport>,
};


export type FlightPlanLegUpsertRequestInput = {
  id?: Maybe<Scalars['FlightPlanLegId']>,
  departAt?: Maybe<Scalars['Date']>,
  departOn?: Maybe<Scalars['LocalDate']>,
  durationInMinutes?: Maybe<Scalars['Int']>,
  flightOperator?: Maybe<Scalars['String']>,
  departureAirportId?: Maybe<Scalars['AirportId']>,
  arrivalAirportId?: Maybe<Scalars['AirportId']>,
};

export enum FlightPlanState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE'
}

export type FormattedAttribute = {
  __typename: 'FormattedAttribute',
  name: Scalars['String'],
  internalName: Scalars['String'],
  displayValue: Scalars['String'],
  displayHtml: Scalars['String'],
  displayHtmlValues: Array<Scalars['String']>,
};

export type FrontendTask = {
  __typename: 'FrontendTask',
  id: Scalars['FrontendTaskId'],
  status: FrontendTaskStatus,
  payload?: Maybe<TaskPayload>,
};


export enum FrontendTaskStatus {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ABORTED = 'ABORTED'
}

export type FulfillmentCenter = {
  __typename: 'FulfillmentCenter',
  id: Scalars['FulfillmentCenterId'],
  name: Scalars['String'],
  active: Scalars['Boolean'],
  /** External id of the fulfillment center if managed by third party managment tool like Shopify */
  externalLocationId?: Maybe<Scalars['String']>,
  address: PostalAddress,
  serviceTypeWithDisplayName: FulfillmentServiceTypeWithDisplayName,
  serviceProviderWithDiplayName: FulfillmentServiceProviderWithDisplayName,
};

export type FulfillmentCenterConnection = {
  __typename: 'FulfillmentCenterConnection',
  pageInfo: PageInfo,
  edges: Array<FulfillmentCenterEdge>,
};

export type FulfillmentCenterEdge = {
  __typename: 'FulfillmentCenterEdge',
  cursor: Scalars['String'],
  node: FulfillmentCenter,
};


export type FulfillmentCentersQuery = {
  activeOnly: Scalars['Boolean'],
};

export enum FulfillmentServiceProvider {
  DEAL = 'DEAL',
  UPS = 'UPS'
}

export type FulfillmentServiceProviderWithDisplayName = {
  __typename: 'FulfillmentServiceProviderWithDisplayName',
  serviceProvider: FulfillmentServiceProvider,
  displayName: Scalars['String'],
};

export enum FulfillmentServiceType {
  THIRD_PARTY_LOGISTICS = 'THIRD_PARTY_LOGISTICS',
  DEAL_WH = 'DEAL_WH'
}

export type FulfillmentServiceTypeWithDisplayName = {
  __typename: 'FulfillmentServiceTypeWithDisplayName',
  serviceType: FulfillmentServiceType,
  displayName: Scalars['String'],
};

export type GenerateCollectPhoneNumberTextInPathInput = {
  pathFlowId: Scalars['PathFlowId'],
};

export type GenerateCollectPhoneNumberTextInPathPayload = {
  __typename: 'GenerateCollectPhoneNumberTextInPathPayload',
  toNumber: Scalars['String'],
  body: Scalars['String'],
};

export type GeocodingResponse = {
  __typename: 'GeocodingResponse',
  streetNumber?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  postalCode?: Maybe<Scalars['String']>,
  formattedAddress?: Maybe<Scalars['String']>,
  placeId?: Maybe<Scalars['String']>,
  latitude?: Maybe<Scalars['Float']>,
  longitude?: Maybe<Scalars['Float']>,
};

export type GetOrCreateUserCartForExpertInput = {
  userId: Scalars['UserId'],
};

export type GetOrCreateUserCartForExpertPayload = {
  __typename: 'GetOrCreateUserCartForExpertPayload',
  order: Order,
};

export type GlobalStatsAggregateExpertReport = {
  __typename: 'GlobalStatsAggregateExpertReport',
  conversationsCountTotal: Scalars['Int'],
  conversationsCountThisWeek: Scalars['Int'],
  averageExpertRating: Scalars['Float'],
  reviewsCount: Scalars['Int'],
  curationsCountTotal: Scalars['Int'],
  curationsCountThisWeek: Scalars['Int'],
};

export type GuestConversation = {
  __typename: 'GuestConversation',
  expert: BusinessUser,
  version: Scalars['Int'],
  messages: Array<GuestConversationMessage>,
  signature: Scalars['String'],
};

export type GuestConversationInput = {
  expertId: Scalars['BusinessUserId'],
  version: Scalars['Int'],
  messages: Array<GuestConversationMessageInput>,
  signature: Scalars['String'],
};

export type GuestConversationMessage = {
  __typename: 'GuestConversationMessage',
  id: Scalars['String'],
  parts: Array<ConversationMessagePart>,
  sendBy: MessagingUser,
  sendAt: Scalars['Date'],
  typeAt?: Maybe<Scalars['Date']>,
};

export type GuestConversationMessageInput = {
  id: Scalars['String'],
  parts: Array<ConversationMessagePartInput>,
  sendBy: Scalars['AnyId'],
  sendAt: Scalars['Date'],
};

export type GuestConversationSequence = {
  __typename: 'GuestConversationSequence',
  id: Scalars['GuestConversationSequenceId'],
  name: Scalars['String'],
  state: GuestConversationSequenceState,
  messages: Array<GuestConversationSequenceMessage>,
};


export type GuestConversationSequenceMessage = {
  __typename: 'GuestConversationSequenceMessage',
  templateType: CommTemplateType,
  delay?: Maybe<Duration>,
  typingDuration?: Maybe<Duration>,
};

export type GuestConversationSequenceMessageInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  delay?: Maybe<DurationInput>,
  typingDuration?: Maybe<DurationInput>,
};

export type GuestConversationSequenceQuery = {
  states?: Maybe<Array<GuestConversationSequenceState>>,
};

export enum GuestConversationSequenceState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum HandleType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}

export type IconFacetImageMetadata = FacetImageMetadata & {
  __typename: 'IconFacetImageMetadata',
  type: FacetImageType,
  imageUrl: Scalars['String'],
};

export type IdCodecPayload = {
  __typename: 'IdCodecPayload',
  error?: Maybe<Scalars['String']>,
  externalId?: Maybe<Scalars['String']>,
  internalId?: Maybe<Scalars['String']>,
  idType?: Maybe<Scalars['String']>,
};

export type IdentifyEBayItemAsSellableInput = {
  sellableId: Scalars['SellableId'],
  eBayItemId: Scalars['String'],
};

export type IdentifyEBayItemAsSellablePayload = {
  __typename: 'IdentifyEBayItemAsSellablePayload',
  sellable: Sellable,
};

/** ====== IdPathFlowQuestion */
export type IdPathFlowQuestion = PathFlowQuestion & {
  __typename: 'IdPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  type: IdPathFlowQuestionType,
  /** If reloading a question answered by the user, this is their previous input */
  idUserInput: SubmitIdPathFlowQuestionInputTypeCopy,
  /** Maximum amount of id values that are allowed for this question */
  maximumValues: Scalars['Int'],
};


/** ====== IdPathFlowQuestion */
export type IdPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum IdPathFlowQuestionType {
  MEDIA_ID_IMAGE_UPLOAD = 'MEDIA_ID_IMAGE_UPLOAD',
  EXPERT_ID_SELECTION = 'EXPERT_ID_SELECTION',
  PRODUCTS_TYPEAHEAD = 'PRODUCTS_TYPEAHEAD',
  FLIGHT_PLAN = 'FLIGHT_PLAN'
}

/** Notes:
 * - For lists that can be paginated, we're following the GraphQL Relay "Connection" model.
 *   This is where the "Node/Edges/Connections" convention comes from. Even though we're
 *   using Apollo, this is the most popular pagination model for GraphQL so it's beneficial
 *   for us to adopt. It's basically cursor based pagination; see the following links for
 *   more info:
 *   https://dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976
 *   https://facebook.github.io/relay/docs/graphql-connections.html
 *   https://facebook.github.io/relay/graphql/connections.htm
 * 
 * - Validation: All submits include an array of validation errors that can target the entire flow,
 *   a specific page, or a specific question. These are meant to be displayed to the user. The
 *   validation rules sent down by the server (e.g.: regex validation) is our best attempt at guiding
 *   the client to provide correct input, but it can't be guaranteed for all inputs (e.g.: server data
 *   is required for validation).
 * =============
 * Generic Types
 * =============
 * ====== Image View Model
 */
export type ImageViewModel = PathImageViewModel;

export type ImportEntitiesInput = {
  file: Scalars['Upload'],
};

export type ImportEntitiesPayload = {
  __typename: 'ImportEntitiesPayload',
  templates: Array<MultiLocaleTemplateSet>,
  triggers: Array<Trigger>,
  templateTypes: Array<CommTemplateType>,
  templateFragments: Array<CommTemplateFragment>,
  leadCampaigns: Array<LeadCampaign>,
};

export type InAppTemplate = ChannelTemplate & {
  __typename: 'InAppTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type InAppTemplateInput = {
  body: Scalars['String'],
};

export type IndividualBucketedDisplayFacet = {
  __typename: 'IndividualBucketedDisplayFacet',
  /** Name to display in the UI for this facet bucket */
  displayName: Scalars['String'],
  /** Internal value that should be provided back to FacetSelection.bucketValues when selecting facet values */
  value: Scalars['String'],
  /** Facet count that should be displayed for this bucket. Depending on product requirements or the way facets
   * are computed, counts may not always be available
 */
  count?: Maybe<Scalars['Long']>,
  /** Optional image associated with the Facet value. This is used in navigation style SERP pages. */
  imageMetadata?: Maybe<FacetImageMetadata>,
};

export type IndividualBucketedRangeDisplayFacet = {
  __typename: 'IndividualBucketedRangeDisplayFacet',
  /** Name to display in the UI for this facet bucket */
  displayName: Scalars['String'],
  /** Facet count that should be displayed for this bucket. Depending on product requirements or the way facets
   * are computed, counts may not always be available
 */
  count?: Maybe<Scalars['Long']>,
  /** Type of numeric facet; currently used to change rendering styles */
  type: NumericRangeDisplayFacetType,
  /** unscaled lower bound */
  lower: Scalars['Long'],
  /** unscaled upper bound */
  upper: Scalars['Long'],
  /** if `upper` is capped (there are values beyond upper, but the result is truncated for ease of use, and querying for
   * the capped upper value will give all values beyond it)
 */
  upperCapped: Scalars['Boolean'],
  /** The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value. */
  scale: Scalars['Int'],
  /** Computed decimal value of `lower` at `scale` */
  decimalLower: Scalars['BigDecimal'],
  /** Computed decimal value of `upper` at `scale` */
  decimalUpper: Scalars['BigDecimal'],
};

export type InitiateAffirmPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
  paymentRedirectUrls: PaymentRedirectUrls,
};

export type InitiateAffirmPaymentForOrderPayload = {
  __typename: 'InitiateAffirmPaymentForOrderPayload',
  order: Order,
  /** The string representation of the JSON object to be passed to Affirm javascript SDK. */
  checkoutData: Scalars['String'],
};

export type InitiateAfterpayPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
  paymentRedirectUrls: PaymentRedirectUrls,
};

export type InitiateAfterpayPaymentForOrderPayload = {
  __typename: 'InitiateAfterpayPaymentForOrderPayload',
  order: Order,
  /** This is a unique token that is used for 2 purposes:
   * 1. As part of the redirect request to Afterpay (on frontend)
   * 2. For uniquely capturing the payment after approval (on backend)
   * 
   * On approval from Afterpay, this same token is appended to the redirectConfirmUrl and should be sent as the
   * paymentProcessorPlatformSourceId field in the ChargeInfoInput object. Note, the Afterpay payments are single use only
 */
  orderToken: Scalars['String'],
};

export type InitiateAuthenticationInput = {
  /** handle/handleType or handleId must be present */
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  handleId?: Maybe<Scalars['AnyId']>,
  captcha: Scalars['String'],
};

export type InitiateAuthenticationPayload = {
  __typename: 'InitiateAuthenticationPayload',
  isValidHandle: Scalars['Boolean'],
  challengeType?: Maybe<ChallengeType>,
  session: Session,
};

export type InitiatePaypalPaymentForOfferConfirmation = {
  __typename: 'InitiatePaypalPaymentForOfferConfirmation',
  paymentId: Scalars['String'],
  authorizationUrl: Scalars['String'],
  price: MonetaryAmount,
  tax?: Maybe<MonetaryAmount>,
  shippingCost?: Maybe<MonetaryAmount>,
  tip?: Maybe<MonetaryAmount>,
};

export type InitiatePaypalPaymentForOfferInput = {
  tip?: Maybe<MonetaryAmountInput>,
  tax?: Maybe<MonetaryAmountInput>,
  shippingAddress?: Maybe<AddressInput>,
  offerId: Scalars['BroadcastOfferId'],
  paymentRedirectUrls?: Maybe<PaymentRedirectUrls>,
};

export type InitiatePaypalPaymentForOfferPayload = {
  __typename: 'InitiatePaypalPaymentForOfferPayload',
  result?: Maybe<InitiatePaypalPaymentForOfferConfirmation>,
  error?: Maybe<Scalars['String']>,
};

export type InitiatePaypalPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
  paymentRedirectUrls?: Maybe<PaymentRedirectUrls>,
};

export type InitiatePaypalPaymentForOrderPayload = {
  __typename: 'InitiatePaypalPaymentForOrderPayload',
  order: Order,
  paymentId: Scalars['String'],
  authorizationUrl: Scalars['String'],
};

export type InitiateResetPasswordInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
};

export type InitiateResetPasswordPayload = {
  __typename: 'InitiateResetPasswordPayload',
  success: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type InitiateVerifyHandleInput = {
  handle: Scalars['String'],
  handleType: HandleType,
};

export type InitiateVerifyHandlePayload = {
  __typename: 'InitiateVerifyHandlePayload',
  success: Scalars['Boolean'],
};

export type InitiateWireTransferPaymentForOrderInput = {
  orderId: Scalars['OrderId'],
};

export type InitiateWireTransferPaymentForOrderPayload = {
  __typename: 'InitiateWireTransferPaymentForOrderPayload',
  order: Order,
  /** The payment source which guarantees that it has a WireTransferPaymentEntity. */
  paymentSource: PaymentSource,
};

export type InputTextPathFlowQuestion = PathFlowQuestion & InputTextPathFlowQuestionMixin & {
  __typename: 'InputTextPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>,
  fieldType: InputTextPathFlowQuestionFieldType,
  placeholder?: Maybe<Scalars['String']>,
  inputTextUserInput: SubmitInputTextPathFlowQuestionInputTypeCopy,
};


export type InputTextPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum InputTextPathFlowQuestionFieldType {
  /** Typeahead for airports only */
  AIRPORT_TYPEAHEAD = 'AIRPORT_TYPEAHEAD',
  /** Single line "telephone" with SMS text context */
  SMS_TEXT = 'SMS_TEXT',
  /** Facebook user expectedReference */
  FACEBOOK_USER_REF = 'FACEBOOK_USER_REF',
  /** FCM Token */
  FCM_TOKEN = 'FCM_TOKEN',
  /** Single line text entry */
  INPUT_FIELD = 'INPUT_FIELD',
  /** Multi-line text area */
  TEXT_AREA = 'TEXT_AREA',
  /** Single line entry (numeric only) */
  NUMERIC = 'NUMERIC',
  /** Single line "telephone"-like entry (numeric only) */
  TELEPHONE = 'TELEPHONE',
  /** Single line "telephone" with its own submit action */
  TELEPHONE_SUBMIT = 'TELEPHONE_SUBMIT',
  /** Single line "email"-like entry (shows @ sign) */
  EMAIL = 'EMAIL',
  /** Text which is provided programmatically, thus should be hidden from the user */
  HIDDEN = 'HIDDEN'
}

export type InputTextPathFlowQuestionLengthValidation = InputTextPathFlowQuestionValidation & {
  __typename: 'InputTextPathFlowQuestionLengthValidation',
  type: InputTextPathFlowQuestionValidationType,
  minSize?: Maybe<Scalars['Int']>,
  maxSize?: Maybe<Scalars['Int']>,
};

/** ====== Input Text */
export type InputTextPathFlowQuestionMixin = {
  __typename: 'InputTextPathFlowQuestionMixin',
  required: Scalars['Boolean'],
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>,
  fieldType: InputTextPathFlowQuestionFieldType,
  placeholder?: Maybe<Scalars['String']>,
  questionSubText?: Maybe<TextViewModel>,
};

export type InputTextPathFlowQuestionNoArgValidation = InputTextPathFlowQuestionValidation & {
  __typename: 'InputTextPathFlowQuestionNoArgValidation',
  type: InputTextPathFlowQuestionValidationType,
};

export type InputTextPathFlowQuestionRegexValidation = InputTextPathFlowQuestionValidation & {
  __typename: 'InputTextPathFlowQuestionRegexValidation',
  type: InputTextPathFlowQuestionValidationType,
  regex: Scalars['String'],
  errorMessage: Scalars['String'],
};

export type InputTextPathFlowQuestionValidation = {
  __typename: 'InputTextPathFlowQuestionValidation',
  type: InputTextPathFlowQuestionValidationType,
};

export enum InputTextPathFlowQuestionValidationType {
  LENGTH = 'LENGTH',
  REGEX = 'REGEX',
  PHONE_NUMBER = 'PHONE_NUMBER'
}

export type InstallmentPaymentEntity = PaymentEntity & {
  __typename: 'InstallmentPaymentEntity',
  paymentMethod: PaymentMethod,
  /** Payment token created and used during the approval process for this PaymentEntity */
  paymentToken: Scalars['String'],
};

export type InternalMessagingUser = {
  __typename: 'InternalMessagingUser',
  id: Scalars['AnyId'],
  displayName: Scalars['String'],
};

export type InterstitialPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'InterstitialPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
  interstitialType: InterstitialPathFlowPageMetadataType,
  title?: Maybe<TextViewModel>,
  body?: Maybe<TextViewModel>,
};

export enum InterstitialPathFlowPageMetadataType {
  ALMOST_DONE = 'ALMOST_DONE',
  BROWSE_EXPERTS = 'BROWSE_EXPERTS',
  CALCULATING = 'CALCULATING',
  CONNECTING_TO_OPERATOR = 'CONNECTING_TO_OPERATOR',
  FINDING_MERCHANTS = 'FINDING_MERCHANTS',
  /** GENERIC_WITH_BUTTON interstitial uses a button to submit */
  GENERIC_WITH_BUTTON = 'GENERIC_WITH_BUTTON',
  /** GENERIC_WITH_TITLE interstitial that uses timer to submit */
  GENERIC_WITH_TITLE = 'GENERIC_WITH_TITLE',
  HIGH_SECURITY = 'HIGH_SECURITY',
  LOADING_QUESTIONS = 'LOADING_QUESTIONS',
  SNOWBOARD_INT_LEARN = 'SNOWBOARD_INT_LEARN',
  WELCOME = 'WELCOME',
  GIVE_US_A_SEC = 'GIVE_US_A_SEC',
  REQUEST_PUSH_NOTIFICATION_PERMISSION = 'REQUEST_PUSH_NOTIFICATION_PERMISSION',
  WHAT_HAPPENS_NEXT = 'WHAT_HAPPENS_NEXT'
}

export type InventoryTaskError = {
  __typename: 'InventoryTaskError',
  row: Scalars['Int'],
  message: Scalars['String'],
};

export type IpBasedUserData = {
  __typename: 'IpBasedUserData',
  companyName?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  countryName?: Maybe<Scalars['String']>,
  regionName?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
};

export type ItemCustomizingInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  customizationNotes?: Maybe<Scalars['String']>,
};

export type ItemCustomizingPayload = {
  __typename: 'ItemCustomizingPayload',
  order: Order,
};

export type ItemHasCustomizationIssuesInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  customizationNotes?: Maybe<Scalars['String']>,
};

export type ItemHasCustomizationIssuesPayload = {
  __typename: 'ItemHasCustomizationIssuesPayload',
  order: Order,
};

export type JoinVideoChatInput = {
  messagingUserId: Scalars['AnyId'],
  externalConversationId: Scalars['String'],
};

export type JoinVideoChatPayload = {
  __typename: 'JoinVideoChatPayload',
  token: Scalars['String'],
};

export type Lead = {
  __typename: 'Lead',
  id: Scalars['LeadId'],
  consumer: User,
  /** The expert of the lead. If the lead is assigned to an expert, this is the same as primaryExpert. Otherwise,
   * this is a placeholder expert.
 */
  expert: BusinessUser,
  /** The primary expert for the lead, if the lead is assigned to an expert */
  primaryExpert?: Maybe<BusinessUser>,
  delegateExpert?: Maybe<BusinessUser>,
  conversation: Conversation,
  labels: Array<LeadLabel>,
  starred: Scalars['Boolean'],
  notRepliedByConsumer: Scalars['Boolean'],
  neverReplied: Scalars['Boolean'],
  archived: Scalars['Boolean'],
  active: Scalars['Boolean'],
  snoozed: Scalars['Boolean'],
  latestRequest?: Maybe<DealRequest>,
  /** The related requests are sorted according to the creation time in ascending order */
  relatedRequests: Array<DealRequest>,
  snooze?: Maybe<LeadSnooze>,
  offers: Array<BroadcastOffer>,
  consumerConversationMetrics: ConversationMetrics,
  expertConversationMetrics: ConversationMetrics,
  dealbotConversationMetrics: ConversationMetrics,
  consumerUrl: Scalars['String'],
  expertUrl: Scalars['String'],
  expertUrlForAdmin: Scalars['String'],
  adminUrl: Scalars['String'],
  recommendationsUrl: Scalars['String'],
  leadScore?: Maybe<Scalars['Float']>,
  consumerReview?: Maybe<ConsumerExpertReview>,
  expertTeam?: Maybe<BusinessUserTeam>,
  /** used for graphql-based trigger entity.  expose Id directly to avoid unnecessary joins */
  labelIds: Array<Scalars['LeadLabelId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  expertId: Scalars['BusinessUserId'],
  delegateExpertId?: Maybe<Scalars['BusinessUserId']>,
  consumerId: Scalars['UserId'],
  lastMessageSentAt?: Maybe<Scalars['Date']>,
  consumerInitialAction?: Maybe<ConsumerInitialLeadAction>,
  pinnedMessages: Array<SavedLeadNote>,
  notes: Array<SavedLeadNote>,
  expertRecommendationRecord?: Maybe<ExpertRecommendationRecord>,
  lastActivityTime: Scalars['Date'],
  lastExpertMessageSentAt?: Maybe<Scalars['Date']>,
  lastExpertManualMessageSentAt?: Maybe<Scalars['Date']>,
  lastAssistantMessageSentAt?: Maybe<Scalars['Date']>,
  firstExpertManualMessageSentAt?: Maybe<Scalars['Date']>,
  lastManualMessageSenderType?: Maybe<LeadParticipantType>,
  expertMessageCount: Scalars['Int'],
  campaignIds: Array<Scalars['LeadCampaignId']>,
  curationSummary: CurationSummary,
  surveySummary?: Maybe<SurveySummary>,
  phoneCallSummary: PhoneCallSummary,
  createdAt: Scalars['Date'],
  category?: Maybe<Category>,
  department?: Maybe<Department>,
  suggestedActions: Array<SuggestedAction>,
  openEscalation?: Maybe<LeadEscalation>,
  curationLastViewedAt?: Maybe<Scalars['Date']>,
  leadActivities: Array<LeadActivity>,
  supportTaskActivities: Array<SupportTaskActivity>,
};


export type LeadOpenEscalationArgs = {
  type: LeadEscalationType
};


export type LeadLeadActivitiesArgs = {
  occurredSince?: Maybe<Scalars['Date']>,
  occurredBefore?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};


export type LeadSupportTaskActivitiesArgs = {
  occurredSince?: Maybe<Scalars['Date']>,
  occurredBefore?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};

export type LeadActivity = {
  __typename: 'LeadActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
};


export enum LeadActivityType {
  DELEGATE_EXPERT_CHANGED = 'DELEGATE_EXPERT_CHANGED',
  SNOOZE_CHANGED = 'SNOOZE_CHANGED',
  WOKE_UP_FROM_SNOOZE = 'WOKE_UP_FROM_SNOOZE',
  REASSIGNED = 'REASSIGNED',
  ARCHIVED = 'ARCHIVED',
  CONSUMER_FIRST_MESSAGE_SENT = 'CONSUMER_FIRST_MESSAGE_SENT',
  CONSUMER_CALLED = 'CONSUMER_CALLED',
  CONSUMER_PAYMENT_FAILED = 'CONSUMER_PAYMENT_FAILED',
  CONSUMER_PAYMENT_SUCCEEDED = 'CONSUMER_PAYMENT_SUCCEEDED',
  CONSUMER_ORDER_PAID = 'CONSUMER_ORDER_PAID',
  CONSUMER_REVIEW_ADDED = 'CONSUMER_REVIEW_ADDED',
  ESCALATION_STARTED = 'ESCALATION_STARTED',
  ESCALATION_CHANGED = 'ESCALATION_CHANGED',
  QUALITY_CONVERSATION_ESTABLISHED = 'QUALITY_CONVERSATION_ESTABLISHED'
}

export type LeadArchivedActivity = LeadActivity & {
  __typename: 'LeadArchivedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
};

export type LeadCampaign = {
  __typename: 'LeadCampaign',
  id: Scalars['LeadCampaignId'],
  name: Scalars['String'],
  sellable?: Maybe<Sellable>,
  deliveryTime?: Maybe<Scalars['Date']>,
  minimumHoursSinceLastMessage: Scalars['Float'],
  minimumHoursSinceLastCampaign: Scalars['Float'],
  maximumRecipients: Scalars['Float'],
  facets: Array<FacetSelectionPayload>,
  state: LeadCampaignState,
  dateRangeFilters: Array<DateRangeFilter>,
  keywordsFilter?: Maybe<Scalars['String']>,
  trigger?: Maybe<Trigger>,
};

export type LeadCampaignFilter = {
  name?: Maybe<Scalars['String']>,
  state?: Maybe<LeadCampaignState>,
};



export enum LeadCampaignState {
  DRAFT = 'DRAFT',
  TEST = 'TEST',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED'
}

export type LeadEscalation = {
  __typename: 'LeadEscalation',
  id: Scalars['LeadEscalationId'],
  createdAt: Scalars['Date'],
  type: LeadEscalationType,
  acceptAsLeadExpertRole: LeadExpertRole,
  level: LeadEscalationLevel,
  /** only used for trigger entity so that we skip looking up the business user */
  ownerId?: Maybe<Scalars['BusinessUserId']>,
  expertsNotifiedAt?: Maybe<Scalars['Date']>,
  teamNotifiedAt?: Maybe<Scalars['Date']>,
  supportNotifiedAt?: Maybe<Scalars['Date']>,
  closedAt?: Maybe<Scalars['Date']>,
  status: LeadEscalationStatus,
  lead: Lead,
  owner?: Maybe<BusinessUser>,
  onCallExpertCount: Scalars['Int'],
};

export type LeadEscalationChangedActivity = LeadActivity & {
  __typename: 'LeadEscalationChangedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  oldEscalation: LeadEscalation,
  newEscalation: LeadEscalation,
  closing: Scalars['Boolean'],
  escalatingUp: Scalars['Boolean'],
  escalatingToTeam: Scalars['Boolean'],
};


export enum LeadEscalationLevel {
  NOT_STARTED = 'NOT_STARTED',
  ONLINE_TEAM_MEMBERS = 'ONLINE_TEAM_MEMBERS',
  ALL_TEAM_MEMBERS = 'ALL_TEAM_MEMBERS',
  SUPPORT = 'SUPPORT',
  ONLINE_EXPERTS = 'ONLINE_EXPERTS',
  ALL_EXPERTS = 'ALL_EXPERTS',
  ON_CALL_EXPERTS = 'ON_CALL_EXPERTS'
}

export type LeadEscalationStartedActivity = LeadActivity & {
  __typename: 'LeadEscalationStartedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  escalation: LeadEscalation,
};

export enum LeadEscalationStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED'
}

export enum LeadEscalationType {
  CONSUMER_WAITING_RESPONSE = 'CONSUMER_WAITING_RESPONSE'
}

export enum LeadExpertRole {
  PRIMARY = 'PRIMARY',
  DELEGATE = 'DELEGATE'
}


export type LeadLabel = {
  __typename: 'LeadLabel',
  id: Scalars['LeadLabelId'],
  name: Scalars['String'],
  internalId: Scalars['String'],
};



/** @deprecated(reason: "LeadPaymentSucceededActivity") */
export type LeadOrderPaidActivity = LeadActivity & {
  __typename: 'LeadOrderPaidActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  total: MonetaryAmount,
  tip?: Maybe<MonetaryAmount>,
};

export enum LeadParticipantType {
  EXPERT = 'EXPERT',
  DELEGATE_EXPERT = 'DELEGATE_EXPERT',
  CONSUMER = 'CONSUMER',
  ASSISTANT = 'ASSISTANT',
  DEAL_BOT = 'DEAL_BOT'
}

export type LeadPaymentFailedActivity = LeadActivity & {
  __typename: 'LeadPaymentFailedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  paymentActivityType: PaymentActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  total: MonetaryAmount,
  amountPaid: MonetaryAmount,
  transactionAmount: MonetaryAmount,
  tip?: Maybe<MonetaryAmount>,
  paymentSource: Scalars['String'],
  paymentError: Scalars['String'],
};

export type LeadPaymentSucceededActivity = LeadActivity & {
  __typename: 'LeadPaymentSucceededActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  paymentActivityType: PaymentActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  total: MonetaryAmount,
  amountPaid: MonetaryAmount,
  transactionAmount: MonetaryAmount,
  fullPaymentDueAt?: Maybe<Scalars['Date']>,
  tip?: Maybe<MonetaryAmount>,
};

export type LeadReassignedActivity = LeadActivity & {
  __typename: 'LeadReassignedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  currentExpert: BusinessUser,
  previousExpert: BusinessUser,
};

export enum LeadReassignmentReason {
  EXPERT_DEACTIVATED = 'EXPERT_DEACTIVATED',
  OTHER = 'OTHER'
}

export type LeadSavedSearchContext = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
};

export type LeadSearchConnection = {
  __typename: 'LeadSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<LeadSearchEdge>,
  pageInfo: PageInfo,
  count?: Maybe<Scalars['Int']>,
};

export type LeadSearchEdge = {
  __typename: 'LeadSearchEdge',
  node: Lead,
  cursor: Scalars['String'],
};

export type LeadSearchQuery = {
  facetedSearch: Scalars['Boolean'],
  facets?: Maybe<Array<FacetSelection>>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  consumerId?: Maybe<Scalars['UserId']>,
  whitelistedFacets?: Maybe<Array<Scalars['String']>>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  keywords?: Maybe<Scalars['String']>,
};

export type LeadSnooze = {
  __typename: 'LeadSnooze',
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  messageSentAt?: Maybe<Scalars['Date']>,
  editedAt?: Maybe<Scalars['Date']>,
  cancelMessageOnConsumerReply: Scalars['Boolean'],
};

export enum LeadSortOrder {
  ACTIVITY_DATE = 'ACTIVITY_DATE',
  CREATION_DATE = 'CREATION_DATE'
}

export type LeadSupportTask = SupportTask & {
  __typename: 'LeadSupportTask',
  id: Scalars['SupportTaskId'],
  type: SupportTaskType,
  state: SupportTaskState,
  url: Scalars['String'],
  dueAt: Scalars['Date'],
  assignedTo?: Maybe<Operator>,
  assignedAt?: Maybe<Scalars['Date']>,
  completedAt?: Maybe<Scalars['Date']>,
  lead: Lead,
  reason: Scalars['String'],
};

/** ====== ListPathFlowQuestion */
export type ListPathFlowQuestion = PathFlowQuestion & {
  __typename: 'ListPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  choices: Array<ListPathFlowQuestionChoice>,
  /** If present, render an additional "other" selection. Only applicable
   * for MULTI_SELECT_LIST and SINGLE_SELECT_LIST question types
 */
  other?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  type: ListPathFlowQuestionType,
  renderStyle: ListPathFlowQuestionRenderStyle,
  /** If present and `type` supports multiple choices, the maximum amount of choices (inclusive) that's allowed */
  maxChoices?: Maybe<Scalars['Int']>,
  /** If reloading a question answered by the user, this is their previous input */
  listUserInput: SubmitListPathFlowQuestionInputTypeCopy,
};


/** ====== ListPathFlowQuestion */
export type ListPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export type ListPathFlowQuestionChoice = {
  __typename: 'ListPathFlowQuestionChoice',
  text?: Maybe<TextViewModel>,
  subText?: Maybe<TextViewModel>,
  /** Internal value to send back to the server if this item is selected */
  value: Scalars['String'],
  /** Primary image associated with the question. Typically a large image that takes the majority of the choice card, used
   * as an alternative to text/subText
 */
  primaryImage?: Maybe<ImageViewModel>,
  /** Icon/sub-image associated with the question. Typically a small image used in conjunction with text/subText */
  iconImage?: Maybe<ImageViewModel>,
};

export enum ListPathFlowQuestionRenderStyle {
  /** The default/stock rendering style that is guaranteed to fit in with the rest of the components, and will have the
   * best support in combining different options that impact rendering. Unless a path with a specific UI treatment is
   * being tested, using DEFAULT is strongly recommended.
 */
  DEFAULT = 'DEFAULT',
  /** If images should be rendered as full width (bleeds into edges of select container) */
  FULL_WIDTH_IMAGES = 'FULL_WIDTH_IMAGES',
  /** If text should be rendered as an overlay of the image in the background */
  OVERLAY_IMAGE = 'OVERLAY_IMAGE',
  /** Use a simpler radio style select that doesn't render the full cards */
  SIMPLE_RADIO = 'SIMPLE_RADIO'
}

export enum ListPathFlowQuestionType {
  SINGLE_SELECT_LIST = 'SINGLE_SELECT_LIST',
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  DROP_DOWN = 'DROP_DOWN',
  MULTI_SELECT_PILLS = 'MULTI_SELECT_PILLS'
}


export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR'
}


export type LongRangeInput = {
  from?: Maybe<Scalars['Long']>,
  to?: Maybe<Scalars['Long']>,
};

export enum LtvType {
  LEAD = 'LEAD',
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
  VIEW_CURATIONS = 'VIEW_CURATIONS'
}

export type MakeExpertCuratedItemDraftsActiveInput = {
  leadId: Scalars['LeadId'],
};

export type MakeExpertCuratedItemDraftsActivePayload = {
  __typename: 'MakeExpertCuratedItemDraftsActivePayload',
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
  addedToCart: Array<ExpertCuratedItem>,
  activated: Array<ExpertCuratedItem>,
  removed: Array<ExpertCuratedItem>,
  errors: Array<Scalars['String']>,
};

export type MarkConversationReadInput = {
  conversationId: Scalars['ConversationId'],
};

export type MarkConversationReadPayload = {
  __typename: 'MarkConversationReadPayload',
  success: Scalars['Boolean'],
};

export type MarkPaymentFailedForOrderInput = {
  orderId: Scalars['OrderId'],
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentProcessorType: PaymentProcessorType,
  /** Failure reason if any. */
  failureReason?: Maybe<Scalars['String']>,
};

export type MarkPaymentFailedForOrderPayload = {
  __typename: 'MarkPaymentFailedForOrderPayload',
  order: Order,
};

export type MarkPaymentPreApprovalFailedForOrderInput = {
  orderId: Scalars['OrderId'],
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentProcessorType: PaymentProcessorType,
  /** Failure reason if any. */
  failureReason?: Maybe<Scalars['String']>,
};

export type MarkPaymentPreApprovalFailedForOrderPayload = {
  __typename: 'MarkPaymentPreApprovalFailedForOrderPayload',
  order: Order,
};

export type MaskedUserHandle = {
  __typename: 'MaskedUserHandle',
  id: Scalars['AnyId'],
  maskedHandle: Scalars['String'],
  handleType: HandleType,
};

export type MediaFile = {
  __typename: 'MediaFile',
  id: Scalars['MediaId'],
  url: Scalars['String'],
  mimeType: Scalars['String'],
  size: Scalars['Int'],
  persisted: Scalars['Boolean'],
  originalFileName?: Maybe<Scalars['String']>,
};

export type MediaFileWithCaption = {
  __typename: 'MediaFileWithCaption',
  mediaFile: MediaFile,
  caption?: Maybe<Scalars['String']>,
};


export type MediaRenderedContent = {
  __typename: 'MediaRenderedContent',
  medias: Array<MediaFile>,
};

export type MediaWithCaptionInput = {
  mediaId: Scalars['MediaId'],
  caption?: Maybe<Scalars['String']>,
};

export type Merchant = {
  __typename: 'Merchant',
  id: Scalars['MerchantId'],
  contacts: Array<Contact>,
  name: Scalars['String'],
  address?: Maybe<PostalAddress>,
  latitude?: Maybe<Scalars['Float']>,
  longitude?: Maybe<Scalars['Float']>,
  reviewRating?: Maybe<Scalars['Int']>,
  googlePlaceId?: Maybe<Scalars['String']>,
  logo?: Maybe<MediaFile>,
  website?: Maybe<Scalars['String']>,
  adHoc: Scalars['Boolean'],
  brands: Array<Brand>,
  categories: Array<Category>,
  onboarded: Scalars['Boolean'],
  shippingAvailable?: Maybe<Scalars['Boolean']>,
  priceRating?: Maybe<Scalars['Int']>,
  responseTimeInMinutes?: Maybe<Scalars['Int']>,
  responseRate?: Maybe<Scalars['Float']>,
  offerAcceptRate?: Maybe<Scalars['Float']>,
  businessAccount?: Maybe<BusinessAccount>,
  shippingNotificationsEmail?: Maybe<Scalars['String']>,
};

export type MerchantClaimedActivity = OrderActivityDetail & {
  __typename: 'MerchantClaimedActivity',
  type: OrderActivityDetailType,
  merchant: Merchant,
  quote?: Maybe<MonetaryAmount>,
  merchantOrderId?: Maybe<Scalars['String']>,
  claimedBy: Operator,
};


export type MerchantSearchQuery = {
  keywords?: Maybe<Scalars['String']>,
  onboarded?: Maybe<Scalars['Boolean']>,
  shippingAvailable?: Maybe<Scalars['Boolean']>,
  minResponseTimeInMinutes?: Maybe<Scalars['Int']>,
  minResponseRate?: Maybe<Scalars['Float']>,
  minOfferAcceptRate?: Maybe<Scalars['Float']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  brandIds?: Maybe<Array<Scalars['BrandId']>>,
  priceRatings?: Maybe<Array<Scalars['Int']>>,
  contactTypes?: Maybe<Array<ContactType>>,
  minReviewRating?: Maybe<Scalars['Int']>,
};

export type MerchantSearchResult = {
  __typename: 'MerchantSearchResult',
  totalCount: Scalars['Long'],
  merchants: Array<Merchant>,
};

export type MerchantSuggestionResult = {
  __typename: 'MerchantSuggestionResult',
  merchants: Array<Merchant>,
};

export type MerchantUploadTaskPayload = {
  __typename: 'MerchantUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numMerchantsCreated: Scalars['Int'],
  numMerchantsUpdated: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  geocodingErrorCount: Scalars['Int'],
  numDuplicateRows: Scalars['Int'],
  googleSpreadsheetId: Scalars['String'],
};

export type MergeStandardizedSellableGroupInput = {
  mergeFrom: Scalars['StandardizedSellableGroupId'],
  mergeInto: Scalars['StandardizedSellableGroupId'],
};

export type MergeStandardizedSellableGroupPayload = {
  __typename: 'MergeStandardizedSellableGroupPayload',
  mergedGroup: StandardizedSellableGroup,
};

export type MergeTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeTypeToKeep: TriggerNodeEdgeType,
};

export type Message = {
  __typename: 'Message',
  id: Scalars['String'],
  sentAt: Scalars['Date'],
  sender: MessagingUser,
  body: MessageBody,
};

export type MessageBody = {
  __typename: 'MessageBody',
  summary: MessageSummary,
};

export enum MessageBodyType {
  TEXT = 'TEXT',
  FILE = 'FILE',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  MULTI_MEDIA = 'MULTI_MEDIA',
  OFFER = 'OFFER',
  DEAL = 'DEAL',
  VIDEO_CHAT_REQUESTED = 'VIDEO_CHAT_REQUESTED',
  VIDEO_CHAT_DECLINED = 'VIDEO_CHAT_DECLINED',
  OTHER = 'OTHER'
}

export enum MessageRichCardType {
  ONBOARDING_REQUEST_CONFIRMATION = 'ONBOARDING_REQUEST_CONFIRMATION',
  ONBOARDING_HOW_CURATED_WORKS = 'ONBOARDING_HOW_CURATED_WORKS',
  ONBOARDING_EXPERT_JOINED = 'ONBOARDING_EXPERT_JOINED',
  NEW_CUSTOM_CURATED_ORDER = 'NEW_CUSTOM_CURATED_ORDER',
  NEW_BOOKABLE_CURATED_ORDER = 'NEW_BOOKABLE_CURATED_ORDER',
  NEW_EXPERT_CURATED_ORDER_LIST = 'NEW_EXPERT_CURATED_ORDER_LIST',
  CONSUMER_INTERESTED_IN_CURATED_ORDER = 'CONSUMER_INTERESTED_IN_CURATED_ORDER',
  NEW_EXPERT_CURATED_ITEMS = 'NEW_EXPERT_CURATED_ITEMS',
  NEW_SYSTEM_CURATED_ITEMS = 'NEW_SYSTEM_CURATED_ITEMS',
  UPDATED_EXPERT_CURATED_ITEMS = 'UPDATED_EXPERT_CURATED_ITEMS',
  FEEDBACK_REQUEST_FROM_EXPERT = 'FEEDBACK_REQUEST_FROM_EXPERT',
  REFERRAL_REQUEST_FROM_EXPERT = 'REFERRAL_REQUEST_FROM_EXPERT',
  SYSTEM_CURATED_ITEM_SURVEY = 'SYSTEM_CURATED_ITEM_SURVEY',
  SIMPLE_CURATED_ORDER = 'SIMPLE_CURATED_ORDER',
  CONTACT_COLLECTION_REQUEST = 'CONTACT_COLLECTION_REQUEST'
}

export type MessageSummary = {
  __typename: 'MessageSummary',
  text?: Maybe<Scalars['String']>,
  type: MessageBodyType,
};

export enum MessageUnsubscribeTag {
  CURATION = 'CURATION',
  ONBOARDING = 'ONBOARDING',
  MESSAGE_NOTIFICATION = 'MESSAGE_NOTIFICATION',
  POST_PURCHASE = 'POST_PURCHASE',
  ABANDONED_ORDER = 'ABANDONED_ORDER',
  PATH_ONBOARDING = 'PATH_ONBOARDING',
  REFERRAL = 'REFERRAL',
  LEAD_CAMPAIGN = 'LEAD_CAMPAIGN'
}

export enum MessagingChannelType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
}

export type MessagingUser = {
  __typename: 'MessagingUser',
  id: Scalars['AnyId'],
  externalId?: Maybe<Scalars['String']>,
  displayName: Scalars['String'],
  internalMessagingUser: Scalars['Boolean'],
  avatar?: Maybe<MediaFile>,
  profile: MessagingUserProfile,
  preferredMessagingChannels: Array<MessagingChannelType>,
  notificationChannels: Array<MessagingChannelType>,
  type: MessagingUserType,
};

export type MessagingUserProfile = User | Merchant | Operator | BusinessUser | InternalMessagingUser | OnboardingSpecialistUser | SupportMessagingUser;

export enum MessagingUserType {
  USER = 'USER',
  MERCHANT = 'MERCHANT',
  BUSINESS_USER = 'BUSINESS_USER',
  OPERATOR = 'OPERATOR',
  DEAL_BOT = 'DEAL_BOT',
  ONBOARDING_SPECIALIST = 'ONBOARDING_SPECIALIST',
  SUPPORT = 'SUPPORT'
}

export type MonetaryAmount = {
  __typename: 'MonetaryAmount',
  amount: Scalars['BigDecimal'],
  currency: Scalars['CurrencyUnit'],
};


export type MonetaryAmountAmountArgs = {
  denominationType?: Maybe<MonetaryAmountDenominationType>
};

export enum MonetaryAmountDenominationType {
  /** Return amount in the default denomination (e.g.: dollars and cents, e.g.: "12.34" for $12.34 */
  DEFAULT = 'DEFAULT',
  /** Return amount in the smallest denomination for the given currency (e.g.: "1234" for $12.34) */
  SMALLEST = 'SMALLEST'
}

export type MonetaryAmountInput = {
  amount: Scalars['BigDecimal'],
  currency: Scalars['String'],
};

export type MonetaryAmountRangeInput = {
  lower?: Maybe<Scalars['BigDecimal']>,
  upper?: Maybe<Scalars['BigDecimal']>,
  currency: Scalars['CurrencyUnit'],
};

export type MonetaryAmountWithTax = {
  __typename: 'MonetaryAmountWithTax',
  /** The amount without tax */
  price: MonetaryAmount,
  /** The amount with tax added in */
  priceWithTax: MonetaryAmount,
  /** The amount of tax added */
  tax: MonetaryAmount,
  /** If tax is added (non-zero tax) */
  isTaxed: Scalars['Boolean'],
};

export type Money = {
  __typename: 'Money',
  amount: Scalars['Float'],
  currency: Scalars['String'],
};

export type MonitorVideoChatInput = {
  externalConversationId: Scalars['String'],
};

export type MonitorVideoChatPayload = {
  __typename: 'MonitorVideoChatPayload',
  token: Scalars['String'],
};

export type MultiLocaleTemplateSet = {
  __typename: 'MultiLocaleTemplateSet',
  id: Scalars['CommTemplateId'],
  title: Scalars['String'],
  active: Scalars['Boolean'],
  createdBy: User,
  updatedBy: User,
  singleLocaleSets: Array<SingleLocaleTemplateSet>,
  category?: Maybe<Category>,
  updatedAt: Scalars['Date'],
  experimentKey?: Maybe<Scalars['String']>,
  categoryType?: Maybe<CategoryType>,
  treatments?: Maybe<Array<Scalars['String']>>,
  templateType: CommTemplateType,
  tagSyntax: TemplateTagSyntax,
  emailFromAddress?: Maybe<Scalars['String']>,
  allowedEmailFromAddresses: Array<Scalars['String']>,
};

export type Mutation = {
  __typename: 'Mutation',
  addAddress: AddAddresssPayload,
  updateAddressPreferences: UpdateAddressPreferencesPayload,
  deleteAddress: DeleteAddressPayload,
  initiateAuthentication: InitiateAuthenticationPayload,
  initiateResetPassword: InitiateResetPasswordPayload,
  initiateVerifyHandle: InitiateVerifyHandlePayload,
  authenticate: AuthenticationResultPayload,
  authenticateByExternalOAuthToken: AuthenticateByExternalOAuthTokenPayload,
  logout: Scalars['Boolean'],
  createPassword: CreatePasswordPayload,
  resetPassword: ResetPasswordPayload,
  changePassword: ChangePasswordPayload,
  verifyResetPasswordChallenge: VerifyResetPasswordChallengePayload,
  verifyHandleChallenge: VerifyHandleChallengePayload,
  createCommTemplate: CreateTemplatePayload,
  updateCommTemplate: UpdateTemplatePayload,
  updateChannelTemplate: UpdateTemplatePayload,
  copyCommTemplate: CreateTemplatePayload,
  setCommTemplateActive: SetTemplateActivePayload,
  removeChannelTemplate: UpdateTemplatePayload,
  addChannelTemplate: UpdateTemplatePayload,
  sendTemplateTestMessage: SendTemplateTestMessagePayload,
  createCommTemplateType: CreateTemplateTypePayload,
  copyCommTemplateType: CopyTemplateTypePayload,
  updateCommTemplateType: UpdateTemplateTypePayload,
  createCommTemplateFragment: CreateTemplateFragmentPayload,
  updateCommTemplateFragment: UpdateTemplateFragmentPayload,
  copyCommTemplateFragment: CopyTemplateFragmentPayload,
  createDealRequest: CreateDealRequestPayload,
  createUser: CreateUserPayload,
  createOperators: CreateOperatorsPayload,
  updateOperator: UpdateOperatorPayload,
  updateUserProfile: UpdateUserProfilePayload,
  createMerchant: CreateMerchantPayload,
  createMerchants: CreateMerchantsPayload,
  updateMerchant: UpdateMerchantPayload,
  registerCustomer: RegisterCustomerPayload,
  createPendingAccessContact: CreatePendingAccessContactPayload,
  verifyPendingAccessContact: VerifyPendingAccessContactPayload,
  assumeOperatorIdentity: AssumeOperatorIdentityPayload,
  releaseOperatorIdentity: ReleaseOperatorIdentityPayload,
  assumeConsumerIdentity: AssumeConsumerIdentityPayload,
  releaseConsumerIdentity: ReleaseConsumerIdentityPayload,
  generateMyLoginToken?: Maybe<Scalars['String']>,
  updateUserSource: UpdateUserSourcePayload,
  createBusinessUser: CreateBusinessUserPayload,
  updateBusinessUser: UpdateBusinessUserPayload,
  assumeBusinessUserIdentity: AssumeBusinessUserIdentityPayload,
  releaseBusinessUserIdentity: ReleaseBusinessUserIdentityPayload,
  setAcceptingNewRequests: SetAcceptingNewRequestsPayload,
  setExpertOnCall: SetExpertOnCallPayload,
  createBusinessAccount: CreateBusinessAccountPayload,
  createBusinessUserTeam: CreateBusinessUserTeamPayload,
  devTools?: Maybe<DevToolsMutation>,
  createFirebaseToken: CreateFirebaseTokenPayload,
  registerFirebaseCloudMessagingToken: RegisterFirebaseCloudMessagingTokenPayload,
  registerWebPushSubscription: RegisterWebPushSubscriptionPayload,
  unregisterWebPushSubscription: UnregisterWebPushSubscriptionPayload,
  unregisterFirebaseCloudMessagingToken: UnregisterFirebaseCloudMessagingTokenPayload,
  updatePreferredMessagingChannels: UpdatePreferredMessagingChannelsPayload,
  setPreferredMessagingChannel: SetPreferredMessagingChannelPayload,
  updateNotificationChannels: UpdateNotificationChannelsPayload,
  joinVideoChat: JoinVideoChatPayload,
  declineVideoChat: DeclineVideoChatPayload,
  monitorVideoChat: MonitorVideoChatPayload,
  bridgePhoneCall: BridgePhoneCallPayload,
  bridgeLeadPhoneCall: BridgePhoneCallPayload,
  bridgeExpertApplicationPhoneCall: BridgePhoneCallPayload,
  markConversationRead: MarkConversationReadPayload,
  generateCollectPhoneNumberTextInPath: GenerateCollectPhoneNumberTextInPathPayload,
  addBlacklistChannelAddress: AddBlacklistChannelAddressPayload,
  upgradeGuestConversation: UpgradeGuestConversationPayload,
  createDraftGuestConversationSequence: CreateDraftGuestConversationSequencePayload,
  addGuestConversationSequenceMessage: AddGuestConversationSequenceMessagePayload,
  updateGuestConversationSequence: UpdateGuestConversationSequencePayload,
  activateGuestConversationSequence: ActivateGuestConversationSequencePayload,
  deactivateGuestConversationSequence: DeactivateGuestConversationSequencePayload,
  startGuestConversation: StartGuestConversationPayload,
  createPathFlow: CreatePathFlowPayload,
  submitPathFlowPage: SubmitPathFlowPagePayload,
  reenterPathFlowPage: ReenterPathFlowPagePayload,
  reenterPathFlowPageBySlugs: ReenterPathFlowPagePayload,
  submitListPathFlowQuestion: SubmitListPathFlowQuestionPayload,
  submitUserContactPathFlowQuestion: SubmitUserContactPathFlowQuestionPayload,
  submitNumericPathFlowQuestion: SubmitNumericPathFlowQuestionPayload,
  submitOAuthEmailPathFlowQuestion: SubmitOAuthEmailPathFlowQuestionPayload,
  submitInputTextPathFlowQuestion: SubmitInputTextPathFlowQuestionPayload,
  submitIdPathFlowQuestion: SubmitIdPathFlowQuestionPayload,
  submitDatePathFlowQuestion: SubmitDatePathFlowQuestionPayload,
  submitDateRangePathFlowQuestion: SubmitDateRangePathFlowQuestionPayload,
  placeOrderForOffer: PlaceOrderForOfferPayload,
  initiatePaypalPaymentForOffer: InitiatePaypalPaymentForOfferPayload,
  /** Order fulfillment related mutations */
  addOperatorNote: UpdateOrderPayload,
  addReturnShipmentTracking: UpdateOrderPayload,
  addShipmentTracking: UpdateOrderPayload,
  assignFulfillmentOperator: UpdateOrderPayload,
  claimOrderLineItem: ClaimOrderLineItemPayload,
  orderLineItemUnavailable: UpdateOrderPayload,
  orderLineItemReady: OrderLineItemReadyPayload,
  orderLineItemReceived: OrderLineItemReceivedPayload,
  removeShipmentTracking: UpdateOrderPayload,
  updateShippingMethod: UpdateShippingMethodPayload,
  updateOrderShippingAddress: UpdateOrderShippingAddressPayload,
  createPaymentSource: CreatePaymentSourcePayload,
  updatePaymentSource: UpdatePaymentSourcePayload,
  deletePaymentSource: DeletePaymentSourcePayload,
  payForOrder: PayForOrderPayload,
  addTipToOrder: AddTipToOrderPayload,
  removeTipFromOrder: RemoveTipFromOrderPayload,
  submitOrder: SubmitOrderPayload,
  cancelSubmittedOrder: CancelSubmittedOrderPayload,
  initiatePaypalPaymentForOrder: InitiatePaypalPaymentForOrderPayload,
  /** The Afterpay payment process starts by generating a unique order token for the Order. This is done on the backend
   * that also sets up the AfterpayPaymentProcessorAccount for the user if it
   * doesn't exist and registers the PaymentRedirectUrls
   * with Afterpay
   * On successful creation, the user is redirected to Afterpay with the orderToken
   * received in response passed as a parameter to Afterpay
   * The user goes through the loan/payment plan process on Afterpay and may be approved or declined.
   * If the user is approved, then the payment should be captured and the process is completed using the payForOrder api,
   * with the paymentProcessorPlatformSourceId set as the orderToken here.
   * If the users is declined or the process fails for any reason, then call the markPaymentDeclinedForOrder to capture
   * this state in the backend
 */
  initiateAfterpayPaymentForOrder: InitiateAfterpayPaymentForOrderPayload,
  /** The Affirm payment process starts by the frontend passing a JSON checkout object to Affirm. This is done on the
   * backend which generates the checkout JSON object from the Order and the given PaymentRedirectUrls. The JSON object is
   * passed back to frontend as a JSON string. Once the frontend calls Affirm Javascript SDK to open the modal and the user
   * gets approved, a checkout_token is received. The checkout_token is used to
   * authorize and capture the payment via payForOrder api.
   * The paymentProcessorPlatformSourceId is the checkout_token.
 */
  initiateAffirmPaymentForOrder: InitiateAffirmPaymentForOrderPayload,
  /** Some payment processors return the authorization response of a succes, approval, failure via means of redirection
   * to our website with additonal params. These processors may not support async webhook events so use this api to
   * notify the backend of any such changes.
   * This is a best effort approach as we run the risk of a user closing the browser before such a the request
   * was initiated. Fortunately, the order/payment doesn't go through.
 */
  markPaymentPreApprovalFailedForOrder: MarkPaymentPreApprovalFailedForOrderPayload,
  /** Deprecate */
  markPaymentFailedForOrder: MarkPaymentFailedForOrderPayload,
  /** For payments that go through the multiple steps with the initiatePayment APIs, its possible that the user might
   * abandon a payment flow mid way. Most of the processors will return and redirect the consumer back to our
   * site with canceled state.
   * The frontend should use this api to inform the server of this canceled state. This is necessary to put the order
   * in the correct state to allow use of other payment methods.
 */
  cancelPaymentRequestForOrder: CancelPaymentRequestForOrderPayload,
  syncOrder: SyncOrderPayload,
  addItemsToOrder: AddItemsToOrderPayload,
  removeItemsFromOrder: RemoveItemsFromOrderPayload,
  updateQuantityForOrder: UpdateQuantityForOrderPayload,
  addPromotionToOrder: AddPromotionToOrderPayload,
  dismissOrderMessages: DismissOrderMessagesPayload,
  /** Expert API to retrieve the user's cart, or create it if it doesn't exist.
   * This API should **never** be invoked when trying to fetch the current user's cart; prefer `syncOrder`.
   * This is primarily for experts to fetch a user's cart (or create if it doesn't exist). This is useful for the expert
   * to view the cart of a user, and eventually add items to the user's cart through `addExpertCuratedItemsToCart`
 */
  getOrCreateUserCartForExpert: GetOrCreateUserCartForExpertPayload,
  /** Create a new promotion in draft state. After customizing the promotion, use `activatePromotion` to shift it to
   * ACTIVE state so it's available for consumers to use.
 */
  createPromotion: CreateDraftPromotionPayload,
  /** Activate a promotion in `DRAFT` state. Note that if there is an existing active promotion with the
   * same promotion code, this API will automatically disable that promotion. Use the `activePromotionByCode` query
   * to discover existing active promotions and prompt the user if one exists before creating this one.
 */
  activatePromotion: ActivatePromotionPayload,
  /** Disable an existing promotion. Users that just added this item to their cart before disabling will still have a
   * short grace period (1 hour) to use the promotion to minimize the chance of disrupting their checkout flow.
 */
  disablePromotion: DisablePromotionPayload,
  /** Create a new promotion in `DRAFT` state which will be a copy of the promotion referenced by the input id. Some
   * state will be reset, for example, if the expiration date is in the past, it'll be removed. usageCount will be
   * reset as well.
 */
  copyPromotion: CopyPromotionPayload,
  /** Conditionally update fields of a promotion in `DRAFT` state. This includes everything except for `rules` and
   * `actions`, which are taken care of by the targeted APIs like `upsertRuleIntoPromotion`, `removeRuleFromPromotion`,
   * and `reorderRulesInPromotion`
 */
  updatePromotion: UpdatePromotionPayload,
  /** Add a rule to a promotion in `DRAFT` state, or if an existing `PromotionRuleReferenceId` is referenced, replace the
   * contents of that rule with the incoming payload.
 */
  upsertRuleIntoPromotion: UpsertRuleIntoPromotionPayload,
  /** Remove a rule from a promotion in `DRAFT` state. */
  removeRuleFromPromotion: RemoveRuleFromPromotionPayload,
  /** Re-order the rules for a promotion in `DRAFT` state. It's assumed all rule expectedReference ids in the promotion are
   * present in this list, potentially re-ordered.
 */
  reorderRulesInPromotion: ReorderRulesInPromotionPayload,
  /** Add a action to a promotion in `DRAFT` state, or if an existing `PromotionActionReferenceId` is referenced, replace
   * the contents of that action with the incoming payload.
 */
  upsertActionIntoPromotion: UpsertActionIntoPromotionPayload,
  /** Remove a action from a promotion in `DRAFT` state. */
  removeActionFromPromotion: RemoveActionFromPromotionPayload,
  /** Re-order the actions for a promotion in `DRAFT` state. It's assumed all action expectedReference ids in the promotion are
   * present in this list, potentially re-ordered.
 */
  reorderActionsInPromotion: ReorderActionsInPromotionPayload,
  /** The ACH/wire transfer payment process starts by assigning a unique bank account for the user. This bank account
   * is reused across multiple orders. This is done on the backend by calling Stripe API to create the ACH credit transfer
   * payment source. This source is associated with the StripeAccount for that user.
 */
  initiateWireTransferPaymentForOrder: InitiateWireTransferPaymentForOrderPayload,
  updateOrderState: UpdateOrderStatePayload,
  updateOrderExpertContributions: UpdateOrderExpertContributionsPayload,
  /** puts an order line item in CUSTOMIZING state, an intermediate state between CLAIMED and PENDING_SHIPPING where the
   * merchant does checks/customizations to get the item ready for shipping
 */
  updateOrderLineItemStateToCustomizing: ItemCustomizingPayload,
  /** indicates problems with the item during CUSTOMIZING state, will put the item back into CLAIMED state */
  markCustomizationIssuesForOrderLineItem: ItemHasCustomizationIssuesPayload,
  /** unclaim an order line item and puts it back into PAID state */
  unclaimOrderLineItem: UpdateOrderPayload,
  createTag: CreateTagPayload,
  removeTag: RemoveTagPayload,
  uploadMerchants: UploadMerchantsPayload,
  uploadSellables: UploadSellablesPayload,
  uploadSellablePrice: UploadSellablePricePayload,
  uploadFeaturedSellableContent: UploadFeaturedSellableContentPayload,
  uploadBrands: UploadBrandsPayload,
  uploadSellableUpdates: UploadSellableUpdatesPayload,
  uploadSellableDeactivations: UploadSellableDeactivationsPayload,
  uploadSellableInventory: UploadSellableInventoryPayload,
  createMerchantOffer: CreateOfferPayload,
  createFreeFormOffer: CreateOfferPayload,
  createOfferFromSellable: CreateOfferPayload,
  createOfferForSelfCheckout: CreateOfferPayload,
  totalCostForOffer: TotalCostForOfferPayload,
  createOrderFromOffer: CreateOrderFromOfferPayload,
  addOfferToCart: AddOfferToCartPayload,
  uploadMedia: UploadMediaPayload,
  createMedia: CreateMediaPayload,
  persistMedia: PersistMediaPayload,
  createDraftExpertProfile: CreateExpertProfilePayload,
  submitExpertProfile: UpdateExpertProfilePayload,
  approveExpertProfile: UpdateExpertProfilePayload,
  requestChangesOnExpertProfile: UpdateExpertProfilePayload,
  updateExpertProfile: UpdateExpertProfilePayload,
  startExpertRating: StartExpertRatingPayload,
  startExpertRatingPath: StartExpertRatingPayload,
  updateConsumerExpertReview: UpdateConsumerExpertReviewPayload,
  deleteConsumerExpertReview: Scalars['Boolean'],
  addExpertProfileHighlight: UpdateExpertProfilePayload,
  removeExpertProfileHighlight: UpdateExpertProfilePayload,
  createBlankExpertApplication: CreateBlankExpertApplicationPayload,
  approveExpertApplication: ApproveExpertApplicationPayload,
  rejectExpertApplication: RejectExpertApplicationPayload,
  setExpertApplicationArchived: UpdateExpertApplicationPayload,
  setExpertApplicationSnooze: UpdateExpertApplicationPayload,
  cancelExpertApplicationSnooze: UpdateExpertApplicationPayload,
  requestConsumerReviewByExpert: RequestConsumerExpertReviewPayload,
  requestReferralByExpert: RequestReferralByExpertPayload,
  sendExpertReferral: SendExpertReferralPayload,
  createExpertFromApplication: CreateExpertFromApplicationPayload,
  addExpertApplicationReview: AddExpertApplicationReviewPayload,
  updateExpertApplicationTaskStatus: UpdateExpertApplicationTaskStatusPayload,
  setExpertApplicationTaskCompleted: SetExpertApplicationTaskCompletedPayload,
  rerunExpertApplicationTask: RerunExpertApplicationTaskPayload,
  startExpertApplicationConversation: ExpertApplication,
  addExpertApplicationNote: UpdateExpertApplicationPayload,
  saveSavedSellable: SaveSavedSellablePayload,
  unsaveSavedSellable: UnsaveSavedSellablePayload,
  createSellable: CreateSellablePayload,
  updateSellable: UpdateSellablePayload,
  deactivateSellable: DeactivateSellablePayload,
  createSellableTerms: CreateSellableTermsPayload,
  requestSellable: RequestSellablePayload,
  deactivateSellablePriceSource: DeactivateSellablePriceSourcePayload,
  saveConsumerSellableReaction: SaveConsumerSellableReactionPayload,
  createSellableResearchLink: CreateSellableResearchLinkPayload,
  deleteSellableResearchLink: DeleteSellableResearchLinkPayload,
  startExpertConsumerConversation: StartExpertConsumerConversationPayload,
  setLeadSnooze: UpdateLeadPayload,
  cancelLeadSnooze: UpdateLeadPayload,
  setLeadStar: UpdateLeadPayload,
  setLeadArchived: UpdateLeadPayload,
  setLeadDoNotCall: UpdateLeadPayload,
  dismissLeadSuggestedAction: UpdateLeadPayload,
  delegateLead: UpdateLeadPayload,
  reassignLead: UpdateLeadPayload,
  setConsumerInitialLeadAction: SetConsumerInitialLeadActionPayload,
  createQuickReplyWithLead: CreateQuickReplyPayload,
  createQuickReplyWithoutLead: CreateQuickReplyPayload,
  createQuickReply: CreateQuickReplyPayload,
  updateQuickReply: UpdateQuickReplyPayload,
  deleteQuickReply: Scalars['Boolean'],
  createLeadNote: CreateLeadNotePayload,
  updateLeadNote: UpdateLeadNotePayload,
  deleteLeadNote: Scalars['Boolean'],
  addUserInfoForLead: AddUserInfoForLeadPayload,
  acceptLeadEscalation: AcceptEscalationResult,
  startLeadEscalation: StartLeadEscalationPayload,
  reportPredictedLifeTimeValueToPlatform: ReportPredictedLifeTimeValuePayload,
  createLeadCampaign: CreateLeadCampaignPayload,
  copyLeadCampaign: CreateLeadCampaignPayload,
  updateLeadCampaign: UpdateLeadCampaignPayload,
  deactivateLeadCampaign: UpdateLeadCampaignPayload,
  activateLeadCampaign: UpdateLeadCampaignPayload,
  createLeadCampaignTrigger: UpdateLeadCampaignPayload,
  createReport: UpdateReportPayload,
  updateReport: UpdateReportPayload,
  addReportSchedule: UpdateReportPayload,
  removeReportSchedule: UpdateReportPayload,
  /** Add expert curated itemt to cart.
   * This is intended to be invoked by consumers to add the expert curated item to cart. Note that this special mutation
   * is required since it'll allow the consumer to add items with price overrides, where the consumer typically can't
   * add items to cart and override the price themselves.
 */
  addExpertCuratedItemToCart: AddExpertCuratedItemToCartPayload,
  /** Create new expert curated item in draft state. `makeExpertCuratedItemDraftsActive` must be used to convert to
   * activate/submit the drafts into an active state.
 */
  createExpertCuratedItem: CreateExpertCuratedItemPayload,
  /** This is intended to allow bulk duplicating data from existing ExpertCuratedItem's as new ExpertCuratedItem's
   * recommended to a new lead based on recommendations of similar ExpertCuratedItem's
 */
  copyFromExpertCuratedItems: CopyFromExpertCuratedItemsPayload,
  /** Update an existing expert curated item */
  updateExpertCuratedItem: UpdateExpertCuratedItemPayload,
  /** Remove an existing expert curated item */
  removeExpertCuratedItem: RemoveExpertCuratedItemPayload,
  /** Make all drafts associated with the lead active, and invoke relevant actions */
  makeExpertCuratedItemDraftsActive: MakeExpertCuratedItemDraftsActivePayload,
  /** Expert API to create a curated recommended order in draft mode that's backed by an actual `Order`. This expert
   * initializes it self from the provided sellable, copying over variations and prices, and starts off in a draft
   * mode where further alterations can be made. (see mutations like `updateExpertCuratedOrderVariationOptions`).
   * This is typically used for recommending services, as they typically involve more than one sellable
 */
  createExpertCuratedOrder: CreateExpertCuratedOrderPayload,
  /** Expert API to change the availability or price of the variations. Note that additional variations that don't
   * exist on the sellable cannot be added!
 */
  updateExpertCuratedOrderVariationOptions: UpdateExpertCuratedOrderVariationOptionsPayload,
  /** Expert API to insert or update an add-on item */
  upsertItemsInExpertCuratedOrder: UpsertItemsInExpertCuratedOrderPayload,
  /** Expert API to remove an add-on item */
  removeItemsFromExpertCuratedOrder: RemoveItemsFromExpertCuratedOrderPayload,
  /** Expert API to make a created expert curated order a bookable one. It will bringing it out of draft mode into ACTIVE state.
   * It requires the curated order to be not in the preview mode and verifies that
   * all required fields like date are all specified
   * once a curated order is active, the terms, variations, or items can't be modified by the expert. It can only be
   * closed, different options can be selected between by the consumer, or a replacement curated order can be made via
   * `findOrCreateReplacementExpertCuratedOrder`. By activating an order, a rich card will be sent to the client as well.
 */
  activateExpertCuratedOrderAsBookable: ActivateExpertCuratedOrderAsBookablePayload,
  /** Expert API to send a notification to the customer about a particular curated order */
  notifyCustomerExpertCuratedOrder: NotifyCustomerExpertCuratedOrderPayload,
  /** Consumer API to send a notification to the expert that they're interested in a curated order */
  customerRequestExpertCuratedOrder: CustomerRequestExpertCuratedOrderPayload,
  /** Close out the expert curated order, effectively expiring it making it unpurchase-able by the user */
  closeExpertCuratedOrder: CloseExpertCuratedOrderPayload,
  /** Expert API to update terms (service start date, etc) */
  updateExpertCuratedOrderTerms: UpdateExpertCuratedOrderTermsPayload,
  /** Consumer API to toggle between available variations. Only applicable if the expert curated order is active,
   * and the order hasn't been purchased yet.
 */
  selectExpertCuratedOrderVariationOption: SelectExpertCuratedOrderVariationOptionPayload,
  /** Consumer API to disable (remove) optional add-ons they're not interested in. Only applicable if the expert curated
   * order is active, and the order hasn't been purchased yet.
 */
  selectExpertCuratedOrderItems: SelectExpertCuratedOrderItemsPayload,
  /** Expert API to override the service location that was originally derived from the sellable service merchant's address.
   * This new address will be used across the board for this expert curated order; displaying to the consumer, computing
   * tax, etc.
 */
  updateServiceLocationExpertCuratedOrder: UpdateServiceLocationExpertCuratedOrderPayload,
  /** Expert API to activate all pending draft curated orders associated with a lead. This is similar to
   * `activateExpertCuratedOrder`, except that this activates multiple curated orders, resulting an a activation list
   * object summarizing the result (the curated orders that were activated, closed, etc). This also sends a custom
   * rich card to the client displaying the activation list (summary of all the curated orders).
 */
  activateExpertCuratedOrdersForLead: ActivateExpertCuratedOrdersForLeadPayload,
  /** Accept ExpertCuratedOrderId, setup superseded chain and make as draft.
   * Activation of this will disable previous supersededId
 */
  findOrCreateReplacementExpertCuratedOrder: FindOrCreateReplacementExpertCuratedOrderPayload,
  /** Expert API to copy `items` from one curated order to another; convienence API to quickly copy addons. */
  copyItemsFromExpertCuratedOrder: CopyItemsFromExpertCuratedOrderPayload,
  /** Expert API to set the contentful itinerary to show on the expert curated orders list page for the lead */
  upsertExpertCuratedLeadItinerary: UpsertExpertCuratedLeadItineraryPayload,
  /** Expert API to delete the contentful itinerary to show on the expert curated orders list page for the lead */
  deleteExpertCuratedLeadItinerary: DeleteExpertCuratedLeadItineraryPayload,
  createSavedExpertCuratedItems: CreateSavedExpertCuratedItemsPayload,
  updateSavedExpertCuratedItems: UpdateSavedExpertCuratedItemsPayload,
  deleteSavedExpertCuratedItems: DeleteSavedExpertCuratedItemsPayload,
  createExpertConsultationFeeOrder: CreateExpertConsultationFeeOrderPayload,
  /** Only allowed to create RecommndedListDefinition of RecommendedListType.CUSTOM. */
  createRecommendedListDefinition: CreateRecommendedListDefinitionPayload,
  /** Update Mutation supports partial updates, most of the fields in the UpdateRecommendedListDefinitionInput are optional
   * and if they input is missing those field values it will retain the corresponding old values.
   * System default recommendedListDefinition don't allow updating their type, query facets and sorting.
 */
  updateRecommendedListDefinition: UpdateRecommendedListDefinitionPayload,
  deleteRecommendedListDefinition: DeleteRecommendedListDefinitionIdPayload,
  createTrigger: CreateTriggerPayload,
  updateTrigger: UpdateTriggerPayload,
  createTriggerNode: UpdateTriggerPayload,
  removeTriggerNode: UpdateTriggerPayload,
  updateTriggerFilter: UpdateTriggerPayload,
  updateTriggerDelay: UpdateTriggerPayload,
  updateTriggerAction: UpdateTriggerPayload,
  updateTriggerBranch: UpdateTriggerPayload,
  swapTriggerBranchEdges: UpdateTriggerPayload,
  updateTriggerWait: UpdateTriggerPayload,
  swapTriggerWaitEdges: UpdateTriggerPayload,
  splitTriggerWaitEdges: UpdateTriggerPayload,
  mergeTriggerWaitEdges: UpdateTriggerPayload,
  updateTriggerEdge: UpdateTriggerPayload,
  removeTriggerEdge: UpdateTriggerPayload,
  publishTrigger: PublishTriggerPayload,
  deactivateTrigger: DeactivateTriggerPayload,
  copyTrigger: CopyTriggerPayload,
  importEntities: ImportEntitiesPayload,
  testTriggerExecution: TestTriggerExecutionPayload,
  shortenUrl?: Maybe<ShortenUrlPayload>,
  createAdhocSellableFromEBayItem: CreateAdhocSellableFromEBayItemPayload,
  identifyEBayItemAsSellable: IdentifyEBayItemAsSellablePayload,
  updateConfig: UpdateConfigPayload,
  resetConfig: ResetConfigPayload,
  syncExternalAdCampaigns: SyncExternalAdCampaignsPayload,
  updateExternalAdCampaign: UpdateExternalAdCampaignPayload,
  updateExternalAdGroup: UpdateExternalAdGroupPayload,
  applyExternalAdBudget: ApplyExternalAdBudgetPayload,
  startSystemCuratedItemSurvey: StartSystemCuratedItemSurveyPayload,
  terminateSystemCuratedItemSurvey: TerminateSystemCuratedItemSurveyPayload,
  createFlightPlan: CreateFlightPlanPayload,
  activateFlightPlan: ActivateFlightPlanPayload,
  copyFlightPlanAsDraft: CopyFlightPlanAsDraftPayload,
  upsertLegsIntoFlightPlan: UpsertLegsIntoFlightPlanPayload,
  removeLegsFromFlightPlan: RemoveLegsFromFlightPlanPayload,
  assignSupportTask: AssignSupportTaskPayload,
  completeSupportTaskNoActionNeeded: CompleteSupportTaskNoActionNeededPayload,
  completeSupportTaskSnooze: CompleteSupportTaskSnoozePayload,
  completeLeadSupportTaskAssignLeadActions: CompleteLeadSupportTaskAssignLeadActionsPayload,
  completeLeadSupportTaskDelegateLead: CompleteLeadSupportTaskDelegateLeadPayload,
  completeLeadSupportTaskReassignLead: CompleteLeadSupportTaskReassignLeadPayload,
  completeLeadSupportTaskEscalateToTeamForDelegation: CompleteLeadSupportTaskEscalateToTeamForDelegationPayload,
  completeLeadSupportTaskEscalateForReassignment: CompleteLeadSupportTaskEscalateForReassignmentPayload,
  completeLeadSupportTaskRequestOrderSupport: CompleteLeadSupportTaskRequestOrderSupportPayload,
  createOrderEscalation: CreateOrderEscalationsPayload,
  assignOrderEscalation: UpdateOrderEscalationPayload,
  startOrderEscalation: UpdateOrderEscalationPayload,
  completeOrderEscalation: UpdateOrderEscalationPayload,
  addEscalationNote: UpdateOrderEscalationPayload,
  setEscalationPriority: UpdateOrderEscalationPayload,
  startSupportConversation: UpdateSupportConversationPayload,
  updateSellableInventoryItem: SellableInventoryItemUpdatePayload,
  createPayStructure: CreatePayStructurePayload,
  createPayStructureRevision: UpdatePayStructureRevisionPayload,
  updatePayStructureRevision: UpdatePayStructureRevisionPayload,
  activatePayStructureRevision: UpdatePayStructureRevisionPayload,
  approvePayout: UpdatePayoutPayload,
  bulkApprovePayouts: BulkUpdatePayoutPayload,
  resendPayout: UpdatePayoutPayload,
  recomputePayout: UpdatePayoutPayload,
  addManualAdjustmentPayLineItem: UpdatePayoutPayload,
  createRawSellableSource: CreateRawSellableSourcePayload,
  updateRawSellableSource: UpdateRawSellableSourcePayload,
  createRawSellableStandardizationRule: CreateRawSellableStandardizationRulePayload,
  updateRawSellableStandardizationRule: UpdateRawSellableStandardizationRulePayload,
  mergeStandardizedSellableGroup: MergeStandardizedSellableGroupPayload,
  startStandardizedSellableGroupIngestion: StartStandardizedSellableGroupIngestionPayload,
  startRawSellableSourceIngestion: StartRawSellableSourceIngestionPayload,
  createSchedulingType: CreateSchedulingTypePayload,
  createSchedulingDemandForecast: CreateSchedulingDemandForecastPayload,
  updateSchedulingDemandForecast: UpdateSchedulingDemandForecastPayload,
  removeSchedulingDemandForecast: RemoveSchedulingDemandForecastPayload,
  createSchedulingUserAvailability: CreateSchedulingUserAvailabilityPayload,
  removeSchedulingUserAvailability: RemoveSchedulingUserAvailabilityPayload,
  acceptShift: AcceptShiftPayload,
  declineShift: DeclineShiftPayload,
  createShift: CreateShiftPayload,
};


export type MutationAddAddressArgs = {
  input: AddAddressInput
};


export type MutationUpdateAddressPreferencesArgs = {
  input: UpdateAddressPreferencesInput
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput
};


export type MutationInitiateAuthenticationArgs = {
  input: InitiateAuthenticationInput
};


export type MutationInitiateResetPasswordArgs = {
  input: InitiateResetPasswordInput
};


export type MutationInitiateVerifyHandleArgs = {
  input: InitiateVerifyHandleInput
};


export type MutationAuthenticateArgs = {
  input: AuthenticationInput
};


export type MutationAuthenticateByExternalOAuthTokenArgs = {
  input: AuthenticateByExternalOAuthTokenInput
};


export type MutationCreatePasswordArgs = {
  input: CreatePasswordInput
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput
};


export type MutationVerifyResetPasswordChallengeArgs = {
  input: VerifyResetPasswordChallengeInput
};


export type MutationVerifyHandleChallengeArgs = {
  input: VerifyHandleChallengeInput
};


export type MutationCreateCommTemplateArgs = {
  input: CreateTemplateInput
};


export type MutationUpdateCommTemplateArgs = {
  input: UpdateTemplateInput
};


export type MutationUpdateChannelTemplateArgs = {
  input: UpdateChannelTemplateInput
};


export type MutationCopyCommTemplateArgs = {
  input: CopyTemplateInput
};


export type MutationSetCommTemplateActiveArgs = {
  input: SetTemplateActiveInput
};


export type MutationRemoveChannelTemplateArgs = {
  input: RemoveChannelTemplateInput
};


export type MutationAddChannelTemplateArgs = {
  input: AddChannelTemplateInput
};


export type MutationSendTemplateTestMessageArgs = {
  input: SendTemplateTestMessageInput
};


export type MutationCreateCommTemplateTypeArgs = {
  input: CreateTemplateTypeInput
};


export type MutationCopyCommTemplateTypeArgs = {
  input: CopyTemplateTypeInput
};


export type MutationUpdateCommTemplateTypeArgs = {
  input: UpdateTemplateTypeInput
};


export type MutationCreateCommTemplateFragmentArgs = {
  input: CreateTemplateFragmentInput
};


export type MutationUpdateCommTemplateFragmentArgs = {
  input: UpdateTemplateFragmentInput
};


export type MutationCopyCommTemplateFragmentArgs = {
  input: CopyTemplateFragmentInput
};


export type MutationCreateDealRequestArgs = {
  input: CreateDealRequestInput
};


export type MutationCreateUserArgs = {
  input: CreateUserInput
};


export type MutationCreateOperatorsArgs = {
  input: CreateOperatorsInput
};


export type MutationUpdateOperatorArgs = {
  input: UpdateOperatorInput
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput
};


export type MutationCreateMerchantArgs = {
  input: CreateMerchantInput
};


export type MutationCreateMerchantsArgs = {
  input: Array<CreateMerchantInput>
};


export type MutationUpdateMerchantArgs = {
  input: UpdateMerchantInput
};


export type MutationRegisterCustomerArgs = {
  input: RegisterCustomerInput
};


export type MutationCreatePendingAccessContactArgs = {
  input: CreatePendingAccessContactInput
};


export type MutationVerifyPendingAccessContactArgs = {
  input: VerifyPendingAccessContactInput
};


export type MutationAssumeOperatorIdentityArgs = {
  input: AssumeOperatorIdentityInput
};


export type MutationAssumeConsumerIdentityArgs = {
  input: AssumeConsumerIdentityInput
};


export type MutationUpdateUserSourceArgs = {
  input: UpdateUserSourceInput
};


export type MutationCreateBusinessUserArgs = {
  input: CreateBusinessUserInput
};


export type MutationUpdateBusinessUserArgs = {
  input: UpdateBusinessUserInput
};


export type MutationAssumeBusinessUserIdentityArgs = {
  input: AssumeBusinessUserIdentityInput
};


export type MutationSetAcceptingNewRequestsArgs = {
  input?: Maybe<SetAcceptingNewRequestsInput>
};


export type MutationSetExpertOnCallArgs = {
  input: SetExpertOnCallInput
};


export type MutationCreateBusinessAccountArgs = {
  input: CreateBusinessAccountInput
};


export type MutationCreateBusinessUserTeamArgs = {
  input: CreateBusinessUserTeamInput
};


export type MutationCreateFirebaseTokenArgs = {
  input: CreateFirebaseTokenInput
};


export type MutationRegisterFirebaseCloudMessagingTokenArgs = {
  input: RegisterFirebaseCloudMessagingTokenInput
};


export type MutationRegisterWebPushSubscriptionArgs = {
  input: RegisterWebPushSubscriptionInput
};


export type MutationUnregisterWebPushSubscriptionArgs = {
  input: UnregisterWebPushSubscriptionInput
};


export type MutationUnregisterFirebaseCloudMessagingTokenArgs = {
  input: UnregisterFirebaseCloudMessagingTokenInput
};


export type MutationUpdatePreferredMessagingChannelsArgs = {
  input: UpdatePreferredMessagingChannelsInput
};


export type MutationSetPreferredMessagingChannelArgs = {
  input: SetPreferredMessagingChannelInput
};


export type MutationUpdateNotificationChannelsArgs = {
  input: UpdateNotificationChannelsInput
};


export type MutationJoinVideoChatArgs = {
  input: JoinVideoChatInput
};


export type MutationDeclineVideoChatArgs = {
  input: DeclineVideoChatInput
};


export type MutationMonitorVideoChatArgs = {
  input: MonitorVideoChatInput
};


export type MutationBridgePhoneCallArgs = {
  input: BridgePhoneCallInput
};


export type MutationBridgeLeadPhoneCallArgs = {
  input: BridgeLeadPhoneCallInput
};


export type MutationBridgeExpertApplicationPhoneCallArgs = {
  input: BridgeExpertApplicantPhoneCallInput
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput
};


export type MutationGenerateCollectPhoneNumberTextInPathArgs = {
  input: GenerateCollectPhoneNumberTextInPathInput
};


export type MutationAddBlacklistChannelAddressArgs = {
  input: AddBlacklistChannelAddressInput
};


export type MutationUpgradeGuestConversationArgs = {
  input: UpgradeGuestConversationInput
};


export type MutationCreateDraftGuestConversationSequenceArgs = {
  input: CreateDraftGuestConversationSequenceInput
};


export type MutationAddGuestConversationSequenceMessageArgs = {
  input: AddGuestConversationSequenceMessageInput
};


export type MutationUpdateGuestConversationSequenceArgs = {
  input: UpdateGuestConversationSequenceInput
};


export type MutationActivateGuestConversationSequenceArgs = {
  input: ActivateGuestConversationSequenceInput
};


export type MutationDeactivateGuestConversationSequenceArgs = {
  input: DeactivateGuestConversationSequenceInput
};


export type MutationStartGuestConversationArgs = {
  input: StartGuestConversationInput
};


export type MutationCreatePathFlowArgs = {
  input: CreatePathFlowInput
};


export type MutationSubmitPathFlowPageArgs = {
  input: SubmitPathFlowPageInput
};


export type MutationReenterPathFlowPageArgs = {
  input: ReenterPathFlowPageInput
};


export type MutationReenterPathFlowPageBySlugsArgs = {
  input: ReenterPathFlowPageBySlugsInput
};


export type MutationSubmitListPathFlowQuestionArgs = {
  input: SubmitListPathFlowQuestionInput
};


export type MutationSubmitUserContactPathFlowQuestionArgs = {
  input: SubmitUserContactPathFlowQuestionInput
};


export type MutationSubmitNumericPathFlowQuestionArgs = {
  input: SubmitNumericPathFlowQuestionInput
};


export type MutationSubmitOAuthEmailPathFlowQuestionArgs = {
  input: SubmitOAuthEmailPathFlowQuestionInput
};


export type MutationSubmitInputTextPathFlowQuestionArgs = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type MutationSubmitIdPathFlowQuestionArgs = {
  input: SubmitIdPathFlowQuestionInput
};


export type MutationSubmitDatePathFlowQuestionArgs = {
  input: SubmitDatePathFlowQuestionInput
};


export type MutationSubmitDateRangePathFlowQuestionArgs = {
  input: SubmitDateRangePathFlowQuestionInput
};


export type MutationPlaceOrderForOfferArgs = {
  input: PlaceOrderForOfferInput
};


export type MutationInitiatePaypalPaymentForOfferArgs = {
  input: InitiatePaypalPaymentForOfferInput
};


export type MutationAddOperatorNoteArgs = {
  input: AddOperatorNoteInput
};


export type MutationAddReturnShipmentTrackingArgs = {
  input: ShipmentTrackingInput
};


export type MutationAddShipmentTrackingArgs = {
  input: ShipmentTrackingInput
};


export type MutationAssignFulfillmentOperatorArgs = {
  input: AssignFulfillmentOperatorInput
};


export type MutationClaimOrderLineItemArgs = {
  input: ClaimOrderLineItemInput
};


export type MutationOrderLineItemUnavailableArgs = {
  input: OrderLineItemUnavailableInput
};


export type MutationOrderLineItemReadyArgs = {
  input: OrderLineItemReadyInput
};


export type MutationOrderLineItemReceivedArgs = {
  input: OrderLineItemReceivedInput
};


export type MutationRemoveShipmentTrackingArgs = {
  input: RemoveShipmentTrackingInput
};


export type MutationUpdateShippingMethodArgs = {
  input: UpdateShippingMethodInput
};


export type MutationUpdateOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput
};


export type MutationCreatePaymentSourceArgs = {
  input: CreatePaymentSourceInput
};


export type MutationUpdatePaymentSourceArgs = {
  input: UpdatePaymentSourceInput
};


export type MutationDeletePaymentSourceArgs = {
  id: Scalars['PaymentSourceId']
};


export type MutationPayForOrderArgs = {
  input: PayForOrderInput
};


export type MutationAddTipToOrderArgs = {
  input: AddTipToOrderInput
};


export type MutationRemoveTipFromOrderArgs = {
  input: RemoveTipFromOrderInput
};


export type MutationSubmitOrderArgs = {
  input: SubmitOrderInput
};


export type MutationCancelSubmittedOrderArgs = {
  input: CancelSubmittedOrderInput
};


export type MutationInitiatePaypalPaymentForOrderArgs = {
  input: InitiatePaypalPaymentForOrderInput
};


export type MutationInitiateAfterpayPaymentForOrderArgs = {
  input: InitiateAfterpayPaymentForOrderInput
};


export type MutationInitiateAffirmPaymentForOrderArgs = {
  input: InitiateAffirmPaymentForOrderInput
};


export type MutationMarkPaymentPreApprovalFailedForOrderArgs = {
  input: MarkPaymentPreApprovalFailedForOrderInput
};


export type MutationMarkPaymentFailedForOrderArgs = {
  input: MarkPaymentFailedForOrderInput
};


export type MutationCancelPaymentRequestForOrderArgs = {
  input: CancelPaymentRequestForOrderInput
};


export type MutationSyncOrderArgs = {
  input: SyncOrderInput
};


export type MutationAddItemsToOrderArgs = {
  input: AddItemsToOrderInput
};


export type MutationRemoveItemsFromOrderArgs = {
  input: RemoveItemsFromOrderInput
};


export type MutationUpdateQuantityForOrderArgs = {
  input: UpdateQuantityForOrderInput
};


export type MutationAddPromotionToOrderArgs = {
  input?: Maybe<AddPromotionToOrderInput>
};


export type MutationDismissOrderMessagesArgs = {
  input: DismissOrderMessagesInput
};


export type MutationGetOrCreateUserCartForExpertArgs = {
  input: GetOrCreateUserCartForExpertInput
};


export type MutationCreatePromotionArgs = {
  input: CreateDraftPromotionInput
};


export type MutationActivatePromotionArgs = {
  input?: Maybe<ActivatePromotionInput>
};


export type MutationDisablePromotionArgs = {
  input: DisablePromotionInput
};


export type MutationCopyPromotionArgs = {
  input: CopyPromotionInput
};


export type MutationUpdatePromotionArgs = {
  input: UpdatePromotionInput
};


export type MutationUpsertRuleIntoPromotionArgs = {
  input: UpsertRuleIntoPromotionInput
};


export type MutationRemoveRuleFromPromotionArgs = {
  input: RemoveRuleFromPromotionInput
};


export type MutationReorderRulesInPromotionArgs = {
  input: ReorderRulesInPromotionInput
};


export type MutationUpsertActionIntoPromotionArgs = {
  input: UpsertActionIntoPromotionInput
};


export type MutationRemoveActionFromPromotionArgs = {
  input: RemoveActionFromPromotionInput
};


export type MutationReorderActionsInPromotionArgs = {
  input: ReorderActionsInPromotionInput
};


export type MutationInitiateWireTransferPaymentForOrderArgs = {
  input: InitiateWireTransferPaymentForOrderInput
};


export type MutationUpdateOrderStateArgs = {
  input: UpdateOrderStateInput
};


export type MutationUpdateOrderExpertContributionsArgs = {
  input: UpdateOrderExpertContributionsInput
};


export type MutationUpdateOrderLineItemStateToCustomizingArgs = {
  input: ItemCustomizingInput
};


export type MutationMarkCustomizationIssuesForOrderLineItemArgs = {
  input: ItemHasCustomizationIssuesInput
};


export type MutationUnclaimOrderLineItemArgs = {
  input: OrderLineItemUnclaimInput
};


export type MutationCreateTagArgs = {
  input: CreateTagInput
};


export type MutationRemoveTagArgs = {
  input: RemoveTagInput
};


export type MutationUploadMerchantsArgs = {
  input: UploadMerchantsInput
};


export type MutationUploadSellablesArgs = {
  input: UploadSellablesInput
};


export type MutationUploadSellablePriceArgs = {
  input: UploadSellablePriceInput
};


export type MutationUploadFeaturedSellableContentArgs = {
  input: UploadFeaturedSellableContentInput
};


export type MutationUploadBrandsArgs = {
  input: UploadBrandsInput
};


export type MutationUploadSellableUpdatesArgs = {
  input: UploadSellableUpdatesInput
};


export type MutationUploadSellableDeactivationsArgs = {
  input: UploadSellableDeactivationsInput
};


export type MutationUploadSellableInventoryArgs = {
  input: UploadSellableInventoryInput
};


export type MutationCreateMerchantOfferArgs = {
  input: CreateOfferInput
};


export type MutationCreateFreeFormOfferArgs = {
  input: CreateOfferInput
};


export type MutationCreateOfferFromSellableArgs = {
  input: CreateOfferFromSellableInput
};


export type MutationCreateOfferForSelfCheckoutArgs = {
  input: CreateOfferForSelfCheckoutInput
};


export type MutationTotalCostForOfferArgs = {
  input: TotalCostForOfferInput
};


export type MutationCreateOrderFromOfferArgs = {
  input: CreateOrderFromOfferInput
};


export type MutationAddOfferToCartArgs = {
  input: AddOfferToCartInput
};


export type MutationUploadMediaArgs = {
  input: UploadMediaInput
};


export type MutationCreateMediaArgs = {
  input: CreateMediaInput
};


export type MutationPersistMediaArgs = {
  input: PersistMediaInput
};


export type MutationCreateDraftExpertProfileArgs = {
  input: CreateDraftExpertProfileInput
};


export type MutationSubmitExpertProfileArgs = {
  id: Scalars['ExpertProfileId']
};


export type MutationApproveExpertProfileArgs = {
  id: Scalars['ExpertProfileId']
};


export type MutationRequestChangesOnExpertProfileArgs = {
  input: ExpertProfileRequestChangesInput
};


export type MutationUpdateExpertProfileArgs = {
  input: UpdateExpertProfileInput
};


export type MutationStartExpertRatingArgs = {
  expertId: Scalars['BusinessUserId']
};


export type MutationStartExpertRatingPathArgs = {
  input: StartExpertRatingInput
};


export type MutationUpdateConsumerExpertReviewArgs = {
  input: UpdateConsumerExpertReviewInput
};


export type MutationDeleteConsumerExpertReviewArgs = {
  id: Scalars['ConsumerExpertReviewId']
};


export type MutationAddExpertProfileHighlightArgs = {
  input: AddProfileHighlightInput
};


export type MutationRemoveExpertProfileHighlightArgs = {
  input: RemoveProfileHighlightInput
};


export type MutationCreateBlankExpertApplicationArgs = {
  input: CreateBlankExpertApplicationInput
};


export type MutationApproveExpertApplicationArgs = {
  input: ApproveExpertApplicationInput
};


export type MutationRejectExpertApplicationArgs = {
  input: RejectExpertApplicationInput
};


export type MutationSetExpertApplicationArchivedArgs = {
  input: SetExpertApplicationArchivedInput
};


export type MutationSetExpertApplicationSnoozeArgs = {
  input: SetExpertApplicationSnoozeInput
};


export type MutationCancelExpertApplicationSnoozeArgs = {
  input: CancelExpertApplicationSnoozeInput
};


export type MutationRequestConsumerReviewByExpertArgs = {
  input: RequestConsumerExpertReviewInput
};


export type MutationRequestReferralByExpertArgs = {
  input: RequestReferralByExpertInput
};


export type MutationSendExpertReferralArgs = {
  input: SendExpertReferralInput
};


export type MutationCreateExpertFromApplicationArgs = {
  input: CreateExpertFromApplicationInput
};


export type MutationAddExpertApplicationReviewArgs = {
  input: AddExpertApplicationReviewInput
};


export type MutationUpdateExpertApplicationTaskStatusArgs = {
  input: UpdateExpertApplicationTaskStatusInput
};


export type MutationSetExpertApplicationTaskCompletedArgs = {
  input: SetExpertApplicationTaskCompletedInput
};


export type MutationRerunExpertApplicationTaskArgs = {
  input: RerunExpertApplicationTaskInput
};


export type MutationStartExpertApplicationConversationArgs = {
  applicationId: Scalars['ExpertApplicationId']
};


export type MutationAddExpertApplicationNoteArgs = {
  input: AddExpertApplicationNoteInput
};


export type MutationSaveSavedSellableArgs = {
  input: SaveSavedSellableInput
};


export type MutationUnsaveSavedSellableArgs = {
  input: UnsaveSavedSellableInput
};


export type MutationCreateSellableArgs = {
  input: CreateSellableInput
};


export type MutationUpdateSellableArgs = {
  input: UpdateSellableInput
};


export type MutationDeactivateSellableArgs = {
  input: DeactivateSellableInput
};


export type MutationCreateSellableTermsArgs = {
  input: CreateSellableTermsInput
};


export type MutationRequestSellableArgs = {
  input: RequestSellableInput
};


export type MutationDeactivateSellablePriceSourceArgs = {
  input: DeactivateSellablePriceSourceInput
};


export type MutationSaveConsumerSellableReactionArgs = {
  input: SaveConsumerSellableReactionInput
};


export type MutationCreateSellableResearchLinkArgs = {
  input: CreateSellableResearchLinkInput
};


export type MutationDeleteSellableResearchLinkArgs = {
  input: DeleteSellableResearchLinkInput
};


export type MutationStartExpertConsumerConversationArgs = {
  input: StartExpertConsumerConversationInput
};


export type MutationSetLeadSnoozeArgs = {
  input: SetLeadSnoozeInput
};


export type MutationCancelLeadSnoozeArgs = {
  input: CancelLeadSnoozeInput
};


export type MutationSetLeadStarArgs = {
  input: SetLeadStarInput
};


export type MutationSetLeadArchivedArgs = {
  input: SetLeadArchivedInput
};


export type MutationSetLeadDoNotCallArgs = {
  input: SetLeadDoNotCallInput
};


export type MutationDismissLeadSuggestedActionArgs = {
  input: DismissLeadSuggestedActionInput
};


export type MutationDelegateLeadArgs = {
  input: DelegateLeadInput
};


export type MutationReassignLeadArgs = {
  input: ReassignLeadInput
};


export type MutationSetConsumerInitialLeadActionArgs = {
  input: SetConsumerInitialLeadActionInput
};


export type MutationCreateQuickReplyWithLeadArgs = {
  input: CreateQuickReplyWithLeadInput
};


export type MutationCreateQuickReplyWithoutLeadArgs = {
  input: CreateQuickReplyWithoutLeadInput
};


export type MutationCreateQuickReplyArgs = {
  input: CreateQuickReplyInput
};


export type MutationUpdateQuickReplyArgs = {
  input: UpdateQuickReplyInput
};


export type MutationDeleteQuickReplyArgs = {
  id: Scalars['QuickReplyId']
};


export type MutationCreateLeadNoteArgs = {
  input: CreateLeadNote
};


export type MutationUpdateLeadNoteArgs = {
  input: UpdateLeadNoteInput
};


export type MutationDeleteLeadNoteArgs = {
  id: Scalars['LeadNoteId']
};


export type MutationAddUserInfoForLeadArgs = {
  input: AddUserInfoForLeadInput
};


export type MutationAcceptLeadEscalationArgs = {
  input: AcceptEscalationInput
};


export type MutationStartLeadEscalationArgs = {
  input: StartLeadEscalationInput
};


export type MutationReportPredictedLifeTimeValueToPlatformArgs = {
  input: ReportPredictedLifeTimeValueInput
};


export type MutationCreateLeadCampaignArgs = {
  input: CreateLeadCampaignInput
};


export type MutationCopyLeadCampaignArgs = {
  input: CopyLeadCampaignInput
};


export type MutationUpdateLeadCampaignArgs = {
  input: UpdateLeadCampaignInput
};


export type MutationDeactivateLeadCampaignArgs = {
  id: Scalars['LeadCampaignId']
};


export type MutationActivateLeadCampaignArgs = {
  id: Scalars['LeadCampaignId']
};


export type MutationCreateLeadCampaignTriggerArgs = {
  input: CreateLeadCampaignTriggerInput
};


export type MutationCreateReportArgs = {
  input: CreateReportInput
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput
};


export type MutationAddReportScheduleArgs = {
  input: AddScheduleReportInput
};


export type MutationRemoveReportScheduleArgs = {
  input: RemoveScheduleReportInput
};


export type MutationAddExpertCuratedItemToCartArgs = {
  input: AddExpertCuratedItemToCartInput
};


export type MutationCreateExpertCuratedItemArgs = {
  input: CreateExpertCuratedItemInput
};


export type MutationCopyFromExpertCuratedItemsArgs = {
  input: CopyFromExpertCuratedItemsInput
};


export type MutationUpdateExpertCuratedItemArgs = {
  input: UpdateExpertCuratedItemInput
};


export type MutationRemoveExpertCuratedItemArgs = {
  input: RemoveExpertCuratedItemInput
};


export type MutationMakeExpertCuratedItemDraftsActiveArgs = {
  input: MakeExpertCuratedItemDraftsActiveInput
};


export type MutationCreateExpertCuratedOrderArgs = {
  input: CreateExpertCuratedOrderInput
};


export type MutationUpdateExpertCuratedOrderVariationOptionsArgs = {
  input: UpdateExpertCuratedOrderVariationOptionsInput
};


export type MutationUpsertItemsInExpertCuratedOrderArgs = {
  input: UpsertItemsInExpertCuratedOrderInput
};


export type MutationRemoveItemsFromExpertCuratedOrderArgs = {
  input: RemoveItemsFromExpertCuratedOrderInput
};


export type MutationActivateExpertCuratedOrderAsBookableArgs = {
  input: ActivateExpertCuratedOrderAsBookableInput
};


export type MutationNotifyCustomerExpertCuratedOrderArgs = {
  input: NotifyCustomerExpertCuratedOrderInput
};


export type MutationCustomerRequestExpertCuratedOrderArgs = {
  input: CustomerRequestExpertCuratedOrderInput
};


export type MutationCloseExpertCuratedOrderArgs = {
  input: CloseExpertCuratedOrderInput
};


export type MutationUpdateExpertCuratedOrderTermsArgs = {
  input: UpdateExpertCuratedOrderTermsInput
};


export type MutationSelectExpertCuratedOrderVariationOptionArgs = {
  input: SelectExpertCuratedOrderVariationOptionInput
};


export type MutationSelectExpertCuratedOrderItemsArgs = {
  input: SelectExpertCuratedOrderItemsInput
};


export type MutationUpdateServiceLocationExpertCuratedOrderArgs = {
  input: UpdateServiceLocationExpertCuratedOrderInput
};


export type MutationActivateExpertCuratedOrdersForLeadArgs = {
  input: ActivateExpertCuratedOrdersForLeadInput
};


export type MutationFindOrCreateReplacementExpertCuratedOrderArgs = {
  input: FindOrCreateReplacementExpertCuratedOrderInput
};


export type MutationCopyItemsFromExpertCuratedOrderArgs = {
  input: CopyItemsFromExpertCuratedOrderInput
};


export type MutationUpsertExpertCuratedLeadItineraryArgs = {
  input: UpsertExpertCuratedLeadItineraryInput
};


export type MutationDeleteExpertCuratedLeadItineraryArgs = {
  input: DeleteExpertCuratedLeadItineraryInput
};


export type MutationCreateSavedExpertCuratedItemsArgs = {
  input: CreateSavedExpertCuratedItemsInput
};


export type MutationUpdateSavedExpertCuratedItemsArgs = {
  input: UpdateSavedExpertCuratedItemsInput
};


export type MutationDeleteSavedExpertCuratedItemsArgs = {
  id: Scalars['SavedExpertCuratedItemsId']
};


export type MutationCreateExpertConsultationFeeOrderArgs = {
  input: CreateExpertConsultationFeeOrderInput
};


export type MutationCreateRecommendedListDefinitionArgs = {
  input: CreateRecommendedListDefinitionInput
};


export type MutationUpdateRecommendedListDefinitionArgs = {
  input: UpdateRecommendedListDefinitionInput
};


export type MutationDeleteRecommendedListDefinitionArgs = {
  id: Scalars['RecommendedListDefinitionId']
};


export type MutationCreateTriggerArgs = {
  input: CreateTriggerInput
};


export type MutationUpdateTriggerArgs = {
  input: UpdateTriggerInput
};


export type MutationCreateTriggerNodeArgs = {
  input: CreateTriggerNodeInput
};


export type MutationRemoveTriggerNodeArgs = {
  input: RemoveTriggerNodeInput
};


export type MutationUpdateTriggerFilterArgs = {
  input: UpdateTriggerFilterInput
};


export type MutationUpdateTriggerDelayArgs = {
  input: UpdateTriggerDelayInput
};


export type MutationUpdateTriggerActionArgs = {
  input: UpdateTriggerActionInput
};


export type MutationUpdateTriggerBranchArgs = {
  input: UpdateTriggerBranchInput
};


export type MutationSwapTriggerBranchEdgesArgs = {
  input: SwapTriggerBranchEdgesInput
};


export type MutationUpdateTriggerWaitArgs = {
  input: UpdateTriggerWaitInput
};


export type MutationSwapTriggerWaitEdgesArgs = {
  input: SwapTriggerWaitEdgesInput
};


export type MutationSplitTriggerWaitEdgesArgs = {
  input: SplitTriggerWaitEdgesInput
};


export type MutationMergeTriggerWaitEdgesArgs = {
  input: MergeTriggerWaitEdgesInput
};


export type MutationUpdateTriggerEdgeArgs = {
  input: UpdateTriggerEdgeInput
};


export type MutationRemoveTriggerEdgeArgs = {
  input: RemoveTriggerEdgeInput
};


export type MutationPublishTriggerArgs = {
  input: PublishTriggerInput
};


export type MutationDeactivateTriggerArgs = {
  input: DeactivateTriggerInput
};


export type MutationCopyTriggerArgs = {
  input: CopyTriggerInput
};


export type MutationImportEntitiesArgs = {
  input: ImportEntitiesInput
};


export type MutationTestTriggerExecutionArgs = {
  input: TestTriggerExecutionInput
};


export type MutationShortenUrlArgs = {
  input?: Maybe<ShortenUrlInput>
};


export type MutationCreateAdhocSellableFromEBayItemArgs = {
  input: CreateAdhocSellableFromEBayItemInput
};


export type MutationIdentifyEBayItemAsSellableArgs = {
  input: IdentifyEBayItemAsSellableInput
};


export type MutationUpdateConfigArgs = {
  input: UpdateConfigInput
};


export type MutationResetConfigArgs = {
  input: ResetConfigInput
};


export type MutationSyncExternalAdCampaignsArgs = {
  input: SyncExternalAdCampaignsInput
};


export type MutationUpdateExternalAdCampaignArgs = {
  input: UpdateExternalAdCampaignInput
};


export type MutationUpdateExternalAdGroupArgs = {
  input: UpdateExternalAdGroupInput
};


export type MutationApplyExternalAdBudgetArgs = {
  input: ApplyExternalAdBudgetInput
};


export type MutationStartSystemCuratedItemSurveyArgs = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type MutationTerminateSystemCuratedItemSurveyArgs = {
  input: TerminateSystemCuratedItemSurveyInput
};


export type MutationCreateFlightPlanArgs = {
  input: CreateFlightPlanInput
};


export type MutationActivateFlightPlanArgs = {
  input: ActivateFlightPlanInput
};


export type MutationCopyFlightPlanAsDraftArgs = {
  input: CopyFlightPlanAsDraftInput
};


export type MutationUpsertLegsIntoFlightPlanArgs = {
  input: UpsertLegsIntoFlightPlanInput
};


export type MutationRemoveLegsFromFlightPlanArgs = {
  input: RemoveLegsFromFlightPlanInput
};


export type MutationAssignSupportTaskArgs = {
  input: AssignSupportTaskInput
};


export type MutationCompleteSupportTaskNoActionNeededArgs = {
  input: CompleteSupportTaskNoActionNeededInput
};


export type MutationCompleteSupportTaskSnoozeArgs = {
  input: CompleteSupportTaskSnoozeInput
};


export type MutationCompleteLeadSupportTaskAssignLeadActionsArgs = {
  input: CompleteLeadSupportTaskAssignLeadActionsInput
};


export type MutationCompleteLeadSupportTaskDelegateLeadArgs = {
  input: CompleteLeadSupportTaskDelegateLeadInput
};


export type MutationCompleteLeadSupportTaskReassignLeadArgs = {
  input: CompleteLeadSupportTaskReassignLeadInput
};


export type MutationCompleteLeadSupportTaskEscalateToTeamForDelegationArgs = {
  input: CompleteLeadSupportTaskEscalateToTeamForDelegationInput
};


export type MutationCompleteLeadSupportTaskEscalateForReassignmentArgs = {
  input: CompleteLeadSupportTaskEscalateForReassignmentInput
};


export type MutationCompleteLeadSupportTaskRequestOrderSupportArgs = {
  input: CompleteLeadSupportTaskRequestOrderSupportInput
};


export type MutationCreateOrderEscalationArgs = {
  input: CreateOrderEscalationInput
};


export type MutationAssignOrderEscalationArgs = {
  input: AssignEscalationInput
};


export type MutationStartOrderEscalationArgs = {
  input: StartEscalationInput
};


export type MutationCompleteOrderEscalationArgs = {
  input: CompleteEscalationInput
};


export type MutationAddEscalationNoteArgs = {
  input: AddEscalationOperatorNoteInput
};


export type MutationSetEscalationPriorityArgs = {
  input: SetEscalationPriorityInput
};


export type MutationStartSupportConversationArgs = {
  input: StartSupportConversationInput
};


export type MutationUpdateSellableInventoryItemArgs = {
  input: SellableInventoryItemUpdateInput
};


export type MutationCreatePayStructureArgs = {
  input: CreatePayStructureInput
};


export type MutationCreatePayStructureRevisionArgs = {
  input: CreatePayStructureRevisionInput
};


export type MutationUpdatePayStructureRevisionArgs = {
  input: UpdatePayStructureRevisionInput
};


export type MutationActivatePayStructureRevisionArgs = {
  input: ActivatePayStructureRevisionInput
};


export type MutationApprovePayoutArgs = {
  id: Scalars['PayoutId']
};


export type MutationBulkApprovePayoutsArgs = {
  ids: Array<Scalars['PayoutId']>
};


export type MutationResendPayoutArgs = {
  id: Scalars['PayoutId']
};


export type MutationRecomputePayoutArgs = {
  id: Scalars['PayoutId']
};


export type MutationAddManualAdjustmentPayLineItemArgs = {
  input: AddManualAdjustmentPayLineItemInput
};


export type MutationCreateRawSellableSourceArgs = {
  input: CreateRawSellableSourceInput
};


export type MutationUpdateRawSellableSourceArgs = {
  input: UpdateRawSellableSourceInput
};


export type MutationCreateRawSellableStandardizationRuleArgs = {
  input: CreateRawSellableStandardizationRuleInput
};


export type MutationUpdateRawSellableStandardizationRuleArgs = {
  input: UpdateRawSellableStandardizationRuleInput
};


export type MutationMergeStandardizedSellableGroupArgs = {
  input: MergeStandardizedSellableGroupInput
};


export type MutationStartStandardizedSellableGroupIngestionArgs = {
  input: StartStandardizedSellableGroupIngestionInput
};


export type MutationStartRawSellableSourceIngestionArgs = {
  input: StartRawSellableSourceIngestionInput
};


export type MutationCreateSchedulingTypeArgs = {
  input: CreateSchedulingTypeInput
};


export type MutationCreateSchedulingDemandForecastArgs = {
  input: CreateSchedulingDemandForecastInput
};


export type MutationUpdateSchedulingDemandForecastArgs = {
  input: UpdateSchedulingDemandForecastInput
};


export type MutationRemoveSchedulingDemandForecastArgs = {
  id: Scalars['SchedulingDemandForecastId']
};


export type MutationCreateSchedulingUserAvailabilityArgs = {
  input: CreateSchedulingUserAvailabilityInput
};


export type MutationRemoveSchedulingUserAvailabilityArgs = {
  id: Scalars['SchedulingUserAvailabilityId']
};


export type MutationAcceptShiftArgs = {
  id: Scalars['ShiftId']
};


export type MutationDeclineShiftArgs = {
  id: Scalars['ShiftId']
};


export type MutationCreateShiftArgs = {
  input: CreateShiftInput
};

export type Myself = {
  __typename: 'Myself',
  id: Scalars['AnyId'],
  user: User,
  operator?: Maybe<Operator>,
  businessUser?: Maybe<BusinessUser>,
  realUser: User,
  hasPassword: Scalars['Boolean'],
  /** Fetching this property will insert data into the database. It is technically a mutation, but due to
   * the restriction of Apollo SSR (no mutation executed) and our requirement to do 301 redirect, we need to make
   * this a query
 */
  loginToken: Scalars['String'],
};

export type NewOrderEscalationNotification = {
  __typename: 'NewOrderEscalationNotification',
  newEscalationCount: Scalars['Long'],
};

export type NoReturnsAcceptedReturnPolicy = ReturnPolicy & {
  __typename: 'NoReturnsAcceptedReturnPolicy',
  type: ReturnPolicyType,
};

export type NotifyCustomerExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
};

export type NotifyCustomerExpertCuratedOrderPayload = {
  __typename: 'NotifyCustomerExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

/** ====== NumericPathFlowQuestion */
export type NumericPathFlowQuestion = PathFlowQuestion & {
  __typename: 'NumericPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  valueType: NumericPathFlowQuestionValueType,
  displayType?: Maybe<NumericPathFlowQuestionDisplayType>,
  placeholder?: Maybe<Scalars['String']>,
  /** If reloading a question answered by the user, this is their previous input */
  numericUserInput: SubmitNumericPathFlowQuestionInputTypeCopy,
  unitLabel?: Maybe<Scalars['String']>,
  unit?: Maybe<NumericPathFlowQuestionUnitType>,
};


/** ====== NumericPathFlowQuestion */
export type NumericPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum NumericPathFlowQuestionDisplayType {
  HEIGHT_IN_INCHES = 'HEIGHT_IN_INCHES',
  STAR_RATING = 'STAR_RATING'
}

export enum NumericPathFlowQuestionUnitType {
  INCHES = 'INCHES',
  FEET = 'FEET',
  POUNDS = 'POUNDS',
  CENTIMETERS = 'CENTIMETERS',
  KILOGRAMS = 'KILOGRAMS'
}

export enum NumericPathFlowQuestionValueType {
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL'
}

/** Display facet for a min/max range */
export type NumericRangeDisplayFacet = DisplayFacet & {
  __typename: 'NumericRangeDisplayFacet',
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'],
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'],
  /** Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
 */
  alias?: Maybe<Scalars['String']>,
  /** Type of numeric facet; currently used to change rendering styles */
  type: NumericRangeDisplayFacetType,
  /** unscaled lower bound */
  lower: Scalars['Long'],
  /** unscaled upper bound */
  upper: Scalars['Long'],
  /** if `upper` is capped (there are values beyond upper, but the result is truncated for ease of use, and querying for
   * the capped upper value will give all values beyond it)
 */
  upperCapped: Scalars['Boolean'],
  /** The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value. */
  scale: Scalars['Int'],
  /** Computed decimal value of `lower` at `scale` */
  decimalLower: Scalars['BigDecimal'],
  /** Computed decimal value of `upper` at `scale` */
  decimalUpper: Scalars['BigDecimal'],
};

export enum NumericRangeDisplayFacetType {
  /** Render the number as is */
  DEFAULT = 'DEFAULT',
  /** Render the number (represented in cents) as USD currency */
  USD_CURRENCY = 'USD_CURRENCY'
}

/** ====== OAuthEmailPathFlowQuestion */
export type OAuthEmailPathFlowQuestion = PathFlowQuestion & {
  __typename: 'OAuthEmailPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  firstName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  lastName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  email?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  googleIdToken?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  facebookUserAccessToken?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  skipFirstName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  skipLastName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  /** If reloading a question answered by the user, this is their previous input */
  oAuthEmailUserInput: SubmitOAuthEmailPathFlowQuestionInputTypeCopy,
};


/** ====== OAuthEmailPathFlowQuestion */
export type OAuthEmailPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum OAuthType {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export type OfferAddOn = {
  __typename: 'OfferAddOn',
  title: Scalars['String'],
  retailPrice: Money,
};

export type OfferAddOnInput = {
  title: Scalars['String'],
  retailPrice: Scalars['Float'],
};

export enum OfferState {
  INITIAL = 'INITIAL',
  GENERATED = 'GENERATED',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  WITHDRAWN = 'WITHDRAWN'
}

export type OfferTerms = ProductOfferTerms | ServiceOfferTerms;

export type OnboardingSpecialistUser = {
  __typename: 'OnboardingSpecialistUser',
  id: Scalars['AnyId'],
  displayName: Scalars['String'],
};

export type OpenGraphData = {
  __typename: 'OpenGraphData',
  url: Scalars['String'],
  properties: Array<OpenGraphProperty>,
};

export type OpenGraphProperty = {
  __typename: 'OpenGraphProperty',
  name: Scalars['String'],
  value: Scalars['String'],
};

export type Operator = {
  __typename: 'Operator',
  id: Scalars['OperatorId'],
  user: User,
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  phoneNumber?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  isAdmin: Scalars['Boolean'],
  permissions: Array<OperatorPermission>,
  roles: Array<OperatorRole>,
  messagingUser: MessagingUser,
  onboardingSpecialistMessagingUserId: Scalars['AnyId'],
  supportMessagingUserId: Scalars['AnyId'],
};

export type OperatorAssignedActivity = OrderActivityDetail & {
  __typename: 'OperatorAssignedActivity',
  type: OrderActivityDetailType,
  assigned: Operator,
};


/** =============
 * Ops UI permission
 * =============
 */
export enum OperatorPermission {
  UI_OPS_MANAGE_CATALOG = 'UI_OPS_MANAGE_CATALOG',
  UI_OPS_MANAGE_LEADS = 'UI_OPS_MANAGE_LEADS',
  UI_OPS_MANAGE_CONSUMERS = 'UI_OPS_MANAGE_CONSUMERS',
  UI_OPS_MANAGE_MERCHANTS = 'UI_OPS_MANAGE_MERCHANTS',
  UI_OPS_MANAGE_EXPERTS = 'UI_OPS_MANAGE_EXPERTS',
  UI_OPS_DEVTOOLS = 'UI_OPS_DEVTOOLS',
  UI_OPS_MANAGE_ALL_ORDERS = 'UI_OPS_MANAGE_ALL_ORDERS',
  UI_OPS_MANAGE_PAYROLL = 'UI_OPS_MANAGE_PAYROLL',
  UI_OPS_MANAGE_ASSIGNED_ORDERS = 'UI_OPS_MANAGE_ASSIGNED_ORDERS',
  UI_OPS_RESEARCH_ORDER_FULFILLMENT = 'UI_OPS_RESEARCH_ORDER_FULFILLMENT',
  UI_OPS_FULFILL_ORDERS = 'UI_OPS_FULFILL_ORDERS',
  UI_OPS_TEST_TRIGGER = 'UI_OPS_TEST_TRIGGER',
  UI_OPS_ASSISTANT = 'UI_OPS_ASSISTANT',
  UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF = 'UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF'
}

export type OperatorQuery = {
  userIds?: Maybe<Array<Scalars['UserId']>>,
  includeInactive?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
};

export enum OperatorRole {
  CATALOG_MANAGER = 'CATALOG_MANAGER',
  ONBOARDING_SPECIALIST = 'ONBOARDING_SPECIALIST',
  LEAD_SUPPORT = 'LEAD_SUPPORT',
  ORDER_SUPPORT = 'ORDER_SUPPORT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  FULFILLMENT_AGENT = 'FULFILLMENT_AGENT',
  PAYROLL_MANAGER = 'PAYROLL_MANAGER'
}

export type Order = {
  __typename: 'Order',
  id: Scalars['OrderId'],
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  paidAt?: Maybe<Scalars['Date']>,
  version: Scalars['Int'],
  /** used for trigger entity.  only need userId, not the user object */
  userId: Scalars['UserId'],
  user: User,
  state: OrderState,
  description: Scalars['String'],
  /** all non tax, shipment, and tip costs */
  price: MonetaryAmount,
  tax: MonetaryAmount,
  discount: MonetaryAmount,
  shippingCost: MonetaryAmount,
  /** amount of tip for the expert, if applicable */
  tip?: Maybe<MonetaryAmount>,
  /** total cost including all line items and adjustments; reflects what the customer should be charged */
  totalCost: MonetaryAmount,
  /** total cost, excluding tax */
  totalCostBeforeTax: MonetaryAmount,
  shippingAddress?: Maybe<Address>,
  shipmentTrackings?: Maybe<Array<ShipmentTracking>>,
  /** De-normalized shipping method for the order, derived from the line items */
  shippingMethod?: Maybe<ShippingMethod>,
  /** Rough estimate of when the entire order will be delivered to the customer; takes `shippingMethod` and `paidAt` into
   * account
 */
  estimatedToArriveAt?: Maybe<Scalars['Date']>,
  merchantEmbursementId?: Maybe<Scalars['String']>,
  internalNotes?: Maybe<Scalars['String']>,
  attachments: Array<MediaFile>,
  transactions?: Maybe<Array<Transaction>>,
  transaction: Transaction,
  offer?: Maybe<BroadcastOffer>,
  title: Scalars['String'],
  /** topLevelOnly: if true, will only return line items where parent is null.  All line items under a parent
   * will be exluded.  default is false.
 */
  lineItems: Array<OrderLineItem>,
  /** Messages associated with this order line item */
  messages: Array<OrderMessage>,
  fulfillmentState: OrderFulfillmentState,
  /** If the order can be charged. For `OrderChargeableUseCase.CHECKOUT`, it checks if it's safe to proceed to checkout.
   * For OrderChargeableUseCase.PURCHASE`, it checks if `payForOrder` is safe to invoke. Everything except for
   * `OrderChargeableStatus.CAN_CHARGE` is an error state.
 */
  chargeableStatus: OrderChargeableStatus,
  /** If the order requires a shipping address
   * Note that this flag simply indicates if the order contains things which are shipped. If a shipping address is
   * required and one is provided, this will continue to be `true`.
 */
  requiresShippingAddress: Scalars['Boolean'],
  /** If this order has a limited lifespan, and must be purchased before this time. If this time elapses, it will be
   * reflected in the `chargeableStatus` property as `EXPIRED`
 */
  expiresAt?: Maybe<Scalars['Date']>,
  /** If this order was curated by an expert, the expert that curated it */
  curatedBy?: Maybe<BusinessUser>,
  /** If this order was curated by an expert, the lead this order was curated for */
  lead?: Maybe<Lead>,
  /** Amount of items being ordered; should be used to display badge counts for how many items the order/cart contains. */
  itemsCount: Scalars['Int'],
  /** Sum of all costs that map to these cost components
   * `TAX_ADJUSTMENTS` and `DISCOUNT_ADJUSTMENTS` only include tax and discounts for other included cost components. For
   * example, if `[SHIPMENT, TAX_ADJUSTMENTS]` are provided, the total cost will be the shipment, plus the tax **ONLY**
   * for the shipment - not the `CORE` (sellables, etc). The same holds true for `CostComponent#DISCOUNT_ADJUSTMENTS`.
   * This also means that if only `TAX_ADJUSTMENTS` is provided, this will always compute a zero monetary amount.
   * To only get tax or discounts, use the `tax` or `discount` properties, respectively.
 */
  totalCostOnlyIncluding: MonetaryAmount,
  /** Sum of all costs except for line items that map to these cost components
   * This contract is similar to `totalCostOnlyIncluding`, but inverted to exclude cost instead of include.
 */
  totalCostExcluding: MonetaryAmount,
  /** All the leads that have contributed to curation for this order.
   * This includes ExpertCuratedItem, ExpertCuratedOrder and BroadcastOffer
 */
  associatedLeads: Array<Lead>,
  consumerReceiptUrl: Scalars['String'],
  consumerUrl: Scalars['String'],
  adminUrl: Scalars['String'],
  /** This id can be used for order receipt.  It is more friendly then the base64 encoded order.id.  This is only available
   *  for PostCart order, ie. order state is not  CREATED or CART
 */
  consumerFriendlyId?: Maybe<Scalars['String']>,
  /** Primary image to display when previewing this order. */
  primaryImage?: Maybe<MediaFile>,
  /** Last time this order was viewed on the view cart page by the order owner (userId) */
  cartLastViewedAt?: Maybe<Scalars['Date']>,
  /** Emburse cardIds */
  emburseCardIds: Array<Scalars['String']>,
  lastCheckedOutAt?: Maybe<Scalars['Date']>,
  primaryLeadForFollowup?: Maybe<Lead>,
  categoryType: CategoryType,
  /** Provides a list of Payment processor to use for the payment of this Order.
   * This list is derived from restrictions some Processors have on the amount of transaction on the Orders.
   * Note, this list may change as the OrderLineItems are added or removed.
 */
  supportedPaymentProviders: Array<PaymentProcessorType>,
  /** Provides a list of payment methods and its payment processor to use for the payment of this Order.
   * This list is derived from restrictions some Processors have on the amount of transaction on the Orders.
   * Note, this list may change as the OrderLineItems are added or removed.
 */
  supportedPaymentMethods: Array<SupportedPaymentMethod>,
  /** This not so great name for timestamp captures the time instant when certain activity occurs.
   * This is equal to the createdAt date when the Order is first created and then update timestamp as the user attempts
   * to place the order. The timestamp is updated for both successful and failed payment attempts, including retries.
 */
  sortTimestamp: Scalars['Date'],
  /** The paid amount of this order. */
  paidAmount: MonetaryAmount,
  /** When deposit is allowed, the remaining balance for deposit. If deposit is already paid, should be 0 */
  remainingDepositBalance?: Maybe<MonetaryAmount>,
  /** The remaining balance of this order. If an order is unpaid, it should be the same as totalCost.
   * If there is a partial payment, or deposit, this would be the remaining amount in order to be fully paid.
 */
  remainingBalance: MonetaryAmount,
  /** If deposit is allowed */
  depositAllowed: Scalars['Boolean'],
  /** When deposit is allowed, this would be the minimum amount to be paid as a deposit */
  minimumDeposit?: Maybe<MonetaryAmount>,
  /** This is the due date for the full payment, regardless if deposit is allowed or not */
  fullPaymentDueAt?: Maybe<Scalars['Date']>,
  depositPaidAt?: Maybe<Scalars['Date']>,
  paidInFullAt?: Maybe<Scalars['Date']>,
  submittedAt?: Maybe<Scalars['Date']>,
  /** The payment source to be charged automatically if allow (i.e. the payment source is chargeable with sufficient funds) */
  chargingPaymentSource?: Maybe<PaymentSource>,
  /** All scheduled payments that are scheduled or canceled. Executed scheduled payments are excluded, and should be
   * available as transactions
 */
  scheduledPayments: Array<ScheduledPayment>,
  scheduledPayment: ScheduledPayment,
  /** All promotions added to this order, including those that may not be actively applied
   * (e.g.: promotion rule may not apply to current items in cart, or one of the promotions gives a greater discount
   * over another).
 */
  promotionEntries: Array<OrderPromotionEntry>,
  /** The currently applied promotion, if any. This is simply the `applied` entry in `promotionEntries`, which there can
   * be at most one (only one promotion active at a time)
 */
  appliedPromotionEntry?: Maybe<OrderPromotionEntry>,
  /** The operator assigned to this order for fulfillment purposes */
  fulfillmentOperator?: Maybe<Operator>,
  /** Notes from operator about the order */
  operatorNotes: Array<OrderOperatorNote>,
  /** A flag indicating if this order is urgent and should be prioritized for fulfillment */
  isUrgent: Scalars['Boolean'],
  /** If this order contains a service, the address which this service will be performed */
  serviceLocation?: Maybe<PostalAddress>,
  /** This is only used for as trigger entity. */
  activity?: Maybe<OrderActivity>,
  /** This is only used for as trigger entity so that we can filter out order events on simple curated order */
  simpleCuratedOrder?: Maybe<SimpleCuratedOrder>,
  /** Labels indicating an order's derived state, such as unclaimed orders, and orders that need to be tracked */
  labels: Array<OrderLabel>,
  /** Distinct Departments the order's sellables belong to */
  departments: Array<Department>,
  /** The experts who helped the customer with this order */
  expertContributions: Array<OrderExpertContribution>,
  /** Escalations associated with the order */
  escalations: Array<OrderEscalation>,
  /** post cart activities associated with the order */
  postCartActivities: Array<PostCartOrderActivity>,
};


export type OrderTransactionArgs = {
  transactionId: Scalars['TransactionId']
};


export type OrderLineItemsArgs = {
  topLevelOnly?: Maybe<Scalars['Boolean']>
};


export type OrderChargeableStatusArgs = {
  useCase: OrderChargeableUseCase
};


export type OrderTotalCostOnlyIncludingArgs = {
  costComponents: Array<OrderCostComponent>
};


export type OrderTotalCostExcludingArgs = {
  costComponents: Array<OrderCostComponent>
};


export type OrderScheduledPaymentArgs = {
  id: Scalars['ScheduledPaymentId']
};


export type OrderPostCartActivitiesArgs = {
  limit?: Maybe<Scalars['Int']>
};

export type OrderActivity = {
  __typename: 'OrderActivity',
  lastPreSubmitAction: OrderPreSubmitAction,
  lastPreSubmitActionOccurredAt: Scalars['Date'],
};

export type OrderActivityDetail = {
  __typename: 'OrderActivityDetail',
  type: OrderActivityDetailType,
};

export enum OrderActivityDetailType {
  OPERATOR_ASSIGNED = 'OPERATOR_ASSIGNED',
  MERCHANT_CLAIMED = 'MERCHANT_CLAIMED',
  TRACKING_UPDATED = 'TRACKING_UPDATED',
  TRACKING_REMOVED = 'TRACKING_REMOVED',
  ORDER_ESCALATED = 'ORDER_ESCALATED',
  ITEM_SHIPPED = 'ITEM_SHIPPED',
  ESCALATION_CLOSED = 'ESCALATION_CLOSED'
}

/** Compare against the total of core line items (sellables, base price, ad hoc) */
export type OrderAmountPromotionRuleReference = PromotionRuleReference & {
  __typename: 'OrderAmountPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  operator: PromotionRuleComparisonOperator,
  /** Right hand side amount, in respect to `operator`. Left hand side is the actual aggregated cost of line items. */
  rightOperandAmount: MonetaryAmount,
};

/** See `OrderAmountPromotionRuleReference` for documentation */
export type OrderAmountPromotionRuleReferenceInput = {
  operator: PromotionRuleComparisonOperator,
  rightOperandAmount: MonetaryAmountInput,
};

export type OrderChargeableStatus = {
  __typename: 'OrderChargeableStatus',
  type: OrderChargeableStatusType,
  /** Optional message for failure (non `CAN_CHARGE` types) that provides more context to the user why they can't buy */
  message?: Maybe<Scalars['String']>,
};

export enum OrderChargeableStatusType {
  /** The order can be charged */
  CAN_CHARGE = 'CAN_CHARGE',
  /** The order has already been charged. */
  ALREADY_CHARGED = 'ALREADY_CHARGED',
  /** The order is empty. */
  EMPTY = 'EMPTY',
  /** The order requires a shipping address, but none was provided. Not relevant for OrderChargeableUseCase.CHECKOUT */
  NO_SHIPPING_ADDRESS = 'NO_SHIPPING_ADDRESS',
  /** The order requires a service address, but none was set by the expert. Orders should never reach the customer in
   * this state as the address should be set by the expert beforehand.
 */
  NO_SERVICE_LOCATION = 'NO_SERVICE_LOCATION',
  /** The order is expired; the user must reach out to the expert to renew the order. */
  EXPIRED = 'EXPIRED',
  /** The order requires a minimum amount (e.g.: Orders shipped to Australia need to have at least $125 in the cart)
   * Use the `message` property on `OrderChargeableStatus` to display a message containing the exact amount the user
   * needs.
 */
  BELOW_MINIMUM_AMOUNT = 'BELOW_MINIMUM_AMOUNT',
  /** The order is in a preview state (only available for viewing); the user must reach out to the expert to receive
   * a new purchase-able order.
 */
  IN_PREVIEW = 'IN_PREVIEW'
}

export enum OrderChargeableUseCase {
  /** Checking if the checkout process can be started */
  CHECKOUT = 'CHECKOUT',
  /** Checking if the order can be purchased (payment provided to stripe/paypal/etc, and order charged) */
  PURCHASE = 'PURCHASE'
}

export enum OrderCostComponent {
  /** Includes the price for AD_HOC, SELLABLE, and BASE_PRICE source types (the core price of what's being purchased) */
  CORE = 'CORE',
  /** Tip paid to Deal.com experts */
  EXPERT_TIP = 'EXPERT_TIP',
  /** Fixed gratuity (e.g.: mandatory crew gratuity for charters) */
  GRATUITY = 'GRATUITY',
  /** Shipping */
  SHIPMENT = 'SHIPMENT',
  /** Tax */
  TAX_ADJUSTMENTS = 'TAX_ADJUSTMENTS',
  /** Discounts through promotions */
  DISCOUNT_ADJUSTMENTS = 'DISCOUNT_ADJUSTMENTS'
}

export type OrderEscalatedActivity = OrderActivityDetail & {
  __typename: 'OrderEscalatedActivity',
  type: OrderActivityDetailType,
  escalation: OrderEscalation,
};

export type OrderEscalation = {
  __typename: 'OrderEscalation',
  id: Scalars['OrderEscalationId'],
  version: Scalars['Int'],
  updatedAt: Scalars['Date'],
  createdAt: Scalars['Date'],
  userId: Scalars['UserId'],
  orderId: Scalars['OrderId'],
  leadId?: Maybe<Scalars['LeadId']>,
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>,
  assignedToId?: Maybe<Scalars['OperatorId']>,
  reason?: Maybe<Scalars['String']>,
  startedAt?: Maybe<Scalars['Date']>,
  completedAt?: Maybe<Scalars['Date']>,
  dueDate?: Maybe<Scalars['Date']>,
  status: OrderEscalationStatus,
  type: OrderEscalationType,
  escalatedById: Scalars['AnyId'],
  user: User,
  assignedTo?: Maybe<Operator>,
  order: Order,
  priority: OrderEscalationPriority,
  operatorNotes?: Maybe<Array<OrderOperatorNote>>,
  mediaAttachments?: Maybe<Array<OrderEscalationAttachment>>,
  preferredContactMethod: ContactType,
  userLastRespondedAt?: Maybe<Scalars['Date']>,
  operatorLastRespondedAt?: Maybe<Scalars['Date']>,
  consumerFriendlyId?: Maybe<Scalars['String']>,
  supportConversation?: Maybe<SupportConversation>,
  escalatedBy: EscalationUser,
};

export type OrderEscalationAttachment = {
  __typename: 'OrderEscalationAttachment',
  uploadedBy: Scalars['AnyId'],
  createdAt: Scalars['Date'],
  title?: Maybe<Scalars['String']>,
  attachmentMediaId: Scalars['MediaId'],
};

export type OrderEscalationConnection = {
  __typename: 'OrderEscalationConnection',
  facets: Array<DisplayFacet>,
  edges: Array<OrderEscalationEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type OrderEscalationEdge = {
  __typename: 'OrderEscalationEdge',
  node: OrderEscalation,
  cursor: Scalars['String'],
};


export enum OrderEscalationPriority {
  HIGH = 'HIGH',
  NORMAL = 'NORMAL'
}

export type OrderEscalationSearchInput = {
  orderIds?: Maybe<Array<Scalars['String']>>,
  userIds?: Maybe<Array<Scalars['UserId']>>,
  operatorIds?: Maybe<Array<Scalars['OperatorId']>>,
  facets?: Maybe<Array<FacetSelection>>,
  facetedSearch?: Maybe<Scalars['Boolean']>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  statuses?: Maybe<Array<OrderEscalationStatus>>,
  consumerFriendlyId?: Maybe<Scalars['String']>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  sources?: Maybe<Array<OrderEscalationSource>>,
  includeUnassigned?: Maybe<Scalars['Boolean']>,
};

export enum OrderEscalationSearchSort {
  CREATED_AT = 'CREATED_AT',
  STATUS = 'STATUS',
  ORDER_ID = 'ORDER_ID',
  USER_ID = 'USER_ID',
  PAID_AT = 'PAID_AT'
}

export enum OrderEscalationSource {
  CONSUMER = 'CONSUMER',
  EXPERT = 'EXPERT',
  OPERATIONS = 'OPERATIONS'
}

export enum OrderEscalationStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}

export enum OrderEscalationType {
  ITEM_UNAVAILABLE = 'ITEM_UNAVAILABLE',
  MISSING_SPECS = 'MISSING_SPECS',
  ORDER_ADJUSTMENT = 'ORDER_ADJUSTMENT',
  CANCELLATION = 'CANCELLATION',
  RETURN = 'RETURN',
  EXCHANGE = 'EXCHANGE',
  MISSING_ITEM = 'MISSING_ITEM',
  TRACKING_INQUIRY = 'TRACKING_INQUIRY',
  ORDER_INFORMATION = 'ORDER_INFORMATION',
  OTHER = 'OTHER'
}

export type OrderExpertContribution = {
  __typename: 'OrderExpertContribution',
  expert: BusinessUser,
  lead: Lead,
  contributionScore: Scalars['Int'],
};

export type OrderExpertContributionInput = {
  expertId: Scalars['BusinessUserId'],
  leadId: Scalars['LeadId'],
  contributionScore: Scalars['Int'],
};

export enum OrderFulfillmentState {
  NEW = 'NEW',
  CLAIMED = 'CLAIMED',
  READY = 'READY',
  FULFILLED = 'FULFILLED'
}


export type OrderItemShippedActivity = OrderActivityDetail & {
  __typename: 'OrderItemShippedActivity',
  type: OrderActivityDetailType,
};

export enum OrderLabel {
  UNCLAIMED = 'UNCLAIMED',
  TRACKING_NEEDED = 'TRACKING_NEEDED',
  TRACKING_OVERDUE = 'TRACKING_OVERDUE'
}

export type OrderLineItem = {
  __typename: 'OrderLineItem',
  id: Scalars['OrderLineItemId'],
  title: Scalars['String'],
  /** The entity which this line item is derived/synced with. Note that changes in a line item's source price
   * (e.g.: changing a sellable's price) will be bubbled down to to the order line's unitPrice each time the
   * order is modified, or the `syncOrder` mutation is called.
 */
  source: OrderLineItemSource,
  /** the base price of one unit; does not include adjustments (tax, promotions, etc) */
  unitPrice: MonetaryAmount,
  /** quantity of items; can only be greater than one for sellable sources. */
  quantity: Scalars['Int'],
  /** the base price for `quantity` items; does not include adjustments (tax, promotions, etc) */
  price: MonetaryAmount,
  /** the final price of this item, excluding tax adjustments, but including other adjustments such as promotions. */
  totalBeforeTax: MonetaryAmount,
  /** Messages associated with this order line item */
  messages: Array<OrderMessage>,
  /** If this order line item is a child line item, this will be the parent line item this line item is a child of.
   * If null, this line item is a parent (top level) line item.
 */
  parentId?: Maybe<Scalars['OrderLineItemId']>,
  /** This is the child -> parent relationship of the `parentId` relationship, provided for convenience. */
  childIds: Array<Scalars['OrderLineItemId']>,
  children: Array<OrderLineItem>,
  /** If this order line item is a grouping order line item. This flag should be used to determine if child line items
   * can expectedReference this line item as a parent. Note that all line items can't have children blindly added - parents
   * need to be explicitly made into groups (groups dictate pricing policies of children, along with taxation), so
   * prefer using this over inferring if this is a group from non-empty `childIds`.
 */
  isGroup: Scalars['Boolean'],
  /** Metadata about this grouping, if isGroup == true */
  groupDefinition?: Maybe<OrderLineItemGroupDefinition>,
  /** If this order line item is required. Note that this will only be true for child line items that are required within
   * their parent line item. Forcefully removing this line item will remove the parent line item, and any other
   * sibling/child line items of that parent.
 */
  required: Scalars['Boolean'],
  /** Terms specific to the user's purchase of the sellable (e.g.: start time for a charter) */
  terms?: Maybe<SellableTerms>,
  /** The state of the order line item */
  state: OrderLineItemState,
  /** Shipment tracking associated with this order */
  shipmentTracking?: Maybe<ShipmentTracking>,
  /** Return shipment tracking associated with this order */
  returnShipmentTracking?: Maybe<ShipmentTracking>,
  /** Shipping method used for this line item, if applicable */
  shippingMethod?: Maybe<ShippingMethod>,
  /** If this line item was refuded to the customer */
  isCustomerRefunded: Scalars['Boolean'],
  /** If this line item was refunded to Deal.com */
  isDealRefunded: Scalars['Boolean'],
  /** Id of the merchant who claimed that item */
  claimedByMerchant?: Maybe<Merchant>,
  /** Price quote from the merchant who claimed that item */
  claimedByMerchantQuote?: Maybe<MonetaryAmount>,
  /** Order identifier for the order placed with the merchant (merchant specific) */
  claimedByMerchantOrderId?: Maybe<Scalars['String']>,
  /** The parent order that contains this line item */
  order: Order,
  /** The expert curated item this line item was added from, if any */
  expertCuratedItem?: Maybe<ExpertCuratedItem>,
  /** ETA for the item from the merchant */
  etaFromMerchant?: Maybe<Scalars['Date']>,
  /** Notes on the item from merchant or vendor during customization phase. */
  customizationNotes?: Maybe<Scalars['String']>,
  /** Max ETA for the item from the merchant, if merchant chose to enter a date range for the eta */
  maxEtaFromMerchant?: Maybe<Scalars['Date']>,
  /** Email alias for the line item used to place order with merchants */
  emailForFulfillment: Scalars['String'],
};

export type OrderLineItemAdHocSource = OrderLineItemSource & {
  __typename: 'OrderLineItemAdHocSource',
  type: OrderLineItemSourceType,
};

export type OrderLineItemBasePriceSource = OrderLineItemSource & {
  __typename: 'OrderLineItemBasePriceSource',
  type: OrderLineItemSourceType,
};

export type OrderLineItemExpertTipSource = OrderLineItemSource & {
  __typename: 'OrderLineItemExpertTipSource',
  type: OrderLineItemSourceType,
  amount: MonetaryAmount,
  expertAmounts: Array<OrderLineItemExpertTipSourceExpertAmount>,
};

export type OrderLineItemExpertTipSourceExpertAmount = {
  __typename: 'OrderLineItemExpertTipSourceExpertAmount',
  expert: BusinessUser,
  amount: MonetaryAmount,
};

export type OrderLineItemGratuitySource = OrderLineItemSource & {
  __typename: 'OrderLineItemGratuitySource',
  type: OrderLineItemSourceType,
  percentage: Scalars['Int'],
};

export type OrderLineItemGroupDefinition = {
  __typename: 'OrderLineItemGroupDefinition',
  /** Defines how price is computed for this grouped line item and its children */
  priceStrategy: OrderLineItemGroupPriceStrategy,
  /** Defines how tax is computed for this grouped line item and its children */
  taxStrategy: OrderLineItemGroupTaxStrategy,
};

export enum OrderLineItemGroupPriceStrategy {
  /** This line item has no price, and is strictly added as a grouping line item with the children having prices. */
  IGNORE_SELF_DEFAULT_CHILDREN = 'IGNORE_SELF_DEFAULT_CHILDREN',
  /** This line item has a price, with the child line item prices being ignored / not respected. */
  ONLY_SELF_IGNORE_CHILDREN = 'ONLY_SELF_IGNORE_CHILDREN'
}

export enum OrderLineItemGroupTaxStrategy {
  /** All line items will retain their default tax calculation. */
  DEFAULT = 'DEFAULT',
  /** All line items that are children of the current line item will use the current line item's tax calculation.
   * This is useful when the grouping parent line item is a service (e.g.: charters) that are taxed using the service
   * location - not the shipping address. This strategy will use that same calculation (service location) for all child
   * line items (e.g.: ensure that add-on food line item is taxed like the charter).
 */
  PROPAGATE_SELF_TO_CHILDREN = 'PROPAGATE_SELF_TO_CHILDREN'
}


export type OrderLineItemReadyInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OrderLineItemReadyPayload = {
  __typename: 'OrderLineItemReadyPayload',
  order: Order,
};

export type OrderLineItemReceivedInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OrderLineItemReceivedPayload = {
  __typename: 'OrderLineItemReceivedPayload',
  order: Order,
};

export type OrderLineItemSellableSource = OrderLineItemSource & {
  __typename: 'OrderLineItemSellableSource',
  type: OrderLineItemSourceType,
  sellable: Sellable,
  overridePrice?: Maybe<MonetaryAmount>,
};

export type OrderLineItemShipmentSource = OrderLineItemSource & {
  __typename: 'OrderLineItemShipmentSource',
  type: OrderLineItemSourceType,
  amount: MonetaryAmount,
};

export type OrderLineItemSource = {
  __typename: 'OrderLineItemSource',
  type: OrderLineItemSourceType,
};

export enum OrderLineItemSourceType {
  /** No additional metadata; ad-hoc line item */
  AD_HOC = 'AD_HOC',
  /** Line item is linked to a sellable */
  SELLABLE = 'SELLABLE',
  /** Line item is a child line item, indicating the base price of the parent (primarily used for services) */
  BASE_PRICE = 'BASE_PRICE',
  /** Line item represents a tip to Deal.com experts */
  EXPERT_TIP = 'EXPERT_TIP',
  /** Fixed gratuity */
  GRATUITY = 'GRATUITY',
  /** Shipment cost line item */
  SHIPMENT = 'SHIPMENT'
}

export enum OrderLineItemState {
  CLAIMED = 'CLAIMED',
  NEW = 'NEW',
  PAID = 'PAID',
  PENDING_SHIPPING = 'PENDING_SHIPPING',
  READY = 'READY',
  RECEIVED = 'RECEIVED',
  RETURN_PENDING_SHIPPING = 'RETURN_PENDING_SHIPPING',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  RETURN_RECEIVED = 'RETURN_RECEIVED',
  RETURN_SHIPPED = 'RETURN_SHIPPED',
  SHIPPED = 'SHIPPED',
  UNAVAILABLE = 'UNAVAILABLE',
  CUSTOMIZING = 'CUSTOMIZING'
}

export type OrderLineItemUnavailableInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OrderLineItemUnclaimInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type OrderMessage = {
  __typename: 'OrderMessage',
  dismissible: Scalars['Boolean'],
  message: Scalars['String'],
};

export type OrderOperatorNote = {
  __typename: 'OrderOperatorNote',
  operator: Operator,
  createdAt: Scalars['Date'],
  title?: Maybe<Scalars['String']>,
  note: Scalars['String'],
};

export enum OrderPreSubmitAction {
  CHECKOUT_STARTED = 'CHECKOUT_STARTED',
  ADD_TO_CART = 'ADD_TO_CART',
  PAYMENT_INFO_ENTERED = 'PAYMENT_INFO_ENTERED'
}

export type OrderPromotionEntry = {
  __typename: 'OrderPromotionEntry',
  promotion: Promotion,
  addedAt: Scalars['Date'],
  /** If this promotion is applied to the order. Note that there will be at most one promotion entry for a given order
   * that has this set to `true`.
 */
  applied: Scalars['Boolean'],
  /** The total discount this promotion provides to the order */
  discount: MonetaryAmount,
};

export type OrderQuery = {
  userId?: Maybe<Scalars['UserId']>,
  /** If omitted, this will default to all states except for CREATED and CART */
  states?: Maybe<Array<OrderState>>,
  fulfillmentStates?: Maybe<Array<OrderFulfillmentState>>,
  orderLineItemStates?: Maybe<Array<OrderLineItemState>>,
  /** this can be either consumerFriendlyId or order external id */
  orderId?: Maybe<Scalars['String']>,
  fulfillmentOperatorIds?: Maybe<Array<Scalars['OperatorId']>>,
  ordersWithNoFulfillmentOperatorOnly?: Maybe<Scalars['Boolean']>,
  userQuery?: Maybe<Scalars['String']>,
  facetedSearch?: Maybe<Scalars['Boolean']>,
  facets?: Maybe<Array<FacetSelection>>,
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>,
  shippingAddresseeName?: Maybe<Scalars['String']>,
  keywords?: Maybe<Scalars['String']>,
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>,
  includeUnassignedOrders?: Maybe<Scalars['Boolean']>,
};

export type OrdersConnection = {
  __typename: 'OrdersConnection',
  facets: Array<DisplayFacet>,
  edges: Array<OrdersEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export enum OrderSearchSort {
  PAID_AT = 'PAID_AT',
  CREATED_AT = 'CREATED_AT',
  EFFECTIVE_ORDER_DATE = 'EFFECTIVE_ORDER_DATE',
  EFFECTIVE_ORDER_DATE_ASC = 'EFFECTIVE_ORDER_DATE_ASC'
}

export type OrdersEdge = {
  __typename: 'OrdersEdge',
  node: Order,
  cursor: Scalars['String'],
};

export type OrderShippingCost = {
  __typename: 'OrderShippingCost',
  shippingMethodCosts: Array<ShippingMethodCost>,
};

/** Can specify either addressId, country/state, or none */
export type OrderShippingCostAddressInput = {
  addressId?: Maybe<Scalars['AddressId']>,
  country?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
};

export type OrdersPagination = {
  __typename: 'OrdersPagination',
  orders: Array<Order>,
  count: Scalars['Long'],
};

export enum OrderState {
  CART = 'CART',
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  CONSUMER_PAYMENT_PENDING = 'CONSUMER_PAYMENT_PENDING',
  CONSUMER_PAYMENT_COMPLETED = 'CONSUMER_PAYMENT_COMPLETED',
  CONSUMER_PAYMENT_FAILED = 'CONSUMER_PAYMENT_FAILED',
  CONSUMER_PAYMENT_PARTIAL = 'CONSUMER_PAYMENT_PARTIAL',
  CONSUMER_OVERPAID = 'CONSUMER_OVERPAID',
  CONSUMER_PAYMENT_REFUNDED = 'CONSUMER_PAYMENT_REFUNDED',
  CONSUMER_PAYMENT_CANCELED = 'CONSUMER_PAYMENT_CANCELED',
  SHIPPED = 'SHIPPED',
  READY = 'READY',
  RECEIVED = 'RECEIVED'
}

export type OrderSupportTask = SupportTask & {
  __typename: 'OrderSupportTask',
  id: Scalars['SupportTaskId'],
  type: SupportTaskType,
  state: SupportTaskState,
  url: Scalars['String'],
  dueAt: Scalars['Date'],
  assignedTo?: Maybe<Operator>,
  assignedAt?: Maybe<Scalars['Date']>,
  completedAt?: Maybe<Scalars['Date']>,
  consumer: User,
  note: Scalars['String'],
  order?: Maybe<Order>,
  lead?: Maybe<Lead>,
};

/** Generic pagination information. We can put things like count/total in here as well */
export type PageInfo = {
  __typename: 'PageInfo',
  hasNextPage: Scalars['Boolean'],
  hasPreviousPage: Scalars['Boolean'],
  startCursor?: Maybe<Scalars['String']>,
  endCursor?: Maybe<Scalars['String']>,
};

/** =============================
 * Path Schema, Flow, & Question
 * =============================
 */
export type PathFlow = {
  __typename: 'PathFlow',
  id: Scalars['PathFlowId'],
  /** Displayable title for the path flow; will be used to eventually derive the request name as well */
  title?: Maybe<TextViewModel>,
  /** Once the user completes the flow, this will be true and no further modifications to the flow are possible */
  completed: Scalars['Boolean'],
  /** When completed=true, this will signify the action that should be performed. */
  onComplete?: Maybe<PathFlowOnComplete>,
  /** When completed=true, there will be a generated Request from this path as well.
   * NOTE: Request schema included in this file; included separately
   * Unique slug for this path flow variant to add to the URL. .e.g.: "watches", "watches-sf", "massages", ...
 */
  slug: Scalars['String'],
  /** Styling that should be applied when rendering the path flow */
  theme: PathFlowTheme,
  /** The category this path is associated with */
  category?: Maybe<Category>,
  /** Server understands client (e.g.: react native with shipped code) - client will only recieve question types they understand
   * You'll get the sequence of static pages until you hit the first dynamic branching step. You can either
   * 1) Go through each step you have cached and as you select, submit the mutation to save and optimistically
   *    show the next screen (if you have it)
   * 2) Each mutation you do returns the updated PathFlow. You'll need to depend on this if there is a branching step
   *    (PathFlowPage.requiresServerSyncAfterSubmit=true), or you don't have the next step cached.
   * Pagination follows GraphQL Relay Connections standard; first = 1 will get you one page. after accepts the "cursor" field
   * from Edge types and will give results after that cursor.
 */
  pagesConnection: PathFlowPagesConnection,
  /** The user who created this path flow */
  createdBy?: Maybe<User>,
};


/** =============================
 * Path Schema, Flow, & Question
 * =============================
 */
export type PathFlowPagesConnectionArgs = {
  first?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>
};

export type PathFlowBySlugPayload = {
  __typename: 'PathFlowBySlugPayload',
  flow?: Maybe<PathFlow>,
};


export type PathFlowOnComplete = PathFlowOnCompleteBroadcast | PathFlowOnCompleteLead | PathFlowOnCompleteNewPath | PathFlowOnCompleteDealRequest | PathFlowOnCompleteExpertReview | PathFlowOnCompleteRedirectOnly | PathFlowOnCompleteRedirectWithUpsert | PathFlowOnCompleteExpertApplication;

/** On complete of a path flow, a conversation is generated
 * DEPRECATED: Use PathFlowOnCompleteLead
 */
export type PathFlowOnCompleteBroadcast = {
  __typename: 'PathFlowOnCompleteBroadcast',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
  /** Actual conversation that was created */
  conversation: Conversation,
};

export type PathFlowOnCompleteDealRequest = {
  __typename: 'PathFlowOnCompleteDealRequest',
  dealRequest: DealRequest,
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowOnCompleteExpertApplication = {
  __typename: 'PathFlowOnCompleteExpertApplication',
  application: ExpertApplication,
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowOnCompleteExpertReview = {
  __typename: 'PathFlowOnCompleteExpertReview',
  review: ConsumerExpertReview,
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowOnCompleteLead = {
  __typename: 'PathFlowOnCompleteLead',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
  /** The new lead that was created, or existing lead that was re-used */
  lead: Lead,
  /** Conversation for the lead */
  conversation: Conversation,
};

/** On complete of a path flow, a new path is generated that should be navigated to */
export type PathFlowOnCompleteNewPath = {
  __typename: 'PathFlowOnCompleteNewPath',
  /** New path flow that was generated that the client should navigate to and start */
  flow: PathFlow,
};

export enum PathFlowOnCompleteRedirectLocation {
  /** Reload the current page, this is used for paths that happen in-place */
  RELOAD_CURRENT_PAGE = 'RELOAD_CURRENT_PAGE',
  /** Expert profile page with selection screen. Only valid for paths completed with a lead. */
  EXPERT_PROFILE = 'EXPERT_PROFILE',
  /** Default inbox page */
  INBOX = 'INBOX',
  /** Redirect to login page */
  LOGIN = 'LOGIN',
  /** Redirect to the completion page after an application is submitted */
  APPLY_FINISH = 'APPLY_FINISH',
  /** Redirect to selected department page */
  DEPARTMENT_PAGE = 'DEPARTMENT_PAGE',
  /** Redirect to selected category page */
  CATEGORY = 'CATEGORY',
  /** For golf experiment only, a redirect that will take the user back into
   * the path system to add their phone number
 */
  PHONE_COLLECTION_PATH = 'PHONE_COLLECTION_PATH'
}

/** On complete of a path flow, the user should be navigated to the specified location.
 * This on complete type is typically used when the path flow isn't relevant, and we
 * want to direct the user to do something else (e.g.: already has an account - login).
 */
export type PathFlowOnCompleteRedirectOnly = {
  __typename: 'PathFlowOnCompleteRedirectOnly',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
};

/** This is the same as the PathFlowOnCompleteRedirectOnly, but the client needs to be able to
 * discern when a lead is coming from an upsert or just a vanilla redirect
 */
export type PathFlowOnCompleteRedirectWithUpsert = {
  __typename: 'PathFlowOnCompleteRedirectWithUpsert',
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation,
};

export type PathFlowPage = {
  __typename: 'PathFlowPage',
  id: Scalars['PathFlowPageId'],
  /** Parent PathFlow this page is a part of */
  flow: PathFlow,
  /** Additional metadata that can be used to customize behavior or rendering of this page */
  metadata: Array<PathFlowPageMetadata>,
  /** Unique identifier for this flow "type". you can pick this up from the client and do any customizations as required.
   * String may be something like: "dial_size". Not to be exposed in the ui/url, only for internal use
 */
  internalName: Scalars['String'],
  /** Display text for page */
  title?: Maybe<TextViewModel>,
  /** Top level image for page */
  titleImage?: Maybe<ImageViewModel>,
  /** Interstitial text for the page. If present, there will be no quesetions on the page. */
  interstitialText?: Maybe<TextViewModel>,
  /** Questions to display on this page. If non-empty, there will be no interstitial text */
  questions: Array<PathFlowQuestion>,
  /** Notifications to display at the top of the page (e.g.: contextual tool tip)
   * Crappy name since we'll probably deprecate this for a richer model which can use the proper "notification" name
 */
  notificationTexts: Array<TextViewModel>,
  /** Unique slug for this page within the parent path flow which should be added to the URL. .e.g.: "flexibility", "distance"
   * Note that when assembling the url, the parent path flow page slug should be used as the preceeding path component. So:
   * http://www.deal.com/request/{pathFlow.slug}/{pathFlowPage.slug}
 */
  slug: Scalars['String'],
  /** Questions from this and previous pages must be submitted before proceeding
   * This may be true due to enforced input validation. e.g.: question doesn't
   * introduce branching, but does special server side validation.
   * This also may be true due to conditional skip targets. e.g..: question does
   * introduce branching, and dynamically selects next page.
 */
  requiresServerSyncAfterSubmit: Scalars['Boolean'],
  /** How close are we to completing this flow. Will be a value from 0 to 100, inclusive
   * Note: Since flows can branch, this number is not guaranteed to progress in a linear fashion
 */
  completionPercentage: Scalars['Int'],
  /** If the user completed this page by submitting it and/or all associated questions on the page */
  completed: Scalars['Boolean'],
  /** submit button text to use when submitting a non-empty response. If empty, should fallback to client default */
  submitButtonText?: Maybe<TextViewModel>,
  /** submit button text to use when all questions are optional, and none of them are filled out. If empty, should
   * fallback to client default.
 */
  skipButtonText?: Maybe<TextViewModel>,
};


export type PathFlowPageMetadata = {
  __typename: 'PathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};

export enum PathFlowPageMetadataType {
  INTERSTITIAL = 'INTERSTITIAL',
  CUSTOM = 'CUSTOM',
  /** Below are deprecated */
  LOADING_QUESTIONS = 'LOADING_QUESTIONS',
  CONNECTING_TO_OPERATOR = 'CONNECTING_TO_OPERATOR',
  FINDING_MERCHANTS = 'FINDING_MERCHANTS',
  HIGH_SECURITY = 'HIGH_SECURITY',
  WELCOME = 'WELCOME'
}

export type PathFlowPagePayload = {
  __typename: 'PathFlowPagePayload',
  page?: Maybe<PathFlowPage>,
};

export type PathFlowPagesConnection = {
  __typename: 'PathFlowPagesConnection',
  edges: Array<PathFlowPagesEdge>,
  pageInfo?: Maybe<PageInfo>,
};

export type PathFlowPagesEdge = {
  __typename: 'PathFlowPagesEdge',
  node: PathFlowPage,
  cursor: Scalars['String'],
};

export type PathFlowPayload = {
  __typename: 'PathFlowPayload',
  flow?: Maybe<PathFlow>,
};

export type PathFlowQuestion = {
  __typename: 'PathFlowQuestion',
  /** Similar to parent's PathFlowPage.internalName, unique identifier for a question within a page.
   * String may be something like: "products.watches.dial_size.diameter"
   * Not to be exposed in the ui/url, only for internal use like customizing UI widget
 */
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  /** An icon that's placed immediately above the question input */
  inputIconImage?: Maybe<ImageViewModel>,
  /** A label that's placed immediately above the question input; should be placed after the icon if inputIconImage is present */
  inputLabel?: Maybe<TextViewModel>,
  /** All of the attributes that have been entered in the path so far */
  attributes: Array<Attribute>,
  /** Pull out a particular attribute value by name */
  attribute?: Maybe<Attribute>,
};


export type PathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export type PathFlowTheme = {
  __typename: 'PathFlowTheme',
  type: PathFlowThemeType,
};

export enum PathFlowThemeType {
  DEFAULT = 'DEFAULT',
  SNOWBOARD = 'SNOWBOARD',
  CHAT_LIKE = 'CHAT_LIKE'
}

/** Denotes an image or icon that's dynamically resolved within the client app */
export type PathImageViewModel = {
  __typename: 'PathImageViewModel',
  imagePath: Scalars['String'],
  imageUrl: Scalars['String'],
};


/** ====== Path validation errors */
export type PathValidationError = {
  __typename: 'PathValidationError',
  /** Which page the error is the associated with */
  pageName?: Maybe<Scalars['String']>,
  /** Which question on the above page the error is associated with. If this is not null, pageId will also be not null. */
  questionName?: Maybe<Scalars['String']>,
  /** Additional "tags" that act something like an error-code, except that a single message may have many tags */
  tags?: Maybe<Array<PathValidationErrorTag>>,
  /** Text describing the validation error which should be displayed to the user */
  message?: Maybe<TextViewModel>,
};

export enum PathValidationErrorTag {
  /** If this error is produced, the client must have the user login, or change the contact information being used to proceed */
  REQUIRES_LOGIN_TO_PROCEED = 'REQUIRES_LOGIN_TO_PROCEED',
  /** Indicates an internal error, typically surfaced if the API is misused, or some type of developer/administrative error. */
  INTERNAL = 'INTERNAL'
}

export type PayComponentCommissionRule = PayComponentRule & {
  __typename: 'PayComponentCommissionRule',
  type: PayComponentType,
  rate: Scalars['BigDecimal'],
};

export type PayComponentCommissionRuleInput = {
  rate: Scalars['BigDecimal'],
};

export type PayComponentCommissionSummary = PayComponentSummary & {
  __typename: 'PayComponentCommissionSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  basisAmount: MonetaryAmount,
};

export type PayComponentFirstShiftsGuaranteedRule = PayComponentRule & {
  __typename: 'PayComponentFirstShiftsGuaranteedRule',
  type: PayComponentType,
  amount: MonetaryAmount,
  shifts: Scalars['Int'],
};

export type PayComponentFirstShiftsGuaranteedRuleInput = {
  amount: MonetaryAmountInput,
  shifts: Scalars['Int'],
};

export type PayComponentFirstShiftsGuaranteedSummary = PayComponentSummary & {
  __typename: 'PayComponentFirstShiftsGuaranteedSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentHourlyOnCallRule = PayComponentRule & {
  __typename: 'PayComponentHourlyOnCallRule',
  type: PayComponentType,
  hourlyPayAmount: MonetaryAmount,
};

export type PayComponentHourlyOnCallRuleInput = {
  hourlyPayAmount: MonetaryAmountInput,
};

export type PayComponentHourlyOnCallSummary = PayComponentSummary & {
  __typename: 'PayComponentHourlyOnCallSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  minutes: Scalars['Int'],
};

export type PayComponentManualAdjustmentSummary = PayComponentSummary & {
  __typename: 'PayComponentManualAdjustmentSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentQualityConversationRule = PayComponentRule & {
  __typename: 'PayComponentQualityConversationRule',
  type: PayComponentType,
  amountPerConversation: MonetaryAmount,
};

export type PayComponentQualityConversationRuleInput = {
  amountPerConversation: MonetaryAmountInput,
};

export type PayComponentQualityConversationSummary = PayComponentSummary & {
  __typename: 'PayComponentQualityConversationSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentRule = {
  __typename: 'PayComponentRule',
  type: PayComponentType,
};

export type PayComponentRuleInput = {
  commission?: Maybe<PayComponentCommissionRuleInput>,
  tip?: Maybe<PayComponentTipRuleInput>,
  hourlyOnCall?: Maybe<PayComponentHourlyOnCallRuleInput>,
  shiftsGuaranteed?: Maybe<PayComponentFirstShiftsGuaranteedRuleInput>,
  qualityConversation?: Maybe<PayComponentQualityConversationRuleInput>,
  type: PayComponentType,
};

export type PayComponentSummary = {
  __typename: 'PayComponentSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export type PayComponentTipRule = PayComponentRule & {
  __typename: 'PayComponentTipRule',
  type: PayComponentType,
};

export type PayComponentTipRuleInput = {
  enabled: Scalars['Boolean'],
};

export type PayComponentTipSummary = PayComponentSummary & {
  __typename: 'PayComponentTipSummary',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
};

export enum PayComponentType {
  COMMISSION = 'COMMISSION',
  QUALITY_CONVERSATION = 'QUALITY_CONVERSATION',
  TIP = 'TIP',
  FIRST_SHIFTS_GUARANTEED_PAY = 'FIRST_SHIFTS_GUARANTEED_PAY',
  HOURLY_ON_CALL = 'HOURLY_ON_CALL',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT'
}

export type PayForOrderInput = {
  orderId: Scalars['OrderId'],
  chargeInfos: Array<ChargeInfoInput>,
};

export type PayForOrderPayload = {
  __typename: 'PayForOrderPayload',
  order?: Maybe<Order>,
  /** string explaining reason for failure if any */
  error?: Maybe<Scalars['String']>,
};

export type PayLineItem = {
  __typename: 'PayLineItem',
  id: Scalars['PayLineItemId'],
  postedAt: Scalars['Date'],
  payStructureRevision?: Maybe<PayStructureRevision>,
  payee: BusinessUser,
  payout: Payout,
  source: PayLineItemSource,
  notes?: Maybe<Scalars['String']>,
};

export type PayLineItemCommissionSource = PayLineItemSource & {
  __typename: 'PayLineItemCommissionSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  orderId: Scalars['OrderId'],
  basisAmount: MonetaryAmount,
  contributionPercent: Scalars['Int'],
  rule: PayComponentCommissionRule,
  order: Order,
};

export type PayLineItemFirstShiftsGuaranteedSource = PayLineItemSource & {
  __typename: 'PayLineItemFirstShiftsGuaranteedSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  rule: PayComponentFirstShiftsGuaranteedRule,
};

export type PayLineItemHourlyOnCallSource = PayLineItemSource & {
  __typename: 'PayLineItemHourlyOnCallSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  durationInMinutes: Scalars['Int'],
  rule: PayComponentHourlyOnCallRule,
};


export type PayLineItemManualAdjustmentSource = PayLineItemSource & {
  __typename: 'PayLineItemManualAdjustmentSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
};

export type PayLineItemQualityConversationSource = PayLineItemSource & {
  __typename: 'PayLineItemQualityConversationSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  rule: PayComponentQualityConversationRule,
  leadId: Scalars['LeadId'],
  lead: Lead,
};

export enum PayLineItemSortField {
  PAY_COMPONENT_TYPE = 'PAY_COMPONENT_TYPE',
  POSTED_AT = 'POSTED_AT',
  AMOUNT = 'AMOUNT'
}

export type PayLineItemSortInput = {
  field: PayLineItemSortField,
  ascending: Scalars['Boolean'],
};

export type PayLineItemSource = {
  __typename: 'PayLineItemSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
};

export type PayLineItemsPagination = {
  __typename: 'PayLineItemsPagination',
  count: Scalars['Long'],
  lineItems: Array<PayLineItem>,
};

export type PayLineItemTipSource = PayLineItemSource & {
  __typename: 'PayLineItemTipSource',
  type: PayComponentType,
  payAmount: MonetaryAmount,
  rule: PayComponentTipRule,
  orderId: Scalars['OrderId'],
  order: Order,
};

export type Payment3DSecure = PaymentEntity & {
  __typename: 'Payment3DSecure',
  paymentMethod: PaymentMethod,
  threeDSecureSourceId: Scalars['String'],
  authenticated: Scalars['Boolean'],
};

export enum PaymentActivityType {
  FULL_PAYMENT = 'FULL_PAYMENT',
  DEPOSIT = 'DEPOSIT',
  REMAINING_BALANCE = 'REMAINING_BALANCE'
}

/** Only saving minimal non PII information to avoid PCI compliance
 * https://www.pcisecuritystandards.org/pdfs/pci_fs_data_storage.pdf
 */
export type PaymentCard = PaymentEntity & {
  __typename: 'PaymentCard',
  paymentMethod: PaymentMethod,
  last4: Scalars['String'],
  /** Ex: Visa, Mastercard etc */
  brand?: Maybe<Scalars['String']>,
  /** 2 digit number representing the card’s expiration month. */
  expiryMonth?: Maybe<Scalars['Int']>,
  /** 4 digit number representing the card’s expiration year. */
  expiryYear?: Maybe<Scalars['Int']>,
  addressZipCheckStatus?: Maybe<CardFieldValidationStatus>,
  cvcCheckStatus?: Maybe<CardFieldValidationStatus>,
  cardFundingType?: Maybe<CardFundingType>,
  country?: Maybe<Scalars['String']>,
  threeDSecureVerificationRequired?: Maybe<Scalars['Boolean']>,
  threeDSecureVerification?: Maybe<ThreeDSecureVerification>,
};

/** The payment entity represents the asset associated the payment method used for the transaction */
export type PaymentEntity = {
  __typename: 'PaymentEntity',
  paymentMethod: PaymentMethod,
};

export enum PaymentMethod {
  CARD = 'CARD',
  PAYPAL = 'PAYPAL',
  THREE_D_SECURE = 'THREE_D_SECURE',
  APPLE_PAY = 'APPLE_PAY',
  ANDROID_PAY = 'ANDROID_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAY_BY_INSTALLMENT = 'PAY_BY_INSTALLMENT',
  WIRE_TRANSFER = 'WIRE_TRANSFER'
}

export type PaymentProcessorAccount = {
  __typename: 'PaymentProcessorAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt?: Maybe<Scalars['Date']>,
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources?: Maybe<Array<PaymentSource>>,
  externalAccountId: Scalars['String'],
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};


export enum PaymentProcessorType {
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL',
  AFTERPAY = 'AFTERPAY',
  AFFIRM = 'AFFIRM'
}

export type PaymentRedirectUrls = {
  /** Url Path without the scheme and domain where the payer will be redirected to after approving the payment */
  paymentApprovedReturnUrlPath: Scalars['String'],
  /** Url Path without the scheme and domain where the payer will be redirected to after canceling the payment */
  paymentCanceledReturnUrlPath: Scalars['String'],
};

/** Abstraction for payment sources like Stripe, Paypal, ACH etc. */
export type PaymentSource = {
  __typename: 'PaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt?: Maybe<Scalars['Date']>,
  updatedAt?: Maybe<Scalars['Date']>,
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
};


export enum PaymentSourceStatus {
  /** indicates the source is archived, for ex: on expiry, account closure, deleting previously saved card */
  ARCHIVED = 'ARCHIVED',
  CANCELED = 'CANCELED',
  /** Only chargeable Source can be used to create a charge */
  CHARGEABLE = 'CHARGEABLE',
  /** This indicates an older Source that is now detached from the user. */
  CONSUMED = 'CONSUMED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

/** Whether this source should be reusable or not. Some source types may or may not be reusable by construction,
 * while other may leave the option at creation. If an incompatible value is passed, an error will be returned.
 */
export enum PaymentSourceUsage {
  REUSABLE = 'REUSABLE',
  SINGLE_USE = 'SINGLE_USE'
}

export type Payout = {
  __typename: 'Payout',
  id: Scalars['PayoutId'],
  state: PayoutState,
  period: PayPeriod,
  payee: BusinessUser,
  department: Department,
  totalAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  components: Array<PayComponentSummary>,
  lastComputedAt?: Maybe<Scalars['Date']>,
};

export type PayoutFilters = {
  state?: Maybe<PayoutState>,
  expertId?: Maybe<Scalars['BusinessUserId']>,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  payDate?: Maybe<Scalars['Date']>,
};


export type PayoutRollupSummary = {
  __typename: 'PayoutRollupSummary',
  payoutCount: Scalars['Int'],
  totalAmount: MonetaryAmount,
  lineCount: Scalars['Int'],
  components: Array<PayComponentSummary>,
};

export enum PayoutSortField {
  POSTED_AT = 'POSTED_AT',
  TOTAL_AMOUNT = 'TOTAL_AMOUNT',
  COMMISSION_AMOUNT = 'COMMISSION_AMOUNT',
  QUALITY_CONVERSATION_AMOUNT = 'QUALITY_CONVERSATION_AMOUNT',
  TIP_AMOUNT = 'TIP_AMOUNT',
  FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT = 'FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT',
  HOURLY_ON_CALL_AMOUNT = 'HOURLY_ON_CALL_AMOUNT',
  MANUAL_ADJUSTMENT_AMOUNT = 'MANUAL_ADJUSTMENT_AMOUNT'
}

export type PayoutSortInput = {
  field: PayoutSortField,
  ascending: Scalars['Boolean'],
};

export type PayoutsPagination = {
  __typename: 'PayoutsPagination',
  payouts: Array<Payout>,
  rollupSummary: PayoutRollupSummary,
};

export enum PayoutState {
  CREATED = 'CREATED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  PAID = 'PAID',
  ARCHIVED = 'ARCHIVED'
}

export type PaypalAccount = PaymentProcessorAccount & {
  __typename: 'PaypalAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt?: Maybe<Scalars['Date']>,
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources?: Maybe<Array<PaymentSource>>,
  externalAccountId: Scalars['String'],
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type PaypalPaymentEntity = PaymentEntity & {
  __typename: 'PaypalPaymentEntity',
  paymentMethod: PaymentMethod,
  payerId: Scalars['String'],
};

export type PaypalPaymentSource = PaymentSource & {
  __typename: 'PaypalPaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt?: Maybe<Scalars['Date']>,
  updatedAt?: Maybe<Scalars['Date']>,
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
  /** PayPal specific attributes */
  paymentId: Scalars['String'],
};

export type PayPeriod = {
  __typename: 'PayPeriod',
  startInclusive: Scalars['Date'],
  endInclusive: Scalars['Date'],
};

export type PayStructure = {
  __typename: 'PayStructure',
  id: Scalars['PayStructureId'],
  department: Department,
  name: Scalars['String'],
  description: Scalars['String'],
  isDefault: Scalars['Boolean'],
  revisions: Array<PayStructureRevision>,
};

export type PayStructureFilters = {
  name?: Maybe<Scalars['String']>,
  departmentId?: Maybe<Scalars['DepartmentId']>,
  defaultOnly?: Maybe<Scalars['Boolean']>,
};


export type PayStructureRevision = {
  __typename: 'PayStructureRevision',
  id: Scalars['PayStructureRevisionId'],
  payStructure: PayStructure,
  createdAt: Scalars['Date'],
  effectiveAt?: Maybe<Scalars['Date']>,
  state: PayStructureRevisionState,
  components: Array<PayComponentRule>,
};


export enum PayStructureRevisionState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DEACTIVATED = 'DEACTIVATED'
}

export type PayStructuresPagination = {
  __typename: 'PayStructuresPagination',
  payStructures: Array<PayStructure>,
  count: Scalars['Long'],
};

export type PendingAccessContact = {
  __typename: 'PendingAccessContact',
  id: Scalars['PendingAccessContactId'],
  contact: Contact,
  interest: Scalars['String'],
  verificationUrl: Scalars['String'],
  user?: Maybe<User>,
};


/** Percent off individual line items that meet the `Promotion.rules` criteria */
export type PercentOffLineItemsPromotionActionReference = PromotionActionReference & {
  __typename: 'PercentOffLineItemsPromotionActionReference',
  id: Scalars['PromotionActionReferenceId'],
  type: PromotionActionType,
  /** Between 1 and 100 */
  percentOff: Scalars['Int'],
};

/** See `PercentOffLineItemsPromotionActionReference` for documentation */
export type PercentOffLineItemsPromotionActionReferenceInput = {
  /** percent off, between 1 and 100 */
  percentOff: Scalars['Int'],
};

/** =============
 * this is used in biz-app, we should migrate to BusinessUserPermission
 * =============
 */
export enum Permission {
  UI_OVERWRITE_SELLABLE_PRICE = 'UI_OVERWRITE_SELLABLE_PRICE',
  UI_ON_CALL_EXPERT = 'UI_ON_CALL_EXPERT',
  UI_ACCEPT_NEW_LEAD = 'UI_ACCEPT_NEW_LEAD'
}

export type PersistMediaInput = {
  id: Scalars['MediaId'],
};

export type PersistMediaPayload = {
  __typename: 'PersistMediaPayload',
  mediaFile?: Maybe<MediaFile>,
};

export type PhoneCallSummary = {
  __typename: 'PhoneCallSummary',
  consumerLastCalledAt?: Maybe<Scalars['Date']>,
  consumerCallCount: Scalars['Int'],
};

export type PhoneExplanationModalMetadata = PathFlowPageMetadata & {
  __typename: 'PhoneExplanationModalMetadata',
  type: PathFlowPageMetadataType,
};

export type PiplAddress = {
  __typename: 'PiplAddress',
  streetNumber?: Maybe<Scalars['String']>,
  apartment?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  zipCode?: Maybe<Scalars['String']>,
  postOfficeBox?: Maybe<Scalars['String']>,
};

export type PiplEducation = {
  __typename: 'PiplEducation',
  degree?: Maybe<Scalars['String']>,
  school?: Maybe<Scalars['String']>,
  duration?: Maybe<DateRange>,
};

export type PiplName = {
  __typename: 'PiplName',
  firstName?: Maybe<Scalars['String']>,
  middleName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  suffix?: Maybe<Scalars['String']>,
  prefix?: Maybe<Scalars['String']>,
  fullName?: Maybe<Scalars['String']>,
};

export type PiplPosition = {
  __typename: 'PiplPosition',
  title?: Maybe<Scalars['String']>,
  company?: Maybe<Scalars['String']>,
  industry?: Maybe<Scalars['String']>,
  duration?: Maybe<DateRange>,
};

export type PiplProfile = ExternalProfile & {
  __typename: 'PiplProfile',
  id: Scalars['String'],
  type: ExternalProfileType,
  names: Array<PiplName>,
  emails: Array<Scalars['String']>,
  phoneNumbers: Array<Scalars['String']>,
  gender?: Maybe<Scalars['String']>,
  addresses: Array<PiplAddress>,
  links: Array<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  dateOfBirth?: Maybe<DateRange>,
  positions: Array<PiplPosition>,
  educations: Array<PiplEducation>,
};

export type PixelFiredEvent = {
  __typename: 'PixelFiredEvent',
  adPlatform: Scalars['String'],
  firedAt: Scalars['Date'],
};

export type PlaceOrderForOfferInput = {
  offerId: Scalars['BroadcastOfferId'],
  chargeInfos: Array<ChargeInfoInput>,
  tip?: Maybe<MonetaryAmountInput>,
  shippingAddress?: Maybe<AddressInput>,
  /** @deprecated moved to ChargeInfoInput */
  billingAddress?: Maybe<AddressInput>,
  serviceConfirmedTime?: Maybe<Scalars['Date']>,
};

export type PlaceOrderForOfferPayload = {
  __typename: 'PlaceOrderForOfferPayload',
  offer?: Maybe<BroadcastOffer>,
  /** string explaining reason for failure if any */
  error?: Maybe<Scalars['String']>,
};

export type PopularExpertCuratedItem = {
  __typename: 'PopularExpertCuratedItem',
  sellable: Sellable,
  recommendedForSellable: Sellable,
  category: Category,
  timesRecommended?: Maybe<Scalars['Int']>,
  popularTag?: Maybe<ExpertCuratedItemTag>,
};

export type PopularExpertCuratedItemConnection = {
  __typename: 'PopularExpertCuratedItemConnection',
  edges: Array<PopularExpertCuratedItemEdge>,
  pageInfo: PageInfo,
};

export type PopularExpertCuratedItemEdge = {
  __typename: 'PopularExpertCuratedItemEdge',
  node: PopularExpertCuratedItem,
  cursor: Scalars['String'],
};

export type PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  expertCuratedItem: ExpertCuratedItem,
  dealRequest: DealRequest,
};

export type PopularExpertCuratedItemQueryInput = {
  /** @deprecated use sellableIds */
  sellableId?: Maybe<Scalars['SellableId']>,
  /** TODO: Make sellableIds required after deprecating sellableId */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  includeCuratedItemTag?: Maybe<Scalars['Boolean']>,
};

/** PostalAddress was used for embedding address data in the User and Merchant objects but unless absolutely needed
 * prefer the Address object, which allows reusability
 */
export type PostalAddress = AddressFields & {
  __typename: 'PostalAddress',
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  countryDetails?: Maybe<Country>,
  postalCode: Scalars['String'],
  phoneNumber?: Maybe<Scalars['String']>,
  displayTitle?: Maybe<Scalars['String']>,
};


/** PostalAddress was used for embedding address data in the User and Merchant objects but unless absolutely needed
 * prefer the Address object, which allows reusability
 */
export type PostalAddressDisplayTitleArgs = {
  displayType: PostalAddressLocationDisplayType
};

export type PostalAddressInput = {
  addresseeName?: Maybe<Scalars['String']>,
  businessName?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country: Scalars['String'],
  postalCode: Scalars['String'],
  phoneNumber?: Maybe<Scalars['String']>,
};

export enum PostalAddressLocationDisplayType {
  CITY_STATE = 'CITY_STATE'
}

export type PostCartOrderActivity = {
  __typename: 'PostCartOrderActivity',
  id: Scalars['PostCartOrderActivityId'],
  updatedAt: Scalars['Date'],
  createdAt: Scalars['Date'],
  orderId: Scalars['OrderId'],
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>,
  occurredAt: Scalars['Date'],
  detail: OrderActivityDetail,
};


export type PredictedLifeTimeValue = {
  __typename: 'PredictedLifeTimeValue',
  id: Scalars['PredictedLifeTimeValueId'],
  userId: Scalars['UserId'],
  ltvType: LtvType,
  pLTV: MonetaryAmount,
  pixelFiredEvents: Array<PixelFiredEvent>,
};


export enum PresenceStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SMS = 'SMS'
}

export enum ProductCondition {
  NEW = 'NEW',
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  FAIR = 'FAIR'
}

export type ProductDealTerms = {
  __typename: 'ProductDealTerms',
  type: DealTermsType,
  condition: ProductCondition,
  returnPolicy: ReturnPolicy,
  shippingPolicy: ShippingPolicy,
  pickupAvailable: Scalars['Boolean'],
};

export type ProductOfferTerms = {
  __typename: 'ProductOfferTerms',
  condition: ProductCondition,
  shippingCost?: Maybe<Money>,
  returnPolicy?: Maybe<ReturnPolicy>,
  shippingAvailable: Scalars['Boolean'],
  pickupAvailable: Scalars['Boolean'],
};

export type ProductOfferTermsInput = {
  condition: ProductCondition,
  shippingCost?: Maybe<Scalars['Float']>,
  shippingAvailable: Scalars['Boolean'],
  pickupAvailable: Scalars['Boolean'],
  returnPolicyType?: Maybe<ReturnPolicyType>,
  refundMethod?: Maybe<ReturnRefundMethod>,
  returnWithinDays?: Maybe<Scalars['Int']>,
  returnShippingPaidBy?: Maybe<ReturnShippingPaidBy>,
};

export type ProfileHighlight = {
  __typename: 'ProfileHighlight',
  type: ProfileHighlightType,
  value: Scalars['String'],
  secondaryValue: Scalars['String'],
};

export enum ProfileHighlightIconType {
  BEER = 'BEER',
  CAKE = 'CAKE',
  CALENDAR = 'CALENDAR',
  CHAT = 'CHAT',
  CHECK = 'CHECK',
  COCKTAIL = 'COCKTAIL',
  DRINK = 'DRINK',
  GOLF_CLUB = 'GOLF_CLUB',
  GOLF_CLUB_SET = 'GOLF_CLUB_SET',
  GOLF_COURSE = 'GOLF_COURSE',
  HEART = 'HEART',
  LOCATION = 'LOCATION',
  DIPLOMA = 'DIPLOMA',
  SKIER = 'SKIER',
  SNOWBOARDER = 'SNOWBOARDER',
  MOUNTAIN = 'MOUNTAIN',
  SNOWFLAKE = 'SNOWFLAKE',
  SMILE = 'SMILE',
  STAR = 'STAR'
}

export type ProfileHighlightInput = {
  typeId: Scalars['ProfileHighlightTypeId'],
  value: Scalars['String'],
  secondaryValue?: Maybe<Scalars['String']>,
};

export enum ProfileHighlightSource {
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export type ProfileHighlightType = {
  __typename: 'ProfileHighlightType',
  id: Scalars['ProfileHighlightTypeId'],
  displayName: Scalars['String'],
  icon: ProfileHighlightIconType,
  source: ProfileHighlightSource,
  valueType: ProfileHighlightValueType,
  enumerationValues?: Maybe<Array<Scalars['String']>>,
  placeHolderForValue?: Maybe<Scalars['String']>,
  placeHolderForSecondaryValue?: Maybe<Scalars['String']>,
  secondaryValueRequired: Scalars['Boolean'],
};


export enum ProfileHighlightValueType {
  TEXT = 'TEXT',
  ENUMERATION = 'ENUMERATION',
  DATE = 'DATE'
}

export type Promotion = {
  __typename: 'Promotion',
  id: Scalars['PromotionId'],
  createdAt: Scalars['Date'],
  createdBy: PromotionCreator,
  /** The time at which the promotion entered `ACTIVE` state */
  activatedAt?: Maybe<Scalars['Date']>,
  /** Promotion the operator copied to create this promotion, if any */
  copiedFrom?: Maybe<Promotion>,
  /** If `state==DISABLED`, information about why/when/who. */
  disabled?: Maybe<PromotionDisabled>,
  /** De-normalized flag, the same as `state==ACTIVE` */
  active: Scalars['Boolean'],
  state: PromotionState,
  /** Promotion code used by consumers to expectedReference the promotion.
   * There is a unique constraint where there can only be one active promotion that uses this code. Many disabled
   * promotions can expectedReference this code (can be viewed as a log of promotion history).
   * While this code is stored and displayed as case sensitive, searching for this code, as well as the unique index
   * for active promotion codes, are both **case insensitive**. So while this can store and display case sensitive
   * values like "BigGolfSale", searching for "biggolfsale" or "BIGGOLFSALE" will locate the same document, and
   * similarly, multiple active codes that only vary by case are not allowed.
 */
  code: Scalars['String'],
  /** Description of this promotion */
  description: Scalars['String'],
  /** Rules run in sequence, filtering down line items in the order that are eligible for the promotion. For example,
   * the 3 rules:
   * - Line item amount over $500
   * - Sellables in Golf category
   * - Line item amount over $100
   * Means, apply the promotion if the order has over $500 of value, and has sellables in the golf category, and those
   * sellables in the golf category are worth at least $100.
   * If all rules are evaluated and all line items are filtered out, the promotion will not be applied to the order.
 */
  rules: Array<PromotionRuleReference>,
  /** Actions to the remaining line items that aren't filtered. These are processed in order, using the result of the
   * previous promotion. For example, if there's a 5% off action, and then a 10% off action, the 5% will be taken off,
   * and then the 10% will be computed from the 5% off amount - not the original total.
 */
  actions: Array<PromotionActionReference>,
  /** If set, this promotion will be automatically disabled when usages meet or exceeds this limit. */
  usageLimit?: Maybe<Scalars['Int']>,
  /** The amount of paid orders that had this promotion code applied */
  usages: Scalars['Int'],
  /** If set, the date this promotion will disable its self */
  expiresAt?: Maybe<Scalars['Date']>,
  /** Indicates this is a template promotion that is used to create other promotions. */
  template: Scalars['Boolean'],
  /** Indicates this promotion is automatically generated, typically from a template, and not manually created. */
  autoGenerated: Scalars['Boolean'],
};

export type PromotionActionReference = {
  __typename: 'PromotionActionReference',
  id: Scalars['PromotionActionReferenceId'],
  type: PromotionActionType,
};


/** Exploded union of `PromotionActionReference` types; exactly one must be non null */
export type PromotionActionReferenceInput = {
  percentOffLineItems?: Maybe<PercentOffLineItemsPromotionActionReferenceInput>,
  amountOffOrder?: Maybe<AmountOffOrderPromotionActionReferenceInput>,
};

export enum PromotionActionType {
  PERCENT_OFF_LINE_ITEMS = 'PERCENT_OFF_LINE_ITEMS',
  AMOUNT_OFF_ORDER = 'AMOUNT_OFF_ORDER'
}

export type PromotionCreator = Operator | User;

export type PromotionDisabled = {
  __typename: 'PromotionDisabled',
  /** If null, disabled by the system (will be the case for expired and reached usage limit) */
  by?: Maybe<Operator>,
  at: Scalars['Date'],
  reason: PromotionDisabledReason,
};

export enum PromotionDisabledReason {
  MANUAL = 'MANUAL',
  REPLACED = 'REPLACED',
  EXPIRED = 'EXPIRED',
  REACHED_USAGE_LIMIT = 'REACHED_USAGE_LIMIT'
}

export type PromotionEdge = {
  __typename: 'PromotionEdge',
  node: Promotion,
  cursor: Scalars['String'],
};


export enum PromotionQueryFlagType {
  /** Surface items including items with this flag set */
  INCLUDE = 'INCLUDE',
  /** Only surface items with this flag set */
  ONLY = 'ONLY',
  /** Exclude items with this flag set */
  NONE = 'NONE'
}

export type PromotionQueryInput = {
  createdById?: Maybe<Scalars['AnyId']>,
  /** Defaults to `[ACTIVE]` */
  states?: Maybe<Array<PromotionState>>,
  /** Case insensitive search for a specific promotion code.
   * If `states=[ACTIVE]` (the default), this will return exactly 0 or 1 entries since there can be at most 1 active
   * promotion for a given code. If searching disabled or draft, you'll also retrieve the previous promotions that used
   * this same code.
 */
  promotionCode?: Maybe<Scalars['String']>,
  /** Defaults to `INCLUDE` */
  template?: Maybe<PromotionQueryFlagType>,
  /** Defaults to `NONE` */
  autoGenerated?: Maybe<PromotionQueryFlagType>,
};

export enum PromotionRuleComparisonOperator {
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  EQUAL = 'EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL'
}

export enum PromotionRuleFilterStrategy {
  /** Filtering reduces the scope of the promotion actions. For example, if the rule is to `FILTER` for sellables in
   * the snowboard category, a subsequent promotion action to take 10% off will only take 10% off of the sellables
   * in the snowboard category - not other items in the cart. If no line items fall into the filter criteria, the
   * promotion will not be applied to the order.
 */
  FILTER = 'FILTER',
  /** Excluding forces the promotion to not be the order if any of its criteria are met. For example, if the rule is
   * to `EXCLUDE` sellable X, any order with sellable X will not be eligible for the promotion.
 */
  EXCLUDE = 'EXCLUDE'
}

export type PromotionRuleReference = {
  __typename: 'PromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
};


/** Exploded union of `PromotionRuleReference` types; exactly one must be non null
 * See `PromotionRuleReference` sub-types for documentation
 */
export type PromotionRuleReferenceInput = {
  orderAmount?: Maybe<OrderAmountPromotionRuleReferenceInput>,
  sellableFilter?: Maybe<SellableFilterPromotionRuleReferenceInput>,
  sellableCategoryFilter?: Maybe<SellableCategoryFilterPromotionRuleReferenceInput>,
  sellableBrandFilter?: Maybe<SellableBrandFilterPromotionRuleReferenceInput>,
  sellableAttributeFilter?: Maybe<SellableAttributeFilterPromotionRuleReferenceInput>,
  purchaseOrderCount?: Maybe<PurchasedOrderCountPromotionRuleReferenceInput>,
  userUsageLimit?: Maybe<UserUsageLimitPromotionRuleReferenceInput>,
};

export enum PromotionRuleType {
  ORDER_AMOUNT = 'ORDER_AMOUNT',
  SELLABLE_FILTER = 'SELLABLE_FILTER',
  SELLABLE_CATEGORY_FILTER = 'SELLABLE_CATEGORY_FILTER',
  SELLABLE_BRAND_FILTER = 'SELLABLE_BRAND_FILTER',
  SELLABLE_ATTRIBUTE_FILTER = 'SELLABLE_ATTRIBUTE_FILTER',
  PURCHASED_ORDER_COUNT = 'PURCHASED_ORDER_COUNT',
  USER_USAGE_LIMIT = 'USER_USAGE_LIMIT'
}

export type PromotionsConnection = {
  __typename: 'PromotionsConnection',
  edges: Array<PromotionEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export enum PromotionState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED'
}

export type PublishTriggerInput = {
  triggerId: Scalars['TriggerId'],
};

export type PublishTriggerPayload = {
  __typename: 'PublishTriggerPayload',
  errors: Array<Scalars['String']>,
  trigger: Trigger,
};

/** Compare against the total amount of purchased orders made by the user */
export type PurchasedOrderCountPromotionRuleReference = PromotionRuleReference & {
  __typename: 'PurchasedOrderCountPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  operator: PromotionRuleComparisonOperator,
  /** Right hand side amount, in respect to `operator`. Left hand side is the purchase count. */
  rightOperandCount: Scalars['Int'],
};

/** See `PurchasedOrderCountPromotionRuleReference` for documentation */
export type PurchasedOrderCountPromotionRuleReferenceInput = {
  operator: PromotionRuleComparisonOperator,
  rightOperandCount: Scalars['Int'],
};

export type PushNotificationTemplate = ChannelTemplate & {
  __typename: 'PushNotificationTemplate',
  channelType: ChannelType,
  title: Scalars['String'],
  body: Scalars['String'],
};

export type PushNotificationTemplateInput = {
  title: Scalars['String'],
  body: Scalars['String'],
};

export type QualityConversationEstablishedActivity = LeadActivity & {
  __typename: 'QualityConversationEstablishedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
};

export type Query = {
  __typename: 'Query',
  health: Scalars['String'],
  savedAddresses: Array<Address>,
  /** categoryIds: Retrieve attributes associated with these categories
   * entityType: Entity type of typed urn we want attribute data for. This influences what types of validations are provided.
   * includeChildCategories: If true, attributes associated with sub-categories of categoryIds are also retrieved. For
   *   example, if the "Services" category is specified, this would also return attributes for specific services like
   *   massage and nails.
   * includeParentCategories: If true, attributes associated with super-categories of categoryIds are also retrieved.
   *   For example, if the "Massages" is specified, this would also return attributes bound to the general "Services"
   *   attribute.
   * first: Retrieve the first N categories in the filter criteria. See Relay Connection spec for more information.
   * after: Retrieve categories after a AttributeSchemasByCategoryEdge.cursor value. Used for pagination.
   *   See Relay Connection spec for more information.
 */
  attributeSchemasByCategories?: Maybe<AttributeSchemasByCategoriesConnection>,
  /** Retrieve attribute schemas by name */
  attributeSchemasByName: Array<AttributeSchema>,
  session: Session,
  maskedHandle: MaskedUserHandle,
  maskedHandlesByLoginToken: Array<MaskedUserHandle>,
  /** categoryTypes: Retrieve categories only under these master category types
   * first: Retrieve the first N categories in the filter criteria. See Relay Connection spec for more information.
   * after: Retrieve categories after a AttributeSchemasByCategoryEdge.cursor value. Used for pagination.
   *   See Relay Connection spec for more information.
 */
  categories: CategoriesConnection,
  topLevelCategories: Array<Category>,
  category: Category,
  categoryBySlug?: Maybe<Category>,
  allPathCategories: Array<Category>,
  /** Finds the first category in the hierarchy tree of the Category identified by specified slug, if present.
   * The category tree is traversed parents first and then children
 */
  departments: Array<Department>,
  departmentsForNavigation: Array<Department>,
  department: Department,
  departmentBySlug?: Maybe<Department>,
  commTemplate: MultiLocaleTemplateSet,
  commTemplates: Array<MultiLocaleTemplateSet>,
  commTemplateTypes?: Maybe<Array<CommTemplateType>>,
  commTemplateType: CommTemplateType,
  renderCommTemplate: RenderCommTemplatePayload,
  commTemplateDataModel: CommTemplateDataModelPayload,
  commTemplateFragment: CommTemplateFragment,
  commTemplateFragments: Array<CommTemplateFragment>,
  dealRequest?: Maybe<DealRequest>,
  findDealRequests: Array<DealRequest>,
  me?: Maybe<Myself>,
  findContact?: Maybe<Contact>,
  user: User,
  userByContact?: Maybe<User>,
  usersByContact: Array<User>,
  merchant: Merchant,
  suggestMerchants: MerchantSuggestionResult,
  searchMerchants: MerchantSearchResult,
  searchUsers: UserSearchResult,
  operators: Array<Operator>,
  pendingAccessContact: PendingAccessContact,
  businessUser: BusinessUser,
  businessUsers: Array<Maybe<BusinessUser>>,
  experts: Array<BusinessUser>,
  businessAccount: BusinessAccount,
  businessAccounts: Array<BusinessAccount>,
  businessUserTeam: BusinessUserTeam,
  devTools?: Maybe<DevTools>,
  conversation: Conversation,
  conversationByExternalId?: Maybe<Conversation>,
  activeVideoChatConversations: Array<Conversation>,
  messagingUsers: Array<MessagingUser>,
  callActivityConnection: CallActivityConnection,
  guestConversationSequence: GuestConversationSequence,
  findGuestConversationSequences: Array<GuestConversationSequence>,
  pathFlow: PathFlowPayload,
  pathFlowPage: PathFlowPagePayload,
  pathFlowBySlug: PathFlowBySlugPayload,
  pathFlowPageBySlugs: PathFlowPagePayload,
  shippingCarriers: Array<ShippingCarrier>,
  paymentSources: Array<Maybe<PaymentSource>>,
  order: Order,
  orderLineItem: OrderLineItem,
  transaction: Transaction,
  findOrders: Array<Order>,
  ordersConnection: OrdersConnection,
  ordersPagination: OrdersPagination,
  paymentSource: PaymentSource,
  reusablePaymentSources: Array<PaymentSource>,
  /** If this returns an empty array, it means the recommendation is to not prompt the user to tip since we weren't able
   * to locate a relevant expert that aided the owner of the order. If more than one `ExpertTipPercentage` is returned,
   * it's guaranteed that all `ExpertTipPercentage.percentOfTip` add up to 100. The user can be shown all of the experts
   * returned by this API.
   * Ultimately, the result of this is intended to be used as an input to the `addTipToOrder` mutation. Users of this API
   * are free to modify the percent distribution, or even select different experts for tip distribution.
 */
  recommendTipPercentagesForOrder: Array<ExpertTipPercentage>,
  promotion: Promotion,
  promotionsConnection: PromotionsConnection,
  /** Case insensitive search for a active promotion with promotion code `code`.
   * Convienence API that's equivalent to querying `promotionsConnection` for `state=[ACTIVE]` and this `code`
 */
  activePromotionByCode?: Maybe<Promotion>,
  /** Get all shipping costs for a given order. A custom address can be specified to compute shipping cost via
   * `orderShippingCostAddress`, or it can be omitted to compute all shipping cost options for the current order shipping
   * address. A `null` return value means the order doesn't require any shipping.
 */
  orderShippingCost?: Maybe<OrderShippingCost>,
  tags: Array<Tag>,
  frontendTask: FrontendTask,
  broadcastOffer: BroadcastOffer,
  mediaFile: MediaFile,
  mediaFiles: Array<MediaFile>,
  openGraphData?: Maybe<OpenGraphData>,
  findExpert?: Maybe<BusinessUser>,
  expertProfile: ExpertProfile,
  recommendExpert?: Maybe<BusinessUser>,
  recommendExpert2: RecommendExpertPayload,
  recommendExpertForRequest: RecommendExpertPayload,
  recommendExpertsForPathFlow: Array<RecommendedExpert>,
  recommendExpertsForDepartment: Array<RecommendedExpert>,
  consumerExpertReview: ConsumerExpertReview,
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  expertApplication: ExpertApplication,
  expertApplicationsPagination: ExpertApplicationsPagination,
  expertApplicationsConnection: ExpertApplicationsConnection,
  expertApplicationsPendingReview: ExpertApplicationsConnection,
  expertApplicationsPendingApproval: ExpertApplicationsConnection,
  expertApplicationsPendingActivation: ExpertApplicationsConnection,
  expertProfilesPagination: ExpertProfilesPagination,
  expertSearchConnection: ExpertSearchConnection,
  expertApplicationFolderGroups: Array<ExpertApplicationFolderGroup>,
  expertApplicationFolderItems: ExpertApplicationFolderItemsPayload,
  expertTypeahead: ExpertTypeaheadPayload,
  aggregateExpertReport: AggregateExpertReport,
  expertReferral: ExpertReferral,
  deal: Deal,
  brands: BrandConnection,
  savedSellable: SavedSellable,
  savedSellablesConnection: SavedSellablesConnection,
  sellable: Sellable,
  findSellable?: Maybe<Sellable>,
  sellables: Array<Sellable>,
  searchSellables: SellableSearchConnection,
  sellableTypeahead: SellableTypeaheadPayload,
  similarSellables: SimilarSellablePayload,
  /** Use this API to identify find mapping of the supplied SellableSearchFacetsQuery to corresponding facets shown in the
   * sellable search results.
   * This useful for cases where the facets internal representation is unknown to the caller but wants to create
   * a preselected facet input to the sellable search api.
   * Note this only provides a transformation, currently no facets are discovered.
 */
  sellableSearchFacets: SellableSearchFacetsPayload,
  consumerSellableReactions: ConsumerSellableReactionConnection,
  sellableResearchLink: SellableResearchLink,
  sellableResearchLinks: Array<SellableResearchLink>,
  findSellableResearchLinks: Array<SellableResearchLink>,
  lead: Lead,
  batchGetLeads: Array<Lead>,
  leadLabels: Array<LeadLabel>,
  leads: LeadSearchConnection,
  findExistingLead?: Maybe<Lead>,
  quickReply: QuickReply,
  quickReplies: Array<QuickReply>,
  expertLeadFolderGroups: Array<ExpertLeadFolderGroup>,
  expertLeadFolderItems: LeadSearchConnection,
  leadEscalation: LeadEscalation,
  predictedLifeTimeValues: Array<PredictedLifeTimeValue>,
  leadCampaign: LeadCampaign,
  leadCampaignRecipient: CampaignRecipient,
  leadCampaigns: Array<LeadCampaign>,
  leadCampaignTargetLeads: Array<Lead>,
  savedSearch: SavedSearch,
  savedSearches: Array<SavedSearch>,
  runSavedSearch: SavedSearchResultConnection,
  runLeadSavedSearch: LeadSearchConnection,
  /** Find the content object by the template and variation. When preview parameter
   * is null, by default it is for published content
 */
  findContentByTemplate?: Maybe<ContentObject>,
  /** For backwards compatibility, if filter is entirely omitted, will default to
   * shippingSupported == true, billingSupported == true
 */
  countries: Array<Country>,
  country: Country,
  airport: Airport,
  airportTypeahead: AirportTypeaheadPayload,
  report: Report,
  allReports: Array<Report>,
  reportResult: ReportResultPayload,
  expertCuratedItem: ExpertCuratedItem,
  expertCuratedItems: Array<ExpertCuratedItem>,
  expertCuratedItemsForLead: ExpertCuratedItemsForLeadPayload,
  expertCuratedItemActivation: ExpertCuratedItemActivation,
  expertCuratedOrder: ExpertCuratedOrder,
  expertCuratedOrders: Array<ExpertCuratedOrder>,
  expertCuratedOrdersForLeadConnection: ExpertCuratedOrdersForLeadConnection,
  expertCuratedOrderListActivation: ExpertCuratedOrderListActivation,
  expertCuratedOrderListActivations: Array<ExpertCuratedOrderListActivation>,
  expertCuratedOrderListActivationsForLead: ExpertCuratedOrderListActivationConnection,
  expertCuratedLeadItinerary?: Maybe<ExpertCuratedLeadItinerary>,
  /** Get all available curated item tags that can be used, with their display labels */
  defaultExpertCuratedItemTags: Array<ExpertCuratedItemTag>,
  /** Get all available curated item price override reasons that can be used */
  expertCuratedItemPriceOverrideReasons: Array<ExpertCuratedItemPriceOverrideReason>,
  popularExpertCuratedItemsForSellable: PopularExpertCuratedItemConnection,
  /** Get suggested notes for a sellable */
  suggestExpertCuratedItemNotes: SuggestExpertCuratedItemNotesConnection,
  /** Recommendation and search style API to get ExpertCuratedItems recommended by other experts for similar lead */
  suggestExpertCuratedItemsForLead: SuggestExpertCuratedItemsForLeadConnection,
  departmentExpertCuratedActivityFeed: ExpertCuratedActivityFeedItemConnection,
  expertExpertCuratedActivityFeed: ExpertCuratedActivityFeedItemConnection,
  expertTopRecommendedSellables: ExpertTopRecommendedSellablesPayload,
  expertTopRecommendedBrands: ExpertTopRecommendedBrandsPayload,
  searchRecentExpertCuratedItemGroups: RecentExpertCuratedItemGroupConnection,
  searchSavedExpertCuratedItems: SavedExpertCuratedItemsConnection,
  simpleCuratedOrder: SimpleCuratedOrder,
  recommendedListsForCategory: RecommendedListConnection,
  recommendedLists: RecommendedListConnection,
  recommendedListDefinition: RecommendedListDefinition,
  recommendedListDefinitions: RecommendedListDefinitionConnection,
  triggerEntities: Array<TriggerEntityMeta>,
  triggerActions: Array<TriggerActionMeta>,
  triggerEvents: Array<TriggerEventMeta>,
  trigger: Trigger,
  triggers: Array<Trigger>,
  validateTrigger: ValidateTriggerPayload,
  eBayItem: EBayItem,
  searchEBayItems: EBayItemSearchConnection,
  matchSellableForEBayItem?: Maybe<Sellable>,
  config: Config,
  configs: Array<Config>,
  configDomains: Array<ConfigDomain>,
  externalAdCampaign: ExternalAdCampaign,
  externalAdCampaignsByCategory: Array<ExternalAdCampaign>,
  externalAdGroup: ExternalAdGroup,
  systemCuratedItemSurvey: SystemCuratedItemSurvey,
  flightPlan: FlightPlan,
  supportTask: SupportTask,
  supportTasks: Array<SupportTask>,
  findSupportTasks: SupportTasksConnection,
  findSupportTasksForOperatorFolder: SupportTasksConnection,
  supportTaskFoldersForOperator: Array<SupportTaskFolder>,
  orderEscalation: OrderEscalation,
  orderEscalations: OrderEscalationConnection,
  supportConversation?: Maybe<SupportConversation>,
  supportConversationById: SupportConversation,
  sellableInventory: SellableInventoryItem,
  payStructure: PayStructure,
  payStructuresPagination: PayStructuresPagination,
  payStructureRevision: PayStructureRevision,
  payoutsPagination: PayoutsPagination,
  payLineItemsPagination: PayLineItemsPagination,
  payout: Payout,
  rawSellableSource: RawSellableSource,
  rawSellable: RawSellable,
  standardizedSellable: StandardizedSellable,
  standardizedSellableGroup: StandardizedSellableGroup,
  rawSellableStandardizationRule: RawSellableStandardizationRule,
  findRawSellableSource: Array<RawSellableSource>,
  findRawSellableStandardizationRule: Array<RawSellableStandardizationRule>,
  findStandardizedSellableGroup: Array<StandardizedSellableGroup>,
  rawSellableStandardizationMeta: RawSellableStandardizationMeta,
  fulfillmentCenters: FulfillmentCenterConnection,
  schedulingTypes: Array<SchedulingType>,
  schedulingType: SchedulingType,
  schedulingDemandForecast: SchedulingDemandForecast,
  schedulingDemandForecastDailyView: Array<SchedulingDemandForecastDailyView>,
  schedulingUserAvailability: SchedulingUserAvailability,
  schedulingUserAvailabilityDailyView: Array<SchedulingUserAvailabilityDailyView>,
  shift: Shift,
  shiftDailyView: Array<ShiftDailyView>,
};


export type QueryAttributeSchemasByCategoriesArgs = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  entityType?: Maybe<Scalars['String']>,
  includeChildCategories: Scalars['Boolean'],
  includeParentCategories: Scalars['Boolean'],
  first?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>
};


export type QueryAttributeSchemasByNameArgs = {
  attributeSchemaNames: Array<Scalars['String']>,
  entityType?: Maybe<Scalars['String']>
};


export type QueryMaskedHandleArgs = {
  id: Scalars['AnyId']
};


export type QueryMaskedHandlesByLoginTokenArgs = {
  loginToken: Scalars['String']
};


export type QueryCategoriesArgs = {
  categoryTypes?: Maybe<Array<Maybe<CategoryType>>>,
  first?: Maybe<Scalars['Int']>,
  after?: Maybe<Scalars['String']>
};


export type QueryCategoryArgs = {
  categoryId: Scalars['CategoryId']
};


export type QueryCategoryBySlugArgs = {
  slug: Scalars['String']
};


export type QueryDepartmentArgs = {
  id: Scalars['DepartmentId']
};


export type QueryDepartmentBySlugArgs = {
  slug: Scalars['String']
};


export type QueryCommTemplateArgs = {
  id: Scalars['CommTemplateId']
};


export type QueryCommTemplatesArgs = {
  active: Scalars['Boolean']
};


export type QueryCommTemplateTypesArgs = {
  filter?: Maybe<CommTemplateTypeFilter>
};


export type QueryCommTemplateTypeArgs = {
  id: Scalars['CommTemplateTypeId']
};


export type QueryRenderCommTemplateArgs = {
  input: RenderCommTemplateInput
};


export type QueryCommTemplateDataModelArgs = {
  input: CommTemplateDataModelInput
};


export type QueryCommTemplateFragmentArgs = {
  id: Scalars['CommTemplateFragmentId']
};


export type QueryCommTemplateFragmentsArgs = {
  filter: CommTemplateFragmentFilter
};


export type QueryDealRequestArgs = {
  id: Scalars['DealRequestId']
};


export type QueryFindDealRequestsArgs = {
  filters: DealRequestFilter
};


export type QueryFindContactArgs = {
  contactId: Scalars['ContactId']
};


export type QueryUserArgs = {
  userId: Scalars['UserId']
};


export type QueryUserByContactArgs = {
  type: ContactType,
  value: Scalars['String']
};


export type QueryUsersByContactArgs = {
  contacts?: Maybe<Array<Scalars['String']>>
};


export type QueryMerchantArgs = {
  id: Scalars['MerchantId']
};


export type QuerySuggestMerchantsArgs = {
  name: Scalars['String'],
  categoryId?: Maybe<Scalars['CategoryId']>
};


export type QuerySearchMerchantsArgs = {
  query: MerchantSearchQuery,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QuerySearchUsersArgs = {
  query: UserSearchQuery,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryOperatorsArgs = {
  query: OperatorQuery
};


export type QueryPendingAccessContactArgs = {
  id: Scalars['PendingAccessContactId']
};


export type QueryBusinessUserArgs = {
  id: Scalars['BusinessUserId']
};


export type QueryBusinessUsersArgs = {
  ids: Array<Scalars['BusinessUserId']>
};


export type QueryExpertsArgs = {
  includeInactive: Scalars['Boolean']
};


export type QueryBusinessAccountArgs = {
  id: Scalars['BusinessAccountId']
};


export type QueryBusinessUserTeamArgs = {
  id: Scalars['BusinessUserTeamId']
};


export type QueryConversationArgs = {
  id: Scalars['ConversationId']
};


export type QueryConversationByExternalIdArgs = {
  externalId: Scalars['String']
};


export type QueryMessagingUsersArgs = {
  ids: Array<Scalars['AnyId']>
};


export type QueryCallActivityConnectionArgs = {
  input?: Maybe<CallActivityFilterInput>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryGuestConversationSequenceArgs = {
  id: Scalars['GuestConversationSequenceId']
};


export type QueryFindGuestConversationSequencesArgs = {
  query: GuestConversationSequenceQuery
};


export type QueryPathFlowArgs = {
  id: Scalars['PathFlowId']
};


export type QueryPathFlowPageArgs = {
  id: Scalars['PathFlowId'],
  pageSlug: Scalars['String']
};


export type QueryPathFlowBySlugArgs = {
  pathFlowSlug: Scalars['String']
};


export type QueryPathFlowPageBySlugsArgs = {
  pathFlowSlug: Scalars['String'],
  pathFlowPageSlug: Scalars['String']
};


export type QueryShippingCarriersArgs = {
  includeInternal: Scalars['Boolean']
};


export type QueryOrderArgs = {
  id: Scalars['OrderId']
};


export type QueryOrderLineItemArgs = {
  id: Scalars['OrderLineItemId']
};


export type QueryTransactionArgs = {
  id: Scalars['TransactionId']
};


export type QueryFindOrdersArgs = {
  state?: Maybe<OrderState>,
  fulfillmentState?: Maybe<OrderFulfillmentState>,
  orderLineItemState?: Maybe<OrderLineItemState>,
  userId?: Maybe<Scalars['UserId']>
};


export type QueryOrdersConnectionArgs = {
  query?: Maybe<OrderQuery>,
  sort: OrderSearchSort,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryOrdersPaginationArgs = {
  query?: Maybe<OrderQuery>,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryPaymentSourceArgs = {
  id: Scalars['PaymentSourceId']
};


export type QueryReusablePaymentSourcesArgs = {
  paymentMethod: PaymentMethod
};


export type QueryRecommendTipPercentagesForOrderArgs = {
  id: Scalars['OrderId']
};


export type QueryPromotionArgs = {
  id: Scalars['PromotionId']
};


export type QueryPromotionsConnectionArgs = {
  query?: Maybe<PromotionQueryInput>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int']
};


export type QueryActivePromotionByCodeArgs = {
  code?: Maybe<Scalars['String']>
};


export type QueryOrderShippingCostArgs = {
  id: Scalars['OrderId'],
  orderShippingCostAddress?: Maybe<OrderShippingCostAddressInput>
};


export type QueryTagsArgs = {
  type: TagType
};


export type QueryFrontendTaskArgs = {
  id: Scalars['FrontendTaskId']
};


export type QueryBroadcastOfferArgs = {
  id: Scalars['BroadcastOfferId']
};


export type QueryMediaFileArgs = {
  id: Scalars['MediaId']
};


export type QueryMediaFilesArgs = {
  ids: Array<Scalars['MediaId']>
};


export type QueryOpenGraphDataArgs = {
  url: Scalars['String']
};


export type QueryFindExpertArgs = {
  vanityIdOrId: Scalars['String']
};


export type QueryExpertProfileArgs = {
  id: Scalars['ExpertProfileId']
};


export type QueryRecommendExpertArgs = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type QueryRecommendExpert2Args = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type QueryRecommendExpertForRequestArgs = {
  requestId: Scalars['DealRequestId']
};


export type QueryRecommendExpertsForPathFlowArgs = {
  pathFlowId: Scalars['PathFlowId'],
  limit: Scalars['Int']
};


export type QueryRecommendExpertsForDepartmentArgs = {
  departmentId: Scalars['DepartmentId'],
  limit: Scalars['Int']
};


export type QueryConsumerExpertReviewArgs = {
  id: Scalars['ConsumerExpertReviewId']
};


export type QueryConsumerExpertReviewConnectionArgs = {
  query: ConsumerReviewSearchQuery,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int'],
  sortBy: ConsumerReviewSearchSort
};


export type QueryExpertApplicationArgs = {
  id: Scalars['ExpertApplicationId']
};


export type QueryExpertApplicationsPaginationArgs = {
  query?: Maybe<ExpertApplicationQuery>,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryExpertApplicationsConnectionArgs = {
  query?: Maybe<ExpertApplicationSearchQueryInput>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int'],
  sortBy: ExpertApplicationSearchSort,
  sortDescending: Scalars['Boolean']
};


export type QueryExpertApplicationsPendingReviewArgs = {
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryExpertApplicationsPendingApprovalArgs = {
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int'],
  reviewedOnly: Scalars['Boolean']
};


export type QueryExpertApplicationsPendingActivationArgs = {
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryExpertProfilesPaginationArgs = {
  query?: Maybe<ExpertProfileQuery>,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryExpertSearchConnectionArgs = {
  query?: Maybe<ExpertSearchQuery>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int'],
  sortBy: ExpertSearchSort
};


export type QueryExpertApplicationFolderItemsArgs = {
  departmentId?: Maybe<Scalars['DepartmentId']>,
  approvedById?: Maybe<Scalars['OperatorId']>,
  folderSlug: Scalars['String'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryExpertTypeaheadArgs = {
  query?: Maybe<ExpertTypeaheadQuery>,
  first: Scalars['Int']
};


export type QueryExpertReferralArgs = {
  id: Scalars['ExpertReferralId']
};


export type QueryDealArgs = {
  id: Scalars['DealId']
};


export type QueryBrandsArgs = {
  activeOnly: Scalars['Boolean'],
  first: Scalars['Int'],
  after?: Maybe<Scalars['String']>,
  last: Scalars['Int'],
  before?: Maybe<Scalars['String']>
};


export type QuerySavedSellableArgs = {
  id: Scalars['SavedSellableId']
};


export type QuerySavedSellablesConnectionArgs = {
  query: SavedSellableQueryInput,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int']
};


export type QuerySellableArgs = {
  id: Scalars['SellableId']
};


export type QueryFindSellableArgs = {
  friendlyIdOrId: Scalars['String']
};


export type QuerySellablesArgs = {
  ids: Array<Scalars['SellableId']>
};


export type QuerySearchSellablesArgs = {
  query?: Maybe<SellableSearchQuery>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int'],
  sortBy: SellableSort,
  order: SortOrder
};


export type QuerySellableTypeaheadArgs = {
  query?: Maybe<SellableTypeaheadQuery>,
  first: Scalars['Int']
};


export type QuerySimilarSellablesArgs = {
  id: Scalars['SellableId'],
  topN: Scalars['Int']
};


export type QuerySellableSearchFacetsArgs = {
  query: SellableSearchFacetsQuery
};


export type QueryConsumerSellableReactionsArgs = {
  query?: Maybe<ConsumerSellableReactionsQuery>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QuerySellableResearchLinkArgs = {
  id: Scalars['SellableResearchLinkId']
};


export type QuerySellableResearchLinksArgs = {
  ids: Array<Scalars['SellableResearchLinkId']>
};


export type QueryFindSellableResearchLinksArgs = {
  input: SellableResearchLinkFilter
};


export type QueryLeadArgs = {
  id: Scalars['LeadId']
};


export type QueryBatchGetLeadsArgs = {
  ids: Array<Scalars['LeadId']>
};


export type QueryLeadsArgs = {
  query: LeadSearchQuery,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryFindExistingLeadArgs = {
  consumerId: Scalars['UserId'],
  expertId: Scalars['BusinessUserId']
};


export type QueryQuickReplyArgs = {
  id: Scalars['QuickReplyId']
};


export type QueryQuickRepliesArgs = {
  query: QuickReplyQuery
};


export type QueryExpertLeadFolderGroupsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>
};


export type QueryExpertLeadFolderItemsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  folderName: Scalars['String'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryLeadEscalationArgs = {
  id: Scalars['LeadEscalationId']
};


export type QueryPredictedLifeTimeValuesArgs = {
  id: Scalars['UserId'],
  ltvType?: Maybe<LtvType>,
  adPlatform?: Maybe<Scalars['String']>
};


export type QueryLeadCampaignArgs = {
  id: Scalars['LeadCampaignId']
};


export type QueryLeadCampaignRecipientArgs = {
  id: Scalars['LeadCampaignRecipientId']
};


export type QueryLeadCampaignsArgs = {
  input: LeadCampaignFilter
};


export type QueryLeadCampaignTargetLeadsArgs = {
  campaignId: Scalars['LeadCampaignId']
};


export type QuerySavedSearchArgs = {
  id: Scalars['SavedSearchId']
};


export type QuerySavedSearchesArgs = {
  groupName: Scalars['String'],
  entityName: Scalars['String']
};


export type QueryRunSavedSearchArgs = {
  id: Scalars['SavedSearchId'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryRunLeadSavedSearchArgs = {
  id: Scalars['SavedSearchId'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int'],
  context: LeadSavedSearchContext
};


export type QueryFindContentByTemplateArgs = {
  space?: Maybe<Scalars['String']>,
  template: Scalars['String'],
  variation: Scalars['String'],
  preview?: Maybe<Scalars['Boolean']>
};


export type QueryCountriesArgs = {
  filter?: Maybe<CountryFilter>
};


export type QueryCountryArgs = {
  countryCode: Scalars['String']
};


export type QueryAirportArgs = {
  airport: Scalars['AirportId']
};


export type QueryAirportTypeaheadArgs = {
  query?: Maybe<AirportTypeaheadQuery>,
  first: Scalars['Int']
};


export type QueryReportArgs = {
  id: Scalars['ReportId']
};


export type QueryReportResultArgs = {
  query: ReportResultQuery
};


export type QueryExpertCuratedItemArgs = {
  id: Scalars['ExpertCuratedItemId']
};


export type QueryExpertCuratedItemsArgs = {
  ids: Array<Scalars['ExpertCuratedItemId']>
};


export type QueryExpertCuratedItemsForLeadArgs = {
  leadId: Scalars['LeadId']
};


export type QueryExpertCuratedItemActivationArgs = {
  id: Scalars['ExpertCuratedItemActivationId']
};


export type QueryExpertCuratedOrderArgs = {
  id: Scalars['ExpertCuratedOrderId']
};


export type QueryExpertCuratedOrdersArgs = {
  ids: Array<Scalars['ExpertCuratedOrderId']>
};


export type QueryExpertCuratedOrdersForLeadConnectionArgs = {
  query: ExpertCuratedOrdersForLeadQueryInput,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryExpertCuratedOrderListActivationArgs = {
  id: Scalars['ExpertCuratedOrderListActivationId']
};


export type QueryExpertCuratedOrderListActivationsArgs = {
  ids: Array<Scalars['ExpertCuratedOrderListActivationId']>
};


export type QueryExpertCuratedOrderListActivationsForLeadArgs = {
  leadId: Scalars['LeadId'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryExpertCuratedLeadItineraryArgs = {
  leadId: Scalars['LeadId']
};


export type QueryPopularExpertCuratedItemsForSellableArgs = {
  query: PopularExpertCuratedItemQueryInput,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QuerySuggestExpertCuratedItemNotesArgs = {
  query: SuggestExpertCuratedItemNotesQueryInput,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  sort: SuggestExpertCuratedItemNotesSort
};


export type QuerySuggestExpertCuratedItemsForLeadArgs = {
  query: SuggestExpertCuratedItemsForLeadQueryInput,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryDepartmentExpertCuratedActivityFeedArgs = {
  id: Scalars['DepartmentId'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int']
};


export type QueryExpertExpertCuratedActivityFeedArgs = {
  id: Scalars['BusinessUserId'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int']
};


export type QueryExpertTopRecommendedSellablesArgs = {
  query: ExpertTopRecommendedSellablesInput
};


export type QueryExpertTopRecommendedBrandsArgs = {
  query: ExpertTopRecommendedBrandsInput
};


export type QuerySearchRecentExpertCuratedItemGroupsArgs = {
  filter: RecentExpertCuratedItemGroupSearchFilter,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QuerySearchSavedExpertCuratedItemsArgs = {
  filter: SavedExpertCuratedItemsSearchFilter,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QuerySimpleCuratedOrderArgs = {
  id: Scalars['SimpleCuratedOrderId']
};


export type QueryRecommendedListsForCategoryArgs = {
  categorySlug: Scalars['String'],
  types?: Maybe<Array<RecommendedListType>>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryRecommendedListsArgs = {
  query: RecommendedListsQuery,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryRecommendedListDefinitionArgs = {
  id: Scalars['RecommendedListDefinitionId']
};


export type QueryRecommendedListDefinitionsArgs = {
  query?: Maybe<RecommendedListDefintionQuery>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryTriggerArgs = {
  id: Scalars['TriggerId']
};


export type QueryTriggersArgs = {
  input: TriggerQuery
};


export type QueryValidateTriggerArgs = {
  input: ValidateTriggerInput
};


export type QueryEBayItemArgs = {
  itemId: Scalars['String']
};


export type QuerySearchEBayItemsArgs = {
  query?: Maybe<EBayItemSearchQuery>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int']
};


export type QueryMatchSellableForEBayItemArgs = {
  itemId: Scalars['String']
};


export type QueryConfigArgs = {
  domain: Scalars['String'],
  key: Scalars['String']
};


export type QueryConfigsArgs = {
  domain: Scalars['String']
};


export type QueryExternalAdCampaignArgs = {
  id: Scalars['ExternalAdCampaignId']
};


export type QueryExternalAdCampaignsByCategoryArgs = {
  categoryId: Scalars['CategoryId']
};


export type QueryExternalAdGroupArgs = {
  id: Scalars['ExternalAdGroupId']
};


export type QuerySystemCuratedItemSurveyArgs = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type QueryFlightPlanArgs = {
  id: Scalars['FlightPlanId']
};


export type QuerySupportTaskArgs = {
  id: Scalars['SupportTaskId']
};


export type QuerySupportTasksArgs = {
  ids: Array<Scalars['SupportTaskId']>
};


export type QueryFindSupportTasksArgs = {
  query: SupportTaskQuery,
  sortOrder: SortOrder,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QueryFindSupportTasksForOperatorFolderArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType,
  folderSlug: Scalars['String'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QuerySupportTaskFoldersForOperatorArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType
};


export type QueryOrderEscalationArgs = {
  input: Scalars['OrderEscalationId']
};


export type QueryOrderEscalationsArgs = {
  query: OrderEscalationSearchInput,
  sort: OrderEscalationSearchSort,
  sortOrder: SortOrder,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QuerySupportConversationArgs = {
  consumerId: Scalars['UserId']
};


export type QuerySupportConversationByIdArgs = {
  id: Scalars['SupportConversationId']
};


export type QuerySellableInventoryArgs = {
  id: Scalars['SellableInventoryItemId']
};


export type QueryPayStructureArgs = {
  id: Scalars['PayStructureId']
};


export type QueryPayStructuresPaginationArgs = {
  filters: PayStructureFilters,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryPayStructureRevisionArgs = {
  id: Scalars['PayStructureRevisionId']
};


export type QueryPayoutsPaginationArgs = {
  filters: PayoutFilters,
  sort?: Maybe<PayoutSortInput>,
  fetchRollupSummary: Scalars['Boolean'],
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryPayLineItemsPaginationArgs = {
  payoutId: Scalars['PayoutId'],
  sort?: Maybe<PayLineItemSortInput>,
  offset: Scalars['Int'],
  limit: Scalars['Int']
};


export type QueryPayoutArgs = {
  id: Scalars['PayoutId']
};


export type QueryRawSellableSourceArgs = {
  id: Scalars['RawSellableSourceId']
};


export type QueryRawSellableArgs = {
  id: Scalars['RawSellableId']
};


export type QueryStandardizedSellableArgs = {
  id: Scalars['StandardizedSellableId']
};


export type QueryStandardizedSellableGroupArgs = {
  id: Scalars['StandardizedSellableGroupId']
};


export type QueryRawSellableStandardizationRuleArgs = {
  id: Scalars['RawSellableStandardizationRuleId']
};


export type QueryFindRawSellableSourceArgs = {
  query: RawSellableSourceQuery
};


export type QueryFindRawSellableStandardizationRuleArgs = {
  query: RawSellableStandardizationRuleQuery
};


export type QueryFindStandardizedSellableGroupArgs = {
  query: StandardizedSellableGroupQuery,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryFulfillmentCentersArgs = {
  query: FulfillmentCentersQuery,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type QuerySchedulingTypesArgs = {
  activeOnly: Scalars['Boolean']
};


export type QuerySchedulingTypeArgs = {
  id: Scalars['SchedulingTypeId']
};


export type QuerySchedulingDemandForecastArgs = {
  id: Scalars['SchedulingDemandForecastId']
};


export type QuerySchedulingDemandForecastDailyViewArgs = {
  input: SchedulingDemandForecastDailyViewFilter
};


export type QuerySchedulingUserAvailabilityArgs = {
  id: Scalars['SchedulingUserAvailabilityId']
};


export type QuerySchedulingUserAvailabilityDailyViewArgs = {
  input: SchedulingUserAvailabilityDailyViewFilter
};


export type QueryShiftArgs = {
  id: Scalars['ShiftId']
};


export type QueryShiftDailyViewArgs = {
  input: ShiftDailyViewFilter
};

export type QuickReply = {
  __typename: 'QuickReply',
  id: Scalars['QuickReplyId'],
  name: Scalars['String'],
  text: Scalars['String'],
  expert: BusinessUser,
  lead?: Maybe<Lead>,
};


export type QuickReplyQuery = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
};

export type RatingContactPageMetadata = PathFlowPageMetadata & {
  __typename: 'RatingContactPageMetadata',
  type: PathFlowPageMetadataType,
};

export type RawAttribute = {
  __typename: 'RawAttribute',
  name: Scalars['String'],
  value: Scalars['String'],
};

export type RawAttributeInput = {
  name: Scalars['String'],
  value: Scalars['String'],
};

export type RawSellable = {
  __typename: 'RawSellable',
  id: Scalars['RawSellableId'],
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  attributes: Array<RawSellableAttribute>,
  titleVariationDimension: Scalars['Boolean'],
  gtin?: Maybe<Scalars['String']>,
  mpn?: Maybe<Scalars['String']>,
  brand?: Maybe<Scalars['String']>,
  originalPrice?: Maybe<MonetaryAmount>,
  salePrice?: Maybe<MonetaryAmount>,
  source: RawSellableSource,
  sourceUniqueKey: Scalars['String'],
  sourceReference: Scalars['String'],
  variationGroupReference?: Maybe<Scalars['String']>,
  state: RawSellableState,
};

export type RawSellableAttribute = {
  __typename: 'RawSellableAttribute',
  name: Scalars['String'],
  value: Scalars['String'],
  variationDimension: Scalars['Boolean'],
};

export enum RawSellableAttributeValuePatternFlag {
  UNIX_LINES = 'UNIX_LINES',
  CASE_INSENSITIVE = 'CASE_INSENSITIVE',
  COMMENTS = 'COMMENTS',
  MULTILINE = 'MULTILINE',
  LITERAL = 'LITERAL',
  DOTALL = 'DOTALL',
  UNICODE_CASE = 'UNICODE_CASE',
  CANON_EQ = 'CANON_EQ',
  UNICODE_CHARACTER_CLASS = 'UNICODE_CHARACTER_CLASS'
}


export type RawSellableScraperSellablePriceSource = SellablePriceSource & {
  __typename: 'RawSellableScraperSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  url: Scalars['String'],
  rawSellableSource: RawSellableScraperSource,
};

export type RawSellableScraperSource = RawSellableSource & {
  __typename: 'RawSellableScraperSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  state: RawSellableSourceState,
  spider: RawSellableSourceSpider,
  priceRefreshInterval: Duration,
};

export type RawSellableSource = {
  __typename: 'RawSellableSource',
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  type: RawSellableSourceType,
  state: RawSellableSourceState,
};


export type RawSellableSourceQuery = {
  states?: Maybe<Array<RawSellableSourceState>>,
  types?: Maybe<Array<RawSellableSourceType>>,
};

export type RawSellableSourceScrapinghubSpider = RawSellableSourceSpider & {
  __typename: 'RawSellableSourceScrapinghubSpider',
  spider: Scalars['String'],
  priceSpider: Scalars['String'],
  projectId: Scalars['String'],
  arguments: Array<RawSellableSourceScrapinghubSpiderArgument>,
  type: ScrapingJobType,
};

export type RawSellableSourceScrapinghubSpiderArgument = {
  __typename: 'RawSellableSourceScrapinghubSpiderArgument',
  key: Scalars['String'],
  value: Scalars['String'],
};

export type RawSellableSourceScrapinghubSpiderArgumentInput = {
  key: Scalars['String'],
  value: Scalars['String'],
};

export type RawSellableSourceScrapinghubSpiderInput = {
  spider: Scalars['String'],
  priceSpider: Scalars['String'],
  projectId: Scalars['String'],
  arguments: Array<RawSellableSourceScrapinghubSpiderArgumentInput>,
};

export type RawSellableSourceSpider = {
  __typename: 'RawSellableSourceSpider',
  type: ScrapingJobType,
};

export type RawSellableSourceSpiderInput = {
  priceRefreshInterval: DurationInput,
  scrapinghubSpider: RawSellableSourceScrapinghubSpiderInput,
};

export enum RawSellableSourceState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum RawSellableSourceType {
  SCRAPER = 'SCRAPER',
  DEAL_INVENTORY = 'DEAL_INVENTORY'
}

export type RawSellableStandardizationAction = {
  __typename: 'RawSellableStandardizationAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationActionInput = {
  type: RawSellableStandardizationActionType,
  copyAttributeValue?: Maybe<RawSellableStandardizationCopyAttributeValueActionInput>,
  removeAttribute?: Maybe<RawSellableStandardizationRemoveAttributeActionInput>,
  replaceAttributeValue?: Maybe<RawSellableStandardizationReplaceAttributeValueActionInput>,
  setAttributeValue?: Maybe<RawSellableStandardizationSetAttributeValueActionInput>,
  setCategory?: Maybe<RawSellableStandardizationSetCategoryActionInput>,
};

export enum RawSellableStandardizationActionType {
  SET_CATEGORY = 'SET_CATEGORY',
  SET_ATTRIBUTE_VALUE = 'SET_ATTRIBUTE_VALUE',
  COPY_ATTRIBUTE_VALUE = 'COPY_ATTRIBUTE_VALUE',
  REMOVE_ATTRIBUTE = 'REMOVE_ATTRIBUTE',
  REPLACE_ATTRIBUTE_VALUE = 'REPLACE_ATTRIBUTE_VALUE',
  MARK_OUT_OF_STOCK = 'MARK_OUT_OF_STOCK',
  DEACTIVATE = 'DEACTIVATE',
  HIDE_FROM_CONSUMER_SEARCH = 'HIDE_FROM_CONSUMER_SEARCH'
}

export type RawSellableStandardizationAttributeValueFieldMeta = RawSellableStandardizationFieldMeta & {
  __typename: 'RawSellableStandardizationAttributeValueFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  attributeName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationAttributeVariationDimensionFieldMeta = RawSellableStandardizationFieldMeta & {
  __typename: 'RawSellableStandardizationAttributeVariationDimensionFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  attributeName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationCopyAttributeValueAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationCopyAttributeValueAction',
  type: RawSellableStandardizationActionType,
  sourceAttributeName: Scalars['String'],
  targetAttributeName: Scalars['String'],
  reference: Scalars['Boolean'],
};

export type RawSellableStandardizationCopyAttributeValueActionInput = {
  sourceAttributeName: Scalars['String'],
  targetAttributeName: Scalars['String'],
  reference: Scalars['Boolean'],
};

export type RawSellableStandardizationDeactivateAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationDeactivateAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationFieldMeta = {
  __typename: 'RawSellableStandardizationFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationHideFromConsumerSearchAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationHideFromConsumerSearchAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationMarkOutOfStockAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationMarkOutOfStockAction',
  type: RawSellableStandardizationActionType,
};

export type RawSellableStandardizationMeta = {
  __typename: 'RawSellableStandardizationMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  fields: Array<RawSellableStandardizationFieldMeta>,
  attributeValueField?: Maybe<RawSellableStandardizationFieldMeta>,
  attributeVariationDimensionField?: Maybe<RawSellableStandardizationFieldMeta>,
};


export type RawSellableStandardizationMetaFieldsArgs = {
  names?: Maybe<Array<Scalars['String']>>
};


export type RawSellableStandardizationMetaAttributeValueFieldArgs = {
  attributeName: Scalars['String']
};


export type RawSellableStandardizationMetaAttributeVariationDimensionFieldArgs = {
  attributeName: Scalars['String']
};

export type RawSellableStandardizationPredefinedFieldMeta = RawSellableStandardizationFieldMeta & {
  __typename: 'RawSellableStandardizationPredefinedFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: RawSellableStandardizationRuleFieldType,
  idType?: Maybe<Scalars['String']>,
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>,
};

export type RawSellableStandardizationRemoveAttributeAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationRemoveAttributeAction',
  type: RawSellableStandardizationActionType,
  attributeName: Scalars['String'],
};

export type RawSellableStandardizationRemoveAttributeActionInput = {
  attributeName: Scalars['String'],
};

export type RawSellableStandardizationReplaceAttributeValueAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationReplaceAttributeValueAction',
  type: RawSellableStandardizationActionType,
  attributeName: Scalars['String'],
  attributeValuePattern: Scalars['String'],
  attributeValuePatternFlags: Array<RawSellableAttributeValuePatternFlag>,
  attributeValueReplacement: Scalars['String'],
};

export type RawSellableStandardizationReplaceAttributeValueActionInput = {
  attributeName: Scalars['String'],
  attributeValuePattern: Scalars['String'],
  attributeValuePatternFlags: Array<RawSellableAttributeValuePatternFlag>,
  attributeValueReplacement: Scalars['String'],
};

export type RawSellableStandardizationRule = {
  __typename: 'RawSellableStandardizationRule',
  id: Scalars['RawSellableStandardizationRuleId'],
  name: Scalars['String'],
  source?: Maybe<RawSellableSource>,
  priority: Scalars['Int'],
  condition: RawSellableStandardizationRuleCondition,
  actions: Array<RawSellableStandardizationAction>,
  state: RawSellableStandardizationRuleState,
  meta: RawSellableStandardizationMeta,
};

export type RawSellableStandardizationRuleBinaryCondition = RawSellableStandardizationRuleCondition & {
  __typename: 'RawSellableStandardizationRuleBinaryCondition',
  type: RawSellableStandardizationRuleConditionType,
  leftOperand: RawSellableStandardizationRuleParameter,
  rightOperand: RawSellableStandardizationRuleParameter,
  binaryOperator: RawSellableStandardizationRuleFieldOperator,
};

export type RawSellableStandardizationRuleBinaryConditionInput = {
  leftOperand: RawSellableStandardizationRuleParameterInput,
  rightOperand: RawSellableStandardizationRuleParameterInput,
  binaryOperator: Scalars['String'],
};

export type RawSellableStandardizationRuleCondition = {
  __typename: 'RawSellableStandardizationRuleCondition',
  type: RawSellableStandardizationRuleConditionType,
};

export type RawSellableStandardizationRuleConditionInput = {
  binaryCondition?: Maybe<RawSellableStandardizationRuleBinaryConditionInput>,
  logicalCondition?: Maybe<RawSellableStandardizationRuleLogicalConditionInput>,
  constantCondition?: Maybe<RawSellableStandardizationRuleConstantConditionInput>,
};

export enum RawSellableStandardizationRuleConditionType {
  LOGICAL = 'LOGICAL',
  BINARY = 'BINARY',
  CONSTANT = 'CONSTANT'
}

export type RawSellableStandardizationRuleConstantCondition = RawSellableStandardizationRuleCondition & {
  __typename: 'RawSellableStandardizationRuleConstantCondition',
  type: RawSellableStandardizationRuleConditionType,
  result: Scalars['Boolean'],
};

export type RawSellableStandardizationRuleConstantConditionInput = {
  result: Scalars['Boolean'],
};

export type RawSellableStandardizationRuleEntityFieldReference = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleEntityFieldReference',
  type: RawSellableStandardizationRuleParameterType,
  field: Scalars['String'],
};

export type RawSellableStandardizationRuleFieldOperator = {
  __typename: 'RawSellableStandardizationRuleFieldOperator',
  name: Scalars['String'],
  displayName: Scalars['String'],
  leftOperandType: RawSellableStandardizationRuleFieldType,
  rightOperandType: RawSellableStandardizationRuleFieldType,
};

export enum RawSellableStandardizationRuleFieldType {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  STRING_LIST = 'STRING_LIST',
  ID = 'ID',
  ID_LIST = 'ID_LIST'
}


export type RawSellableStandardizationRuleLiteralBooleanValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralBooleanValue',
  type: RawSellableStandardizationRuleParameterType,
  booleanValue: Scalars['Boolean'],
};

export type RawSellableStandardizationRuleLiteralIdListValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralIdListValue',
  type: RawSellableStandardizationRuleParameterType,
  idListValue: Array<Scalars['AnyId']>,
};

export type RawSellableStandardizationRuleLiteralIdValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralIdValue',
  type: RawSellableStandardizationRuleParameterType,
  idValue: Scalars['AnyId'],
};

export type RawSellableStandardizationRuleLiteralStringListValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralStringListValue',
  type: RawSellableStandardizationRuleParameterType,
  stringListValue: Array<Scalars['String']>,
};

export type RawSellableStandardizationRuleLiteralStringValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralStringValue',
  type: RawSellableStandardizationRuleParameterType,
  stringValue: Scalars['String'],
};

export type RawSellableStandardizationRuleLogicalCondition = RawSellableStandardizationRuleCondition & {
  __typename: 'RawSellableStandardizationRuleLogicalCondition',
  type: RawSellableStandardizationRuleConditionType,
  conditions: Array<RawSellableStandardizationRuleCondition>,
  logicalOperator: LogicalOperator,
};

export type RawSellableStandardizationRuleLogicalConditionInput = {
  logicalOperator: LogicalOperator,
  conditions: Array<RawSellableStandardizationRuleConditionInput>,
};

export type RawSellableStandardizationRuleParameter = {
  __typename: 'RawSellableStandardizationRuleParameter',
  type: RawSellableStandardizationRuleParameterType,
};

export type RawSellableStandardizationRuleParameterInput = {
  fieldName?: Maybe<Scalars['String']>,
  stringValue?: Maybe<Scalars['String']>,
  stringListValue?: Maybe<Array<Scalars['String']>>,
  booleanValue?: Maybe<Scalars['Boolean']>,
  idValue?: Maybe<Scalars['AnyId']>,
  idListValue?: Maybe<Array<Scalars['AnyId']>>,
};

export enum RawSellableStandardizationRuleParameterType {
  ENTITY_FIELD = 'ENTITY_FIELD',
  LITERAL_VALUE = 'LITERAL_VALUE'
}

export type RawSellableStandardizationRuleQuery = {
  states?: Maybe<Array<RawSellableStandardizationRuleState>>,
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>,
};

export enum RawSellableStandardizationRuleState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type RawSellableStandardizationSetAttributeValueAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetAttributeValueAction',
  type: RawSellableStandardizationActionType,
  attributeName: Scalars['String'],
  attributeValue: Scalars['String'],
};

export type RawSellableStandardizationSetAttributeValueActionInput = {
  attributeName: Scalars['String'],
  attributeValue: Scalars['String'],
};

export type RawSellableStandardizationSetCategoryAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetCategoryAction',
  type: RawSellableStandardizationActionType,
  category: Category,
};

export type RawSellableStandardizationSetCategoryActionInput = {
  categoryId: Scalars['CategoryId'],
};

export enum RawSellableState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type ReassignLeadInput = {
  leadId: Scalars['LeadId'],
  reassignedToExpertId: Scalars['BusinessUserId'],
  reason: LeadReassignmentReason,
};

export type ReassignLeadSupportTaskActivity = SupportTaskActivity & {
  __typename: 'ReassignLeadSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  reassignedTo: BusinessUser,
};

export type RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  expertCuratedItem: ExpertCuratedItem,
  dealRequest: DealRequest,
};

export type RecentExpertCuratedItemGroupConnection = {
  __typename: 'RecentExpertCuratedItemGroupConnection',
  edges: Array<RecentExpertCuratedItemGroupEdge>,
  pageInfo: PageInfo,
  facets: Array<DisplayFacet>,
  count: Scalars['Int'],
};

export type RecentExpertCuratedItemGroupEdge = {
  __typename: 'RecentExpertCuratedItemGroupEdge',
  node: ExpertCuratedItemGroup,
  cursor: Scalars['String'],
};

export type RecentExpertCuratedItemGroupSearchFilter = {
  facets?: Maybe<Array<FacetSelection>>,
};

export type RecommendedExpert = {
  __typename: 'RecommendedExpert',
  expert: BusinessUser,
  existingLead?: Maybe<Lead>,
};

/** A RecommendedList corresponds to a list of Sellables that are grouped together based on a combination of
 * Attributes and properties from a Sellable that match the Users intent.
 * For example, Carbon fiber Bike under $2000
 */
export type RecommendedList = {
  __typename: 'RecommendedList',
  /** The RecommendedListDefinition used to build this RecommendedList
   * All recommendation lists should have a corresponding RecommendedListDefinition but this may be filtered based
   * on requesters Permission levels.
 */
  recommendedListDefinition?: Maybe<RecommendedListDefinition>,
  /** the display name is dynamically generated using the matched Attributes of Sellables in the list and the users intent
   * If this is RecommendedList is built using a corresponding RecommendedListDefinition then this is the resolved title
 */
  displayName: Scalars['String'],
  subTitle?: Maybe<Scalars['String']>,
  /** A list of Sellables belonging to this RecommendedList */
  sellables: Array<Sellable>,
  /** The top level RecommendedListType for this RecommendedList */
  type?: Maybe<RecommendedListType>,
};

/** The RecommendedLists are a list of Sellable items categorized into different RecommendedList, each with its corresponding
 * RecommendedListDefinition.
 * 
 * The RecommendedList is identified from the users intent for a Category specified in the request. Each individual
 * list edge is generated dynamically using a combination of attributes in the user's request in a path.
 * There is a default ordering for the edges returned in the response, listed as follows:
 * 1. Top recommendation based on a combination of user attributes
 * 2. Top level category Attribute Function type + Price combination. For ex: Road bikes under $2000.
 * 3. Top level category Function type + Brand combination. For ex: Specialized bikes
 * 4. The next section will contain lists of itmes belonging to Sub-categories or Accessories. For ex: Bike Helmets, Bike Shoes
 * 5. Any custom RecommendedListDefinition based Recommended List.
 * 
 * The above default order can be changed by updating the rank property of the corresponding RecommendedListDefinition.
 * 
 * Note, that based on the user's intent we may have 0 or more lists of a specific type. For example, if the user didn't
 * specify the brand preference, then we will skip the recommended list for brand type.
 * Also, note that a Sellable may belong to one or more RecommendedList's based on the list generation Criteria.
 * 
 * The total items in each RecommendedList are restricted to 10 items if present and minimum of 3
 */
export type RecommendedListConnection = {
  __typename: 'RecommendedListConnection',
  edges: Array<RecommendedListEdge>,
  pageInfo: PageInfo,
};

export type RecommendedListDefinition = {
  __typename: 'RecommendedListDefinition',
  id: Scalars['RecommendedListDefinitionId'],
  /** User friendly name for this recommended list definition */
  name?: Maybe<Scalars['String']>,
  /** The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
 */
  titleTemplate: Scalars['String'],
  /** The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
 */
  subTitleTemplate?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  /** The category for which this RecommendedListDefinition is being built. */
  categoryIds: Array<Scalars['CategoryId']>,
  /** The categories for which this RecommendedListDefinition is being built. */
  categories: Array<Category>,
  /** The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
 */
  rank: Scalars['Int'],
  recommendedListType: RecommendedListType,
  /** The filtering facets to refine recommended list results */
  queryFacets?: Maybe<Array<RecommendedListDisplayFacet>>,
  /** defaults to relevance based sorting */
  sortOptions?: Maybe<Array<RecommendedListSortOrder>>,
  /** The system auto generated RecommendedLists can't be edited, only their ranking can be changed. */
  queryFiltersAndSortingEditable: Scalars['Boolean'],
  /** A expectedReference User whose request Attributes to use for building the preview results */
  previewResults: DecoratedRecommendedListConnection,
};


export type RecommendedListDefinitionPreviewResultsArgs = {
  asViewedByUser: Scalars['UserId'],
  forParentCategoryId: Scalars['CategoryId'],
  maxFacetTerms: Scalars['Int'],
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};

export type RecommendedListDefinitionConnection = {
  __typename: 'RecommendedListDefinitionConnection',
  edges: Array<RecommendedListDefinitionEdge>,
  pageInfo: PageInfo,
};

export type RecommendedListDefinitionEdge = {
  __typename: 'RecommendedListDefinitionEdge',
  node: RecommendedListDefinition,
  cursor: Scalars['String'],
};


export type RecommendedListDefintionQuery = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  recurseToChildCategories?: Maybe<Scalars['Boolean']>,
};

export type RecommendedListDisplayFacet = {
  __typename: 'RecommendedListDisplayFacet',
  facet?: Maybe<DisplayFacet>,
  useUserPreference: Scalars['Boolean'],
};

export type RecommendedListEdge = {
  __typename: 'RecommendedListEdge',
  node: RecommendedList,
  cursor: Scalars['String'],
};

export type RecommendedListFacetSelectionInput = {
  facetSelection: FacetSelection,
  useUserPreference: Scalars['Boolean'],
};

export type RecommendedListSortOrder = {
  __typename: 'RecommendedListSortOrder',
  sellableSortBy: SellableSort,
  order: SortOrder,
};

export type RecommendedListSortOrderInput = {
  sellableSortBy: SellableSort,
  order: SortOrder,
};

export type RecommendedListsQuery = {
  /** Fetch recommended list for a specific category only */
  categorySlug?: Maybe<Scalars['String']>,
  /** Recommendations include sellables from all categories within the department */
  departmentSlug?: Maybe<Scalars['String']>,
  /** Recommendation types to be used for building the RecommendedList. This includes some pre defined types and a custom
   * type. Use RecommendedListType.CUSTOM to get all RecommendedList built using definitions in the Recommendation list builder
   * To filter further to specific RecommendedListDefinition specify the RecommendedListDefinitionId
 */
  types?: Maybe<Array<RecommendedListType>>,
  /** To restrict recommended list to a specific RecommendedListDefinition only. This overrides types specified above. */
  recommendedListDefinitionId?: Maybe<Scalars['RecommendedListDefinitionId']>,
};

export enum RecommendedListType {
  /** Recommendation list built using  a combination of multiple user Attributes learnt from
   * the Path Deal request. More specifically, it uses Gender, Price, Brand, Primary Attributes and other secondary
   * attributes to build this request.
   * The list built only if brand and primary attributes are present in the users request
   * Accessories are explicitly excluded
 */
  MY_TOP_LIST = 'MY_TOP_LIST',
  /** This is similar to TOP LIST but enforces a strict matching of user request attributes. */
  STRICT_MY_TOP_LIST = 'STRICT_MY_TOP_LIST',
  /** Recommendation list built using price and primary attributes from users path request attributes
   * Each primary attribute has a separate list
   * The list built only if primary attributes are present in the users request
   * Accessories are explicitly excluded
 */
  PRICE_AND_PRIMARY_ATTRIBUTES = 'PRICE_AND_PRIMARY_ATTRIBUTES',
  /** Recommendation list built using brands and primary attributes from users path request attributes
   * Each brand has a separate list
   * The list built only if brand attributes are present in the users request
   * Accessories are explicitly excluded
 */
  BRAND_AND_PRIMARY_ATTRIBUTES = 'BRAND_AND_PRIMARY_ATTRIBUTES',
  /** Recommendation list built using accessories selected by the user in the path request
   * Each Accessory has a separate list
 */
  ACCESSORIES = 'ACCESSORIES',
  /** Recommended list built using curated lists that were recommended to similar users */
  CURATED_LIST_TO_SIMILAR_USERS = 'CURATED_LIST_TO_SIMILAR_USERS',
  /** This recommendation list is used to build a digest of recommendations based on user intent from the deal request
   * The relevancy favors most recent sellables and also favors sellables with price within users budget
   * that has changed recently.
 */
  PRICE_SENSITIVE_INTENT_BASED_DIGEST = 'PRICE_SENSITIVE_INTENT_BASED_DIGEST',
  /** the recommended list built from a custom list defined by the operator or expert */
  CUSTOM = 'CUSTOM'
}

export type RecommendExpertPayload = {
  __typename: 'RecommendExpertPayload',
  expert?: Maybe<BusinessUser>,
  existingLead?: Maybe<Lead>,
};

export type ReenterPathFlowPageBySlugsInput = {
  pathFlowSlug: Scalars['String'],
  pathFlowPageSlug: Scalars['String'],
};

export type ReenterPathFlowPageInput = {
  pathFlowId: Scalars['PathFlowId'],
  pathFlowPageSlug: Scalars['String'],
};

export type ReenterPathFlowPagePayload = {
  __typename: 'ReenterPathFlowPagePayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export enum RegisterCustomerErrorCode {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER'
}

export type RegisterCustomerInput = {
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  externalOAuthType?: Maybe<OAuthType>,
  externalOAuthToken?: Maybe<Scalars['String']>,
};

export type RegisterCustomerPayload = {
  __typename: 'RegisterCustomerPayload',
  user?: Maybe<User>,
  errors?: Maybe<Array<Scalars['String']>>,
  errorCodes: Array<RegisterCustomerErrorCode>,
};

export type RegisterFirebaseCloudMessagingTokenInput = {
  messagingUserId: Scalars['AnyId'],
  fcmToken: Scalars['String'],
  deviceUniqueId?: Maybe<Scalars['String']>,
  applicationId?: Maybe<Scalars['String']>,
};

export type RegisterFirebaseCloudMessagingTokenPayload = {
  __typename: 'RegisterFirebaseCloudMessagingTokenPayload',
  registered?: Maybe<Scalars['Boolean']>,
};

export type RegisterWebPushSubscriptionInput = {
  messagingUserId: Scalars['AnyId'],
  subscription: Scalars['String'],
};

export type RegisterWebPushSubscriptionPayload = {
  __typename: 'RegisterWebPushSubscriptionPayload',
  registered: Scalars['Boolean'],
};

export type RejectExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'],
  reason: Scalars['String'],
};

export type RejectExpertApplicationPayload = {
  __typename: 'RejectExpertApplicationPayload',
  application: ExpertApplication,
};

export type ReleaseBusinessUserIdentityPayload = {
  __typename: 'ReleaseBusinessUserIdentityPayload',
  myself?: Maybe<Myself>,
};

export type ReleaseConsumerIdentityPayload = {
  __typename: 'ReleaseConsumerIdentityPayload',
  user?: Maybe<User>,
  myself?: Maybe<Myself>,
};

export type ReleaseOperatorIdentityPayload = {
  __typename: 'ReleaseOperatorIdentityPayload',
  operator?: Maybe<Operator>,
};

export type RemoveActionFromPromotionInput = {
  id: Scalars['PromotionId'],
  referenceId: Scalars['PromotionActionReferenceId'],
};

export type RemoveActionFromPromotionPayload = {
  __typename: 'RemoveActionFromPromotionPayload',
  promotion: Promotion,
};

export type RemoveChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  channelType: ChannelType,
};

export type RemoveExpertCuratedItemInput = {
  id: Scalars['ExpertCuratedItemId'],
  reason: ExpertCuratedItemRemovedReason,
  otherReason?: Maybe<Scalars['String']>,
  /** Defaults to false; only experts can set this to true. Note that if a draft is being removed, it gets hard deleted. */
  shouldCopyUpdateIntoNewDraft?: Maybe<Scalars['Boolean']>,
};

export type RemoveExpertCuratedItemPayload = {
  __typename: 'RemoveExpertCuratedItemPayload',
  /** The entity that as ultimately modified; may be a new/existing draft that's staged to replace the targeted curated
   * item
 */
  updated: ExpertCuratedItem,
  /** The entity that was targeted for update being staged to be removed once `updated` is activated (converted to non
   * draft status)
 */
  superseded?: Maybe<ExpertCuratedItem>,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type RemoveItemsFromExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
  sellableIds: Array<Scalars['SellableId']>,
};

export type RemoveItemsFromExpertCuratedOrderPayload = {
  __typename: 'RemoveItemsFromExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type RemoveItemsFromOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  lineItemIds: Array<Scalars['OrderLineItemId']>,
};

export type RemoveItemsFromOrderPayload = {
  __typename: 'RemoveItemsFromOrderPayload',
  order: Order,
};

export type RemoveLegsFromFlightPlanInput = {
  id: Scalars['FlightPlanId'],
  legIdsToRemove: Array<Scalars['FlightPlanLegId']>,
};

export type RemoveLegsFromFlightPlanPayload = {
  __typename: 'RemoveLegsFromFlightPlanPayload',
  flightPlan: FlightPlan,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type RemoveProfileHighlightInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  typeId: Scalars['ProfileHighlightTypeId'],
};

export type RemoveRuleFromPromotionInput = {
  id: Scalars['PromotionId'],
  referenceId: Scalars['PromotionRuleReferenceId'],
};

export type RemoveRuleFromPromotionPayload = {
  __typename: 'RemoveRuleFromPromotionPayload',
  promotion: Promotion,
};

export type RemoveScheduleReportInput = {
  reportId: Scalars['ReportId'],
};

export type RemoveSchedulingDemandForecastPayload = {
  __typename: 'RemoveSchedulingDemandForecastPayload',
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'],
};

export type RemoveSchedulingUserAvailabilityPayload = {
  __typename: 'RemoveSchedulingUserAvailabilityPayload',
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'],
};

export type RemoveShipmentTrackingInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
};

export type RemoveTagInput = {
  id: Scalars['TagId'],
};

export type RemoveTagPayload = {
  __typename: 'RemoveTagPayload',
  success?: Maybe<Scalars['Boolean']>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type RemoveTipFromOrderInput = {
  id: Scalars['OrderId'],
};

export type RemoveTipFromOrderPayload = {
  __typename: 'RemoveTipFromOrderPayload',
  order: Order,
};

export type RemoveTriggerEdgeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeType: TriggerNodeEdgeType,
};

export type RemoveTriggerNodeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeTypeToKeep: TriggerNodeEdgeType,
};

export type RenderCommTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  variables: Array<RenderCommTemplateVariableInput>,
};

export type RenderCommTemplatePayload = {
  __typename: 'RenderCommTemplatePayload',
  contents?: Maybe<Array<RenderedChannelContent>>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type RenderCommTemplateVariableInput = {
  name: Scalars['String'],
  /** @deprecated Broken out into type specific properties (`idValue`, `stringValue`) */
  value?: Maybe<Scalars['AnyId']>,
  idValue?: Maybe<Scalars['AnyId']>,
  stringValue?: Maybe<Scalars['String']>,
};

export type RenderedChannelContent = {
  __typename: 'RenderedChannelContent',
  channelType: ChannelType,
};

export type RenderedContent = MediaRenderedContent | TextRenderedContent;

export type RenderedEmailContent = RenderedChannelContent & {
  __typename: 'RenderedEmailContent',
  channelType: ChannelType,
  subject: Scalars['String'],
  htmlBody: Scalars['String'],
  textBody: Scalars['String'],
  medias: Array<MediaFile>,
};

export type RenderedFacebookContent = RenderedChannelContent & {
  __typename: 'RenderedFacebookContent',
  channelType: ChannelType,
  content: Scalars['String'],
  medias: Array<MediaFile>,
};

export type RenderedInAppContent = RenderedChannelContent & {
  __typename: 'RenderedInAppContent',
  channelType: ChannelType,
  content: Scalars['String'],
  contents: Array<RenderedContent>,
};

export type RenderedPushNotificationContent = RenderedChannelContent & {
  __typename: 'RenderedPushNotificationContent',
  channelType: ChannelType,
  title: Scalars['String'],
  body: Scalars['String'],
  threadId?: Maybe<Scalars['String']>,
  medias: Array<MediaFile>,
};

export type RenderedSlackContent = RenderedChannelContent & {
  __typename: 'RenderedSlackContent',
  channelType: ChannelType,
  content: Scalars['String'],
};

export type RenderedSmsContent = RenderedChannelContent & {
  __typename: 'RenderedSmsContent',
  channelType: ChannelType,
  content: Scalars['String'],
  medias: Array<MediaFile>,
};

export type ReorderActionsInPromotionInput = {
  id: Scalars['PromotionId'],
  newReferenceIdOrder: Array<Scalars['PromotionActionReferenceId']>,
};

export type ReorderActionsInPromotionPayload = {
  __typename: 'ReorderActionsInPromotionPayload',
  promotion: Promotion,
};

export type ReorderRulesInPromotionInput = {
  id: Scalars['PromotionId'],
  newReferenceIdOrder: Array<Scalars['PromotionRuleReferenceId']>,
};

export type ReorderRulesInPromotionPayload = {
  __typename: 'ReorderRulesInPromotionPayload',
  promotion: Promotion,
};

export type Report = {
  __typename: 'Report',
  id: Scalars['ReportId'],
  title: Scalars['String'],
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>,
  columns: Array<ReportColumn>,
  refreshIntervalInMinutes?: Maybe<Scalars['Int']>,
  lastGeneratedAt?: Maybe<Scalars['Date']>,
  scope: ReportAccessScope,
  schemaType?: Maybe<ReportSchemaType>,
};

export enum ReportAccessScope {
  BUSINESS_USER = 'BUSINESS_USER',
  TEAM = 'TEAM',
  DEPARTMENT = 'DEPARTMENT',
  GLOBAL = 'GLOBAL'
}

export type ReportColumn = {
  __typename: 'ReportColumn',
  title: Scalars['String'],
  description: Scalars['String'],
  name: Scalars['String'],
  type: ReportColumnValueType,
  format: ReportColumnFormat,
  filterOnly: Scalars['Boolean'],
};

export enum ReportColumnFormat {
  NONE = 'NONE',
  PERCENTAGE = 'PERCENTAGE',
  CURRENCY = 'CURRENCY'
}

export type ReportColumnInput = {
  name: Scalars['String'],
  title: Scalars['String'],
  type: ReportColumnValueType,
};

export type ReportColumnValue = {
  __typename: 'ReportColumnValue',
  stringValue?: Maybe<Scalars['String']>,
  integerValue?: Maybe<Scalars['Int']>,
  doubleValue?: Maybe<Scalars['Float']>,
  type: ReportColumnValueType,
};

export enum ReportColumnValueType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DOUBLE = 'DOUBLE'
}


export type ReportPredictedLifeTimeValueInput = {
  userId: Scalars['UserId'],
  ltvType: LtvType,
  adPlatform: Scalars['String'],
};

export type ReportPredictedLifeTimeValuePayload = {
  __typename: 'ReportPredictedLifeTimeValuePayload',
  predictedLifeTimeValues: Array<PredictedLifeTimeValue>,
};

export type ReportResultPayload = {
  __typename: 'ReportResultPayload',
  error?: Maybe<Scalars['String']>,
  report?: Maybe<Report>,
  rows: Array<ReportResultRow>,
};

export type ReportResultQuery = {
  reportName?: Maybe<Scalars['String']>,
  reportId?: Maybe<Scalars['ReportId']>,
};

export type ReportResultRow = {
  __typename: 'ReportResultRow',
  values: Array<ReportColumnValue>,
};

export enum ReportSchemaType {
  /** The total amount of conversations, and the amount of new conversations in the last week. */
  CONVERSATIONS_COUNT = 'CONVERSATIONS_COUNT',
  /** Stats about expert ratings; total rating count, and average rating score. */
  EXPERT_RATING_STATS = 'EXPERT_RATING_STATS',
  /** The total amount of curations, and the amount of new curations in the last week. */
  CURATIONS_COUNT = 'CURATIONS_COUNT',
  /** Most popular brands recommended by experts, grouped by category */
  RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS = 'RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS',
  /** Most popular brands recommended by experts, grouped and rolled up by category
   * linked to department (e.g.: winter sports, golf, etc)
 */
  RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS = 'RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS'
}

export type RequestConsumerExpertReviewInput = {
  leadId: Scalars['LeadId'],
};

export type RequestConsumerExpertReviewPayload = {
  __typename: 'RequestConsumerExpertReviewPayload',
  success: Scalars['Boolean'],
};

export type RequestOrderSupportForLeadSupportTaskActivity = SupportTaskActivity & {
  __typename: 'RequestOrderSupportForLeadSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};

export type RequestReferralByExpertInput = {
  leadId: Scalars['LeadId'],
  expertId: Scalars['BusinessUserId'],
};

export type RequestReferralByExpertPayload = {
  __typename: 'RequestReferralByExpertPayload',
  success: Scalars['Boolean'],
};

export type RequestSellableInput = {
  expertId: Scalars['BusinessUserId'],
  sellableId: Scalars['SellableId'],
};

export type RequestSellablePayload = {
  __typename: 'RequestSellablePayload',
  error?: Maybe<Scalars['String']>,
  lead?: Maybe<Lead>,
};

export type RerunExpertApplicationTaskInput = {
  applicationId: Scalars['ExpertApplicationId'],
  task: ExpertApplicationTaskType,
};

export type RerunExpertApplicationTaskPayload = {
  __typename: 'RerunExpertApplicationTaskPayload',
  success: Scalars['Boolean'],
};

export type ResetConfigInput = {
  domain: Scalars['String'],
  key: Scalars['String'],
};

export type ResetConfigPayload = {
  __typename: 'ResetConfigPayload',
  config: Config,
};

export type ResetPasswordInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  challenge?: Maybe<Scalars['String']>,
  newPassword: Scalars['String'],
};

export type ResetPasswordPayload = {
  __typename: 'ResetPasswordPayload',
  result: AuthenticationResult,
  user?: Maybe<User>,
  message?: Maybe<Scalars['String']>,
};

export type ReturnPolicy = {
  __typename: 'ReturnPolicy',
  type: ReturnPolicyType,
};

export enum ReturnPolicyType {
  NO_RETURNS_ACCEPTED = 'NO_RETURNS_ACCEPTED',
  STANDARD = 'STANDARD'
}

export enum ReturnRefundMethod {
  ORIGINAL_PAYMENT = 'ORIGINAL_PAYMENT',
  STORE_CREDIT = 'STORE_CREDIT'
}

export enum ReturnShippingPaidBy {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  MERCHANT = 'MERCHANT',
  CUSTOMER = 'CUSTOMER'
}

export type ReviewSummary = {
  __typename: 'ReviewSummary',
  averageRating?: Maybe<Scalars['Float']>,
  totalReviews: Scalars['Int'],
  summaryByRating: Array<ReviewSummaryByRating>,
};

export type ReviewSummaryByRating = {
  __typename: 'ReviewSummaryByRating',
  rating: Scalars['Int'],
  count: Scalars['Int'],
};

export type SaveConsumerSellableReactionInput = {
  rating: ConsumerSellableReactionRating,
  reasons?: Maybe<Array<ConsumerSellableReactionReason>>,
  additionalReason?: Maybe<Scalars['String']>,
  /** The sellable being reviewed */
  sellableId: Scalars['SellableId'],
  /** Since the sellable can be shown in multiple context like different types of recommended list, search results or
   * in auto curations. This field provides the source of the recommendation if one exists
   * If this is review for an ExpertCuratedItem the id of the corresponding item
   * If this is a review for sellable seen in a recommended list the id of the corresponding RecommendedListDefinition
 */
  recommendationSource?: Maybe<ConsumerSellableReactionRecommendationSourceInput>,
  /** Logical Component on the UI that triggered this reaction */
  reactionSource?: Maybe<ConsumerSellableReactionSource>,
};

export type SaveConsumerSellableReactionPayload = {
  __typename: 'SaveConsumerSellableReactionPayload',
  consumerSellableReaction?: Maybe<ConsumerSellableReaction>,
  error?: Maybe<Scalars['String']>,
};

/** SavedExpertCuratedItems is a container for ExpertCuratedItem's that were saved for future reference by an expert.
 * Although, this may have been originally created for a lead, it is not tied to a lead and such this information
 * is not persisted.
 * There is however some metadata about request attributes of the original lead to who this curation was sent, which
 * is mainly used for tagging and searching theis curation.
 */
export type SavedExpertCuratedItems = {
  __typename: 'SavedExpertCuratedItems',
  id: Scalars['SavedExpertCuratedItemsId'],
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  active: Scalars['Boolean'],
  expertCuratedItems: Array<ExpertCuratedItem>,
  /** a list of request attributes tagged and associated with this curation */
  taggedRequestAttributes: Array<Attribute>,
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>,
};

export type SavedExpertCuratedItemsConnection = {
  __typename: 'SavedExpertCuratedItemsConnection',
  edges: Array<SavedExpertCuratedItemsEdge>,
  pageInfo: PageInfo,
  facets: Array<DisplayFacet>,
  count: Scalars['Int'],
};

export type SavedExpertCuratedItemsEdge = {
  __typename: 'SavedExpertCuratedItemsEdge',
  node: SavedExpertCuratedItems,
  cursor: Scalars['String'],
};


export type SavedExpertCuratedItemsSearchFilter = {
  /** keywords for search
   * currently only supports the name of the saved curation and sellable title
 */
  keywords?: Maybe<Scalars['String']>,
  facets?: Maybe<Array<FacetSelection>>,
};

export type SavedLeadNote = {
  __typename: 'SavedLeadNote',
  id: Scalars['LeadNoteId'],
  lead: Lead,
  text: Scalars['String'],
  messageId?: Maybe<Scalars['String']>,
};

export type SavedSearch = {
  __typename: 'SavedSearch',
  id: Scalars['SavedSearchId'],
  title: Scalars['String'],
  entityName: Scalars['String'],
  count: Scalars['Int'],
};


export type SavedSearchResultConnection = LeadSearchConnection;

export type SavedSellable = {
  __typename: 'SavedSellable',
  id: Scalars['SavedSellableId'],
  sellable: Sellable,
  saved: Scalars['Boolean'],
  savedAt: Scalars['Date'],
  savedReason?: Maybe<SavedSellableReason>,
  savedReasonDisplay?: Maybe<Scalars['String']>,
  unsavedAt?: Maybe<Scalars['Date']>,
  unsavedReason?: Maybe<UnsavedSellableReason>,
  unsavedReasonDisplay?: Maybe<Scalars['String']>,
};

export type SavedSellableEdge = {
  __typename: 'SavedSellableEdge',
  node: SavedSellable,
  cursor: Scalars['String'],
};


export type SavedSellableQueryInput = {
  /** Defaults to the logged in user */
  userId?: Maybe<Scalars['UserId']>,
};

export enum SavedSellableReason {
  PRICE = 'PRICE',
  STYLE = 'STYLE',
  HIGH_QUALITY = 'HIGH_QUALITY',
  BRAND = 'BRAND'
}

export type SavedSellablesConnection = {
  __typename: 'SavedSellablesConnection',
  edges: Array<SavedSellableEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type SaveSavedSellableInput = {
  sellableId: Scalars['SellableId'],
  reason?: Maybe<SavedSellableReason>,
};

export type SaveSavedSellablePayload = {
  __typename: 'SaveSavedSellablePayload',
  savedSellable: SavedSellable,
};

export type ScheduledPayment = {
  __typename: 'ScheduledPayment',
  id: Scalars['ScheduledPaymentId'],
  amount: MonetaryAmount,
  payAt: Scalars['Date'],
  state: ScheduledPaymentState,
  order: Order,
  paymentSource: PaymentSource,
  remindedAt?: Maybe<Scalars['Date']>,
};


export enum ScheduledPaymentState {
  SCHEDULED = 'SCHEDULED',
  EXECUTED = 'EXECUTED',
  CANCELED = 'CANCELED'
}

export type SchedulingDemandForecast = {
  __typename: 'SchedulingDemandForecast',
  id: Scalars['SchedulingDemandForecastId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  maximumShiftUnits: Scalars['BigDecimal'],
  type: SchedulingType,
  locked: Scalars['Boolean'],
};

export type SchedulingDemandForecastDailyView = {
  __typename: 'SchedulingDemandForecastDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<SchedulingDemandForecast>,
  zoneId: Scalars['String'],
};

export type SchedulingDemandForecastDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  typeId: Scalars['SchedulingTypeId'],
};


export type SchedulingType = {
  __typename: 'SchedulingType',
  id: Scalars['SchedulingTypeId'],
  name: Scalars['String'],
  role: SchedulingUserRole,
  department?: Maybe<Department>,
  category?: Maybe<Category>,
};


export type SchedulingUser = {
  __typename: 'SchedulingUser',
  id: Scalars['AnyId'],
  profiles: Array<SchedulingUserProfile>,
  identity: SchedulingUserIdentity,
};

export type SchedulingUserAvailability = {
  __typename: 'SchedulingUserAvailability',
  id: Scalars['SchedulingUserAvailabilityId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  user: SchedulingUser,
  locked: Scalars['Boolean'],
};

export type SchedulingUserAvailabilityDailyView = {
  __typename: 'SchedulingUserAvailabilityDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<SchedulingUserAvailability>,
  zoneId: Scalars['String'],
};

export type SchedulingUserAvailabilityDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  userId: Scalars['AnyId'],
};


export type SchedulingUserIdentity = Operator | BusinessUser;

export type SchedulingUserProfile = {
  __typename: 'SchedulingUserProfile',
  type: SchedulingType,
  shiftUnits: Scalars['BigDecimal'],
  maximumShiftsPerWeek: Scalars['Int'],
  shiftDurationOptions: Array<ShiftDurationOption>,
  priority: Scalars['Int'],
};

export enum SchedulingUserRole {
  EXPERT = 'EXPERT'
}

export enum ScrapingJobType {
  SCRAPINGHUB = 'SCRAPINGHUB'
}

export type ScrapingSellablePriceSource = SellablePriceSource & {
  __typename: 'ScrapingSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  url: Scalars['String'],
  spider: ScrapingSellablePriceSourceSpider,
};

export enum ScrapingSellablePriceSourceSpider {
  EVO = 'EVO',
  PROGOLFYAKIMA = 'PROGOLFYAKIMA',
  JENSONUSA = 'JENSONUSA',
  BIKEBLING = 'BIKEBLING',
  CHAINREACTIONCYCLES = 'CHAINREACTIONCYCLES',
  CAMBRIABIKE = 'CAMBRIABIKE'
}

export type SelectExpertCuratedOrderItemInput = {
  id: Scalars['SellableId'],
  selected: Scalars['Boolean'],
};

export type SelectExpertCuratedOrderItemsInput = {
  id: Scalars['ExpertCuratedOrderId'],
  items: Array<SelectExpertCuratedOrderItemInput>,
};

export type SelectExpertCuratedOrderItemsPayload = {
  __typename: 'SelectExpertCuratedOrderItemsPayload',
  expertCuratedOrder: ExpertCuratedOrder,
  errorCode?: Maybe<ExpertCuratedOrderSelectErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
  /** If errorCode is NOT_ACTIVE and this is present, it means this is the latest active update which replaces
   * `expertCuratedOrder`.
 */
  activeReplacement?: Maybe<ExpertCuratedOrder>,
};

export type SelectExpertCuratedOrderVariationOptionInput = {
  id: Scalars['ExpertCuratedOrderId'],
  sellableId: Scalars['SellableId'],
};

export type SelectExpertCuratedOrderVariationOptionPayload = {
  __typename: 'SelectExpertCuratedOrderVariationOptionPayload',
  expertCuratedOrder: ExpertCuratedOrder,
  errorCode?: Maybe<ExpertCuratedOrderSelectErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
  /** If errorCode is NOT_ACTIVE and this is present, it means this is the latest active update which replaces
   * `expertCuratedOrder`.
 */
  activeReplacement?: Maybe<ExpertCuratedOrder>,
};

export type Sellable = {
  __typename: 'Sellable',
  id: Scalars['SellableId'],
  /** Case-insensitive ID */
  googleId: Scalars['String'],
  /** The ID in the google shopping feed for this sellable
   * If the sellable has GTIN or MPN, this is the same as googleId. Otherwise, it is the parent sellable's googleId
 */
  feedId: Scalars['String'],
  /** Title of the product or service */
  title: Scalars['String'],
  /** Plain text description */
  descriptionText?: Maybe<Scalars['String']>,
  /** Description in GitHub-flavored Markdown format
   * See https://github.github.com/gfm/
 */
  descriptionMarkdown?: Maybe<Scalars['String']>,
  /** categories this sellable is associated with */
  categories: Array<Category>,
  /** if this sellable is a product or service */
  type: SellableType,
  /** MSRP price of this sellable; omittied if not applicable/available. Note that this is not what the consumer pays for
   * the product on Deal.com; salePrice is the actual price paid for the product.
 */
  originalPrice?: Maybe<MonetaryAmount>,
  price?: Maybe<MonetaryAmount>,
  /** default price we sell to consumer without tax; omitted if not applicable/available (usually for parent sellable) */
  salePrice?: Maybe<MonetaryAmount>,
  /** the price source of the sale price. for legacy sale price, this source may not exist, even though salePrice exists */
  salePriceSource?: Maybe<SellablePriceSource>,
  /** The amount of savings `salePrice` offers over `originalPrice`; null if there are no savings, or there is no
   * `originalPrice`
 */
  savingsAmountFromOriginaPrice?: Maybe<MonetaryAmount>,
  /** Percent savings for `savingsAmountFromOriginaPrice` */
  savingsPercentFromOriginalPrice?: Maybe<Scalars['Float']>,
  /** Default price we sell to the consumer for with estimated tax. If no input is provided, the user's address associated
   * with their account will be used. If no address is found/provided, or there is no sale price, this field will be null.
 */
  salePriceWithEstimatedTax?: Maybe<MonetaryAmountWithTax>,
  brand?: Maybe<Brand>,
  images: Array<MediaFile>,
  /** Subset of ids in `images` that are sample/backfill images, and not indicative of the exact product or service the
   * customer is receiving.
 */
  sampleImageIds: Array<Scalars['MediaId']>,
  active: Scalars['Boolean'],
  /** The parent sellable if this is a child variant */
  parent?: Maybe<Sellable>,
  /** If this sellable is a variant */
  variant: Scalars['Boolean'],
  /** Computed n-dimension matrix of all of the child variants of this product (e.g.: color, size, etc variations) */
  variationMatrix?: Maybe<VariationMatrix>,
  /** Get formatted components that make up this sellable's unique variant (e.g.: red color, Medium size, etc) */
  variants: Array<SellableFormattedVariant>,
  /** Specifications table */
  specifications: Array<SellableSpecification>,
  /** Get all standardized attributes for this sellable. Note that this will be a subset of specifications. */
  attributes: Array<Attribute>,
  /** Get a specific standardized attribute. */
  attribute?: Maybe<Attribute>,
  /** If this sellable is in the user's cart */
  inCart: Scalars['Boolean'],
  /** Unique sources this sellable is associated with. */
  sources: Array<SellableSource>,
  /** If this sellable type is a service, the location at which this service is provided */
  serviceLocation?: Maybe<SellableServiceLocation>,
  /** If this sellable is created ad-hoc for single use (e.g.: created for a single customer).
   * Ad-hoc sellables are not surfaced in search, and are primarily used for experts to sell items we don't have a
   * proper standardized sellable for, but have some means to fulfill.
 */
  adHoc: Scalars['Boolean'],
  consumerUrl: Scalars['String'],
  /** Retrieve expert curated items associated with the specified lead and this sellable, or any of it's variations.
   * If leadId is null, this property will return an empty list. This is to simplify client side queries so the same
   * query can be used for UIs that require and don't require this property
 */
  expertCuratedItemsForLead: Array<ExpertCuratedItem>,
  /** List of features this product/service has */
  features: Array<Scalars['String']>,
  /** Featured rich content from various sites (e.g.: YouTube, Instagram, review sites, etc) */
  featuredContent?: Maybe<FeaturedSellableContent>,
  /** Metrics about this sellable, like page views, purchase count etc. */
  metrics?: Maybe<SellableMetrics>,
  /** If the current user has saved (or subsequently unsaved) this sellable */
  savedSellable?: Maybe<SavedSellable>,
  /** If this particular sellable is out of stock. If this is the parent sellable that is not sellable, it will always
   * be out of stock since it is not sellable in its self.
 */
  outOfStock: Scalars['Boolean'],
  /** If part of a variation, checks if all child/sibling variants are out of stock. If not in a variation, this is
   * identical to `outOfStock`
 */
  areAllVariantsOutOfStock: Scalars['Boolean'],
  department?: Maybe<Department>,
  /** All price sources */
  priceSources: Array<SellablePriceSource>,
  /** Note that this slug is for SEO purposes to put in the url, and is NOT globally unique. The friendlyId should be
   * added to the URL as a unique identifier
 */
  slug: Scalars['String'],
  /** Alternative unique identifier that's shorter than `id`, and more SEO friendly. If not present, it means this
   * sellable is not intended to be discovered via search (e.g.: ad hoc sellables).
 */
  friendlyId?: Maybe<Scalars['String']>,
  /** A flag indicating if this sellable is in short supply */
  inShortSupply: Scalars['Boolean'],
  /** Best-effort search on recent active expert curated items an expert extended to the current user that match this
   * exact sellable, or a variant of this sellable
 */
  recentExpertCuratedItem?: Maybe<ExpertCuratedItem>,
  /** Returns Sellable reactions in context of the viewer. For Consumer, it returns the reactions given by the user to
   * this specific sellable, while in context of Expert, this returns the
   * ConsumerSellableReaction's given by all users to this expert
 */
  consumerSellableReactions?: Maybe<ConsumerSellableReactionConnection>,
  /** url to html page providing 360 view of the product, currently used for diamonds */
  dynamic360ViewUrl?: Maybe<Scalars['String']>,
  /** GIA cert url for diamonds */
  certificateUrl?: Maybe<Scalars['String']>,
};


export type SellableSalePriceWithEstimatedTaxArgs = {
  input?: Maybe<EstimatedTaxLocationInput>
};


export type SellableAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};


export type SellableExpertCuratedItemsForLeadArgs = {
  leadId?: Maybe<Scalars['LeadId']>,
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>,
  sort?: Maybe<ExpertCuratedItemSort>
};


export type SellableConsumerSellableReactionsArgs = {
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};

export type SellableAttributeFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableAttributeFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  attributes: Array<Attribute>,
  rawAttributes: Array<RawAttribute>,
  comparison: SellableAttributePromotionRuleReferenceComparison,
  strategy: PromotionRuleFilterStrategy,
};

/** See `SellableAttributeFilterPromotionRuleReference` for documentation */
export type SellableAttributeFilterPromotionRuleReferenceInput = {
  attributes?: Maybe<Array<AttributeInput>>,
  rawAttributes?: Maybe<Array<RawAttributeInput>>,
  comparison: SellableAttributePromotionRuleReferenceComparison,
  strategy: PromotionRuleFilterStrategy,
};

export enum SellableAttributePromotionRuleReferenceComparison {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL'
}

export type SellableBrandFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableBrandFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  brands: Array<Brand>,
  strategy: PromotionRuleFilterStrategy,
};

/** See `SellableBrandFilterPromotionRuleReference` for documentation */
export type SellableBrandFilterPromotionRuleReferenceInput = {
  brandIds: Array<Scalars['BrandId']>,
  strategy: PromotionRuleFilterStrategy,
};

/** Filter or exclude (depending on `strategy`) line item sellables that match `categories` */
export type SellableCategoryFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableCategoryFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  categories: Array<Category>,
  strategy: PromotionRuleFilterStrategy,
  /** If children, parents, or both of `categories` should also be included during the filtering/excluding evaluation */
  traversalOptions: Array<SellableCategoryFilterPromotionRuleReferenceTraversalOption>,
};

/** See `SellableCategoryFilterPromotionRuleReference` for documentation */
export type SellableCategoryFilterPromotionRuleReferenceInput = {
  categoryIds: Array<Scalars['CategoryId']>,
  strategy: PromotionRuleFilterStrategy,
  traversalOptions: Array<SellableCategoryFilterPromotionRuleReferenceTraversalOption>,
};

export enum SellableCategoryFilterPromotionRuleReferenceTraversalOption {
  INCLUDE_PARENTS = 'INCLUDE_PARENTS',
  INCLUDE_CHILDREN = 'INCLUDE_CHILDREN'
}

export type SellableDeactivationTaskPayload = {
  __typename: 'SellableDeactivationTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableDisabled: Scalars['Int'],
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
};

/** Filter or exclude (depending on `strategy`) line items that match `sellables`, or their parents match `sellables` */
export type SellableFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableFilterPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  sellables: Array<Sellable>,
  strategy: PromotionRuleFilterStrategy,
};

/** See `SellableFilterPromotionRuleReference` for documentation */
export type SellableFilterPromotionRuleReferenceInput = {
  sellableIds: Array<Scalars['SellableId']>,
  strategy: PromotionRuleFilterStrategy,
};

export type SellableFormattedVariant = {
  __typename: 'SellableFormattedVariant',
  /** Internal name for this variant; not intended to be displayed in the UI */
  name: Scalars['String'],
  /** Display name for this variant.
   * This may be something like "Color", "Length", where it effectively serves as a title. Note that this display name is
   * not required. For example, if there is only one dimension, and that's a title dimension, the grouping may not be
   * titled. For title dimensions, the display name may be the shortened product title, e.g.: "Red Special Edition",
   * "Anniversary Edition", "Game of the year bundle".
 */
  displayName?: Maybe<Scalars['String']>,
  /** Internal value; not to be displayed in the UI. Expect this to be things like "RED", "123", "WOMAN", etc. */
  value: Scalars['String'],
  /** Display value formatted as sanitized HTML. To match with the value property examples, expect this to be things like
   * "Red", "123cm", "Woman", etc.
 */
  displayValueHtml: Scalars['String'],
};


export type SellableInventoryItem = {
  __typename: 'SellableInventoryItem',
  id: Scalars['SellableInventoryItemId'],
  category: Category,
  dealSku: Scalars['String'],
  /** External inventory source if managed by a third party management tool */
  externalInventoryItemSource?: Maybe<ExternalInventoryItemSource>,
  gtin?: Maybe<Scalars['String']>,
  mpn?: Maybe<Scalars['String']>,
  attributes: Array<Attribute>,
  rawAttributes: Array<RawAttribute>,
  /** The total available quantity to sell across all fulfillment centers
   * This will take into account any orders that are yet to be fulfilled but are scheduled to be fulfilled
 */
  totalAvailableToOrder: Scalars['Int'],
  /** Availability to order by fulfillment center */
  orderAvailabilityByFulfillmentCenter: Array<AvailabilityByFulfillmentCenter>,
  inventoryItemLevels: Array<SellableInventoryItemLevel>,
  cost?: Maybe<MonetaryAmount>,
  msrp?: Maybe<MonetaryAmount>,
  map?: Maybe<MonetaryAmount>,
};


export type SellableInventoryItemLevel = {
  __typename: 'SellableInventoryItemLevel',
  /** Details of fulfillment center where this inventory is located */
  fulfillmentCenter: FulfillmentCenter,
  /** time when the inventory level was updated */
  updatedAt: Scalars['Date'],
  /** current quantity of items available at this Fulfillment Center */
  availableAtFulfillmentCenter: Scalars['Int'],
  /** current number of items in transit to this Fulfillment Center */
  inTransitShippedToFulfillmentCenter: Scalars['Int'],
};

export type SellableInventoryItemLevelUpdateInput = {
  fulfillmentCenterId: Scalars['FulfillmentCenterId'],
  totalShippedToFulfillmentCenter?: Maybe<Scalars['Int']>,
  availableAtFulfillmentCenter?: Maybe<Scalars['Int']>,
};

export type SellableInventoryItemUpdateInput = {
  id: Scalars['SellableInventoryItemId'],
  gtin?: Maybe<Scalars['String']>,
  /** manufacture part number */
  mpn?: Maybe<Scalars['String']>,
  /** Updates to inventory level are allowed as a backup in case of synchronization or data integrity issues
   * The values act as overrides so use them carefully
 */
  inventoryLevels?: Maybe<Array<SellableInventoryItemLevelUpdateInput>>,
  /** The purchase price of the sellable per unit */
  cost?: Maybe<MonetaryAmountInput>,
  /** The msp of the sellable */
  msrp?: Maybe<MonetaryAmountInput>,
};

export type SellableInventoryItemUpdatePayload = {
  __typename: 'SellableInventoryItemUpdatePayload',
  data?: Maybe<SellableInventoryItem>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type SellableInventoryUploadTaskPayload = {
  __typename: 'SellableInventoryUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numInventoryItemsCreated: Scalars['Int'],
  numInventoryItemsUpdated: Scalars['Int'],
  errors: Array<InventoryTaskError>,
  googleSpreadsheetId: Scalars['String'],
  /** The file to be uploaded on UPS when this new inventory ships */
  upsShipmentUploadFile?: Maybe<MediaFile>,
};

export type SellableMetrics = {
  __typename: 'SellableMetrics',
  /** Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the hourly window is considered a single event
 */
  totalUniqueInPastHour?: Maybe<Scalars['Long']>,
  totalUniquePVsInPastHour?: Maybe<Scalars['Int']>,
  /** Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the day long window is considered a single event
 */
  totalUniqueInPastDay?: Maybe<Scalars['Long']>,
  totalUniquePVsInPastDay?: Maybe<Scalars['Int']>,
  /** Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the week long window is considered a single event
 */
  totalUniqueInPastWeek?: Maybe<Scalars['Long']>,
  totalUniquePVsInPastWeek?: Maybe<Scalars['Int']>,
  /** total number of purchases in the past day across all users */
  totalPurchasesInPast24Hours?: Maybe<Scalars['Long']>,
  totalPurchasesInLast24Hours?: Maybe<Scalars['Int']>,
  /** total number of purchases in the past 30 days across all users */
  totalPurchasesInPast30Days?: Maybe<Scalars['Long']>,
  totalPurchasesInLast30Days?: Maybe<Scalars['Int']>,
  timesRecommendedByExpert?: Maybe<Scalars['Int']>,
};

export type SellablePriceSource = {
  __typename: 'SellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
};


export enum SellablePriceSourceType {
  DEAL = 'DEAL',
  AMAZON = 'AMAZON',
  EBAY = 'EBAY',
  SCRAPING = 'SCRAPING',
  YADAV = 'YADAV',
  RAW_SELLABLE_SCRAPER = 'RAW_SELLABLE_SCRAPER'
}

export type SellablePriceUploadTaskPayload = {
  __typename: 'SellablePriceUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableUpdated: Scalars['Int'],
  numSellableCreated: Scalars['Int'],
  numSellableDisabled: Scalars['Int'],
  errorRows: Array<Scalars['Int']>,
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
};

export type SellableResearchLink = {
  __typename: 'SellableResearchLink',
  id: Scalars['SellableResearchLinkId'],
  createdAt: Scalars['Date'],
  active: Scalars['Boolean'],
  createdBy: BusinessUser,
  sellable: Sellable,
  url: Scalars['String'],
};

export type SellableResearchLinkFilter = {
  sellableId?: Maybe<Scalars['SellableId']>,
  parentSellableId?: Maybe<Scalars['SellableId']>,
  createdById?: Maybe<Scalars['BusinessUserId']>,
};


export type SellableSearchConnection = {
  __typename: 'SellableSearchConnection',
  facets: Array<DisplayFacet>,
  edges: Array<SellableSearchEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
  /** Additional metadata that could describe the associated results */
  pageMetadata?: Maybe<SellableSearchResultPageMetadata>,
};

export type SellableSearchEdge = {
  __typename: 'SellableSearchEdge',
  node: Sellable,
  cursor: Scalars['String'],
};

export type SellableSearchFacetsPayload = {
  __typename: 'SellableSearchFacetsPayload',
  facets: Array<FacetSelectionPayload>,
};

export type SellableSearchFacetsQuery = {
  /** hack - this is mainly used to provide a facet selection mapping from the external brand ids to internal brand ids */
  brandIds?: Maybe<Array<Scalars['BrandId']>>,
};

export enum SellableSearchFacetsQueryFilter {
  /** Returns facets that have attributes that are marked as PRIMARY in the specific category.
   * In case there are multiple PRIMARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
 */
  FIRST_PRIMARY_ATTRIBUTE_ONLY = 'FIRST_PRIMARY_ATTRIBUTE_ONLY',
  /** All facets with PRIMARY attributes are returned, ordered by category specific sorting. */
  ALL_PRIMARY_ATTRIBUTES = 'ALL_PRIMARY_ATTRIBUTES',
  /** Returns facets that have attributes that are marked as SECONDARY in the specific category.
   * In case there are multiple SECONDARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
 */
  FIRST_SECONDARY_ATTRIBUTE_ONLY = 'FIRST_SECONDARY_ATTRIBUTE_ONLY',
  /** All facets with SECONDARY attributes are returned, ordered by category specific sorting. */
  ALL_SECONDARY_ATTRIBUTES = 'ALL_SECONDARY_ATTRIBUTES',
  /** Returns brand facets for the specific category */
  INCLUDE_BRANDS = 'INCLUDE_BRANDS',
  /** Excludes out of stock sellables while building the facets */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK',
  /** Include gender facet */
  INCLUDE_GENDER = 'INCLUDE_GENDER',
  /** Include Sale price facet as a range */
  INCLUDE_SALE_PRICE_RANGE = 'INCLUDE_SALE_PRICE_RANGE',
  /** Only includes sellables that have discounts */
  INCLUDE_DISCOUNTED_ONLY = 'INCLUDE_DISCOUNTED_ONLY'
}

export enum SellableSearchFilter {
  /** Returns sellables that have discounts only
   * In addition if the sorting is by relevancy, it boosts the sellables that have their price updated recently
   * higher in the result set.
 */
  DISCOUNTED = 'DISCOUNTED',
  /** Exclude out of stock sellables */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK'
}

export type SellableSearchQuery = {
  facets?: Maybe<Array<FacetSelection>>,
  title?: Maybe<Scalars['String']>,
  keywords?: Maybe<Scalars['String']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  categorySlugs?: Maybe<Array<Scalars['String']>>,
  /** The department Id or slug is internally expanded to include all children categories within the department */
  departmentId?: Maybe<Scalars['DepartmentId']>,
  departmentSlug?: Maybe<Scalars['String']>,
  brandIds?: Maybe<Array<Scalars['BrandId']>>,
  /** If omitted, defaults to CONSUMER_SEARCH */
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>,
  /** Admin/Expert search queries can pass the UserId to see the results that the specified consumer will see. */
  impersonatingUserId?: Maybe<Scalars['UserId']>,
  /** To restrict the search results to a specific SellableType */
  type?: Maybe<SellableType>,
  /** Top N facet terms to be returned per facet. */
  maxFacetTerms?: Maybe<Scalars['Int']>,
  /** Explicit query filters that are applied to the search results. These provide special query conditions
   * that are different than facets or categories for example.
   * In case of multiple SellableSearchFilters, all input SellableSearchFilters are ANDed
 */
  filters?: Maybe<Array<SellableSearchFilter>>,
};

export type SellableSearchResultPageMetadata = {
  __typename: 'SellableSearchResultPageMetadata',
  featuredFacets: Array<DisplayFacet>,
  /** The page title is generated using following rules, that are applied in order:
   * 1. The title is generated based on the Facet Selection input instead of the Facet results.
   * 2. A selected facets value is used only if there is a single selection. This is enforced to keep the title
   *    as clean and simple as possible, instead of adding comma separated values of facet selections.
   * 3. Presence of Brand or Destination is used to imply if the request is for products or services.
   *    If Brand is present it is assumed it is a product category, similarly if destination is present it is
   *    assumed to be a service.
   * 5. Gender applies only to product categories
   * 6. Appends feature facet value if there is a single featured facet with single selection
   * 7. Category names are appended if the category is present. This has 2 forms: Singular or Plural name and the choice
   *    depends on a few factors.
   *    a. If SellableSearchFilters are supplied, it uses the Singular Category name and decorates the title with filter
   *       specific suffix. For ex: Deals for SellableSearchFilter#DISCOUNTED
   *    b. Otherwise, use Plural Category name.
 */
  pageTitle: Scalars['String'],
  /** An optional image associated with the page title. */
  pageTitleImage?: Maybe<MediaFile>,
};

export enum SellableSearchUseCase {
  CONSUMER_SEARCH = 'CONSUMER_SEARCH',
  EXPERT_SEARCH = 'EXPERT_SEARCH',
  IMPERSONATE_CONSUMER = 'IMPERSONATE_CONSUMER',
  OPS_SEARCH = 'OPS_SEARCH',
  /** This use case for consumer does not take the user intent into account and is basically a simple brand search query */
  CONSUMER_HOME_PAGE_BY_BRANDS = 'CONSUMER_HOME_PAGE_BY_BRANDS'
}

export type SellableServiceLocation = {
  __typename: 'SellableServiceLocation',
  displayTitle?: Maybe<Scalars['String']>,
};


export type SellableServiceLocationDisplayTitleArgs = {
  displayType: SellableServiceLocationDisplayType
};

export enum SellableServiceLocationDisplayType {
  CITY_STATE = 'CITY_STATE'
}

export enum SellableSort {
  /** Average sale price is calculated as (min + max)/2 for all variations */
  AVG_SALE_PRICE = 'AVG_SALE_PRICE',
  /** Savings = actual price - sale price */
  MAX_PRICE_SAVINGS = 'MAX_PRICE_SAVINGS',
  /** Percent savings = (actual price - sale price)/actual price */
  MAX_PRICE_PERCENT_SAVINGS = 'MAX_PRICE_PERCENT_SAVINGS',
  /** Defined as the unique page views in the last 7 days */
  POPULARITY = 'POPULARITY',
  /** Defined as the number of purchases in the last 30 days */
  BEST_SELLER = 'BEST_SELLER',
  /** Relevance score computed from sellables that match users intent */
  RELEVANCE = 'RELEVANCE',
  /** This is the fastest way to get results if ordering is not important */
  INDEX_ORDER = 'INDEX_ORDER',
  /** An stable way to paginate across all indexed documents */
  DOC_ID_ORDER = 'DOC_ID_ORDER'
}

export type SellableSource = {
  __typename: 'SellableSource',
  type: SellableSourceType,
};

export type SellableSourceExternalId = SellableSource & {
  __typename: 'SellableSourceExternalId',
  type: SellableSourceType,
  externalId: Scalars['String'],
  externalIdType: SellableSourceExternalIdType,
};

export enum SellableSourceExternalIdType {
  YADAV_DIAMOND = 'YADAV_DIAMOND',
  YADAV_SETTING = 'YADAV_SETTING'
}

export type SellableSourceStandardizedSellableGroup = SellableSource & {
  __typename: 'SellableSourceStandardizedSellableGroup',
  type: SellableSourceType,
  standardizedSellableGroup: StandardizedSellableGroup,
};

export enum SellableSourceType {
  URL = 'URL',
  EXTERNAL_ID = 'EXTERNAL_ID',
  STANDARDIZED_SELLABLE_GROUP = 'STANDARDIZED_SELLABLE_GROUP'
}

export type SellableSourceUrl = SellableSource & {
  __typename: 'SellableSourceUrl',
  type: SellableSourceType,
  url: Scalars['String'],
};

export type SellableSpecification = {
  __typename: 'SellableSpecification',
  /** Internal unique name that can be used as a unique key for referencing this specification entry.
   * This name is human readable and consistent to match the underlying data source (e.g.: attribute:fooBar), so UI
   * treatments can be created if these keys are hard coded and checked against.
 */
  key?: Maybe<Scalars['String']>,
  /** Display name for the specification */
  name: Scalars['String'],
  /** Display HTML value for the specification */
  valueHtml: Scalars['String'],
};

export type SellableTaskError = {
  __typename: 'SellableTaskError',
  row: Scalars['Int'],
  message: Scalars['String'],
};

export type SellableTerms = {
  __typename: 'SellableTerms',
  id: Scalars['SellableTermsId'],
  createdFor: User,
  createdByExpert?: Maybe<BusinessUser>,
  orderLineItemId: Scalars['OrderLineItemId'],
  order: Order,
  type: SellableType,
};


export enum SellableType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type SellableTypeaheadHit = {
  __typename: 'SellableTypeaheadHit',
  id: Scalars['SellableId'],
  /** The matched text string in the indexed keywords */
  text: Scalars['String'],
  /** The sellable title */
  title: Scalars['String'],
  /** The Brand name associated with this Sellable if present */
  brandName?: Maybe<Scalars['String']>,
  /** Image url if present for this Sellable. Typically, Sellables will have multiple images but this returns only one
   * since its usage is restricted to the typeahead
 */
  imageUrl?: Maybe<Scalars['String']>,
  /** For maximum typeahead performance, don't resolve this sellable property */
  sellable: Sellable,
};

export type SellableTypeaheadPayload = {
  __typename: 'SellableTypeaheadPayload',
  hits: Array<SellableTypeaheadHit>,
};

export type SellableTypeaheadQuery = {
  prefixSearch?: Maybe<Scalars['String']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  categorySlugs?: Maybe<Array<Scalars['String']>>,
  /** The department Id or slug is internally expanded to include all children categories within the department */
  departmentId?: Maybe<Scalars['DepartmentId']>,
  departmentSlug?: Maybe<Scalars['String']>,
  /** If omitted, defaults to CONSUMER_SEARCH */
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>,
};

export type SellableUpdateTaskPayload = {
  __typename: 'SellableUpdateTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableUpdated: Scalars['Int'],
  numSellableSkipped: Scalars['Int'],
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
};

export type SellableUploadTaskPayload = {
  __typename: 'SellableUploadTaskPayload',
  numRowsProcessed: Scalars['Int'],
  numRowsIgnored: Scalars['Int'],
  numSellableUpdated: Scalars['Int'],
  numSellableCreated: Scalars['Int'],
  numSellableDisabled: Scalars['Int'],
  numSellableVariationFilteredOut: Scalars['Int'],
  errorRows: Array<Scalars['Int']>,
  errors: Array<SellableTaskError>,
  googleSpreadsheetId: Scalars['String'],
};

export type SendExpertReferralInput = {
  expertId: Scalars['BusinessUserId'],
  referrerId: Scalars['UserId'],
  emails: Array<Scalars['String']>,
  note: Scalars['String'],
};

export type SendExpertReferralPayload = {
  __typename: 'SendExpertReferralPayload',
  expertReferral?: Maybe<ExpertReferral>,
  errors: Array<Scalars['String']>,
};

export type SendTemplateTestMessageInput = {
  templateId: Scalars['CommTemplateId'],
  variables: Array<RenderCommTemplateVariableInput>,
  channelType: ChannelType,
  contact: Scalars['String'],
};

export type SendTemplateTestMessagePayload = {
  __typename: 'SendTemplateTestMessagePayload',
  success: Scalars['Boolean'],
  error?: Maybe<Scalars['String']>,
};

export type ServiceDealTerms = {
  __typename: 'ServiceDealTerms',
  type: DealTermsType,
  additionalDetails?: Maybe<Scalars['String']>,
};

export type ServiceOfferTerms = {
  __typename: 'ServiceOfferTerms',
  dateTimes?: Maybe<Array<Scalars['Date']>>,
  confirmedTime?: Maybe<Scalars['Date']>,
  additionalDetails?: Maybe<Scalars['String']>,
  termDocuments: Array<MediaFile>,
};

export type ServiceOfferTermsInput = {
  dateTimes?: Maybe<Array<Scalars['Date']>>,
  additionalDetails?: Maybe<Scalars['String']>,
  termDocuments?: Maybe<Array<Scalars['MediaId']>>,
};

export type ServiceSellableTerms = SellableTerms & {
  __typename: 'ServiceSellableTerms',
  id: Scalars['SellableTermsId'],
  createdFor: User,
  createdByExpert?: Maybe<BusinessUser>,
  orderLineItemId: Scalars['OrderLineItemId'],
  order: Order,
  type: SellableType,
  startAt: Scalars['Date'],
};

export type Session = {
  __typename: 'Session',
  id: Scalars['SessionId'],
  authenticationMethod?: Maybe<AuthenticationMethod>,
  authenticationState: AuthenticationSessionState,
};


export type SetAcceptingNewRequestsInput = {
  id: Scalars['BusinessUserId'],
  accept: Scalars['Boolean'],
};

export type SetAcceptingNewRequestsPayload = {
  __typename: 'SetAcceptingNewRequestsPayload',
  businessUser?: Maybe<BusinessUser>,
};

export type SetConsumerInitialLeadActionInput = {
  leadId: Scalars['LeadId'],
  action: ConsumerInitialLeadAction,
};

export type SetConsumerInitialLeadActionPayload = {
  __typename: 'SetConsumerInitialLeadActionPayload',
  lead?: Maybe<Lead>,
};

export type SetEscalationPriorityInput = {
  escalationId: Scalars['OrderEscalationId'],
  priority: OrderEscalationPriority,
};

export type SetExpertApplicationArchivedInput = {
  applicationId: Scalars['ExpertApplicationId'],
  archived: Scalars['Boolean'],
};

export type SetExpertApplicationSnoozeInput = {
  applicationId: Scalars['ExpertApplicationId'],
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  cancelMessageOnReply?: Maybe<Scalars['Boolean']>,
};

export type SetExpertApplicationTaskCompletedInput = {
  applicationId: Scalars['ExpertApplicationId'],
  task: ExpertApplicationTaskType,
};

export type SetExpertApplicationTaskCompletedPayload = {
  __typename: 'SetExpertApplicationTaskCompletedPayload',
  error?: Maybe<Scalars['String']>,
  application: ExpertApplication,
};

export type SetExpertOnCallInput = {
  id: Scalars['BusinessUserId'],
  onCall: Scalars['Boolean'],
};

export type SetExpertOnCallPayload = {
  __typename: 'SetExpertOnCallPayload',
  businessUser: BusinessUser,
};

export type SetLeadArchivedInput = {
  leadId: Scalars['LeadId'],
  archived: Scalars['Boolean'],
};

export type SetLeadDoNotCallInput = {
  leadId: Scalars['LeadId'],
  doNotCall: Scalars['Boolean'],
};

export type SetLeadSnoozeInput = {
  leadId: Scalars['LeadId'],
  wakeupTime: Scalars['Date'],
  note?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  cancelMessageOnConsumerReply?: Maybe<Scalars['Boolean']>,
};

export type SetLeadStarInput = {
  leadId: Scalars['LeadId'],
  starred: Scalars['Boolean'],
};

export type SetPreferredMessagingChannelInput = {
  messagingUserId: Scalars['AnyId'],
  preferredMessagingChannel: MessagingChannelType,
};

export type SetPreferredMessagingChannelPayload = {
  __typename: 'SetPreferredMessagingChannelPayload',
  messagingUser: MessagingUser,
};

export type SetTemplateActiveInput = {
  templateId: Scalars['CommTemplateId'],
  active: Scalars['Boolean'],
};

export type SetTemplateActivePayload = {
  __typename: 'SetTemplateActivePayload',
  updatedTemplate?: Maybe<MultiLocaleTemplateSet>,
  defaultTemplate?: Maybe<MultiLocaleTemplateSet>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type Shift = {
  __typename: 'Shift',
  id: Scalars['ShiftId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  state: ShiftState,
  user: SchedulingUser,
};

export type ShiftDailyView = {
  __typename: 'ShiftDailyView',
  date: Scalars['LocalDate'],
  orderedList: Array<Shift>,
  zoneId: Scalars['String'],
};

export type ShiftDailyViewFilter = {
  zoneId: Scalars['String'],
  startDateInclusive: Scalars['LocalDate'],
  endDateExclusive: Scalars['LocalDate'],
  userId: Scalars['AnyId'],
};

export enum ShiftDurationOption {
  THREE_HOURS = 'THREE_HOURS',
  ONE_AND_HALF_HOURS = 'ONE_AND_HALF_HOURS'
}


export enum ShiftState {
  PROPOSED = 'PROPOSED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED'
}

export type ShipmentTracking = {
  __typename: 'ShipmentTracking',
  trackingNumber: Scalars['String'],
  shippingCarrier: ShippingCarrier,
  status: ShippingStatus,
  estimatedDeliveryTime?: Maybe<Scalars['Date']>,
  trackingUrl?: Maybe<Scalars['String']>,
};

export type ShipmentTrackingInput = {
  orderId: Scalars['OrderId'],
  orderLineItemId: Scalars['OrderLineItemId'],
  shippingCarrierId: Scalars['ShippingCarrierId'],
  trackingNumber: Scalars['String'],
};

export type ShipmentTrackingRemovedActivity = OrderActivityDetail & {
  __typename: 'ShipmentTrackingRemovedActivity',
  type: OrderActivityDetailType,
  removedBy?: Maybe<Operator>,
};

export type ShipmentTrackingUpdatedActivity = OrderActivityDetail & {
  __typename: 'ShipmentTrackingUpdatedActivity',
  type: OrderActivityDetailType,
  shippingCarrier: ShippingCarrier,
  trackingNumber: Scalars['String'],
  updatedBy?: Maybe<Operator>,
};

export type ShippingCarrier = {
  __typename: 'ShippingCarrier',
  id: Scalars['ShippingCarrierId'],
  code: Scalars['String'],
  displayName: Scalars['String'],
};


export enum ShippingMethod {
  /** Standard ground (default) */
  STANDARD = 'STANDARD',
  /** Expedited shipping */
  EXPEDITED = 'EXPEDITED'
}

export type ShippingMethodCost = {
  __typename: 'ShippingMethodCost',
  shippingMethod: ShippingMethod,
  cost: MonetaryAmount,
  /** Rough estimate of when the entire order will be delivered to the customer using this shipping method. If the order
   * isn't purchased yet, this will use the current time to compute the estimation.
 */
  estimatedToArriveAt: Scalars['Date'],
};

export enum ShippingPolicy {
  NO_SHIPPING = 'NO_SHIPPING',
  FREE_SHIPPING = 'FREE_SHIPPING',
  PAID_BY_CUSTOMER = 'PAID_BY_CUSTOMER'
}

export enum ShippingStatus {
  UNKNOWN = 'UNKNOWN',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED',
  FAILURE = 'FAILURE',
  RETURNED = 'RETURNED'
}

export type ShortenUrlInput = {
  url: Scalars['String'],
  preferredDomain?: Maybe<Scalars['String']>,
};

export type ShortenUrlPayload = {
  __typename: 'ShortenUrlPayload',
  url: Scalars['String'],
};

export type SimilarSellablePayload = {
  __typename: 'SimilarSellablePayload',
  sellables?: Maybe<Array<Sellable>>,
};

export type SimpleCuratedOrder = {
  __typename: 'SimpleCuratedOrder',
  id: Scalars['SimpleCuratedOrderId'],
  curator: BusinessUser,
  curatedFor: User,
  order: Order,
  lead: Lead,
  type: SimpleCuratedOrderType,
  /** Expose id fields for trigger entity */
  curatorId: Scalars['BusinessUserId'],
  curatedForId: Scalars['UserId'],
  leadId: Scalars['LeadId'],
  orderId: Scalars['OrderId'],
};


export enum SimpleCuratedOrderType {
  EXPERT_CONSULTATION_FEE = 'EXPERT_CONSULTATION_FEE'
}

export type SingleCategoryGroupedBrandStatsAggregateExpertReport = {
  __typename: 'SingleCategoryGroupedBrandStatsAggregateExpertReport',
  id: Scalars['CategoryId'],
  category: Category,
  categoryStats: Array<BrandStatsAggregateExpertReport>,
};


export type SingleCategoryGroupedBrandStatsAggregateExpertReportCategoryStatsArgs = {
  limit: Scalars['Int']
};

export type SingleLocaleTemplateSet = {
  __typename: 'SingleLocaleTemplateSet',
  locale: Scalars['String'],
  templates: Array<ChannelTemplate>,
};

export type SlackTemplate = ChannelTemplate & {
  __typename: 'SlackTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type SlackTemplateInput = {
  body: Scalars['String'],
};

export type SmsTemplate = ChannelTemplate & {
  __typename: 'SmsTemplate',
  channelType: ChannelType,
  body: Scalars['String'],
};

export type SmsTemplateInput = {
  body: Scalars['String'],
};

export type SnoozeChangedActivity = LeadActivity & {
  __typename: 'SnoozeChangedActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  oldSnooze?: Maybe<LeadSnooze>,
  newSnooze?: Maybe<LeadSnooze>,
};

export type SnoozeSupportTaskActivity = SupportTaskActivity & {
  __typename: 'SnoozeSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  wakeAt: Scalars['Date'],
};

export type SocialMediaAccessToken = {
  __typename: 'SocialMediaAccessToken',
  socialMediaType: SocialMediaType,
  accessToken: Scalars['String'],
};

export type SocialMediaAccessTokenInput = {
  socialMediaType: SocialMediaType,
  accessToken: Scalars['String'],
};

export type SocialMediaLink = {
  __typename: 'SocialMediaLink',
  socialMediaType: SocialMediaType,
  url: Scalars['String'],
};

export enum SocialMediaType {
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  LINKEDIN = 'LINKEDIN',
  INSTAGRAM = 'INSTAGRAM',
  PINTEREST = 'PINTEREST',
  YOUTUBE = 'YOUTUBE',
  STRAVA = 'STRAVA'
}

/** Common ordering context, each query should define its specific sortable fields as enums. */
export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SplitTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
};

export type StandardizedSellable = {
  __typename: 'StandardizedSellable',
  id: Scalars['StandardizedSellableId'],
  rawSellable: RawSellable,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  imageUrls: Array<Scalars['String']>,
  attributes: Array<Attribute>,
  rawAttributes: Array<RawAttribute>,
  attributeVariationDimensions: Array<Scalars['String']>,
  brand?: Maybe<Brand>,
  category: Category,
  titleVariationDimension: Scalars['Boolean'],
  gtin?: Maybe<Scalars['String']>,
  mpn?: Maybe<Scalars['String']>,
  originalPrice?: Maybe<MonetaryAmount>,
  salePrice?: Maybe<MonetaryAmount>,
  state: StandardizedSellableState,
};

export type StandardizedSellableGroup = {
  __typename: 'StandardizedSellableGroup',
  id: Scalars['StandardizedSellableGroupId'],
  standardizedSellableScores: Array<StandardizedSellableScore>,
  state: StandardizedSellableGroupState,
  mergedInto?: Maybe<StandardizedSellableGroup>,
};


export type StandardizedSellableGroupQuery = {
  states?: Maybe<Array<StandardizedSellableGroupState>>,
  standardizedSellableIds?: Maybe<Array<Scalars['StandardizedSellableId']>>,
  dirty?: Maybe<Scalars['Boolean']>,
};

export enum StandardizedSellableGroupState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}


export type StandardizedSellableScore = {
  __typename: 'StandardizedSellableScore',
  standardizedSellable: StandardizedSellable,
  score: Scalars['Float'],
};

export enum StandardizedSellableState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type StandardReturnPolicy = ReturnPolicy & {
  __typename: 'StandardReturnPolicy',
  type: ReturnPolicyType,
  returnWithinDays: Scalars['Int'],
  returnShippingPaidBy: ReturnShippingPaidBy,
  refundMethod: ReturnRefundMethod,
};

export type StartEscalationInput = {
  escalationId: Scalars['OrderEscalationId'],
  assignedToId?: Maybe<Scalars['OperatorId']>,
};

export type StartExpertConsumerConversationInput = {
  consumerId: Scalars['UserId'],
  expertId: Scalars['BusinessUserId'],
  requestId?: Maybe<Scalars['DealRequestId']>,
};

export type StartExpertConsumerConversationPayload = {
  __typename: 'StartExpertConsumerConversationPayload',
  conversation?: Maybe<Conversation>,
  error?: Maybe<Scalars['String']>,
};

export type StartExpertRatingInput = {
  expertId: Scalars['BusinessUserId'],
  expertStartRating?: Maybe<Scalars['Int']>,
};

export type StartExpertRatingPayload = {
  __typename: 'StartExpertRatingPayload',
  expert: BusinessUser,
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type StartGuestConversationInput = {
  expertId: Scalars['BusinessUserId'],
};

export type StartGuestConversationPayload = {
  __typename: 'StartGuestConversationPayload',
  conversation: GuestConversation,
};

export type StartLeadEscalationInput = {
  type: LeadEscalationType,
  acceptAsLeadExpertRole: LeadExpertRole,
  leadId: Scalars['LeadId'],
};

export type StartLeadEscalationPayload = {
  __typename: 'StartLeadEscalationPayload',
  escalation: LeadEscalation,
};

export type StartOnCallActivity = BusinessUserActivity & {
  __typename: 'StartOnCallActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type StartRawSellableSourceIngestionInput = {
  sourceId: Scalars['RawSellableSourceId'],
};

export type StartRawSellableSourceIngestionPayload = {
  __typename: 'StartRawSellableSourceIngestionPayload',
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type StartReceivingLeadsActivity = BusinessUserActivity & {
  __typename: 'StartReceivingLeadsActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type StartStandardizedSellableGroupIngestionInput = {
  query: StandardizedSellableGroupQuery,
};

export type StartStandardizedSellableGroupIngestionPayload = {
  __typename: 'StartStandardizedSellableGroupIngestionPayload',
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type StartSupportConversationInput = {
  consumerId: Scalars['UserId'],
};

export type StartSystemCuratedItemSurveyPayload = {
  __typename: 'StartSystemCuratedItemSurveyPayload',
  data?: Maybe<SystemCuratedItemSurvey>,
  error?: Maybe<Scalars['String']>,
};

export type StopOnCallActivity = BusinessUserActivity & {
  __typename: 'StopOnCallActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export type StopReceivingLeadsActivity = BusinessUserActivity & {
  __typename: 'StopReceivingLeadsActivity',
  id: Scalars['BusinessUserActivityId'],
  type: BusinessUserActivityType,
  occurredAt: Scalars['Date'],
};

export enum StringFieldType {
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  DURATION = 'DURATION'
}

export type StripeAccount = PaymentProcessorAccount & {
  __typename: 'StripeAccount',
  id: Scalars['PaymentProcessorAccountId'],
  createdAt: Scalars['Date'],
  updatedAt?: Maybe<Scalars['Date']>,
  type: PaymentProcessorType,
  userId: Scalars['UserId'],
  paymentSources?: Maybe<Array<PaymentSource>>,
  externalAccountId: Scalars['String'],
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type StripeAddress = {
  __typename: 'StripeAddress',
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  postalCode: Scalars['String'],
};

export enum StripeAuthenticationFlow {
  REDIRECT = 'redirect',
  RECEIVER = 'receiver',
  CODE_VERIFICATION = 'code_verification',
  NONE = 'none'
}

export type StripeCodeVerification = {
  __typename: 'StripeCodeVerification',
  /** The number of attempts remaining to authenticate the source object with a verification code. */
  attemptsRemaining?: Maybe<Scalars['Int']>,
  status?: Maybe<StripeCodeVerificationStatus>,
};

export enum StripeCodeVerificationStatus {
  PENDING = 'pending',
  AWAITING_VERIFICATION = 'awaiting_verification',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
}

export type StripeOwner = {
  __typename: 'StripeOwner',
  address?: Maybe<StripeAddress>,
  email?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  verifiedAddress?: Maybe<StripeAddress>,
  verifiedEmail?: Maybe<Scalars['String']>,
  verifiedName?: Maybe<Scalars['String']>,
  verifiedPhone?: Maybe<Scalars['String']>,
};

export type StripePaymentSource = PaymentSource & {
  __typename: 'StripePaymentSource',
  id: Scalars['PaymentSourceId'],
  createdAt?: Maybe<Scalars['Date']>,
  updatedAt?: Maybe<Scalars['Date']>,
  externalSourceId: Scalars['String'],
  type: PaymentProcessorType,
  usage: PaymentSourceUsage,
  status: PaymentSourceStatus,
  userId: Scalars['UserId'],
  billingAddress?: Maybe<Address>,
  paymentEntity: PaymentEntity,
  isDefault: Scalars['Boolean'],
  /** Stripe specific attributes
   * The client secret of the source. Used for client-side retrieval using a publishable key.
 */
  clientSecret?: Maybe<Scalars['String']>,
  authenticationFlow?: Maybe<StripeAuthenticationFlow>,
  codeVerification?: Maybe<StripeCodeVerification>,
  /** Flag indicating whether the object exists in live mode or test mode. */
  liveMode?: Maybe<Scalars['Boolean']>,
  owner?: Maybe<StripeOwner>,
};

export type SubmitDatePathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Scalars['Date']>,
};

export type SubmitDatePathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitDatePathFlowQuestionInputTypeCopy',
  value?: Maybe<Scalars['Date']>,
};

export type SubmitDatePathFlowQuestionPayload = {
  __typename: 'SubmitDatePathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitDateRangePathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  startValue?: Maybe<Scalars['Date']>,
  endValue?: Maybe<Scalars['Date']>,
};

export type SubmitDateRangePathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitDateRangePathFlowQuestionInputTypeCopy',
  startValue?: Maybe<Scalars['Date']>,
  endValue?: Maybe<Scalars['Date']>,
};

export type SubmitDateRangePathFlowQuestionPayload = {
  __typename: 'SubmitDateRangePathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitIdPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Array<Scalars['AnyId']>>,
};

export type SubmitIdPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitIdPathFlowQuestionInputTypeCopy',
  value: Array<Scalars['AnyId']>,
};

export type SubmitIdPathFlowQuestionPayload = {
  __typename: 'SubmitIdPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitInputTextPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Scalars['String']>,
};

/** Identical to SubmitInputTextPathFlowQuestionInput used to include in output schemas */
export type SubmitInputTextPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitInputTextPathFlowQuestionInputTypeCopy',
  /** Same fields as SubmitInputTextPathFlowQuestionInput */
  value?: Maybe<Scalars['String']>,
};

export type SubmitInputTextPathFlowQuestionPayload = {
  __typename: 'SubmitInputTextPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitListPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  /** If values were selected, specify them here.
   * Note that this is called value and not values to be consistent with other question inputs
 */
  value?: Maybe<Array<Scalars['String']>>,
  /** If other was filled out, specify the input here.
   * Note that values and other are mutually exclusive - only one should be filled out.
 */
  other?: Maybe<Scalars['String']>,
};

/** Identical to SubmitListPathFlowQuestionInput used to include in output schemas */
export type SubmitListPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitListPathFlowQuestionInputTypeCopy',
  /** If values were selected, specify them here.
   * Note that this is called value and not values to be consistent with other question inputs
 */
  value?: Maybe<Array<Scalars['String']>>,
  /** If other was filled out, specify the input here.
   * Note that values and other are mutually exclusive - only one should be filled out.
 */
  other?: Maybe<Scalars['String']>,
};

export type SubmitListPathFlowQuestionPayload = {
  __typename: 'SubmitListPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitNumericPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  value?: Maybe<Scalars['Int']>,
};

export type SubmitNumericPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitNumericPathFlowQuestionInputTypeCopy',
  value?: Maybe<Scalars['Int']>,
  decimalValue?: Maybe<Scalars['BigDecimal']>,
};

export type SubmitNumericPathFlowQuestionPayload = {
  __typename: 'SubmitNumericPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitOAuthEmailPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  email: Scalars['String'],
  googleIdToken?: Maybe<Scalars['String']>,
  facebookUserAccessToken?: Maybe<Scalars['String']>,
  skipFirstName?: Maybe<Scalars['String']>,
  skipLastName?: Maybe<Scalars['String']>,
};

export type SubmitOAuthEmailPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitOAuthEmailPathFlowQuestionInputTypeCopy',
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  googleIdToken?: Maybe<Scalars['String']>,
  facebookUserAccessToken?: Maybe<Scalars['String']>,
  skipFirstName?: Maybe<Scalars['String']>,
  skipLastName?: Maybe<Scalars['String']>,
};

export type SubmitOAuthEmailPathFlowQuestionPayload = {
  __typename: 'SubmitOAuthEmailPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type SubmitOrderInput = {
  orderId: Scalars['OrderId'],
  paymentSourceId: Scalars['PaymentSourceId'],
};

export type SubmitOrderPayload = {
  __typename: 'SubmitOrderPayload',
  order: Order,
};

export type SubmitPathFlowPageInput = {
  pathFlowId: Scalars['PathFlowId'],
  pageName: Scalars['String'],
};

export type SubmitPathFlowPagePayload = {
  __typename: 'SubmitPathFlowPagePayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
  /** If a new user is registered as part of this path flow page submit */
  newUserRegistered: Scalars['Boolean'],
  /** If a new deal request is created as part of this path flow page submit */
  newRequestCreated: Scalars['Boolean'],
};

export type SubmitUserContactPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'],
  questionName: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  phoneNumber: Scalars['String'],
};

export type SubmitUserContactPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitUserContactPathFlowQuestionInputTypeCopy',
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
};

export type SubmitUserContactPathFlowQuestionPayload = {
  __typename: 'SubmitUserContactPathFlowQuestionPayload',
  flow?: Maybe<PathFlow>,
  errors?: Maybe<Array<PathValidationError>>,
};

export type Subscription = {
  __typename: 'Subscription',
  /** Updates when the user's order in CART status has line items that change (item added, removed, or quantity changes),
   * or the cart is replaced (user purchases previous cart and a new cart is generated). Intended for use cases like
   * keeping the items in cart badge updated.
   * If `userId` is omitted, it will use the current viewer (assumed to be a user)
 */
  userCartLineItemsChanged: Order,
  expertApplicationsPendingReviewChanged: ExpertApplicationSubscriptionChange,
  expertApplicationsPendingReviewCountChanged: Scalars['Int'],
  expertApplicationsPendingApprovalChanged: ExpertApplicationSubscriptionChange,
  expertApplicationsPendingActivationChanged: ExpertApplicationSubscriptionChange,
  expertApplicationFolderChanged: ExpertApplicationFolder,
  expertApplicationFolderItemChanged: ExpertApplicationFolderItemChange,
  expertNotification: ExpertNotification,
  expertLeadFolderChanged: ExpertLeadFolder,
  expertLeadFolderItemChanged: ExpertLeadFolderItemChange,
  leadEscalationChanged: LeadEscalation,
  heartbeat: Scalars['Boolean'],
  /** Consumer API; subscription version of the read query `expertCuratedOrder` that broadcasts changes to the curated
   * order, except for changes while the curated order is in draft state.
 */
  expertCuratedOrderChanged: ExpertCuratedOrderChangedPayload,
  /** Consumer API; subscription version of the read query `expertCuratedOrdersForLeadConnection` that broadcasts changes
   * when any curated order associated with the queried lead changes state, except for curated orders in draft state.
 */
  expertCuratedOrdersForLeadConnectionChanged: ExpertCuratedOrdersForLeadConnectionChangedPayload,
  /** Subscription that emits changes when a expert curated item is modified (excluding draft modifications/creations),
   * and when the consumer's active cart is modified. This makes it possible to get an up to date view on both the
   * active curated items (e.g.: pick up changes if the consumer dismisses an item), as well as cart updates the user
   * makes (allows experts to dynamically refresh the `lineItemInCart` property).
 */
  expertCuratedItemsByCategoryChanged: ExpertCuratedItemsByCategoryChangedPayload,
  leadActivityOccurred: LeadActivity,
  supportTaskOperatorFolderChanged: SupportTaskFolderEvent,
  supportTaskOperatorFolderListChanged: SupportTaskListEvent,
  newEscalationCount: NewOrderEscalationNotification,
  escalationFacetCounts: EscalationFacetCountsPayload,
  orderEscalationCreated: OrderEscalation,
};


export type SubscriptionUserCartLineItemsChangedArgs = {
  userId?: Maybe<Scalars['UserId']>
};


export type SubscriptionExpertApplicationsPendingApprovalChangedArgs = {
  reviewedOnly: Scalars['Boolean']
};


export type SubscriptionExpertApplicationFolderChangedArgs = {
  departmentId?: Maybe<Scalars['DepartmentId']>,
  approvedById?: Maybe<Scalars['OperatorId']>
};


export type SubscriptionExpertApplicationFolderItemChangedArgs = {
  departmentId?: Maybe<Scalars['DepartmentId']>,
  approvedById?: Maybe<Scalars['OperatorId']>,
  folderSlug: Scalars['String']
};


export type SubscriptionExpertNotificationArgs = {
  expertId: Scalars['BusinessUserId']
};


export type SubscriptionExpertLeadFolderChangedArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>
};


export type SubscriptionExpertLeadFolderItemChangedArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>,
  folderSlug: Scalars['String']
};


export type SubscriptionLeadEscalationChangedArgs = {
  id: Scalars['LeadEscalationId']
};


export type SubscriptionExpertCuratedOrderChangedArgs = {
  id: Scalars['ExpertCuratedOrderId']
};


export type SubscriptionExpertCuratedOrdersForLeadConnectionChangedArgs = {
  query: ExpertCuratedOrdersForLeadQueryInput,
  first: Scalars['Int']
};


export type SubscriptionExpertCuratedItemsByCategoryChangedArgs = {
  leadId: Scalars['LeadId']
};


export type SubscriptionLeadActivityOccurredArgs = {
  expertId: Scalars['BusinessUserId'],
  types: Array<LeadActivityType>,
  teamActivityTypes?: Maybe<Array<LeadActivityType>>
};


export type SubscriptionSupportTaskOperatorFolderChangedArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType
};


export type SubscriptionSupportTaskOperatorFolderListChangedArgs = {
  operatorId: Scalars['OperatorId'],
  supportTaskType: SupportTaskType,
  folderSlug: Scalars['String']
};


export type SubscriptionEscalationFacetCountsArgs = {
  searchQuery: OrderEscalationSearchInput,
  facetNames: Array<Maybe<Scalars['String']>>
};

export type SuggestedAction = {
  __typename: 'SuggestedAction',
  type: SuggestedActionType,
  headline: Scalars['String'],
  reason: Scalars['String'],
  suggestedMessage?: Maybe<Scalars['String']>,
};

export enum SuggestedActionType {
  SEND_INITIAL_RESPONSE = 'SEND_INITIAL_RESPONSE',
  RESPOND_TO_NEW_MESSAGE = 'RESPOND_TO_NEW_MESSAGE',
  FOLLOW_UP = 'FOLLOW_UP',
  SNOOZE = 'SNOOZE',
  STAR = 'STAR',
  ARCHIVE = 'ARCHIVE',
  REQUEST_EXPERT_REVIEW = 'REQUEST_EXPERT_REVIEW',
  REQUEST_EXPERT_REFERRAL = 'REQUEST_EXPERT_REFERRAL',
  SEND_CURATION = 'SEND_CURATION',
  CLASSIFY_ARCHIVED_LEAD = 'CLASSIFY_ARCHIVED_LEAD',
  REVIEW_SURVEY = 'REVIEW_SURVEY',
  FULFILL_PROMISE = 'FULFILL_PROMISE',
  CURATION_VIEWED_FOLLOW_UP = 'CURATION_VIEWED_FOLLOW_UP'
}

export type SuggestedExpertCuratedItems = {
  __typename: 'SuggestedExpertCuratedItems',
  /** The suggested ExpertCuratedItem */
  expertCuratedItems: Array<ExpertCuratedItem>,
  /** Attributes that were common between the requested user and the user to whom these ExpertCuratedItem's were recommended. */
  commonUserRequestAttributes: Array<FormattedAttribute>,
  /** Relevance Metadata for reconciling when a new ExpertCuratedItem is created from the suggested expertCuratedItems above. */
  relevanceMetadata?: Maybe<Scalars['String']>,
  /** The lead to who these ExpertCuratedItem's were recommended. */
  sourceLead?: Maybe<Lead>,
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>,
  /** Rank of this Lead in the group of other similar leads */
  rank?: Maybe<Scalars['Int']>,
  /** How closely this lead matches the query lead */
  matchPercent?: Maybe<Scalars['Float']>,
};

/** SuggestedExpertTaggableRequestAttribute consist of all values of the Attribute that are marked AttributeFunction,TAGGABLE
 * during the schema definition.
 * The values are further flagged if they were selected by the lead in the request, which can be used on the UI
 * to auto tag the curation.
 */
export type SuggestedExpertTaggableRequestAttribute = {
  __typename: 'SuggestedExpertTaggableRequestAttribute',
  attributeSchema: AttributeSchema,
  values: Array<SuggestedExpertTaggableRequestAttributeValue>,
};

export type SuggestedExpertTaggableRequestAttributeValue = {
  __typename: 'SuggestedExpertTaggableRequestAttributeValue',
  attributeValue: AttributeValue,
  displayValue: Scalars['String'],
  selectedByLead: Scalars['Boolean'],
};

export enum SuggestedSupportAction {
  SUPPORT_RESPONSE_NEEDED = 'SUPPORT_RESPONSE_NEEDED'
}

export type SuggestExpertCuratedItemNotesConnection = {
  __typename: 'SuggestExpertCuratedItemNotesConnection',
  edges: Array<SuggestExpertCuratedItemNotesEdge>,
  pageInfo: PageInfo,
};

export type SuggestExpertCuratedItemNotesEdge = {
  __typename: 'SuggestExpertCuratedItemNotesEdge',
  node: ExpertCuratedItemNote,
  cursor: Scalars['String'],
};

export type SuggestExpertCuratedItemNotesQueryInput = {
  /** Suggested notes will be given for the parent of this sellable (or this sellable directly if it's already the parent) */
  sellableId: Scalars['SellableId'],
};

export enum SuggestExpertCuratedItemNotesSort {
  /** Sort by purchase rate, usage count, note length */
  DEFAULT = 'DEFAULT',
  /** Sort by usage count, note length */
  USAGES = 'USAGES'
}

export type SuggestExpertCuratedItemsForLeadConnection = {
  __typename: 'SuggestExpertCuratedItemsForLeadConnection',
  facets: Array<DisplayFacet>,
  edges: Array<SuggestExpertCuratedItemsForLeadEdge>,
  pageInfo: PageInfo,
  count: Scalars['Int'],
};

export type SuggestExpertCuratedItemsForLeadEdge = {
  __typename: 'SuggestExpertCuratedItemsForLeadEdge',
  node: SuggestedExpertCuratedItems,
  cursor: Scalars['String'],
};

export type SuggestExpertCuratedItemsForLeadQueryInput = {
  /** Facets to filter search result */
  facets?: Maybe<Array<FacetSelection>>,
  /** The category for which the expert curated item is being searched. */
  categoryId: Scalars['CategoryId'],
  /** The lead for whom the ExpertCuratedItems are being searched for. */
  searchingForLead: Scalars['LeadId'],
  /** Top N facet terms to be returned per facet. */
  maxFacetTerms?: Maybe<Scalars['Int']>,
};

export type SuggestLeadActionsSupportTaskActivity = SupportTaskActivity & {
  __typename: 'SuggestLeadActionsSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  suggestedActions: Array<SuggestedActionType>,
};

export type SummarizedAddSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedAddSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedCheckoutStartedUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedCheckoutStartedUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedPaymentInfoEnteredUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedPaymentInfoEnteredUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedRemoveSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedRemoveSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedSavedSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedSavedSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
  saved: Scalars['Boolean'],
  reason?: Maybe<Scalars['String']>,
};

export type SummarizedUnSavedSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedUnSavedSellableUserActivity',
  sellable: Sellable,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
  reason?: Maybe<Scalars['String']>,
};

export type SummarizedUserActivity = {
  __typename: 'SummarizedUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedViewCartUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedViewCartUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SummarizedViewCuratedListUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedViewCuratedListUserActivity',
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
  lead: Lead,
};

export type SummarizedViewSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedViewSellableUserActivity',
  sellable: Sellable,
  count: Scalars['Int'],
  lastViewedAt: Scalars['Date'],
  lastViewEndedAt?: Maybe<Scalars['Date']>,
  type: UserActivityType,
  lastOccurredAt: Scalars['Date'],
};

export type SupportConversation = {
  __typename: 'SupportConversation',
  id: Scalars['SupportConversationId'],
  version: Scalars['Int'],
  updatedAt: Scalars['Date'],
  createdAt: Scalars['Date'],
  conversationId: Scalars['ConversationId'],
  consumerId: Scalars['UserId'],
  conversation: Conversation,
  supportLastMessagedAt?: Maybe<Scalars['Date']>,
  consumerLastMessagedAt?: Maybe<Scalars['Date']>,
  suggestedActions: Array<SuggestedSupportAction>,
  consumerUnreadCount: Scalars['Int'],
  consumer: User,
  escalations: Array<OrderEscalation>,
};


export type SupportedPaymentMethod = {
  __typename: 'SupportedPaymentMethod',
  paymentMethod: PaymentMethod,
  paymentProvider: PaymentProcessorType,
};

export type SupportMessagingUser = {
  __typename: 'SupportMessagingUser',
  id: Scalars['AnyId'],
  displayName: Scalars['String'],
};

export type SupportTask = {
  __typename: 'SupportTask',
  id: Scalars['SupportTaskId'],
  type: SupportTaskType,
  state: SupportTaskState,
  url: Scalars['String'],
  dueAt: Scalars['Date'],
  assignedTo?: Maybe<Operator>,
  assignedAt?: Maybe<Scalars['Date']>,
  completedAt?: Maybe<Scalars['Date']>,
};

export enum SupportTaskAction {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
  DISMISS = 'DISMISS',
  DELEGATE_LEAD = 'DELEGATE_LEAD',
  REASSIGN_LEAD = 'REASSIGN_LEAD',
  SUGGEST_LEAD_ACTIONS = 'SUGGEST_LEAD_ACTIONS',
  ESCALATE_LEAD_FOR_DELEGATION = 'ESCALATE_LEAD_FOR_DELEGATION',
  ESCALATE_LEAD_FOR_REASSIGNMENT = 'ESCALATE_LEAD_FOR_REASSIGNMENT',
  REQUEST_ORDER_SUPPORT_FOR_LEAD = 'REQUEST_ORDER_SUPPORT_FOR_LEAD',
  SNOOZE = 'SNOOZE',
  UNSNOOZE = 'UNSNOOZE'
}

export type SupportTaskActivity = {
  __typename: 'SupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};


export type SupportTaskActor = Operator | SystemUser;

export type SupportTaskAssignedToQuery = {
  assigneeIds: Array<Scalars['OperatorId']>,
  includeUnassigned?: Maybe<Scalars['Boolean']>,
};

export type SupportTaskFolder = {
  __typename: 'SupportTaskFolder',
  id: Scalars['SupportTaskFolderId'],
  slug: Scalars['String'],
  displayName: Scalars['String'],
  badgeCount?: Maybe<Scalars['Int']>,
};

export type SupportTaskFolderEvent = {
  __typename: 'SupportTaskFolderEvent',
  folder: SupportTaskFolder,
};



export type SupportTaskListEvent = {
  __typename: 'SupportTaskListEvent',
  supportTask: SupportTask,
  type: SupportTaskListEventType,
};

export enum SupportTaskListEventType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export type SupportTaskQuery = {
  types?: Maybe<Array<SupportTaskType>>,
  states?: Maybe<Array<SupportTaskState>>,
  dueAtRange?: Maybe<DateRangeInput>,
  assignedTo?: Maybe<SupportTaskAssignedToQuery>,
};

export type SupportTasksConnection = {
  __typename: 'SupportTasksConnection',
  edges: Array<SupportTasksEdge>,
  pageInfo: PageInfo,
  count: Scalars['Long'],
};

export type SupportTasksEdge = {
  __typename: 'SupportTasksEdge',
  node: SupportTask,
  cursor: Scalars['String'],
};

export enum SupportTaskState {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED'
}

export enum SupportTaskType {
  LEAD = 'LEAD',
  ORDER = 'ORDER'
}

export type SurveySummary = {
  __typename: 'SurveySummary',
  lastSystemCuratedItemSurvey: SystemCuratedItemSurvey,
  lastSystemCuratedItemSurveySentAt: Scalars['Date'],
};

export type SwapTriggerBranchEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
};

export type SwapTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
};

export type SyncExternalAdCampaignsInput = {
  categoryId: Scalars['CategoryId'],
};

export type SyncExternalAdCampaignsPayload = {
  __typename: 'SyncExternalAdCampaignsPayload',
  adCampaigns: Array<ExternalAdCampaign>,
};

export type SyncOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  useCase: CartSyncUseCase,
};

export type SyncOrderPayload = {
  __typename: 'SyncOrderPayload',
  order: Order,
};

export enum SystemCuratedConsumerSellableReactionRating {
  SKIP = 'SKIP',
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  LOVE = 'LOVE'
}

export type SystemCuratedItem = {
  __typename: 'SystemCuratedItem',
  id: Scalars['SystemCuratedItemId'],
  type: SystemCuratedItemType,
  sellable: Sellable,
  category: Category,
  systemCuratedItemSource: SystemCuratedItemSource,
};


export type SystemCuratedItemSource = {
  __typename: 'SystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
};

export type SystemCuratedItemSurvey = {
  __typename: 'SystemCuratedItemSurvey',
  id: Scalars['SystemCuratedItemSurveyId'],
  systemCuratedItems: Array<SystemCuratedItem>,
  ended: Scalars['Boolean'],
  startedAt?: Maybe<Scalars['Date']>,
  endedAt?: Maybe<Scalars['Date']>,
  terminationReason?: Maybe<SystemCuratedItemSurveyTerminationReason>,
  stats?: Maybe<SystemCuratedItemSurveyStats>,
  /** skipped all questions */
  skippedAll?: Maybe<Scalars['Boolean']>,
  /** answered some question before early termination */
  answeredSome?: Maybe<Scalars['Boolean']>,
  /** all questions answered, inclusive of skips */
  answeredAll?: Maybe<Scalars['Boolean']>,
};


export type SystemCuratedItemSurveyStats = {
  __typename: 'SystemCuratedItemSurveyStats',
  ratingStats: Array<ConsumerSellableReactionRatingStats>,
};

export enum SystemCuratedItemSurveyTerminationReason {
  SKIPPED = 'SKIPPED',
  TERMINATED_EARLY = 'TERMINATED_EARLY',
  REVIEWED_ALL = 'REVIEWED_ALL'
}

export enum SystemCuratedItemType {
  EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER = 'EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER',
  EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED = 'EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED',
  TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST = 'TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST',
  SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED = 'SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED'
}


export type SystemUser = {
  __typename: 'SystemUser',
  id: Scalars['SystemId'],
};

export type Tag = {
  __typename: 'Tag',
  id: Scalars['TagId'],
  type: TagType,
  name: Scalars['String'],
};


export enum TagType {
  BROADCAST_LEAD_QUALITY = 'BROADCAST_LEAD_QUALITY',
  BROADCAST_CONVERSION_STRATEGY = 'BROADCAST_CONVERSION_STRATEGY',
  BROADCAST_TRUST_STRATEGY = 'BROADCAST_TRUST_STRATEGY',
  REMINDER_TASK_TYPE = 'REMINDER_TASK_TYPE'
}

export type TaskPayload = MerchantUploadTaskPayload | DealUploadTaskPayload | SellableUploadTaskPayload | SellablePriceUploadTaskPayload | BrandUploadTaskPayload | FeaturedSellableContentUploadTaskPayload | SellableUpdateTaskPayload | SellableDeactivationTaskPayload | SellableInventoryUploadTaskPayload;

export type TemplateCustomQueryDataModel = TemplateDataModel & {
  __typename: 'TemplateCustomQueryDataModel',
  type: TemplateDataModelType,
};

export type TemplateDataModel = {
  __typename: 'TemplateDataModel',
  type: TemplateDataModelType,
};

export type TemplateDataModelInput = {
  queryName: Scalars['String'],
  categoryType?: Maybe<TriggerParameterInput>,
  category?: Maybe<TriggerParameterInput>,
  variables: Array<TemplateNamedQueryVariableInput>,
};

export enum TemplateDataModelType {
  DATA_OBJECT = 'DATA_OBJECT',
  CUSTOM_QUERY = 'CUSTOM_QUERY',
  NAMED_QUERIES = 'NAMED_QUERIES'
}

export type TemplateNamedQuery = {
  __typename: 'TemplateNamedQuery',
  queryName: Scalars['String'],
  variables: Array<TemplateNamedQueryVariable>,
};

export type TemplateNamedQueryDataModel = TemplateDataModel & {
  __typename: 'TemplateNamedQueryDataModel',
  type: TemplateDataModelType,
  categoryType?: Maybe<TriggerParameter>,
  categoryId?: Maybe<TriggerParameter>,
  query: TemplateNamedQuery,
};

export type TemplateNamedQueryMeta = {
  __typename: 'TemplateNamedQueryMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  query: Scalars['String'],
  variables: Array<TemplateNamedQueryVariableMeta>,
};

export type TemplateNamedQueryVariable = {
  __typename: 'TemplateNamedQueryVariable',
  name: Scalars['String'],
  value: TriggerParameter,
};

export type TemplateNamedQueryVariableInput = {
  name: Scalars['String'],
  value: TriggerParameterInput,
};

export type TemplateNamedQueryVariableMeta = {
  __typename: 'TemplateNamedQueryVariableMeta',
  name: Scalars['String'],
  type: Scalars['String'],
};

export type TemplateObjectTemplateDataModel = TemplateDataModel & {
  __typename: 'TemplateObjectTemplateDataModel',
  type: TemplateDataModelType,
};

export enum TemplateTagSyntax {
  DEFAULT = 'DEFAULT',
  ALTERNATIVE = 'ALTERNATIVE'
}

export enum TemplateTypeGroup {
  ONBOARDING = 'ONBOARDING',
  NURTURING = 'NURTURING',
  FEEDBACK = 'FEEDBACK',
  CURATION = 'CURATION',
  EXPERT_ONBOARDING = 'EXPERT_ONBOARDING',
  MESSAGE_ROUTING = 'MESSAGE_ROUTING',
  EXPERT_NOTIFICATION = 'EXPERT_NOTIFICATION',
  POST_PURCHASE = 'POST_PURCHASE',
  CONSUMER_REQUEST = 'CONSUMER_REQUEST',
  CAMPAIGN = 'CAMPAIGN',
  ABANDONED_CART = 'ABANDONED_CART',
  ABANDONED_CHECKOUT = 'ABANDONED_CHECKOUT',
  PATH_DROPOFF = 'PATH_DROPOFF',
  FULFILLMENT = 'FULFILLMENT',
  REFERRAL = 'REFERRAL'
}

export type TerminateSystemCuratedItemSurveyInput = {
  id: Scalars['SystemCuratedItemSurveyId'],
  reason: SystemCuratedItemSurveyTerminationReason,
};

export type TerminateSystemCuratedItemSurveyPayload = {
  __typename: 'TerminateSystemCuratedItemSurveyPayload',
  data?: Maybe<SystemCuratedItemSurvey>,
  error?: Maybe<Scalars['String']>,
};

export type TermsAndConditionsPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'TermsAndConditionsPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};

export type TermsPrivacyMedicalPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'TermsPrivacyMedicalPathFlowPageMetadata',
  type: PathFlowPageMetadataType,
};

export type TestTriggerEventParameterInput = {
  name: Scalars['String'],
  idValue?: Maybe<Scalars['AnyId']>,
  stringValue?: Maybe<Scalars['String']>,
};

export type TestTriggerExecutionInput = {
  triggerId: Scalars['TriggerId'],
  eventParameters: Array<TestTriggerEventParameterInput>,
};

export type TestTriggerExecutionPayload = {
  __typename: 'TestTriggerExecutionPayload',
  success: Scalars['Boolean'],
  error?: Maybe<Scalars['String']>,
};

export type TextRenderedContent = {
  __typename: 'TextRenderedContent',
  text: Scalars['String'],
  link?: Maybe<Scalars['String']>,
};

/** ====== Text View Model */
export type TextViewModel = AttributedHtmlTextViewModel;

export enum ThreeDSecureVerification {
  /** 3D Secure is required, and the process must be completed for a charge to be successful. */
  REQUIRED = 'REQUIRED',
  /** 3D Secure is recommended. The process is not required, but it is highly recommended and
   * has minimal impact to your conversion rate.
 */
  RECOMMENDED = 'RECOMMENDED',
  /** 3D Secure is optional. The process is neither required nor recommended, but it can be performed to
   * help reduce the likelihood of fraud.
 */
  OPTIONAL = 'OPTIONAL',
  /** 3D Secure is not supported on this card. Proceed with a regular card payment instead. */
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}


export type TopRecommendationAndSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'TopRecommendationAndSimilarUserSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  recentExpertCuratedItemFromSimilarUserSource?: Maybe<RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource>,
  topRecommendedListSystemCuratedItemSource?: Maybe<TopRecommendedListSystemCuratedItemSource>,
};

export type TopRecommendedListSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'TopRecommendedListSystemCuratedItemSource',
  type?: Maybe<SystemCuratedItemType>,
  recommendedListDefinition: RecommendedListDefinition,
  dealRequest: DealRequest,
};

export type TotalCostForOfferInput = {
  id: Scalars['BroadcastOfferId'],
  address?: Maybe<AddressInput>,
  tip?: Maybe<MonetaryAmountInput>,
};

export type TotalCostForOfferPayload = {
  __typename: 'TotalCostForOfferPayload',
  address?: Maybe<Address>,
  price: MonetaryAmount,
  tax: MonetaryAmount,
  shippingCost: MonetaryAmount,
  totalCost: MonetaryAmount,
  tip?: Maybe<MonetaryAmount>,
};

export type Transaction = {
  __typename: 'Transaction',
  id: Scalars['TransactionId'],
  createdAt: Scalars['Date'],
  updatedAt?: Maybe<Scalars['Date']>,
  orderId: Scalars['OrderId'],
  order: Order,
  status: TransactionStatus,
  type: TransactionType,
  request: TransactionRequest,
  response?: Maybe<TransactionResponse>,
};


export type TransactionRequest = {
  __typename: 'TransactionRequest',
  chargeAmount: MonetaryAmount,
  statementDescriptor: Scalars['String'],
  fullDescription?: Maybe<Scalars['String']>,
  paymentSourceType: PaymentProcessorType,
  paymentProcessorPlatformSourceId: Scalars['String'],
  paymentSourceUsage: PaymentSourceUsage,
};

export type TransactionResponse = {
  __typename: 'TransactionResponse',
  paymentProcessorTransactionId?: Maybe<Scalars['String']>,
  paymentSource?: Maybe<PaymentSource>,
  errorMessage?: Maybe<Scalars['String']>,
  userFriendlyErrorMessage?: Maybe<Scalars['String']>,
  sourceAccount?: Maybe<PaymentProcessorAccount>,
  destinationAccount?: Maybe<PaymentProcessorAccount>,
  /** Statement descriptor is a protected field and only accessible to the admin.
   * this statement descriptor can be different from one in TransactionRequest and is specific to the PaymentProcessor.
   * It may be truncated or have additional metadata addded to it.
 */
  statementDescriptor?: Maybe<Scalars['String']>,
};

export enum TransactionStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILURE = 'FAILURE',
  REFUNDED = 'REFUNDED'
}

export enum TransactionType {
  CUSTOMER = 'CUSTOMER',
  MERCHANT = 'MERCHANT'
}

export type Trigger = {
  __typename: 'Trigger',
  id: Scalars['TriggerId'],
  name: Scalars['String'],
  groupName: Scalars['String'],
  description: Scalars['String'],
  triggeredBy: TriggerEventMeta,
  entityMeta: TriggerEntityMeta,
  supportedActions: Array<TriggerActionMeta>,
  waitableEvents: Array<TriggerEventMeta>,
  nodes: Array<TriggerNode>,
  state: TriggerState,
  createdAt: Scalars['Date'],
  updatedAt: Scalars['Date'],
  namedQueries: Array<TemplateNamedQueryMeta>,
  campaign?: Maybe<Campaign>,
};

export type TriggerAction = TriggerNode & {
  __typename: 'TriggerAction',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  name: Scalars['String'],
  parameters: Array<TriggerActionParameter>,
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>,
};

export type TriggerActionMeta = {
  __typename: 'TriggerActionMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  parameters: Array<TriggerParameterMeta>,
  internal: Scalars['Boolean'],
};

export type TriggerActionParameter = {
  __typename: 'TriggerActionParameter',
  name: Scalars['String'],
  value: TriggerParameter,
};

export type TriggerActionParameterInput = {
  name: Scalars['String'],
  parameter: TriggerParameterInput,
};

export type TriggerBinaryCondition = TriggerCondition & {
  __typename: 'TriggerBinaryCondition',
  type: TriggerConditionType,
  leftOperand: TriggerParameter,
  rightOperand: TriggerParameter,
  binaryOperator: TriggerFieldOperator,
};

export type TriggerBinaryConditionInput = {
  leftOperand: TriggerParameterInput,
  rightOperand: TriggerParameterInput,
  binaryOperator: Scalars['String'],
};

export type TriggerBranch = TriggerNode & {
  __typename: 'TriggerBranch',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  condition?: Maybe<TriggerCondition>,
  nodeIdIfTrue?: Maybe<Scalars['TriggerNodeId']>,
  nodeIdIfFalse?: Maybe<Scalars['TriggerNodeId']>,
};

export type TriggerCondition = {
  __typename: 'TriggerCondition',
  type: TriggerConditionType,
};

export type TriggerConditionInput = {
  logicalCondition?: Maybe<TriggerLogicalConditionInput>,
  binaryCondition?: Maybe<TriggerBinaryConditionInput>,
  experimentCondition?: Maybe<TriggerExperimentConditionInput>,
};

export enum TriggerConditionType {
  LOGICAL = 'LOGICAL',
  BINARY = 'BINARY',
  EXPERIMENT = 'EXPERIMENT'
}

export type TriggerDelay = TriggerNode & {
  __typename: 'TriggerDelay',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  interval: TriggerDelayInterval,
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>,
};

export type TriggerDelayFixedInterval = TriggerDelayInterval & {
  __typename: 'TriggerDelayFixedInterval',
  type: TriggerDelayIntervalType,
  minimalWaitTime: TriggerDuration,
  waitUntilLocalTime?: Maybe<TriggerLocalTimeRange>,
};

export type TriggerDelayFixedIntervalInput = {
  minimalWaitTime: TriggerDurationInput,
  waitUtilLocalTime?: Maybe<TriggerLocalTimeRangeInput>,
};

export type TriggerDelayInterval = {
  __typename: 'TriggerDelayInterval',
  type: TriggerDelayIntervalType,
};

export type TriggerDelayIntervalTreatment = {
  __typename: 'TriggerDelayIntervalTreatment',
  treatments: Array<Scalars['String']>,
  interval: TriggerDelayFixedInterval,
};

export type TriggerDelayIntervalTreatmentInput = {
  treatments: Array<Scalars['String']>,
  fixedInterval: TriggerDelayFixedIntervalInput,
};

export enum TriggerDelayIntervalType {
  FIXED = 'FIXED',
  WITH_EXPERIMENT = 'WITH_EXPERIMENT'
}

export type TriggerDelayWithExperiment = TriggerDelayInterval & {
  __typename: 'TriggerDelayWithExperiment',
  type: TriggerDelayIntervalType,
  experiment: Scalars['String'],
  key: TriggerParameter,
  intervals: Array<TriggerDelayIntervalTreatment>,
};

export type TriggerDelayWithExperimentInput = {
  experiment: Scalars['String'],
  key: TriggerParameterInput,
  intervals: Array<TriggerDelayIntervalTreatmentInput>,
};

export type TriggerDuration = {
  __typename: 'TriggerDuration',
  unit: TriggerDurationUnit,
  amount: Scalars['Int'],
};

export type TriggerDurationInput = {
  unit: TriggerDurationUnit,
  amount: Scalars['Int'],
};

export enum TriggerDurationUnit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}

/** fields exists on an trigger entity */
export type TriggerEntityFieldMeta = {
  __typename: 'TriggerEntityFieldMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: TriggerFieldType,
  idType?: Maybe<Scalars['String']>,
  enumValues?: Maybe<Array<Scalars['String']>>,
  experimentKey: Scalars['Boolean'],
  supportedOperators: Array<TriggerFieldOperator>,
  stringFieldType?: Maybe<StringFieldType>,
};

export type TriggerEntityFieldReference = {
  __typename: 'TriggerEntityFieldReference',
  type: TriggerParameterType,
  field: Scalars['String'],
};

/** Entities we can create trigger on, like User, Lead, Order and etc */
export type TriggerEntityMeta = {
  __typename: 'TriggerEntityMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  fields: Array<TriggerEntityFieldMeta>,
};

export type TriggerEventMeta = {
  __typename: 'TriggerEventMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  parameters: Array<TriggerParameterMeta>,
  entityId: TriggerParameterMeta,
  waitable: Scalars['Boolean'],
};

export type TriggerEventParameterReference = {
  __typename: 'TriggerEventParameterReference',
  type: TriggerParameterType,
  parameterName: Scalars['String'],
};

export type TriggerExperimentCondition = TriggerCondition & {
  __typename: 'TriggerExperimentCondition',
  type: TriggerConditionType,
  key: TriggerParameter,
  experiment: Scalars['String'],
  treatments: Array<Scalars['String']>,
};

export type TriggerExperimentConditionInput = {
  experiment: Scalars['String'],
  treatments: Array<Scalars['String']>,
  key: TriggerParameterInput,
};

/** operator supported for each trigger field type
 * for example, equals, greater_than
 */
export type TriggerFieldOperator = {
  __typename: 'TriggerFieldOperator',
  name: Scalars['String'],
  displayName: Scalars['String'],
  leftOperandType: TriggerFieldType,
  rightOperandType: TriggerFieldType,
};

/** =============================
 * Trigger metadata.
 * =============================
 */
export enum TriggerFieldType {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  STRING = 'STRING',
  STRING_LIST = 'STRING_LIST',
  DATE = 'DATE',
  ID = 'ID',
  ID_LIST = 'ID_LIST'
}

export type TriggerFilter = TriggerNode & {
  __typename: 'TriggerFilter',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  condition?: Maybe<TriggerCondition>,
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>,
};


export type TriggerLiteralBooleanValue = {
  __typename: 'TriggerLiteralBooleanValue',
  type: TriggerParameterType,
  booleanValue: Scalars['Boolean'],
};

export type TriggerLiteralDateValue = {
  __typename: 'TriggerLiteralDateValue',
  type: TriggerParameterType,
  dateValue: Scalars['Date'],
};

export type TriggerLiteralIdListValue = {
  __typename: 'TriggerLiteralIdListValue',
  type: TriggerParameterType,
  idListValue: Array<Scalars['AnyId']>,
};

export type TriggerLiteralIdValue = {
  __typename: 'TriggerLiteralIdValue',
  type: TriggerParameterType,
  idValue: Scalars['AnyId'],
};

export type TriggerLiteralIntegerValue = {
  __typename: 'TriggerLiteralIntegerValue',
  type: TriggerParameterType,
  integerValue: Scalars['Int'],
};

export type TriggerLiteralStringListValue = {
  __typename: 'TriggerLiteralStringListValue',
  type: TriggerParameterType,
  stringListValue: Array<Scalars['String']>,
};

export type TriggerLiteralStringValue = {
  __typename: 'TriggerLiteralStringValue',
  type: TriggerParameterType,
  stringValue: Scalars['String'],
};

export type TriggerLiteralValue = TriggerLiteralBooleanValue | TriggerLiteralIntegerValue | TriggerLiteralStringValue | TriggerLiteralStringListValue | TriggerLiteralDateValue | TriggerLiteralIdValue | TriggerLiteralIdListValue;

export type TriggerLocalTime = {
  __typename: 'TriggerLocalTime',
  /** 0-23 */
  hour: Scalars['Int'],
  minute: Scalars['Int'],
};

export type TriggerLocalTimeInput = {
  /** 0-23 */
  hour: Scalars['Int'],
  minute: Scalars['Int'],
};

export type TriggerLocalTimeRange = {
  __typename: 'TriggerLocalTimeRange',
  beginTime: TriggerLocalTime,
  endTime?: Maybe<TriggerLocalTime>,
  timeZone: TriggerParameter,
};

export type TriggerLocalTimeRangeInput = {
  beginTime: TriggerLocalTimeInput,
  endTime?: Maybe<TriggerLocalTimeInput>,
  timeZone: TriggerParameterInput,
};

export type TriggerLogicalCondition = TriggerCondition & {
  __typename: 'TriggerLogicalCondition',
  type: TriggerConditionType,
  conditions: Array<TriggerCondition>,
  logicalOperator: LogicalOperator,
};

export type TriggerLogicalConditionInput = {
  conditions: Array<TriggerConditionInput>,
  logicalOperator: LogicalOperator,
};

export type TriggerNode = {
  __typename: 'TriggerNode',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
};

export enum TriggerNodeEdgeType {
  NEXT = 'NEXT',
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}


export enum TriggerNodeType {
  DELAY = 'DELAY',
  FILTER = 'FILTER',
  BRANCH = 'BRANCH',
  ACTION = 'ACTION',
  WAIT = 'WAIT'
}

export type TriggerParameter = TriggerEntityFieldReference | TriggerEventParameterReference | TriggerLiteralBooleanValue | TriggerLiteralIntegerValue | TriggerLiteralStringValue | TriggerLiteralStringListValue | TriggerLiteralDateValue | TriggerLiteralIdValue | TriggerLiteralIdListValue;

export type TriggerParameterInput = {
  type: TriggerParameterType,
  fieldName?: Maybe<Scalars['String']>,
  eventParameter?: Maybe<Scalars['String']>,
  booleanValue?: Maybe<Scalars['Boolean']>,
  stringValue?: Maybe<Scalars['String']>,
  integerValue?: Maybe<Scalars['Int']>,
  dateValue?: Maybe<Scalars['Date']>,
  idValue?: Maybe<Scalars['AnyId']>,
  stringListValue?: Maybe<Array<Scalars['String']>>,
  idListValue?: Maybe<Array<Scalars['AnyId']>>,
};

export type TriggerParameterMeta = {
  __typename: 'TriggerParameterMeta',
  name: Scalars['String'],
  displayName: Scalars['String'],
  type: TriggerFieldType,
  idType?: Maybe<Scalars['String']>,
  enumValues?: Maybe<Array<Scalars['String']>>,
  supportedOperators: Array<TriggerFieldOperator>,
  /** only applicable to TriggerActionMeta, N/A for TriggerEventMeta */
  required: Scalars['Boolean'],
  deprecated: Scalars['Boolean'],
  defaultValue?: Maybe<TriggerLiteralValue>,
  stringFieldType?: Maybe<StringFieldType>,
};

export enum TriggerParameterType {
  ENTITY_FIELD = 'ENTITY_FIELD',
  EVENT_PARAMETER = 'EVENT_PARAMETER',
  LITERAL_VALUE = 'LITERAL_VALUE'
}

export type TriggerQuery = {
  eventName?: Maybe<Scalars['String']>,
  state?: Maybe<TriggerState>,
};

/** =============================
 * Trigger instance
 * =============================
 */
export enum TriggerState {
  DRAFT = 'DRAFT',
  TEST = 'TEST',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED'
}

export type TriggerWait = TriggerNode & {
  __typename: 'TriggerWait',
  id: Scalars['TriggerNodeId'],
  type: TriggerNodeType,
  eventName?: Maybe<Scalars['String']>,
  eventEntityId?: Maybe<TriggerParameter>,
  maxWaitTime: TriggerDuration,
  nodeIdIfTrue?: Maybe<Scalars['TriggerNodeId']>,
  nodeIdIfFalse?: Maybe<Scalars['TriggerNodeId']>,
};

export type UnassignSupportTaskActivity = SupportTaskActivity & {
  __typename: 'UnassignSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
};

export type UnregisterFirebaseCloudMessagingTokenInput = {
  fcmToken: Scalars['String'],
};

export type UnregisterFirebaseCloudMessagingTokenPayload = {
  __typename: 'UnregisterFirebaseCloudMessagingTokenPayload',
  unregistered?: Maybe<Scalars['Boolean']>,
};

export type UnregisterWebPushSubscriptionInput = {
  subscription: Scalars['String'],
};

export type UnregisterWebPushSubscriptionPayload = {
  __typename: 'UnregisterWebPushSubscriptionPayload',
  unregistered: Scalars['Boolean'],
};

export enum UnsavedSellableReason {
  NOT_INTERESTED = 'NOT_INTERESTED',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  LOW_QUALITY = 'LOW_QUALITY',
  UGLY = 'UGLY',
  DONT_NEED = 'DONT_NEED',
  BOUGHT_ELSEWHERE = 'BOUGHT_ELSEWHERE'
}

export type UnsaveSavedSellableInput = {
  sellableId: Scalars['SellableId'],
  reason?: Maybe<UnsavedSellableReason>,
};

export type UnsaveSavedSellablePayload = {
  __typename: 'UnsaveSavedSellablePayload',
  savedSellable: SavedSellable,
};

export type UnsnoozeSupportTaskActivity = SupportTaskActivity & {
  __typename: 'UnsnoozeSupportTaskActivity',
  id: Scalars['SupportTaskActivityId'],
  supportTask: SupportTask,
  action: SupportTaskAction,
  actor: SupportTaskActor,
  consumer: User,
  lead?: Maybe<Lead>,
  occurredAt: Scalars['Date'],
  snoozedSupportTask: SupportTask,
};

/** Updates only supports minimal field updates, the core address fields are immutable */
export type UpdateAddressPreferencesInput = {
  addressId: Scalars['AddressId'],
  userId: Scalars['UserId'],
  userFriendlyName?: Maybe<Scalars['String']>,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type UpdateAddressPreferencesPayload = {
  __typename: 'UpdateAddressPreferencesPayload',
  updatedAddress?: Maybe<Address>,
  error?: Maybe<Scalars['String']>,
};

export type UpdateBusinessUserInput = {
  id: Scalars['BusinessUserId'],
  departmentId: Scalars['DepartmentId'],
  active?: Maybe<Scalars['Boolean']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
  expertAttributes?: Maybe<ExpertAttributeInput>,
  teamId?: Maybe<Scalars['BusinessUserTeamId']>,
  payStructureId?: Maybe<Scalars['PayStructureId']>,
  onCallCapable?: Maybe<Scalars['Boolean']>,
  featured?: Maybe<Scalars['Boolean']>,
};

export type UpdateBusinessUserPayload = {
  __typename: 'UpdateBusinessUserPayload',
  errors?: Maybe<Array<Scalars['String']>>,
  businessUser?: Maybe<BusinessUser>,
};

export type UpdateChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  channelType: ChannelType,
  emailTemplate?: Maybe<EmailTemplateInput>,
  smsTemplate?: Maybe<SmsTemplateInput>,
  inAppTemplate?: Maybe<InAppTemplateInput>,
  pushNotificationTemplate?: Maybe<PushNotificationTemplateInput>,
  slackTemplate?: Maybe<SlackTemplateInput>,
  facebookTemplate?: Maybe<FacebookTemplateInput>,
};

export type UpdateConfigInput = {
  domain: Scalars['String'],
  key: Scalars['String'],
  value: Scalars['String'],
};

export type UpdateConfigPayload = {
  __typename: 'UpdateConfigPayload',
  config?: Maybe<Config>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpdateConsumerExpertReviewInput = {
  id: Scalars['ConsumerExpertReviewId'],
  rating?: Maybe<Scalars['Int']>,
  headline?: Maybe<Scalars['String']>,
  comments?: Maybe<Scalars['String']>,
  goodQualities?: Maybe<Array<Scalars['String']>>,
  featured?: Maybe<Scalars['Boolean']>,
};

export type UpdateConsumerExpertReviewPayload = {
  __typename: 'UpdateConsumerExpertReviewPayload',
  review: ConsumerExpertReview,
};

export type UpdateExpertApplicationPayload = {
  __typename: 'UpdateExpertApplicationPayload',
  application: ExpertApplication,
};

export type UpdateExpertApplicationTaskStatusInput = {
  applicationId: Scalars['ExpertApplicationId'],
  task: ExpertApplicationTaskType,
  status: Scalars['String'],
  externalId?: Maybe<Scalars['String']>,
};

export type UpdateExpertApplicationTaskStatusPayload = {
  __typename: 'UpdateExpertApplicationTaskStatusPayload',
  application: ExpertApplication,
};

export type UpdateExpertCuratedItemCustomizationInput = {
  id: Scalars['SellableId'],
  title?: Maybe<Scalars['String']>,
  price?: Maybe<MonetaryAmountInput>,
};

export type UpdateExpertCuratedItemInput = {
  id: Scalars['ExpertCuratedItemId'],
  sellableId?: Maybe<Scalars['SellableId']>,
  priceOverride?: Maybe<MonetaryAmountInput>,
  tag?: Maybe<ExpertCuratedItemTagInput>,
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>,
  isBuiltFromRecommendation?: Maybe<Scalars['Boolean']>,
  draftNote?: Maybe<Scalars['String']>,
  noteId?: Maybe<Scalars['ExpertCuratedItemNoteId']>,
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>,
  /** add or update customizations, matching on `SellableId` to determine if it's an insert or update */
  upsertCustomizations?: Maybe<Array<UpdateExpertCuratedItemCustomizationInput>>,
  /** remove customizations for matching `SellableId`s */
  removeCustomizations?: Maybe<Array<Scalars['SellableId']>>,
};

export type UpdateExpertCuratedItemPayload = {
  __typename: 'UpdateExpertCuratedItemPayload',
  /** The entity that as ultimately modified; may be a new/existing draft that's staged to replace the targeted curated
   * item
 */
  updated: ExpertCuratedItem,
  /** The entity that was targeted for update being staged to be removed once `updated` is activated (converted to non
   * draft status)
 */
  superseded?: Maybe<ExpertCuratedItem>,
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories,
};

export type UpdateExpertCuratedOrderTermsInput = {
  id: Scalars['ExpertCuratedOrderId'],
  serviceStartsAt?: Maybe<Scalars['Date']>,
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>,
  minimumDepositPercent?: Maybe<Scalars['Int']>,
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>,
  flightPlanId?: Maybe<Scalars['FlightPlanId']>,
  defaultManualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>,
  inPreview?: Maybe<Scalars['Boolean']>,
};

export type UpdateExpertCuratedOrderTermsPayload = {
  __typename: 'UpdateExpertCuratedOrderTermsPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type UpdateExpertCuratedOrderVariationOptionInput = {
  id: Scalars['SellableId'],
  price?: Maybe<MonetaryAmountInput>,
  enabled?: Maybe<Scalars['Boolean']>,
  selected?: Maybe<Scalars['Boolean']>,
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>,
};

export type UpdateExpertCuratedOrderVariationOptionsInput = {
  id: Scalars['ExpertCuratedOrderId'],
  options: Array<UpdateExpertCuratedOrderVariationOptionInput>,
};

export type UpdateExpertCuratedOrderVariationOptionsPayload = {
  __typename: 'UpdateExpertCuratedOrderVariationOptionsPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type UpdateExpertProfileInput = {
  expertProfileId: Scalars['ExpertProfileId'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  profilePhotoId?: Maybe<Scalars['MediaId']>,
  headline?: Maybe<Scalars['String']>,
  background?: Maybe<Scalars['String']>,
  backgroundRichText?: Maybe<Scalars['String']>,
  quotes?: Maybe<Array<Scalars['String']>>,
  socialMediaUrls?: Maybe<Array<Scalars['String']>>,
  gallery?: Maybe<Array<MediaWithCaptionInput>>,
  recentArticles?: Maybe<Array<ExternalContentInput>>,
  highlights?: Maybe<Array<ProfileHighlightInput>>,
  introductionVideoUrl?: Maybe<Scalars['String']>,
  socialMediaAccessTokens?: Maybe<Array<SocialMediaAccessTokenInput>>,
  currentGearIds?: Maybe<Array<Scalars['SellableId']>>,
  favoriteBrandIds?: Maybe<Array<Scalars['BrandId']>>,
  gender?: Maybe<ExpertGender>,
};

export type UpdateExpertProfilePayload = {
  __typename: 'UpdateExpertProfilePayload',
  expertProfile?: Maybe<ExpertProfile>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateExternalAdCampaignInput = {
  adCampaignId: Scalars['ExternalAdCampaignId'],
  status: ExternalAdStatus,
  normalizedBudget: Scalars['BigDecimal'],
};

export type UpdateExternalAdCampaignPayload = {
  __typename: 'UpdateExternalAdCampaignPayload',
  adCampaign: ExternalAdCampaign,
};

export type UpdateExternalAdGroupInput = {
  adGroupId: Scalars['ExternalAdGroupId'],
  status: ExternalAdStatus,
  normalizedBudget?: Maybe<Scalars['BigDecimal']>,
  campaignNormalizedBudget?: Maybe<Scalars['BigDecimal']>,
};

export type UpdateExternalAdGroupPayload = {
  __typename: 'UpdateExternalAdGroupPayload',
  adGroup: ExternalAdGroup,
};

export type UpdateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'],
  name: Scalars['String'],
  messages: Array<GuestConversationSequenceMessageInput>,
};

export type UpdateGuestConversationSequencePayload = {
  __typename: 'UpdateGuestConversationSequencePayload',
  sequence: GuestConversationSequence,
};

export type UpdateLeadCampaignInput = {
  id: Scalars['LeadCampaignId'],
  name: Scalars['String'],
  facets: Array<FacetSelection>,
  deliveryTime?: Maybe<Scalars['Date']>,
  sellableId?: Maybe<Scalars['SellableId']>,
  minimumHoursSinceLastMessage: Scalars['Float'],
  minimumHoursSinceLastCampaign?: Maybe<Scalars['Float']>,
  maximumRecipients: Scalars['Float'],
  dateRangeFilters: Array<DateRangeFilterInput>,
  keywordsFilter?: Maybe<Scalars['String']>,
};

export type UpdateLeadCampaignPayload = {
  __typename: 'UpdateLeadCampaignPayload',
  error?: Maybe<Scalars['String']>,
  campaign?: Maybe<LeadCampaign>,
};

export type UpdateLeadNoteInput = {
  id: Scalars['LeadNoteId'],
  text: Scalars['String'],
};

export type UpdateLeadNotePayload = {
  __typename: 'UpdateLeadNotePayload',
  note: SavedLeadNote,
};

export type UpdateLeadPayload = {
  __typename: 'UpdateLeadPayload',
  lead: Lead,
};

export type UpdateMerchantInput = {
  id: Scalars['MerchantId'],
  /** Name cannot be unset; it must either be omitted, or set with a non-null value */
  name?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  address?: Maybe<PostalAddressInput>,
  logoUrl?: Maybe<Scalars['String']>,
  shippingNotificationsEmail?: Maybe<Scalars['String']>,
};

export type UpdateMerchantPayload = {
  __typename: 'UpdateMerchantPayload',
  merchant: Merchant,
};

export type UpdateNotificationChannelsInput = {
  messagingUserId: Scalars['AnyId'],
  notificationChannels: Array<MessagingChannelType>,
};

export type UpdateNotificationChannelsPayload = {
  __typename: 'UpdateNotificationChannelsPayload',
  messagingUser?: Maybe<MessagingUser>,
};

export type UpdateOperatorInput = {
  operatorId: Scalars['OperatorId'],
  active: Scalars['Boolean'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  roles: Array<OperatorRole>,
  /** @deprecated Use roles */
  isAdmin?: Maybe<Scalars['Boolean']>,
};

export type UpdateOperatorPayload = {
  __typename: 'UpdateOperatorPayload',
  operator?: Maybe<Operator>,
};

export type UpdateOrderEscalationPayload = {
  __typename: 'UpdateOrderEscalationPayload',
  orderEscalation: OrderEscalation,
};

export type UpdateOrderExpertContributionsInput = {
  orderId: Scalars['OrderId'],
  contributions: Array<OrderExpertContributionInput>,
};

export type UpdateOrderExpertContributionsPayload = {
  __typename: 'UpdateOrderExpertContributionsPayload',
  order: Order,
};

export type UpdateOrderPayload = {
  __typename: 'UpdateOrderPayload',
  order?: Maybe<Order>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateOrderShippingAddressInput = {
  orderId: Scalars['OrderId'],
  shippingAddress?: Maybe<AddressInput>,
};

export type UpdateOrderShippingAddressPayload = {
  __typename: 'UpdateOrderShippingAddressPayload',
  order: Order,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpdateOrderStateInput = {
  orderId: Scalars['OrderId'],
  newOrderState: OrderState,
};

export type UpdateOrderStatePayload = {
  __typename: 'UpdateOrderStatePayload',
  order?: Maybe<Order>,
  error?: Maybe<Scalars['String']>,
};

export type UpdatePaymentSourceInput = {
  id: Scalars['PaymentSourceId'],
  billingAddress: AddressInput,
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type UpdatePaymentSourcePayload = {
  __typename: 'UpdatePaymentSourcePayload',
  paymentSource: PaymentSource,
};

export type UpdatePayoutPayload = {
  __typename: 'UpdatePayoutPayload',
  payout?: Maybe<Payout>,
  error?: Maybe<Scalars['String']>,
};

export type UpdatePayStructureRevisionInput = {
  id: Scalars['PayStructureRevisionId'],
  components: Array<PayComponentRuleInput>,
};

export type UpdatePayStructureRevisionPayload = {
  __typename: 'UpdatePayStructureRevisionPayload',
  revision?: Maybe<PayStructureRevision>,
  error?: Maybe<Scalars['String']>,
};

export type UpdatePreferredMessagingChannelsInput = {
  messagingUserId: Scalars['AnyId'],
  preferredMessagingChannels: Array<MessagingChannelType>,
};

export type UpdatePreferredMessagingChannelsPayload = {
  __typename: 'UpdatePreferredMessagingChannelsPayload',
  messagingUser?: Maybe<MessagingUser>,
};

export type UpdatePromotionInput = {
  id: Scalars['PromotionId'],
  /** If omitted, this field won't be modified. */
  code?: Maybe<Scalars['String']>,
  /** If omitted, this field won't be modified. */
  description?: Maybe<Scalars['String']>,
  /** If omitted, this field won't be modified. */
  template?: Maybe<Scalars['Boolean']>,
  /** If omitted, this field won't be modified. If set to null, usageLimit will be removed. */
  usageLimit?: Maybe<Scalars['Int']>,
  /** If omitted, this field won't be modified. If set to null, expiresAt will be removed. */
  expiresAt?: Maybe<Scalars['Date']>,
};

export type UpdatePromotionPayload = {
  __typename: 'UpdatePromotionPayload',
  promotion: Promotion,
};

export type UpdateQuantityForOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>,
  lineItems: Array<UpdateQuantityForOrderLineItemInput>,
};

export type UpdateQuantityForOrderLineItemInput = {
  id: Scalars['OrderLineItemId'],
  quantity: Scalars['Int'],
};

export type UpdateQuantityForOrderPayload = {
  __typename: 'UpdateQuantityForOrderPayload',
  order: Order,
};

export type UpdateQuickReplyInput = {
  id: Scalars['QuickReplyId'],
  name: Scalars['String'],
  text: Scalars['String'],
};

export type UpdateQuickReplyPayload = {
  __typename: 'UpdateQuickReplyPayload',
  quickReply: QuickReply,
};

export type UpdateRawSellableSourceInput = {
  id: Scalars['RawSellableSourceId'],
  name: Scalars['String'],
  state: RawSellableSourceState,
  spider?: Maybe<RawSellableSourceSpiderInput>,
};

export type UpdateRawSellableSourcePayload = {
  __typename: 'UpdateRawSellableSourcePayload',
  source?: Maybe<RawSellableSource>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateRawSellableStandardizationRuleInput = {
  id: Scalars['RawSellableStandardizationRuleId'],
  name: Scalars['String'],
  sourceId?: Maybe<Scalars['RawSellableSourceId']>,
  priority: Scalars['Int'],
  condition: RawSellableStandardizationRuleConditionInput,
  actions: Array<RawSellableStandardizationActionInput>,
  state: RawSellableStandardizationRuleState,
};

export type UpdateRawSellableStandardizationRulePayload = {
  __typename: 'UpdateRawSellableStandardizationRulePayload',
  rule?: Maybe<RawSellableStandardizationRule>,
  hasError: Scalars['Boolean'],
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateRecommendedListDefinitionInput = {
  id: Scalars['RecommendedListDefinitionId'],
  /** User friendly name for this recommended list definition */
  name?: Maybe<Scalars['String']>,
  /** The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
 */
  titleTemplate?: Maybe<Scalars['String']>,
  /** The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
 */
  subTitleTemplate?: Maybe<Scalars['String']>,
  active?: Maybe<Scalars['Boolean']>,
  /** The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
 */
  rank?: Maybe<Scalars['Int']>,
  /** The categories for which this RecommendedListDefinition is being built. */
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  /** The filtering facets to refine recommended list results */
  queryFacets?: Maybe<Array<RecommendedListFacetSelectionInput>>,
  /** defaults to relevance based sorting */
  sortOptions?: Maybe<Array<RecommendedListSortOrderInput>>,
};

export type UpdateRecommendedListDefinitionPayload = {
  __typename: 'UpdateRecommendedListDefinitionPayload',
  recommendedListDefinition: RecommendedListDefinition,
};

export type UpdateReportInput = {
  reportId: Scalars['ReportId'],
  title: Scalars['String'],
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>,
  query: Scalars['String'],
  columns: Array<ReportColumnInput>,
  scope: ReportAccessScope,
  /** If specified, the columns from the schema are automatically added to the columns */
  schemaType?: Maybe<ReportSchemaType>,
};

export type UpdateReportPayload = {
  __typename: 'UpdateReportPayload',
  report: Report,
  errors?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type UpdateSavedExpertCuratedItemsInput = {
  id: Scalars['SavedExpertCuratedItemsId'],
  name?: Maybe<Scalars['String']>,
  /** Optional description for this curation */
  description?: Maybe<Scalars['String']>,
  taggedRequestAttributes?: Maybe<Array<AttributeInput>>,
};

export type UpdateSavedExpertCuratedItemsPayload = {
  __typename: 'UpdateSavedExpertCuratedItemsPayload',
  data?: Maybe<SavedExpertCuratedItems>,
  error?: Maybe<Scalars['String']>,
  hasError: Scalars['Boolean'],
};

export type UpdateSchedulingDemandForecastInput = {
  id: Scalars['SchedulingDemandForecastId'],
  startsAt: Scalars['Date'],
  endsAt: Scalars['Date'],
  maximumShiftUnits: Scalars['BigDecimal'],
};

export type UpdateSchedulingDemandForecastPayload = {
  __typename: 'UpdateSchedulingDemandForecastPayload',
  error?: Maybe<Scalars['String']>,
  forecast?: Maybe<SchedulingDemandForecast>,
};

export type UpdateSellableInput = {
  id: Scalars['SellableId'],
  /** price of this sellable; omittied if not applicable/available */
  originalPrice?: Maybe<MonetaryAmountInput>,
  /** default price we sell to consumer; omitted if not applicable/available (usually for parent sellable) */
  salePrice?: Maybe<MonetaryAmountInput>,
};

export type UpdateSellablePayload = {
  __typename: 'UpdateSellablePayload',
  sellable: Sellable,
};

/** `address` or `rawAddress` is required */
export type UpdateServiceLocationExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
  address?: Maybe<PostalAddressInput>,
  /** If entered, this will be geolocated and standardized into a `PostalAddress`. On geolocation failure, the
   * payload will have an appropriate errorCode and message.
 */
  rawAddress?: Maybe<Scalars['String']>,
};

export type UpdateServiceLocationExpertCuratedOrderPayload = {
  __typename: 'UpdateServiceLocationExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
  errorCode?: Maybe<ExpertCuratedOrderServiceLocationErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpdateShippingMethodInput = {
  orderId: Scalars['OrderId'],
  shippingMethod: ShippingMethod,
};

export type UpdateShippingMethodPayload = {
  __typename: 'UpdateShippingMethodPayload',
  order: Order,
};

export type UpdateSupportConversationPayload = {
  __typename: 'UpdateSupportConversationPayload',
  supportConversation: SupportConversation,
};

export type UpdateTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'],
  active: Scalars['Boolean'],
  title: Scalars['String'],
  description: Scalars['String'],
  content: Scalars['String'],
  usage: Scalars['String'],
};

export type UpdateTemplateFragmentPayload = {
  __typename: 'UpdateTemplateFragmentPayload',
  fragment: CommTemplateFragment,
};

export type UpdateTemplateInput = {
  templateId: Scalars['CommTemplateId'],
  title: Scalars['String'],
  locale: Scalars['String'],
  emailTemplate?: Maybe<EmailTemplateInput>,
  pushNotificationTemplate?: Maybe<PushNotificationTemplateInput>,
  slackTemplate?: Maybe<SlackTemplateInput>,
  inAppBody?: Maybe<Scalars['String']>,
  smsBody?: Maybe<Scalars['String']>,
  facebookBody?: Maybe<Scalars['String']>,
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryType?: Maybe<CategoryType>,
  experimentKey?: Maybe<Scalars['String']>,
  treatments?: Maybe<Array<Scalars['String']>>,
  tagSyntax?: Maybe<TemplateTagSyntax>,
  emailFromAddress?: Maybe<Scalars['String']>,
};

export type UpdateTemplatePayload = {
  __typename: 'UpdateTemplatePayload',
  multiLocaleTemplate?: Maybe<MultiLocaleTemplateSet>,
  errors?: Maybe<Array<Scalars['String']>>,
};

export type UpdateTemplateTypeInput = {
  templateTypeId: Scalars['CommTemplateTypeId'],
  group: TemplateTypeGroup,
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>,
  displayName: Scalars['String'],
  description: Scalars['String'],
  richCardType?: Maybe<MessageRichCardType>,
  dataModel: TemplateDataModelInput,
};

export type UpdateTemplateTypePayload = {
  __typename: 'UpdateTemplateTypePayload',
  error?: Maybe<Scalars['String']>,
  templateType?: Maybe<CommTemplateType>,
};

export type UpdateTriggerActionInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  actionName: Scalars['String'],
  parameters: Array<TriggerActionParameterInput>,
};

export type UpdateTriggerBranchInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  condition: TriggerConditionInput,
};

export type UpdateTriggerDelayInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  fixedInterval?: Maybe<TriggerDelayFixedIntervalInput>,
  delayWithExperiment?: Maybe<TriggerDelayWithExperimentInput>,
};

export type UpdateTriggerEdgeInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  edgeType: TriggerNodeEdgeType,
  nextNodeId: Scalars['TriggerNodeId'],
};

export type UpdateTriggerFilterInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  condition: TriggerConditionInput,
};

export type UpdateTriggerInput = {
  triggerId: Scalars['TriggerId'],
  name: Scalars['String'],
  groupName: Scalars['String'],
  description: Scalars['String'],
};

export type UpdateTriggerPayload = {
  __typename: 'UpdateTriggerPayload',
  trigger: Trigger,
};

export type UpdateTriggerWaitInput = {
  triggerId: Scalars['TriggerId'],
  nodeId: Scalars['TriggerNodeId'],
  eventName: Scalars['String'],
  eventEntityId: TriggerParameterInput,
  maxWaitTime: TriggerDurationInput,
};

export type UpdateUserProfileInput = {
  userId?: Maybe<Scalars['UserId']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  address?: Maybe<PostalAddressInput>,
  /** @deprecated use address */
  addressLine1?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  addressLine2?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  city?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  state?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  postalCode?: Maybe<Scalars['String']>,
  /** @deprecated use address */
  country?: Maybe<Scalars['String']>,
};

export type UpdateUserProfilePayload = {
  __typename: 'UpdateUserProfilePayload',
  user: User,
  errorCode?: Maybe<UserEditErrorCode>,
  hasError: Scalars['Boolean'],
  errors: Array<Scalars['String']>,
};

export type UpdateUserSourceInput = {
  userId: Scalars['UserId'],
  type: EditableUserSourceType,
};

export type UpdateUserSourcePayload = {
  __typename: 'UpdateUserSourcePayload',
  user: User,
  errorCode?: Maybe<UserEditErrorCode>,
  hasError: Scalars['Boolean'],
  errors: Array<Scalars['String']>,
};

export type UpgradeGuestConversationInput = {
  conversation: GuestConversationInput,
};

export type UpgradeGuestConversationPayload = {
  __typename: 'UpgradeGuestConversationPayload',
  me: Myself,
  lead: Lead,
};


export type UploadBrandsInput = {
  googleSpreadsheetId: Scalars['String'],
};

export type UploadBrandsPayload = {
  __typename: 'UploadBrandsPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadFeaturedSellableContentInput = {
  mediaId: Scalars['MediaId'],
};

export type UploadFeaturedSellableContentPayload = {
  __typename: 'UploadFeaturedSellableContentPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadMediaInput = {
  file: Scalars['Upload'],
  persist?: Maybe<Scalars['Boolean']>,
  mimeType?: Maybe<Scalars['String']>,
};

export type UploadMediaPayload = {
  __typename: 'UploadMediaPayload',
  mediaFile?: Maybe<MediaFile>,
};

export type UploadMerchantsInput = {
  googleSpreadsheetId: Scalars['String'],
  categoryId: Scalars['CategoryId'],
};

export type UploadMerchantsPayload = {
  __typename: 'UploadMerchantsPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellableDeactivationsInput = {
  googleSpreadsheetId: Scalars['String'],
};

export type UploadSellableDeactivationsPayload = {
  __typename: 'UploadSellableDeactivationsPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellableInventoryInput = {
  googleSpreadsheetId: Scalars['String'],
  categoryId: Scalars['CategoryId'],
  fulfillmentCenterId: Scalars['FulfillmentCenterId'],
};

export type UploadSellableInventoryPayload = {
  __typename: 'UploadSellableInventoryPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellablePriceInput = {
  googleSpreadsheetId: Scalars['String'],
  /** this field is deprecated and ignored */
  categoryId?: Maybe<Scalars['CategoryId']>,
};

export type UploadSellablePricePayload = {
  __typename: 'UploadSellablePricePayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellablesInput = {
  googleSpreadsheetId: Scalars['String'],
  filterGoogleSpreadsheetId?: Maybe<Scalars['String']>,
  categoryId: Scalars['CategoryId'],
};

export type UploadSellablesPayload = {
  __typename: 'UploadSellablesPayload',
  task?: Maybe<FrontendTask>,
};

export type UploadSellableUpdatesInput = {
  googleSpreadsheetId: Scalars['String'],
};

export type UploadSellableUpdatesPayload = {
  __typename: 'UploadSellableUpdatesPayload',
  task?: Maybe<FrontendTask>,
};

export type UpsertActionIntoPromotionInput = {
  id: Scalars['PromotionId'],
  /** If specified, the existing action with this same expectedReference id will be updated */
  referenceId?: Maybe<Scalars['PromotionActionReferenceId']>,
  action: PromotionActionReferenceInput,
};

export type UpsertActionIntoPromotionPayload = {
  __typename: 'UpsertActionIntoPromotionPayload',
  promotion: Promotion,
};

export type UpsertExpertCuratedLeadItineraryInput = {
  id: Scalars['LeadId'],
  contentfulVariation: Scalars['String'],
};

export type UpsertExpertCuratedLeadItineraryPayload = {
  __typename: 'UpsertExpertCuratedLeadItineraryPayload',
  expertCuratedLeadItinerary: ExpertCuratedLeadItinerary,
};

export type UpsertItemInExpertCuratedOrderInput = {
  id: Scalars['SellableId'],
  title?: Maybe<Scalars['String']>,
  price?: Maybe<MonetaryAmountInput>,
  /** Defaults to true */
  taxable?: Maybe<Scalars['Boolean']>,
  /** Defaults to true */
  optional?: Maybe<Scalars['Boolean']>,
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>,
};

export type UpsertItemsInExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'],
  items: Array<UpsertItemInExpertCuratedOrderInput>,
};

export type UpsertItemsInExpertCuratedOrderPayload = {
  __typename: 'UpsertItemsInExpertCuratedOrderPayload',
  expertCuratedOrder: ExpertCuratedOrder,
};

export type UpsertLegsIntoFlightPlanInput = {
  id: Scalars['FlightPlanId'],
  legs: Array<FlightPlanLegUpsertRequestInput>,
};

export type UpsertLegsIntoFlightPlanPayload = {
  __typename: 'UpsertLegsIntoFlightPlanPayload',
  flightPlan: FlightPlan,
  errorCode?: Maybe<FlightPlanEditErrorCode>,
  hasError: Scalars['Boolean'],
  errorMessage?: Maybe<Scalars['String']>,
};

export type UpsertRuleIntoPromotionInput = {
  id: Scalars['PromotionId'],
  /** If specified, the existing rule with this same expectedReference id will be updated */
  referenceId?: Maybe<Scalars['PromotionRuleReferenceId']>,
  rule: PromotionRuleReferenceInput,
};

export type UpsertRuleIntoPromotionPayload = {
  __typename: 'UpsertRuleIntoPromotionPayload',
  promotion: Promotion,
};

export type User = {
  __typename: 'User',
  /** This needs to AnyId instead of UserId since it is used with other identity objects such as BusinessUser
   * in a few union type.  Graphql will complain if the same field return different types
 */
  id: Scalars['AnyId'],
  firstName?: Maybe<Scalars['String']>,
  /** AUTH | Only current user and operator */
  lastName?: Maybe<Scalars['String']>,
  /** AUTH | Only current user and operator */
  contacts: Array<Contact>,
  /** AUTH | Only current user */
  roles: Array<Scalars['String']>,
  /** AUTH | Only current user */
  messagingUserId: Scalars['AnyId'],
  messagingUser: MessagingUser,
  /** AUTH | Only current user, merchant, or operator */
  profilePhoto?: Maybe<MediaFile>,
  /** AUTH | Only current user, operator.  address saved on the user profile. */
  address?: Maybe<PostalAddress>,
  /** AUTH | Only current user, operator.  addressed saved for payment */
  savedAddresses: Array<Address>,
  /** AUTH | Only current user, operator */
  assignedOperatorSeat?: Maybe<Operator>,
  assignedBusinessUsers: Array<BusinessUser>,
  externalProfiles: Array<ExternalProfile>,
  presence: PresenceStatus,
  anonymous: Scalars['Boolean'],
  pathUrl: Scalars['String'],
  browseUrl: Scalars['String'],
  recentCompletedPathIds: Array<Scalars['PathFlowId']>,
  recentIncompletePathIds: Array<Scalars['PathFlowId']>,
  firstCompletedRequest?: Maybe<DealRequest>,
  mostRecentRequest?: Maybe<DealRequest>,
  /** most recent lead sorted by activity time or creation date */
  mostRecentLead?: Maybe<Lead>,
  zoneId: Scalars['String'],
  /** use hasPhoneNumber instead of phoneNumber to check if the user has phone number
   * since phoneNumber can be null if the viewer doesn't have  permission
 */
  hasPhoneNumber: Scalars['Boolean'],
  /** use hasEmail instead of email to check if the user has phone number
   * since email can be null if the viewer doesn't have  permission
 */
  hasEmail: Scalars['Boolean'],
  phoneNumber?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  facebookMessengerId?: Maybe<Scalars['String']>,
  referredBy?: Maybe<User>,
  vip: Scalars['Boolean'],
  referral: Scalars['Boolean'],
  orders: Array<Order>,
  source?: Maybe<UserSource>,
  ipBasedData?: Maybe<IpBasedUserData>,
  adminUrl: Scalars['String'],
  /** Globally unique referral code */
  referralCode?: Maybe<Scalars['String']>,
  consumerExpertReviewConnection: ConsumerExpertReviewConnection,
  expertReviews: Array<ConsumerExpertReview>,
  viewSellableActivities: Array<ViewSellableUserActivity>,
  summarizedViewSellableActivities: Array<SummarizedViewSellableUserActivity>,
  summarizedActivities: Array<SummarizedUserActivity>,
};


export type UserExternalProfilesArgs = {
  type?: Maybe<ExternalProfileType>,
  premium: Scalars['Boolean']
};


export type UserPathUrlArgs = {
  pathFlowId: Scalars['PathFlowId']
};


export type UserBrowseUrlArgs = {
  pathFlowId: Scalars['PathFlowId']
};


export type UserMostRecentLeadArgs = {
  sortBy: LeadSortOrder
};


export type UserConsumerExpertReviewConnectionArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>,
  after?: Maybe<Scalars['String']>,
  first: Scalars['Int'],
  before?: Maybe<Scalars['String']>,
  last: Scalars['Int']
};


export type UserExpertReviewsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>
};


export type UserViewSellableActivitiesArgs = {
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  occurredSince?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};


export type UserSummarizedViewSellableActivitiesArgs = {
  categoryId?: Maybe<Scalars['CategoryId']>,
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  occurredSince?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};


export type UserSummarizedActivitiesArgs = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  leadIds?: Maybe<Array<Scalars['LeadId']>>,
  occurredSince?: Maybe<Scalars['Date']>,
  occurredBefore?: Maybe<Scalars['Date']>,
  limit?: Maybe<Scalars['Int']>
};

export type UserActivity = {
  __typename: 'UserActivity',
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  occurredAt: Scalars['Date'],
};


export enum UserActivityType {
  ADD_SELLABLE = 'ADD_SELLABLE',
  CHECKOUT_STARTED = 'CHECKOUT_STARTED',
  COMPLETE_ORDER = 'COMPLETE_ORDER',
  CURATED_LIST_VIEWED = 'CURATED_LIST_VIEWED',
  PAYMENT_INFO_ENTERED = 'PAYMENT_INFO_ENTERED',
  REMOVE_SELLABLE = 'REMOVE_SELLABLE',
  SEARCH_SELLABLES = 'SEARCH_SELLABLES',
  VIEW_CART = 'VIEW_CART',
  VIEW_SELLABLE = 'VIEW_SELLABLE',
  VOICE_CALL = 'VOICE_CALL',
  SAVED_SELLABLE = 'SAVED_SELLABLE',
  UNSAVED_SELLABLE = 'UNSAVED_SELLABLE'
}

/** ====== UserContactPathFlowQuestion */
export type UserContactPathFlowQuestion = PathFlowQuestion & {
  __typename: 'UserContactPathFlowQuestion',
  internalName: Scalars['String'],
  questionText?: Maybe<TextViewModel>,
  questionSubText?: Maybe<TextViewModel>,
  required: Scalars['Boolean'],
  inputIconImage?: Maybe<ImageViewModel>,
  inputLabel?: Maybe<TextViewModel>,
  attributes: Array<Attribute>,
  attribute?: Maybe<Attribute>,
  firstName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  lastName?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  phoneNumber?: Maybe<EmbeddedInputTextPathFlowQuestion>,
  /** If reloading a question answered by the user, this is their previous input */
  userContactUserInput: SubmitUserContactPathFlowQuestionInputTypeCopy,
};


/** ====== UserContactPathFlowQuestion */
export type UserContactPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>
};

export enum UserEditErrorCode {
  FIRST_NAME_REQUIRED = 'FIRST_NAME_REQUIRED',
  INVALID_CONTACT = 'INVALID_CONTACT'
}


export type UserSearchQuery = {
  keywords?: Maybe<Scalars['String']>,
};

export type UserSearchResult = {
  __typename: 'UserSearchResult',
  totalCount: Scalars['Long'],
  users: Array<User>,
};

export type UserSource = {
  __typename: 'UserSource',
  type: UserSourceType,
  initialUrl?: Maybe<Scalars['String']>,
  referrerUrl?: Maybe<Scalars['String']>,
  attributes: Array<UserSourceAttribute>,
  landingPageKey?: Maybe<Scalars['String']>,
};

export type UserSourceAttribute = {
  __typename: 'UserSourceAttribute',
  name: Scalars['String'],
  value: Scalars['String'],
};

export enum UserSourceType {
  ADS = 'ADS',
  REFERRAL = 'REFERRAL',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS',
  INVESTOR = 'INVESTOR',
  PARTNER = 'PARTNER',
  ORGANIC = 'ORGANIC'
}

/** Limit the amount of times a user can use a given promotion */
export type UserUsageLimitPromotionRuleReference = PromotionRuleReference & {
  __typename: 'UserUsageLimitPromotionRuleReference',
  id: Scalars['PromotionRuleReferenceId'],
  type: PromotionRuleType,
  /** The maximum amount of times the user can utilize this promotion. */
  limit: Scalars['Int'],
};

/** See `UserUsageLimitPromotionRuleReference` for documentation */
export type UserUsageLimitPromotionRuleReferenceInput = {
  limit: Scalars['Int'],
};

export type ValidateTriggerInput = {
  triggerId: Scalars['TriggerId'],
};

export type ValidateTriggerPayload = {
  __typename: 'ValidateTriggerPayload',
  errors: Array<Scalars['String']>,
};

/** A matrix of related sellables.
 * 
 * There are three hierarchies to this data structure; this variation matrix, the set of dimensions it contains, and
 * vectors for each dimension. Rather than defining these in abstract terms, lets work off of a simple example sellable.
 * 
 * Lets assume there's a parent sellable for "Nike T-Shirt", and it can vary on color (red, blue) and size (small,
 * medium, large). To understand the vocabulary used here, envision a matrix with two axis, "Color" on X, and "Size" on
 * Y. Each column will be marked with a color (red or blue), and each row will be marked with a size (small, medium, or
 * large). Each cell is a unique sellable variant (e.g.: Large Red Nike T-Shirt).
 * 
 * This is how the above concept is represented with the variation matrix data structures:
 * 
 * - VariationMatrix: This class which represents the entire matrix. This only contains variations, so in our example
 *   this will contain "Medium Red" and "Small Blue" T-Shirts, but doesn't contain the top level "Nike T-Shirt" sellable.
 * - VariationMatrixDimension: A dimension (axis) which a sellable can vary. In our example, there
 *   will be two dimensions; Size and Color. These are the axis on our matrix.
 * - VariationMatrixVector: For each of the dimensions, there will be a vector (a row or column) in the matrix that
 *   represents a unique value for that dimension. For example, if the dimension is "Color", a Vector may be labled with
 *   "red". Note that this is not a "cell" of a matrix which would represent a single SellableId (like "Medium Red"), this
 *   represents the entire column/row. So for the "red" vector, it will contain three SellableIds: "Small red", "Medium
 *   red", and "Large red". See following sections for how to use this data.
 * 
 * To allow for seamless client UIs that don't require network communication when flipping between variants, API calls
 * are not required to compute what variants are applicable as variants or selected, or to get the final sellable id
 * after all variants are selected. Instead, two things are provided:
 * 
 * 
 * - All of the related SellableIds that are part of this variation matrix (via sellables property). This is guaranteed
 *   to contain all variations, so it's possible to pre-load these sellables to provide a seamless UI that show details of
 *   sellables as variants are selected / moused over without going back to the network.
 * - For each vector (e.g.: color red), the SellableIds that match that criteria (via VariationMatrixVector.sellableIds).
 * 
 * To compute what sellables (if any) are applicable, take the intersection of the SellableIds for each selected vector
 * in each dimension (there should only be one selected vector per dimension). This computation will result in zero or
 * one SellableIds - zero if there are no sellables for that variation combination, or one which will be the sellable for
 * that variation combination.
 */
export type VariationMatrix = {
  __typename: 'VariationMatrix',
  /** Dimensions for this variation matrix; a dimension is something like "color", "size", "gender", etc.
   * Each dimension will contain at least one vector
 */
  dimensions: Array<VariationMatrixDimension>,
  /** All of the sellable ids that are inside of this variation matrix, excluding the parent sellable. */
  sellables: Array<Sellable>,
  /** The price range across all the sellables in the variation matrix. */
  priceRange?: Maybe<VariationMatrixPriceRange>,
  /** The preferred sellable variant to show by default */
  defaultVariant: Sellable,
  /** Variant that has the maximum delta between original price (MSRP) and sale price. If none of the variants provide
   * savings over MSRP, this will be the cheapest variant
 */
  maximumSavingsVariant: Sellable,
  /** The maximum delta between original price (MSRP) and sale price across all variations. If none of the variants
   * provide savings over MSRP, this will be null.
 */
  maximumSavingsAmount?: Maybe<MonetaryAmount>,
  /** The maximum percent savings between original price (MSRP) and sale price across all variations. If none of the
   * variants provide savings over MSRP, this will be null.
 */
  maximumSavingsPercent?: Maybe<Scalars['Float']>,
  /** All out of stock sellables that are inside of this variation matrix. */
  outOfStockSellables: Array<Sellable>,
};

/** Dimensions represent categories of things that are varied on, like color, size, gender, etc. */
export type VariationMatrixDimension = {
  __typename: 'VariationMatrixDimension',
  /** Internal name for this variation matrix dimension; not intended to be displayed in the UI */
  name: Scalars['String'],
  /** Display name for this dimension.
   * This may be something like "Color", "Length", where it effectively serves as a title for the vectors within this
   * dimension. Note that this display name is not required. For example, if there is only one dimension, and that's a
   * title dimension, the grouping may not be titled. For title dimensions, each vector may be the shortened product
   * title, e.g.: "Red Special Edition", "Anniversary Edition", "Game of the year bundle".
 */
  displayName?: Maybe<Scalars['String']>,
  /** Vectors (unique options) within this dimension.
   * 
   * If this dimension is color, vectors will represent concrete values like "Red", "Blue", "Black", etc.
 */
  vectors: Array<VariationMatrixVector>,
};

export type VariationMatrixPriceRange = {
  __typename: 'VariationMatrixPriceRange',
  min: MonetaryAmount,
  max: MonetaryAmount,
};

/** A unique option within a dimension.
 * For example, if this vector is contained inside of the "color" dimension, this may represent the color "red".
 */
export type VariationMatrixVector = {
  __typename: 'VariationMatrixVector',
  /** Internal value for this vector; not to be displayed in the UI. Expect this to be things like "RED", "123", "WOMAN", etc. */
  value: Scalars['String'],
  /** Display value formatted as sanitized HTML. To match with the value property examples, expect this to be things like
   * "Red", "123cm", "Woman", etc.
 */
  displayValueHtml: Scalars['String'],
  /** All of the sellable ids (subset of VariationMatrix.sellables) that fall into this vector.
   * See the docs associated with VariationMatrix to see how these SellableIds should be used.
 */
  sellableIds: Array<Scalars['SellableId']>,
};

export type VerifyHandleChallengeInput = {
  /** handle/handleType or handleId must be present */
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  handleId?: Maybe<Scalars['AnyId']>,
  challenge: Scalars['String'],
};

export type VerifyHandleChallengePayload = {
  __typename: 'VerifyHandleChallengePayload',
  success: Scalars['Boolean'],
  message?: Maybe<Scalars['String']>,
};

export enum VerifyPendingAccessContactErrorCode {
  INVALID_TOKEN = 'INVALID_TOKEN'
}

export type VerifyPendingAccessContactInput = {
  id: Scalars['PendingAccessContactId'],
  token: Scalars['String'],
};

export type VerifyPendingAccessContactPayload = {
  __typename: 'VerifyPendingAccessContactPayload',
  pendingAccessContact?: Maybe<PendingAccessContact>,
  hasError: Scalars['Boolean'],
  errorCode?: Maybe<VerifyPendingAccessContactErrorCode>,
  errorMessage?: Maybe<Scalars['String']>,
};

export type VerifyResetPasswordChallengeInput = {
  handle?: Maybe<Scalars['String']>,
  handleType?: Maybe<HandleType>,
  challenge: Scalars['String'],
};

export type VerifyResetPasswordChallengePayload = {
  __typename: 'VerifyResetPasswordChallengePayload',
  success: Scalars['Boolean'],
  message?: Maybe<Scalars['String']>,
  session: Session,
};

export type ViewSellableUserActivity = UserActivity & {
  __typename: 'ViewSellableUserActivity',
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  occurredAt: Scalars['Date'],
  endedAt?: Maybe<Scalars['Date']>,
  sellable: Sellable,
};

export type VoiceCallUserActivity = UserActivity & {
  __typename: 'VoiceCallUserActivity',
  id: Scalars['UserActivityId'],
  userId: Scalars['UserId'],
  type: UserActivityType,
  expertId: Scalars['BusinessUserId'],
  userPhoneNumber: Scalars['String'],
  status: Scalars['String'],
  callId: Scalars['String'],
  occurredAt: Scalars['Date'],
};

export type WireTransferPaymentEntity = PaymentEntity & {
  __typename: 'WireTransferPaymentEntity',
  paymentMethod: PaymentMethod,
  accountNumber: Scalars['String'],
  bankName: Scalars['String'],
  routingNumber: Scalars['String'],
  swiftCode: Scalars['String'],
  beneficiaryName: Scalars['String'],
  beneficiaryAddress: WireTransferPaymentEntityBeneficiaryAddress,
  chargeableAmount: MonetaryAmount,
};

export type WireTransferPaymentEntityBeneficiaryAddress = {
  __typename: 'WireTransferPaymentEntityBeneficiaryAddress',
  line1: Scalars['String'],
  line2?: Maybe<Scalars['String']>,
  city: Scalars['String'],
  state: Scalars['String'],
  country: Scalars['String'],
  postalCode: Scalars['String'],
};

export type WokeUpFromSnoozeActivity = LeadActivity & {
  __typename: 'WokeUpFromSnoozeActivity',
  id: Scalars['LeadActivityId'],
  type: LeadActivityType,
  lead: Lead,
  occurredAt: Scalars['Date'],
  snooze: LeadSnooze,
};

export type YadavSellablePriceSource = SellablePriceSource & {
  __typename: 'YadavSellablePriceSource',
  id: Scalars['SellablePriceSourceId'],
  type: SellablePriceSourceType,
  sellable: Sellable,
  price?: Maybe<MonetaryAmount>,
  canRefresh: Scalars['Boolean'],
  willRefresh: Scalars['Boolean'],
  externalId: Scalars['String'],
  certificateUrl?: Maybe<Scalars['String']>,
};
export type ConsumerExpertReviewFragment = ({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id' | 'reviewedAt' | 'rating' | 'headline' | 'comments' | 'consumerName'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'acceptingNewRequests'>)> }), verifiedPurchases: Array<({ __typename: 'Sellable' } & ActivityFeedSellableFragment)> });

export type ActivityFeedSellableFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> } & SellablePricingFragment);

export type AirportTypeaheadResultFragment = ({ __typename: 'AirportTypeaheadHit' } & Pick<AirportTypeaheadHit, 'id' | 'name'>);

export type AirportTypeaheadSearchQueryVariables = {
  query: AirportTypeaheadQuery,
  first?: Maybe<Scalars['Int']>
};


export type AirportTypeaheadSearchQuery = ({ __typename: 'Query' } & { airportTypeahead: ({ __typename: 'AirportTypeaheadPayload' } & { hits: Array<({ __typename: 'AirportTypeaheadHit' } & AirportTypeaheadResultFragment)> }) });

export type ExpertPhoneNumberBySlugQueryVariables = {
  slug: Scalars['String']
};


export type ExpertPhoneNumberBySlugQuery = ({ __typename: 'Query' } & { categoryBySlug: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { recommendExpertForConsumer: ({ __typename: 'RecommendExpertPayload' } & { expert: Maybe<({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { assignedPhone: BusinessUser['assignedAddress'] } & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> })> })> }) })> });

export type CategoryBreadcrumbFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>);

export type UserLoginTokenQueryVariables = {};


export type UserLoginTokenQuery = ({ __typename: 'Query' } & { me: Maybe<({ __typename: 'Myself' } & Pick<Myself, 'id' | 'loginToken'>)> });

export type HeroExpertCuratedItemByCategoryFragment = ({ __typename: 'ExpertCuratedItemsByCategory' } & { category: ({ __typename: 'Category' } & Pick<Category, 'id' | 'singularDisplayName'>), items: Array<({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'> & { note: Maybe<({ __typename: 'ExpertCuratedItemNote' } & Pick<ExpertCuratedItemNote, 'id'>)> })> });

export type HeroCuratedExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>)>, expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> });

export type HeroCuratedItemsLeadFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id'>), expert: ({ __typename: 'BusinessUser' } & HeroCuratedExpertFragment), consumerConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>), expertConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'type'>)> });

export type HeroExpertCuratedItemImageFragment = ({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'> & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'title'> & { images: Array<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> }) });

export type CuratedItemsForLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type CuratedItemsForLeadQuery = ({ __typename: 'Query' } & { expertCuratedItemsForLead: ({ __typename: 'ExpertCuratedItemsForLeadPayload' } & { byCategories: ({ __typename: 'ExpertCuratedItemsByCategories' } & Pick<ExpertCuratedItemsByCategories, 'id'> & { categories: Array<({ __typename: 'ExpertCuratedItemsByCategory' } & HeroExpertCuratedItemByCategoryFragment)> }), items: Array<({ __typename: 'ExpertCuratedItem' } & HeroExpertCuratedItemImageFragment)> }), lead: ({ __typename: 'Lead' } & HeroCuratedItemsLeadFragment), expertCuratedOrdersForLeadConnection: ({ __typename: 'ExpertCuratedOrdersForLeadConnection' } & { edges: Array<({ __typename: 'ExpertCuratedOrdersForLeadEdge' } & { node: ({ __typename: 'ExpertCuratedOrder' } & ExpertCuratedOrderFragment) })> }) });

export type DepartmentExpertReviewFragment = ({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id' | 'comments' | 'goodQualities' | 'headline' | 'rating' | 'reviewedAt'> & { consumer: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>), expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }) });

export type DepartmentDetailedReviewsQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type DepartmentDetailedReviewsQuery = ({ __typename: 'Query' } & { department: ({ __typename: 'Department' } & Pick<Department, 'id' | 'displayName' | 'slug'> & { reviewSummary: ({ __typename: 'ReviewSummary' } & Pick<ReviewSummary, 'averageRating' | 'totalReviews'>), consumerExpertReviewConnection: ({ __typename: 'ConsumerExpertReviewConnection' } & { edges: Array<({ __typename: 'ConsumerExpertReviewEdge' } & { node: ({ __typename: 'ConsumerExpertReview' } & DepartmentExpertReviewFragment) })> }) }) });

export type PathCategoryFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'> & { parents: Array<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> });

export type EngagementChannelCategoryFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'> & { department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'type' | 'acceptingRequests' | 'launched'>)>, contentAssets: ({ __typename: 'CategoryContentAssets' } & { fixedBarDesktop: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)>, callout: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)>, fullPageTakeover: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }), ancestorWithPath: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> } & PathCategoryFragment);

export type EngagementChannelCategoryAssetsQueryVariables = {
  categoryId: Scalars['CategoryId']
};


export type EngagementChannelCategoryAssetsQuery = ({ __typename: 'Query' } & { category: ({ __typename: 'Category' } & EngagementChannelCategoryFragment) });

export type PathSlugForCategoryQueryVariables = {
  slug: Scalars['String']
};


export type PathSlugForCategoryQuery = ({ __typename: 'Query' } & { categoryBySlug: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'> & { ancestorWithPath: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> })> });

export type CategoryModalFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName' | 'singularDisplayName'> & { ancestorWithPath: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> });

export type SellableBrandCategoryQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableBrandCategoryQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { brand: Maybe<({ __typename: 'Brand' } & BrandFragment)>, categories: Array<({ __typename: 'Category' } & CategoryModalFragment)> })> });

export type AddItemsToOrderMutationVariables = {
  input: AddItemsToOrderInput
};


export type AddItemsToOrderMutation = ({ __typename: 'Mutation' } & { addItemsToOrder: ({ __typename: 'AddItemsToOrderPayload' } & { order: ({ __typename: 'Order' } & Pick<Order, 'id'>) }) });

export type SellableForModalFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'title'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> } & SellablePricingFragment);

export type SellableForModalQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableForModalQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & SellableForModalFragment)> });

export type ExpertByCategoryQueryVariables = {
  categoryId: Scalars['CategoryId']
};


export type ExpertByCategoryQuery = ({ __typename: 'Query' } & { category: ({ __typename: 'Category' } & Pick<Category, 'id'> & { ancestorWithPath: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'name' | 'slug' | 'startPathUrl'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })>, experts: Array<({ __typename: 'BusinessUser' } & ChatWidgetExpertFragment)> }) });

export type ExpertPhoneNumberQueryVariables = {
  slug: Scalars['String']
};


export type ExpertPhoneNumberQuery = ({ __typename: 'Query' } & { categoryBySlug: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { recommendExpertForConsumer: ({ __typename: 'RecommendExpertPayload' } & { expert: Maybe<({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id'> & { assignedPhone: BusinessUser['assignedAddress'] })> }) })> });

export type RatesTableQueryVariables = {
  id: Scalars['SellableId']
};


export type RatesTableQuery = ({ __typename: 'Query' } & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { variationMatrix: Maybe<({ __typename: 'VariationMatrix' } & VariationMatrixFragment)> }) });

export type RatesTableSellableQueryVariables = {
  ids: Array<Scalars['SellableId']>
};


export type RatesTableSellableQuery = ({ __typename: 'Query' } & { sellables: Array<({ __typename: 'Sellable' } & SellablePricingFragment)> });

export type SelectExperienceVariationOptionMutationVariables = {
  input: SelectExpertCuratedOrderVariationOptionInput
};


export type SelectExperienceVariationOptionMutation = ({ __typename: 'Mutation' } & { selectExpertCuratedOrderVariationOption: ({ __typename: 'SelectExpertCuratedOrderVariationOptionPayload' } & { expertCuratedOrder: ({ __typename: 'ExpertCuratedOrder' } & ExpertCuratedOrderFragment) }) });

export type DurationSelectorFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, variants: Array<({ __typename: 'SellableFormattedVariant' } & Pick<SellableFormattedVariant, 'value'>)>, variationMatrix: Maybe<({ __typename: 'VariationMatrix' } & VariationMatrixFragment)> });

export type DurationSelectorQueryVariables = {
  id: Scalars['SellableId']
};


export type DurationSelectorQuery = ({ __typename: 'Query' } & { sellable: ({ __typename: 'Sellable' } & DurationSelectorFragment) });

export type RecommendedExpertForRequestQueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type RecommendedExpertForRequestQuery = ({ __typename: 'Query' } & { recommendExpert2: ({ __typename: 'RecommendExpertPayload' } & { expert: Maybe<({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id'>)> }) });

export type ExperienceByExpertCuratedOrderQueryVariables = {
  id: Scalars['ExpertCuratedOrderId']
};


export type ExperienceByExpertCuratedOrderQuery = ({ __typename: 'Query' } & { expertCuratedOrder: ({ __typename: 'ExpertCuratedOrder' } & ExpertCuratedOrderFragment) });

export type ExperienceAttributeFragment = ({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'name' | 'displayHtml'>)> });

export type ExperienceSellableDetailsFragment = ({ __typename: 'Sellable' } & { charterLocation: Maybe<({ __typename: 'Attribute' } & ExperienceAttributeFragment)>, charterLengthFeet: Maybe<({ __typename: 'Attribute' } & ExperienceAttributeFragment)>, charterCabins: Maybe<({ __typename: 'Attribute' } & ExperienceAttributeFragment)>, charterCapacity: Maybe<({ __typename: 'Attribute' } & ExperienceAttributeFragment)>, charterAmenities: Maybe<({ __typename: 'Attribute' } & ExperienceAttributeFragment)> } & (SellableDetailsFragment & SellablePricingFragment));

export type ExperienceByFriendlyIdOrIdQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type ExperienceByFriendlyIdOrIdQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & ExperienceSellableDetailsFragment)> });

export type RequestSellableMutationVariables = {
  input: RequestSellableInput
};


export type RequestSellableMutation = ({ __typename: 'Mutation' } & { requestSellable: ({ __typename: 'RequestSellablePayload' } & Pick<RequestSellablePayload, 'error'> & { lead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) })> }) });

export type FindExpertCalloutQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type FindExpertCalloutQuery = ({ __typename: 'Query' } & { findExpert: Maybe<({ __typename: 'BusinessUser' } & ProductExpertCardFragment)> });

export type ExpertDepartmentFragment = ({ __typename: 'Department' } & Pick<Department, 'id' | 'type'>);

export type ProductExpertCardFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'active' | 'vanityId' | 'firstName' | 'lastName'> & { department: ({ __typename: 'Department' } & ExpertDepartmentFragment), expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline' | 'location' | 'background'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>)>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'averageRating' | 'totalMessages' | 'totalReviews' | 'totalLeads'>)> });

export type ProductRecommendedExpertCalloutQueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type ProductRecommendedExpertCalloutQuery = ({ __typename: 'Query' } & { recommendExpert2: ({ __typename: 'RecommendExpertPayload' } & { existingLead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) })>, expert: Maybe<({ __typename: 'BusinessUser' } & ProductExpertCardFragment)> }) });

export type ExpertFooterUserReviewsQueryVariables = {
  userId: Scalars['UserId'],
  expertId?: Maybe<Scalars['BusinessUserId']>
};


export type ExpertFooterUserReviewsQuery = ({ __typename: 'Query' } & { user: ({ __typename: 'User' } & Pick<User, 'id'> & { consumerExpertReviewConnection: ({ __typename: 'ConsumerExpertReviewConnection' } & { edges: Array<({ __typename: 'ConsumerExpertReviewEdge' } & { node: ({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id'>) }) })> }) }) });

export type ExpertProfilePhotoCarouselFragment = ({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, gallery: Array<({ __typename: 'MediaFileWithCaption' } & Pick<MediaFileWithCaption, 'caption'> & { mediaFile: ({ __typename: 'MediaFile' } & MediaFileFragment) })> });

export type SellableKeywordTypeaheadResultFragment = ({ __typename: 'SellableTypeaheadHit' } & Pick<SellableTypeaheadHit, 'id' | 'text' | 'title' | 'brandName'> & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>) });

export type SellableKeywordTypeaheadQueryVariables = {
  query: SellableTypeaheadQuery,
  first?: Maybe<Scalars['Int']>
};


export type SellableKeywordTypeaheadQuery = ({ __typename: 'Query' } & { sellableTypeahead: ({ __typename: 'SellableTypeaheadPayload' } & { hits: Array<({ __typename: 'SellableTypeaheadHit' } & SellableKeywordTypeaheadResultFragment)> }) });

export type NavInactiveDepartmentFragment = ({ __typename: 'Department' } & Pick<Department, 'id' | 'type' | 'slug' | 'displayName' | 'acceptingRequests' | 'launched'> & { topLevelCategory: ({ __typename: 'Category' } & Pick<Category, 'id'>) });

export type NavDepartmentsQueryVariables = {};


export type NavDepartmentsQuery = ({ __typename: 'Query' } & { departmentsForNavigation: Array<({ __typename: 'Department' } & NavInactiveDepartmentFragment)> });

export type FacetSelectionPayloadFragment = ({ __typename: 'FacetSelectionPayload' } & Pick<FacetSelectionPayload, 'name' | 'alias' | 'displayName' | 'bucketValues' | 'lower' | 'upper'>);

export type DepartmentNavigationResponsiveMixinFragment = ({ __typename: 'DepartmentNavigationTopLevelItem' | 'DepartmentNavigationExpertSubSection' | 'DepartmentNavigationListSubSection' } & Pick<DepartmentNavigationResponsiveMixin, 'showIfSmallSize' | 'showIfFullSize' | 'smallSizeOptions' | 'fullSizeOptions'>);

export type DepartmentNavigationLinkFragment = (({ __typename: 'DepartmentNavigationCategoryLink' } & { category: ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>) }) | ({ __typename: 'DepartmentNavigationSearchLink' } & { category: ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>), facets: Array<({ __typename: 'FacetSelectionPayload' } & FacetSelectionPayloadFragment)> }) | ({ __typename: 'DepartmentNavigationCreatePathLink' } & Pick<DepartmentNavigationCreatePathLink, 'pathSlug'>) | ({ __typename: 'DepartmentNavigationExpertCommunityLink' } & Pick<DepartmentNavigationExpertCommunityLink, 'departmentSlug'>));

export type DepartmentNavigationSubSectionFragment = ({ __typename: 'DepartmentNavigationExpertSubSection' | 'DepartmentNavigationListSubSection' } & Pick<DepartmentNavigationSubSection, 'id' | 'title'> & { titleLink: Maybe<DepartmentNavigationLinkFragment> } & (DepartmentNavigationResponsiveMixinFragment & ({ __typename: 'DepartmentNavigationListSubSection' } & DepartmentNavigationListSubSectionFragment)));

export type DepartmentNavigationListSubSectionFragment = ({ __typename: 'DepartmentNavigationListSubSection' } & Pick<DepartmentNavigationListSubSection, 'title'> & { titleLink: Maybe<DepartmentNavigationLinkFragment>, items: Array<({ __typename: 'DepartmentNavigationListSubSectionItem' } & Pick<DepartmentNavigationListSubSectionItem, 'id' | 'label' | 'labelStyles' | 'imagePath' | 'imageUrl'> & { link: DepartmentNavigationLinkFragment })> });

export type DepartmentNavigationTopLevelItemFragment = ({ __typename: 'DepartmentNavigationTopLevelItem' } & Pick<DepartmentNavigationTopLevelItem, 'id' | 'label'> & { labelLink: Maybe<DepartmentNavigationLinkFragment>, subSections: Array<({ __typename: 'DepartmentNavigationExpertSubSection' | 'DepartmentNavigationListSubSection' } & DepartmentNavigationSubSectionFragment)> } & DepartmentNavigationResponsiveMixinFragment);

export type NavActiveDepartmentFragment = ({ __typename: 'Department' } & Pick<Department, 'id' | 'type' | 'slug' | 'displayName' | 'launched' | 'acceptingRequests'> & { navigation: ({ __typename: 'DepartmentNavigation' } & { topLevelItems: Array<({ __typename: 'DepartmentNavigationTopLevelItem' } & DepartmentNavigationTopLevelItemFragment)> }), topLevelCategories: Array<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> });

export type NavHierarchyQueryVariables = {
  activeDepartmentId: Scalars['DepartmentId']
};


export type NavHierarchyQuery = ({ __typename: 'Query' } & { activeDepartment: ({ __typename: 'Department' } & NavActiveDepartmentFragment) });

export type SubSectionExpertQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type SubSectionExpertQuery = ({ __typename: 'Query' } & { recommendExpertsForDepartment: Array<({ __typename: 'RecommendedExpert' } & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'averageRating' | 'totalMessages'>)>, expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> })> }), existingLead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id'>) })> })> });

export type ReleaseConsumerIdentityMutationVariables = {};


export type ReleaseConsumerIdentityMutation = ({ __typename: 'Mutation' } & { releaseConsumerIdentity: ({ __typename: 'ReleaseConsumerIdentityPayload' } & { user: Maybe<({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>)> }) });

export type HeartbeatSubscriptionVariables = {};


export type HeartbeatSubscription = ({ __typename: 'Subscription' } & Pick<Subscription, 'heartbeat'>);

export type LandingPageExpertCardFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'active' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'background'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, highlights: Array<({ __typename: 'ProfileHighlight' } & Pick<ProfileHighlight, 'secondaryValue' | 'value'>)> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'averageRating' | 'totalReviews' | 'totalMessages'>)> });

export type LandingPageExpertsQueryVariables = {
  slug: Scalars['String']
};


export type LandingPageExpertsQuery = ({ __typename: 'Query' } & { categoryBySlug: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { experts: Array<({ __typename: 'BusinessUser' } & LandingPageExpertCardFragment)> })> });

export type KeystoneExpertsQueryVariables = {
  slug: Scalars['String']
};


export type KeystoneExpertsQuery = ({ __typename: 'Query' } & { categoryBySlug: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { experts: Array<({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> })> })> });

export type SearchSellablesLandingQueryVariables = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  type?: Maybe<SellableType>,
  facets?: Maybe<Array<FacetSelection>>
};


export type SearchSellablesLandingQuery = ({ __typename: 'Query' } & { searchSellables: ({ __typename: 'SellableSearchConnection' } & Pick<SellableSearchConnection, 'count'> & { facets: Array<({ __typename: 'BucketedDisplayFacet' | 'BucketedRangeDisplayFacet' | 'NumericRangeDisplayFacet' } & DisplayFacetFragment)> }) });

export type DiamondDepartmentContextQueryVariables = {};


export type DiamondDepartmentContextQuery = ({ __typename: 'Query' } & { departmentBySlug: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> });

export type JetChartersDepartmentContextQueryVariables = {};


export type JetChartersDepartmentContextQuery = ({ __typename: 'Query' } & { departmentBySlug: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> });

export type CategoryMediaFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'type' | 'name' | 'singularDisplayName'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) });

export type ExpertDataFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> })>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>)> });

export type RequestAttributesFragment = ({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>)> });

export type ChatLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ChatLeadQuery = ({ __typename: 'Query' } & { lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & ExpertDataFragment), consumer: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName'> & { contacts: Array<({ __typename: 'Contact' } & Pick<Contact, 'id' | 'type' | 'value'>)>, messagingUser: ({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id'>) }), category: Maybe<({ __typename: 'Category' } & CategoryMediaFragment)>, latestRequest: Maybe<({ __typename: 'DealRequest' } & Pick<DealRequest, 'id'> & { attributes: Array<({ __typename: 'Attribute' } & RequestAttributesFragment)> })> }) });

export type CommTemplateTypeQueryVariables = {
  id: Scalars['CommTemplateTypeId']
};


export type CommTemplateTypeQuery = ({ __typename: 'Query' } & { commTemplateType: ({ __typename: 'CommTemplateType' } & Pick<CommTemplateType, 'id' | 'richCardType'>) });

export type ContactCollectionUpdatePhoneMutationVariables = {
  input: UpdateUserProfileInput
};


export type ContactCollectionUpdatePhoneMutation = ({ __typename: 'Mutation' } & { updateUserProfile: ({ __typename: 'UpdateUserProfilePayload' } & Pick<UpdateUserProfilePayload, 'errors'> & { user: ({ __typename: 'User' } & Pick<User, 'id'> & { contacts: Array<({ __typename: 'Contact' } & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>)> }) }) });

export type ExpertCuratedOrderListActivationQueryVariables = {
  id: Scalars['ExpertCuratedOrderListActivationId']
};


export type ExpertCuratedOrderListActivationQuery = ({ __typename: 'Query' } & { expertCuratedOrderListActivation: ({ __typename: 'ExpertCuratedOrderListActivation' } & Pick<ExpertCuratedOrderListActivation, 'id'> & { active: Array<({ __typename: 'ExpertCuratedOrder' } & Pick<ExpertCuratedOrder, 'id'>)>, lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'type' | 'name' | 'slug' | 'singularDisplayName'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })> }) }) });

export type DealAddOnFragment = ({ __typename: 'DealAddOn' } & Pick<DealAddOn, 'title'> & { retailPrice: ({ __typename: 'Money' } & Pick<Money, 'amount'>) });

export type DealFragment = ({ __typename: 'Deal' } & Pick<Deal, 'id' | 'title' | 'discount'> & { price: ({ __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>), originalPrice: Maybe<({ __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>)>, images: Array<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)>, brand: Maybe<({ __typename: 'Brand' } & Pick<Brand, 'id' | 'displayName'>)>, freeAddOns: Array<({ __typename: 'DealAddOn' } & DealAddOnFragment)> });

export type ExpertCuratedOrderRichCardQueryVariables = {
  id: Scalars['ExpertCuratedOrderId']
};


export type ExpertCuratedOrderRichCardQuery = ({ __typename: 'Query' } & { expertCuratedOrder: ({ __typename: 'ExpertCuratedOrder' } & ExpertCuratedOrderFragment) });

export type ExpertCuratedItemActivationQueryVariables = {
  activationId: Scalars['ExpertCuratedItemActivationId']
};


export type ExpertCuratedItemActivationQuery = ({ __typename: 'Query' } & { expertCuratedItemActivation: ({ __typename: 'ExpertCuratedItemActivation' } & { activated: Array<({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'>)>, activatedBy: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName'>), lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { consumer: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'> & { messagingUser: ({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id'>), profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> }), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'name'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })>, conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) }) }) });

export type NewCurationQueryVariables = {
  leadId: Scalars['LeadId']
};


export type NewCurationQuery = ({ __typename: 'Query' } & { expertCuratedItemsForLead: ({ __typename: 'ExpertCuratedItemsForLeadPayload' } & { byCategories: ({ __typename: 'ExpertCuratedItemsByCategories' } & Pick<ExpertCuratedItemsByCategories, 'id'> & { categories: Array<({ __typename: 'ExpertCuratedItemsByCategory' } & Pick<ExpertCuratedItemsByCategory, 'id'> & { items: Array<({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'>)> })> }) }), lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'name'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })>, conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) }) });

export type SaveConsumerSellableReactionMutationVariables = {
  input: SaveConsumerSellableReactionInput
};


export type SaveConsumerSellableReactionMutation = ({ __typename: 'Mutation' } & { saveConsumerSellableReaction: ({ __typename: 'SaveConsumerSellableReactionPayload' } & Pick<SaveConsumerSellableReactionPayload, 'error'> & { consumerSellableReaction: Maybe<({ __typename: 'ConsumerSellableReaction' } & Pick<ConsumerSellableReaction, 'id' | 'additionalReason' | 'systemRecommended'> & { reasonsWithDisplayName: Array<({ __typename: 'ConsumerSellableReactionReasonWithDisplayName' } & Pick<ConsumerSellableReactionReasonWithDisplayName, 'reason' | 'displayName'>)>, ratingWithDisplayName: ({ __typename: 'ConsumerSellableReactionRatingWithDisplayName' } & Pick<ConsumerSellableReactionRatingWithDisplayName, 'rating' | 'displayName'>), sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'>), recommendedBy: Maybe<({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id'>)> })> }) });

export type StartSystemCuratedItemSurveyMutationVariables = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type StartSystemCuratedItemSurveyMutation = ({ __typename: 'Mutation' } & { startSystemCuratedItemSurvey: ({ __typename: 'StartSystemCuratedItemSurveyPayload' } & Pick<StartSystemCuratedItemSurveyPayload, 'error'> & { data: Maybe<({ __typename: 'SystemCuratedItemSurvey' } & Pick<SystemCuratedItemSurvey, 'id' | 'startedAt'>)> }) });

export type SystemCuratedItemSourceFragment = ({ __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource' | 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource' | 'TopRecommendationAndSimilarUserSystemCuratedItemSource' | 'TopRecommendedListSystemCuratedItemSource' } & Pick<SystemCuratedItemSource, 'type'> & (({ __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource' } & { expertCuratedItem: ({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'>) }) | ({ __typename: 'TopRecommendedListSystemCuratedItemSource' } & { recommendedListDefinition: ({ __typename: 'RecommendedListDefinition' } & Pick<RecommendedListDefinition, 'id'>) }) | ({ __typename: 'TopRecommendationAndSimilarUserSystemCuratedItemSource' } & { recentExpertCuratedItemFromSimilarUserSource: Maybe<({ __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource' } & Pick<RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource, 'type'> & { expertCuratedItem: ({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'>) })>, topRecommendedListSystemCuratedItemSource: Maybe<({ __typename: 'TopRecommendedListSystemCuratedItemSource' } & Pick<TopRecommendedListSystemCuratedItemSource, 'type'> & { recommendedListDefinition: ({ __typename: 'RecommendedListDefinition' } & Pick<RecommendedListDefinition, 'id'>) })> }) | ({ __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource' } & Pick<RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource, 'type'> & { expertCuratedItem: ({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'>) })));

export type SystemCuratedItemFragment = ({ __typename: 'SystemCuratedItem' } & Pick<SystemCuratedItem, 'id' | 'type'> & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> } & SellablePricingFragment), category: ({ __typename: 'Category' } & Pick<Category, 'id'>), systemCuratedItemSource: ({ __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource' | 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource' | 'TopRecommendationAndSimilarUserSystemCuratedItemSource' | 'TopRecommendedListSystemCuratedItemSource' } & SystemCuratedItemSourceFragment) });

export type SystemCuratedItemSurveyQueryVariables = {
  id: Scalars['SystemCuratedItemSurveyId']
};


export type SystemCuratedItemSurveyQuery = ({ __typename: 'Query' } & { systemCuratedItemSurvey: ({ __typename: 'SystemCuratedItemSurvey' } & Pick<SystemCuratedItemSurvey, 'id' | 'ended' | 'terminationReason'> & { systemCuratedItems: Array<({ __typename: 'SystemCuratedItem' } & SystemCuratedItemFragment)>, stats: Maybe<({ __typename: 'SystemCuratedItemSurveyStats' } & SystemCuratedItemSurveyStatsFragment)> }) });

export type SystemCuratedItemSurveyStatsFragment = ({ __typename: 'SystemCuratedItemSurveyStats' } & { ratingStats: Array<({ __typename: 'ConsumerSellableReactionRatingStats' } & Pick<ConsumerSellableReactionRatingStats, 'rating' | 'count'>)> });

export type TerminateSystemCuratedItemSurveyMutationVariables = {
  input: TerminateSystemCuratedItemSurveyInput
};


export type TerminateSystemCuratedItemSurveyMutation = ({ __typename: 'Mutation' } & { terminateSystemCuratedItemSurvey: ({ __typename: 'TerminateSystemCuratedItemSurveyPayload' } & Pick<TerminateSystemCuratedItemSurveyPayload, 'error'> & { data: Maybe<({ __typename: 'SystemCuratedItemSurvey' } & Pick<SystemCuratedItemSurvey, 'id' | 'ended' | 'terminationReason'> & { systemCuratedItems: Array<({ __typename: 'SystemCuratedItem' } & SystemCuratedItemFragment)>, stats: Maybe<({ __typename: 'SystemCuratedItemSurveyStats' } & SystemCuratedItemSurveyStatsFragment)> })> }) });

export type ReferralExpertQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type ReferralExpertQuery = ({ __typename: 'Query' } & { findExpert: Maybe<({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & { categories: Array<({ __typename: 'Category' } & Pick<Category, 'id' | 'singularDisplayName'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })> })> })> });

export type SimpleCuratedOrderRichCardQueryVariables = {
  id: Scalars['SimpleCuratedOrderId']
};


export type SimpleCuratedOrderRichCardQuery = ({ __typename: 'Query' } & { simpleCuratedOrder: ({ __typename: 'SimpleCuratedOrder' } & Pick<SimpleCuratedOrder, 'id'> & { curatedFor: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName'>), curator: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName'>), lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })> }), order: ({ __typename: 'Order' } & Pick<Order, 'id' | 'state'> & { totalCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) }) }) });

export type AuthenticateByExternalOAuthTokenMutationVariables = {
  input: AuthenticateByExternalOAuthTokenInput
};


export type AuthenticateByExternalOAuthTokenMutation = ({ __typename: 'Mutation' } & { authenticateByExternalOAuthToken: ({ __typename: 'AuthenticateByExternalOAuthTokenPayload' } & Pick<AuthenticateByExternalOAuthTokenPayload, 'result' | 'message'> & { user: Maybe<({ __typename: 'User' } & AuthenticatedUserFragment)> }) });

export type RegisterCustomerMutationVariables = {
  input: RegisterCustomerInput
};


export type RegisterCustomerMutation = ({ __typename: 'Mutation' } & { registerCustomer: ({ __typename: 'RegisterCustomerPayload' } & Pick<RegisterCustomerPayload, 'errors'> & { user: Maybe<({ __typename: 'User' } & AuthenticatedUserFragment)> }) });

export type FlightPlanQuestionFragment = ({ __typename: 'FlightPlan' } & Pick<FlightPlan, 'id'> & { legs: Array<({ __typename: 'FlightPlanLeg' } & Pick<FlightPlanLeg, 'arriveAt' | 'departOn'> & { arrivalAirport: Maybe<({ __typename: 'Airport' } & Pick<Airport, 'id' | 'name'>)>, departureAirport: Maybe<({ __typename: 'Airport' } & Pick<Airport, 'id' | 'name'>)> })> });

export type FlightPlanQuestionQueryVariables = {
  id: Scalars['FlightPlanId']
};


export type FlightPlanQuestionQuery = ({ __typename: 'Query' } & { flightPlan: ({ __typename: 'FlightPlan' } & FlightPlanQuestionFragment) });

export type ConversationWithLeadFragment = ({ __typename: 'Conversation' } & Pick<Conversation, 'id'> & { lead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId'>) })> });

export type DatePathFlowQuestionFragment = ({ __typename: 'DatePathFlowQuestion' } & { dateUserInput: ({ __typename: 'SubmitDatePathFlowQuestionInputTypeCopy' } & Pick<SubmitDatePathFlowQuestionInputTypeCopy, 'value'>) });

export type DateRangePathFlowQuestionFragment = ({ __typename: 'DateRangePathFlowQuestion' } & Pick<DateRangePathFlowQuestion, 'endRequired' | 'startRequired'> & { dateRangeUserInput: ({ __typename: 'SubmitDateRangePathFlowQuestionInputTypeCopy' } & Pick<SubmitDateRangePathFlowQuestionInputTypeCopy, 'startValue' | 'endValue'>) });

export type ExpertProfileDetailFragment = ({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline' | 'background' | 'quotes' | 'socialMediaUrls'> & { businessUser: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'>), profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> });

export type IdPathFlowQuestionFragment = ({ __typename: 'IdPathFlowQuestion' } & { idType: IdPathFlowQuestion['type'] } & { idUserInput: ({ __typename: 'SubmitIdPathFlowQuestionInputTypeCopy' } & Pick<SubmitIdPathFlowQuestionInputTypeCopy, 'value'>) });

export type ImageViewModelFragment = ({ __typename: 'PathImageViewModel' } & Pick<PathImageViewModel, 'imageUrl' | 'imagePath'>);

export type InputTextPathFlowQuestionFragment = ({ __typename: 'InputTextPathFlowQuestion' } & { countryCodeAttribute: Maybe<({ __typename: 'Attribute' } & { values: Array<({ __typename: 'AttributeValueEnumeration' } & Pick<AttributeValueEnumeration, 'enumerationValue' | 'enumerationValueDescription'>)> })>, inputTextUserInput: ({ __typename: 'SubmitInputTextPathFlowQuestionInputTypeCopy' } & Pick<SubmitInputTextPathFlowQuestionInputTypeCopy, 'value'>) } & InputTextPathFlowQuestionMixinFragment);

export type InputTextPathFlowQuestionMixinFragment = ({ __typename: 'EmbeddedInputTextPathFlowQuestion' | 'InputTextPathFlowQuestion' } & Pick<InputTextPathFlowQuestionMixin, 'required' | 'fieldType' | 'placeholder'> & { inputTextValidations: Array<({ __typename: 'InputTextPathFlowQuestionLengthValidation' | 'InputTextPathFlowQuestionNoArgValidation' | 'InputTextPathFlowQuestionRegexValidation' } & InputTextPathFlowQuestionValidationFragment)>, questionSubText: Maybe<TextViewModelFragment> });

export type InputTextPathFlowQuestionValidationFragment = ({ __typename: 'InputTextPathFlowQuestionLengthValidation' | 'InputTextPathFlowQuestionNoArgValidation' | 'InputTextPathFlowQuestionRegexValidation' } & Pick<InputTextPathFlowQuestionValidation, 'type'> & (({ __typename: 'InputTextPathFlowQuestionLengthValidation' } & Pick<InputTextPathFlowQuestionLengthValidation, 'minSize' | 'maxSize'>) | ({ __typename: 'InputTextPathFlowQuestionRegexValidation' } & Pick<InputTextPathFlowQuestionRegexValidation, 'regex' | 'errorMessage'>)));

export type InterstitialPageMetadataFragment = ({ __typename: 'InterstitialPathFlowPageMetadata' } & Pick<InterstitialPathFlowPageMetadata, 'interstitialType'> & { title: Maybe<TextViewModelFragment>, body: Maybe<TextViewModelFragment> });

export type ListPathFlowQuestionFragment = ({ __typename: 'ListPathFlowQuestion' } & Pick<ListPathFlowQuestion, 'renderStyle'> & { listType: ListPathFlowQuestion['type'] } & { choices: Array<({ __typename: 'ListPathFlowQuestionChoice' } & Pick<ListPathFlowQuestionChoice, 'value'> & { text: Maybe<TextViewModelFragment>, subText: Maybe<TextViewModelFragment>, primaryImage: Maybe<ImageViewModelFragment>, iconImage: Maybe<ImageViewModelFragment> })>, other: Maybe<({ __typename: 'EmbeddedInputTextPathFlowQuestion' } & InputTextPathFlowQuestionMixinFragment)>, listUserInput: ({ __typename: 'SubmitListPathFlowQuestionInputTypeCopy' } & Pick<SubmitListPathFlowQuestionInputTypeCopy, 'value' | 'other'>) });

export type NumericPathFlowQuestionFragment = ({ __typename: 'NumericPathFlowQuestion' } & Pick<NumericPathFlowQuestion, 'unit' | 'unitLabel' | 'placeholder' | 'displayType'> & { numericUserInput: ({ __typename: 'SubmitNumericPathFlowQuestionInputTypeCopy' } & Pick<SubmitNumericPathFlowQuestionInputTypeCopy, 'value' | 'decimalValue'>) });

export type OAuthEmailPathFlowQuestionFragment = ({ __typename: 'OAuthEmailPathFlowQuestion' } & { oAuthEmailUserInput: ({ __typename: 'SubmitOAuthEmailPathFlowQuestionInputTypeCopy' } & Pick<SubmitOAuthEmailPathFlowQuestionInputTypeCopy, 'firstName' | 'lastName' | 'email' | 'googleIdToken' | 'facebookUserAccessToken' | 'skipFirstName' | 'skipLastName'>) });

export type PathFlowPagesConnectionFragment = ({ __typename: 'PathFlowPagesConnection' } & { edges: Array<({ __typename: 'PathFlowPagesEdge' } & Pick<PathFlowPagesEdge, 'cursor'> & { node: ({ __typename: 'PathFlowPage' } & PathFlowPageFragment) })> });

export type PathFlowFragment = ({ __typename: 'PathFlow' } & Pick<PathFlow, 'id' | 'completed' | 'slug'> & { title: Maybe<TextViewModelFragment>, onComplete: Maybe<(({ __typename: 'PathFlowOnCompleteBroadcast' } & Pick<PathFlowOnCompleteBroadcast, 'location'> & { conversation: ({ __typename: 'Conversation' } & ConversationWithLeadFragment) }) | ({ __typename: 'PathFlowOnCompleteLead' } & Pick<PathFlowOnCompleteLead, 'location'> & { conversation: ({ __typename: 'Conversation' } & ConversationWithLeadFragment) }) | ({ __typename: 'PathFlowOnCompleteNewPath' } & { flow: ({ __typename: 'PathFlow' } & Pick<PathFlow, 'id' | 'slug'> & { pagesConnection: ({ __typename: 'PathFlowPagesConnection' } & PathFlowPagesConnectionFragment) }) }) | ({ __typename: 'PathFlowOnCompleteExpertReview' } & Pick<PathFlowOnCompleteExpertReview, 'location'> & { review: ({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id'>) }) | ({ __typename: 'PathFlowOnCompleteRedirectOnly' } & Pick<PathFlowOnCompleteRedirectOnly, 'location'>) | ({ __typename: 'PathFlowOnCompleteRedirectWithUpsert' } & Pick<PathFlowOnCompleteRedirectWithUpsert, 'location'>) | ({ __typename: 'PathFlowOnCompleteExpertApplication' } & Pick<PathFlowOnCompleteExpertApplication, 'location'> & { application: ({ __typename: 'ExpertApplication' } & Pick<ExpertApplication, 'id'>) }))>, theme: ({ __typename: 'PathFlowTheme' } & Pick<PathFlowTheme, 'type'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'> & { department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> })>, pagesConnection: ({ __typename: 'PathFlowPagesConnection' } & PathFlowPagesConnectionFragment) });

export type PathFlowPageFragment = ({ __typename: 'PathFlowPage' } & Pick<PathFlowPage, 'id' | 'internalName' | 'slug' | 'completed' | 'completionPercentage' | 'requiresServerSyncAfterSubmit'> & { metadata: Array<({ __typename: 'BasicPathFlowPageMetadata' | 'ContactPrivacyMetadata' | 'ContactTCPAComplianceMetadata' | 'FacebookMessengerPathFlowPageMetadata' | 'FacebookTCPAComplianceMetadata' | 'InterstitialPathFlowPageMetadata' | 'PhoneExplanationModalMetadata' | 'RatingContactPageMetadata' | 'TermsAndConditionsPathFlowPageMetadata' | 'TermsPrivacyMedicalPathFlowPageMetadata' } & PathFlowPageMetadataFragment)>, title: Maybe<TextViewModelFragment>, notificationTexts: Array<TextViewModelFragment>, questions: Array<({ __typename: 'DatePathFlowQuestion' | 'DateRangePathFlowQuestion' | 'IdPathFlowQuestion' | 'InputTextPathFlowQuestion' | 'ListPathFlowQuestion' | 'NumericPathFlowQuestion' | 'OAuthEmailPathFlowQuestion' | 'UserContactPathFlowQuestion' } & PathFlowQuestionFragment)>, submitButtonText: Maybe<TextViewModelFragment>, skipButtonText: Maybe<TextViewModelFragment> });

export type RatingContactPageMetadataFragment = ({ __typename: 'RatingContactPageMetadata' } & Pick<RatingContactPageMetadata, 'type'>);

export type TermsAndConditionsPageMetadataFragment = ({ __typename: 'TermsAndConditionsPathFlowPageMetadata' } & Pick<TermsAndConditionsPathFlowPageMetadata, 'type'>);

export type PathFlowPageMetadataFragment = ({ __typename: 'BasicPathFlowPageMetadata' | 'ContactPrivacyMetadata' | 'ContactTCPAComplianceMetadata' | 'FacebookMessengerPathFlowPageMetadata' | 'FacebookTCPAComplianceMetadata' | 'InterstitialPathFlowPageMetadata' | 'PhoneExplanationModalMetadata' | 'RatingContactPageMetadata' | 'TermsAndConditionsPathFlowPageMetadata' | 'TermsPrivacyMedicalPathFlowPageMetadata' } & Pick<PathFlowPageMetadata, 'type'> & (InterstitialPageMetadataFragment | TermsAndConditionsPageMetadataFragment | RatingContactPageMetadataFragment));

export type PathFlowQuestionFragment = ({ __typename: 'DatePathFlowQuestion' | 'DateRangePathFlowQuestion' | 'IdPathFlowQuestion' | 'InputTextPathFlowQuestion' | 'ListPathFlowQuestion' | 'NumericPathFlowQuestion' | 'OAuthEmailPathFlowQuestion' | 'UserContactPathFlowQuestion' } & (SharedPathFlowQuestionFragment & (({ __typename: 'ListPathFlowQuestion' } & ListPathFlowQuestionFragment) | ({ __typename: 'InputTextPathFlowQuestion' } & InputTextPathFlowQuestionFragment) | ({ __typename: 'NumericPathFlowQuestion' } & NumericPathFlowQuestionFragment) | ({ __typename: 'OAuthEmailPathFlowQuestion' } & OAuthEmailPathFlowQuestionFragment) | ({ __typename: 'IdPathFlowQuestion' } & IdPathFlowQuestionFragment) | ({ __typename: 'DateRangePathFlowQuestion' } & DateRangePathFlowQuestionFragment) | ({ __typename: 'DatePathFlowQuestion' } & DatePathFlowQuestionFragment))));

export type PathValidationErrorFragment = ({ __typename: 'PathValidationError' } & Pick<PathValidationError, 'pageName' | 'questionName' | 'tags'> & { message: Maybe<TextViewModelFragment> });

export type SharedPathFlowQuestionFragment = ({ __typename: 'DatePathFlowQuestion' | 'DateRangePathFlowQuestion' | 'IdPathFlowQuestion' | 'InputTextPathFlowQuestion' | 'ListPathFlowQuestion' | 'NumericPathFlowQuestion' | 'OAuthEmailPathFlowQuestion' | 'UserContactPathFlowQuestion' } & Pick<PathFlowQuestion, 'internalName' | 'required'> & { questionText: Maybe<TextViewModelFragment>, questionSubText: Maybe<TextViewModelFragment>, inputLabel: Maybe<TextViewModelFragment>, inputIconImage: Maybe<ImageViewModelFragment> });

export type TextViewModelFragment = ({ __typename: 'AttributedHtmlTextViewModel' } & Pick<AttributedHtmlTextViewModel, 'text'> & { attributes: Maybe<Array<({ __typename: 'AttributedHtmlTextViewModelAttribute' } & Pick<AttributedHtmlTextViewModelAttribute, 'key' | 'type'> & { image: Maybe<ImageViewModelFragment> })>> });

export type RoryReviewFragment = ({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id' | 'comments' | 'reviewedAt' | 'rating' | 'consumerName' | 'consumerLocation'>);

export type RoryReviewsQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type RoryReviewsQuery = ({ __typename: 'Query' } & { department: ({ __typename: 'Department' } & Pick<Department, 'id'> & { reviewSummary: ({ __typename: 'ReviewSummary' } & Pick<ReviewSummary, 'averageRating' | 'totalReviews'>), consumerExpertReviewConnection: ({ __typename: 'ConsumerExpertReviewConnection' } & { edges: Array<({ __typename: 'ConsumerExpertReviewEdge' } & { node: ({ __typename: 'ConsumerExpertReview' } & RoryReviewFragment) })> }) }) });

export type CreatePathFlowMutationVariables = {
  input: CreatePathFlowInput
};


export type CreatePathFlowMutation = ({ __typename: 'Mutation' } & { createPathFlow: ({ __typename: 'CreatePathFlowPayload' } & Pick<CreatePathFlowPayload, 'newUserRegistered'> & { flow: Maybe<({ __typename: 'PathFlow' } & PathFlowFragment)>, errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type GenerateCollectPhoneNumberTextInPathMutationVariables = {
  input: GenerateCollectPhoneNumberTextInPathInput
};


export type GenerateCollectPhoneNumberTextInPathMutation = ({ __typename: 'Mutation' } & { generateCollectPhoneNumberTextInPath: ({ __typename: 'GenerateCollectPhoneNumberTextInPathPayload' } & Pick<GenerateCollectPhoneNumberTextInPathPayload, 'toNumber' | 'body'>) });

export type ReenterPathFlowPageMutationVariables = {
  input: ReenterPathFlowPageInput
};


export type ReenterPathFlowPageMutation = ({ __typename: 'Mutation' } & { reenterPathFlowPage: ({ __typename: 'ReenterPathFlowPagePayload' } & { flow: Maybe<({ __typename: 'PathFlow' } & PathFlowFragment)> }) });

export type SubmitDatePathFlowQuestionMutationVariables = {
  input: SubmitDatePathFlowQuestionInput
};


export type SubmitDatePathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitDatePathFlowQuestion: ({ __typename: 'SubmitDatePathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitDateRangePathFlowQuestionMutationVariables = {
  input: SubmitDateRangePathFlowQuestionInput
};


export type SubmitDateRangePathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitDateRangePathFlowQuestion: ({ __typename: 'SubmitDateRangePathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitFacebookPathFlowQuestionMutationVariables = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type SubmitFacebookPathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitInputTextPathFlowQuestion: ({ __typename: 'SubmitInputTextPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitIdPathFlowQuestionMutationVariables = {
  input: SubmitIdPathFlowQuestionInput
};


export type SubmitIdPathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitIdPathFlowQuestion: ({ __typename: 'SubmitIdPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitInputTextPathFlowQuestionMutationVariables = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type SubmitInputTextPathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitInputTextPathFlowQuestion: ({ __typename: 'SubmitInputTextPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitListPathFlowQuestionMutationVariables = {
  input: SubmitListPathFlowQuestionInput
};


export type SubmitListPathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitListPathFlowQuestion: ({ __typename: 'SubmitListPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitNumericPathFlowQuestionMutationVariables = {
  input: SubmitNumericPathFlowQuestionInput
};


export type SubmitNumericPathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitNumericPathFlowQuestion: ({ __typename: 'SubmitNumericPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitOAuthEmailPathFlowQuestionMutationVariables = {
  input: SubmitOAuthEmailPathFlowQuestionInput
};


export type SubmitOAuthEmailPathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitOAuthEmailPathFlowQuestion: ({ __typename: 'SubmitOAuthEmailPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitPathFlowPageMutationVariables = {
  input: SubmitPathFlowPageInput
};


export type SubmitPathFlowPageMutation = ({ __typename: 'Mutation' } & { submitPathFlowPage: ({ __typename: 'SubmitPathFlowPagePayload' } & Pick<SubmitPathFlowPagePayload, 'newUserRegistered'> & { flow: Maybe<({ __typename: 'PathFlow' } & PathFlowFragment)>, errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitPushNotifcationFcmTokenMutationVariables = {
  input: SubmitInputTextPathFlowQuestionInput
};


export type SubmitPushNotifcationFcmTokenMutation = ({ __typename: 'Mutation' } & { submitInputTextPathFlowQuestion: ({ __typename: 'SubmitInputTextPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitPushNotificationAuthorizedStatusMutationVariables = {
  input: SubmitListPathFlowQuestionInput
};


export type SubmitPushNotificationAuthorizedStatusMutation = ({ __typename: 'Mutation' } & { submitListPathFlowQuestion: ({ __typename: 'SubmitListPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type SubmitUserContactPathFlowQuestionMutationVariables = {
  input: SubmitUserContactPathFlowQuestionInput
};


export type SubmitUserContactPathFlowQuestionMutation = ({ __typename: 'Mutation' } & { submitUserContactPathFlowQuestion: ({ __typename: 'SubmitUserContactPathFlowQuestionPayload' } & { errors: Maybe<Array<({ __typename: 'PathValidationError' } & PathValidationErrorFragment)>> }) });

export type UploadGearImageMutationVariables = {
  input: UploadMediaInput
};


export type UploadGearImageMutation = ({ __typename: 'Mutation' } & { uploadMedia: ({ __typename: 'UploadMediaPayload' } & { mediaFile: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> }) });

export type PathFlowQueryVariables = {
  id: Scalars['PathFlowId']
};


export type PathFlowQuery = ({ __typename: 'Query' } & { pathFlow: ({ __typename: 'PathFlowPayload' } & { flow: Maybe<({ __typename: 'PathFlow' } & PathFlowFragment)> }) });

export type PathFlowPageQueryVariables = {
  pathFlowId: Scalars['PathFlowId'],
  pathFlowPageSlug: Scalars['String']
};


export type PathFlowPageQuery = ({ __typename: 'Query' } & { pathFlowPage: ({ __typename: 'PathFlowPagePayload' } & { page: Maybe<({ __typename: 'PathFlowPage' } & PathFlowPageFragment)> }) });

export type PathExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'background' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, highlights: Array<({ __typename: 'ProfileHighlight' } & Pick<ProfileHighlight, 'value' | 'secondaryValue'> & { type: ({ __typename: 'ProfileHighlightType' } & Pick<ProfileHighlightType, 'id' | 'displayName'>) })> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & ExpertStatsFragment)> });

export type RecommendExpertsForPathFlowQueryVariables = {
  pathFlowId: Scalars['PathFlowId']
};


export type RecommendExpertsForPathFlowQuery = ({ __typename: 'Query' } & { recommendExpertsForPathFlow: Array<({ __typename: 'RecommendedExpert' } & { expert: ({ __typename: 'BusinessUser' } & PathExpertFragment) })> });

export type DepartmentCategoryAssetsQueryVariables = {
  id: Scalars['DepartmentId']
};


export type DepartmentCategoryAssetsQuery = ({ __typename: 'Query' } & { department: ({ __typename: 'Department' } & Pick<Department, 'id'> & { topLevelCategories: Array<({ __typename: 'Category' } & Pick<Category, 'id'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })> }) });

export type PhoneCollectionExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName' | 'presence'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> });

export type PhoneCollectionBusinessUserQueryVariables = {
  id: Scalars['BusinessUserId']
};


export type PhoneCollectionBusinessUserQuery = ({ __typename: 'Query' } & { businessUser: ({ __typename: 'BusinessUser' } & PhoneCollectionExpertFragment) });

export type UpdateUserPhoneNumberMutationVariables = {
  input: UpdateUserProfileInput
};


export type UpdateUserPhoneNumberMutation = ({ __typename: 'Mutation' } & { updateUserProfile: ({ __typename: 'UpdateUserProfilePayload' } & Pick<UpdateUserProfilePayload, 'errors'> & { user: ({ __typename: 'User' } & Pick<User, 'id'> & { contacts: Array<({ __typename: 'Contact' } & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>)> }) }) });

export type IssueVerificationCodeMutationVariables = {
  input: InitiateVerifyHandleInput
};


export type IssueVerificationCodeMutation = ({ __typename: 'Mutation' } & { initiateVerifyHandle: ({ __typename: 'InitiateVerifyHandlePayload' } & Pick<InitiateVerifyHandlePayload, 'success'>) });

export type UpdateUserPhoneMutationVariables = {
  input: UpdateUserProfileInput
};


export type UpdateUserPhoneMutation = ({ __typename: 'Mutation' } & { updateUserProfile: ({ __typename: 'UpdateUserProfilePayload' } & Pick<UpdateUserProfilePayload, 'errors'> & { user: ({ __typename: 'User' } & Pick<User, 'id'> & { contacts: Array<({ __typename: 'Contact' } & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>)> }) }) });

export type ConfirmVerificationCodeMutationVariables = {
  input: VerifyHandleChallengeInput
};


export type ConfirmVerificationCodeMutation = ({ __typename: 'Mutation' } & { verifyHandleChallenge: ({ __typename: 'VerifyHandleChallengePayload' } & Pick<VerifyHandleChallengePayload, 'message' | 'success'>) });

export type RecommendedListFragment = ({ __typename: 'RecommendedList' } & Pick<RecommendedList, 'displayName' | 'subTitle'> & { recommendedListDefinition: Maybe<({ __typename: 'RecommendedListDefinition' } & Pick<RecommendedListDefinition, 'id' | 'rank'>)>, sellables: Array<({ __typename: 'Sellable' } & SellableCardFragment)> });

export type RecommendedListByTypeQueryVariables = {
  categorySlug: Scalars['String'],
  types?: Maybe<Array<RecommendedListType>>
};


export type RecommendedListByTypeQuery = ({ __typename: 'Query' } & { recommendedListsForCategory: ({ __typename: 'RecommendedListConnection' } & { pageInfo: ({ __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>), edges: Array<({ __typename: 'RecommendedListEdge' } & Pick<RecommendedListEdge, 'cursor'> & { node: ({ __typename: 'RecommendedList' } & RecommendedListFragment) })> }) });

export type BusinessUserToRateFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> });

export type StartExpertRatingPathMutationVariables = {
  input: StartExpertRatingInput
};


export type StartExpertRatingPathMutation = ({ __typename: 'Mutation' } & { startExpertRatingPath: ({ __typename: 'StartExpertRatingPayload' } & { expert: ({ __typename: 'BusinessUser' } & BusinessUserToRateFragment), flow: Maybe<({ __typename: 'PathFlow' } & Pick<PathFlow, 'id' | 'slug'> & { pagesConnection: ({ __typename: 'PathFlowPagesConnection' } & { edges: Array<({ __typename: 'PathFlowPagesEdge' } & { node: ({ __typename: 'PathFlowPage' } & Pick<PathFlowPage, 'slug'>) })> }) })>, errors: Maybe<Array<({ __typename: 'PathValidationError' } & Pick<PathValidationError, 'pageName' | 'questionName'>)>> }) });

export type UserExpertReviewsQueryVariables = {
  expertId?: Maybe<Scalars['BusinessUserId']>
};


export type UserExpertReviewsQuery = ({ __typename: 'Query' } & { me: Maybe<({ __typename: 'Myself' } & Pick<Myself, 'id'> & { user: ({ __typename: 'User' } & Pick<User, 'id'> & { expertReviews: Array<({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id'>) })> }) })> });

export type DepartmentReviewsQueryVariables = {
  id: Scalars['DepartmentId']
};


export type DepartmentReviewsQuery = ({ __typename: 'Query' } & { department: ({ __typename: 'Department' } & Pick<Department, 'id'> & { reviewSummary: ({ __typename: 'ReviewSummary' } & Pick<ReviewSummary, 'averageRating' | 'totalReviews'>) }) });

export type SaveableSellableFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)>, parent: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)> })> });

export type SaveableSellableResponseFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)> } & TrackableSellableFragment);

export type SaveSellableMutationVariables = {
  input: SaveSavedSellableInput
};


export type SaveSellableMutation = ({ __typename: 'Mutation' } & { saveSavedSellable: ({ __typename: 'SaveSavedSellablePayload' } & { savedSellable: ({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'> & { sellable: ({ __typename: 'Sellable' } & SellableCardFragment) }) }) });

export type UnsaveSellableMutationVariables = {
  input: UnsaveSavedSellableInput
};


export type UnsaveSellableMutation = ({ __typename: 'Mutation' } & { unsaveSavedSellable: ({ __typename: 'UnsaveSavedSellablePayload' } & { savedSellable: ({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'> & { sellable: ({ __typename: 'Sellable' } & SellableCardFragment) }) }) });

export type SellableCardFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'areAllVariantsOutOfStock'> & { metrics: Maybe<({ __typename: 'SellableMetrics' } & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days'>)>, department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'type' | 'slug'>)>, parent: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { metrics: Maybe<({ __typename: 'SellableMetrics' } & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days'>)>, savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)> })>, savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)>, variationMatrix: Maybe<({ __typename: 'VariationMatrix' } & { priceRange: Maybe<({ __typename: 'VariationMatrixPriceRange' } & { max: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), min: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) })>, defaultVariant: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> }) })>, charterBathrooms: Maybe<({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>)> })>, charterCabins: Maybe<({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>)> })>, charterCapacity: Maybe<({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>)> })>, charterLocation: Maybe<({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'name' | 'displayHtml' | 'displayHtmlValues'>)> })>, consumerSellableReactions: Maybe<({ __typename: 'ConsumerSellableReactionConnection' } & { edges: Array<({ __typename: 'ConsumerSellableReactionEdge' } & { node: ({ __typename: 'ConsumerSellableReaction' } & Pick<ConsumerSellableReaction, 'id'> & { ratingWithDisplayName: ({ __typename: 'ConsumerSellableReactionRatingWithDisplayName' } & Pick<ConsumerSellableReactionRatingWithDisplayName, 'displayName' | 'rating'>) }) })> })> } & TrackableSellableFragment);

export type ConsumerReactionsForSellableQueryVariables = {
  id: Scalars['SellableId']
};


export type ConsumerReactionsForSellableQuery = ({ __typename: 'Query' } & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { consumerSellableReactions: Maybe<({ __typename: 'ConsumerSellableReactionConnection' } & { edges: Array<({ __typename: 'ConsumerSellableReactionEdge' } & { node: ({ __typename: 'ConsumerSellableReaction' } & Pick<ConsumerSellableReaction, 'id'> & { ratingWithDisplayName: ({ __typename: 'ConsumerSellableReactionRatingWithDisplayName' } & Pick<ConsumerSellableReactionRatingWithDisplayName, 'displayName' | 'rating'>) }) })> })> }) });

export type SaveRecommendedListRatingMutationVariables = {
  input: SaveConsumerSellableReactionInput
};


export type SaveRecommendedListRatingMutation = ({ __typename: 'Mutation' } & { saveConsumerSellableReaction: ({ __typename: 'SaveConsumerSellableReactionPayload' } & { consumerSellableReaction: Maybe<({ __typename: 'ConsumerSellableReaction' } & Pick<ConsumerSellableReaction, 'id'> & { sellable: ({ __typename: 'Sellable' } & SellableCardFragment) })> }) });

export type CreateShareLinkMutationVariables = {
  input: ShortenUrlInput
};


export type CreateShareLinkMutation = ({ __typename: 'Mutation' } & { shortenUrl: Maybe<({ __typename: 'ShortenUrlPayload' } & Pick<ShortenUrlPayload, 'url'>)> });

export type SendExpertReferralMutationVariables = {
  input: SendExpertReferralInput
};


export type SendExpertReferralMutation = ({ __typename: 'Mutation' } & { sendExpertReferral: ({ __typename: 'SendExpertReferralPayload' } & Pick<SendExpertReferralPayload, 'errors'>) });

export type BusinessUserToShareQueryVariables = {
  id: Scalars['BusinessUserId']
};


export type BusinessUserToShareQuery = ({ __typename: 'Query' } & { businessUser: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & { categories: Array<({ __typename: 'Category' } & Pick<Category, 'id' | 'singularDisplayName'>)> })> }) });

export type DismissOrderMessageMutationVariables = {};


export type DismissOrderMessageMutation = ({ __typename: 'Mutation' } & { dismissOrderMessages: ({ __typename: 'DismissOrderMessagesPayload' } & { order: ({ __typename: 'Order' } & ShoppingCartOrderFragment) }) });

export type RemoveItemFromOrderMutationVariables = {
  input: RemoveItemsFromOrderInput
};


export type RemoveItemFromOrderMutation = ({ __typename: 'Mutation' } & { removeItemsFromOrder: ({ __typename: 'RemoveItemsFromOrderPayload' } & { order: ({ __typename: 'Order' } & ShoppingCartOrderFragment) }) });

export type SimilarProductsQueryVariables = {
  sellableId: Scalars['SellableId']
};


export type SimilarProductsQuery = ({ __typename: 'Query' } & { similarSellables: ({ __typename: 'SimilarSellablePayload' } & { sellables: Maybe<Array<({ __typename: 'Sellable' } & SellableCardFragment)>> }) });

export type StandaloneRegisterMutationVariables = {
  input: RegisterCustomerInput
};


export type StandaloneRegisterMutation = ({ __typename: 'Mutation' } & { registerCustomer: ({ __typename: 'RegisterCustomerPayload' } & Pick<RegisterCustomerPayload, 'errors' | 'errorCodes'> & { user: Maybe<({ __typename: 'User' } & AuthenticatedUserFragment)> }) });

export type UploadMediaMutationVariables = {
  input: UploadMediaInput
};


export type UploadMediaMutation = ({ __typename: 'Mutation' } & { uploadMedia: ({ __typename: 'UploadMediaPayload' } & { mediaFile: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> }) });

export type UpdateProfileDataMutationVariables = {
  input: UpdateUserProfileInput
};


export type UpdateProfileDataMutation = ({ __typename: 'Mutation' } & { updateUserProfile: ({ __typename: 'UpdateUserProfilePayload' } & Pick<UpdateUserProfilePayload, 'errors'>) });

export type VariationMatrixQueryVariables = {
  id: Scalars['SellableId']
};


export type VariationMatrixQuery = ({ __typename: 'Query' } & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { variationMatrix: Maybe<({ __typename: 'VariationMatrix' } & VariationMatrixFragment)> }) });

export type BusinessUserChatWidgetQueryVariables = {
  id: Scalars['BusinessUserId']
};


export type BusinessUserChatWidgetQuery = ({ __typename: 'Query' } & { businessUser: ({ __typename: 'BusinessUser' } & { existingLeadForConsumer: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) })> } & ChatWidgetExpertFragment) });

export type ShoppingCartQueryVariables = {
  id: Scalars['OrderId']
};


export type ShoppingCartQuery = ({ __typename: 'Query' } & { order: ({ __typename: 'Order' } & ShoppingCartOrderFragment) });

export type ShoppingCartSubscriptionSubscriptionVariables = {
  userId?: Maybe<Scalars['UserId']>
};


export type ShoppingCartSubscriptionSubscription = ({ __typename: 'Subscription' } & { userCartLineItemsChanged: ({ __typename: 'Order' } & ShoppingCartOrderFragment) });

export type SyncShoppingCartMutationVariables = {};


export type SyncShoppingCartMutation = ({ __typename: 'Mutation' } & { syncOrder: ({ __typename: 'SyncOrderPayload' } & { order: ({ __typename: 'Order' } & ShoppingCartOrderFragment) }) });

export type RecommendExpert2QueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type RecommendExpert2Query = ({ __typename: 'Query' } & { recommendExpert2: ({ __typename: 'RecommendExpertPayload' } & { expert: Maybe<({ __typename: 'BusinessUser' } & { existingLeadForConsumer: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) })> } & ChatWidgetExpertFragment)> }) });

export type DeclineVideoChatFromInvitationMutationVariables = {
  input: DeclineVideoChatInput
};


export type DeclineVideoChatFromInvitationMutation = ({ __typename: 'Mutation' } & { declineVideoChat: ({ __typename: 'DeclineVideoChatPayload' } & Pick<DeclineVideoChatPayload, 'success'>) });

export type GetMessagingUsersQueryVariables = {
  ids: Array<Scalars['AnyId']>
};


export type GetMessagingUsersQuery = ({ __typename: 'Query' } & { messagingUsers: Array<({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id' | 'displayName' | 'type'> & { avatar: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)>, profile: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId'> & { expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'averageRating'>)> }) })> });

export type JoinVideoChatMutationVariables = {
  input: JoinVideoChatInput
};


export type JoinVideoChatMutation = ({ __typename: 'Mutation' } & { joinVideoChat: ({ __typename: 'JoinVideoChatPayload' } & Pick<JoinVideoChatPayload, 'token'>) });

export type PersistMediaMutationVariables = {
  input: PersistMediaInput
};


export type PersistMediaMutation = ({ __typename: 'Mutation' } & { persistMedia: ({ __typename: 'PersistMediaPayload' } & { mediaFile: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> }) });

export type UploadMediaForChatMutationVariables = {
  input: UploadMediaInput
};


export type UploadMediaForChatMutation = ({ __typename: 'Mutation' } & { uploadMedia: ({ __typename: 'UploadMediaPayload' } & { mediaFile: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> }) });

export type ChatWidgetExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { messagingUser: ({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id'>), expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'acceptingNewRequests' | 'placeholderExpert'>)>, expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, highlights: Array<({ __typename: 'ProfileHighlight' } & Pick<ProfileHighlight, 'secondaryValue' | 'value'> & { type: ({ __typename: 'ProfileHighlightType' } & Pick<ProfileHighlightType, 'id' | 'icon'>) })> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'totalMessages' | 'totalReviews'>)> });

export type ContentfulImageDataFragment = ({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'mimeType' | 'title' | 'imageUrl'>);

export type RawContentTypesFragment = (({ __typename: 'ContentBooleanValue' } & Pick<ContentBooleanValue, 'booleanValue'>) | ({ __typename: 'ContentStringValue' } & Pick<ContentStringValue, 'stringValue'>) | ({ __typename: 'ContentIntValue' } & Pick<ContentIntValue, 'intValue'>) | ({ __typename: 'ContentFloatValue' } & Pick<ContentFloatValue, 'floatValue'>) | ({ __typename: 'ContentAsset' } & ContentfulImageDataFragment));

export type ContentTypesFragment = (RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<RawContentTypesFragment> }) | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: RawContentTypesFragment })> }))> })) })> })) })> }))> })) })> }))> }) | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<RawContentTypesFragment> }) | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: RawContentTypesFragment })> })) })> }))> })) })> }))> })) })> })) })> }) | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<RawContentTypesFragment> })) })> }))> })) })> }))> }) | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<(RawContentTypesFragment | ({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: (RawContentTypesFragment | ({ __typename: 'ContentValueArray' } & { values: Array<RawContentTypesFragment> })) })> }))> })) })> })) })> }))> }));

export type ContentfulByVariationQueryVariables = {
  template: Scalars['String'],
  variation: Scalars['String'],
  space?: Maybe<Scalars['String']>
};


export type ContentfulByVariationQuery = ({ __typename: 'Query' } & { findContentByTemplate: Maybe<({ __typename: 'ContentObject' } & { entries: Array<({ __typename: 'ContentObjectEntry' } & Pick<ContentObjectEntry, 'key'> & { value: ContentTypesFragment })> })> });

export type RealUserFragment = ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'> & { assignedOperatorSeat: Maybe<({ __typename: 'Operator' } & Pick<Operator, 'id'>)> });

export type MyselfFragment = ({ __typename: 'Myself' } & Pick<Myself, 'id' | 'hasPassword'> & { user: ({ __typename: 'User' } & { mostRecentLead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id' | 'createdAt'> & { category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> })> })>, source: Maybe<({ __typename: 'UserSource' } & { attributes: Array<({ __typename: 'UserSourceAttribute' } & Pick<UserSourceAttribute, 'name' | 'value'>)> })> } & AuthenticatedUserFragment), realUser: ({ __typename: 'User' } & RealUserFragment) });

export type SessionFragment = ({ __typename: 'Session' } & Pick<Session, 'id'>);

export type MyselfQueryVariables = {};


export type MyselfQuery = ({ __typename: 'Query' } & { me: Maybe<({ __typename: 'Myself' } & MyselfFragment)>, session: ({ __typename: 'Session' } & SessionFragment) });

export type ConversationFragment = ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'> & { lead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & ChatWidgetExpertFragment) })> });

export type LeadForChatWidgetQueryVariables = {
  leadId: Scalars['LeadId']
};


export type LeadForChatWidgetQuery = ({ __typename: 'Query' } & { lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & ConversationFragment) }) });

export type DepartmentContextFragment = ({ __typename: 'Department' } & Pick<Department, 'id' | 'type' | 'slug' | 'displayName' | 'acceptingRequests' | 'launched'> & { topLevelCategory: ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'type'>) });

export type AddressFragment = ({ __typename: 'Address' } & Pick<Address, 'id' | 'addresseeName' | 'line1' | 'line2' | 'city' | 'state' | 'country' | 'postalCode' | 'securityCode' | 'phoneNumber' | 'active' | 'isDefault'> & { countryDetails: Maybe<({ __typename: 'Country' } & Pick<Country, 'displayCountry'>)> });

export type AuthenticatedUserFragment = ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName' | 'roles'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)>, messagingUser: ({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id' | 'notificationChannels'>), address: Maybe<({ __typename: 'PostalAddress' } & Pick<PostalAddress, 'line1' | 'city' | 'state' | 'postalCode' | 'country'>)>, savedAddresses: Array<({ __typename: 'Address' } & AddressFragment)>, contacts: Array<({ __typename: 'Contact' } & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>)> });

export type BrandFragment = ({ __typename: 'Brand' } & Pick<Brand, 'id' | 'name' | 'displayName'> & { logo: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> });

export type ExpertCuratedVariationOptionFragment = ({ __typename: 'ExpertCuratedOrderVariationOption' } & Pick<ExpertCuratedOrderVariationOption, 'enabled' | 'selected'> & { price: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'title' | 'descriptionText'> & { variants: Array<({ __typename: 'SellableFormattedVariant' } & Pick<SellableFormattedVariant, 'displayName' | 'value' | 'displayValueHtml'>)> }) });

export type ExpertCuratedAttributeFragment = ({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'name' | 'displayHtml'>)> });

export type ExpertCuratedSellableDetailsFragment = ({ __typename: 'Sellable' } & { charterLocation: Maybe<({ __typename: 'Attribute' } & ExpertCuratedAttributeFragment)>, charterLengthFeet: Maybe<({ __typename: 'Attribute' } & ExpertCuratedAttributeFragment)>, charterCabins: Maybe<({ __typename: 'Attribute' } & ExpertCuratedAttributeFragment)>, charterCapacity: Maybe<({ __typename: 'Attribute' } & ExpertCuratedAttributeFragment)>, charterAmenities: Maybe<({ __typename: 'Attribute' } & ExpertCuratedAttributeFragment)>, charterBathrooms: Maybe<({ __typename: 'Attribute' } & ExpertCuratedAttributeFragment)>, aircraftType: Maybe<({ __typename: 'Attribute' } & ExpertCuratedAttributeFragment)> } & (SellableDetailsFragment & SellablePricingFragment));

export type ExpertCuratedOrderLineItemFragment = ({ __typename: 'OrderLineItem' } & Pick<OrderLineItem, 'id' | 'isGroup' | 'title' | 'quantity'> & { unitPrice: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), source: ({ __typename: 'OrderLineItemAdHocSource' | 'OrderLineItemBasePriceSource' | 'OrderLineItemExpertTipSource' | 'OrderLineItemGratuitySource' | 'OrderLineItemSellableSource' | 'OrderLineItemShipmentSource' } & Pick<OrderLineItemSource, 'type'> & (({ __typename: 'OrderLineItemAdHocSource' | 'OrderLineItemBasePriceSource' | 'OrderLineItemExpertTipSource' | 'OrderLineItemGratuitySource' | 'OrderLineItemSellableSource' | 'OrderLineItemShipmentSource' } & Pick<OrderLineItemSource, 'type'>) & (({ __typename: 'OrderLineItemSellableSource' } & { sellable: ({ __typename: 'Sellable' } & ExpertCuratedSellableDetailsFragment) }) | ({ __typename: 'OrderLineItemAdHocSource' } & Pick<OrderLineItemAdHocSource, 'type'>) | ({ __typename: 'OrderLineItemBasePriceSource' } & Pick<OrderLineItemBasePriceSource, 'type'>) | ({ __typename: 'OrderLineItemExpertTipSource' } & Pick<OrderLineItemExpertTipSource, 'type'>) | ({ __typename: 'OrderLineItemGratuitySource' } & Pick<OrderLineItemGratuitySource, 'type'>) | ({ __typename: 'OrderLineItemShipmentSource' } & Pick<OrderLineItemShipmentSource, 'type'>)))) });

export type LeadCuratedOrderFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'title' | 'imageUrl'>)> }) })>, consumer: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>), expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { phoneNumber: BusinessUser['assignedAddress'] } & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }) });

export type AirportFragment = ({ __typename: 'Airport' } & Pick<Airport, 'id' | 'zoneId' | 'displayCode'>);

export type FlightPlanLegFragment = ({ __typename: 'FlightPlanLeg' } & Pick<FlightPlanLeg, 'id' | 'departAt' | 'departOn' | 'arriveAt' | 'durationInMinutes' | 'flightOperator'> & { departureAirport: Maybe<({ __typename: 'Airport' } & AirportFragment)>, arrivalAirport: Maybe<({ __typename: 'Airport' } & AirportFragment)> });

export type FlightPlanFragment = ({ __typename: 'FlightPlan' } & Pick<FlightPlan, 'id' | 'state'> & { legs: Array<({ __typename: 'FlightPlanLeg' } & FlightPlanLegFragment)> });

export type ExpertCuratedOrderManualTaxAdjustmentFragment = ({ __typename: 'ExpertCuratedOrderManualTaxAdjustment' } & Pick<ExpertCuratedOrderManualTaxAdjustment, 'taxRate'> & { amount: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, computedFromAmount: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> });

export type ExpertCuratedOrderFragment = ({ __typename: 'ExpertCuratedOrder' } & Pick<ExpertCuratedOrder, 'id' | 'state' | 'serviceStartAt' | 'inPreview' | 'expiresAt' | 'serviceStartAt' | 'taxWillBeAutomaticallyComputed'> & { category: ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>), serviceLocation: Maybe<({ __typename: 'PostalAddress' } & Pick<PostalAddress, 'displayTitle'>)>, curatedFor: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName'>), items: Array<({ __typename: 'ExpertCuratedOrderItem' } & Pick<ExpertCuratedOrderItem, 'id'>)>, order: ({ __typename: 'Order' } & Pick<Order, 'id' | 'title' | 'description' | 'state'> & { primaryImage: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, totalCostBeforeTax: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), tax: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), totalCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), remainingBalance: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), minimumDeposit: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, lineItems: Array<({ __typename: 'OrderLineItem' } & ExpertCuratedOrderLineItemFragment)> }), variationOptions: Array<({ __typename: 'ExpertCuratedOrderVariationOption' } & ExpertCuratedVariationOptionFragment)>, lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'singularDisplayName'> & { department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> })> } & LeadCuratedOrderFragment), flightPlan: Maybe<({ __typename: 'FlightPlan' } & FlightPlanFragment)>, defaultManualTaxAdjustment: Maybe<({ __typename: 'ExpertCuratedOrderManualTaxAdjustment' } & ExpertCuratedOrderManualTaxAdjustmentFragment)> });

export type ExpertProfileHighlightsFragment = ({ __typename: 'ProfileHighlight' } & Pick<ProfileHighlight, 'value' | 'secondaryValue'> & { type: ({ __typename: 'ProfileHighlightType' } & Pick<ProfileHighlightType, 'id' | 'icon' | 'displayName'>) });

export type ExpertStatsFragment = ({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'topGoodQualities' | 'averageRating' | 'totalLeads' | 'totalMessages' | 'totalReviews'>);

export type NumericRangeDisplayFacetFragment = ({ __typename: 'NumericRangeDisplayFacet' } & Pick<NumericRangeDisplayFacet, 'displayName' | 'name' | 'alias' | 'type' | 'lower' | 'upper' | 'scale' | 'upperCapped'>);

export type BucketedDisplayFacetFragment = ({ __typename: 'BucketedDisplayFacet' } & Pick<BucketedDisplayFacet, 'displayName' | 'name' | 'alias'> & { buckets: Array<({ __typename: 'IndividualBucketedDisplayFacet' } & Pick<IndividualBucketedDisplayFacet, 'displayName' | 'value' | 'count'> & { imageMetadata: Maybe<({ __typename: 'BackgroundFacetImageMetadata' | 'IconFacetImageMetadata' } & (({ __typename: 'BackgroundFacetImageMetadata' } & Pick<BackgroundFacetImageMetadata, 'type' | 'imageUrl'>) | ({ __typename: 'IconFacetImageMetadata' } & Pick<IconFacetImageMetadata, 'type' | 'imageUrl'>)))> })> });

export type DisplayFacetFragment = ({ __typename: 'BucketedDisplayFacet' | 'BucketedRangeDisplayFacet' | 'NumericRangeDisplayFacet' } & (BucketedDisplayFacetFragment | NumericRangeDisplayFacetFragment));

export type MediaFileFragment = ({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url' | 'mimeType' | 'size' | 'persisted'>);

export type MonetaryAmountFragment = ({ __typename: 'MonetaryAmount' } & Pick<MonetaryAmount, 'currency' | 'amount'> & { amountInSmallestDenomination: MonetaryAmount['amount'] });

export type OrderMessageFragment = ({ __typename: 'OrderMessage' } & Pick<OrderMessage, 'dismissible' | 'message'>);

export type TransactionFragment = ({ __typename: 'Transaction' } & Pick<Transaction, 'id' | 'status'> & { request: ({ __typename: 'TransactionRequest' } & Pick<TransactionRequest, 'paymentSourceType'> & { chargeAmount: ({ __typename: 'MonetaryAmount' } & Pick<MonetaryAmount, 'amount' | 'currency'>) }), response: Maybe<({ __typename: 'TransactionResponse' } & Pick<TransactionResponse, 'errorMessage' | 'userFriendlyErrorMessage'> & { paymentSource: Maybe<({ __typename: 'AffirmPaymentSource' | 'AfterpayPaymentSource' | 'PaypalPaymentSource' | 'StripePaymentSource' } & PaymentSourceFragment)> })> });

export type WireTransferPaymentEntityFragment = ({ __typename: 'WireTransferPaymentEntity' } & Pick<WireTransferPaymentEntity, 'paymentMethod' | 'accountNumber' | 'bankName' | 'routingNumber' | 'swiftCode'> & { chargeableAmount: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) });

export type OrderFragment = ({ __typename: 'Order' } & Pick<Order, 'id' | 'state' | 'createdAt' | 'paidAt' | 'categoryType' | 'requiresShippingAddress' | 'itemsCount'> & { user: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>), tax: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), shippingCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), chargingPaymentSource: Maybe<({ __typename: 'AffirmPaymentSource' | 'AfterpayPaymentSource' | 'PaypalPaymentSource' | 'StripePaymentSource' } & Pick<PaymentSource, 'id'> & { paymentEntity: ({ __typename: 'InstallmentPaymentEntity' | 'Payment3DSecure' | 'PaymentCard' | 'PaypalPaymentEntity' | 'WireTransferPaymentEntity' } & ({ __typename: 'WireTransferPaymentEntity' } & WireTransferPaymentEntityFragment)) })>, totalCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), totalCostBeforeTax: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), subtotal: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), totalCostWithoutTip: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), totalShippingCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), tip: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, messages: Array<({ __typename: 'OrderMessage' } & OrderMessageFragment)>, shippingAddress: Maybe<({ __typename: 'Address' } & AddressFragment)>, shipmentTrackings: Maybe<Array<({ __typename: 'ShipmentTracking' } & ShipmentTrackingFragment)>>, transactions: Maybe<Array<({ __typename: 'Transaction' } & TransactionFragment)>>, offer: Maybe<({ __typename: 'BroadcastOffer' } & Pick<BroadcastOffer, 'id' | 'title' | 'type'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, supportedPaymentMethods: Array<({ __typename: 'SupportedPaymentMethod' } & Pick<SupportedPaymentMethod, 'paymentMethod' | 'paymentProvider'>)>, appliedPromotionEntry: Maybe<({ __typename: 'OrderPromotionEntry' } & Pick<OrderPromotionEntry, 'applied'> & { discount: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), promotion: ({ __typename: 'Promotion' } & Pick<Promotion, 'id' | 'code'>) })> });

export type OrderLineItemFragment = ({ __typename: 'OrderLineItem' } & Pick<OrderLineItem, 'id' | 'quantity' | 'isGroup' | 'parentId' | 'title'> & { messages: Array<({ __typename: 'OrderMessage' } & Pick<OrderMessage, 'dismissible' | 'message'>)>, price: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), source: ({ __typename: 'OrderLineItemAdHocSource' | 'OrderLineItemBasePriceSource' | 'OrderLineItemExpertTipSource' | 'OrderLineItemGratuitySource' | 'OrderLineItemSellableSource' | 'OrderLineItemShipmentSource' } & Pick<OrderLineItemSource, 'type'> & (({ __typename: 'OrderLineItemBasePriceSource' } & Pick<OrderLineItemBasePriceSource, 'type'>) | ({ __typename: 'OrderLineItemGratuitySource' } & Pick<OrderLineItemGratuitySource, 'type' | 'percentage'>) | ({ __typename: 'OrderLineItemExpertTipSource' } & Pick<OrderLineItemExpertTipSource, 'type'> & { amount: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) }) | ({ __typename: 'OrderLineItemShipmentSource' } & Pick<OrderLineItemShipmentSource, 'type'> & { amount: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) }) | ({ __typename: 'OrderLineItemAdHocSource' } & Pick<OrderLineItemAdHocSource, 'type'>) | ({ __typename: 'OrderLineItemSellableSource' } & { sellable: ({ __typename: 'Sellable' } & SellableDetailsFragment) }))), unitPrice: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), totalBeforeTax: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) });

export type PageInfoFragment = ({ __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>);

export type StripePaymentSourceFragment = ({ __typename: 'StripePaymentSource' } & Pick<StripePaymentSource, 'id' | 'createdAt' | 'updatedAt' | 'externalSourceId' | 'type' | 'usage' | 'status' | 'userId' | 'isDefault'> & { owner: Maybe<({ __typename: 'StripeOwner' } & Pick<StripeOwner, 'name' | 'verifiedName'>)>, billingAddress: Maybe<({ __typename: 'Address' } & AddressFragment)>, paymentEntity: ({ __typename: 'InstallmentPaymentEntity' | 'Payment3DSecure' | 'PaymentCard' | 'PaypalPaymentEntity' | 'WireTransferPaymentEntity' } & ({ __typename: 'PaymentCard' } & Pick<PaymentCard, 'paymentMethod' | 'last4' | 'brand' | 'threeDSecureVerificationRequired'>)) });

export type PaymentSourceFragment = ({ __typename: 'AffirmPaymentSource' | 'AfterpayPaymentSource' | 'PaypalPaymentSource' | 'StripePaymentSource' } & (StripePaymentSourceFragment | ({ __typename: 'AffirmPaymentSource' } & Pick<AffirmPaymentSource, 'id'>) | ({ __typename: 'PaypalPaymentSource' } & Pick<PaypalPaymentSource, 'id'>) | ({ __typename: 'AfterpayPaymentSource' } & Pick<AfterpayPaymentSource, 'id'>)));

export type VideoReviewFragment = ({ __typename: 'ExternalVideo' } & Pick<ExternalVideo, 'id' | 'idType' | 'destinationUrl'>);

export type FeaturedContentFragment = ({ __typename: 'Sellable' } & { featuredContent: Maybe<({ __typename: 'FeaturedSellableContent' } & Pick<FeaturedSellableContent, 'id'> & { externalVideos: Array<({ __typename: 'ExternalVideo' } & VideoReviewFragment)> })> });

export type SellableDetailsVariantFragment = ({ __typename: 'SellableFormattedVariant' } & Pick<SellableFormattedVariant, 'name' | 'displayName' | 'value' | 'displayValueHtml'>);

export type SellableSpecificationFragment = ({ __typename: 'SellableSpecification' } & Pick<SellableSpecification, 'key' | 'name' | 'valueHtml'>);

export type SellableDetailsFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'type' | 'adHoc' | 'descriptionText' | 'descriptionMarkdown' | 'features' | 'active' | 'inShortSupply' | 'variant'> & { department: Maybe<({ __typename: 'Department' } & { mostRecentLeadForConsumer: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'>)> } & DepartmentContextFragment)>, savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)>, variants: Array<({ __typename: 'SellableFormattedVariant' } & SellableDetailsVariantFragment)>, specifications: Array<({ __typename: 'SellableSpecification' } & SellableSpecificationFragment)>, metrics: Maybe<({ __typename: 'SellableMetrics' } & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days' | 'timesRecommendedByExpert'>)>, serviceLocation: Maybe<({ __typename: 'SellableServiceLocation' } & Pick<SellableServiceLocation, 'displayTitle'>)>, categories: Array<({ __typename: 'Category' } & { breadcrumbs: Array<({ __typename: 'Category' } & CategoryBreadcrumbFragment)> })>, parent: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { metrics: Maybe<({ __typename: 'SellableMetrics' } & Pick<SellableMetrics, 'totalUniquePVsInPastWeek' | 'totalPurchasesInLast30Days'>)>, savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)>, department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> })>, variationMatrix: Maybe<({ __typename: 'VariationMatrix' } & { defaultVariant: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> }), outOfStockSellables: Array<({ __typename: 'Sellable' } & Pick<Sellable, 'id'>)>, priceRange: Maybe<({ __typename: 'VariationMatrixPriceRange' } & { max: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), min: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) })> })>, salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> } & (TrackableSellableFragment & FeaturedContentFragment));

export type SellablePricingFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, variationMatrix: Maybe<({ __typename: 'VariationMatrix' } & { defaultVariant: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> }) })> });

export type SellableUrlFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>);

export type ShipmentTrackingFragment = ({ __typename: 'ShipmentTracking' } & Pick<ShipmentTracking, 'trackingNumber' | 'status' | 'estimatedDeliveryTime' | 'trackingUrl'> & { shippingCarrier: ({ __typename: 'ShippingCarrier' } & Pick<ShippingCarrier, 'id' | 'displayName'>) });

export type ShoppingCartOrderFragment = ({ __typename: 'Order' } & { lineItems: Array<({ __typename: 'OrderLineItem' } & OrderLineItemFragment)> } & OrderFragment);

export type ParentCategoryDataFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'> & { department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> });

export type CategoryDataFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'name' | 'pluralDisplayName' | 'singularDisplayName' | 'slug' | 'faqSlug' | 'type'> & { department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)>, parents: Array<({ __typename: 'Category' } & ParentCategoryDataFragment)>, contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) });

export type TrackableSellableFragment = ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'googleId' | 'title' | 'feedId' | 'variant' | 'feedId' | 'sampleImageIds'> & { department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id'> & { topLevelCategory: ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>) })>, brand: Maybe<({ __typename: 'Brand' } & BrandFragment)>, images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)>, salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, variationMatrix: Maybe<({ __typename: 'VariationMatrix' } & { defaultVariant: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'> & { salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> }) })>, categories: Array<({ __typename: 'Category' } & CategoryDataFragment)>, parent: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'googleId'> & { categories: Array<({ __typename: 'Category' } & CategoryDataFragment)> })> });

export type VariationMatrixDimensionFragment = ({ __typename: 'VariationMatrixDimension' } & Pick<VariationMatrixDimension, 'name' | 'displayName'> & { vectors: Array<({ __typename: 'VariationMatrixVector' } & VariationMatrixVectorFragment)> });

export type VariationMatrixVectorFragment = ({ __typename: 'VariationMatrixVector' } & Pick<VariationMatrixVector, 'value' | 'displayValueHtml' | 'sellableIds'>);

export type VariationMatrixFragment = ({ __typename: 'VariationMatrix' } & Pick<VariationMatrix, 'maximumSavingsPercent'> & { dimensions: Array<({ __typename: 'VariationMatrixDimension' } & VariationMatrixDimensionFragment)>, sellables: Array<({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>)>, defaultVariant: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'> & { salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> }), priceRange: Maybe<({ __typename: 'VariationMatrixPriceRange' } & { min: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), max: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) })>, maximumSavingsAmount: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, outOfStockSellables: Array<({ __typename: 'Sellable' } & Pick<Sellable, 'id'>)> });

export type CreateBookingFlightPlanMutationVariables = {
  input: CreateFlightPlanInput
};


export type CreateBookingFlightPlanMutation = ({ __typename: 'Mutation' } & { createFlightPlan: ({ __typename: 'CreateFlightPlanPayload' } & Pick<CreateFlightPlanPayload, 'hasError' | 'errorMessage'> & { flightPlan: Maybe<({ __typename: 'FlightPlan' } & Pick<FlightPlan, 'id'>)> }) });

export type StartExpertConsumerConversationMutationVariables = {
  input: StartExpertConsumerConversationInput
};


export type StartExpertConsumerConversationMutation = ({ __typename: 'Mutation' } & { startExpertConsumerConversation: ({ __typename: 'StartExpertConsumerConversationPayload' } & Pick<StartExpertConsumerConversationPayload, 'error'> & { conversation: Maybe<({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'> & { lead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'>)> })> }) });

export type CategoryWithPathQueryVariables = {
  categorySlug: Scalars['String']
};


export type CategoryWithPathQuery = ({ __typename: 'Query' } & { categoryBySlug: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { ancestorWithPath: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> })> });

export type CountryFragment = ({ __typename: 'Country' } & Pick<Country, 'countryCode' | 'displayCountry' | 'displayFirstAdministrativeAreaLabel' | 'displayPostalCodeLabel' | 'displayCityLabel'> & { firstAdministrativeAreas: Array<({ __typename: 'AdministrativeArea' } & Pick<AdministrativeArea, 'countryCode' | 'code' | 'displayName'>)> });

export type CountriesQueryVariables = {
  filter: CountryFilter
};


export type CountriesQuery = ({ __typename: 'Query' } & { countries: Array<({ __typename: 'Country' } & CountryFragment)> });

export type ChangePasswordMutationVariables = {
  oldPassword: Scalars['String'],
  newPassword: Scalars['String']
};


export type ChangePasswordMutation = ({ __typename: 'Mutation' } & { changePassword: ({ __typename: 'ChangePasswordPayload' } & Pick<ChangePasswordPayload, 'result' | 'message'>) });

export type CreatePasswordMutationVariables = {
  password: Scalars['String']
};


export type CreatePasswordMutation = ({ __typename: 'Mutation' } & { createPassword: ({ __typename: 'CreatePasswordPayload' } & Pick<CreatePasswordPayload, 'success'>) });

export type OrderEscalationFragment = ({ __typename: 'OrderEscalation' } & Pick<OrderEscalation, 'id' | 'type' | 'status' | 'createdAt' | 'orderLineItemId' | 'consumerFriendlyId'>);

export type EscalateOrderMutationVariables = {
  input: CreateOrderEscalationInput
};


export type EscalateOrderMutation = ({ __typename: 'Mutation' } & { createOrderEscalation: ({ __typename: 'CreateOrderEscalationsPayload' } & { orderEscalation: ({ __typename: 'OrderEscalation' } & OrderEscalationFragment) }) });

export type OrderListLineItemFragment = ({ __typename: 'OrderLineItem' } & Pick<OrderLineItem, 'id' | 'state' | 'title'> & { shipmentTracking: Maybe<({ __typename: 'ShipmentTracking' } & ShipmentTrackingFragment)>, source: ({ __typename: 'OrderLineItemAdHocSource' | 'OrderLineItemBasePriceSource' | 'OrderLineItemExpertTipSource' | 'OrderLineItemGratuitySource' | 'OrderLineItemSellableSource' | 'OrderLineItemShipmentSource' } & Pick<OrderLineItemSource, 'type'> & ({ __typename: 'OrderLineItemSellableSource' } & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)>, variants: Array<({ __typename: 'SellableFormattedVariant' } & Pick<SellableFormattedVariant, 'displayValueHtml'>)> }) })) });

export type OrderListEscalationFragment = ({ __typename: 'OrderEscalation' } & Pick<OrderEscalation, 'id' | 'orderId' | 'orderLineItemId' | 'consumerFriendlyId' | 'createdAt' | 'type' | 'status'> & { assignedTo: Maybe<({ __typename: 'Operator' } & Pick<Operator, 'id' | 'firstName'>)> });

export type MyOrderListItemFragment = ({ __typename: 'Order' } & Pick<Order, 'id' | 'consumerFriendlyId' | 'state' | 'categoryType' | 'sortTimestamp'> & { totalCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), lineItems: Array<({ __typename: 'OrderLineItem' } & OrderListLineItemFragment)>, escalations: Array<({ __typename: 'OrderEscalation' } & OrderListEscalationFragment)> });

export type MyOrdersConnectionQueryVariables = {
  query: OrderQuery,
  after?: Maybe<Scalars['String']>
};


export type MyOrdersConnectionQuery = ({ __typename: 'Query' } & { ordersConnection: ({ __typename: 'OrdersConnection' } & { edges: Array<({ __typename: 'OrdersEdge' } & { node: ({ __typename: 'Order' } & MyOrderListItemFragment) })> }) });

export type StartingSupportConversationFragment = ({ __typename: 'SupportConversation' } & Pick<SupportConversation, 'id' | 'conversationId' | 'consumerId'>);

export type StartSupportConversationMutationVariables = {
  input: StartSupportConversationInput
};


export type StartSupportConversationMutation = ({ __typename: 'Mutation' } & { startSupportConversation: ({ __typename: 'UpdateSupportConversationPayload' } & { supportConversation: ({ __typename: 'SupportConversation' } & SupportConversationFragment) }) });

export type UpdateNotificationChannelsMutationVariables = {
  input: UpdateNotificationChannelsInput
};


export type UpdateNotificationChannelsMutation = ({ __typename: 'Mutation' } & { updateNotificationChannels: ({ __typename: 'UpdateNotificationChannelsPayload' } & { messagingUser: Maybe<({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id' | 'notificationChannels'>)> }) });

export type UpdateUserProfileMutationVariables = {
  input: UpdateUserProfileInput
};


export type UpdateUserProfileMutation = ({ __typename: 'Mutation' } & { updateUserProfile: ({ __typename: 'UpdateUserProfilePayload' } & Pick<UpdateUserProfilePayload, 'errors'> & { user: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName' | 'roles'> & { messagingUser: ({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id'>), address: Maybe<({ __typename: 'PostalAddress' } & Pick<PostalAddress, 'line1' | 'city' | 'state' | 'postalCode' | 'country'>)>, contacts: Array<({ __typename: 'Contact' } & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>)> }) }) });

export type CreateExpertFromApplicationMutationVariables = {
  applicationId: Scalars['ExpertApplicationId']
};


export type CreateExpertFromApplicationMutation = ({ __typename: 'Mutation' } & { createExpertFromApplication: ({ __typename: 'CreateExpertFromApplicationPayload' } & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id'>) }) });

export type AuthenticationSessionStateFragment = ({ __typename: 'Session' } & Pick<Session, 'id' | 'authenticationMethod'> & { authenticationState: ({ __typename: 'AuthenticationSessionState' } & Pick<AuthenticationSessionState, 'handle' | 'handleId' | 'loginChallengeType' | 'resetPasswordChallengeVerified'>) });

export type AuthenticationSessionStateQueryVariables = {};


export type AuthenticationSessionStateQuery = ({ __typename: 'Query' } & { session: ({ __typename: 'Session' } & AuthenticationSessionStateFragment) });

export type FindContactQueryVariables = {
  contactId: Scalars['ContactId']
};


export type FindContactQuery = ({ __typename: 'Query' } & { findContact: Maybe<({ __typename: 'Contact' } & Pick<Contact, 'id' | 'type' | 'value' | 'verified'>)> });

export type MaskedHandlesByLoginTokenQueryVariables = {
  loginToken: Scalars['String']
};


export type MaskedHandlesByLoginTokenQuery = ({ __typename: 'Query' } & { maskedHandlesByLoginToken: Array<({ __typename: 'MaskedUserHandle' } & Pick<MaskedUserHandle, 'id' | 'maskedHandle' | 'handleType'>)> });

export type InitiateAuthenticationMutationVariables = {
  input: InitiateAuthenticationInput
};


export type InitiateAuthenticationMutation = ({ __typename: 'Mutation' } & { initiateAuthentication: ({ __typename: 'InitiateAuthenticationPayload' } & Pick<InitiateAuthenticationPayload, 'isValidHandle' | 'challengeType'> & { session: ({ __typename: 'Session' } & AuthenticationSessionStateFragment) }) });

export type AuthenticateMutationVariables = {
  input: AuthenticationInput
};


export type AuthenticateMutation = ({ __typename: 'Mutation' } & { authenticate: ({ __typename: 'AuthenticationResultPayload' } & Pick<AuthenticationResultPayload, 'result' | 'message'> & { user: Maybe<({ __typename: 'User' } & AuthenticatedUserFragment)> }) });

export type MaskedHandleQueryVariables = {
  id: Scalars['AnyId']
};


export type MaskedHandleQuery = ({ __typename: 'Query' } & { maskedHandle: ({ __typename: 'MaskedUserHandle' } & Pick<MaskedUserHandle, 'id' | 'maskedHandle' | 'handleType'>) });

export type InitiateResetPasswordMutationVariables = {
  input: InitiateResetPasswordInput
};


export type InitiateResetPasswordMutation = ({ __typename: 'Mutation' } & { initiateResetPassword: ({ __typename: 'InitiateResetPasswordPayload' } & Pick<InitiateResetPasswordPayload, 'success' | 'errorMessage'>) });

export type LogoutMutationVariables = {};


export type LogoutMutation = ({ __typename: 'Mutation' } & Pick<Mutation, 'logout'>);

export type ResetPasswordMutationVariables = {
  input: ResetPasswordInput
};


export type ResetPasswordMutation = ({ __typename: 'Mutation' } & { resetPassword: ({ __typename: 'ResetPasswordPayload' } & Pick<ResetPasswordPayload, 'result' | 'message'> & { user: Maybe<({ __typename: 'User' } & AuthenticatedUserFragment)> }) });

export type VerifyResetPasswordChallengeMutationVariables = {
  input: VerifyResetPasswordChallengeInput
};


export type VerifyResetPasswordChallengeMutation = ({ __typename: 'Mutation' } & { verifyResetPasswordChallenge: ({ __typename: 'VerifyResetPasswordChallengePayload' } & Pick<VerifyResetPasswordChallengePayload, 'success' | 'message'> & { session: ({ __typename: 'Session' } & AuthenticationSessionStateFragment) }) });

export type CategoryFilterDisplayMetadataFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>);

export type CategoryFilterBreadcrumbsFragment = ({ __typename: 'Category' } & { ancestry: Array<({ __typename: 'Category' } & CategoryFilterDisplayMetadataFragment)>, children: Array<({ __typename: 'Category' } & CategoryFilterDisplayMetadataFragment)> } & CategoryFilterDisplayMetadataFragment);

export type CategorySellableSearchResultFragment = ({ __typename: 'SellableSearchEdge' } & Pick<SellableSearchEdge, 'cursor'> & { node: ({ __typename: 'Sellable' } & SellableCardFragment) });

export type SellableSearchResultPageMetadataFragment = ({ __typename: 'SellableSearchResultPageMetadata' } & Pick<SellableSearchResultPageMetadata, 'pageTitle'> & { pageTitleImage: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, featuredFacets: Array<({ __typename: 'BucketedDisplayFacet' | 'BucketedRangeDisplayFacet' | 'NumericRangeDisplayFacet' } & DisplayFacetFragment)> });

export type CategorySellableSearchQueryVariables = {
  keywords?: Maybe<Scalars['String']>,
  categorySlug: Scalars['String'],
  facets?: Maybe<Array<FacetSelection>>,
  after?: Maybe<Scalars['String']>,
  maxFacetTerms?: Maybe<Scalars['Int']>,
  filters?: Maybe<Array<SellableSearchFilter>>,
  sortBy: SellableSort,
  order: SortOrder
};


export type CategorySellableSearchQuery = ({ __typename: 'Query' } & { searchSellables: ({ __typename: 'SellableSearchConnection' } & Pick<SellableSearchConnection, 'count'> & { facets: Array<({ __typename: 'BucketedDisplayFacet' | 'BucketedRangeDisplayFacet' | 'NumericRangeDisplayFacet' } & DisplayFacetFragment)>, edges: Array<({ __typename: 'SellableSearchEdge' } & CategorySellableSearchResultFragment)>, pageInfo: ({ __typename: 'PageInfo' } & PageInfoFragment), pageMetadata: Maybe<({ __typename: 'SellableSearchResultPageMetadata' } & SellableSearchResultPageMetadataFragment)> }), categoryBySlug: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'pluralDisplayName' | 'type'> & { department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)>, breadcrumbs: Array<({ __typename: 'Category' } & CategoryBreadcrumbFragment)> } & CategoryFilterBreadcrumbsFragment)> });

export type CategoryAssetsForMetadataQueryVariables = {
  categoryId: Scalars['CategoryId']
};


export type CategoryAssetsForMetadataQuery = ({ __typename: 'Query' } & { category: ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { communityPoster: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) }) });

export type NoResultsDepartmentsQueryVariables = {};


export type NoResultsDepartmentsQuery = ({ __typename: 'Query' } & { departments: Array<({ __typename: 'Department' } & Pick<Department, 'id' | 'slug'>)> });

export type SellableSearchResultFragment = ({ __typename: 'SellableSearchEdge' } & Pick<SellableSearchEdge, 'cursor'> & { node: ({ __typename: 'Sellable' } & SellableCardFragment) });

export type CustomerRequestExpertCuratedOrderMutationVariables = {
  id: Scalars['ExpertCuratedOrderId']
};


export type CustomerRequestExpertCuratedOrderMutation = ({ __typename: 'Mutation' } & { customerRequestExpertCuratedOrder: ({ __typename: 'CustomerRequestExpertCuratedOrderPayload' } & { expertCuratedOrder: ({ __typename: 'ExpertCuratedOrder' } & Pick<ExpertCuratedOrder, 'id'>) }) });

export type ExpertCuratedLeadItineraryQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertCuratedLeadItineraryQuery = ({ __typename: 'Query' } & { expertCuratedLeadItinerary: Maybe<({ __typename: 'ExpertCuratedLeadItinerary' } & Pick<ExpertCuratedLeadItinerary, 'id' | 'contentfulVariation'>)> });

export type LeadForCurationsFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { consumer: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName'>), expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }), conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'title' | 'mimeType' | 'imageUrl'>)> }) })>, department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'slug'>)> });

export type LeadForCurationsQueryVariables = {
  id: Scalars['LeadId']
};


export type LeadForCurationsQuery = ({ __typename: 'Query' } & { lead: ({ __typename: 'Lead' } & LeadForCurationsFragment) });

export type ExpertCuratedItemsForSellableQueryVariables = {
  query: PopularExpertCuratedItemQueryInput
};


export type ExpertCuratedItemsForSellableQuery = ({ __typename: 'Query' } & { popularExpertCuratedItemsForSellable: ({ __typename: 'PopularExpertCuratedItemConnection' } & { edges: Array<({ __typename: 'PopularExpertCuratedItemEdge' } & Pick<PopularExpertCuratedItemEdge, 'cursor'> & { node: ({ __typename: 'PopularExpertCuratedItem' } & { sellable: ({ __typename: 'Sellable' } & SellableCardFragment) }) })> }) });

export type ExpertCuratedOrdersForLeadConnectionQueryVariables = {
  query: ExpertCuratedOrdersForLeadQueryInput,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  before?: Maybe<Scalars['String']>,
  last?: Maybe<Scalars['Int']>
};


export type ExpertCuratedOrdersForLeadConnectionQuery = ({ __typename: 'Query' } & { expertCuratedOrdersForLeadConnection: ({ __typename: 'ExpertCuratedOrdersForLeadConnection' } & { edges: Array<({ __typename: 'ExpertCuratedOrdersForLeadEdge' } & { node: ({ __typename: 'ExpertCuratedOrder' } & ExpertCuratedOrderFragment) })> }) });

export type ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables = {
  query: ExpertCuratedOrdersForLeadQueryInput
};


export type ExpertCuratedOrdersForLeadConnectionChangedSubscription = ({ __typename: 'Subscription' } & { expertCuratedOrdersForLeadConnectionChanged: ({ __typename: 'ExpertCuratedOrdersForLeadConnectionChangedPayload' } & { connection: ({ __typename: 'ExpertCuratedOrdersForLeadConnection' } & { edges: Array<({ __typename: 'ExpertCuratedOrdersForLeadEdge' } & { node: ({ __typename: 'ExpertCuratedOrder' } & ExpertCuratedOrderFragment) })> }) }) });

export type AddExpertCuratedItemToCartMutationVariables = {
  id: Scalars['ExpertCuratedItemId']
};


export type AddExpertCuratedItemToCartMutation = ({ __typename: 'Mutation' } & { addExpertCuratedItemToCart: ({ __typename: 'AddExpertCuratedItemToCartPayload' } & { expertCuratedItem: ({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'> & { lineItemInCart: Maybe<({ __typename: 'OrderLineItem' } & Pick<OrderLineItem, 'id'>)> }), order: ({ __typename: 'Order' } & ShoppingCartOrderFragment) }) });

export type RemoveExpertCuratedItemsFromCartMutationVariables = {
  id: Scalars['OrderLineItemId']
};


export type RemoveExpertCuratedItemsFromCartMutation = ({ __typename: 'Mutation' } & { removeItemsFromOrder: ({ __typename: 'RemoveItemsFromOrderPayload' } & { order: ({ __typename: 'Order' } & ShoppingCartOrderFragment) }) });

export type SelectExpertCuratedOrderVariationOptionMutationVariables = {
  input: SelectExpertCuratedOrderVariationOptionInput
};


export type SelectExpertCuratedOrderVariationOptionMutation = ({ __typename: 'Mutation' } & { selectExpertCuratedOrderVariationOption: ({ __typename: 'SelectExpertCuratedOrderVariationOptionPayload' } & { expertCuratedOrder: ({ __typename: 'ExpertCuratedOrder' } & ExpertCuratedOrderFragment) }) });

export type ReportPredictedLifeTimeValueToPlatformMutationVariables = {
  input: ReportPredictedLifeTimeValueInput
};


export type ReportPredictedLifeTimeValueToPlatformMutation = ({ __typename: 'Mutation' } & { reportPredictedLifeTimeValueToPlatform: ({ __typename: 'ReportPredictedLifeTimeValuePayload' } & { predictedLifeTimeValues: Array<({ __typename: 'PredictedLifeTimeValue' } & Pick<PredictedLifeTimeValue, 'id' | 'userId' | 'ltvType'> & { pLTV: ({ __typename: 'MonetaryAmount' } & Pick<MonetaryAmount, 'amount' | 'currency'>) })> }) });

export type ExpertCuratedItemCustomizationFragment = ({ __typename: 'ExpertCuratedItemCustomization' } & Pick<ExpertCuratedItemCustomization, 'createdAt' | 'title'> & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'>), price: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) });

export type ProductCurationsExpertCuratedItemFragment = ({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'> & { createdBy: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }), tag: Maybe<({ __typename: 'ExpertCuratedItemTag' } & Pick<ExpertCuratedItemTag, 'type' | 'displayLabel'>)>, note: Maybe<({ __typename: 'ExpertCuratedItemNote' } & Pick<ExpertCuratedItemNote, 'id' | 'text'>)>, sellable: ({ __typename: 'Sellable' } & { originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'type' | 'slug'>)>, variants: Array<({ __typename: 'SellableFormattedVariant' } & Pick<SellableFormattedVariant, 'name' | 'displayName' | 'displayValueHtml'>)>, savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)>, parent: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { savedSellable: Maybe<({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved'>)> } & TrackableSellableFragment)> } & TrackableSellableFragment), priceOverride: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, lineItemInCart: Maybe<({ __typename: 'OrderLineItem' } & Pick<OrderLineItem, 'id'>)>, customizations: Array<({ __typename: 'ExpertCuratedItemCustomization' } & ExpertCuratedItemCustomizationFragment)> });

export type ExpertCuratedItemByCategoryFragment = ({ __typename: 'ExpertCuratedItemsByCategory' } & { category: ({ __typename: 'Category' } & Pick<Category, 'id' | 'pluralDisplayName' | 'singularDisplayName' | 'slug'> & { department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'slug'>)> }), items: Array<({ __typename: 'ExpertCuratedItem' } & ProductCurationsExpertCuratedItemFragment)> });

export type CategoryBannerAssetsFragment = ({ __typename: 'Category' } & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) });

export type CuratedItemsLeadFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'>), delegateExpert: Maybe<({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'>)>, category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'> & { department: Maybe<({ __typename: 'Department' } & DepartmentContextFragment)> } & CategoryBannerAssetsFragment)>, conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>), consumerConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>), expertConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>) });

export type ExpertCuratedItemsForLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertCuratedItemsForLeadQuery = ({ __typename: 'Query' } & { expertCuratedItemsForLead: ({ __typename: 'ExpertCuratedItemsForLeadPayload' } & { byCategories: ({ __typename: 'ExpertCuratedItemsByCategories' } & Pick<ExpertCuratedItemsByCategories, 'id'> & { categories: Array<({ __typename: 'ExpertCuratedItemsByCategory' } & ExpertCuratedItemByCategoryFragment)> }) }), lead: ({ __typename: 'Lead' } & CuratedItemsLeadFragment) });

export type RemoveExpertCuratedItemFromListMutationVariables = {
  id: Scalars['ExpertCuratedItemId'],
  reason: ExpertCuratedItemRemovedReason,
  otherReason?: Maybe<Scalars['String']>
};


export type RemoveExpertCuratedItemFromListMutation = ({ __typename: 'Mutation' } & { removeExpertCuratedItem: ({ __typename: 'RemoveExpertCuratedItemPayload' } & { expertCuratedItemsByCategories: ({ __typename: 'ExpertCuratedItemsByCategories' } & Pick<ExpertCuratedItemsByCategories, 'id'> & { categories: Array<({ __typename: 'ExpertCuratedItemsByCategory' } & ExpertCuratedItemByCategoryFragment)> }) }) });

export type SubcategoryInfoFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>);

export type CategoryInfoFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'type' | 'pluralDisplayName'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { communityPoster: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }), children: Array<({ __typename: 'Category' } & SubcategoryInfoFragment)>, parents: Array<({ __typename: 'Category' } & Pick<Category, 'id'> & { children: Array<({ __typename: 'Category' } & SubcategoryInfoFragment)> })>, brands: Array<({ __typename: 'Brand' } & BrandFragment)> });

export type HomeExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName'> & { department: ({ __typename: 'Department' } & Pick<Department, 'id' | 'type'>) });

export type MostRecentLeadFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id'>), expert: ({ __typename: 'BusinessUser' } & HomeExpertFragment) });

export type CurationItemsQueryVariables = {
  leadId: Scalars['LeadId']
};


export type CurationItemsQuery = ({ __typename: 'Query' } & { expertCuratedItemsForLead: ({ __typename: 'ExpertCuratedItemsForLeadPayload' } & { items: Array<({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'>)> }), expertCuratedOrdersForLeadConnection: ({ __typename: 'ExpertCuratedOrdersForLeadConnection' } & { edges: Array<({ __typename: 'ExpertCuratedOrdersForLeadEdge' } & { node: ({ __typename: 'ExpertCuratedOrder' } & Pick<ExpertCuratedOrder, 'id'>) })> }) });

export type DepartmentExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'background' | 'backgroundRichText' | 'headline'> & { gallery: Array<({ __typename: 'MediaFileWithCaption' } & Pick<MediaFileWithCaption, 'caption'> & { mediaFile: ({ __typename: 'MediaFile' } & MediaFileFragment) })>, highlights: Array<({ __typename: 'ProfileHighlight' } & ExpertProfileHighlightsFragment)>, profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, socialMediaLinks: Array<({ __typename: 'SocialMediaLink' } & Pick<SocialMediaLink, 'socialMediaType' | 'url'>)> })>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'acceptingNewRequests' | 'placeholderExpert'>)>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'averageRating' | 'totalMessages' | 'totalReviews' | 'totalLeads'>)>, department: ({ __typename: 'Department' } & Pick<Department, 'id' | 'type'>) });

export type DepartmentLeadFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { curationSummary: ({ __typename: 'CurationSummary' } & Pick<CurationSummary, 'lastCurationSentAt'>), conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'type'>)>, expert: ({ __typename: 'BusinessUser' } & DepartmentExpertFragment) });

export type DepartmentConsumerExpertReviewFragment = ({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id' | 'comments' | 'goodQualities' | 'headline' | 'rating' | 'reviewedAt'> & { consumer: ({ __typename: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>), expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }) });

export type DepartmentSearchFacetSelectionsFragment = ({ __typename: 'FacetSelectionPayload' } & Pick<FacetSelectionPayload, 'name' | 'displayName' | 'bucketValues'>);

export type DepartmentTopLevelCategoryFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { communityPoster: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) });

export type DepartmentInfoQueryVariables = {
  departmentSlug: Scalars['String']
};


export type DepartmentInfoQuery = ({ __typename: 'Query' } & { departmentBySlug: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'displayName'> & { sellableSearchFacets: Array<({ __typename: 'DisplayFacetSelection' } & Pick<DisplayFacetSelection, 'name' | 'displayName'> & { selections: Array<({ __typename: 'FacetSelectionPayload' } & DepartmentSearchFacetSelectionsFragment)> })>, topLevelCategory: ({ __typename: 'Category' } & DepartmentTopLevelCategoryFragment), mostRecentLeadForConsumer: Maybe<({ __typename: 'Lead' } & DepartmentLeadFragment)> } & DepartmentContextFragment)>, recommendedLists: ({ __typename: 'RecommendedListConnection' } & { edges: Array<({ __typename: 'RecommendedListEdge' } & { node: ({ __typename: 'RecommendedList' } & RecommendedListFragment) })> }) });

export type DepartmentSavedSellablesQueryVariables = {
  query: SavedSellableQueryInput
};


export type DepartmentSavedSellablesQuery = ({ __typename: 'Query' } & { savedSellablesConnection: ({ __typename: 'SavedSellablesConnection' } & { edges: Array<({ __typename: 'SavedSellableEdge' } & { node: ({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id'> & { sellable: ({ __typename: 'Sellable' } & SellableCardFragment) }) })> }) });

export type InfiniteScrollSellablesQueryVariables = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>,
  after?: Maybe<Scalars['String']>,
  filters?: Maybe<Array<SellableSearchFilter>>
};


export type InfiniteScrollSellablesQuery = ({ __typename: 'Query' } & { searchSellables: ({ __typename: 'SellableSearchConnection' } & Pick<SellableSearchConnection, 'count'> & { edges: Array<({ __typename: 'SellableSearchEdge' } & Pick<SellableSearchEdge, 'cursor'> & { node: ({ __typename: 'Sellable' } & SellableCardFragment) })>, pageInfo: ({ __typename: 'PageInfo' } & PageInfoFragment) }) });

export type YachtSearchBarFacetsQueryVariables = {};


export type YachtSearchBarFacetsQuery = ({ __typename: 'Query' } & { departmentBySlug: Maybe<({ __typename: 'Department' } & Pick<Department, 'id'> & { sellableSearchFacets: Array<({ __typename: 'DisplayFacetSelection' } & Pick<DisplayFacetSelection, 'name' | 'displayName'> & { selections: Array<({ __typename: 'FacetSelectionPayload' } & Pick<FacetSelectionPayload, 'name' | 'displayName' | 'bucketValues' | 'lower' | 'upper'>)> })> })> });

export type ExpertTopBrandsQueryVariables = {
  query: ExpertTopRecommendedBrandsInput
};


export type ExpertTopBrandsQuery = ({ __typename: 'Query' } & { expertTopRecommendedBrands: ({ __typename: 'ExpertTopRecommendedBrandsPayload' } & { topRecommendedBrands: Array<({ __typename: 'ExpertTopRecommendedBrand' } & { brand: ({ __typename: 'Brand' } & Pick<Brand, 'id' | 'displayName' | 'name'> & { logo: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> }) })> }) });

export type ExpertReviewFragment = ({ __typename: 'ConsumerExpertReview' } & Pick<ConsumerExpertReview, 'id' | 'consumerName' | 'consumerLocation' | 'rating' | 'comments' | 'headline' | 'goodQualities' | 'reviewedAt'>);

export type ExpertProfileBusinessUserFragment = ({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline' | 'background' | 'backgroundRichText' | 'location'> & { highlights: Array<({ __typename: 'ProfileHighlight' } & ExpertProfileHighlightsFragment)>, profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, socialMediaLinks: Array<({ __typename: 'SocialMediaLink' } & Pick<SocialMediaLink, 'socialMediaType' | 'url'>)>, favoriteBrands: Array<({ __typename: 'Brand' } & BrandFragment)>, currentGears: Array<({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'title' | 'friendlyId' | 'slug' | 'type'> & { brand: Maybe<({ __typename: 'Brand' } & Pick<Brand, 'id' | 'displayName'>)>, images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> })> } & ExpertProfilePhotoCarouselFragment);

export type ExpertBusinessUserFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { messagingUser: ({ __typename: 'MessagingUser' } & Pick<MessagingUser, 'id'>), expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert' | 'acceptingNewRequests'> & { categories: Array<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'>)> })>, department: ({ __typename: 'Department' } & { topLevelCategory: ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>) } & DepartmentContextFragment), expertProfile: Maybe<({ __typename: 'ExpertProfile' } & ExpertProfileBusinessUserFragment)>, consumerExpertReviewConnection: ({ __typename: 'ConsumerExpertReviewConnection' } & { edges: Array<({ __typename: 'ConsumerExpertReviewEdge' } & { node: ({ __typename: 'ConsumerExpertReview' } & ExpertReviewFragment) })> }), expertStats: Maybe<({ __typename: 'ExpertStats' } & ExpertStatsFragment)> });

export type GetExpertProfileQueryVariables = {
  vanityIdOrId: Scalars['String']
};


export type GetExpertProfileQuery = ({ __typename: 'Query' } & { findExpert: Maybe<({ __typename: 'BusinessUser' } & ExpertBusinessUserFragment)> });

export type TopRecommendedSellableCategoryFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'pluralDisplayName'>);

export type TopRecommendedSellableFragment = ({ __typename: 'ExpertTopRecommendedSellable' } & Pick<ExpertTopRecommendedSellable, 'timesRecommended'> & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type' | 'title'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)>, brand: Maybe<({ __typename: 'Brand' } & Pick<Brand, 'id' | 'displayName'> & { logo: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }) });

export type ExpertTopSellablesFragment = ({ __typename: 'ExpertCategoryTopRecommendedSellable' } & Pick<ExpertCategoryTopRecommendedSellable, 'displayTitle'> & { category: ({ __typename: 'Category' } & TopRecommendedSellableCategoryFragment), topRecommendedSellables: Array<({ __typename: 'ExpertTopRecommendedSellable' } & TopRecommendedSellableFragment)> });

export type ExpertTopRecommendedSellablesQueryVariables = {
  query: ExpertTopRecommendedSellablesInput
};


export type ExpertTopRecommendedSellablesQuery = ({ __typename: 'Query' } & { expertTopRecommendedSellables: ({ __typename: 'ExpertTopRecommendedSellablesPayload' } & { categoryTopRecommendedSellables: Array<({ __typename: 'ExpertCategoryTopRecommendedSellable' } & ExpertTopSellablesFragment)> }) });

export type ExpertFeedQueryVariables = {
  query: ConsumerReviewSearchQuery,
  after?: Maybe<Scalars['String']>
};


export type ExpertFeedQuery = ({ __typename: 'Query' } & { consumerExpertReviewConnection: ({ __typename: 'ConsumerExpertReviewConnection' } & { pageInfo: ({ __typename: 'PageInfo' } & PageInfoFragment), edges: Array<({ __typename: 'ConsumerExpertReviewEdge' } & Pick<ConsumerExpertReviewEdge, 'cursor'> & { node: ({ __typename: 'ConsumerExpertReview' } & ConsumerExpertReviewFragment) })> }) });

export type ExpertInfoFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> })> });

export type MyCurationsQueryVariables = {
  leadId: Scalars['LeadId']
};


export type MyCurationsQuery = ({ __typename: 'Query' } & { expertCuratedItemsForLead: ({ __typename: 'ExpertCuratedItemsForLeadPayload' } & { items: Array<({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'> & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'title'> & { images: Array<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> }) })> }), lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & ExpertInfoFragment), delegateExpert: Maybe<({ __typename: 'BusinessUser' } & ExpertInfoFragment)>, category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { bannerImages: Array<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })> }), expertCuratedOrdersForLeadConnection: ({ __typename: 'ExpertCuratedOrdersForLeadConnection' } & { edges: Array<({ __typename: 'ExpertCuratedOrdersForLeadEdge' } & { node: ({ __typename: 'ExpertCuratedOrder' } & Pick<ExpertCuratedOrder, 'id' | 'serviceStartAt'> & { serviceLocation: Maybe<({ __typename: 'PostalAddress' } & Pick<PostalAddress, 'city' | 'state'>)>, order: ({ __typename: 'Order' } & Pick<Order, 'id' | 'title'> & { primaryImage: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> }) }) })> }) });

export type MyFavoritesQueryVariables = {};


export type MyFavoritesQuery = ({ __typename: 'Query' } & { savedSellablesConnection: ({ __typename: 'SavedSellablesConnection' } & { edges: Array<({ __typename: 'SavedSellableEdge' } & { node: ({ __typename: 'SavedSellable' } & Pick<SavedSellable, 'id' | 'saved' | 'savedReason'> & { sellable: ({ __typename: 'Sellable' } & SellableCardFragment) }) })> }) });

export type LatestLeadQueryVariables = {};


export type LatestLeadQuery = ({ __typename: 'Query' } & { me: Maybe<({ __typename: 'Myself' } & Pick<Myself, 'id'> & { user: ({ __typename: 'User' } & Pick<User, 'id'> & { mostRecentLead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'slug'>)> })> }) })> });

export type LoggedOutHomeExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline' | 'background'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & ExpertStatsFragment)> });

export type LoggedOutHomeExpertsQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type LoggedOutHomeExpertsQuery = ({ __typename: 'Query' } & { recommendExpertsForDepartment: Array<({ __typename: 'RecommendedExpert' } & { expert: ({ __typename: 'BusinessUser' } & LoggedOutHomeExpertFragment) })> });

export type LoggedOutHomeFixedExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline' | 'background'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & ExpertStatsFragment)> });

export type LoggedOutHomeFixedExpertsQueryVariables = {
  ids: Array<Scalars['BusinessUserId']>
};


export type LoggedOutHomeFixedExpertsQuery = ({ __typename: 'Query' } & { businessUsers: Array<Maybe<({ __typename: 'BusinessUser' } & LoggedOutHomeFixedExpertFragment)>> });

export type LoggedOutHomeDepartmentFragment = ({ __typename: 'Department' } & Pick<Department, 'id' | 'slug' | 'type' | 'displayName' | 'acceptingRequests' | 'launched'> & { topLevelCategories: Array<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> });

export type LoggedOutHomeDepartmentsQueryVariables = {};


export type LoggedOutHomeDepartmentsQuery = ({ __typename: 'Query' } & { departmentsForNavigation: Array<({ __typename: 'Department' } & LoggedOutHomeDepartmentFragment)> });

export type LeadOverviewFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>), offers: Array<({ __typename: 'BroadcastOffer' } & Pick<BroadcastOffer, 'id' | 'state'>)> });

export type LeadsQueryVariables = {
  consumerId: Scalars['UserId'],
  after?: Maybe<Scalars['String']>
};


export type LeadsQuery = ({ __typename: 'Query' } & { leads: ({ __typename: 'LeadSearchConnection' } & { edges: Array<({ __typename: 'LeadSearchEdge' } & { node: ({ __typename: 'Lead' } & LeadOverviewFragment) })> }) });

export type SupportConversationFragment = ({ __typename: 'SupportConversation' } & Pick<SupportConversation, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) });

export type SupportConversationQueryVariables = {
  consumerId: Scalars['UserId']
};


export type SupportConversationQuery = ({ __typename: 'Query' } & { supportConversation: Maybe<({ __typename: 'SupportConversation' } & SupportConversationFragment)> });

export type ExpertByLeadQueryVariables = {
  leadId: Scalars['LeadId']
};


export type ExpertByLeadQuery = ({ __typename: 'Query' } & { lead: ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { latestRequest: Maybe<({ __typename: 'DealRequest' } & Pick<DealRequest, 'id'> & { attributes: Array<({ __typename: 'Attribute' } & { formatted: Maybe<({ __typename: 'FormattedAttribute' } & Pick<FormattedAttribute, 'displayHtml'>)> })> })>, department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'type'>)>, conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id'>), expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>)>, expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'averageRating' | 'totalReviews' | 'totalMessages'>)> }), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'singularDisplayName'> & { department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'slug'>)>, contentAssets: ({ __typename: 'CategoryContentAssets' } & { modalHeader: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)>, fullPageTakeover: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) })> }) });

export type SetConsumerInitialLeadActionMutationVariables = {
  leadId: Scalars['LeadId'],
  action: ConsumerInitialLeadAction
};


export type SetConsumerInitialLeadActionMutation = ({ __typename: 'Mutation' } & { setConsumerInitialLeadAction: ({ __typename: 'SetConsumerInitialLeadActionPayload' } & { lead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>), category: Maybe<({ __typename: 'Category' } & Pick<Category, 'id' | 'slug'>)> })> }) });

export type LeadExpertProfileExpertProfileFragment = ({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline' | 'background' | 'quotes'> & { socialMediaLinks: Array<({ __typename: 'SocialMediaLink' } & Pick<SocialMediaLink, 'socialMediaType' | 'url'>)>, highlights: Array<({ __typename: 'ProfileHighlight' } & Pick<ProfileHighlight, 'value' | 'secondaryValue'> & { type: ({ __typename: 'ProfileHighlightType' } & Pick<ProfileHighlightType, 'id' | 'icon' | 'displayName'>) })>, profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> });

export type LeadExpertProfileExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & LeadExpertProfileExpertProfileFragment)>, expertStats: Maybe<({ __typename: 'ExpertStats' } & ExpertStatsFragment)> });

export type LeadExpertProfileFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & LeadExpertProfileExpertFragment), consumerConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>), expertConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>) });

export type ConversationExpertProfileQueryVariables = {
  id: Scalars['LeadId']
};


export type ConversationExpertProfileQuery = ({ __typename: 'Query' } & { lead: ({ __typename: 'Lead' } & LeadExpertProfileFragment), expertCuratedItemsForLead: ({ __typename: 'ExpertCuratedItemsForLeadPayload' } & { items: Array<({ __typename: 'ExpertCuratedItem' } & Pick<ExpertCuratedItem, 'id'>)> }) });

export type ConversationExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, highlights: Array<({ __typename: 'ProfileHighlight' } & Pick<ProfileHighlight, 'value' | 'secondaryValue'> & { type: ({ __typename: 'ProfileHighlightType' } & Pick<ProfileHighlightType, 'id' | 'icon'>) })> })>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>)>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'totalMessages' | 'totalReviews'>)> });

export type ConversationWithMetaDataFragment = ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId' | 'title' | 'active'> & { lead: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id' | 'consumerInitialAction'> & { expert: ({ __typename: 'BusinessUser' } & ConversationExpertFragment), consumerConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>), expertConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>), dealbotConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>) })> });

export type ConversationQueryVariables = {
  id: Scalars['ConversationId']
};


export type ConversationQuery = ({ __typename: 'Query' } & { conversation: ({ __typename: 'Conversation' } & ConversationWithMetaDataFragment) });

export type DepartmentSlugByCategorySlugQueryVariables = {
  categorySlug: Scalars['String']
};


export type DepartmentSlugByCategorySlugQuery = ({ __typename: 'Query' } & { categoryBySlug: Maybe<({ __typename: 'Category' } & { department: Maybe<({ __typename: 'Department' } & Pick<Department, 'id' | 'type' | 'slug'>)> })> });

export type ExpertDepartmentBySlugQueryVariables = {
  slug: Scalars['String']
};


export type ExpertDepartmentBySlugQuery = ({ __typename: 'Query' } & { departmentBySlug: Maybe<({ __typename: 'Department' } & Pick<Department, 'id'> & { topLevelCategory: ({ __typename: 'Category' } & Pick<Category, 'id'>) })> });

export type FeaturedExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { department: ({ __typename: 'Department' } & Pick<Department, 'id' | 'type'> & { topLevelCategory: ({ __typename: 'Category' } & Pick<Category, 'id' | 'singularDisplayName' | 'pluralDisplayName'>) }), expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'location' | 'background' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)>, highlights: Array<({ __typename: 'ProfileHighlight' } & ExpertProfileHighlightsFragment)> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'averageRating' | 'totalLeads' | 'totalReviews'>)> });

export type FeaturedExpertsForDepartmentQueryVariables = {
  query: ExpertSearchQuery,
  after?: Maybe<Scalars['String']>
};


export type FeaturedExpertsForDepartmentQuery = ({ __typename: 'Query' } & { expertSearchConnection: ({ __typename: 'ExpertSearchConnection' } & Pick<ExpertSearchConnection, 'count'> & { pageInfo: ({ __typename: 'PageInfo' } & PageInfoFragment), edges: Array<({ __typename: 'ExpertSearchEdge' } & Pick<ExpertSearchEdge, 'cursor'> & { node: ({ __typename: 'BusinessUser' } & FeaturedExpertFragment) })> }) });

export type InitiateAffirmPaymentForOrderMutationVariables = {
  input: InitiateAffirmPaymentForOrderInput
};


export type InitiateAffirmPaymentForOrderMutation = ({ __typename: 'Mutation' } & { initiateAffirmPaymentForOrder: ({ __typename: 'InitiateAffirmPaymentForOrderPayload' } & Pick<InitiateAffirmPaymentForOrderPayload, 'checkoutData'> & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type InitiateAfterpayPaymentForOrderMutationVariables = {
  input: InitiateAfterpayPaymentForOrderInput
};


export type InitiateAfterpayPaymentForOrderMutation = ({ __typename: 'Mutation' } & { initiateAfterpayPaymentForOrder: ({ __typename: 'InitiateAfterpayPaymentForOrderPayload' } & Pick<InitiateAfterpayPaymentForOrderPayload, 'orderToken'> & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type SyncOrderMutationVariables = {
  input: SyncOrderInput
};


export type SyncOrderMutation = ({ __typename: 'Mutation' } & { syncOrder: ({ __typename: 'SyncOrderPayload' } & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type GetOrderQueryVariables = {
  id: Scalars['OrderId']
};


export type GetOrderQuery = ({ __typename: 'Query' } & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) });

export type PaymentSourceForReviewQueryVariables = {
  id: Scalars['PaymentSourceId']
};


export type PaymentSourceForReviewQuery = ({ __typename: 'Query' } & { paymentSource: ({ __typename: 'AffirmPaymentSource' | 'AfterpayPaymentSource' | 'PaypalPaymentSource' | 'StripePaymentSource' } & PaymentSourceFragment) });

export type InitiatePaypalPaymentForOrderMutationVariables = {
  input: InitiatePaypalPaymentForOrderInput
};


export type InitiatePaypalPaymentForOrderMutation = ({ __typename: 'Mutation' } & { initiatePaypalPaymentForOrder: ({ __typename: 'InitiatePaypalPaymentForOrderPayload' } & Pick<InitiatePaypalPaymentForOrderPayload, 'paymentId' | 'authorizationUrl'> & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type AddPromotionToOrderMutationVariables = {
  id: Scalars['OrderId'],
  promotionCode: Scalars['String']
};


export type AddPromotionToOrderMutation = ({ __typename: 'Mutation' } & { addPromotionToOrder: ({ __typename: 'AddPromotionToOrderPayload' } & Pick<AddPromotionToOrderPayload, 'hasError' | 'errorMessage'> & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type DeletePaymentSourceMutationVariables = {
  id: Scalars['PaymentSourceId']
};


export type DeletePaymentSourceMutation = ({ __typename: 'Mutation' } & { deletePaymentSource: ({ __typename: 'DeletePaymentSourcePayload' } & Pick<DeletePaymentSourcePayload, 'error' | 'success'>) });

export type UpdateAddressPreferencesMutationVariables = {
  input: UpdateAddressPreferencesInput
};


export type UpdateAddressPreferencesMutation = ({ __typename: 'Mutation' } & { updateAddressPreferences: ({ __typename: 'UpdateAddressPreferencesPayload' } & Pick<UpdateAddressPreferencesPayload, 'error'> & { updatedAddress: Maybe<({ __typename: 'Address' } & AddressFragment)> }) });

export type UpdateOrderShippingAddressMutationVariables = {
  input: UpdateOrderShippingAddressInput
};


export type UpdateOrderShippingAddressMutation = ({ __typename: 'Mutation' } & { updateOrderShippingAddress: ({ __typename: 'UpdateOrderShippingAddressPayload' } & Pick<UpdateOrderShippingAddressPayload, 'hasError' | 'errorMessage'> & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type ShippingMethodCostFragment = ({ __typename: 'ShippingMethodCost' } & Pick<ShippingMethodCost, 'shippingMethod' | 'estimatedToArriveAt'> & { cost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) });

export type OrderShippingCostQueryVariables = {
  id: Scalars['OrderId'],
  orderShippingCostAddress?: Maybe<OrderShippingCostAddressInput>
};


export type OrderShippingCostQuery = ({ __typename: 'Query' } & { orderShippingCost: Maybe<({ __typename: 'OrderShippingCost' } & { shippingMethodCosts: Array<({ __typename: 'ShippingMethodCost' } & ShippingMethodCostFragment)> })> });

export type UpdateShippingMethodMutationVariables = {
  orderId: Scalars['OrderId'],
  shippingMethod: ShippingMethod
};


export type UpdateShippingMethodMutation = ({ __typename: 'Mutation' } & { updateShippingMethod: ({ __typename: 'UpdateShippingMethodPayload' } & { order: ({ __typename: 'Order' } & Pick<Order, 'id' | 'shippingMethod'> & { lineItems: Array<({ __typename: 'OrderLineItem' } & OrderLineItemFragment)>, totalShippingCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) }) }) });

export type ReusablePaymentSourcesQueryVariables = {};


export type ReusablePaymentSourcesQuery = ({ __typename: 'Query' } & { reusablePaymentSources: Array<({ __typename: 'AffirmPaymentSource' | 'AfterpayPaymentSource' | 'PaypalPaymentSource' | 'StripePaymentSource' } & PaymentSourceFragment)> });

export type InitiateWireTransferForOrderMutationVariables = {
  input: InitiateWireTransferPaymentForOrderInput
};


export type InitiateWireTransferForOrderMutation = ({ __typename: 'Mutation' } & { initiateWireTransferPaymentForOrder: ({ __typename: 'InitiateWireTransferPaymentForOrderPayload' } & { paymentSource: ({ __typename: 'AffirmPaymentSource' | 'AfterpayPaymentSource' | 'PaypalPaymentSource' | 'StripePaymentSource' } & Pick<PaymentSource, 'id'>) }) });

export type SubmitWireOrderMutationVariables = {
  input: SubmitOrderInput
};


export type SubmitWireOrderMutation = ({ __typename: 'Mutation' } & { submitOrder: ({ __typename: 'SubmitOrderPayload' } & { order: ({ __typename: 'Order' } & TrackableOrderFragment) }) });

export type AddTipToOrderMutationVariables = {
  input: AddTipToOrderInput
};


export type AddTipToOrderMutation = ({ __typename: 'Mutation' } & { addTipToOrder: ({ __typename: 'AddTipToOrderPayload' } & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type TipContainerOrderFragment = ({ __typename: 'Order' } & Pick<Order, 'id'> & { tip: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, associatedLeads: Array<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName'>), expertConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'initialSentAt' | 'messageCount'>), consumerConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>) })>, lineItems: Array<({ __typename: 'OrderLineItem' } & Pick<OrderLineItem, 'id'> & { source: ({ __typename: 'OrderLineItemAdHocSource' | 'OrderLineItemBasePriceSource' | 'OrderLineItemExpertTipSource' | 'OrderLineItemGratuitySource' | 'OrderLineItemSellableSource' | 'OrderLineItemShipmentSource' } & Pick<OrderLineItemSource, 'type'> & ({ __typename: 'OrderLineItemSellableSource' } & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'type'> & { originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> }) })) })>, subtotal: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment) });

export type ExpertTipPercentageFragment = ({ __typename: 'ExpertTipPercentage' } & Pick<ExpertTipPercentage, 'percentOfTip'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }) });

export type RecommendTipPercentagesForOrderQueryVariables = {
  id: Scalars['OrderId']
};


export type RecommendTipPercentagesForOrderQuery = ({ __typename: 'Query' } & { recommendTipPercentagesForOrder: Array<({ __typename: 'ExpertTipPercentage' } & ExpertTipPercentageFragment)> });

export type OrderSellableInfoFragment = ({ __typename: 'OrderLineItemSellableSource' } & { sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'title'> & { images: Array<({ __typename: 'MediaFile' } & Pick<MediaFile, 'url'>)>, originalPrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, salePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> }), overridePrice: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)> });

export type OrderWithLineItemsFragment = ({ __typename: 'Order' } & Pick<Order, 'estimatedToArriveAt' | 'shippingMethod' | 'consumerFriendlyId' | 'depositPaidAt' | 'fullPaymentDueAt' | 'paidInFullAt'> & { appliedPromotionEntry: Maybe<({ __typename: 'OrderPromotionEntry' } & Pick<OrderPromotionEntry, 'applied'> & { discount: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), promotion: ({ __typename: 'Promotion' } & Pick<Promotion, 'id' | 'code'>) })>, promotionEntries: Array<({ __typename: 'OrderPromotionEntry' } & Pick<OrderPromotionEntry, 'applied'> & { discount: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), promotion: ({ __typename: 'Promotion' } & Pick<Promotion, 'id' | 'code'>) })>, chargeableStatus: ({ __typename: 'OrderChargeableStatus' } & Pick<OrderChargeableStatus, 'type' | 'message'>), associatedLeads: Array<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName'> & { expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>)> }), expertConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'initialSentAt' | 'messageCount'>), consumerConversationMetrics: ({ __typename: 'ConversationMetrics' } & Pick<ConversationMetrics, 'messageCount'>) })>, remainingBalance: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), minimumDeposit: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, paidAmount: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), lineItems: Array<({ __typename: 'OrderLineItem' } & OrderLineItemFragment)>, serviceLocation: Maybe<({ __typename: 'PostalAddress' } & Pick<PostalAddress, 'displayTitle'>)>, simpleCuratedOrder: Maybe<({ __typename: 'SimpleCuratedOrder' } & Pick<SimpleCuratedOrder, 'id' | 'type'>)> } & (OrderFragment & TrackableOrderFragment & TipContainerOrderFragment));

export type TrackableOrderFragment = ({ __typename: 'Order' } & Pick<Order, 'id' | 'state'> & { tax: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), tip: Maybe<({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment)>, totalCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), totalShippingCost: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), subtotal: ({ __typename: 'MonetaryAmount' } & MonetaryAmountFragment), appliedPromotionEntry: Maybe<({ __typename: 'OrderPromotionEntry' } & { promotion: ({ __typename: 'Promotion' } & Pick<Promotion, 'id' | 'code'>) })>, lineItems: Array<({ __typename: 'OrderLineItem' } & Pick<OrderLineItem, 'id' | 'quantity'> & { source: ({ __typename: 'OrderLineItemAdHocSource' | 'OrderLineItemBasePriceSource' | 'OrderLineItemExpertTipSource' | 'OrderLineItemGratuitySource' | 'OrderLineItemSellableSource' | 'OrderLineItemShipmentSource' } & ({ __typename: 'OrderLineItemSellableSource' } & { sellable: ({ __typename: 'Sellable' } & TrackableSellableFragment) })) })> });

export type CancelPaymentRequestForOrderMutationVariables = {
  input: CancelPaymentRequestForOrderInput
};


export type CancelPaymentRequestForOrderMutation = ({ __typename: 'Mutation' } & { cancelPaymentRequestForOrder: ({ __typename: 'CancelPaymentRequestForOrderPayload' } & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type DeleteAddressMutationVariables = {
  input: DeleteAddressInput
};


export type DeleteAddressMutation = ({ __typename: 'Mutation' } & { deleteAddress: ({ __typename: 'DeleteAddressPayload' } & Pick<DeleteAddressPayload, 'error' | 'success'>) });

export type MarkPaymentPreApprovalFailedForOrderMutationVariables = {
  input: MarkPaymentPreApprovalFailedForOrderInput
};


export type MarkPaymentPreApprovalFailedForOrderMutation = ({ __typename: 'Mutation' } & { markPaymentPreApprovalFailedForOrder: ({ __typename: 'MarkPaymentPreApprovalFailedForOrderPayload' } & { order: ({ __typename: 'Order' } & OrderWithLineItemsFragment) }) });

export type PayForOrderMutationVariables = {
  input: PayForOrderInput
};


export type PayForOrderMutation = ({ __typename: 'Mutation' } & { payForOrder: ({ __typename: 'PayForOrderPayload' } & Pick<PayForOrderPayload, 'error'> & { order: Maybe<({ __typename: 'Order' } & OrderWithLineItemsFragment)> }) });

export type DiamondCertificateUrlQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type DiamondCertificateUrlQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'certificateUrl'>)> });

export type ExpertCuratedItemNoteFragment = ({ __typename: 'ExpertCuratedItemNote' } & Pick<ExpertCuratedItemNote, 'id' | 'text' | 'useCount'> & { createdBy: ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName' | 'vanityId'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> }), sellable: ({ __typename: 'Sellable' } & Pick<Sellable, 'id'> & { categories: Array<({ __typename: 'Category' } & Pick<Category, 'id' | 'singularDisplayName'>)> }) });

export type ExpertSellableNotesQueryVariables = {
  query: SuggestExpertCuratedItemNotesQueryInput
};


export type ExpertSellableNotesQuery = ({ __typename: 'Query' } & { suggestExpertCuratedItemNotes: ({ __typename: 'SuggestExpertCuratedItemNotesConnection' } & { edges: Array<({ __typename: 'SuggestExpertCuratedItemNotesEdge' } & { node: ({ __typename: 'ExpertCuratedItemNote' } & ExpertCuratedItemNoteFragment) })> }) });

export type RecommendedProductsByCategoryQueryVariables = {
  query: RecommendedListsQuery
};


export type RecommendedProductsByCategoryQuery = ({ __typename: 'Query' } & { recommendedLists: ({ __typename: 'RecommendedListConnection' } & { edges: Array<({ __typename: 'RecommendedListEdge' } & Pick<RecommendedListEdge, 'cursor'> & { node: ({ __typename: 'RecommendedList' } & Pick<RecommendedList, 'displayName'> & { recommendedListDefinition: Maybe<({ __typename: 'RecommendedListDefinition' } & Pick<RecommendedListDefinition, 'id' | 'rank'>)>, sellables: Array<({ __typename: 'Sellable' } & SellableCardFragment)> }) })> }) });

export type Diamond360VideoQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type Diamond360VideoQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'dynamic360ViewUrl'>)> });

export type ProductByFriendlyIdOrIdQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type ProductByFriendlyIdOrIdQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & SellableDetailsFragment)> });

export type ExistingLeadFragment = ({ __typename: 'Lead' } & Pick<Lead, 'id'> & { conversation: ({ __typename: 'Conversation' } & Pick<Conversation, 'id' | 'externalId'>) });

export type ProductExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'vanityId' | 'firstName' | 'lastName'> & { expertStats: Maybe<({ __typename: 'ExpertStats' } & ExpertStatsFragment)>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert'>)>, expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'headline'> & { highlights: Array<({ __typename: 'ProfileHighlight' } & ExpertProfileHighlightsFragment)>, profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })> });

export type ProductRecommendedExpertFragment = ({ __typename: 'RecommendExpertPayload' } & { existingLead: Maybe<({ __typename: 'Lead' } & ExistingLeadFragment)>, expert: Maybe<({ __typename: 'BusinessUser' } & ProductExpertFragment)> });

export type ProductExpertQueryVariables = {
  consumerId: Scalars['UserId'],
  categoryId: Scalars['CategoryId']
};


export type ProductExpertQuery = ({ __typename: 'Query' } & { recommendExpert2: ({ __typename: 'RecommendExpertPayload' } & ProductRecommendedExpertFragment) });

export type GlobalStatsFragment = ({ __typename: 'GlobalStatsAggregateExpertReport' } & Pick<GlobalStatsAggregateExpertReport, 'conversationsCountThisWeek' | 'conversationsCountTotal' | 'curationsCountTotal' | 'curationsCountThisWeek' | 'reviewsCount' | 'averageExpertRating'>);

export type CommunityAggregateStatsQueryVariables = {};


export type CommunityAggregateStatsQuery = ({ __typename: 'Query' } & { aggregateExpertReport: ({ __typename: 'AggregateExpertReport' } & { globalStats: ({ __typename: 'GlobalStatsAggregateExpertReport' } & GlobalStatsFragment) }) });

export type TopLevelCategoryFragment = ({ __typename: 'Category' } & Pick<Category, 'id' | 'slug' | 'pluralDisplayName'> & { contentAssets: ({ __typename: 'CategoryContentAssets' } & { communityPoster: Maybe<({ __typename: 'ContentAsset' } & Pick<ContentAsset, 'imageUrl'>)> }) });

export type CommunityLeadExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'background' | 'headline'> & { socialMediaLinks: Array<({ __typename: 'SocialMediaLink' } & Pick<SocialMediaLink, 'socialMediaType' | 'url'>)>, highlights: Array<({ __typename: 'ProfileHighlight' } & ExpertProfileHighlightsFragment)>, profilePhoto: Maybe<({ __typename: 'MediaFile' } & Pick<MediaFile, 'id' | 'url'>)> } & ExpertProfilePhotoCarouselFragment)>, expertAttributes: Maybe<({ __typename: 'BusinessUserExpertAttributes' } & Pick<BusinessUserExpertAttributes, 'placeholderExpert' | 'acceptingNewRequests'>)>, expertStats: Maybe<({ __typename: 'ExpertStats' } & Pick<ExpertStats, 'totalReviews' | 'totalLeads' | 'averageRating'>)>, department: ({ __typename: 'Department' } & Pick<Department, 'id' | 'type'>) });

export type DepartmentBySlugQueryVariables = {
  slug: Scalars['String']
};


export type DepartmentBySlugQuery = ({ __typename: 'Query' } & { departmentBySlug: Maybe<({ __typename: 'Department' } & { mostRecentLeadForConsumer: Maybe<({ __typename: 'Lead' } & Pick<Lead, 'id'> & { expert: ({ __typename: 'BusinessUser' } & CommunityLeadExpertFragment) })>, topLevelCategories: Array<({ __typename: 'Category' } & TopLevelCategoryFragment)> } & DepartmentContextFragment)> });

export type ReviewSummaryBucketsFragment = ({ __typename: 'BucketedDisplayFacet' } & { buckets: Array<({ __typename: 'IndividualBucketedDisplayFacet' } & Pick<IndividualBucketedDisplayFacet, 'count' | 'value'>)> });

export type DepartmentCuratedActivityFeedQueryVariables = {
  query: ConsumerReviewSearchQuery,
  after?: Maybe<Scalars['String']>,
  sortBy: ConsumerReviewSearchSort
};


export type DepartmentCuratedActivityFeedQuery = ({ __typename: 'Query' } & { consumerExpertReviewConnection: ({ __typename: 'ConsumerExpertReviewConnection' } & Pick<ConsumerExpertReviewConnection, 'count'> & { pageInfo: ({ __typename: 'PageInfo' } & PageInfoFragment), facets: Array<({ __typename: 'BucketedDisplayFacet' | 'BucketedRangeDisplayFacet' | 'NumericRangeDisplayFacet' } & Pick<DisplayFacet, 'displayName' | 'alias' | 'name'> & ({ __typename: 'BucketedDisplayFacet' } & ReviewSummaryBucketsFragment))>, edges: Array<({ __typename: 'ConsumerExpertReviewEdge' } & Pick<ConsumerExpertReviewEdge, 'cursor'> & { node: ({ __typename: 'ConsumerExpertReview' } & ConsumerExpertReviewFragment) })> }) });

export type SellableByIdQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableByIdQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'friendlyId' | 'slug' | 'type'>)> });

export type OrderEscalationSummaryFragment = ({ __typename: 'OrderEscalation' } & Pick<OrderEscalation, 'id' | 'consumerFriendlyId' | 'createdAt' | 'type' | 'status'> & { assignedTo: Maybe<({ __typename: 'Operator' } & Pick<Operator, 'id' | 'firstName'>)> });

export type OrderEscalationSearchResultFragment = ({ __typename: 'OrderEscalationEdge' } & Pick<OrderEscalationEdge, 'cursor'> & { node: ({ __typename: 'OrderEscalation' } & OrderEscalationSummaryFragment) });

export type SearchOrderEscalationsQueryVariables = {
  pageSize: Maybe<Scalars['Int']>,
  userIds?: Maybe<Array<Scalars['UserId']>>
};


export type SearchOrderEscalationsQuery = ({ __typename: 'Query' } & { orderEscalations: ({ __typename: 'OrderEscalationConnection' } & { edges: Array<({ __typename: 'OrderEscalationEdge' } & OrderEscalationSearchResultFragment)> }) });

export type SellableDetailsForExpertItemQueryVariables = {
  friendlyIdOrId: Scalars['String']
};


export type SellableDetailsForExpertItemQuery = ({ __typename: 'Query' } & { findSellable: Maybe<({ __typename: 'Sellable' } & Pick<Sellable, 'id' | 'title'> & { images: Array<({ __typename: 'MediaFile' } & MediaFileFragment)> } & SellablePricingFragment)> });

export type TopicPageExpertFragment = ({ __typename: 'BusinessUser' } & Pick<BusinessUser, 'id' | 'firstName' | 'lastName'> & { expertProfile: Maybe<({ __typename: 'ExpertProfile' } & Pick<ExpertProfile, 'id' | 'location'> & { profilePhoto: Maybe<({ __typename: 'MediaFile' } & MediaFileFragment)> })>, expertStats: Maybe<({ __typename: 'ExpertStats' } & ExpertStatsFragment)> });

export type TopicExpertsQueryVariables = {
  departmentId: Scalars['DepartmentId']
};


export type TopicExpertsQuery = ({ __typename: 'Query' } & { recommendExpertsForDepartment: Array<({ __typename: 'RecommendedExpert' } & { expert: ({ __typename: 'BusinessUser' } & TopicPageExpertFragment) })> });

export type GetSessionIdQueryVariables = {};


export type GetSessionIdQuery = ({ __typename: 'Query' } & { session: ({ __typename: 'Session' } & Pick<Session, 'id'>) });
export const MediaFileFragmentDoc = gql`
    fragment MediaFile on MediaFile {
  id
  url
  mimeType
  size
  persisted
}
    `;
export const MonetaryAmountFragmentDoc = gql`
    fragment MonetaryAmount on MonetaryAmount {
  currency
  amount
  amountInSmallestDenomination: amount(denominationType: SMALLEST)
}
    `;
export const SellablePricingFragmentDoc = gql`
    fragment SellablePricing on Sellable {
  id
  salePrice {
    ...MonetaryAmount
  }
  originalPrice {
    ...MonetaryAmount
  }
  variationMatrix {
    defaultVariant {
      id
      salePrice {
        ...MonetaryAmount
      }
      originalPrice {
        ...MonetaryAmount
      }
    }
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const ActivityFeedSellableFragmentDoc = gql`
    fragment ActivityFeedSellable on Sellable {
  id
  friendlyId
  slug
  type
  title
  ...SellablePricing
  images {
    ...MediaFile
  }
}
    ${SellablePricingFragmentDoc}
${MediaFileFragmentDoc}`;
export const ConsumerExpertReviewFragmentDoc = gql`
    fragment ConsumerExpertReview on ConsumerExpertReview {
  id
  reviewedAt
  rating
  headline
  comments
  consumerName
  expert {
    id
    vanityId
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    expertAttributes {
      acceptingNewRequests
    }
    firstName
    lastName
  }
  verifiedPurchases {
    ...ActivityFeedSellable
  }
}
    ${MediaFileFragmentDoc}
${ActivityFeedSellableFragmentDoc}`;
export const AirportTypeaheadResultFragmentDoc = gql`
    fragment AirportTypeaheadResult on AirportTypeaheadHit {
  id
  name
}
    `;
export const HeroExpertCuratedItemByCategoryFragmentDoc = gql`
    fragment HeroExpertCuratedItemByCategory on ExpertCuratedItemsByCategory {
  category {
    id
    singularDisplayName
  }
  items {
    id
    note {
      id
    }
  }
}
    `;
export const HeroCuratedExpertFragmentDoc = gql`
    fragment HeroCuratedExpert on BusinessUser {
  id
  vanityId
  firstName
  lastName
  expertAttributes {
    placeholderExpert
  }
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const HeroCuratedItemsLeadFragmentDoc = gql`
    fragment HeroCuratedItemsLead on Lead {
  id
  conversation {
    id
  }
  expert {
    ...HeroCuratedExpert
  }
  consumerConversationMetrics {
    messageCount
  }
  expertConversationMetrics {
    messageCount
  }
  category {
    id
    slug
    type
  }
}
    ${HeroCuratedExpertFragmentDoc}`;
export const HeroExpertCuratedItemImageFragmentDoc = gql`
    fragment HeroExpertCuratedItemImage on ExpertCuratedItem {
  id
  sellable {
    id
    title
    images {
      id
      url
    }
  }
}
    `;
export const DepartmentExpertReviewFragmentDoc = gql`
    fragment DepartmentExpertReview on ConsumerExpertReview {
  id
  comments
  goodQualities
  headline
  rating
  consumer {
    id
    firstName
    lastName
  }
  expert {
    id
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    firstName
    lastName
  }
  reviewedAt
}
    ${MediaFileFragmentDoc}`;
export const PathCategoryFragmentDoc = gql`
    fragment PathCategory on Category {
  id
  slug
  parents {
    id
    slug
  }
}
    `;
export const EngagementChannelCategoryFragmentDoc = gql`
    fragment EngagementChannelCategory on Category {
  id
  slug
  department {
    id
    type
    acceptingRequests
    launched
  }
  contentAssets {
    fixedBarDesktop {
      imageUrl
    }
    callout {
      imageUrl
    }
    fullPageTakeover {
      imageUrl
    }
  }
  ancestorWithPath {
    id
    slug
  }
  ...PathCategory
}
    ${PathCategoryFragmentDoc}`;
export const CategoryModalFragmentDoc = gql`
    fragment CategoryModal on Category {
  id
  slug
  pluralDisplayName
  singularDisplayName
  ancestorWithPath {
    id
    slug
  }
}
    `;
export const SellableForModalFragmentDoc = gql`
    fragment SellableForModal on Sellable {
  id
  title
  images {
    ...MediaFile
  }
  ...SellablePricing
}
    ${MediaFileFragmentDoc}
${SellablePricingFragmentDoc}`;
export const VariationMatrixVectorFragmentDoc = gql`
    fragment VariationMatrixVector on VariationMatrixVector {
  value
  displayValueHtml
  sellableIds
}
    `;
export const VariationMatrixDimensionFragmentDoc = gql`
    fragment VariationMatrixDimension on VariationMatrixDimension {
  name
  displayName
  vectors {
    ...VariationMatrixVector
  }
}
    ${VariationMatrixVectorFragmentDoc}`;
export const VariationMatrixFragmentDoc = gql`
    fragment VariationMatrix on VariationMatrix {
  dimensions {
    ...VariationMatrixDimension
  }
  sellables {
    id
    friendlyId
    slug
    type
  }
  defaultVariant {
    id
    friendlyId
    slug
    type
    salePrice {
      ...MonetaryAmount
    }
    originalPrice {
      ...MonetaryAmount
    }
    images {
      ...MediaFile
    }
  }
  priceRange {
    min {
      ...MonetaryAmount
    }
    max {
      ...MonetaryAmount
    }
  }
  maximumSavingsAmount {
    ...MonetaryAmount
  }
  maximumSavingsPercent
  outOfStockSellables {
    id
  }
}
    ${VariationMatrixDimensionFragmentDoc}
${MonetaryAmountFragmentDoc}
${MediaFileFragmentDoc}`;
export const DurationSelectorFragmentDoc = gql`
    fragment DurationSelector on Sellable {
  id
  originalPrice {
    ...MonetaryAmount
  }
  salePrice {
    ...MonetaryAmount
  }
  variants {
    value
  }
  variationMatrix {
    ...VariationMatrix
  }
}
    ${MonetaryAmountFragmentDoc}
${VariationMatrixFragmentDoc}`;
export const ExperienceAttributeFragmentDoc = gql`
    fragment ExperienceAttribute on Attribute {
  formatted {
    name
    displayHtml
  }
}
    `;
export const BrandFragmentDoc = gql`
    fragment Brand on Brand {
  id
  name
  displayName
  logo {
    ...MediaFile
  }
}
    ${MediaFileFragmentDoc}`;
export const DepartmentContextFragmentDoc = gql`
    fragment DepartmentContext on Department {
  id
  type
  slug
  displayName
  acceptingRequests
  launched
  topLevelCategory {
    id
    slug
    type
  }
}
    `;
export const ParentCategoryDataFragmentDoc = gql`
    fragment ParentCategoryData on Category {
  id
  slug
  pluralDisplayName
  department {
    ...DepartmentContext
  }
}
    ${DepartmentContextFragmentDoc}`;
export const CategoryDataFragmentDoc = gql`
    fragment CategoryData on Category {
  id
  name
  pluralDisplayName
  singularDisplayName
  slug
  faqSlug
  type
  department {
    ...DepartmentContext
  }
  parents {
    ...ParentCategoryData
  }
  contentAssets {
    bannerImages {
      imageUrl
    }
  }
}
    ${DepartmentContextFragmentDoc}
${ParentCategoryDataFragmentDoc}`;
export const TrackableSellableFragmentDoc = gql`
    fragment TrackableSellable on Sellable {
  id
  friendlyId
  slug
  type
  googleId
  title
  feedId
  variant
  feedId
  department {
    id
    topLevelCategory {
      id
      slug
    }
  }
  brand {
    ...Brand
  }
  images {
    ...MediaFile
  }
  sampleImageIds
  salePrice {
    ...MonetaryAmount
  }
  originalPrice {
    ...MonetaryAmount
  }
  variationMatrix {
    defaultVariant {
      id
      friendlyId
      slug
      type
      salePrice {
        ...MonetaryAmount
      }
      originalPrice {
        ...MonetaryAmount
      }
    }
  }
  categories {
    ...CategoryData
  }
  parent {
    id
    googleId
    categories {
      ...CategoryData
    }
  }
}
    ${BrandFragmentDoc}
${MediaFileFragmentDoc}
${MonetaryAmountFragmentDoc}
${CategoryDataFragmentDoc}`;
export const SellableDetailsVariantFragmentDoc = gql`
    fragment SellableDetailsVariant on SellableFormattedVariant {
  name
  displayName
  value
  displayValueHtml
}
    `;
export const SellableSpecificationFragmentDoc = gql`
    fragment SellableSpecification on SellableSpecification {
  key
  name
  valueHtml
}
    `;
export const CategoryBreadcrumbFragmentDoc = gql`
    fragment CategoryBreadcrumb on Category {
  id
  slug
  pluralDisplayName
}
    `;
export const VideoReviewFragmentDoc = gql`
    fragment VideoReview on ExternalVideo {
  id
  idType
  destinationUrl
}
    `;
export const FeaturedContentFragmentDoc = gql`
    fragment FeaturedContent on Sellable {
  featuredContent {
    id
    externalVideos {
      ...VideoReview
    }
  }
}
    ${VideoReviewFragmentDoc}`;
export const SellableDetailsFragmentDoc = gql`
    fragment SellableDetails on Sellable {
  ...TrackableSellable
  type
  adHoc
  descriptionText
  descriptionMarkdown
  features
  active
  inShortSupply
  department {
    mostRecentLeadForConsumer {
      id
    }
    ...DepartmentContext
  }
  savedSellable {
    id
    saved
  }
  variant
  variants {
    ...SellableDetailsVariant
  }
  specifications {
    ...SellableSpecification
  }
  metrics {
    totalUniquePVsInPastWeek
    totalPurchasesInLast30Days
    timesRecommendedByExpert
  }
  serviceLocation {
    displayTitle
  }
  categories {
    breadcrumbs: parents {
      ...CategoryBreadcrumb
    }
  }
  parent {
    id
    metrics {
      totalUniquePVsInPastWeek
      totalPurchasesInLast30Days
    }
    savedSellable {
      id
      saved
    }
    department {
      ...DepartmentContext
    }
  }
  variationMatrix {
    defaultVariant {
      id
      originalPrice {
        ...MonetaryAmount
      }
      salePrice {
        ...MonetaryAmount
      }
    }
    outOfStockSellables {
      id
    }
    priceRange {
      max {
        ...MonetaryAmount
      }
      min {
        ...MonetaryAmount
      }
    }
  }
  salePrice {
    ...MonetaryAmount
  }
  originalPrice {
    ...MonetaryAmount
  }
  ...FeaturedContent
}
    ${TrackableSellableFragmentDoc}
${DepartmentContextFragmentDoc}
${SellableDetailsVariantFragmentDoc}
${SellableSpecificationFragmentDoc}
${CategoryBreadcrumbFragmentDoc}
${MonetaryAmountFragmentDoc}
${FeaturedContentFragmentDoc}`;
export const ExperienceSellableDetailsFragmentDoc = gql`
    fragment ExperienceSellableDetails on Sellable {
  charterLocation: attribute(attributeName: "charterLocation") {
    ...ExperienceAttribute
  }
  charterLengthFeet: attribute(attributeName: "charterLengthFeet") {
    ...ExperienceAttribute
  }
  charterCabins: attribute(attributeName: "charterCabins") {
    ...ExperienceAttribute
  }
  charterCapacity: attribute(attributeName: "charterCapacity") {
    ...ExperienceAttribute
  }
  charterAmenities: attribute(attributeName: "charterAmenities") {
    ...ExperienceAttribute
  }
  ...SellableDetails
  ...SellablePricing
}
    ${ExperienceAttributeFragmentDoc}
${SellableDetailsFragmentDoc}
${SellablePricingFragmentDoc}`;
export const ExpertDepartmentFragmentDoc = gql`
    fragment ExpertDepartment on Department {
  id
  type
}
    `;
export const ProductExpertCardFragmentDoc = gql`
    fragment ProductExpertCard on BusinessUser {
  id
  active
  vanityId
  firstName
  lastName
  department {
    ...ExpertDepartment
  }
  expertProfile {
    id
    headline
    location
    background
    profilePhoto {
      ...MediaFile
    }
  }
  expertAttributes {
    placeholderExpert
  }
  expertStats {
    averageRating
    totalMessages
    totalReviews
    totalLeads
  }
}
    ${ExpertDepartmentFragmentDoc}
${MediaFileFragmentDoc}`;
export const SellableKeywordTypeaheadResultFragmentDoc = gql`
    fragment SellableKeywordTypeaheadResult on SellableTypeaheadHit {
  id
  text
  title
  brandName
  sellable {
    id
    friendlyId
    slug
    type
  }
}
    `;
export const NavInactiveDepartmentFragmentDoc = gql`
    fragment NavInactiveDepartment on Department {
  id
  type
  slug
  displayName
  acceptingRequests
  launched
  topLevelCategory {
    id
  }
}
    `;
export const FacetSelectionPayloadFragmentDoc = gql`
    fragment FacetSelectionPayload on FacetSelectionPayload {
  name
  alias
  displayName
  bucketValues
  lower
  upper
}
    `;
export const DepartmentNavigationLinkFragmentDoc = gql`
    fragment DepartmentNavigationLink on DepartmentNavigationLink {
  ... on DepartmentNavigationCategoryLink {
    category {
      id
      slug
    }
  }
  ... on DepartmentNavigationSearchLink {
    category {
      id
      slug
    }
    facets {
      ...FacetSelectionPayload
    }
  }
  ... on DepartmentNavigationCreatePathLink {
    pathSlug
  }
  ... on DepartmentNavigationExpertCommunityLink {
    departmentSlug
  }
}
    ${FacetSelectionPayloadFragmentDoc}`;
export const DepartmentNavigationListSubSectionFragmentDoc = gql`
    fragment DepartmentNavigationListSubSection on DepartmentNavigationListSubSection {
  title
  titleLink {
    ...DepartmentNavigationLink
  }
  items {
    id
    label
    labelStyles
    imagePath
    imageUrl
    link {
      ...DepartmentNavigationLink
    }
  }
}
    ${DepartmentNavigationLinkFragmentDoc}`;
export const DepartmentNavigationResponsiveMixinFragmentDoc = gql`
    fragment DepartmentNavigationResponsiveMixin on DepartmentNavigationResponsiveMixin {
  showIfSmallSize
  showIfFullSize
  smallSizeOptions
  fullSizeOptions
}
    `;
export const DepartmentNavigationSubSectionFragmentDoc = gql`
    fragment DepartmentNavigationSubSection on DepartmentNavigationSubSection {
  id
  title
  titleLink {
    ...DepartmentNavigationLink
  }
  ... on DepartmentNavigationListSubSection {
    ...DepartmentNavigationListSubSection
  }
  ...DepartmentNavigationResponsiveMixin
}
    ${DepartmentNavigationLinkFragmentDoc}
${DepartmentNavigationListSubSectionFragmentDoc}
${DepartmentNavigationResponsiveMixinFragmentDoc}`;
export const DepartmentNavigationTopLevelItemFragmentDoc = gql`
    fragment DepartmentNavigationTopLevelItem on DepartmentNavigationTopLevelItem {
  id
  label
  labelLink {
    ...DepartmentNavigationLink
  }
  subSections {
    ...DepartmentNavigationSubSection
  }
  ...DepartmentNavigationResponsiveMixin
}
    ${DepartmentNavigationLinkFragmentDoc}
${DepartmentNavigationSubSectionFragmentDoc}
${DepartmentNavigationResponsiveMixinFragmentDoc}`;
export const NavActiveDepartmentFragmentDoc = gql`
    fragment NavActiveDepartment on Department {
  id
  type
  slug
  displayName
  navigation {
    topLevelItems {
      ...DepartmentNavigationTopLevelItem
    }
  }
  topLevelCategories {
    id
    slug
  }
  launched
  acceptingRequests
}
    ${DepartmentNavigationTopLevelItemFragmentDoc}`;
export const LandingPageExpertCardFragmentDoc = gql`
    fragment LandingPageExpertCard on BusinessUser {
  id
  vanityId
  active
  firstName
  lastName
  expertProfile {
    id
    background
    profilePhoto {
      ...MediaFile
    }
    highlights {
      secondaryValue
      value
    }
  }
  expertStats {
    averageRating
    totalReviews
    totalMessages
  }
}
    ${MediaFileFragmentDoc}`;
export const CategoryMediaFragmentDoc = gql`
    fragment CategoryMedia on Category {
  id
  type
  name
  singularDisplayName
  contentAssets {
    bannerImages {
      imageUrl
    }
  }
}
    `;
export const ExpertDataFragmentDoc = gql`
    fragment ExpertData on BusinessUser {
  id
  vanityId
  firstName
  lastName
  expertProfile {
    id
    profilePhoto {
      id
      url
    }
  }
  expertAttributes {
    placeholderExpert
  }
}
    `;
export const RequestAttributesFragmentDoc = gql`
    fragment RequestAttributes on Attribute {
  formatted {
    name
    displayHtml
    displayHtmlValues
  }
}
    `;
export const DealAddOnFragmentDoc = gql`
    fragment DealAddOn on DealAddOn {
  title
  retailPrice {
    amount
  }
}
    `;
export const DealFragmentDoc = gql`
    fragment Deal on Deal {
  id
  title
  discount
  price {
    currency
    amount
  }
  originalPrice {
    currency
    amount
  }
  images {
    id
    url
  }
  brand {
    id
    displayName
  }
  freeAddOns {
    ...DealAddOn
  }
}
    ${DealAddOnFragmentDoc}`;
export const SystemCuratedItemSourceFragmentDoc = gql`
    fragment SystemCuratedItemSource on SystemCuratedItemSource {
  type
  ... on PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource {
    expertCuratedItem {
      id
    }
  }
  ... on TopRecommendedListSystemCuratedItemSource {
    recommendedListDefinition {
      id
    }
  }
  ... on TopRecommendationAndSimilarUserSystemCuratedItemSource {
    recentExpertCuratedItemFromSimilarUserSource {
      type
      expertCuratedItem {
        id
      }
    }
    topRecommendedListSystemCuratedItemSource {
      type
      recommendedListDefinition {
        id
      }
    }
  }
  ... on RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource {
    type
    expertCuratedItem {
      id
    }
  }
}
    `;
export const SystemCuratedItemFragmentDoc = gql`
    fragment SystemCuratedItem on SystemCuratedItem {
  id
  type
  sellable {
    id
    friendlyId
    slug
    type
    title
    images {
      ...MediaFile
    }
    ...SellablePricing
  }
  category {
    id
  }
  systemCuratedItemSource {
    ...SystemCuratedItemSource
  }
}
    ${MediaFileFragmentDoc}
${SellablePricingFragmentDoc}
${SystemCuratedItemSourceFragmentDoc}`;
export const SystemCuratedItemSurveyStatsFragmentDoc = gql`
    fragment SystemCuratedItemSurveyStats on SystemCuratedItemSurveyStats {
  ratingStats {
    rating
    count
  }
}
    `;
export const FlightPlanQuestionFragmentDoc = gql`
    fragment FlightPlanQuestion on FlightPlan {
  id
  legs {
    arrivalAirport {
      id
      name
    }
    arriveAt
    departureAirport {
      id
      name
    }
    departOn
  }
}
    `;
export const ExpertProfileDetailFragmentDoc = gql`
    fragment ExpertProfileDetail on ExpertProfile {
  id
  businessUser {
    id
    firstName
    lastName
  }
  profilePhoto {
    ...MediaFile
  }
  headline
  background
  quotes
  socialMediaUrls
}
    ${MediaFileFragmentDoc}`;
export const ImageViewModelFragmentDoc = gql`
    fragment ImageViewModel on PathImageViewModel {
  imageUrl
  imagePath
}
    `;
export const TextViewModelFragmentDoc = gql`
    fragment TextViewModel on TextViewModel {
  ... on AttributedHtmlTextViewModel {
    text
    attributes {
      key
      type
      image {
        ...ImageViewModel
      }
    }
  }
}
    ${ImageViewModelFragmentDoc}`;
export const ConversationWithLeadFragmentDoc = gql`
    fragment ConversationWithLead on Conversation {
  id
  lead {
    id
    expert {
      id
      vanityId
    }
  }
}
    `;
export const InterstitialPageMetadataFragmentDoc = gql`
    fragment InterstitialPageMetadata on InterstitialPathFlowPageMetadata {
  interstitialType
  title {
    ...TextViewModel
  }
  body {
    ...TextViewModel
  }
}
    ${TextViewModelFragmentDoc}`;
export const TermsAndConditionsPageMetadataFragmentDoc = gql`
    fragment TermsAndConditionsPageMetadata on TermsAndConditionsPathFlowPageMetadata {
  type
}
    `;
export const RatingContactPageMetadataFragmentDoc = gql`
    fragment RatingContactPageMetadata on RatingContactPageMetadata {
  type
}
    `;
export const PathFlowPageMetadataFragmentDoc = gql`
    fragment PathFlowPageMetadata on PathFlowPageMetadata {
  type
  ...InterstitialPageMetadata
  ...TermsAndConditionsPageMetadata
  ...RatingContactPageMetadata
}
    ${InterstitialPageMetadataFragmentDoc}
${TermsAndConditionsPageMetadataFragmentDoc}
${RatingContactPageMetadataFragmentDoc}`;
export const SharedPathFlowQuestionFragmentDoc = gql`
    fragment SharedPathFlowQuestion on PathFlowQuestion {
  internalName
  required
  questionText {
    ...TextViewModel
  }
  questionSubText {
    ...TextViewModel
  }
  inputLabel {
    ...TextViewModel
  }
  inputIconImage {
    ...ImageViewModel
  }
}
    ${TextViewModelFragmentDoc}
${ImageViewModelFragmentDoc}`;
export const InputTextPathFlowQuestionValidationFragmentDoc = gql`
    fragment InputTextPathFlowQuestionValidation on InputTextPathFlowQuestionValidation {
  type
  ... on InputTextPathFlowQuestionLengthValidation {
    minSize
    maxSize
  }
  ... on InputTextPathFlowQuestionRegexValidation {
    regex
    errorMessage
  }
}
    `;
export const InputTextPathFlowQuestionMixinFragmentDoc = gql`
    fragment InputTextPathFlowQuestionMixin on InputTextPathFlowQuestionMixin {
  required
  fieldType
  placeholder
  inputTextValidations {
    ...InputTextPathFlowQuestionValidation
  }
  questionSubText {
    ...TextViewModel
  }
}
    ${InputTextPathFlowQuestionValidationFragmentDoc}
${TextViewModelFragmentDoc}`;
export const ListPathFlowQuestionFragmentDoc = gql`
    fragment ListPathFlowQuestion on ListPathFlowQuestion {
  listType: type
  choices {
    value
    text {
      ...TextViewModel
    }
    subText {
      ...TextViewModel
    }
    primaryImage {
      ...ImageViewModel
    }
    iconImage {
      ...ImageViewModel
    }
  }
  renderStyle
  other {
    ...InputTextPathFlowQuestionMixin
  }
  listUserInput {
    value
    other
  }
}
    ${TextViewModelFragmentDoc}
${ImageViewModelFragmentDoc}
${InputTextPathFlowQuestionMixinFragmentDoc}`;
export const InputTextPathFlowQuestionFragmentDoc = gql`
    fragment InputTextPathFlowQuestion on InputTextPathFlowQuestion {
  ...InputTextPathFlowQuestionMixin
  countryCodeAttribute: attribute(attributeName: "countryCode") {
    values {
      ... on AttributeValueEnumeration {
        enumerationValue
        enumerationValueDescription
      }
    }
  }
  inputTextUserInput {
    value
  }
}
    ${InputTextPathFlowQuestionMixinFragmentDoc}`;
export const NumericPathFlowQuestionFragmentDoc = gql`
    fragment NumericPathFlowQuestion on NumericPathFlowQuestion {
  unit
  unitLabel
  placeholder
  numericUserInput {
    value
    decimalValue
  }
  displayType
}
    `;
export const OAuthEmailPathFlowQuestionFragmentDoc = gql`
    fragment OAuthEmailPathFlowQuestion on OAuthEmailPathFlowQuestion {
  oAuthEmailUserInput {
    firstName
    lastName
    email
    googleIdToken
    facebookUserAccessToken
    skipFirstName
    skipLastName
  }
}
    `;
export const IdPathFlowQuestionFragmentDoc = gql`
    fragment IdPathFlowQuestion on IdPathFlowQuestion {
  idType: type
  idUserInput {
    value
  }
}
    `;
export const DateRangePathFlowQuestionFragmentDoc = gql`
    fragment DateRangePathFlowQuestion on DateRangePathFlowQuestion {
  dateRangeUserInput {
    startValue
    endValue
  }
  endRequired
  startRequired
}
    `;
export const DatePathFlowQuestionFragmentDoc = gql`
    fragment DatePathFlowQuestion on DatePathFlowQuestion {
  dateUserInput {
    value
  }
}
    `;
export const PathFlowQuestionFragmentDoc = gql`
    fragment PathFlowQuestion on PathFlowQuestion {
  ...SharedPathFlowQuestion
  ... on ListPathFlowQuestion {
    ...ListPathFlowQuestion
  }
  ... on InputTextPathFlowQuestion {
    ...InputTextPathFlowQuestion
  }
  ... on NumericPathFlowQuestion {
    ...NumericPathFlowQuestion
  }
  ... on OAuthEmailPathFlowQuestion {
    ...OAuthEmailPathFlowQuestion
  }
  ... on IdPathFlowQuestion {
    ...IdPathFlowQuestion
  }
  ... on DateRangePathFlowQuestion {
    ...DateRangePathFlowQuestion
  }
  ... on DatePathFlowQuestion {
    ...DatePathFlowQuestion
  }
}
    ${SharedPathFlowQuestionFragmentDoc}
${ListPathFlowQuestionFragmentDoc}
${InputTextPathFlowQuestionFragmentDoc}
${NumericPathFlowQuestionFragmentDoc}
${OAuthEmailPathFlowQuestionFragmentDoc}
${IdPathFlowQuestionFragmentDoc}
${DateRangePathFlowQuestionFragmentDoc}
${DatePathFlowQuestionFragmentDoc}`;
export const PathFlowPageFragmentDoc = gql`
    fragment PathFlowPage on PathFlowPage {
  id
  internalName
  metadata {
    ...PathFlowPageMetadata
  }
  title {
    ...TextViewModel
  }
  slug
  completed
  completionPercentage
  requiresServerSyncAfterSubmit
  notificationTexts {
    ...TextViewModel
  }
  questions {
    ...PathFlowQuestion
  }
  submitButtonText {
    ...TextViewModel
  }
  skipButtonText {
    ...TextViewModel
  }
}
    ${PathFlowPageMetadataFragmentDoc}
${TextViewModelFragmentDoc}
${PathFlowQuestionFragmentDoc}`;
export const PathFlowPagesConnectionFragmentDoc = gql`
    fragment PathFlowPagesConnection on PathFlowPagesConnection {
  edges {
    cursor
    node {
      ...PathFlowPage
    }
  }
}
    ${PathFlowPageFragmentDoc}`;
export const PathFlowFragmentDoc = gql`
    fragment PathFlow on PathFlow {
  id
  title {
    ...TextViewModel
  }
  completed
  onComplete {
    ... on PathFlowOnCompleteBroadcast {
      location
      conversation {
        ...ConversationWithLead
      }
    }
    ... on PathFlowOnCompleteLead {
      conversation {
        ...ConversationWithLead
      }
      location
    }
    ... on PathFlowOnCompleteNewPath {
      flow {
        id
        slug
        pagesConnection {
          ...PathFlowPagesConnection
        }
      }
    }
    ... on PathFlowOnCompleteExpertReview {
      review {
        id
      }
      location
    }
    ... on PathFlowOnCompleteRedirectOnly {
      location
    }
    ... on PathFlowOnCompleteRedirectWithUpsert {
      location
    }
    ... on PathFlowOnCompleteExpertApplication {
      application {
        id
      }
      location
    }
  }
  theme {
    type
  }
  slug
  category {
    id
    slug
    department {
      ...DepartmentContext
    }
  }
  pagesConnection {
    ...PathFlowPagesConnection
  }
}
    ${TextViewModelFragmentDoc}
${ConversationWithLeadFragmentDoc}
${PathFlowPagesConnectionFragmentDoc}
${DepartmentContextFragmentDoc}`;
export const PathValidationErrorFragmentDoc = gql`
    fragment PathValidationError on PathValidationError {
  pageName
  questionName
  message {
    ...TextViewModel
  }
  tags
}
    ${TextViewModelFragmentDoc}`;
export const RoryReviewFragmentDoc = gql`
    fragment RoryReview on ConsumerExpertReview {
  id
  comments
  reviewedAt
  rating
  consumerName
  consumerLocation
}
    `;
export const ExpertStatsFragmentDoc = gql`
    fragment ExpertStats on ExpertStats {
  topGoodQualities
  averageRating
  totalLeads
  totalMessages
  totalReviews
}
    `;
export const PathExpertFragmentDoc = gql`
    fragment PathExpert on BusinessUser {
  id
  firstName
  lastName
  expertProfile {
    id
    background
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      type {
        id
        displayName
      }
      value
      secondaryValue
    }
  }
  expertStats {
    ...ExpertStats
  }
}
    ${MediaFileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const PhoneCollectionExpertFragmentDoc = gql`
    fragment PhoneCollectionExpert on BusinessUser {
  id
  firstName
  lastName
  presence
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
    headline
  }
}
    ${MediaFileFragmentDoc}`;
export const SellableCardFragmentDoc = gql`
    fragment SellableCard on Sellable {
  ...TrackableSellable
  id
  metrics {
    totalUniquePVsInPastWeek
    totalPurchasesInLast30Days
  }
  areAllVariantsOutOfStock
  department {
    id
    type
    slug
  }
  parent {
    id
    metrics {
      totalUniquePVsInPastWeek
      totalPurchasesInLast30Days
    }
    savedSellable {
      id
      saved
    }
  }
  savedSellable {
    id
    saved
  }
  variationMatrix {
    priceRange {
      max {
        ...MonetaryAmount
      }
      min {
        ...MonetaryAmount
      }
    }
    defaultVariant {
      id
      images {
        ...MediaFile
      }
    }
  }
  charterBathrooms: attribute(attributeName: "charterBathrooms") {
    formatted {
      name
      displayHtml
      displayHtmlValues
    }
  }
  charterCabins: attribute(attributeName: "charterCabins") {
    formatted {
      name
      displayHtml
      displayHtmlValues
    }
  }
  charterCapacity: attribute(attributeName: "charterCapacity") {
    formatted {
      name
      displayHtml
      displayHtmlValues
    }
  }
  charterLocation: attribute(attributeName: "charterLocation") {
    formatted {
      name
      displayHtml
      displayHtmlValues
    }
  }
  consumerSellableReactions {
    edges {
      node {
        id
        ratingWithDisplayName {
          displayName
          rating
        }
      }
    }
  }
}
    ${TrackableSellableFragmentDoc}
${MonetaryAmountFragmentDoc}
${MediaFileFragmentDoc}`;
export const RecommendedListFragmentDoc = gql`
    fragment RecommendedList on RecommendedList {
  displayName
  subTitle
  recommendedListDefinition {
    id
    rank
  }
  sellables {
    ...SellableCard
  }
}
    ${SellableCardFragmentDoc}`;
export const BusinessUserToRateFragmentDoc = gql`
    fragment BusinessUserToRate on BusinessUser {
  id
  vanityId
  firstName
  lastName
  expertProfile {
    id
    headline
    profilePhoto {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const SaveableSellableFragmentDoc = gql`
    fragment SaveableSellable on Sellable {
  id
  savedSellable {
    id
    saved
  }
  parent {
    id
    savedSellable {
      id
      saved
    }
  }
}
    `;
export const SaveableSellableResponseFragmentDoc = gql`
    fragment SaveableSellableResponse on Sellable {
  id
  ...TrackableSellable
  savedSellable {
    id
    saved
  }
}
    ${TrackableSellableFragmentDoc}`;
export const ContentfulImageDataFragmentDoc = gql`
    fragment ContentfulImageData on ContentAsset {
  mimeType
  title
  imageUrl
}
    `;
export const RawContentTypesFragmentDoc = gql`
    fragment RawContentTypes on ContentValue {
  ... on ContentBooleanValue {
    booleanValue
  }
  ... on ContentStringValue {
    stringValue
  }
  ... on ContentIntValue {
    intValue
  }
  ... on ContentFloatValue {
    floatValue
  }
  ... on ContentAsset {
    ...ContentfulImageData
  }
}
    ${ContentfulImageDataFragmentDoc}`;
export const ContentTypesFragmentDoc = gql`
    fragment ContentTypes on ContentValue {
  ...RawContentTypes
  ... on ContentObject {
    entries {
      key
      value {
        ...RawContentTypes
        ... on ContentValueArray {
          values {
            ...RawContentTypes
            ... on ContentObject {
              entries {
                key
                value {
                  ...RawContentTypes
                  ... on ContentValueArray {
                    values {
                      ...RawContentTypes
                      ... on ContentObject {
                        entries {
                          key
                          value {
                            ...RawContentTypes
                            ... on ContentValueArray {
                              values {
                                ...RawContentTypes
                              }
                            }
                            ... on ContentObject {
                              entries {
                                key
                                value {
                                  ...RawContentTypes
                                  ... on ContentValueArray {
                                    values {
                                      ...RawContentTypes
                                      ... on ContentObject {
                                        entries {
                                          key
                                          value {
                                            ...RawContentTypes
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        ... on ContentObject {
          entries {
            key
            value {
              ...RawContentTypes
              ... on ContentValueArray {
                values {
                  ...RawContentTypes
                  ... on ContentObject {
                    entries {
                      key
                      value {
                        ...RawContentTypes
                        ... on ContentValueArray {
                          values {
                            ...RawContentTypes
                            ... on ContentObject {
                              entries {
                                key
                                value {
                                  ...RawContentTypes
                                  ... on ContentValueArray {
                                    values {
                                      ...RawContentTypes
                                    }
                                  }
                                  ... on ContentObject {
                                    entries {
                                      key
                                      value {
                                        ...RawContentTypes
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ... on ContentValueArray {
    values {
      ...RawContentTypes
      ... on ContentObject {
        entries {
          key
          value {
            ...RawContentTypes
            ... on ContentValueArray {
              values {
                ...RawContentTypes
                ... on ContentObject {
                  entries {
                    key
                    value {
                      ...RawContentTypes
                      ... on ContentValueArray {
                        values {
                          ...RawContentTypes
                          ... on ContentObject {
                            entries {
                              key
                              value {
                                ...RawContentTypes
                                ... on ContentValueArray {
                                  values {
                                    ...RawContentTypes
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            ... on ContentObject {
              entries {
                key
                value {
                  ...RawContentTypes
                  ... on ContentValueArray {
                    values {
                      ...RawContentTypes
                      ... on ContentObject {
                        entries {
                          key
                          value {
                            ...RawContentTypes
                            ... on ContentValueArray {
                              values {
                                ...RawContentTypes
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${RawContentTypesFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  id
  addresseeName
  line1
  line2
  city
  state
  country
  countryDetails {
    displayCountry
  }
  postalCode
  securityCode
  phoneNumber
  active
  isDefault
}
    `;
export const AuthenticatedUserFragmentDoc = gql`
    fragment AuthenticatedUser on User {
  id
  firstName
  lastName
  roles
  profilePhoto {
    id
    url
  }
  messagingUser {
    id
    notificationChannels
  }
  address {
    line1
    city
    state
    postalCode
    country
  }
  savedAddresses {
    ...Address
  }
  contacts {
    id
    type
    value
    verified
  }
}
    ${AddressFragmentDoc}`;
export const RealUserFragmentDoc = gql`
    fragment RealUser on User {
  id
  firstName
  lastName
  assignedOperatorSeat {
    id
  }
}
    `;
export const MyselfFragmentDoc = gql`
    fragment Myself on Myself {
  id
  hasPassword
  user {
    ...AuthenticatedUser
    mostRecentLead {
      id
      createdAt
      category {
        id
        department {
          ...DepartmentContext
        }
      }
    }
    source {
      attributes {
        name
        value
      }
    }
  }
  realUser {
    ...RealUser
  }
}
    ${AuthenticatedUserFragmentDoc}
${DepartmentContextFragmentDoc}
${RealUserFragmentDoc}`;
export const SessionFragmentDoc = gql`
    fragment Session on Session {
  id
}
    `;
export const ChatWidgetExpertFragmentDoc = gql`
    fragment ChatWidgetExpert on BusinessUser {
  id
  vanityId
  firstName
  lastName
  messagingUser {
    id
  }
  expertAttributes {
    acceptingNewRequests
    placeholderExpert
  }
  expertProfile {
    id
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      secondaryValue
      type {
        id
        icon
      }
      value
    }
  }
  expertStats {
    totalMessages
    totalReviews
  }
}
    ${MediaFileFragmentDoc}`;
export const ConversationFragmentDoc = gql`
    fragment Conversation on Conversation {
  id
  externalId
  lead {
    id
    expert {
      ...ChatWidgetExpert
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export const ExpertCuratedAttributeFragmentDoc = gql`
    fragment ExpertCuratedAttribute on Attribute {
  formatted {
    name
    displayHtml
  }
}
    `;
export const ExpertCuratedSellableDetailsFragmentDoc = gql`
    fragment ExpertCuratedSellableDetails on Sellable {
  charterLocation: attribute(attributeName: "charterLocation") {
    ...ExpertCuratedAttribute
  }
  charterLengthFeet: attribute(attributeName: "charterLengthFeet") {
    ...ExpertCuratedAttribute
  }
  charterCabins: attribute(attributeName: "charterCabins") {
    ...ExpertCuratedAttribute
  }
  charterCapacity: attribute(attributeName: "charterCapacity") {
    ...ExpertCuratedAttribute
  }
  charterAmenities: attribute(attributeName: "charterAmenities") {
    ...ExpertCuratedAttribute
  }
  charterBathrooms: attribute(attributeName: "charterBathrooms") {
    ...ExpertCuratedAttribute
  }
  aircraftType: attribute(attributeName: "aircraftType") {
    ...ExpertCuratedAttribute
  }
  ...SellableDetails
  ...SellablePricing
}
    ${ExpertCuratedAttributeFragmentDoc}
${SellableDetailsFragmentDoc}
${SellablePricingFragmentDoc}`;
export const ExpertCuratedOrderLineItemFragmentDoc = gql`
    fragment ExpertCuratedOrderLineItem on OrderLineItem {
  id
  isGroup
  title
  unitPrice {
    ...MonetaryAmount
  }
  quantity
  source {
    type
    ... on OrderLineItemSellableSource {
      sellable {
        ...ExpertCuratedSellableDetails
      }
    }
    ... on OrderLineItemAdHocSource {
      type
    }
    ... on OrderLineItemBasePriceSource {
      type
    }
    ... on OrderLineItemExpertTipSource {
      type
    }
    ... on OrderLineItemGratuitySource {
      type
    }
    ... on OrderLineItemShipmentSource {
      type
    }
    ... on OrderLineItemSource {
      type
    }
  }
}
    ${MonetaryAmountFragmentDoc}
${ExpertCuratedSellableDetailsFragmentDoc}`;
export const ExpertCuratedVariationOptionFragmentDoc = gql`
    fragment ExpertCuratedVariationOption on ExpertCuratedOrderVariationOption {
  enabled
  price {
    ...MonetaryAmount
  }
  selected
  sellable {
    id
    title
    descriptionText
    variants {
      displayName
      value
      displayValueHtml
    }
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const LeadCuratedOrderFragmentDoc = gql`
    fragment LeadCuratedOrder on Lead {
  id
  conversation {
    id
  }
  category {
    id
    contentAssets {
      bannerImages {
        title
        imageUrl
      }
    }
  }
  consumer {
    id
    firstName
    lastName
  }
  expert {
    id
    firstName
    lastName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    phoneNumber: assignedAddress(type: SMS)
  }
}
    ${MediaFileFragmentDoc}`;
export const AirportFragmentDoc = gql`
    fragment Airport on Airport {
  id
  zoneId
  displayCode
}
    `;
export const FlightPlanLegFragmentDoc = gql`
    fragment FlightPlanLeg on FlightPlanLeg {
  id
  departAt
  departOn
  arriveAt
  durationInMinutes
  flightOperator
  departureAirport {
    ...Airport
  }
  arrivalAirport {
    ...Airport
  }
}
    ${AirportFragmentDoc}`;
export const FlightPlanFragmentDoc = gql`
    fragment FlightPlan on FlightPlan {
  id
  state
  legs {
    ...FlightPlanLeg
  }
}
    ${FlightPlanLegFragmentDoc}`;
export const ExpertCuratedOrderManualTaxAdjustmentFragmentDoc = gql`
    fragment ExpertCuratedOrderManualTaxAdjustment on ExpertCuratedOrderManualTaxAdjustment {
  taxRate
  amount {
    ...MonetaryAmount
  }
  computedFromAmount {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const ExpertCuratedOrderFragmentDoc = gql`
    fragment ExpertCuratedOrder on ExpertCuratedOrder {
  id
  state
  serviceStartAt
  inPreview
  expiresAt
  category {
    id
    slug
  }
  serviceLocation {
    displayTitle
  }
  curatedFor {
    id
    firstName
  }
  items {
    id
  }
  order {
    id
    title
    description
    primaryImage {
      ...MediaFile
    }
    totalCostBeforeTax {
      ...MonetaryAmount
    }
    tax {
      ...MonetaryAmount
    }
    totalCost {
      ...MonetaryAmount
    }
    remainingBalance {
      ...MonetaryAmount
    }
    minimumDeposit {
      ...MonetaryAmount
    }
    lineItems {
      ...ExpertCuratedOrderLineItem
    }
    state
  }
  variationOptions {
    ...ExpertCuratedVariationOption
  }
  serviceStartAt
  lead {
    id
    category {
      id
      singularDisplayName
      department {
        ...DepartmentContext
      }
    }
    ...LeadCuratedOrder
  }
  flightPlan {
    ...FlightPlan
  }
  taxWillBeAutomaticallyComputed
  defaultManualTaxAdjustment {
    ...ExpertCuratedOrderManualTaxAdjustment
  }
}
    ${MediaFileFragmentDoc}
${MonetaryAmountFragmentDoc}
${ExpertCuratedOrderLineItemFragmentDoc}
${ExpertCuratedVariationOptionFragmentDoc}
${DepartmentContextFragmentDoc}
${LeadCuratedOrderFragmentDoc}
${FlightPlanFragmentDoc}
${ExpertCuratedOrderManualTaxAdjustmentFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const SellableUrlFragmentDoc = gql`
    fragment SellableUrl on Sellable {
  id
  friendlyId
  slug
  type
}
    `;
export const WireTransferPaymentEntityFragmentDoc = gql`
    fragment WireTransferPaymentEntity on WireTransferPaymentEntity {
  paymentMethod
  accountNumber
  bankName
  chargeableAmount {
    ...MonetaryAmount
  }
  routingNumber
  swiftCode
}
    ${MonetaryAmountFragmentDoc}`;
export const OrderMessageFragmentDoc = gql`
    fragment OrderMessage on OrderMessage {
  dismissible
  message
}
    `;
export const ShipmentTrackingFragmentDoc = gql`
    fragment ShipmentTracking on ShipmentTracking {
  shippingCarrier {
    id
    displayName
  }
  trackingNumber
  status
  estimatedDeliveryTime
  trackingUrl
}
    `;
export const StripePaymentSourceFragmentDoc = gql`
    fragment StripePaymentSource on StripePaymentSource {
  id
  createdAt
  updatedAt
  externalSourceId
  type
  usage
  status
  userId
  owner {
    name
    verifiedName
  }
  billingAddress {
    ...Address
  }
  paymentEntity {
    ... on PaymentCard {
      paymentMethod
      last4
      brand
      threeDSecureVerificationRequired
    }
  }
  isDefault
}
    ${AddressFragmentDoc}`;
export const PaymentSourceFragmentDoc = gql`
    fragment PaymentSource on PaymentSource {
  ...StripePaymentSource
  ... on AffirmPaymentSource {
    id
  }
  ... on PaypalPaymentSource {
    id
  }
  ... on AfterpayPaymentSource {
    id
  }
}
    ${StripePaymentSourceFragmentDoc}`;
export const TransactionFragmentDoc = gql`
    fragment Transaction on Transaction {
  id
  status
  request {
    chargeAmount {
      amount
      currency
    }
    paymentSourceType
  }
  response {
    paymentSource {
      ...PaymentSource
    }
    errorMessage
    userFriendlyErrorMessage
  }
}
    ${PaymentSourceFragmentDoc}`;
export const OrderFragmentDoc = gql`
    fragment Order on Order {
  id
  state
  createdAt
  paidAt
  categoryType
  user {
    id
    firstName
    lastName
  }
  tax {
    ...MonetaryAmount
  }
  shippingCost {
    ...MonetaryAmount
  }
  chargingPaymentSource {
    id
    paymentEntity {
      ... on WireTransferPaymentEntity {
        ...WireTransferPaymentEntity
      }
    }
  }
  totalCost {
    ...MonetaryAmount
  }
  totalCostBeforeTax {
    ...MonetaryAmount
  }
  subtotal: totalCostOnlyIncluding(costComponents: [CORE, GRATUITY]) {
    ...MonetaryAmount
  }
  totalCostWithoutTip: totalCostExcluding(costComponents: [EXPERT_TIP]) {
    ...MonetaryAmount
  }
  totalShippingCost: totalCostOnlyIncluding(costComponents: [SHIPMENT]) {
    ...MonetaryAmount
  }
  tip {
    ...MonetaryAmount
  }
  messages {
    ...OrderMessage
  }
  shippingAddress {
    ...Address
  }
  shipmentTrackings {
    ...ShipmentTracking
  }
  transactions {
    ...Transaction
  }
  offer {
    id
    images {
      ...MediaFile
    }
    title
    type
  }
  requiresShippingAddress
  itemsCount
  supportedPaymentMethods {
    paymentMethod
    paymentProvider
  }
  appliedPromotionEntry {
    applied
    discount {
      ...MonetaryAmount
    }
    promotion {
      id
      code
    }
  }
}
    ${MonetaryAmountFragmentDoc}
${WireTransferPaymentEntityFragmentDoc}
${OrderMessageFragmentDoc}
${AddressFragmentDoc}
${ShipmentTrackingFragmentDoc}
${TransactionFragmentDoc}
${MediaFileFragmentDoc}`;
export const OrderLineItemFragmentDoc = gql`
    fragment OrderLineItem on OrderLineItem {
  id
  messages {
    dismissible
    message
  }
  price {
    ...MonetaryAmount
  }
  quantity
  isGroup
  parentId
  source {
    type
    ... on OrderLineItemBasePriceSource {
      type
    }
    ... on OrderLineItemGratuitySource {
      type
      percentage
    }
    ... on OrderLineItemExpertTipSource {
      type
      amount {
        ...MonetaryAmount
      }
    }
    ... on OrderLineItemShipmentSource {
      type
      amount {
        ...MonetaryAmount
      }
    }
    ... on OrderLineItemAdHocSource {
      type
    }
    ... on OrderLineItemSellableSource {
      sellable {
        ...SellableDetails
      }
    }
  }
  title
  unitPrice {
    ...MonetaryAmount
  }
  totalBeforeTax {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}
${SellableDetailsFragmentDoc}`;
export const ShoppingCartOrderFragmentDoc = gql`
    fragment ShoppingCartOrder on Order {
  ...Order
  lineItems {
    ...OrderLineItem
  }
}
    ${OrderFragmentDoc}
${OrderLineItemFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  countryCode
  displayCountry
  displayFirstAdministrativeAreaLabel
  displayPostalCodeLabel
  displayCityLabel
  firstAdministrativeAreas {
    countryCode
    code
    displayName
  }
}
    `;
export const OrderEscalationFragmentDoc = gql`
    fragment OrderEscalation on OrderEscalation {
  id
  type
  status
  createdAt
  orderLineItemId
  consumerFriendlyId
}
    `;
export const OrderListLineItemFragmentDoc = gql`
    fragment OrderListLineItem on OrderLineItem {
  id
  state
  shipmentTracking {
    ...ShipmentTracking
  }
  source {
    type
    ... on OrderLineItemSellableSource {
      sellable {
        id
        images {
          ...MediaFile
        }
        variants {
          displayValueHtml
        }
      }
    }
  }
  title
}
    ${ShipmentTrackingFragmentDoc}
${MediaFileFragmentDoc}`;
export const OrderListEscalationFragmentDoc = gql`
    fragment OrderListEscalation on OrderEscalation {
  id
  orderId
  orderLineItemId
  consumerFriendlyId
  createdAt
  type
  status
  assignedTo {
    id
    firstName
  }
}
    `;
export const MyOrderListItemFragmentDoc = gql`
    fragment MyOrderListItem on Order {
  id
  consumerFriendlyId
  state
  categoryType
  sortTimestamp
  totalCost {
    ...MonetaryAmount
  }
  lineItems {
    ...OrderListLineItem
  }
  escalations {
    ...OrderListEscalation
  }
}
    ${MonetaryAmountFragmentDoc}
${OrderListLineItemFragmentDoc}
${OrderListEscalationFragmentDoc}`;
export const StartingSupportConversationFragmentDoc = gql`
    fragment StartingSupportConversation on SupportConversation {
  id
  conversationId
  consumerId
}
    `;
export const AuthenticationSessionStateFragmentDoc = gql`
    fragment AuthenticationSessionState on Session {
  id
  authenticationMethod
  authenticationState {
    handle
    handleId
    loginChallengeType
    resetPasswordChallengeVerified
  }
}
    `;
export const CategoryFilterDisplayMetadataFragmentDoc = gql`
    fragment CategoryFilterDisplayMetadata on Category {
  id
  slug
  pluralDisplayName
}
    `;
export const CategoryFilterBreadcrumbsFragmentDoc = gql`
    fragment CategoryFilterBreadcrumbs on Category {
  ...CategoryFilterDisplayMetadata
  ancestry: parents {
    ...CategoryFilterDisplayMetadata
  }
  children(recurse: false) {
    ...CategoryFilterDisplayMetadata
  }
}
    ${CategoryFilterDisplayMetadataFragmentDoc}`;
export const CategorySellableSearchResultFragmentDoc = gql`
    fragment CategorySellableSearchResult on SellableSearchEdge {
  cursor
  node {
    ...SellableCard
  }
}
    ${SellableCardFragmentDoc}`;
export const BucketedDisplayFacetFragmentDoc = gql`
    fragment BucketedDisplayFacet on BucketedDisplayFacet {
  displayName
  name
  alias
  buckets {
    displayName
    value
    count
    imageMetadata {
      ... on BackgroundFacetImageMetadata {
        type
        imageUrl
      }
      ... on IconFacetImageMetadata {
        type
        imageUrl
      }
    }
  }
}
    `;
export const NumericRangeDisplayFacetFragmentDoc = gql`
    fragment NumericRangeDisplayFacet on NumericRangeDisplayFacet {
  displayName
  name
  alias
  type
  lower
  upper
  scale
  upperCapped
}
    `;
export const DisplayFacetFragmentDoc = gql`
    fragment DisplayFacet on DisplayFacet {
  ...BucketedDisplayFacet
  ...NumericRangeDisplayFacet
}
    ${BucketedDisplayFacetFragmentDoc}
${NumericRangeDisplayFacetFragmentDoc}`;
export const SellableSearchResultPageMetadataFragmentDoc = gql`
    fragment SellableSearchResultPageMetadata on SellableSearchResultPageMetadata {
  pageTitle
  pageTitleImage {
    ...MediaFile
  }
  featuredFacets {
    ...DisplayFacet
  }
}
    ${MediaFileFragmentDoc}
${DisplayFacetFragmentDoc}`;
export const SellableSearchResultFragmentDoc = gql`
    fragment SellableSearchResult on SellableSearchEdge {
  cursor
  node {
    ...SellableCard
  }
}
    ${SellableCardFragmentDoc}`;
export const LeadForCurationsFragmentDoc = gql`
    fragment LeadForCurations on Lead {
  id
  consumer {
    id
    firstName
  }
  expert {
    id
    firstName
    lastName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
  }
  conversation {
    id
  }
  category {
    id
    contentAssets {
      bannerImages {
        title
        mimeType
        imageUrl
      }
    }
  }
  department {
    id
    slug
  }
}
    ${MediaFileFragmentDoc}`;
export const ExpertCuratedItemCustomizationFragmentDoc = gql`
    fragment ExpertCuratedItemCustomization on ExpertCuratedItemCustomization {
  sellable {
    id
  }
  createdAt
  title
  price {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const ProductCurationsExpertCuratedItemFragmentDoc = gql`
    fragment ProductCurationsExpertCuratedItem on ExpertCuratedItem {
  id
  createdBy {
    id
    firstName
    lastName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
  }
  tag {
    type
    displayLabel
  }
  note {
    id
    text
  }
  sellable {
    ...TrackableSellable
    originalPrice {
      ...MonetaryAmount
    }
    department {
      id
      type
      slug
    }
    variants {
      name
      displayName
      displayValueHtml
    }
    savedSellable {
      id
      saved
    }
    parent {
      id
      ...TrackableSellable
      savedSellable {
        id
        saved
      }
    }
  }
  priceOverride {
    ...MonetaryAmount
  }
  lineItemInCart {
    id
  }
  customizations {
    ...ExpertCuratedItemCustomization
  }
}
    ${MediaFileFragmentDoc}
${TrackableSellableFragmentDoc}
${MonetaryAmountFragmentDoc}
${ExpertCuratedItemCustomizationFragmentDoc}`;
export const ExpertCuratedItemByCategoryFragmentDoc = gql`
    fragment ExpertCuratedItemByCategory on ExpertCuratedItemsByCategory {
  category {
    id
    pluralDisplayName
    singularDisplayName
    slug
    department {
      id
      slug
    }
  }
  items {
    ...ProductCurationsExpertCuratedItem
  }
}
    ${ProductCurationsExpertCuratedItemFragmentDoc}`;
export const CategoryBannerAssetsFragmentDoc = gql`
    fragment CategoryBannerAssets on Category {
  contentAssets {
    bannerImages {
      imageUrl
    }
  }
}
    `;
export const CuratedItemsLeadFragmentDoc = gql`
    fragment CuratedItemsLead on Lead {
  id
  expert {
    id
    vanityId
    firstName
    lastName
  }
  delegateExpert {
    id
    firstName
    lastName
  }
  category {
    id
    slug
    ...CategoryBannerAssets
    department {
      ...DepartmentContext
    }
  }
  conversation {
    id
    externalId
  }
  consumerConversationMetrics {
    messageCount
  }
  expertConversationMetrics {
    messageCount
  }
}
    ${CategoryBannerAssetsFragmentDoc}
${DepartmentContextFragmentDoc}`;
export const SubcategoryInfoFragmentDoc = gql`
    fragment SubcategoryInfo on Category {
  id
  slug
  pluralDisplayName
}
    `;
export const CategoryInfoFragmentDoc = gql`
    fragment CategoryInfo on Category {
  id
  slug
  type
  pluralDisplayName
  contentAssets {
    communityPoster {
      imageUrl
    }
  }
  children(recurse: false) {
    ...SubcategoryInfo
  }
  parents {
    id
    children(recurse: false) {
      ...SubcategoryInfo
    }
  }
  brands(activeOnly: true) {
    ...Brand
  }
}
    ${SubcategoryInfoFragmentDoc}
${BrandFragmentDoc}`;
export const HomeExpertFragmentDoc = gql`
    fragment HomeExpert on BusinessUser {
  id
  firstName
  department {
    id
    type
  }
}
    `;
export const MostRecentLeadFragmentDoc = gql`
    fragment MostRecentLead on Lead {
  id
  conversation {
    id
  }
  expert {
    ...HomeExpert
  }
}
    ${HomeExpertFragmentDoc}`;
export const ExpertProfileHighlightsFragmentDoc = gql`
    fragment ExpertProfileHighlights on ProfileHighlight {
  type {
    id
    icon
    displayName
  }
  value
  secondaryValue
}
    `;
export const DepartmentExpertFragmentDoc = gql`
    fragment DepartmentExpert on BusinessUser {
  id
  vanityId
  expertProfile {
    id
    background
    backgroundRichText
    headline
    gallery {
      caption
      mediaFile {
        ...MediaFile
      }
    }
    highlights {
      ...ExpertProfileHighlights
    }
    profilePhoto {
      ...MediaFile
    }
    socialMediaLinks {
      socialMediaType
      url
    }
  }
  expertAttributes {
    acceptingNewRequests
    placeholderExpert
  }
  expertStats {
    averageRating
    totalMessages
    totalReviews
    totalLeads
  }
  firstName
  lastName
  department {
    id
    type
  }
}
    ${MediaFileFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}`;
export const DepartmentLeadFragmentDoc = gql`
    fragment DepartmentLead on Lead {
  id
  curationSummary {
    lastCurationSentAt
  }
  conversation {
    id
  }
  category {
    id
    type
  }
  expert {
    ...DepartmentExpert
  }
}
    ${DepartmentExpertFragmentDoc}`;
export const DepartmentConsumerExpertReviewFragmentDoc = gql`
    fragment DepartmentConsumerExpertReview on ConsumerExpertReview {
  id
  comments
  goodQualities
  headline
  rating
  consumer {
    id
    firstName
    lastName
  }
  expert {
    id
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    firstName
    lastName
  }
  reviewedAt
}
    ${MediaFileFragmentDoc}`;
export const DepartmentSearchFacetSelectionsFragmentDoc = gql`
    fragment DepartmentSearchFacetSelections on FacetSelectionPayload {
  name
  displayName
  bucketValues
}
    `;
export const DepartmentTopLevelCategoryFragmentDoc = gql`
    fragment DepartmentTopLevelCategory on Category {
  id
  slug
  pluralDisplayName
  contentAssets {
    communityPoster {
      imageUrl
    }
  }
}
    `;
export const ExpertProfilePhotoCarouselFragmentDoc = gql`
    fragment ExpertProfilePhotoCarousel on ExpertProfile {
  id
  profilePhoto {
    ...MediaFile
  }
  gallery {
    caption
    mediaFile {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const ExpertProfileBusinessUserFragmentDoc = gql`
    fragment ExpertProfileBusinessUser on ExpertProfile {
  id
  headline
  background
  backgroundRichText
  location
  highlights {
    ...ExpertProfileHighlights
  }
  profilePhoto {
    ...MediaFile
  }
  ...ExpertProfilePhotoCarousel
  socialMediaLinks {
    socialMediaType
    url
  }
  favoriteBrands {
    ...Brand
  }
  currentGears {
    id
    title
    friendlyId
    slug
    type
    brand {
      id
      displayName
    }
    images {
      ...MediaFile
    }
  }
}
    ${ExpertProfileHighlightsFragmentDoc}
${MediaFileFragmentDoc}
${ExpertProfilePhotoCarouselFragmentDoc}
${BrandFragmentDoc}`;
export const ExpertReviewFragmentDoc = gql`
    fragment ExpertReview on ConsumerExpertReview {
  id
  consumerName
  consumerLocation
  rating
  comments
  headline
  goodQualities
  reviewedAt
}
    `;
export const ExpertBusinessUserFragmentDoc = gql`
    fragment ExpertBusinessUser on BusinessUser {
  id
  vanityId
  messagingUser {
    id
  }
  expertAttributes {
    placeholderExpert
    acceptingNewRequests
    categories {
      id
      slug
      pluralDisplayName
    }
  }
  department {
    ...DepartmentContext
    topLevelCategory {
      id
      slug
    }
  }
  firstName
  lastName
  expertProfile {
    ...ExpertProfileBusinessUser
  }
  consumerExpertReviewConnection {
    edges {
      node {
        ...ExpertReview
      }
    }
  }
  expertStats {
    ...ExpertStats
  }
}
    ${DepartmentContextFragmentDoc}
${ExpertProfileBusinessUserFragmentDoc}
${ExpertReviewFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const TopRecommendedSellableCategoryFragmentDoc = gql`
    fragment TopRecommendedSellableCategory on Category {
  id
  pluralDisplayName
}
    `;
export const TopRecommendedSellableFragmentDoc = gql`
    fragment TopRecommendedSellable on ExpertTopRecommendedSellable {
  sellable {
    id
    friendlyId
    slug
    type
    images {
      ...MediaFile
    }
    title
    brand {
      id
      displayName
      logo {
        ...MediaFile
      }
    }
  }
  timesRecommended
}
    ${MediaFileFragmentDoc}`;
export const ExpertTopSellablesFragmentDoc = gql`
    fragment ExpertTopSellables on ExpertCategoryTopRecommendedSellable {
  displayTitle
  category {
    ...TopRecommendedSellableCategory
  }
  topRecommendedSellables {
    ...TopRecommendedSellable
  }
}
    ${TopRecommendedSellableCategoryFragmentDoc}
${TopRecommendedSellableFragmentDoc}`;
export const ExpertInfoFragmentDoc = gql`
    fragment ExpertInfo on BusinessUser {
  id
  firstName
  expertProfile {
    id
    profilePhoto {
      id
      url
    }
  }
}
    `;
export const LoggedOutHomeExpertFragmentDoc = gql`
    fragment LoggedOutHomeExpert on BusinessUser {
  id
  firstName
  lastName
  expertProfile {
    id
    headline
    background
    profilePhoto {
      ...MediaFile
    }
  }
  expertStats {
    ...ExpertStats
  }
}
    ${MediaFileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const LoggedOutHomeFixedExpertFragmentDoc = gql`
    fragment LoggedOutHomeFixedExpert on BusinessUser {
  id
  firstName
  lastName
  expertProfile {
    id
    headline
    background
    profilePhoto {
      ...MediaFile
    }
  }
  expertStats {
    ...ExpertStats
  }
}
    ${MediaFileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const LoggedOutHomeDepartmentFragmentDoc = gql`
    fragment LoggedOutHomeDepartment on Department {
  id
  slug
  type
  displayName
  acceptingRequests
  launched
  topLevelCategories {
    id
    slug
  }
}
    `;
export const LeadOverviewFragmentDoc = gql`
    fragment LeadOverview on Lead {
  id
  conversation {
    id
    externalId
  }
  offers {
    id
    state
  }
}
    `;
export const SupportConversationFragmentDoc = gql`
    fragment SupportConversation on SupportConversation {
  id
  conversation {
    id
    externalId
  }
}
    `;
export const LeadExpertProfileExpertProfileFragmentDoc = gql`
    fragment LeadExpertProfileExpertProfile on ExpertProfile {
  id
  headline
  background
  quotes
  socialMediaLinks {
    socialMediaType
    url
  }
  highlights {
    type {
      id
      icon
      displayName
    }
    value
    secondaryValue
  }
  profilePhoto {
    ...MediaFile
  }
}
    ${MediaFileFragmentDoc}`;
export const LeadExpertProfileExpertFragmentDoc = gql`
    fragment LeadExpertProfileExpert on BusinessUser {
  id
  vanityId
  firstName
  lastName
  expertProfile {
    ...LeadExpertProfileExpertProfile
  }
  expertStats {
    ...ExpertStats
  }
}
    ${LeadExpertProfileExpertProfileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const LeadExpertProfileFragmentDoc = gql`
    fragment LeadExpertProfile on Lead {
  id
  expert {
    ...LeadExpertProfileExpert
  }
  consumerConversationMetrics {
    messageCount
  }
  expertConversationMetrics {
    messageCount
  }
}
    ${LeadExpertProfileExpertFragmentDoc}`;
export const ConversationExpertFragmentDoc = gql`
    fragment ConversationExpert on BusinessUser {
  id
  vanityId
  firstName
  lastName
  expertProfile {
    id
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      value
      secondaryValue
      type {
        id
        icon
      }
    }
  }
  expertAttributes {
    placeholderExpert
  }
  expertStats {
    totalMessages
    totalReviews
  }
}
    ${MediaFileFragmentDoc}`;
export const ConversationWithMetaDataFragmentDoc = gql`
    fragment ConversationWithMetaData on Conversation {
  id
  externalId
  title
  active
  lead {
    id
    expert {
      ...ConversationExpert
    }
    consumerConversationMetrics {
      messageCount
    }
    expertConversationMetrics {
      messageCount
    }
    dealbotConversationMetrics {
      messageCount
    }
    consumerInitialAction
  }
}
    ${ConversationExpertFragmentDoc}`;
export const FeaturedExpertFragmentDoc = gql`
    fragment FeaturedExpert on BusinessUser {
  id
  vanityId
  firstName
  lastName
  department {
    id
    type
    topLevelCategory {
      id
      singularDisplayName
      pluralDisplayName
    }
  }
  expertProfile {
    location
    background
    headline
    profilePhoto {
      ...MediaFile
    }
    highlights {
      ...ExpertProfileHighlights
    }
  }
  expertStats {
    averageRating
    totalLeads
    totalReviews
  }
}
    ${MediaFileFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}`;
export const ShippingMethodCostFragmentDoc = gql`
    fragment ShippingMethodCost on ShippingMethodCost {
  shippingMethod
  cost {
    ...MonetaryAmount
  }
  estimatedToArriveAt
}
    ${MonetaryAmountFragmentDoc}`;
export const ExpertTipPercentageFragmentDoc = gql`
    fragment ExpertTipPercentage on ExpertTipPercentage {
  expert {
    id
    firstName
    lastName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
  }
  percentOfTip
}
    ${MediaFileFragmentDoc}`;
export const OrderSellableInfoFragmentDoc = gql`
    fragment OrderSellableInfo on OrderLineItemSellableSource {
  sellable {
    images {
      url
    }
    title
    originalPrice {
      ...MonetaryAmount
    }
    salePrice {
      ...MonetaryAmount
    }
  }
  overridePrice {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const TrackableOrderFragmentDoc = gql`
    fragment TrackableOrder on Order {
  id
  state
  tax {
    ...MonetaryAmount
  }
  tip {
    ...MonetaryAmount
  }
  totalCost {
    ...MonetaryAmount
  }
  totalShippingCost: totalCostOnlyIncluding(costComponents: [SHIPMENT]) {
    ...MonetaryAmount
  }
  subtotal: totalCostOnlyIncluding(costComponents: [CORE, GRATUITY]) {
    ...MonetaryAmount
  }
  appliedPromotionEntry {
    promotion {
      id
      code
    }
  }
  lineItems {
    id
    quantity
    source {
      ... on OrderLineItemSellableSource {
        sellable {
          ...TrackableSellable
        }
      }
    }
  }
}
    ${MonetaryAmountFragmentDoc}
${TrackableSellableFragmentDoc}`;
export const TipContainerOrderFragmentDoc = gql`
    fragment TipContainerOrder on Order {
  id
  tip {
    ...MonetaryAmount
  }
  associatedLeads {
    id
    expert {
      id
      vanityId
      firstName
    }
    expertConversationMetrics {
      initialSentAt
      messageCount
    }
    consumerConversationMetrics {
      messageCount
    }
  }
  lineItems {
    id
    source {
      type
      ... on OrderLineItemSellableSource {
        sellable {
          id
          type
          originalPrice {
            ...MonetaryAmount
          }
        }
      }
    }
  }
  subtotal: totalCostOnlyIncluding(costComponents: [CORE, GRATUITY]) {
    ...MonetaryAmount
  }
}
    ${MonetaryAmountFragmentDoc}`;
export const OrderWithLineItemsFragmentDoc = gql`
    fragment OrderWithLineItems on Order {
  ...Order
  ...TrackableOrder
  ...TipContainerOrder
  estimatedToArriveAt
  shippingMethod
  consumerFriendlyId
  appliedPromotionEntry {
    applied
    discount {
      ...MonetaryAmount
    }
    promotion {
      id
      code
    }
  }
  promotionEntries {
    applied
    discount {
      ...MonetaryAmount
    }
    promotion {
      id
      code
    }
  }
  chargeableStatus(useCase: PURCHASE) {
    type
    message
  }
  associatedLeads {
    id
    expert {
      id
      vanityId
      firstName
      expertAttributes {
        placeholderExpert
      }
    }
    expertConversationMetrics {
      initialSentAt
      messageCount
    }
    consumerConversationMetrics {
      messageCount
    }
  }
  remainingBalance {
    ...MonetaryAmount
  }
  minimumDeposit {
    ...MonetaryAmount
  }
  depositPaidAt
  fullPaymentDueAt
  paidInFullAt
  paidAmount {
    ...MonetaryAmount
  }
  lineItems {
    ...OrderLineItem
  }
  serviceLocation {
    displayTitle
  }
  simpleCuratedOrder {
    id
    type
  }
}
    ${OrderFragmentDoc}
${TrackableOrderFragmentDoc}
${TipContainerOrderFragmentDoc}
${MonetaryAmountFragmentDoc}
${OrderLineItemFragmentDoc}`;
export const ExpertCuratedItemNoteFragmentDoc = gql`
    fragment ExpertCuratedItemNote on ExpertCuratedItemNote {
  id
  text
  useCount
  createdBy {
    id
    firstName
    lastName
    vanityId
    expertProfile {
      id
      headline
      profilePhoto {
        ...MediaFile
      }
    }
  }
  sellable {
    id
    categories {
      id
      singularDisplayName
    }
  }
}
    ${MediaFileFragmentDoc}`;
export const ExistingLeadFragmentDoc = gql`
    fragment ExistingLead on Lead {
  id
  conversation {
    id
    externalId
  }
}
    `;
export const ProductExpertFragmentDoc = gql`
    fragment ProductExpert on BusinessUser {
  id
  vanityId
  expertStats {
    ...ExpertStats
  }
  firstName
  lastName
  expertAttributes {
    placeholderExpert
  }
  expertProfile {
    id
    headline
    highlights {
      ...ExpertProfileHighlights
    }
    profilePhoto {
      ...MediaFile
    }
  }
}
    ${ExpertStatsFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}
${MediaFileFragmentDoc}`;
export const ProductRecommendedExpertFragmentDoc = gql`
    fragment ProductRecommendedExpert on RecommendExpertPayload {
  existingLead {
    ...ExistingLead
  }
  expert {
    ...ProductExpert
  }
}
    ${ExistingLeadFragmentDoc}
${ProductExpertFragmentDoc}`;
export const GlobalStatsFragmentDoc = gql`
    fragment GlobalStats on GlobalStatsAggregateExpertReport {
  conversationsCountThisWeek
  conversationsCountTotal
  curationsCountTotal
  curationsCountThisWeek
  reviewsCount
  averageExpertRating
}
    `;
export const TopLevelCategoryFragmentDoc = gql`
    fragment TopLevelCategory on Category {
  id
  slug
  pluralDisplayName
  contentAssets {
    communityPoster {
      imageUrl
    }
  }
}
    `;
export const CommunityLeadExpertFragmentDoc = gql`
    fragment CommunityLeadExpert on BusinessUser {
  id
  expertProfile {
    ...ExpertProfilePhotoCarousel
    id
    background
    socialMediaLinks {
      socialMediaType
      url
    }
    highlights {
      ...ExpertProfileHighlights
    }
    headline
    profilePhoto {
      id
      url
    }
  }
  expertAttributes {
    placeholderExpert
    acceptingNewRequests
  }
  expertStats {
    totalReviews
    totalLeads
    averageRating
  }
  department {
    id
    type
  }
  firstName
  lastName
}
    ${ExpertProfilePhotoCarouselFragmentDoc}
${ExpertProfileHighlightsFragmentDoc}`;
export const ReviewSummaryBucketsFragmentDoc = gql`
    fragment ReviewSummaryBuckets on BucketedDisplayFacet {
  buckets {
    count
    value
  }
}
    `;
export const OrderEscalationSummaryFragmentDoc = gql`
    fragment OrderEscalationSummary on OrderEscalation {
  id
  consumerFriendlyId
  createdAt
  type
  status
  assignedTo {
    id
    firstName
  }
}
    `;
export const OrderEscalationSearchResultFragmentDoc = gql`
    fragment OrderEscalationSearchResult on OrderEscalationEdge {
  cursor
  node {
    ...OrderEscalationSummary
  }
}
    ${OrderEscalationSummaryFragmentDoc}`;
export const TopicPageExpertFragmentDoc = gql`
    fragment TopicPageExpert on BusinessUser {
  id
  firstName
  lastName
  expertProfile {
    id
    profilePhoto {
      ...MediaFile
    }
    location
  }
  expertStats {
    ...ExpertStats
  }
}
    ${MediaFileFragmentDoc}
${ExpertStatsFragmentDoc}`;
export const AirportTypeaheadSearchDocument = gql`
    query AirportTypeaheadSearch($query: AirportTypeaheadQuery!, $first: Int) {
  airportTypeahead(query: $query, first: $first) {
    hits {
      ...AirportTypeaheadResult
    }
  }
}
    ${AirportTypeaheadResultFragmentDoc}`;
export type AirportTypeaheadSearchComponentProps = Omit<Omit<ReactApollo.QueryProps<AirportTypeaheadSearchQuery, AirportTypeaheadSearchQueryVariables>, 'query'>, 'variables'> & { variables: AirportTypeaheadSearchQueryVariables };

    export const AirportTypeaheadSearchComponent = (props: AirportTypeaheadSearchComponentProps) => (
      <ReactApollo.Query<AirportTypeaheadSearchQuery, AirportTypeaheadSearchQueryVariables> query={AirportTypeaheadSearchDocument} {...props} />
    );
    
export type AirportTypeaheadSearchProps<TChildProps = {}> = Partial<ReactApollo.DataProps<AirportTypeaheadSearchQuery, AirportTypeaheadSearchQueryVariables>> & TChildProps;
export function withAirportTypeaheadSearch<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AirportTypeaheadSearchQuery,
  AirportTypeaheadSearchQueryVariables,
  AirportTypeaheadSearchProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, AirportTypeaheadSearchQuery, AirportTypeaheadSearchQueryVariables, AirportTypeaheadSearchProps<TChildProps>>(AirportTypeaheadSearchDocument, {
      alias: 'withAirportTypeaheadSearch',
      ...operationOptions
    });
};
export const ExpertPhoneNumberBySlugDocument = gql`
    query ExpertPhoneNumberBySlug($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    recommendExpertForConsumer {
      expert {
        id
        firstName
        lastName
        expertProfile {
          id
          profilePhoto {
            id
            url
          }
        }
        assignedPhone: assignedAddress(type: SMS)
      }
    }
  }
}
    `;
export type ExpertPhoneNumberBySlugComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>, 'query'>, 'variables'> & { variables: ExpertPhoneNumberBySlugQueryVariables };

    export const ExpertPhoneNumberBySlugComponent = (props: ExpertPhoneNumberBySlugComponentProps) => (
      <ReactApollo.Query<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables> query={ExpertPhoneNumberBySlugDocument} {...props} />
    );
    
export type ExpertPhoneNumberBySlugProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables>> & TChildProps;
export function withExpertPhoneNumberBySlug<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertPhoneNumberBySlugQuery,
  ExpertPhoneNumberBySlugQueryVariables,
  ExpertPhoneNumberBySlugProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertPhoneNumberBySlugQuery, ExpertPhoneNumberBySlugQueryVariables, ExpertPhoneNumberBySlugProps<TChildProps>>(ExpertPhoneNumberBySlugDocument, {
      alias: 'withExpertPhoneNumberBySlug',
      ...operationOptions
    });
};
export const UserLoginTokenDocument = gql`
    query UserLoginToken {
  me {
    id
    loginToken
  }
}
    `;
export type UserLoginTokenComponentProps = Omit<Omit<ReactApollo.QueryProps<UserLoginTokenQuery, UserLoginTokenQueryVariables>, 'query'>, 'variables'> & { variables?: UserLoginTokenQueryVariables };

    export const UserLoginTokenComponent = (props: UserLoginTokenComponentProps) => (
      <ReactApollo.Query<UserLoginTokenQuery, UserLoginTokenQueryVariables> query={UserLoginTokenDocument} {...props} />
    );
    
export type UserLoginTokenProps<TChildProps = {}> = Partial<ReactApollo.DataProps<UserLoginTokenQuery, UserLoginTokenQueryVariables>> & TChildProps;
export function withUserLoginToken<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UserLoginTokenQuery,
  UserLoginTokenQueryVariables,
  UserLoginTokenProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, UserLoginTokenQuery, UserLoginTokenQueryVariables, UserLoginTokenProps<TChildProps>>(UserLoginTokenDocument, {
      alias: 'withUserLoginToken',
      ...operationOptions
    });
};
export const CuratedItemsForLeadDocument = gql`
    query CuratedItemsForLead($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    byCategories {
      id
      categories {
        ...HeroExpertCuratedItemByCategory
      }
    }
    items {
      ...HeroExpertCuratedItemImage
    }
  }
  lead(id: $leadId) {
    ...HeroCuratedItemsLead
  }
  expertCuratedOrdersForLeadConnection(query: {leadId: $leadId, showClosed: true}) {
    edges {
      node {
        ...ExpertCuratedOrder
      }
    }
  }
}
    ${HeroExpertCuratedItemByCategoryFragmentDoc}
${HeroExpertCuratedItemImageFragmentDoc}
${HeroCuratedItemsLeadFragmentDoc}
${ExpertCuratedOrderFragmentDoc}`;
export type CuratedItemsForLeadComponentProps = Omit<Omit<ReactApollo.QueryProps<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>, 'query'>, 'variables'> & { variables: CuratedItemsForLeadQueryVariables };

    export const CuratedItemsForLeadComponent = (props: CuratedItemsForLeadComponentProps) => (
      <ReactApollo.Query<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables> query={CuratedItemsForLeadDocument} {...props} />
    );
    
export type CuratedItemsForLeadProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables>> & TChildProps;
export function withCuratedItemsForLead<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CuratedItemsForLeadQuery,
  CuratedItemsForLeadQueryVariables,
  CuratedItemsForLeadProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CuratedItemsForLeadQuery, CuratedItemsForLeadQueryVariables, CuratedItemsForLeadProps<TChildProps>>(CuratedItemsForLeadDocument, {
      alias: 'withCuratedItemsForLead',
      ...operationOptions
    });
};
export const DepartmentDetailedReviewsDocument = gql`
    query DepartmentDetailedReviews($departmentId: DepartmentId!) {
  department(id: $departmentId) {
    id
    displayName
    slug
    reviewSummary {
      averageRating
      totalReviews
    }
    consumerExpertReviewConnection(filter: {source: SHOPPER_APPROVED}, first: 15) {
      edges {
        node {
          ...DepartmentExpertReview
        }
      }
    }
  }
}
    ${DepartmentExpertReviewFragmentDoc}`;
export type DepartmentDetailedReviewsComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentDetailedReviewsQueryVariables };

    export const DepartmentDetailedReviewsComponent = (props: DepartmentDetailedReviewsComponentProps) => (
      <ReactApollo.Query<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables> query={DepartmentDetailedReviewsDocument} {...props} />
    );
    
export type DepartmentDetailedReviewsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables>> & TChildProps;
export function withDepartmentDetailedReviews<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentDetailedReviewsQuery,
  DepartmentDetailedReviewsQueryVariables,
  DepartmentDetailedReviewsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentDetailedReviewsQuery, DepartmentDetailedReviewsQueryVariables, DepartmentDetailedReviewsProps<TChildProps>>(DepartmentDetailedReviewsDocument, {
      alias: 'withDepartmentDetailedReviews',
      ...operationOptions
    });
};
export const EngagementChannelCategoryAssetsDocument = gql`
    query EngagementChannelCategoryAssets($categoryId: CategoryId!) {
  category(categoryId: $categoryId) {
    ...EngagementChannelCategory
  }
}
    ${EngagementChannelCategoryFragmentDoc}`;
export type EngagementChannelCategoryAssetsComponentProps = Omit<Omit<ReactApollo.QueryProps<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>, 'query'>, 'variables'> & { variables: EngagementChannelCategoryAssetsQueryVariables };

    export const EngagementChannelCategoryAssetsComponent = (props: EngagementChannelCategoryAssetsComponentProps) => (
      <ReactApollo.Query<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables> query={EngagementChannelCategoryAssetsDocument} {...props} />
    );
    
export type EngagementChannelCategoryAssetsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables>> & TChildProps;
export function withEngagementChannelCategoryAssets<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  EngagementChannelCategoryAssetsQuery,
  EngagementChannelCategoryAssetsQueryVariables,
  EngagementChannelCategoryAssetsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, EngagementChannelCategoryAssetsQuery, EngagementChannelCategoryAssetsQueryVariables, EngagementChannelCategoryAssetsProps<TChildProps>>(EngagementChannelCategoryAssetsDocument, {
      alias: 'withEngagementChannelCategoryAssets',
      ...operationOptions
    });
};
export const PathSlugForCategoryDocument = gql`
    query PathSlugForCategory($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    slug
    ancestorWithPath {
      id
      slug
    }
  }
}
    `;
export type PathSlugForCategoryComponentProps = Omit<Omit<ReactApollo.QueryProps<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>, 'query'>, 'variables'> & { variables: PathSlugForCategoryQueryVariables };

    export const PathSlugForCategoryComponent = (props: PathSlugForCategoryComponentProps) => (
      <ReactApollo.Query<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables> query={PathSlugForCategoryDocument} {...props} />
    );
    
export type PathSlugForCategoryProps<TChildProps = {}> = Partial<ReactApollo.DataProps<PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables>> & TChildProps;
export function withPathSlugForCategory<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  PathSlugForCategoryQuery,
  PathSlugForCategoryQueryVariables,
  PathSlugForCategoryProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, PathSlugForCategoryQuery, PathSlugForCategoryQueryVariables, PathSlugForCategoryProps<TChildProps>>(PathSlugForCategoryDocument, {
      alias: 'withPathSlugForCategory',
      ...operationOptions
    });
};
export const SellableBrandCategoryDocument = gql`
    query SellableBrandCategory($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    brand {
      ...Brand
    }
    categories {
      ...CategoryModal
    }
  }
}
    ${BrandFragmentDoc}
${CategoryModalFragmentDoc}`;
export type SellableBrandCategoryComponentProps = Omit<Omit<ReactApollo.QueryProps<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>, 'query'>, 'variables'> & { variables: SellableBrandCategoryQueryVariables };

    export const SellableBrandCategoryComponent = (props: SellableBrandCategoryComponentProps) => (
      <ReactApollo.Query<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables> query={SellableBrandCategoryDocument} {...props} />
    );
    
export type SellableBrandCategoryProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables>> & TChildProps;
export function withSellableBrandCategory<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SellableBrandCategoryQuery,
  SellableBrandCategoryQueryVariables,
  SellableBrandCategoryProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SellableBrandCategoryQuery, SellableBrandCategoryQueryVariables, SellableBrandCategoryProps<TChildProps>>(SellableBrandCategoryDocument, {
      alias: 'withSellableBrandCategory',
      ...operationOptions
    });
};
export const AddItemsToOrderDocument = gql`
    mutation AddItemsToOrder($input: AddItemsToOrderInput!) {
  addItemsToOrder(input: $input) {
    order {
      id
    }
  }
}
    `;
export type AddItemsToOrderMutationFn = ReactApollo.MutationFn<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>;
export type AddItemsToOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: AddItemsToOrderMutationVariables };

    export const AddItemsToOrderComponent = (props: AddItemsToOrderComponentProps) => (
      <ReactApollo.Mutation<AddItemsToOrderMutation, AddItemsToOrderMutationVariables> mutation={AddItemsToOrderDocument} {...props} />
    );
    
export type AddItemsToOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<AddItemsToOrderMutation, AddItemsToOrderMutationVariables>> & TChildProps;
export function withAddItemsToOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AddItemsToOrderMutation,
  AddItemsToOrderMutationVariables,
  AddItemsToOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, AddItemsToOrderMutation, AddItemsToOrderMutationVariables, AddItemsToOrderProps<TChildProps>>(AddItemsToOrderDocument, {
      alias: 'withAddItemsToOrder',
      ...operationOptions
    });
};
export const SellableForModalDocument = gql`
    query SellableForModal($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    ...SellableForModal
  }
}
    ${SellableForModalFragmentDoc}`;
export type SellableForModalComponentProps = Omit<Omit<ReactApollo.QueryProps<SellableForModalQuery, SellableForModalQueryVariables>, 'query'>, 'variables'> & { variables: SellableForModalQueryVariables };

    export const SellableForModalComponent = (props: SellableForModalComponentProps) => (
      <ReactApollo.Query<SellableForModalQuery, SellableForModalQueryVariables> query={SellableForModalDocument} {...props} />
    );
    
export type SellableForModalProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SellableForModalQuery, SellableForModalQueryVariables>> & TChildProps;
export function withSellableForModal<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SellableForModalQuery,
  SellableForModalQueryVariables,
  SellableForModalProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SellableForModalQuery, SellableForModalQueryVariables, SellableForModalProps<TChildProps>>(SellableForModalDocument, {
      alias: 'withSellableForModal',
      ...operationOptions
    });
};
export const ExpertByCategoryDocument = gql`
    query ExpertByCategory($categoryId: CategoryId!) {
  category(categoryId: $categoryId) {
    id
    ancestorWithPath {
      id
      name
      slug
      startPathUrl
      contentAssets {
        bannerImages {
          imageUrl
        }
      }
    }
    experts {
      ...ChatWidgetExpert
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type ExpertByCategoryComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>, 'query'>, 'variables'> & { variables: ExpertByCategoryQueryVariables };

    export const ExpertByCategoryComponent = (props: ExpertByCategoryComponentProps) => (
      <ReactApollo.Query<ExpertByCategoryQuery, ExpertByCategoryQueryVariables> query={ExpertByCategoryDocument} {...props} />
    );
    
export type ExpertByCategoryProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertByCategoryQuery, ExpertByCategoryQueryVariables>> & TChildProps;
export function withExpertByCategory<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertByCategoryQuery,
  ExpertByCategoryQueryVariables,
  ExpertByCategoryProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertByCategoryQuery, ExpertByCategoryQueryVariables, ExpertByCategoryProps<TChildProps>>(ExpertByCategoryDocument, {
      alias: 'withExpertByCategory',
      ...operationOptions
    });
};
export const ExpertPhoneNumberDocument = gql`
    query ExpertPhoneNumber($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    recommendExpertForConsumer {
      expert {
        id
        assignedPhone: assignedAddress(type: SMS)
      }
    }
  }
}
    `;
export type ExpertPhoneNumberComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>, 'query'>, 'variables'> & { variables: ExpertPhoneNumberQueryVariables };

    export const ExpertPhoneNumberComponent = (props: ExpertPhoneNumberComponentProps) => (
      <ReactApollo.Query<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables> query={ExpertPhoneNumberDocument} {...props} />
    );
    
export type ExpertPhoneNumberProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables>> & TChildProps;
export function withExpertPhoneNumber<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertPhoneNumberQuery,
  ExpertPhoneNumberQueryVariables,
  ExpertPhoneNumberProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertPhoneNumberQuery, ExpertPhoneNumberQueryVariables, ExpertPhoneNumberProps<TChildProps>>(ExpertPhoneNumberDocument, {
      alias: 'withExpertPhoneNumber',
      ...operationOptions
    });
};
export const RatesTableDocument = gql`
    query RatesTable($id: SellableId!) {
  sellable(id: $id) {
    id
    variationMatrix {
      ...VariationMatrix
    }
  }
}
    ${VariationMatrixFragmentDoc}`;
export type RatesTableComponentProps = Omit<Omit<ReactApollo.QueryProps<RatesTableQuery, RatesTableQueryVariables>, 'query'>, 'variables'> & { variables: RatesTableQueryVariables };

    export const RatesTableComponent = (props: RatesTableComponentProps) => (
      <ReactApollo.Query<RatesTableQuery, RatesTableQueryVariables> query={RatesTableDocument} {...props} />
    );
    
export type RatesTableProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RatesTableQuery, RatesTableQueryVariables>> & TChildProps;
export function withRatesTable<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RatesTableQuery,
  RatesTableQueryVariables,
  RatesTableProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RatesTableQuery, RatesTableQueryVariables, RatesTableProps<TChildProps>>(RatesTableDocument, {
      alias: 'withRatesTable',
      ...operationOptions
    });
};
export const RatesTableSellableDocument = gql`
    query RatesTableSellable($ids: [SellableId!]!) {
  sellables(ids: $ids) {
    ...SellablePricing
  }
}
    ${SellablePricingFragmentDoc}`;
export type RatesTableSellableComponentProps = Omit<Omit<ReactApollo.QueryProps<RatesTableSellableQuery, RatesTableSellableQueryVariables>, 'query'>, 'variables'> & { variables: RatesTableSellableQueryVariables };

    export const RatesTableSellableComponent = (props: RatesTableSellableComponentProps) => (
      <ReactApollo.Query<RatesTableSellableQuery, RatesTableSellableQueryVariables> query={RatesTableSellableDocument} {...props} />
    );
    
export type RatesTableSellableProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RatesTableSellableQuery, RatesTableSellableQueryVariables>> & TChildProps;
export function withRatesTableSellable<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RatesTableSellableQuery,
  RatesTableSellableQueryVariables,
  RatesTableSellableProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RatesTableSellableQuery, RatesTableSellableQueryVariables, RatesTableSellableProps<TChildProps>>(RatesTableSellableDocument, {
      alias: 'withRatesTableSellable',
      ...operationOptions
    });
};
export const SelectExperienceVariationOptionDocument = gql`
    mutation SelectExperienceVariationOption($input: SelectExpertCuratedOrderVariationOptionInput!) {
  selectExpertCuratedOrderVariationOption(input: $input) {
    expertCuratedOrder {
      ...ExpertCuratedOrder
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type SelectExperienceVariationOptionMutationFn = ReactApollo.MutationFn<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>;
export type SelectExperienceVariationOptionComponentProps = Omit<Omit<ReactApollo.MutationProps<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SelectExperienceVariationOptionMutationVariables };

    export const SelectExperienceVariationOptionComponent = (props: SelectExperienceVariationOptionComponentProps) => (
      <ReactApollo.Mutation<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables> mutation={SelectExperienceVariationOptionDocument} {...props} />
    );
    
export type SelectExperienceVariationOptionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables>> & TChildProps;
export function withSelectExperienceVariationOption<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SelectExperienceVariationOptionMutation,
  SelectExperienceVariationOptionMutationVariables,
  SelectExperienceVariationOptionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SelectExperienceVariationOptionMutation, SelectExperienceVariationOptionMutationVariables, SelectExperienceVariationOptionProps<TChildProps>>(SelectExperienceVariationOptionDocument, {
      alias: 'withSelectExperienceVariationOption',
      ...operationOptions
    });
};
export const DurationSelectorDocument = gql`
    query DurationSelector($id: SellableId!) {
  sellable(id: $id) {
    ...DurationSelector
  }
}
    ${DurationSelectorFragmentDoc}`;
export type DurationSelectorComponentProps = Omit<Omit<ReactApollo.QueryProps<DurationSelectorQuery, DurationSelectorQueryVariables>, 'query'>, 'variables'> & { variables: DurationSelectorQueryVariables };

    export const DurationSelectorComponent = (props: DurationSelectorComponentProps) => (
      <ReactApollo.Query<DurationSelectorQuery, DurationSelectorQueryVariables> query={DurationSelectorDocument} {...props} />
    );
    
export type DurationSelectorProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DurationSelectorQuery, DurationSelectorQueryVariables>> & TChildProps;
export function withDurationSelector<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DurationSelectorQuery,
  DurationSelectorQueryVariables,
  DurationSelectorProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DurationSelectorQuery, DurationSelectorQueryVariables, DurationSelectorProps<TChildProps>>(DurationSelectorDocument, {
      alias: 'withDurationSelector',
      ...operationOptions
    });
};
export const RecommendedExpertForRequestDocument = gql`
    query RecommendedExpertForRequest($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    expert {
      id
    }
  }
}
    `;
export type RecommendedExpertForRequestComponentProps = Omit<Omit<ReactApollo.QueryProps<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>, 'query'>, 'variables'> & { variables: RecommendedExpertForRequestQueryVariables };

    export const RecommendedExpertForRequestComponent = (props: RecommendedExpertForRequestComponentProps) => (
      <ReactApollo.Query<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables> query={RecommendedExpertForRequestDocument} {...props} />
    );
    
export type RecommendedExpertForRequestProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables>> & TChildProps;
export function withRecommendedExpertForRequest<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RecommendedExpertForRequestQuery,
  RecommendedExpertForRequestQueryVariables,
  RecommendedExpertForRequestProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RecommendedExpertForRequestQuery, RecommendedExpertForRequestQueryVariables, RecommendedExpertForRequestProps<TChildProps>>(RecommendedExpertForRequestDocument, {
      alias: 'withRecommendedExpertForRequest',
      ...operationOptions
    });
};
export const ExperienceByExpertCuratedOrderDocument = gql`
    query ExperienceByExpertCuratedOrder($id: ExpertCuratedOrderId!) {
  expertCuratedOrder(id: $id) {
    ...ExpertCuratedOrder
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type ExperienceByExpertCuratedOrderComponentProps = Omit<Omit<ReactApollo.QueryProps<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>, 'query'>, 'variables'> & { variables: ExperienceByExpertCuratedOrderQueryVariables };

    export const ExperienceByExpertCuratedOrderComponent = (props: ExperienceByExpertCuratedOrderComponentProps) => (
      <ReactApollo.Query<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables> query={ExperienceByExpertCuratedOrderDocument} {...props} />
    );
    
export type ExperienceByExpertCuratedOrderProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables>> & TChildProps;
export function withExperienceByExpertCuratedOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExperienceByExpertCuratedOrderQuery,
  ExperienceByExpertCuratedOrderQueryVariables,
  ExperienceByExpertCuratedOrderProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExperienceByExpertCuratedOrderQuery, ExperienceByExpertCuratedOrderQueryVariables, ExperienceByExpertCuratedOrderProps<TChildProps>>(ExperienceByExpertCuratedOrderDocument, {
      alias: 'withExperienceByExpertCuratedOrder',
      ...operationOptions
    });
};
export const ExperienceByFriendlyIdOrIdDocument = gql`
    query ExperienceByFriendlyIdOrId($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    ...ExperienceSellableDetails
  }
}
    ${ExperienceSellableDetailsFragmentDoc}`;
export type ExperienceByFriendlyIdOrIdComponentProps = Omit<Omit<ReactApollo.QueryProps<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>, 'query'>, 'variables'> & { variables: ExperienceByFriendlyIdOrIdQueryVariables };

    export const ExperienceByFriendlyIdOrIdComponent = (props: ExperienceByFriendlyIdOrIdComponentProps) => (
      <ReactApollo.Query<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables> query={ExperienceByFriendlyIdOrIdDocument} {...props} />
    );
    
export type ExperienceByFriendlyIdOrIdProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables>> & TChildProps;
export function withExperienceByFriendlyIdOrId<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExperienceByFriendlyIdOrIdQuery,
  ExperienceByFriendlyIdOrIdQueryVariables,
  ExperienceByFriendlyIdOrIdProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExperienceByFriendlyIdOrIdQuery, ExperienceByFriendlyIdOrIdQueryVariables, ExperienceByFriendlyIdOrIdProps<TChildProps>>(ExperienceByFriendlyIdOrIdDocument, {
      alias: 'withExperienceByFriendlyIdOrId',
      ...operationOptions
    });
};
export const RequestSellableDocument = gql`
    mutation RequestSellable($input: RequestSellableInput!) {
  requestSellable(input: $input) {
    error
    lead {
      id
      conversation {
        id
        externalId
      }
    }
  }
}
    `;
export type RequestSellableMutationFn = ReactApollo.MutationFn<RequestSellableMutation, RequestSellableMutationVariables>;
export type RequestSellableComponentProps = Omit<Omit<ReactApollo.MutationProps<RequestSellableMutation, RequestSellableMutationVariables>, 'mutation'>, 'variables'> & { variables?: RequestSellableMutationVariables };

    export const RequestSellableComponent = (props: RequestSellableComponentProps) => (
      <ReactApollo.Mutation<RequestSellableMutation, RequestSellableMutationVariables> mutation={RequestSellableDocument} {...props} />
    );
    
export type RequestSellableProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<RequestSellableMutation, RequestSellableMutationVariables>> & TChildProps;
export function withRequestSellable<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RequestSellableMutation,
  RequestSellableMutationVariables,
  RequestSellableProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, RequestSellableMutation, RequestSellableMutationVariables, RequestSellableProps<TChildProps>>(RequestSellableDocument, {
      alias: 'withRequestSellable',
      ...operationOptions
    });
};
export const FindExpertCalloutDocument = gql`
    query FindExpertCallout($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    ...ProductExpertCard
  }
}
    ${ProductExpertCardFragmentDoc}`;
export type FindExpertCalloutComponentProps = Omit<Omit<ReactApollo.QueryProps<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>, 'query'>, 'variables'> & { variables: FindExpertCalloutQueryVariables };

    export const FindExpertCalloutComponent = (props: FindExpertCalloutComponentProps) => (
      <ReactApollo.Query<FindExpertCalloutQuery, FindExpertCalloutQueryVariables> query={FindExpertCalloutDocument} {...props} />
    );
    
export type FindExpertCalloutProps<TChildProps = {}> = Partial<ReactApollo.DataProps<FindExpertCalloutQuery, FindExpertCalloutQueryVariables>> & TChildProps;
export function withFindExpertCallout<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  FindExpertCalloutQuery,
  FindExpertCalloutQueryVariables,
  FindExpertCalloutProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, FindExpertCalloutQuery, FindExpertCalloutQueryVariables, FindExpertCalloutProps<TChildProps>>(FindExpertCalloutDocument, {
      alias: 'withFindExpertCallout',
      ...operationOptions
    });
};
export const ProductRecommendedExpertCalloutDocument = gql`
    query ProductRecommendedExpertCallout($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    existingLead {
      id
      conversation {
        id
        externalId
      }
    }
    expert {
      ...ProductExpertCard
    }
  }
}
    ${ProductExpertCardFragmentDoc}`;
export type ProductRecommendedExpertCalloutComponentProps = Omit<Omit<ReactApollo.QueryProps<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>, 'query'>, 'variables'> & { variables: ProductRecommendedExpertCalloutQueryVariables };

    export const ProductRecommendedExpertCalloutComponent = (props: ProductRecommendedExpertCalloutComponentProps) => (
      <ReactApollo.Query<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables> query={ProductRecommendedExpertCalloutDocument} {...props} />
    );
    
export type ProductRecommendedExpertCalloutProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables>> & TChildProps;
export function withProductRecommendedExpertCallout<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ProductRecommendedExpertCalloutQuery,
  ProductRecommendedExpertCalloutQueryVariables,
  ProductRecommendedExpertCalloutProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ProductRecommendedExpertCalloutQuery, ProductRecommendedExpertCalloutQueryVariables, ProductRecommendedExpertCalloutProps<TChildProps>>(ProductRecommendedExpertCalloutDocument, {
      alias: 'withProductRecommendedExpertCallout',
      ...operationOptions
    });
};
export const ExpertFooterUserReviewsDocument = gql`
    query ExpertFooterUserReviews($userId: UserId!, $expertId: BusinessUserId) {
  user(userId: $userId) {
    id
    consumerExpertReviewConnection(expertId: $expertId) {
      edges {
        node {
          id
          expert {
            id
          }
        }
      }
    }
  }
}
    `;
export type ExpertFooterUserReviewsComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>, 'query'>, 'variables'> & { variables: ExpertFooterUserReviewsQueryVariables };

    export const ExpertFooterUserReviewsComponent = (props: ExpertFooterUserReviewsComponentProps) => (
      <ReactApollo.Query<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables> query={ExpertFooterUserReviewsDocument} {...props} />
    );
    
export type ExpertFooterUserReviewsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables>> & TChildProps;
export function withExpertFooterUserReviews<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertFooterUserReviewsQuery,
  ExpertFooterUserReviewsQueryVariables,
  ExpertFooterUserReviewsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertFooterUserReviewsQuery, ExpertFooterUserReviewsQueryVariables, ExpertFooterUserReviewsProps<TChildProps>>(ExpertFooterUserReviewsDocument, {
      alias: 'withExpertFooterUserReviews',
      ...operationOptions
    });
};
export const SellableKeywordTypeaheadDocument = gql`
    query SellableKeywordTypeahead($query: SellableTypeaheadQuery!, $first: Int) {
  sellableTypeahead(query: $query, first: $first) {
    hits {
      ...SellableKeywordTypeaheadResult
    }
  }
}
    ${SellableKeywordTypeaheadResultFragmentDoc}`;
export type SellableKeywordTypeaheadComponentProps = Omit<Omit<ReactApollo.QueryProps<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>, 'query'>, 'variables'> & { variables: SellableKeywordTypeaheadQueryVariables };

    export const SellableKeywordTypeaheadComponent = (props: SellableKeywordTypeaheadComponentProps) => (
      <ReactApollo.Query<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables> query={SellableKeywordTypeaheadDocument} {...props} />
    );
    
export type SellableKeywordTypeaheadProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables>> & TChildProps;
export function withSellableKeywordTypeahead<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SellableKeywordTypeaheadQuery,
  SellableKeywordTypeaheadQueryVariables,
  SellableKeywordTypeaheadProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SellableKeywordTypeaheadQuery, SellableKeywordTypeaheadQueryVariables, SellableKeywordTypeaheadProps<TChildProps>>(SellableKeywordTypeaheadDocument, {
      alias: 'withSellableKeywordTypeahead',
      ...operationOptions
    });
};
export const NavDepartmentsDocument = gql`
    query NavDepartments {
  departmentsForNavigation {
    ...NavInactiveDepartment
  }
}
    ${NavInactiveDepartmentFragmentDoc}`;
export type NavDepartmentsComponentProps = Omit<Omit<ReactApollo.QueryProps<NavDepartmentsQuery, NavDepartmentsQueryVariables>, 'query'>, 'variables'> & { variables?: NavDepartmentsQueryVariables };

    export const NavDepartmentsComponent = (props: NavDepartmentsComponentProps) => (
      <ReactApollo.Query<NavDepartmentsQuery, NavDepartmentsQueryVariables> query={NavDepartmentsDocument} {...props} />
    );
    
export type NavDepartmentsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<NavDepartmentsQuery, NavDepartmentsQueryVariables>> & TChildProps;
export function withNavDepartments<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  NavDepartmentsQuery,
  NavDepartmentsQueryVariables,
  NavDepartmentsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, NavDepartmentsQuery, NavDepartmentsQueryVariables, NavDepartmentsProps<TChildProps>>(NavDepartmentsDocument, {
      alias: 'withNavDepartments',
      ...operationOptions
    });
};
export const NavHierarchyDocument = gql`
    query NavHierarchy($activeDepartmentId: DepartmentId!) {
  activeDepartment: department(id: $activeDepartmentId) {
    ...NavActiveDepartment
  }
}
    ${NavActiveDepartmentFragmentDoc}`;
export type NavHierarchyComponentProps = Omit<Omit<ReactApollo.QueryProps<NavHierarchyQuery, NavHierarchyQueryVariables>, 'query'>, 'variables'> & { variables: NavHierarchyQueryVariables };

    export const NavHierarchyComponent = (props: NavHierarchyComponentProps) => (
      <ReactApollo.Query<NavHierarchyQuery, NavHierarchyQueryVariables> query={NavHierarchyDocument} {...props} />
    );
    
export type NavHierarchyProps<TChildProps = {}> = Partial<ReactApollo.DataProps<NavHierarchyQuery, NavHierarchyQueryVariables>> & TChildProps;
export function withNavHierarchy<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  NavHierarchyQuery,
  NavHierarchyQueryVariables,
  NavHierarchyProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, NavHierarchyQuery, NavHierarchyQueryVariables, NavHierarchyProps<TChildProps>>(NavHierarchyDocument, {
      alias: 'withNavHierarchy',
      ...operationOptions
    });
};
export const SubSectionExpertDocument = gql`
    query SubSectionExpert($departmentId: DepartmentId!) {
  recommendExpertsForDepartment(departmentId: $departmentId) {
    expert {
      id
      vanityId
      firstName
      lastName
      expertStats {
        averageRating
        totalMessages
      }
      expertProfile {
        id
        headline
        profilePhoto {
          id
          url
        }
      }
    }
    existingLead {
      id
      conversation {
        id
      }
    }
  }
}
    `;
export type SubSectionExpertComponentProps = Omit<Omit<ReactApollo.QueryProps<SubSectionExpertQuery, SubSectionExpertQueryVariables>, 'query'>, 'variables'> & { variables: SubSectionExpertQueryVariables };

    export const SubSectionExpertComponent = (props: SubSectionExpertComponentProps) => (
      <ReactApollo.Query<SubSectionExpertQuery, SubSectionExpertQueryVariables> query={SubSectionExpertDocument} {...props} />
    );
    
export type SubSectionExpertProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SubSectionExpertQuery, SubSectionExpertQueryVariables>> & TChildProps;
export function withSubSectionExpert<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubSectionExpertQuery,
  SubSectionExpertQueryVariables,
  SubSectionExpertProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SubSectionExpertQuery, SubSectionExpertQueryVariables, SubSectionExpertProps<TChildProps>>(SubSectionExpertDocument, {
      alias: 'withSubSectionExpert',
      ...operationOptions
    });
};
export const ReleaseConsumerIdentityDocument = gql`
    mutation ReleaseConsumerIdentity {
  releaseConsumerIdentity {
    user {
      id
      firstName
      lastName
    }
  }
}
    `;
export type ReleaseConsumerIdentityMutationFn = ReactApollo.MutationFn<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>;
export type ReleaseConsumerIdentityComponentProps = Omit<Omit<ReactApollo.MutationProps<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>, 'mutation'>, 'variables'> & { variables?: ReleaseConsumerIdentityMutationVariables };

    export const ReleaseConsumerIdentityComponent = (props: ReleaseConsumerIdentityComponentProps) => (
      <ReactApollo.Mutation<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables> mutation={ReleaseConsumerIdentityDocument} {...props} />
    );
    
export type ReleaseConsumerIdentityProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables>> & TChildProps;
export function withReleaseConsumerIdentity<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ReleaseConsumerIdentityMutation,
  ReleaseConsumerIdentityMutationVariables,
  ReleaseConsumerIdentityProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, ReleaseConsumerIdentityMutation, ReleaseConsumerIdentityMutationVariables, ReleaseConsumerIdentityProps<TChildProps>>(ReleaseConsumerIdentityDocument, {
      alias: 'withReleaseConsumerIdentity',
      ...operationOptions
    });
};
export const HeartbeatDocument = gql`
    subscription Heartbeat {
  heartbeat
}
    `;
export type HeartbeatComponentProps = Omit<Omit<ReactApollo.SubscriptionProps<HeartbeatSubscription, HeartbeatSubscriptionVariables>, 'subscription'>, 'variables'> & { variables?: HeartbeatSubscriptionVariables };

    export const HeartbeatComponent = (props: HeartbeatComponentProps) => (
      <ReactApollo.Subscription<HeartbeatSubscription, HeartbeatSubscriptionVariables> subscription={HeartbeatDocument} {...props} />
    );
    
export type HeartbeatProps<TChildProps = {}> = Partial<ReactApollo.DataProps<HeartbeatSubscription, HeartbeatSubscriptionVariables>> & TChildProps;
export function withHeartbeat<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  HeartbeatSubscription,
  HeartbeatSubscriptionVariables,
  HeartbeatProps<TChildProps>>) {
    return ReactApollo.withSubscription<TProps, HeartbeatSubscription, HeartbeatSubscriptionVariables, HeartbeatProps<TChildProps>>(HeartbeatDocument, {
      alias: 'withHeartbeat',
      ...operationOptions
    });
};
export const LandingPageExpertsDocument = gql`
    query LandingPageExperts($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    experts {
      ...LandingPageExpertCard
    }
  }
}
    ${LandingPageExpertCardFragmentDoc}`;
export type LandingPageExpertsComponentProps = Omit<Omit<ReactApollo.QueryProps<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>, 'query'>, 'variables'> & { variables: LandingPageExpertsQueryVariables };

    export const LandingPageExpertsComponent = (props: LandingPageExpertsComponentProps) => (
      <ReactApollo.Query<LandingPageExpertsQuery, LandingPageExpertsQueryVariables> query={LandingPageExpertsDocument} {...props} />
    );
    
export type LandingPageExpertsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LandingPageExpertsQuery, LandingPageExpertsQueryVariables>> & TChildProps;
export function withLandingPageExperts<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LandingPageExpertsQuery,
  LandingPageExpertsQueryVariables,
  LandingPageExpertsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LandingPageExpertsQuery, LandingPageExpertsQueryVariables, LandingPageExpertsProps<TChildProps>>(LandingPageExpertsDocument, {
      alias: 'withLandingPageExperts',
      ...operationOptions
    });
};
export const KeystoneExpertsDocument = gql`
    query KeystoneExperts($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    experts {
      id
      firstName
      lastName
      expertProfile {
        id
        headline
        profilePhoto {
          ...MediaFile
        }
      }
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type KeystoneExpertsComponentProps = Omit<Omit<ReactApollo.QueryProps<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>, 'query'>, 'variables'> & { variables: KeystoneExpertsQueryVariables };

    export const KeystoneExpertsComponent = (props: KeystoneExpertsComponentProps) => (
      <ReactApollo.Query<KeystoneExpertsQuery, KeystoneExpertsQueryVariables> query={KeystoneExpertsDocument} {...props} />
    );
    
export type KeystoneExpertsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<KeystoneExpertsQuery, KeystoneExpertsQueryVariables>> & TChildProps;
export function withKeystoneExperts<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  KeystoneExpertsQuery,
  KeystoneExpertsQueryVariables,
  KeystoneExpertsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, KeystoneExpertsQuery, KeystoneExpertsQueryVariables, KeystoneExpertsProps<TChildProps>>(KeystoneExpertsDocument, {
      alias: 'withKeystoneExperts',
      ...operationOptions
    });
};
export const SearchSellablesLandingDocument = gql`
    query SearchSellablesLanding($categoryIds: [CategoryId!], $type: SellableType, $facets: [FacetSelection!]) {
  searchSellables(query: {facets: $facets, maxFacetTerms: 25, categoryIds: $categoryIds, type: $type}, first: 6) {
    count
    facets {
      ...DisplayFacet
    }
  }
}
    ${DisplayFacetFragmentDoc}`;
export type SearchSellablesLandingComponentProps = Omit<Omit<ReactApollo.QueryProps<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>, 'query'>, 'variables'> & { variables?: SearchSellablesLandingQueryVariables };

    export const SearchSellablesLandingComponent = (props: SearchSellablesLandingComponentProps) => (
      <ReactApollo.Query<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables> query={SearchSellablesLandingDocument} {...props} />
    );
    
export type SearchSellablesLandingProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables>> & TChildProps;
export function withSearchSellablesLanding<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SearchSellablesLandingQuery,
  SearchSellablesLandingQueryVariables,
  SearchSellablesLandingProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SearchSellablesLandingQuery, SearchSellablesLandingQueryVariables, SearchSellablesLandingProps<TChildProps>>(SearchSellablesLandingDocument, {
      alias: 'withSearchSellablesLanding',
      ...operationOptions
    });
};
export const DiamondDepartmentContextDocument = gql`
    query DiamondDepartmentContext {
  departmentBySlug(slug: "jewelry") {
    ...DepartmentContext
  }
}
    ${DepartmentContextFragmentDoc}`;
export type DiamondDepartmentContextComponentProps = Omit<Omit<ReactApollo.QueryProps<DiamondDepartmentContextQuery, DiamondDepartmentContextQueryVariables>, 'query'>, 'variables'> & { variables?: DiamondDepartmentContextQueryVariables };

    export const DiamondDepartmentContextComponent = (props: DiamondDepartmentContextComponentProps) => (
      <ReactApollo.Query<DiamondDepartmentContextQuery, DiamondDepartmentContextQueryVariables> query={DiamondDepartmentContextDocument} {...props} />
    );
    
export type DiamondDepartmentContextProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DiamondDepartmentContextQuery, DiamondDepartmentContextQueryVariables>> & TChildProps;
export function withDiamondDepartmentContext<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DiamondDepartmentContextQuery,
  DiamondDepartmentContextQueryVariables,
  DiamondDepartmentContextProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DiamondDepartmentContextQuery, DiamondDepartmentContextQueryVariables, DiamondDepartmentContextProps<TChildProps>>(DiamondDepartmentContextDocument, {
      alias: 'withDiamondDepartmentContext',
      ...operationOptions
    });
};
export const JetChartersDepartmentContextDocument = gql`
    query JetChartersDepartmentContext {
  departmentBySlug(slug: "jet-charters") {
    ...DepartmentContext
  }
}
    ${DepartmentContextFragmentDoc}`;
export type JetChartersDepartmentContextComponentProps = Omit<Omit<ReactApollo.QueryProps<JetChartersDepartmentContextQuery, JetChartersDepartmentContextQueryVariables>, 'query'>, 'variables'> & { variables?: JetChartersDepartmentContextQueryVariables };

    export const JetChartersDepartmentContextComponent = (props: JetChartersDepartmentContextComponentProps) => (
      <ReactApollo.Query<JetChartersDepartmentContextQuery, JetChartersDepartmentContextQueryVariables> query={JetChartersDepartmentContextDocument} {...props} />
    );
    
export type JetChartersDepartmentContextProps<TChildProps = {}> = Partial<ReactApollo.DataProps<JetChartersDepartmentContextQuery, JetChartersDepartmentContextQueryVariables>> & TChildProps;
export function withJetChartersDepartmentContext<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  JetChartersDepartmentContextQuery,
  JetChartersDepartmentContextQueryVariables,
  JetChartersDepartmentContextProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, JetChartersDepartmentContextQuery, JetChartersDepartmentContextQueryVariables, JetChartersDepartmentContextProps<TChildProps>>(JetChartersDepartmentContextDocument, {
      alias: 'withJetChartersDepartmentContext',
      ...operationOptions
    });
};
export const ChatLeadDocument = gql`
    query ChatLead($leadId: LeadId!) {
  lead(id: $leadId) {
    id
    expert {
      ...ExpertData
    }
    consumer {
      id
      firstName
      contacts {
        id
        type
        value
      }
      messagingUser {
        id
      }
    }
    category {
      ...CategoryMedia
    }
    latestRequest {
      id
      attributes {
        ...RequestAttributes
      }
    }
  }
}
    ${ExpertDataFragmentDoc}
${CategoryMediaFragmentDoc}
${RequestAttributesFragmentDoc}`;
export type ChatLeadComponentProps = Omit<Omit<ReactApollo.QueryProps<ChatLeadQuery, ChatLeadQueryVariables>, 'query'>, 'variables'> & { variables: ChatLeadQueryVariables };

    export const ChatLeadComponent = (props: ChatLeadComponentProps) => (
      <ReactApollo.Query<ChatLeadQuery, ChatLeadQueryVariables> query={ChatLeadDocument} {...props} />
    );
    
export type ChatLeadProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ChatLeadQuery, ChatLeadQueryVariables>> & TChildProps;
export function withChatLead<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ChatLeadQuery,
  ChatLeadQueryVariables,
  ChatLeadProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ChatLeadQuery, ChatLeadQueryVariables, ChatLeadProps<TChildProps>>(ChatLeadDocument, {
      alias: 'withChatLead',
      ...operationOptions
    });
};
export const CommTemplateTypeDocument = gql`
    query CommTemplateType($id: CommTemplateTypeId!) {
  commTemplateType(id: $id) {
    id
    richCardType
  }
}
    `;
export type CommTemplateTypeComponentProps = Omit<Omit<ReactApollo.QueryProps<CommTemplateTypeQuery, CommTemplateTypeQueryVariables>, 'query'>, 'variables'> & { variables: CommTemplateTypeQueryVariables };

    export const CommTemplateTypeComponent = (props: CommTemplateTypeComponentProps) => (
      <ReactApollo.Query<CommTemplateTypeQuery, CommTemplateTypeQueryVariables> query={CommTemplateTypeDocument} {...props} />
    );
    
export type CommTemplateTypeProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CommTemplateTypeQuery, CommTemplateTypeQueryVariables>> & TChildProps;
export function withCommTemplateType<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CommTemplateTypeQuery,
  CommTemplateTypeQueryVariables,
  CommTemplateTypeProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CommTemplateTypeQuery, CommTemplateTypeQueryVariables, CommTemplateTypeProps<TChildProps>>(CommTemplateTypeDocument, {
      alias: 'withCommTemplateType',
      ...operationOptions
    });
};
export const ContactCollectionUpdatePhoneDocument = gql`
    mutation ContactCollectionUpdatePhone($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
    user {
      id
      contacts {
        id
        type
        value
        verified
      }
    }
  }
}
    `;
export type ContactCollectionUpdatePhoneMutationFn = ReactApollo.MutationFn<ContactCollectionUpdatePhoneMutation, ContactCollectionUpdatePhoneMutationVariables>;
export type ContactCollectionUpdatePhoneComponentProps = Omit<Omit<ReactApollo.MutationProps<ContactCollectionUpdatePhoneMutation, ContactCollectionUpdatePhoneMutationVariables>, 'mutation'>, 'variables'> & { variables?: ContactCollectionUpdatePhoneMutationVariables };

    export const ContactCollectionUpdatePhoneComponent = (props: ContactCollectionUpdatePhoneComponentProps) => (
      <ReactApollo.Mutation<ContactCollectionUpdatePhoneMutation, ContactCollectionUpdatePhoneMutationVariables> mutation={ContactCollectionUpdatePhoneDocument} {...props} />
    );
    
export type ContactCollectionUpdatePhoneProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<ContactCollectionUpdatePhoneMutation, ContactCollectionUpdatePhoneMutationVariables>> & TChildProps;
export function withContactCollectionUpdatePhone<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ContactCollectionUpdatePhoneMutation,
  ContactCollectionUpdatePhoneMutationVariables,
  ContactCollectionUpdatePhoneProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, ContactCollectionUpdatePhoneMutation, ContactCollectionUpdatePhoneMutationVariables, ContactCollectionUpdatePhoneProps<TChildProps>>(ContactCollectionUpdatePhoneDocument, {
      alias: 'withContactCollectionUpdatePhone',
      ...operationOptions
    });
};
export const ExpertCuratedOrderListActivationDocument = gql`
    query ExpertCuratedOrderListActivation($id: ExpertCuratedOrderListActivationId!) {
  expertCuratedOrderListActivation(id: $id) {
    id
    active {
      id
    }
    lead {
      id
      expert {
        id
        firstName
        lastName
      }
      category {
        id
        type
        name
        slug
        singularDisplayName
        contentAssets {
          bannerImages {
            imageUrl
          }
        }
      }
    }
  }
}
    `;
export type ExpertCuratedOrderListActivationComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertCuratedOrderListActivationQuery, ExpertCuratedOrderListActivationQueryVariables>, 'query'>, 'variables'> & { variables: ExpertCuratedOrderListActivationQueryVariables };

    export const ExpertCuratedOrderListActivationComponent = (props: ExpertCuratedOrderListActivationComponentProps) => (
      <ReactApollo.Query<ExpertCuratedOrderListActivationQuery, ExpertCuratedOrderListActivationQueryVariables> query={ExpertCuratedOrderListActivationDocument} {...props} />
    );
    
export type ExpertCuratedOrderListActivationProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedOrderListActivationQuery, ExpertCuratedOrderListActivationQueryVariables>> & TChildProps;
export function withExpertCuratedOrderListActivation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedOrderListActivationQuery,
  ExpertCuratedOrderListActivationQueryVariables,
  ExpertCuratedOrderListActivationProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertCuratedOrderListActivationQuery, ExpertCuratedOrderListActivationQueryVariables, ExpertCuratedOrderListActivationProps<TChildProps>>(ExpertCuratedOrderListActivationDocument, {
      alias: 'withExpertCuratedOrderListActivation',
      ...operationOptions
    });
};
export const ExpertCuratedOrderRichCardDocument = gql`
    query ExpertCuratedOrderRichCard($id: ExpertCuratedOrderId!) {
  expertCuratedOrder(id: $id) {
    ...ExpertCuratedOrder
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type ExpertCuratedOrderRichCardComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertCuratedOrderRichCardQuery, ExpertCuratedOrderRichCardQueryVariables>, 'query'>, 'variables'> & { variables: ExpertCuratedOrderRichCardQueryVariables };

    export const ExpertCuratedOrderRichCardComponent = (props: ExpertCuratedOrderRichCardComponentProps) => (
      <ReactApollo.Query<ExpertCuratedOrderRichCardQuery, ExpertCuratedOrderRichCardQueryVariables> query={ExpertCuratedOrderRichCardDocument} {...props} />
    );
    
export type ExpertCuratedOrderRichCardProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedOrderRichCardQuery, ExpertCuratedOrderRichCardQueryVariables>> & TChildProps;
export function withExpertCuratedOrderRichCard<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedOrderRichCardQuery,
  ExpertCuratedOrderRichCardQueryVariables,
  ExpertCuratedOrderRichCardProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertCuratedOrderRichCardQuery, ExpertCuratedOrderRichCardQueryVariables, ExpertCuratedOrderRichCardProps<TChildProps>>(ExpertCuratedOrderRichCardDocument, {
      alias: 'withExpertCuratedOrderRichCard',
      ...operationOptions
    });
};
export const ExpertCuratedItemActivationDocument = gql`
    query ExpertCuratedItemActivation($activationId: ExpertCuratedItemActivationId!) {
  expertCuratedItemActivation(id: $activationId) {
    activated {
      id
    }
    activatedBy {
      id
      firstName
    }
    lead {
      id
      consumer {
        id
        messagingUser {
          id
        }
        firstName
        lastName
        profilePhoto {
          ...MediaFile
        }
      }
      category {
        id
        name
        contentAssets {
          bannerImages {
            imageUrl
          }
        }
      }
      conversation {
        id
        externalId
      }
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type ExpertCuratedItemActivationComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertCuratedItemActivationQuery, ExpertCuratedItemActivationQueryVariables>, 'query'>, 'variables'> & { variables: ExpertCuratedItemActivationQueryVariables };

    export const ExpertCuratedItemActivationComponent = (props: ExpertCuratedItemActivationComponentProps) => (
      <ReactApollo.Query<ExpertCuratedItemActivationQuery, ExpertCuratedItemActivationQueryVariables> query={ExpertCuratedItemActivationDocument} {...props} />
    );
    
export type ExpertCuratedItemActivationProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedItemActivationQuery, ExpertCuratedItemActivationQueryVariables>> & TChildProps;
export function withExpertCuratedItemActivation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedItemActivationQuery,
  ExpertCuratedItemActivationQueryVariables,
  ExpertCuratedItemActivationProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertCuratedItemActivationQuery, ExpertCuratedItemActivationQueryVariables, ExpertCuratedItemActivationProps<TChildProps>>(ExpertCuratedItemActivationDocument, {
      alias: 'withExpertCuratedItemActivation',
      ...operationOptions
    });
};
export const NewCurationDocument = gql`
    query NewCuration($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    byCategories {
      id
      categories {
        id
        items {
          id
        }
      }
    }
  }
  lead(id: $leadId) {
    id
    expert {
      id
      firstName
    }
    category {
      id
      name
      contentAssets {
        bannerImages {
          imageUrl
        }
      }
    }
    conversation {
      id
      externalId
    }
  }
}
    `;
export type NewCurationComponentProps = Omit<Omit<ReactApollo.QueryProps<NewCurationQuery, NewCurationQueryVariables>, 'query'>, 'variables'> & { variables: NewCurationQueryVariables };

    export const NewCurationComponent = (props: NewCurationComponentProps) => (
      <ReactApollo.Query<NewCurationQuery, NewCurationQueryVariables> query={NewCurationDocument} {...props} />
    );
    
export type NewCurationProps<TChildProps = {}> = Partial<ReactApollo.DataProps<NewCurationQuery, NewCurationQueryVariables>> & TChildProps;
export function withNewCuration<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  NewCurationQuery,
  NewCurationQueryVariables,
  NewCurationProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, NewCurationQuery, NewCurationQueryVariables, NewCurationProps<TChildProps>>(NewCurationDocument, {
      alias: 'withNewCuration',
      ...operationOptions
    });
};
export const SaveConsumerSellableReactionDocument = gql`
    mutation SaveConsumerSellableReaction($input: SaveConsumerSellableReactionInput!) {
  saveConsumerSellableReaction(input: $input) {
    consumerSellableReaction {
      id
      reasonsWithDisplayName {
        reason
        displayName
      }
      ratingWithDisplayName {
        rating
        displayName
      }
      additionalReason
      sellable {
        id
      }
      systemRecommended
      recommendedBy {
        id
      }
    }
    error
  }
}
    `;
export type SaveConsumerSellableReactionMutationFn = ReactApollo.MutationFn<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>;
export type SaveConsumerSellableReactionComponentProps = Omit<Omit<ReactApollo.MutationProps<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SaveConsumerSellableReactionMutationVariables };

    export const SaveConsumerSellableReactionComponent = (props: SaveConsumerSellableReactionComponentProps) => (
      <ReactApollo.Mutation<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables> mutation={SaveConsumerSellableReactionDocument} {...props} />
    );
    
export type SaveConsumerSellableReactionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables>> & TChildProps;
export function withSaveConsumerSellableReaction<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SaveConsumerSellableReactionMutation,
  SaveConsumerSellableReactionMutationVariables,
  SaveConsumerSellableReactionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SaveConsumerSellableReactionMutation, SaveConsumerSellableReactionMutationVariables, SaveConsumerSellableReactionProps<TChildProps>>(SaveConsumerSellableReactionDocument, {
      alias: 'withSaveConsumerSellableReaction',
      ...operationOptions
    });
};
export const StartSystemCuratedItemSurveyDocument = gql`
    mutation StartSystemCuratedItemSurvey($id: SystemCuratedItemSurveyId!) {
  startSystemCuratedItemSurvey(id: $id) {
    data {
      id
      startedAt
    }
    error
  }
}
    `;
export type StartSystemCuratedItemSurveyMutationFn = ReactApollo.MutationFn<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>;
export type StartSystemCuratedItemSurveyComponentProps = Omit<Omit<ReactApollo.MutationProps<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>, 'mutation'>, 'variables'> & { variables?: StartSystemCuratedItemSurveyMutationVariables };

    export const StartSystemCuratedItemSurveyComponent = (props: StartSystemCuratedItemSurveyComponentProps) => (
      <ReactApollo.Mutation<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables> mutation={StartSystemCuratedItemSurveyDocument} {...props} />
    );
    
export type StartSystemCuratedItemSurveyProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables>> & TChildProps;
export function withStartSystemCuratedItemSurvey<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  StartSystemCuratedItemSurveyMutation,
  StartSystemCuratedItemSurveyMutationVariables,
  StartSystemCuratedItemSurveyProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, StartSystemCuratedItemSurveyMutation, StartSystemCuratedItemSurveyMutationVariables, StartSystemCuratedItemSurveyProps<TChildProps>>(StartSystemCuratedItemSurveyDocument, {
      alias: 'withStartSystemCuratedItemSurvey',
      ...operationOptions
    });
};
export const SystemCuratedItemSurveyDocument = gql`
    query SystemCuratedItemSurvey($id: SystemCuratedItemSurveyId!) {
  systemCuratedItemSurvey(id: $id) {
    id
    ended
    terminationReason
    systemCuratedItems {
      ...SystemCuratedItem
    }
    stats {
      ...SystemCuratedItemSurveyStats
    }
  }
}
    ${SystemCuratedItemFragmentDoc}
${SystemCuratedItemSurveyStatsFragmentDoc}`;
export type SystemCuratedItemSurveyComponentProps = Omit<Omit<ReactApollo.QueryProps<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>, 'query'>, 'variables'> & { variables: SystemCuratedItemSurveyQueryVariables };

    export const SystemCuratedItemSurveyComponent = (props: SystemCuratedItemSurveyComponentProps) => (
      <ReactApollo.Query<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables> query={SystemCuratedItemSurveyDocument} {...props} />
    );
    
export type SystemCuratedItemSurveyProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables>> & TChildProps;
export function withSystemCuratedItemSurvey<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SystemCuratedItemSurveyQuery,
  SystemCuratedItemSurveyQueryVariables,
  SystemCuratedItemSurveyProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SystemCuratedItemSurveyQuery, SystemCuratedItemSurveyQueryVariables, SystemCuratedItemSurveyProps<TChildProps>>(SystemCuratedItemSurveyDocument, {
      alias: 'withSystemCuratedItemSurvey',
      ...operationOptions
    });
};
export const TerminateSystemCuratedItemSurveyDocument = gql`
    mutation TerminateSystemCuratedItemSurvey($input: TerminateSystemCuratedItemSurveyInput!) {
  terminateSystemCuratedItemSurvey(input: $input) {
    data {
      id
      ended
      terminationReason
      systemCuratedItems {
        ...SystemCuratedItem
      }
      stats {
        ...SystemCuratedItemSurveyStats
      }
    }
    error
  }
}
    ${SystemCuratedItemFragmentDoc}
${SystemCuratedItemSurveyStatsFragmentDoc}`;
export type TerminateSystemCuratedItemSurveyMutationFn = ReactApollo.MutationFn<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>;
export type TerminateSystemCuratedItemSurveyComponentProps = Omit<Omit<ReactApollo.MutationProps<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>, 'mutation'>, 'variables'> & { variables?: TerminateSystemCuratedItemSurveyMutationVariables };

    export const TerminateSystemCuratedItemSurveyComponent = (props: TerminateSystemCuratedItemSurveyComponentProps) => (
      <ReactApollo.Mutation<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables> mutation={TerminateSystemCuratedItemSurveyDocument} {...props} />
    );
    
export type TerminateSystemCuratedItemSurveyProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables>> & TChildProps;
export function withTerminateSystemCuratedItemSurvey<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  TerminateSystemCuratedItemSurveyMutation,
  TerminateSystemCuratedItemSurveyMutationVariables,
  TerminateSystemCuratedItemSurveyProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, TerminateSystemCuratedItemSurveyMutation, TerminateSystemCuratedItemSurveyMutationVariables, TerminateSystemCuratedItemSurveyProps<TChildProps>>(TerminateSystemCuratedItemSurveyDocument, {
      alias: 'withTerminateSystemCuratedItemSurvey',
      ...operationOptions
    });
};
export const ReferralExpertDocument = gql`
    query ReferralExpert($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    id
    vanityId
    firstName
    lastName
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    expertAttributes {
      categories {
        id
        singularDisplayName
        contentAssets {
          bannerImages {
            imageUrl
          }
        }
      }
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type ReferralExpertComponentProps = Omit<Omit<ReactApollo.QueryProps<ReferralExpertQuery, ReferralExpertQueryVariables>, 'query'>, 'variables'> & { variables: ReferralExpertQueryVariables };

    export const ReferralExpertComponent = (props: ReferralExpertComponentProps) => (
      <ReactApollo.Query<ReferralExpertQuery, ReferralExpertQueryVariables> query={ReferralExpertDocument} {...props} />
    );
    
export type ReferralExpertProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ReferralExpertQuery, ReferralExpertQueryVariables>> & TChildProps;
export function withReferralExpert<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ReferralExpertQuery,
  ReferralExpertQueryVariables,
  ReferralExpertProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ReferralExpertQuery, ReferralExpertQueryVariables, ReferralExpertProps<TChildProps>>(ReferralExpertDocument, {
      alias: 'withReferralExpert',
      ...operationOptions
    });
};
export const SimpleCuratedOrderRichCardDocument = gql`
    query SimpleCuratedOrderRichCard($id: SimpleCuratedOrderId!) {
  simpleCuratedOrder(id: $id) {
    id
    curatedFor {
      id
      firstName
    }
    curator {
      id
      firstName
    }
    lead {
      id
      category {
        id
        contentAssets {
          bannerImages {
            imageUrl
          }
        }
      }
    }
    order {
      id
      state
      totalCost {
        ...MonetaryAmount
      }
    }
  }
}
    ${MonetaryAmountFragmentDoc}`;
export type SimpleCuratedOrderRichCardComponentProps = Omit<Omit<ReactApollo.QueryProps<SimpleCuratedOrderRichCardQuery, SimpleCuratedOrderRichCardQueryVariables>, 'query'>, 'variables'> & { variables: SimpleCuratedOrderRichCardQueryVariables };

    export const SimpleCuratedOrderRichCardComponent = (props: SimpleCuratedOrderRichCardComponentProps) => (
      <ReactApollo.Query<SimpleCuratedOrderRichCardQuery, SimpleCuratedOrderRichCardQueryVariables> query={SimpleCuratedOrderRichCardDocument} {...props} />
    );
    
export type SimpleCuratedOrderRichCardProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SimpleCuratedOrderRichCardQuery, SimpleCuratedOrderRichCardQueryVariables>> & TChildProps;
export function withSimpleCuratedOrderRichCard<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SimpleCuratedOrderRichCardQuery,
  SimpleCuratedOrderRichCardQueryVariables,
  SimpleCuratedOrderRichCardProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SimpleCuratedOrderRichCardQuery, SimpleCuratedOrderRichCardQueryVariables, SimpleCuratedOrderRichCardProps<TChildProps>>(SimpleCuratedOrderRichCardDocument, {
      alias: 'withSimpleCuratedOrderRichCard',
      ...operationOptions
    });
};
export const AuthenticateByExternalOAuthTokenDocument = gql`
    mutation AuthenticateByExternalOAuthToken($input: AuthenticateByExternalOAuthTokenInput!) {
  authenticateByExternalOAuthToken(input: $input) {
    result
    message
    user {
      ...AuthenticatedUser
    }
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type AuthenticateByExternalOAuthTokenMutationFn = ReactApollo.MutationFn<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>;
export type AuthenticateByExternalOAuthTokenComponentProps = Omit<Omit<ReactApollo.MutationProps<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>, 'mutation'>, 'variables'> & { variables?: AuthenticateByExternalOAuthTokenMutationVariables };

    export const AuthenticateByExternalOAuthTokenComponent = (props: AuthenticateByExternalOAuthTokenComponentProps) => (
      <ReactApollo.Mutation<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables> mutation={AuthenticateByExternalOAuthTokenDocument} {...props} />
    );
    
export type AuthenticateByExternalOAuthTokenProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables>> & TChildProps;
export function withAuthenticateByExternalOAuthToken<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AuthenticateByExternalOAuthTokenMutation,
  AuthenticateByExternalOAuthTokenMutationVariables,
  AuthenticateByExternalOAuthTokenProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, AuthenticateByExternalOAuthTokenMutation, AuthenticateByExternalOAuthTokenMutationVariables, AuthenticateByExternalOAuthTokenProps<TChildProps>>(AuthenticateByExternalOAuthTokenDocument, {
      alias: 'withAuthenticateByExternalOAuthToken',
      ...operationOptions
    });
};
export const RegisterCustomerDocument = gql`
    mutation RegisterCustomer($input: RegisterCustomerInput!) {
  registerCustomer(input: $input) {
    user {
      ...AuthenticatedUser
    }
    errors
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type RegisterCustomerMutationFn = ReactApollo.MutationFn<RegisterCustomerMutation, RegisterCustomerMutationVariables>;
export type RegisterCustomerComponentProps = Omit<Omit<ReactApollo.MutationProps<RegisterCustomerMutation, RegisterCustomerMutationVariables>, 'mutation'>, 'variables'> & { variables?: RegisterCustomerMutationVariables };

    export const RegisterCustomerComponent = (props: RegisterCustomerComponentProps) => (
      <ReactApollo.Mutation<RegisterCustomerMutation, RegisterCustomerMutationVariables> mutation={RegisterCustomerDocument} {...props} />
    );
    
export type RegisterCustomerProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<RegisterCustomerMutation, RegisterCustomerMutationVariables>> & TChildProps;
export function withRegisterCustomer<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RegisterCustomerMutation,
  RegisterCustomerMutationVariables,
  RegisterCustomerProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, RegisterCustomerMutation, RegisterCustomerMutationVariables, RegisterCustomerProps<TChildProps>>(RegisterCustomerDocument, {
      alias: 'withRegisterCustomer',
      ...operationOptions
    });
};
export const FlightPlanQuestionDocument = gql`
    query FlightPlanQuestion($id: FlightPlanId!) {
  flightPlan(id: $id) {
    ...FlightPlanQuestion
  }
}
    ${FlightPlanQuestionFragmentDoc}`;
export type FlightPlanQuestionComponentProps = Omit<Omit<ReactApollo.QueryProps<FlightPlanQuestionQuery, FlightPlanQuestionQueryVariables>, 'query'>, 'variables'> & { variables: FlightPlanQuestionQueryVariables };

    export const FlightPlanQuestionComponent = (props: FlightPlanQuestionComponentProps) => (
      <ReactApollo.Query<FlightPlanQuestionQuery, FlightPlanQuestionQueryVariables> query={FlightPlanQuestionDocument} {...props} />
    );
    
export type FlightPlanQuestionProps<TChildProps = {}> = Partial<ReactApollo.DataProps<FlightPlanQuestionQuery, FlightPlanQuestionQueryVariables>> & TChildProps;
export function withFlightPlanQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  FlightPlanQuestionQuery,
  FlightPlanQuestionQueryVariables,
  FlightPlanQuestionProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, FlightPlanQuestionQuery, FlightPlanQuestionQueryVariables, FlightPlanQuestionProps<TChildProps>>(FlightPlanQuestionDocument, {
      alias: 'withFlightPlanQuestion',
      ...operationOptions
    });
};
export const RoryReviewsDocument = gql`
    query RoryReviews($departmentId: DepartmentId!) {
  department(id: $departmentId) {
    id
    reviewSummary {
      averageRating
      totalReviews
    }
    consumerExpertReviewConnection(filter: {source: SHOPPER_APPROVED}, first: 3) {
      edges {
        node {
          ...RoryReview
        }
      }
    }
  }
}
    ${RoryReviewFragmentDoc}`;
export type RoryReviewsComponentProps = Omit<Omit<ReactApollo.QueryProps<RoryReviewsQuery, RoryReviewsQueryVariables>, 'query'>, 'variables'> & { variables: RoryReviewsQueryVariables };

    export const RoryReviewsComponent = (props: RoryReviewsComponentProps) => (
      <ReactApollo.Query<RoryReviewsQuery, RoryReviewsQueryVariables> query={RoryReviewsDocument} {...props} />
    );
    
export type RoryReviewsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RoryReviewsQuery, RoryReviewsQueryVariables>> & TChildProps;
export function withRoryReviews<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RoryReviewsQuery,
  RoryReviewsQueryVariables,
  RoryReviewsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RoryReviewsQuery, RoryReviewsQueryVariables, RoryReviewsProps<TChildProps>>(RoryReviewsDocument, {
      alias: 'withRoryReviews',
      ...operationOptions
    });
};
export const CreatePathFlowDocument = gql`
    mutation CreatePathFlow($input: CreatePathFlowInput!) {
  createPathFlow(input: $input) {
    flow {
      ...PathFlow
    }
    errors {
      ...PathValidationError
    }
    newUserRegistered
  }
}
    ${PathFlowFragmentDoc}
${PathValidationErrorFragmentDoc}`;
export type CreatePathFlowMutationFn = ReactApollo.MutationFn<CreatePathFlowMutation, CreatePathFlowMutationVariables>;
export type CreatePathFlowComponentProps = Omit<Omit<ReactApollo.MutationProps<CreatePathFlowMutation, CreatePathFlowMutationVariables>, 'mutation'>, 'variables'> & { variables?: CreatePathFlowMutationVariables };

    export const CreatePathFlowComponent = (props: CreatePathFlowComponentProps) => (
      <ReactApollo.Mutation<CreatePathFlowMutation, CreatePathFlowMutationVariables> mutation={CreatePathFlowDocument} {...props} />
    );
    
export type CreatePathFlowProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<CreatePathFlowMutation, CreatePathFlowMutationVariables>> & TChildProps;
export function withCreatePathFlow<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CreatePathFlowMutation,
  CreatePathFlowMutationVariables,
  CreatePathFlowProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, CreatePathFlowMutation, CreatePathFlowMutationVariables, CreatePathFlowProps<TChildProps>>(CreatePathFlowDocument, {
      alias: 'withCreatePathFlow',
      ...operationOptions
    });
};
export const GenerateCollectPhoneNumberTextInPathDocument = gql`
    mutation GenerateCollectPhoneNumberTextInPath($input: GenerateCollectPhoneNumberTextInPathInput!) {
  generateCollectPhoneNumberTextInPath(input: $input) {
    toNumber
    body
  }
}
    `;
export type GenerateCollectPhoneNumberTextInPathMutationFn = ReactApollo.MutationFn<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>;
export type GenerateCollectPhoneNumberTextInPathComponentProps = Omit<Omit<ReactApollo.MutationProps<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>, 'mutation'>, 'variables'> & { variables?: GenerateCollectPhoneNumberTextInPathMutationVariables };

    export const GenerateCollectPhoneNumberTextInPathComponent = (props: GenerateCollectPhoneNumberTextInPathComponentProps) => (
      <ReactApollo.Mutation<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables> mutation={GenerateCollectPhoneNumberTextInPathDocument} {...props} />
    );
    
export type GenerateCollectPhoneNumberTextInPathProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables>> & TChildProps;
export function withGenerateCollectPhoneNumberTextInPath<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  GenerateCollectPhoneNumberTextInPathMutation,
  GenerateCollectPhoneNumberTextInPathMutationVariables,
  GenerateCollectPhoneNumberTextInPathProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, GenerateCollectPhoneNumberTextInPathMutation, GenerateCollectPhoneNumberTextInPathMutationVariables, GenerateCollectPhoneNumberTextInPathProps<TChildProps>>(GenerateCollectPhoneNumberTextInPathDocument, {
      alias: 'withGenerateCollectPhoneNumberTextInPath',
      ...operationOptions
    });
};
export const ReenterPathFlowPageDocument = gql`
    mutation ReenterPathFlowPage($input: ReenterPathFlowPageInput!) {
  reenterPathFlowPage(input: $input) {
    flow {
      ...PathFlow
    }
  }
}
    ${PathFlowFragmentDoc}`;
export type ReenterPathFlowPageMutationFn = ReactApollo.MutationFn<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>;
export type ReenterPathFlowPageComponentProps = Omit<Omit<ReactApollo.MutationProps<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>, 'mutation'>, 'variables'> & { variables?: ReenterPathFlowPageMutationVariables };

    export const ReenterPathFlowPageComponent = (props: ReenterPathFlowPageComponentProps) => (
      <ReactApollo.Mutation<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables> mutation={ReenterPathFlowPageDocument} {...props} />
    );
    
export type ReenterPathFlowPageProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables>> & TChildProps;
export function withReenterPathFlowPage<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ReenterPathFlowPageMutation,
  ReenterPathFlowPageMutationVariables,
  ReenterPathFlowPageProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, ReenterPathFlowPageMutation, ReenterPathFlowPageMutationVariables, ReenterPathFlowPageProps<TChildProps>>(ReenterPathFlowPageDocument, {
      alias: 'withReenterPathFlowPage',
      ...operationOptions
    });
};
export const SubmitDatePathFlowQuestionDocument = gql`
    mutation SubmitDatePathFlowQuestion($input: SubmitDatePathFlowQuestionInput!) {
  submitDatePathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitDatePathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>;
export type SubmitDatePathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitDatePathFlowQuestionMutationVariables };

    export const SubmitDatePathFlowQuestionComponent = (props: SubmitDatePathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables> mutation={SubmitDatePathFlowQuestionDocument} {...props} />
    );
    
export type SubmitDatePathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitDatePathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitDatePathFlowQuestionMutation,
  SubmitDatePathFlowQuestionMutationVariables,
  SubmitDatePathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitDatePathFlowQuestionMutation, SubmitDatePathFlowQuestionMutationVariables, SubmitDatePathFlowQuestionProps<TChildProps>>(SubmitDatePathFlowQuestionDocument, {
      alias: 'withSubmitDatePathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitDateRangePathFlowQuestionDocument = gql`
    mutation SubmitDateRangePathFlowQuestion($input: SubmitDateRangePathFlowQuestionInput!) {
  submitDateRangePathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitDateRangePathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>;
export type SubmitDateRangePathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitDateRangePathFlowQuestionMutationVariables };

    export const SubmitDateRangePathFlowQuestionComponent = (props: SubmitDateRangePathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables> mutation={SubmitDateRangePathFlowQuestionDocument} {...props} />
    );
    
export type SubmitDateRangePathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitDateRangePathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitDateRangePathFlowQuestionMutation,
  SubmitDateRangePathFlowQuestionMutationVariables,
  SubmitDateRangePathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitDateRangePathFlowQuestionMutation, SubmitDateRangePathFlowQuestionMutationVariables, SubmitDateRangePathFlowQuestionProps<TChildProps>>(SubmitDateRangePathFlowQuestionDocument, {
      alias: 'withSubmitDateRangePathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitFacebookPathFlowQuestionDocument = gql`
    mutation SubmitFacebookPathFlowQuestion($input: SubmitInputTextPathFlowQuestionInput!) {
  submitInputTextPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitFacebookPathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>;
export type SubmitFacebookPathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitFacebookPathFlowQuestionMutationVariables };

    export const SubmitFacebookPathFlowQuestionComponent = (props: SubmitFacebookPathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables> mutation={SubmitFacebookPathFlowQuestionDocument} {...props} />
    );
    
export type SubmitFacebookPathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitFacebookPathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitFacebookPathFlowQuestionMutation,
  SubmitFacebookPathFlowQuestionMutationVariables,
  SubmitFacebookPathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitFacebookPathFlowQuestionMutation, SubmitFacebookPathFlowQuestionMutationVariables, SubmitFacebookPathFlowQuestionProps<TChildProps>>(SubmitFacebookPathFlowQuestionDocument, {
      alias: 'withSubmitFacebookPathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitIdPathFlowQuestionDocument = gql`
    mutation SubmitIdPathFlowQuestion($input: SubmitIdPathFlowQuestionInput!) {
  submitIdPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitIdPathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>;
export type SubmitIdPathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitIdPathFlowQuestionMutationVariables };

    export const SubmitIdPathFlowQuestionComponent = (props: SubmitIdPathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables> mutation={SubmitIdPathFlowQuestionDocument} {...props} />
    );
    
export type SubmitIdPathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitIdPathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitIdPathFlowQuestionMutation,
  SubmitIdPathFlowQuestionMutationVariables,
  SubmitIdPathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitIdPathFlowQuestionMutation, SubmitIdPathFlowQuestionMutationVariables, SubmitIdPathFlowQuestionProps<TChildProps>>(SubmitIdPathFlowQuestionDocument, {
      alias: 'withSubmitIdPathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitInputTextPathFlowQuestionDocument = gql`
    mutation SubmitInputTextPathFlowQuestion($input: SubmitInputTextPathFlowQuestionInput!) {
  submitInputTextPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitInputTextPathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>;
export type SubmitInputTextPathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitInputTextPathFlowQuestionMutationVariables };

    export const SubmitInputTextPathFlowQuestionComponent = (props: SubmitInputTextPathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables> mutation={SubmitInputTextPathFlowQuestionDocument} {...props} />
    );
    
export type SubmitInputTextPathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitInputTextPathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitInputTextPathFlowQuestionMutation,
  SubmitInputTextPathFlowQuestionMutationVariables,
  SubmitInputTextPathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitInputTextPathFlowQuestionMutation, SubmitInputTextPathFlowQuestionMutationVariables, SubmitInputTextPathFlowQuestionProps<TChildProps>>(SubmitInputTextPathFlowQuestionDocument, {
      alias: 'withSubmitInputTextPathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitListPathFlowQuestionDocument = gql`
    mutation SubmitListPathFlowQuestion($input: SubmitListPathFlowQuestionInput!) {
  submitListPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitListPathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>;
export type SubmitListPathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitListPathFlowQuestionMutationVariables };

    export const SubmitListPathFlowQuestionComponent = (props: SubmitListPathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables> mutation={SubmitListPathFlowQuestionDocument} {...props} />
    );
    
export type SubmitListPathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitListPathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitListPathFlowQuestionMutation,
  SubmitListPathFlowQuestionMutationVariables,
  SubmitListPathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitListPathFlowQuestionMutation, SubmitListPathFlowQuestionMutationVariables, SubmitListPathFlowQuestionProps<TChildProps>>(SubmitListPathFlowQuestionDocument, {
      alias: 'withSubmitListPathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitNumericPathFlowQuestionDocument = gql`
    mutation SubmitNumericPathFlowQuestion($input: SubmitNumericPathFlowQuestionInput!) {
  submitNumericPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitNumericPathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>;
export type SubmitNumericPathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitNumericPathFlowQuestionMutationVariables };

    export const SubmitNumericPathFlowQuestionComponent = (props: SubmitNumericPathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables> mutation={SubmitNumericPathFlowQuestionDocument} {...props} />
    );
    
export type SubmitNumericPathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitNumericPathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitNumericPathFlowQuestionMutation,
  SubmitNumericPathFlowQuestionMutationVariables,
  SubmitNumericPathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitNumericPathFlowQuestionMutation, SubmitNumericPathFlowQuestionMutationVariables, SubmitNumericPathFlowQuestionProps<TChildProps>>(SubmitNumericPathFlowQuestionDocument, {
      alias: 'withSubmitNumericPathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitOAuthEmailPathFlowQuestionDocument = gql`
    mutation SubmitOAuthEmailPathFlowQuestion($input: SubmitOAuthEmailPathFlowQuestionInput!) {
  submitOAuthEmailPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitOAuthEmailPathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>;
export type SubmitOAuthEmailPathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitOAuthEmailPathFlowQuestionMutationVariables };

    export const SubmitOAuthEmailPathFlowQuestionComponent = (props: SubmitOAuthEmailPathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables> mutation={SubmitOAuthEmailPathFlowQuestionDocument} {...props} />
    );
    
export type SubmitOAuthEmailPathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitOAuthEmailPathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitOAuthEmailPathFlowQuestionMutation,
  SubmitOAuthEmailPathFlowQuestionMutationVariables,
  SubmitOAuthEmailPathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitOAuthEmailPathFlowQuestionMutation, SubmitOAuthEmailPathFlowQuestionMutationVariables, SubmitOAuthEmailPathFlowQuestionProps<TChildProps>>(SubmitOAuthEmailPathFlowQuestionDocument, {
      alias: 'withSubmitOAuthEmailPathFlowQuestion',
      ...operationOptions
    });
};
export const SubmitPathFlowPageDocument = gql`
    mutation SubmitPathFlowPage($input: SubmitPathFlowPageInput!) {
  submitPathFlowPage(input: $input) {
    flow {
      ...PathFlow
    }
    errors {
      ...PathValidationError
    }
    newUserRegistered
  }
}
    ${PathFlowFragmentDoc}
${PathValidationErrorFragmentDoc}`;
export type SubmitPathFlowPageMutationFn = ReactApollo.MutationFn<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>;
export type SubmitPathFlowPageComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitPathFlowPageMutationVariables };

    export const SubmitPathFlowPageComponent = (props: SubmitPathFlowPageComponentProps) => (
      <ReactApollo.Mutation<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables> mutation={SubmitPathFlowPageDocument} {...props} />
    );
    
export type SubmitPathFlowPageProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables>> & TChildProps;
export function withSubmitPathFlowPage<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitPathFlowPageMutation,
  SubmitPathFlowPageMutationVariables,
  SubmitPathFlowPageProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitPathFlowPageMutation, SubmitPathFlowPageMutationVariables, SubmitPathFlowPageProps<TChildProps>>(SubmitPathFlowPageDocument, {
      alias: 'withSubmitPathFlowPage',
      ...operationOptions
    });
};
export const SubmitPushNotifcationFcmTokenDocument = gql`
    mutation SubmitPushNotifcationFCMToken($input: SubmitInputTextPathFlowQuestionInput!) {
  submitInputTextPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitPushNotifcationFcmTokenMutationFn = ReactApollo.MutationFn<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>;
export type SubmitPushNotifcationFcmTokenComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitPushNotifcationFcmTokenMutationVariables };

    export const SubmitPushNotifcationFcmTokenComponent = (props: SubmitPushNotifcationFcmTokenComponentProps) => (
      <ReactApollo.Mutation<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables> mutation={SubmitPushNotifcationFcmTokenDocument} {...props} />
    );
    
export type SubmitPushNotifcationFcmTokenProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables>> & TChildProps;
export function withSubmitPushNotifcationFcmToken<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitPushNotifcationFcmTokenMutation,
  SubmitPushNotifcationFcmTokenMutationVariables,
  SubmitPushNotifcationFcmTokenProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitPushNotifcationFcmTokenMutation, SubmitPushNotifcationFcmTokenMutationVariables, SubmitPushNotifcationFcmTokenProps<TChildProps>>(SubmitPushNotifcationFcmTokenDocument, {
      alias: 'withSubmitPushNotifcationFcmToken',
      ...operationOptions
    });
};
export const SubmitPushNotificationAuthorizedStatusDocument = gql`
    mutation SubmitPushNotificationAuthorizedStatus($input: SubmitListPathFlowQuestionInput!) {
  submitListPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitPushNotificationAuthorizedStatusMutationFn = ReactApollo.MutationFn<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>;
export type SubmitPushNotificationAuthorizedStatusComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitPushNotificationAuthorizedStatusMutationVariables };

    export const SubmitPushNotificationAuthorizedStatusComponent = (props: SubmitPushNotificationAuthorizedStatusComponentProps) => (
      <ReactApollo.Mutation<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables> mutation={SubmitPushNotificationAuthorizedStatusDocument} {...props} />
    );
    
export type SubmitPushNotificationAuthorizedStatusProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables>> & TChildProps;
export function withSubmitPushNotificationAuthorizedStatus<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitPushNotificationAuthorizedStatusMutation,
  SubmitPushNotificationAuthorizedStatusMutationVariables,
  SubmitPushNotificationAuthorizedStatusProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitPushNotificationAuthorizedStatusMutation, SubmitPushNotificationAuthorizedStatusMutationVariables, SubmitPushNotificationAuthorizedStatusProps<TChildProps>>(SubmitPushNotificationAuthorizedStatusDocument, {
      alias: 'withSubmitPushNotificationAuthorizedStatus',
      ...operationOptions
    });
};
export const SubmitUserContactPathFlowQuestionDocument = gql`
    mutation SubmitUserContactPathFlowQuestion($input: SubmitUserContactPathFlowQuestionInput!) {
  submitUserContactPathFlowQuestion(input: $input) {
    errors {
      ...PathValidationError
    }
  }
}
    ${PathValidationErrorFragmentDoc}`;
export type SubmitUserContactPathFlowQuestionMutationFn = ReactApollo.MutationFn<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>;
export type SubmitUserContactPathFlowQuestionComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitUserContactPathFlowQuestionMutationVariables };

    export const SubmitUserContactPathFlowQuestionComponent = (props: SubmitUserContactPathFlowQuestionComponentProps) => (
      <ReactApollo.Mutation<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables> mutation={SubmitUserContactPathFlowQuestionDocument} {...props} />
    );
    
export type SubmitUserContactPathFlowQuestionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables>> & TChildProps;
export function withSubmitUserContactPathFlowQuestion<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitUserContactPathFlowQuestionMutation,
  SubmitUserContactPathFlowQuestionMutationVariables,
  SubmitUserContactPathFlowQuestionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitUserContactPathFlowQuestionMutation, SubmitUserContactPathFlowQuestionMutationVariables, SubmitUserContactPathFlowQuestionProps<TChildProps>>(SubmitUserContactPathFlowQuestionDocument, {
      alias: 'withSubmitUserContactPathFlowQuestion',
      ...operationOptions
    });
};
export const UploadGearImageDocument = gql`
    mutation UploadGearImage($input: UploadMediaInput!) {
  uploadMedia(input: $input) {
    mediaFile {
      id
      url
    }
  }
}
    `;
export type UploadGearImageMutationFn = ReactApollo.MutationFn<UploadGearImageMutation, UploadGearImageMutationVariables>;
export type UploadGearImageComponentProps = Omit<Omit<ReactApollo.MutationProps<UploadGearImageMutation, UploadGearImageMutationVariables>, 'mutation'>, 'variables'> & { variables?: UploadGearImageMutationVariables };

    export const UploadGearImageComponent = (props: UploadGearImageComponentProps) => (
      <ReactApollo.Mutation<UploadGearImageMutation, UploadGearImageMutationVariables> mutation={UploadGearImageDocument} {...props} />
    );
    
export type UploadGearImageProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UploadGearImageMutation, UploadGearImageMutationVariables>> & TChildProps;
export function withUploadGearImage<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UploadGearImageMutation,
  UploadGearImageMutationVariables,
  UploadGearImageProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UploadGearImageMutation, UploadGearImageMutationVariables, UploadGearImageProps<TChildProps>>(UploadGearImageDocument, {
      alias: 'withUploadGearImage',
      ...operationOptions
    });
};
export const PathFlowDocument = gql`
    query PathFlow($id: PathFlowId!) {
  pathFlow(id: $id) {
    flow {
      ...PathFlow
    }
  }
}
    ${PathFlowFragmentDoc}`;
export type PathFlowComponentProps = Omit<Omit<ReactApollo.QueryProps<PathFlowQuery, PathFlowQueryVariables>, 'query'>, 'variables'> & { variables: PathFlowQueryVariables };

    export const PathFlowComponent = (props: PathFlowComponentProps) => (
      <ReactApollo.Query<PathFlowQuery, PathFlowQueryVariables> query={PathFlowDocument} {...props} />
    );
    
export type PathFlowProps<TChildProps = {}> = Partial<ReactApollo.DataProps<PathFlowQuery, PathFlowQueryVariables>> & TChildProps;
export function withPathFlow<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  PathFlowQuery,
  PathFlowQueryVariables,
  PathFlowProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, PathFlowQuery, PathFlowQueryVariables, PathFlowProps<TChildProps>>(PathFlowDocument, {
      alias: 'withPathFlow',
      ...operationOptions
    });
};
export const PathFlowPageDocument = gql`
    query PathFlowPage($pathFlowId: PathFlowId!, $pathFlowPageSlug: String!) {
  pathFlowPage(id: $pathFlowId, pageSlug: $pathFlowPageSlug) {
    page {
      ...PathFlowPage
    }
  }
}
    ${PathFlowPageFragmentDoc}`;
export type PathFlowPageComponentProps = Omit<Omit<ReactApollo.QueryProps<PathFlowPageQuery, PathFlowPageQueryVariables>, 'query'>, 'variables'> & { variables: PathFlowPageQueryVariables };

    export const PathFlowPageComponent = (props: PathFlowPageComponentProps) => (
      <ReactApollo.Query<PathFlowPageQuery, PathFlowPageQueryVariables> query={PathFlowPageDocument} {...props} />
    );
    
export type PathFlowPageProps<TChildProps = {}> = Partial<ReactApollo.DataProps<PathFlowPageQuery, PathFlowPageQueryVariables>> & TChildProps;
export function withPathFlowPage<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  PathFlowPageQuery,
  PathFlowPageQueryVariables,
  PathFlowPageProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, PathFlowPageQuery, PathFlowPageQueryVariables, PathFlowPageProps<TChildProps>>(PathFlowPageDocument, {
      alias: 'withPathFlowPage',
      ...operationOptions
    });
};
export const RecommendExpertsForPathFlowDocument = gql`
    query RecommendExpertsForPathFlow($pathFlowId: PathFlowId!) {
  recommendExpertsForPathFlow(pathFlowId: $pathFlowId, limit: 3) {
    expert {
      ...PathExpert
    }
  }
}
    ${PathExpertFragmentDoc}`;
export type RecommendExpertsForPathFlowComponentProps = Omit<Omit<ReactApollo.QueryProps<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>, 'query'>, 'variables'> & { variables: RecommendExpertsForPathFlowQueryVariables };

    export const RecommendExpertsForPathFlowComponent = (props: RecommendExpertsForPathFlowComponentProps) => (
      <ReactApollo.Query<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables> query={RecommendExpertsForPathFlowDocument} {...props} />
    );
    
export type RecommendExpertsForPathFlowProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables>> & TChildProps;
export function withRecommendExpertsForPathFlow<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RecommendExpertsForPathFlowQuery,
  RecommendExpertsForPathFlowQueryVariables,
  RecommendExpertsForPathFlowProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RecommendExpertsForPathFlowQuery, RecommendExpertsForPathFlowQueryVariables, RecommendExpertsForPathFlowProps<TChildProps>>(RecommendExpertsForPathFlowDocument, {
      alias: 'withRecommendExpertsForPathFlow',
      ...operationOptions
    });
};
export const DepartmentCategoryAssetsDocument = gql`
    query DepartmentCategoryAssets($id: DepartmentId!) {
  department(id: $id) {
    id
    topLevelCategories {
      id
      contentAssets {
        bannerImages {
          imageUrl
        }
      }
    }
  }
}
    `;
export type DepartmentCategoryAssetsComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentCategoryAssetsQuery, DepartmentCategoryAssetsQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentCategoryAssetsQueryVariables };

    export const DepartmentCategoryAssetsComponent = (props: DepartmentCategoryAssetsComponentProps) => (
      <ReactApollo.Query<DepartmentCategoryAssetsQuery, DepartmentCategoryAssetsQueryVariables> query={DepartmentCategoryAssetsDocument} {...props} />
    );
    
export type DepartmentCategoryAssetsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentCategoryAssetsQuery, DepartmentCategoryAssetsQueryVariables>> & TChildProps;
export function withDepartmentCategoryAssets<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentCategoryAssetsQuery,
  DepartmentCategoryAssetsQueryVariables,
  DepartmentCategoryAssetsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentCategoryAssetsQuery, DepartmentCategoryAssetsQueryVariables, DepartmentCategoryAssetsProps<TChildProps>>(DepartmentCategoryAssetsDocument, {
      alias: 'withDepartmentCategoryAssets',
      ...operationOptions
    });
};
export const PhoneCollectionBusinessUserDocument = gql`
    query PhoneCollectionBusinessUser($id: BusinessUserId!) {
  businessUser(id: $id) {
    ...PhoneCollectionExpert
  }
}
    ${PhoneCollectionExpertFragmentDoc}`;
export type PhoneCollectionBusinessUserComponentProps = Omit<Omit<ReactApollo.QueryProps<PhoneCollectionBusinessUserQuery, PhoneCollectionBusinessUserQueryVariables>, 'query'>, 'variables'> & { variables: PhoneCollectionBusinessUserQueryVariables };

    export const PhoneCollectionBusinessUserComponent = (props: PhoneCollectionBusinessUserComponentProps) => (
      <ReactApollo.Query<PhoneCollectionBusinessUserQuery, PhoneCollectionBusinessUserQueryVariables> query={PhoneCollectionBusinessUserDocument} {...props} />
    );
    
export type PhoneCollectionBusinessUserProps<TChildProps = {}> = Partial<ReactApollo.DataProps<PhoneCollectionBusinessUserQuery, PhoneCollectionBusinessUserQueryVariables>> & TChildProps;
export function withPhoneCollectionBusinessUser<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  PhoneCollectionBusinessUserQuery,
  PhoneCollectionBusinessUserQueryVariables,
  PhoneCollectionBusinessUserProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, PhoneCollectionBusinessUserQuery, PhoneCollectionBusinessUserQueryVariables, PhoneCollectionBusinessUserProps<TChildProps>>(PhoneCollectionBusinessUserDocument, {
      alias: 'withPhoneCollectionBusinessUser',
      ...operationOptions
    });
};
export const UpdateUserPhoneNumberDocument = gql`
    mutation UpdateUserPhoneNumber($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
    user {
      id
      contacts {
        id
        type
        value
        verified
      }
    }
  }
}
    `;
export type UpdateUserPhoneNumberMutationFn = ReactApollo.MutationFn<UpdateUserPhoneNumberMutation, UpdateUserPhoneNumberMutationVariables>;
export type UpdateUserPhoneNumberComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateUserPhoneNumberMutation, UpdateUserPhoneNumberMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateUserPhoneNumberMutationVariables };

    export const UpdateUserPhoneNumberComponent = (props: UpdateUserPhoneNumberComponentProps) => (
      <ReactApollo.Mutation<UpdateUserPhoneNumberMutation, UpdateUserPhoneNumberMutationVariables> mutation={UpdateUserPhoneNumberDocument} {...props} />
    );
    
export type UpdateUserPhoneNumberProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateUserPhoneNumberMutation, UpdateUserPhoneNumberMutationVariables>> & TChildProps;
export function withUpdateUserPhoneNumber<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateUserPhoneNumberMutation,
  UpdateUserPhoneNumberMutationVariables,
  UpdateUserPhoneNumberProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateUserPhoneNumberMutation, UpdateUserPhoneNumberMutationVariables, UpdateUserPhoneNumberProps<TChildProps>>(UpdateUserPhoneNumberDocument, {
      alias: 'withUpdateUserPhoneNumber',
      ...operationOptions
    });
};
export const IssueVerificationCodeDocument = gql`
    mutation IssueVerificationCode($input: InitiateVerifyHandleInput!) {
  initiateVerifyHandle(input: $input) {
    success
  }
}
    `;
export type IssueVerificationCodeMutationFn = ReactApollo.MutationFn<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>;
export type IssueVerificationCodeComponentProps = Omit<Omit<ReactApollo.MutationProps<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>, 'mutation'>, 'variables'> & { variables?: IssueVerificationCodeMutationVariables };

    export const IssueVerificationCodeComponent = (props: IssueVerificationCodeComponentProps) => (
      <ReactApollo.Mutation<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables> mutation={IssueVerificationCodeDocument} {...props} />
    );
    
export type IssueVerificationCodeProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables>> & TChildProps;
export function withIssueVerificationCode<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  IssueVerificationCodeMutation,
  IssueVerificationCodeMutationVariables,
  IssueVerificationCodeProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, IssueVerificationCodeMutation, IssueVerificationCodeMutationVariables, IssueVerificationCodeProps<TChildProps>>(IssueVerificationCodeDocument, {
      alias: 'withIssueVerificationCode',
      ...operationOptions
    });
};
export const UpdateUserPhoneDocument = gql`
    mutation UpdateUserPhone($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
    user {
      id
      contacts {
        id
        type
        value
        verified
      }
    }
  }
}
    `;
export type UpdateUserPhoneMutationFn = ReactApollo.MutationFn<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>;
export type UpdateUserPhoneComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateUserPhoneMutationVariables };

    export const UpdateUserPhoneComponent = (props: UpdateUserPhoneComponentProps) => (
      <ReactApollo.Mutation<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables> mutation={UpdateUserPhoneDocument} {...props} />
    );
    
export type UpdateUserPhoneProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>> & TChildProps;
export function withUpdateUserPhone<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateUserPhoneMutation,
  UpdateUserPhoneMutationVariables,
  UpdateUserPhoneProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables, UpdateUserPhoneProps<TChildProps>>(UpdateUserPhoneDocument, {
      alias: 'withUpdateUserPhone',
      ...operationOptions
    });
};
export const ConfirmVerificationCodeDocument = gql`
    mutation ConfirmVerificationCode($input: VerifyHandleChallengeInput!) {
  verifyHandleChallenge(input: $input) {
    message
    success
  }
}
    `;
export type ConfirmVerificationCodeMutationFn = ReactApollo.MutationFn<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>;
export type ConfirmVerificationCodeComponentProps = Omit<Omit<ReactApollo.MutationProps<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>, 'mutation'>, 'variables'> & { variables?: ConfirmVerificationCodeMutationVariables };

    export const ConfirmVerificationCodeComponent = (props: ConfirmVerificationCodeComponentProps) => (
      <ReactApollo.Mutation<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables> mutation={ConfirmVerificationCodeDocument} {...props} />
    );
    
export type ConfirmVerificationCodeProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>> & TChildProps;
export function withConfirmVerificationCode<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ConfirmVerificationCodeMutation,
  ConfirmVerificationCodeMutationVariables,
  ConfirmVerificationCodeProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables, ConfirmVerificationCodeProps<TChildProps>>(ConfirmVerificationCodeDocument, {
      alias: 'withConfirmVerificationCode',
      ...operationOptions
    });
};
export const RecommendedListByTypeDocument = gql`
    query RecommendedListByType($categorySlug: String!, $types: [RecommendedListType!]) {
  recommendedListsForCategory(categorySlug: $categorySlug, types: $types) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...RecommendedList
      }
    }
  }
}
    ${RecommendedListFragmentDoc}`;
export type RecommendedListByTypeComponentProps = Omit<Omit<ReactApollo.QueryProps<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>, 'query'>, 'variables'> & { variables: RecommendedListByTypeQueryVariables };

    export const RecommendedListByTypeComponent = (props: RecommendedListByTypeComponentProps) => (
      <ReactApollo.Query<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables> query={RecommendedListByTypeDocument} {...props} />
    );
    
export type RecommendedListByTypeProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables>> & TChildProps;
export function withRecommendedListByType<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RecommendedListByTypeQuery,
  RecommendedListByTypeQueryVariables,
  RecommendedListByTypeProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RecommendedListByTypeQuery, RecommendedListByTypeQueryVariables, RecommendedListByTypeProps<TChildProps>>(RecommendedListByTypeDocument, {
      alias: 'withRecommendedListByType',
      ...operationOptions
    });
};
export const StartExpertRatingPathDocument = gql`
    mutation StartExpertRatingPath($input: StartExpertRatingInput!) {
  startExpertRatingPath(input: $input) {
    expert {
      ...BusinessUserToRate
    }
    flow {
      id
      slug
      pagesConnection {
        edges {
          node {
            slug
          }
        }
      }
    }
    errors {
      pageName
      questionName
    }
  }
}
    ${BusinessUserToRateFragmentDoc}`;
export type StartExpertRatingPathMutationFn = ReactApollo.MutationFn<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>;
export type StartExpertRatingPathComponentProps = Omit<Omit<ReactApollo.MutationProps<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>, 'mutation'>, 'variables'> & { variables?: StartExpertRatingPathMutationVariables };

    export const StartExpertRatingPathComponent = (props: StartExpertRatingPathComponentProps) => (
      <ReactApollo.Mutation<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables> mutation={StartExpertRatingPathDocument} {...props} />
    );
    
export type StartExpertRatingPathProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables>> & TChildProps;
export function withStartExpertRatingPath<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  StartExpertRatingPathMutation,
  StartExpertRatingPathMutationVariables,
  StartExpertRatingPathProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, StartExpertRatingPathMutation, StartExpertRatingPathMutationVariables, StartExpertRatingPathProps<TChildProps>>(StartExpertRatingPathDocument, {
      alias: 'withStartExpertRatingPath',
      ...operationOptions
    });
};
export const UserExpertReviewsDocument = gql`
    query UserExpertReviews($expertId: BusinessUserId) {
  me {
    id
    user {
      id
      expertReviews(expertId: $expertId) {
        id
        expert {
          id
        }
      }
    }
  }
}
    `;
export type UserExpertReviewsComponentProps = Omit<Omit<ReactApollo.QueryProps<UserExpertReviewsQuery, UserExpertReviewsQueryVariables>, 'query'>, 'variables'> & { variables?: UserExpertReviewsQueryVariables };

    export const UserExpertReviewsComponent = (props: UserExpertReviewsComponentProps) => (
      <ReactApollo.Query<UserExpertReviewsQuery, UserExpertReviewsQueryVariables> query={UserExpertReviewsDocument} {...props} />
    );
    
export type UserExpertReviewsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<UserExpertReviewsQuery, UserExpertReviewsQueryVariables>> & TChildProps;
export function withUserExpertReviews<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UserExpertReviewsQuery,
  UserExpertReviewsQueryVariables,
  UserExpertReviewsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, UserExpertReviewsQuery, UserExpertReviewsQueryVariables, UserExpertReviewsProps<TChildProps>>(UserExpertReviewsDocument, {
      alias: 'withUserExpertReviews',
      ...operationOptions
    });
};
export const DepartmentReviewsDocument = gql`
    query DepartmentReviews($id: DepartmentId!) {
  department(id: $id) {
    id
    reviewSummary {
      averageRating
      totalReviews
    }
  }
}
    `;
export type DepartmentReviewsComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentReviewsQueryVariables };

    export const DepartmentReviewsComponent = (props: DepartmentReviewsComponentProps) => (
      <ReactApollo.Query<DepartmentReviewsQuery, DepartmentReviewsQueryVariables> query={DepartmentReviewsDocument} {...props} />
    );
    
export type DepartmentReviewsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentReviewsQuery, DepartmentReviewsQueryVariables>> & TChildProps;
export function withDepartmentReviews<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentReviewsQuery,
  DepartmentReviewsQueryVariables,
  DepartmentReviewsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentReviewsQuery, DepartmentReviewsQueryVariables, DepartmentReviewsProps<TChildProps>>(DepartmentReviewsDocument, {
      alias: 'withDepartmentReviews',
      ...operationOptions
    });
};
export const SaveSellableDocument = gql`
    mutation SaveSellable($input: SaveSavedSellableInput!) {
  saveSavedSellable(input: $input) {
    savedSellable {
      id
      saved
      sellable {
        ...SellableCard
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type SaveSellableMutationFn = ReactApollo.MutationFn<SaveSellableMutation, SaveSellableMutationVariables>;
export type SaveSellableComponentProps = Omit<Omit<ReactApollo.MutationProps<SaveSellableMutation, SaveSellableMutationVariables>, 'mutation'>, 'variables'> & { variables?: SaveSellableMutationVariables };

    export const SaveSellableComponent = (props: SaveSellableComponentProps) => (
      <ReactApollo.Mutation<SaveSellableMutation, SaveSellableMutationVariables> mutation={SaveSellableDocument} {...props} />
    );
    
export type SaveSellableProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SaveSellableMutation, SaveSellableMutationVariables>> & TChildProps;
export function withSaveSellable<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SaveSellableMutation,
  SaveSellableMutationVariables,
  SaveSellableProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SaveSellableMutation, SaveSellableMutationVariables, SaveSellableProps<TChildProps>>(SaveSellableDocument, {
      alias: 'withSaveSellable',
      ...operationOptions
    });
};
export const UnsaveSellableDocument = gql`
    mutation UnsaveSellable($input: UnsaveSavedSellableInput!) {
  unsaveSavedSellable(input: $input) {
    savedSellable {
      id
      saved
      sellable {
        ...SellableCard
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type UnsaveSellableMutationFn = ReactApollo.MutationFn<UnsaveSellableMutation, UnsaveSellableMutationVariables>;
export type UnsaveSellableComponentProps = Omit<Omit<ReactApollo.MutationProps<UnsaveSellableMutation, UnsaveSellableMutationVariables>, 'mutation'>, 'variables'> & { variables?: UnsaveSellableMutationVariables };

    export const UnsaveSellableComponent = (props: UnsaveSellableComponentProps) => (
      <ReactApollo.Mutation<UnsaveSellableMutation, UnsaveSellableMutationVariables> mutation={UnsaveSellableDocument} {...props} />
    );
    
export type UnsaveSellableProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UnsaveSellableMutation, UnsaveSellableMutationVariables>> & TChildProps;
export function withUnsaveSellable<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UnsaveSellableMutation,
  UnsaveSellableMutationVariables,
  UnsaveSellableProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UnsaveSellableMutation, UnsaveSellableMutationVariables, UnsaveSellableProps<TChildProps>>(UnsaveSellableDocument, {
      alias: 'withUnsaveSellable',
      ...operationOptions
    });
};
export const ConsumerReactionsForSellableDocument = gql`
    query ConsumerReactionsForSellable($id: SellableId!) {
  sellable(id: $id) {
    id
    consumerSellableReactions {
      edges {
        node {
          id
          ratingWithDisplayName {
            displayName
            rating
          }
        }
      }
    }
  }
}
    `;
export type ConsumerReactionsForSellableComponentProps = Omit<Omit<ReactApollo.QueryProps<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>, 'query'>, 'variables'> & { variables: ConsumerReactionsForSellableQueryVariables };

    export const ConsumerReactionsForSellableComponent = (props: ConsumerReactionsForSellableComponentProps) => (
      <ReactApollo.Query<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables> query={ConsumerReactionsForSellableDocument} {...props} />
    );
    
export type ConsumerReactionsForSellableProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables>> & TChildProps;
export function withConsumerReactionsForSellable<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ConsumerReactionsForSellableQuery,
  ConsumerReactionsForSellableQueryVariables,
  ConsumerReactionsForSellableProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ConsumerReactionsForSellableQuery, ConsumerReactionsForSellableQueryVariables, ConsumerReactionsForSellableProps<TChildProps>>(ConsumerReactionsForSellableDocument, {
      alias: 'withConsumerReactionsForSellable',
      ...operationOptions
    });
};
export const SaveRecommendedListRatingDocument = gql`
    mutation SaveRecommendedListRating($input: SaveConsumerSellableReactionInput!) {
  saveConsumerSellableReaction(input: $input) {
    consumerSellableReaction {
      id
      sellable {
        ...SellableCard
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type SaveRecommendedListRatingMutationFn = ReactApollo.MutationFn<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>;
export type SaveRecommendedListRatingComponentProps = Omit<Omit<ReactApollo.MutationProps<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>, 'mutation'>, 'variables'> & { variables?: SaveRecommendedListRatingMutationVariables };

    export const SaveRecommendedListRatingComponent = (props: SaveRecommendedListRatingComponentProps) => (
      <ReactApollo.Mutation<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables> mutation={SaveRecommendedListRatingDocument} {...props} />
    );
    
export type SaveRecommendedListRatingProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables>> & TChildProps;
export function withSaveRecommendedListRating<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SaveRecommendedListRatingMutation,
  SaveRecommendedListRatingMutationVariables,
  SaveRecommendedListRatingProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SaveRecommendedListRatingMutation, SaveRecommendedListRatingMutationVariables, SaveRecommendedListRatingProps<TChildProps>>(SaveRecommendedListRatingDocument, {
      alias: 'withSaveRecommendedListRating',
      ...operationOptions
    });
};
export const CreateShareLinkDocument = gql`
    mutation CreateShareLink($input: ShortenUrlInput!) {
  shortenUrl(input: $input) {
    url
  }
}
    `;
export type CreateShareLinkMutationFn = ReactApollo.MutationFn<CreateShareLinkMutation, CreateShareLinkMutationVariables>;
export type CreateShareLinkComponentProps = Omit<Omit<ReactApollo.MutationProps<CreateShareLinkMutation, CreateShareLinkMutationVariables>, 'mutation'>, 'variables'> & { variables?: CreateShareLinkMutationVariables };

    export const CreateShareLinkComponent = (props: CreateShareLinkComponentProps) => (
      <ReactApollo.Mutation<CreateShareLinkMutation, CreateShareLinkMutationVariables> mutation={CreateShareLinkDocument} {...props} />
    );
    
export type CreateShareLinkProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<CreateShareLinkMutation, CreateShareLinkMutationVariables>> & TChildProps;
export function withCreateShareLink<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CreateShareLinkMutation,
  CreateShareLinkMutationVariables,
  CreateShareLinkProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, CreateShareLinkMutation, CreateShareLinkMutationVariables, CreateShareLinkProps<TChildProps>>(CreateShareLinkDocument, {
      alias: 'withCreateShareLink',
      ...operationOptions
    });
};
export const SendExpertReferralDocument = gql`
    mutation SendExpertReferral($input: SendExpertReferralInput!) {
  sendExpertReferral(input: $input) {
    errors
  }
}
    `;
export type SendExpertReferralMutationFn = ReactApollo.MutationFn<SendExpertReferralMutation, SendExpertReferralMutationVariables>;
export type SendExpertReferralComponentProps = Omit<Omit<ReactApollo.MutationProps<SendExpertReferralMutation, SendExpertReferralMutationVariables>, 'mutation'>, 'variables'> & { variables?: SendExpertReferralMutationVariables };

    export const SendExpertReferralComponent = (props: SendExpertReferralComponentProps) => (
      <ReactApollo.Mutation<SendExpertReferralMutation, SendExpertReferralMutationVariables> mutation={SendExpertReferralDocument} {...props} />
    );
    
export type SendExpertReferralProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SendExpertReferralMutation, SendExpertReferralMutationVariables>> & TChildProps;
export function withSendExpertReferral<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SendExpertReferralMutation,
  SendExpertReferralMutationVariables,
  SendExpertReferralProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SendExpertReferralMutation, SendExpertReferralMutationVariables, SendExpertReferralProps<TChildProps>>(SendExpertReferralDocument, {
      alias: 'withSendExpertReferral',
      ...operationOptions
    });
};
export const BusinessUserToShareDocument = gql`
    query BusinessUserToShare($id: BusinessUserId!) {
  businessUser(id: $id) {
    id
    expertProfile {
      id
      profilePhoto {
        ...MediaFile
      }
    }
    expertAttributes {
      categories {
        id
        singularDisplayName
      }
    }
    firstName
    lastName
  }
}
    ${MediaFileFragmentDoc}`;
export type BusinessUserToShareComponentProps = Omit<Omit<ReactApollo.QueryProps<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>, 'query'>, 'variables'> & { variables: BusinessUserToShareQueryVariables };

    export const BusinessUserToShareComponent = (props: BusinessUserToShareComponentProps) => (
      <ReactApollo.Query<BusinessUserToShareQuery, BusinessUserToShareQueryVariables> query={BusinessUserToShareDocument} {...props} />
    );
    
export type BusinessUserToShareProps<TChildProps = {}> = Partial<ReactApollo.DataProps<BusinessUserToShareQuery, BusinessUserToShareQueryVariables>> & TChildProps;
export function withBusinessUserToShare<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  BusinessUserToShareQuery,
  BusinessUserToShareQueryVariables,
  BusinessUserToShareProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, BusinessUserToShareQuery, BusinessUserToShareQueryVariables, BusinessUserToShareProps<TChildProps>>(BusinessUserToShareDocument, {
      alias: 'withBusinessUserToShare',
      ...operationOptions
    });
};
export const DismissOrderMessageDocument = gql`
    mutation DismissOrderMessage {
  dismissOrderMessages(input: {}) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type DismissOrderMessageMutationFn = ReactApollo.MutationFn<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>;
export type DismissOrderMessageComponentProps = Omit<Omit<ReactApollo.MutationProps<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>, 'mutation'>, 'variables'> & { variables?: DismissOrderMessageMutationVariables };

    export const DismissOrderMessageComponent = (props: DismissOrderMessageComponentProps) => (
      <ReactApollo.Mutation<DismissOrderMessageMutation, DismissOrderMessageMutationVariables> mutation={DismissOrderMessageDocument} {...props} />
    );
    
export type DismissOrderMessageProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<DismissOrderMessageMutation, DismissOrderMessageMutationVariables>> & TChildProps;
export function withDismissOrderMessage<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DismissOrderMessageMutation,
  DismissOrderMessageMutationVariables,
  DismissOrderMessageProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, DismissOrderMessageMutation, DismissOrderMessageMutationVariables, DismissOrderMessageProps<TChildProps>>(DismissOrderMessageDocument, {
      alias: 'withDismissOrderMessage',
      ...operationOptions
    });
};
export const RemoveItemFromOrderDocument = gql`
    mutation RemoveItemFromOrder($input: RemoveItemsFromOrderInput!) {
  removeItemsFromOrder(input: $input) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type RemoveItemFromOrderMutationFn = ReactApollo.MutationFn<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>;
export type RemoveItemFromOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: RemoveItemFromOrderMutationVariables };

    export const RemoveItemFromOrderComponent = (props: RemoveItemFromOrderComponentProps) => (
      <ReactApollo.Mutation<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables> mutation={RemoveItemFromOrderDocument} {...props} />
    );
    
export type RemoveItemFromOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables>> & TChildProps;
export function withRemoveItemFromOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RemoveItemFromOrderMutation,
  RemoveItemFromOrderMutationVariables,
  RemoveItemFromOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, RemoveItemFromOrderMutation, RemoveItemFromOrderMutationVariables, RemoveItemFromOrderProps<TChildProps>>(RemoveItemFromOrderDocument, {
      alias: 'withRemoveItemFromOrder',
      ...operationOptions
    });
};
export const SimilarProductsDocument = gql`
    query SimilarProducts($sellableId: SellableId!) {
  similarSellables(id: $sellableId) {
    sellables {
      ...SellableCard
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type SimilarProductsComponentProps = Omit<Omit<ReactApollo.QueryProps<SimilarProductsQuery, SimilarProductsQueryVariables>, 'query'>, 'variables'> & { variables: SimilarProductsQueryVariables };

    export const SimilarProductsComponent = (props: SimilarProductsComponentProps) => (
      <ReactApollo.Query<SimilarProductsQuery, SimilarProductsQueryVariables> query={SimilarProductsDocument} {...props} />
    );
    
export type SimilarProductsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SimilarProductsQuery, SimilarProductsQueryVariables>> & TChildProps;
export function withSimilarProducts<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SimilarProductsQuery,
  SimilarProductsQueryVariables,
  SimilarProductsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SimilarProductsQuery, SimilarProductsQueryVariables, SimilarProductsProps<TChildProps>>(SimilarProductsDocument, {
      alias: 'withSimilarProducts',
      ...operationOptions
    });
};
export const StandaloneRegisterDocument = gql`
    mutation StandaloneRegister($input: RegisterCustomerInput!) {
  registerCustomer(input: $input) {
    user {
      ...AuthenticatedUser
    }
    errors
    errorCodes
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type StandaloneRegisterMutationFn = ReactApollo.MutationFn<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>;
export type StandaloneRegisterComponentProps = Omit<Omit<ReactApollo.MutationProps<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>, 'mutation'>, 'variables'> & { variables?: StandaloneRegisterMutationVariables };

    export const StandaloneRegisterComponent = (props: StandaloneRegisterComponentProps) => (
      <ReactApollo.Mutation<StandaloneRegisterMutation, StandaloneRegisterMutationVariables> mutation={StandaloneRegisterDocument} {...props} />
    );
    
export type StandaloneRegisterProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<StandaloneRegisterMutation, StandaloneRegisterMutationVariables>> & TChildProps;
export function withStandaloneRegister<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  StandaloneRegisterMutation,
  StandaloneRegisterMutationVariables,
  StandaloneRegisterProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, StandaloneRegisterMutation, StandaloneRegisterMutationVariables, StandaloneRegisterProps<TChildProps>>(StandaloneRegisterDocument, {
      alias: 'withStandaloneRegister',
      ...operationOptions
    });
};
export const UploadMediaDocument = gql`
    mutation UploadMedia($input: UploadMediaInput!) {
  uploadMedia(input: $input) {
    mediaFile {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type UploadMediaMutationFn = ReactApollo.MutationFn<UploadMediaMutation, UploadMediaMutationVariables>;
export type UploadMediaComponentProps = Omit<Omit<ReactApollo.MutationProps<UploadMediaMutation, UploadMediaMutationVariables>, 'mutation'>, 'variables'> & { variables?: UploadMediaMutationVariables };

    export const UploadMediaComponent = (props: UploadMediaComponentProps) => (
      <ReactApollo.Mutation<UploadMediaMutation, UploadMediaMutationVariables> mutation={UploadMediaDocument} {...props} />
    );
    
export type UploadMediaProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UploadMediaMutation, UploadMediaMutationVariables>> & TChildProps;
export function withUploadMedia<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UploadMediaMutation,
  UploadMediaMutationVariables,
  UploadMediaProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UploadMediaMutation, UploadMediaMutationVariables, UploadMediaProps<TChildProps>>(UploadMediaDocument, {
      alias: 'withUploadMedia',
      ...operationOptions
    });
};
export const UpdateProfileDataDocument = gql`
    mutation UpdateProfileData($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
  }
}
    `;
export type UpdateProfileDataMutationFn = ReactApollo.MutationFn<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>;
export type UpdateProfileDataComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateProfileDataMutationVariables };

    export const UpdateProfileDataComponent = (props: UpdateProfileDataComponentProps) => (
      <ReactApollo.Mutation<UpdateProfileDataMutation, UpdateProfileDataMutationVariables> mutation={UpdateProfileDataDocument} {...props} />
    );
    
export type UpdateProfileDataProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateProfileDataMutation, UpdateProfileDataMutationVariables>> & TChildProps;
export function withUpdateProfileData<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateProfileDataMutation,
  UpdateProfileDataMutationVariables,
  UpdateProfileDataProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateProfileDataMutation, UpdateProfileDataMutationVariables, UpdateProfileDataProps<TChildProps>>(UpdateProfileDataDocument, {
      alias: 'withUpdateProfileData',
      ...operationOptions
    });
};
export const VariationMatrixDocument = gql`
    query VariationMatrix($id: SellableId!) {
  sellable(id: $id) {
    id
    variationMatrix {
      ...VariationMatrix
    }
  }
}
    ${VariationMatrixFragmentDoc}`;
export type VariationMatrixComponentProps = Omit<Omit<ReactApollo.QueryProps<VariationMatrixQuery, VariationMatrixQueryVariables>, 'query'>, 'variables'> & { variables: VariationMatrixQueryVariables };

    export const VariationMatrixComponent = (props: VariationMatrixComponentProps) => (
      <ReactApollo.Query<VariationMatrixQuery, VariationMatrixQueryVariables> query={VariationMatrixDocument} {...props} />
    );
    
export type VariationMatrixProps<TChildProps = {}> = Partial<ReactApollo.DataProps<VariationMatrixQuery, VariationMatrixQueryVariables>> & TChildProps;
export function withVariationMatrix<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  VariationMatrixQuery,
  VariationMatrixQueryVariables,
  VariationMatrixProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, VariationMatrixQuery, VariationMatrixQueryVariables, VariationMatrixProps<TChildProps>>(VariationMatrixDocument, {
      alias: 'withVariationMatrix',
      ...operationOptions
    });
};
export const BusinessUserChatWidgetDocument = gql`
    query BusinessUserChatWidget($id: BusinessUserId!) {
  businessUser(id: $id) {
    ...ChatWidgetExpert
    existingLeadForConsumer {
      id
      conversation {
        id
        externalId
      }
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type BusinessUserChatWidgetComponentProps = Omit<Omit<ReactApollo.QueryProps<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>, 'query'>, 'variables'> & { variables: BusinessUserChatWidgetQueryVariables };

    export const BusinessUserChatWidgetComponent = (props: BusinessUserChatWidgetComponentProps) => (
      <ReactApollo.Query<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables> query={BusinessUserChatWidgetDocument} {...props} />
    );
    
export type BusinessUserChatWidgetProps<TChildProps = {}> = Partial<ReactApollo.DataProps<BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables>> & TChildProps;
export function withBusinessUserChatWidget<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  BusinessUserChatWidgetQuery,
  BusinessUserChatWidgetQueryVariables,
  BusinessUserChatWidgetProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, BusinessUserChatWidgetQuery, BusinessUserChatWidgetQueryVariables, BusinessUserChatWidgetProps<TChildProps>>(BusinessUserChatWidgetDocument, {
      alias: 'withBusinessUserChatWidget',
      ...operationOptions
    });
};
export const ShoppingCartDocument = gql`
    query ShoppingCart($id: OrderId!) {
  order(id: $id) {
    ...ShoppingCartOrder
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type ShoppingCartComponentProps = Omit<Omit<ReactApollo.QueryProps<ShoppingCartQuery, ShoppingCartQueryVariables>, 'query'>, 'variables'> & { variables: ShoppingCartQueryVariables };

    export const ShoppingCartComponent = (props: ShoppingCartComponentProps) => (
      <ReactApollo.Query<ShoppingCartQuery, ShoppingCartQueryVariables> query={ShoppingCartDocument} {...props} />
    );
    
export type ShoppingCartProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ShoppingCartQuery, ShoppingCartQueryVariables>> & TChildProps;
export function withShoppingCart<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ShoppingCartQuery,
  ShoppingCartQueryVariables,
  ShoppingCartProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ShoppingCartQuery, ShoppingCartQueryVariables, ShoppingCartProps<TChildProps>>(ShoppingCartDocument, {
      alias: 'withShoppingCart',
      ...operationOptions
    });
};
export const ShoppingCartSubscriptionDocument = gql`
    subscription ShoppingCartSubscription($userId: UserId) {
  userCartLineItemsChanged(userId: $userId) {
    ...ShoppingCartOrder
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type ShoppingCartSubscriptionComponentProps = Omit<Omit<ReactApollo.SubscriptionProps<ShoppingCartSubscriptionSubscription, ShoppingCartSubscriptionSubscriptionVariables>, 'subscription'>, 'variables'> & { variables?: ShoppingCartSubscriptionSubscriptionVariables };

    export const ShoppingCartSubscriptionComponent = (props: ShoppingCartSubscriptionComponentProps) => (
      <ReactApollo.Subscription<ShoppingCartSubscriptionSubscription, ShoppingCartSubscriptionSubscriptionVariables> subscription={ShoppingCartSubscriptionDocument} {...props} />
    );
    
export type ShoppingCartSubscriptionProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ShoppingCartSubscriptionSubscription, ShoppingCartSubscriptionSubscriptionVariables>> & TChildProps;
export function withShoppingCartSubscription<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ShoppingCartSubscriptionSubscription,
  ShoppingCartSubscriptionSubscriptionVariables,
  ShoppingCartSubscriptionProps<TChildProps>>) {
    return ReactApollo.withSubscription<TProps, ShoppingCartSubscriptionSubscription, ShoppingCartSubscriptionSubscriptionVariables, ShoppingCartSubscriptionProps<TChildProps>>(ShoppingCartSubscriptionDocument, {
      alias: 'withShoppingCartSubscription',
      ...operationOptions
    });
};
export const SyncShoppingCartDocument = gql`
    mutation SyncShoppingCart {
  syncOrder(input: {useCase: CART_VIEW}) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type SyncShoppingCartMutationFn = ReactApollo.MutationFn<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>;
export type SyncShoppingCartComponentProps = Omit<Omit<ReactApollo.MutationProps<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>, 'mutation'>, 'variables'> & { variables?: SyncShoppingCartMutationVariables };

    export const SyncShoppingCartComponent = (props: SyncShoppingCartComponentProps) => (
      <ReactApollo.Mutation<SyncShoppingCartMutation, SyncShoppingCartMutationVariables> mutation={SyncShoppingCartDocument} {...props} />
    );
    
export type SyncShoppingCartProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SyncShoppingCartMutation, SyncShoppingCartMutationVariables>> & TChildProps;
export function withSyncShoppingCart<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SyncShoppingCartMutation,
  SyncShoppingCartMutationVariables,
  SyncShoppingCartProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SyncShoppingCartMutation, SyncShoppingCartMutationVariables, SyncShoppingCartProps<TChildProps>>(SyncShoppingCartDocument, {
      alias: 'withSyncShoppingCart',
      ...operationOptions
    });
};
export const RecommendExpert2Document = gql`
    query RecommendExpert2($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    expert {
      ...ChatWidgetExpert
      existingLeadForConsumer {
        id
        conversation {
          id
          externalId
        }
      }
    }
  }
}
    ${ChatWidgetExpertFragmentDoc}`;
export type RecommendExpert2ComponentProps = Omit<Omit<ReactApollo.QueryProps<RecommendExpert2Query, RecommendExpert2QueryVariables>, 'query'>, 'variables'> & { variables: RecommendExpert2QueryVariables };

    export const RecommendExpert2Component = (props: RecommendExpert2ComponentProps) => (
      <ReactApollo.Query<RecommendExpert2Query, RecommendExpert2QueryVariables> query={RecommendExpert2Document} {...props} />
    );
    
export type RecommendExpert2Props<TChildProps = {}> = Partial<ReactApollo.DataProps<RecommendExpert2Query, RecommendExpert2QueryVariables>> & TChildProps;
export function withRecommendExpert2<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RecommendExpert2Query,
  RecommendExpert2QueryVariables,
  RecommendExpert2Props<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RecommendExpert2Query, RecommendExpert2QueryVariables, RecommendExpert2Props<TChildProps>>(RecommendExpert2Document, {
      alias: 'withRecommendExpert2',
      ...operationOptions
    });
};
export const DeclineVideoChatFromInvitationDocument = gql`
    mutation DeclineVideoChatFromInvitation($input: DeclineVideoChatInput!) {
  declineVideoChat(input: $input) {
    success
  }
}
    `;
export type DeclineVideoChatFromInvitationMutationFn = ReactApollo.MutationFn<DeclineVideoChatFromInvitationMutation, DeclineVideoChatFromInvitationMutationVariables>;
export type DeclineVideoChatFromInvitationComponentProps = Omit<Omit<ReactApollo.MutationProps<DeclineVideoChatFromInvitationMutation, DeclineVideoChatFromInvitationMutationVariables>, 'mutation'>, 'variables'> & { variables?: DeclineVideoChatFromInvitationMutationVariables };

    export const DeclineVideoChatFromInvitationComponent = (props: DeclineVideoChatFromInvitationComponentProps) => (
      <ReactApollo.Mutation<DeclineVideoChatFromInvitationMutation, DeclineVideoChatFromInvitationMutationVariables> mutation={DeclineVideoChatFromInvitationDocument} {...props} />
    );
    
export type DeclineVideoChatFromInvitationProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<DeclineVideoChatFromInvitationMutation, DeclineVideoChatFromInvitationMutationVariables>> & TChildProps;
export function withDeclineVideoChatFromInvitation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DeclineVideoChatFromInvitationMutation,
  DeclineVideoChatFromInvitationMutationVariables,
  DeclineVideoChatFromInvitationProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, DeclineVideoChatFromInvitationMutation, DeclineVideoChatFromInvitationMutationVariables, DeclineVideoChatFromInvitationProps<TChildProps>>(DeclineVideoChatFromInvitationDocument, {
      alias: 'withDeclineVideoChatFromInvitation',
      ...operationOptions
    });
};
export const GetMessagingUsersDocument = gql`
    query GetMessagingUsers($ids: [AnyId!]!) {
  messagingUsers(ids: $ids) {
    id
    displayName
    avatar {
      id
      url
    }
    type
    profile {
      ... on BusinessUser {
        id
        vanityId
        expertStats {
          averageRating
        }
      }
    }
  }
}
    `;
export type GetMessagingUsersComponentProps = Omit<Omit<ReactApollo.QueryProps<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>, 'query'>, 'variables'> & { variables: GetMessagingUsersQueryVariables };

    export const GetMessagingUsersComponent = (props: GetMessagingUsersComponentProps) => (
      <ReactApollo.Query<GetMessagingUsersQuery, GetMessagingUsersQueryVariables> query={GetMessagingUsersDocument} {...props} />
    );
    
export type GetMessagingUsersProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetMessagingUsersQuery, GetMessagingUsersQueryVariables>> & TChildProps;
export function withGetMessagingUsers<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  GetMessagingUsersQuery,
  GetMessagingUsersQueryVariables,
  GetMessagingUsersProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, GetMessagingUsersQuery, GetMessagingUsersQueryVariables, GetMessagingUsersProps<TChildProps>>(GetMessagingUsersDocument, {
      alias: 'withGetMessagingUsers',
      ...operationOptions
    });
};
export const JoinVideoChatDocument = gql`
    mutation JoinVideoChat($input: JoinVideoChatInput!) {
  joinVideoChat(input: $input) {
    token
  }
}
    `;
export type JoinVideoChatMutationFn = ReactApollo.MutationFn<JoinVideoChatMutation, JoinVideoChatMutationVariables>;
export type JoinVideoChatComponentProps = Omit<Omit<ReactApollo.MutationProps<JoinVideoChatMutation, JoinVideoChatMutationVariables>, 'mutation'>, 'variables'> & { variables?: JoinVideoChatMutationVariables };

    export const JoinVideoChatComponent = (props: JoinVideoChatComponentProps) => (
      <ReactApollo.Mutation<JoinVideoChatMutation, JoinVideoChatMutationVariables> mutation={JoinVideoChatDocument} {...props} />
    );
    
export type JoinVideoChatProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<JoinVideoChatMutation, JoinVideoChatMutationVariables>> & TChildProps;
export function withJoinVideoChat<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  JoinVideoChatMutation,
  JoinVideoChatMutationVariables,
  JoinVideoChatProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, JoinVideoChatMutation, JoinVideoChatMutationVariables, JoinVideoChatProps<TChildProps>>(JoinVideoChatDocument, {
      alias: 'withJoinVideoChat',
      ...operationOptions
    });
};
export const PersistMediaDocument = gql`
    mutation PersistMedia($input: PersistMediaInput!) {
  persistMedia(input: $input) {
    mediaFile {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type PersistMediaMutationFn = ReactApollo.MutationFn<PersistMediaMutation, PersistMediaMutationVariables>;
export type PersistMediaComponentProps = Omit<Omit<ReactApollo.MutationProps<PersistMediaMutation, PersistMediaMutationVariables>, 'mutation'>, 'variables'> & { variables?: PersistMediaMutationVariables };

    export const PersistMediaComponent = (props: PersistMediaComponentProps) => (
      <ReactApollo.Mutation<PersistMediaMutation, PersistMediaMutationVariables> mutation={PersistMediaDocument} {...props} />
    );
    
export type PersistMediaProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<PersistMediaMutation, PersistMediaMutationVariables>> & TChildProps;
export function withPersistMedia<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  PersistMediaMutation,
  PersistMediaMutationVariables,
  PersistMediaProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, PersistMediaMutation, PersistMediaMutationVariables, PersistMediaProps<TChildProps>>(PersistMediaDocument, {
      alias: 'withPersistMedia',
      ...operationOptions
    });
};
export const UploadMediaForChatDocument = gql`
    mutation UploadMediaForChat($input: UploadMediaInput!) {
  uploadMedia(input: $input) {
    mediaFile {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type UploadMediaForChatMutationFn = ReactApollo.MutationFn<UploadMediaForChatMutation, UploadMediaForChatMutationVariables>;
export type UploadMediaForChatComponentProps = Omit<Omit<ReactApollo.MutationProps<UploadMediaForChatMutation, UploadMediaForChatMutationVariables>, 'mutation'>, 'variables'> & { variables?: UploadMediaForChatMutationVariables };

    export const UploadMediaForChatComponent = (props: UploadMediaForChatComponentProps) => (
      <ReactApollo.Mutation<UploadMediaForChatMutation, UploadMediaForChatMutationVariables> mutation={UploadMediaForChatDocument} {...props} />
    );
    
export type UploadMediaForChatProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UploadMediaForChatMutation, UploadMediaForChatMutationVariables>> & TChildProps;
export function withUploadMediaForChat<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UploadMediaForChatMutation,
  UploadMediaForChatMutationVariables,
  UploadMediaForChatProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UploadMediaForChatMutation, UploadMediaForChatMutationVariables, UploadMediaForChatProps<TChildProps>>(UploadMediaForChatDocument, {
      alias: 'withUploadMediaForChat',
      ...operationOptions
    });
};
export const ContentfulByVariationDocument = gql`
    query ContentfulByVariation($template: String!, $variation: String!, $space: String) {
  findContentByTemplate(template: $template, variation: $variation, space: $space) {
    entries {
      key
      value {
        ...ContentTypes
      }
    }
  }
}
    ${ContentTypesFragmentDoc}`;
export type ContentfulByVariationComponentProps = Omit<Omit<ReactApollo.QueryProps<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>, 'query'>, 'variables'> & { variables: ContentfulByVariationQueryVariables };

    export const ContentfulByVariationComponent = (props: ContentfulByVariationComponentProps) => (
      <ReactApollo.Query<ContentfulByVariationQuery, ContentfulByVariationQueryVariables> query={ContentfulByVariationDocument} {...props} />
    );
    
export type ContentfulByVariationProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ContentfulByVariationQuery, ContentfulByVariationQueryVariables>> & TChildProps;
export function withContentfulByVariation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ContentfulByVariationQuery,
  ContentfulByVariationQueryVariables,
  ContentfulByVariationProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ContentfulByVariationQuery, ContentfulByVariationQueryVariables, ContentfulByVariationProps<TChildProps>>(ContentfulByVariationDocument, {
      alias: 'withContentfulByVariation',
      ...operationOptions
    });
};
export const MyselfDocument = gql`
    query Myself {
  me {
    ...Myself
  }
  session {
    ...Session
  }
}
    ${MyselfFragmentDoc}
${SessionFragmentDoc}`;
export type MyselfComponentProps = Omit<Omit<ReactApollo.QueryProps<MyselfQuery, MyselfQueryVariables>, 'query'>, 'variables'> & { variables?: MyselfQueryVariables };

    export const MyselfComponent = (props: MyselfComponentProps) => (
      <ReactApollo.Query<MyselfQuery, MyselfQueryVariables> query={MyselfDocument} {...props} />
    );
    
export type MyselfProps<TChildProps = {}> = Partial<ReactApollo.DataProps<MyselfQuery, MyselfQueryVariables>> & TChildProps;
export function withMyself<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  MyselfQuery,
  MyselfQueryVariables,
  MyselfProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, MyselfQuery, MyselfQueryVariables, MyselfProps<TChildProps>>(MyselfDocument, {
      alias: 'withMyself',
      ...operationOptions
    });
};
export const LeadForChatWidgetDocument = gql`
    query LeadForChatWidget($leadId: LeadId!) {
  lead(id: $leadId) {
    id
    conversation {
      ...Conversation
    }
  }
}
    ${ConversationFragmentDoc}`;
export type LeadForChatWidgetComponentProps = Omit<Omit<ReactApollo.QueryProps<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>, 'query'>, 'variables'> & { variables: LeadForChatWidgetQueryVariables };

    export const LeadForChatWidgetComponent = (props: LeadForChatWidgetComponentProps) => (
      <ReactApollo.Query<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables> query={LeadForChatWidgetDocument} {...props} />
    );
    
export type LeadForChatWidgetProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables>> & TChildProps;
export function withLeadForChatWidget<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LeadForChatWidgetQuery,
  LeadForChatWidgetQueryVariables,
  LeadForChatWidgetProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LeadForChatWidgetQuery, LeadForChatWidgetQueryVariables, LeadForChatWidgetProps<TChildProps>>(LeadForChatWidgetDocument, {
      alias: 'withLeadForChatWidget',
      ...operationOptions
    });
};
export const CreateBookingFlightPlanDocument = gql`
    mutation CreateBookingFlightPlan($input: CreateFlightPlanInput!) {
  createFlightPlan(input: $input) {
    flightPlan {
      id
    }
    hasError
    errorMessage
  }
}
    `;
export type CreateBookingFlightPlanMutationFn = ReactApollo.MutationFn<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>;
export type CreateBookingFlightPlanComponentProps = Omit<Omit<ReactApollo.MutationProps<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>, 'mutation'>, 'variables'> & { variables?: CreateBookingFlightPlanMutationVariables };

    export const CreateBookingFlightPlanComponent = (props: CreateBookingFlightPlanComponentProps) => (
      <ReactApollo.Mutation<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables> mutation={CreateBookingFlightPlanDocument} {...props} />
    );
    
export type CreateBookingFlightPlanProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables>> & TChildProps;
export function withCreateBookingFlightPlan<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CreateBookingFlightPlanMutation,
  CreateBookingFlightPlanMutationVariables,
  CreateBookingFlightPlanProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, CreateBookingFlightPlanMutation, CreateBookingFlightPlanMutationVariables, CreateBookingFlightPlanProps<TChildProps>>(CreateBookingFlightPlanDocument, {
      alias: 'withCreateBookingFlightPlan',
      ...operationOptions
    });
};
export const StartExpertConsumerConversationDocument = gql`
    mutation StartExpertConsumerConversation($input: StartExpertConsumerConversationInput!) {
  startExpertConsumerConversation(input: $input) {
    error
    conversation {
      id
      externalId
      lead {
        id
      }
    }
  }
}
    `;
export type StartExpertConsumerConversationMutationFn = ReactApollo.MutationFn<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>;
export type StartExpertConsumerConversationComponentProps = Omit<Omit<ReactApollo.MutationProps<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>, 'mutation'>, 'variables'> & { variables?: StartExpertConsumerConversationMutationVariables };

    export const StartExpertConsumerConversationComponent = (props: StartExpertConsumerConversationComponentProps) => (
      <ReactApollo.Mutation<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables> mutation={StartExpertConsumerConversationDocument} {...props} />
    );
    
export type StartExpertConsumerConversationProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables>> & TChildProps;
export function withStartExpertConsumerConversation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  StartExpertConsumerConversationMutation,
  StartExpertConsumerConversationMutationVariables,
  StartExpertConsumerConversationProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, StartExpertConsumerConversationMutation, StartExpertConsumerConversationMutationVariables, StartExpertConsumerConversationProps<TChildProps>>(StartExpertConsumerConversationDocument, {
      alias: 'withStartExpertConsumerConversation',
      ...operationOptions
    });
};
export const CategoryWithPathDocument = gql`
    query CategoryWithPath($categorySlug: String!) {
  categoryBySlug(slug: $categorySlug) {
    id
    ancestorWithPath {
      id
      slug
    }
  }
}
    `;
export type CategoryWithPathComponentProps = Omit<Omit<ReactApollo.QueryProps<CategoryWithPathQuery, CategoryWithPathQueryVariables>, 'query'>, 'variables'> & { variables: CategoryWithPathQueryVariables };

    export const CategoryWithPathComponent = (props: CategoryWithPathComponentProps) => (
      <ReactApollo.Query<CategoryWithPathQuery, CategoryWithPathQueryVariables> query={CategoryWithPathDocument} {...props} />
    );
    
export type CategoryWithPathProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CategoryWithPathQuery, CategoryWithPathQueryVariables>> & TChildProps;
export function withCategoryWithPath<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CategoryWithPathQuery,
  CategoryWithPathQueryVariables,
  CategoryWithPathProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CategoryWithPathQuery, CategoryWithPathQueryVariables, CategoryWithPathProps<TChildProps>>(CategoryWithPathDocument, {
      alias: 'withCategoryWithPath',
      ...operationOptions
    });
};
export const CountriesDocument = gql`
    query Countries($filter: CountryFilter!) {
  countries(filter: $filter) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
export type CountriesComponentProps = Omit<Omit<ReactApollo.QueryProps<CountriesQuery, CountriesQueryVariables>, 'query'>, 'variables'> & { variables: CountriesQueryVariables };

    export const CountriesComponent = (props: CountriesComponentProps) => (
      <ReactApollo.Query<CountriesQuery, CountriesQueryVariables> query={CountriesDocument} {...props} />
    );
    
export type CountriesProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CountriesQuery, CountriesQueryVariables>> & TChildProps;
export function withCountries<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CountriesQuery,
  CountriesQueryVariables,
  CountriesProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CountriesQuery, CountriesQueryVariables, CountriesProps<TChildProps>>(CountriesDocument, {
      alias: 'withCountries',
      ...operationOptions
    });
};
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(input: {oldPassword: $oldPassword, newPassword: $newPassword}) {
    result
    message
  }
}
    `;
export type ChangePasswordMutationFn = ReactApollo.MutationFn<ChangePasswordMutation, ChangePasswordMutationVariables>;
export type ChangePasswordComponentProps = Omit<Omit<ReactApollo.MutationProps<ChangePasswordMutation, ChangePasswordMutationVariables>, 'mutation'>, 'variables'> & { variables?: ChangePasswordMutationVariables };

    export const ChangePasswordComponent = (props: ChangePasswordComponentProps) => (
      <ReactApollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> mutation={ChangePasswordDocument} {...props} />
    );
    
export type ChangePasswordProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<ChangePasswordMutation, ChangePasswordMutationVariables>> & TChildProps;
export function withChangePassword<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  ChangePasswordProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, ChangePasswordMutation, ChangePasswordMutationVariables, ChangePasswordProps<TChildProps>>(ChangePasswordDocument, {
      alias: 'withChangePassword',
      ...operationOptions
    });
};
export const CreatePasswordDocument = gql`
    mutation CreatePassword($password: String!) {
  createPassword(input: {password: $password}) {
    success
  }
}
    `;
export type CreatePasswordMutationFn = ReactApollo.MutationFn<CreatePasswordMutation, CreatePasswordMutationVariables>;
export type CreatePasswordComponentProps = Omit<Omit<ReactApollo.MutationProps<CreatePasswordMutation, CreatePasswordMutationVariables>, 'mutation'>, 'variables'> & { variables?: CreatePasswordMutationVariables };

    export const CreatePasswordComponent = (props: CreatePasswordComponentProps) => (
      <ReactApollo.Mutation<CreatePasswordMutation, CreatePasswordMutationVariables> mutation={CreatePasswordDocument} {...props} />
    );
    
export type CreatePasswordProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<CreatePasswordMutation, CreatePasswordMutationVariables>> & TChildProps;
export function withCreatePassword<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CreatePasswordMutation,
  CreatePasswordMutationVariables,
  CreatePasswordProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, CreatePasswordMutation, CreatePasswordMutationVariables, CreatePasswordProps<TChildProps>>(CreatePasswordDocument, {
      alias: 'withCreatePassword',
      ...operationOptions
    });
};
export const EscalateOrderDocument = gql`
    mutation EscalateOrder($input: CreateOrderEscalationInput!) {
  createOrderEscalation(input: $input) {
    orderEscalation {
      ...OrderEscalation
    }
  }
}
    ${OrderEscalationFragmentDoc}`;
export type EscalateOrderMutationFn = ReactApollo.MutationFn<EscalateOrderMutation, EscalateOrderMutationVariables>;
export type EscalateOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<EscalateOrderMutation, EscalateOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: EscalateOrderMutationVariables };

    export const EscalateOrderComponent = (props: EscalateOrderComponentProps) => (
      <ReactApollo.Mutation<EscalateOrderMutation, EscalateOrderMutationVariables> mutation={EscalateOrderDocument} {...props} />
    );
    
export type EscalateOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<EscalateOrderMutation, EscalateOrderMutationVariables>> & TChildProps;
export function withEscalateOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  EscalateOrderMutation,
  EscalateOrderMutationVariables,
  EscalateOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, EscalateOrderMutation, EscalateOrderMutationVariables, EscalateOrderProps<TChildProps>>(EscalateOrderDocument, {
      alias: 'withEscalateOrder',
      ...operationOptions
    });
};
export const MyOrdersConnectionDocument = gql`
    query MyOrdersConnection($query: OrderQuery!, $after: String) {
  ordersConnection(query: $query, after: $after, first: 50) {
    edges {
      node {
        ...MyOrderListItem
      }
    }
  }
}
    ${MyOrderListItemFragmentDoc}`;
export type MyOrdersConnectionComponentProps = Omit<Omit<ReactApollo.QueryProps<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>, 'query'>, 'variables'> & { variables: MyOrdersConnectionQueryVariables };

    export const MyOrdersConnectionComponent = (props: MyOrdersConnectionComponentProps) => (
      <ReactApollo.Query<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables> query={MyOrdersConnectionDocument} {...props} />
    );
    
export type MyOrdersConnectionProps<TChildProps = {}> = Partial<ReactApollo.DataProps<MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables>> & TChildProps;
export function withMyOrdersConnection<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  MyOrdersConnectionQuery,
  MyOrdersConnectionQueryVariables,
  MyOrdersConnectionProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, MyOrdersConnectionQuery, MyOrdersConnectionQueryVariables, MyOrdersConnectionProps<TChildProps>>(MyOrdersConnectionDocument, {
      alias: 'withMyOrdersConnection',
      ...operationOptions
    });
};
export const StartSupportConversationDocument = gql`
    mutation StartSupportConversation($input: StartSupportConversationInput!) {
  startSupportConversation(input: $input) {
    supportConversation {
      ...SupportConversation
    }
  }
}
    ${SupportConversationFragmentDoc}`;
export type StartSupportConversationMutationFn = ReactApollo.MutationFn<StartSupportConversationMutation, StartSupportConversationMutationVariables>;
export type StartSupportConversationComponentProps = Omit<Omit<ReactApollo.MutationProps<StartSupportConversationMutation, StartSupportConversationMutationVariables>, 'mutation'>, 'variables'> & { variables?: StartSupportConversationMutationVariables };

    export const StartSupportConversationComponent = (props: StartSupportConversationComponentProps) => (
      <ReactApollo.Mutation<StartSupportConversationMutation, StartSupportConversationMutationVariables> mutation={StartSupportConversationDocument} {...props} />
    );
    
export type StartSupportConversationProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<StartSupportConversationMutation, StartSupportConversationMutationVariables>> & TChildProps;
export function withStartSupportConversation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  StartSupportConversationMutation,
  StartSupportConversationMutationVariables,
  StartSupportConversationProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, StartSupportConversationMutation, StartSupportConversationMutationVariables, StartSupportConversationProps<TChildProps>>(StartSupportConversationDocument, {
      alias: 'withStartSupportConversation',
      ...operationOptions
    });
};
export const UpdateNotificationChannelsDocument = gql`
    mutation UpdateNotificationChannels($input: UpdateNotificationChannelsInput!) {
  updateNotificationChannels(input: $input) {
    messagingUser {
      id
      notificationChannels
    }
  }
}
    `;
export type UpdateNotificationChannelsMutationFn = ReactApollo.MutationFn<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>;
export type UpdateNotificationChannelsComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateNotificationChannelsMutationVariables };

    export const UpdateNotificationChannelsComponent = (props: UpdateNotificationChannelsComponentProps) => (
      <ReactApollo.Mutation<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables> mutation={UpdateNotificationChannelsDocument} {...props} />
    );
    
export type UpdateNotificationChannelsProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables>> & TChildProps;
export function withUpdateNotificationChannels<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateNotificationChannelsMutation,
  UpdateNotificationChannelsMutationVariables,
  UpdateNotificationChannelsProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateNotificationChannelsMutation, UpdateNotificationChannelsMutationVariables, UpdateNotificationChannelsProps<TChildProps>>(UpdateNotificationChannelsDocument, {
      alias: 'withUpdateNotificationChannels',
      ...operationOptions
    });
};
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    errors
    user {
      id
      firstName
      lastName
      roles
      messagingUser {
        id
      }
      address {
        line1
        city
        state
        postalCode
        country
      }
      contacts {
        id
        type
        value
        verified
      }
    }
  }
}
    `;
export type UpdateUserProfileMutationFn = ReactApollo.MutationFn<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export type UpdateUserProfileComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateUserProfileMutationVariables };

    export const UpdateUserProfileComponent = (props: UpdateUserProfileComponentProps) => (
      <ReactApollo.Mutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables> mutation={UpdateUserProfileDocument} {...props} />
    );
    
export type UpdateUserProfileProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>> & TChildProps;
export function withUpdateUserProfile<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables,
  UpdateUserProfileProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateUserProfileMutation, UpdateUserProfileMutationVariables, UpdateUserProfileProps<TChildProps>>(UpdateUserProfileDocument, {
      alias: 'withUpdateUserProfile',
      ...operationOptions
    });
};
export const CreateExpertFromApplicationDocument = gql`
    mutation CreateExpertFromApplication($applicationId: ExpertApplicationId!) {
  createExpertFromApplication(input: {applicationId: $applicationId}) {
    expert {
      id
    }
  }
}
    `;
export type CreateExpertFromApplicationMutationFn = ReactApollo.MutationFn<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>;
export type CreateExpertFromApplicationComponentProps = Omit<Omit<ReactApollo.MutationProps<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>, 'mutation'>, 'variables'> & { variables?: CreateExpertFromApplicationMutationVariables };

    export const CreateExpertFromApplicationComponent = (props: CreateExpertFromApplicationComponentProps) => (
      <ReactApollo.Mutation<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables> mutation={CreateExpertFromApplicationDocument} {...props} />
    );
    
export type CreateExpertFromApplicationProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables>> & TChildProps;
export function withCreateExpertFromApplication<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CreateExpertFromApplicationMutation,
  CreateExpertFromApplicationMutationVariables,
  CreateExpertFromApplicationProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, CreateExpertFromApplicationMutation, CreateExpertFromApplicationMutationVariables, CreateExpertFromApplicationProps<TChildProps>>(CreateExpertFromApplicationDocument, {
      alias: 'withCreateExpertFromApplication',
      ...operationOptions
    });
};
export const AuthenticationSessionStateDocument = gql`
    query AuthenticationSessionState {
  session {
    ...AuthenticationSessionState
  }
}
    ${AuthenticationSessionStateFragmentDoc}`;
export type AuthenticationSessionStateComponentProps = Omit<Omit<ReactApollo.QueryProps<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>, 'query'>, 'variables'> & { variables?: AuthenticationSessionStateQueryVariables };

    export const AuthenticationSessionStateComponent = (props: AuthenticationSessionStateComponentProps) => (
      <ReactApollo.Query<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables> query={AuthenticationSessionStateDocument} {...props} />
    );
    
export type AuthenticationSessionStateProps<TChildProps = {}> = Partial<ReactApollo.DataProps<AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables>> & TChildProps;
export function withAuthenticationSessionState<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AuthenticationSessionStateQuery,
  AuthenticationSessionStateQueryVariables,
  AuthenticationSessionStateProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, AuthenticationSessionStateQuery, AuthenticationSessionStateQueryVariables, AuthenticationSessionStateProps<TChildProps>>(AuthenticationSessionStateDocument, {
      alias: 'withAuthenticationSessionState',
      ...operationOptions
    });
};
export const FindContactDocument = gql`
    query FindContact($contactId: ContactId!) {
  findContact(contactId: $contactId) {
    id
    type
    value
    verified
  }
}
    `;
export type FindContactComponentProps = Omit<Omit<ReactApollo.QueryProps<FindContactQuery, FindContactQueryVariables>, 'query'>, 'variables'> & { variables: FindContactQueryVariables };

    export const FindContactComponent = (props: FindContactComponentProps) => (
      <ReactApollo.Query<FindContactQuery, FindContactQueryVariables> query={FindContactDocument} {...props} />
    );
    
export type FindContactProps<TChildProps = {}> = Partial<ReactApollo.DataProps<FindContactQuery, FindContactQueryVariables>> & TChildProps;
export function withFindContact<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  FindContactQuery,
  FindContactQueryVariables,
  FindContactProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, FindContactQuery, FindContactQueryVariables, FindContactProps<TChildProps>>(FindContactDocument, {
      alias: 'withFindContact',
      ...operationOptions
    });
};
export const MaskedHandlesByLoginTokenDocument = gql`
    query MaskedHandlesByLoginToken($loginToken: String!) {
  maskedHandlesByLoginToken(loginToken: $loginToken) {
    id
    maskedHandle
    handleType
  }
}
    `;
export type MaskedHandlesByLoginTokenComponentProps = Omit<Omit<ReactApollo.QueryProps<MaskedHandlesByLoginTokenQuery, MaskedHandlesByLoginTokenQueryVariables>, 'query'>, 'variables'> & { variables: MaskedHandlesByLoginTokenQueryVariables };

    export const MaskedHandlesByLoginTokenComponent = (props: MaskedHandlesByLoginTokenComponentProps) => (
      <ReactApollo.Query<MaskedHandlesByLoginTokenQuery, MaskedHandlesByLoginTokenQueryVariables> query={MaskedHandlesByLoginTokenDocument} {...props} />
    );
    
export type MaskedHandlesByLoginTokenProps<TChildProps = {}> = Partial<ReactApollo.DataProps<MaskedHandlesByLoginTokenQuery, MaskedHandlesByLoginTokenQueryVariables>> & TChildProps;
export function withMaskedHandlesByLoginToken<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  MaskedHandlesByLoginTokenQuery,
  MaskedHandlesByLoginTokenQueryVariables,
  MaskedHandlesByLoginTokenProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, MaskedHandlesByLoginTokenQuery, MaskedHandlesByLoginTokenQueryVariables, MaskedHandlesByLoginTokenProps<TChildProps>>(MaskedHandlesByLoginTokenDocument, {
      alias: 'withMaskedHandlesByLoginToken',
      ...operationOptions
    });
};
export const InitiateAuthenticationDocument = gql`
    mutation InitiateAuthentication($input: InitiateAuthenticationInput!) {
  initiateAuthentication(input: $input) {
    isValidHandle
    challengeType
    session {
      ...AuthenticationSessionState
    }
  }
}
    ${AuthenticationSessionStateFragmentDoc}`;
export type InitiateAuthenticationMutationFn = ReactApollo.MutationFn<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>;
export type InitiateAuthenticationComponentProps = Omit<Omit<ReactApollo.MutationProps<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>, 'mutation'>, 'variables'> & { variables?: InitiateAuthenticationMutationVariables };

    export const InitiateAuthenticationComponent = (props: InitiateAuthenticationComponentProps) => (
      <ReactApollo.Mutation<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables> mutation={InitiateAuthenticationDocument} {...props} />
    );
    
export type InitiateAuthenticationProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables>> & TChildProps;
export function withInitiateAuthentication<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  InitiateAuthenticationMutation,
  InitiateAuthenticationMutationVariables,
  InitiateAuthenticationProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, InitiateAuthenticationMutation, InitiateAuthenticationMutationVariables, InitiateAuthenticationProps<TChildProps>>(InitiateAuthenticationDocument, {
      alias: 'withInitiateAuthentication',
      ...operationOptions
    });
};
export const AuthenticateDocument = gql`
    mutation Authenticate($input: AuthenticationInput!) {
  authenticate(input: $input) {
    result
    message
    user {
      ...AuthenticatedUser
    }
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type AuthenticateMutationFn = ReactApollo.MutationFn<AuthenticateMutation, AuthenticateMutationVariables>;
export type AuthenticateComponentProps = Omit<Omit<ReactApollo.MutationProps<AuthenticateMutation, AuthenticateMutationVariables>, 'mutation'>, 'variables'> & { variables?: AuthenticateMutationVariables };

    export const AuthenticateComponent = (props: AuthenticateComponentProps) => (
      <ReactApollo.Mutation<AuthenticateMutation, AuthenticateMutationVariables> mutation={AuthenticateDocument} {...props} />
    );
    
export type AuthenticateProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<AuthenticateMutation, AuthenticateMutationVariables>> & TChildProps;
export function withAuthenticate<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AuthenticateMutation,
  AuthenticateMutationVariables,
  AuthenticateProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, AuthenticateMutation, AuthenticateMutationVariables, AuthenticateProps<TChildProps>>(AuthenticateDocument, {
      alias: 'withAuthenticate',
      ...operationOptions
    });
};
export const MaskedHandleDocument = gql`
    query MaskedHandle($id: AnyId!) {
  maskedHandle(id: $id) {
    id
    maskedHandle
    handleType
  }
}
    `;
export type MaskedHandleComponentProps = Omit<Omit<ReactApollo.QueryProps<MaskedHandleQuery, MaskedHandleQueryVariables>, 'query'>, 'variables'> & { variables: MaskedHandleQueryVariables };

    export const MaskedHandleComponent = (props: MaskedHandleComponentProps) => (
      <ReactApollo.Query<MaskedHandleQuery, MaskedHandleQueryVariables> query={MaskedHandleDocument} {...props} />
    );
    
export type MaskedHandleProps<TChildProps = {}> = Partial<ReactApollo.DataProps<MaskedHandleQuery, MaskedHandleQueryVariables>> & TChildProps;
export function withMaskedHandle<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  MaskedHandleQuery,
  MaskedHandleQueryVariables,
  MaskedHandleProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, MaskedHandleQuery, MaskedHandleQueryVariables, MaskedHandleProps<TChildProps>>(MaskedHandleDocument, {
      alias: 'withMaskedHandle',
      ...operationOptions
    });
};
export const InitiateResetPasswordDocument = gql`
    mutation InitiateResetPassword($input: InitiateResetPasswordInput!) {
  initiateResetPassword(input: $input) {
    success
    errorMessage
  }
}
    `;
export type InitiateResetPasswordMutationFn = ReactApollo.MutationFn<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>;
export type InitiateResetPasswordComponentProps = Omit<Omit<ReactApollo.MutationProps<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>, 'mutation'>, 'variables'> & { variables?: InitiateResetPasswordMutationVariables };

    export const InitiateResetPasswordComponent = (props: InitiateResetPasswordComponentProps) => (
      <ReactApollo.Mutation<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables> mutation={InitiateResetPasswordDocument} {...props} />
    );
    
export type InitiateResetPasswordProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>> & TChildProps;
export function withInitiateResetPassword<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  InitiateResetPasswordMutation,
  InitiateResetPasswordMutationVariables,
  InitiateResetPasswordProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables, InitiateResetPasswordProps<TChildProps>>(InitiateResetPasswordDocument, {
      alias: 'withInitiateResetPassword',
      ...operationOptions
    });
};
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = ReactApollo.MutationFn<LogoutMutation, LogoutMutationVariables>;
export type LogoutComponentProps = Omit<Omit<ReactApollo.MutationProps<LogoutMutation, LogoutMutationVariables>, 'mutation'>, 'variables'> & { variables?: LogoutMutationVariables };

    export const LogoutComponent = (props: LogoutComponentProps) => (
      <ReactApollo.Mutation<LogoutMutation, LogoutMutationVariables> mutation={LogoutDocument} {...props} />
    );
    
export type LogoutProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<LogoutMutation, LogoutMutationVariables>> & TChildProps;
export function withLogout<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LogoutMutation,
  LogoutMutationVariables,
  LogoutProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, LogoutMutation, LogoutMutationVariables, LogoutProps<TChildProps>>(LogoutDocument, {
      alias: 'withLogout',
      ...operationOptions
    });
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    result
    message
    user {
      ...AuthenticatedUser
    }
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export type ResetPasswordMutationFn = ReactApollo.MutationFn<ResetPasswordMutation, ResetPasswordMutationVariables>;
export type ResetPasswordComponentProps = Omit<Omit<ReactApollo.MutationProps<ResetPasswordMutation, ResetPasswordMutationVariables>, 'mutation'>, 'variables'> & { variables?: ResetPasswordMutationVariables };

    export const ResetPasswordComponent = (props: ResetPasswordComponentProps) => (
      <ReactApollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> mutation={ResetPasswordDocument} {...props} />
    );
    
export type ResetPasswordProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<ResetPasswordMutation, ResetPasswordMutationVariables>> & TChildProps;
export function withResetPassword<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
  ResetPasswordProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, ResetPasswordMutation, ResetPasswordMutationVariables, ResetPasswordProps<TChildProps>>(ResetPasswordDocument, {
      alias: 'withResetPassword',
      ...operationOptions
    });
};
export const VerifyResetPasswordChallengeDocument = gql`
    mutation VerifyResetPasswordChallenge($input: VerifyResetPasswordChallengeInput!) {
  verifyResetPasswordChallenge(input: $input) {
    success
    message
    session {
      ...AuthenticationSessionState
    }
  }
}
    ${AuthenticationSessionStateFragmentDoc}`;
export type VerifyResetPasswordChallengeMutationFn = ReactApollo.MutationFn<VerifyResetPasswordChallengeMutation, VerifyResetPasswordChallengeMutationVariables>;
export type VerifyResetPasswordChallengeComponentProps = Omit<Omit<ReactApollo.MutationProps<VerifyResetPasswordChallengeMutation, VerifyResetPasswordChallengeMutationVariables>, 'mutation'>, 'variables'> & { variables?: VerifyResetPasswordChallengeMutationVariables };

    export const VerifyResetPasswordChallengeComponent = (props: VerifyResetPasswordChallengeComponentProps) => (
      <ReactApollo.Mutation<VerifyResetPasswordChallengeMutation, VerifyResetPasswordChallengeMutationVariables> mutation={VerifyResetPasswordChallengeDocument} {...props} />
    );
    
export type VerifyResetPasswordChallengeProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<VerifyResetPasswordChallengeMutation, VerifyResetPasswordChallengeMutationVariables>> & TChildProps;
export function withVerifyResetPasswordChallenge<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  VerifyResetPasswordChallengeMutation,
  VerifyResetPasswordChallengeMutationVariables,
  VerifyResetPasswordChallengeProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, VerifyResetPasswordChallengeMutation, VerifyResetPasswordChallengeMutationVariables, VerifyResetPasswordChallengeProps<TChildProps>>(VerifyResetPasswordChallengeDocument, {
      alias: 'withVerifyResetPasswordChallenge',
      ...operationOptions
    });
};
export const CategorySellableSearchDocument = gql`
    query CategorySellableSearch($keywords: String, $categorySlug: String!, $facets: [FacetSelection!], $after: String, $maxFacetTerms: Int, $filters: [SellableSearchFilter!], $sortBy: SellableSort!, $order: SortOrder!) {
  searchSellables(query: {facets: $facets, keywords: $keywords, categorySlugs: [$categorySlug], maxFacetTerms: $maxFacetTerms, filters: $filters}, sortBy: $sortBy, order: $order, first: 36, after: $after) {
    count
    facets {
      ...DisplayFacet
    }
    edges {
      ...CategorySellableSearchResult
    }
    pageInfo {
      ...PageInfo
    }
    pageMetadata {
      ...SellableSearchResultPageMetadata
    }
  }
  categoryBySlug(slug: $categorySlug) {
    id
    pluralDisplayName
    type
    department {
      ...DepartmentContext
    }
    breadcrumbs: parents {
      ...CategoryBreadcrumb
    }
    ...CategoryFilterBreadcrumbs
  }
}
    ${DisplayFacetFragmentDoc}
${CategorySellableSearchResultFragmentDoc}
${PageInfoFragmentDoc}
${SellableSearchResultPageMetadataFragmentDoc}
${DepartmentContextFragmentDoc}
${CategoryBreadcrumbFragmentDoc}
${CategoryFilterBreadcrumbsFragmentDoc}`;
export type CategorySellableSearchComponentProps = Omit<Omit<ReactApollo.QueryProps<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>, 'query'>, 'variables'> & { variables: CategorySellableSearchQueryVariables };

    export const CategorySellableSearchComponent = (props: CategorySellableSearchComponentProps) => (
      <ReactApollo.Query<CategorySellableSearchQuery, CategorySellableSearchQueryVariables> query={CategorySellableSearchDocument} {...props} />
    );
    
export type CategorySellableSearchProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CategorySellableSearchQuery, CategorySellableSearchQueryVariables>> & TChildProps;
export function withCategorySellableSearch<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CategorySellableSearchQuery,
  CategorySellableSearchQueryVariables,
  CategorySellableSearchProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CategorySellableSearchQuery, CategorySellableSearchQueryVariables, CategorySellableSearchProps<TChildProps>>(CategorySellableSearchDocument, {
      alias: 'withCategorySellableSearch',
      ...operationOptions
    });
};
export const CategoryAssetsForMetadataDocument = gql`
    query CategoryAssetsForMetadata($categoryId: CategoryId!) {
  category(categoryId: $categoryId) {
    id
    slug
    pluralDisplayName
    contentAssets {
      communityPoster {
        imageUrl
      }
    }
  }
}
    `;
export type CategoryAssetsForMetadataComponentProps = Omit<Omit<ReactApollo.QueryProps<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>, 'query'>, 'variables'> & { variables: CategoryAssetsForMetadataQueryVariables };

    export const CategoryAssetsForMetadataComponent = (props: CategoryAssetsForMetadataComponentProps) => (
      <ReactApollo.Query<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables> query={CategoryAssetsForMetadataDocument} {...props} />
    );
    
export type CategoryAssetsForMetadataProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables>> & TChildProps;
export function withCategoryAssetsForMetadata<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CategoryAssetsForMetadataQuery,
  CategoryAssetsForMetadataQueryVariables,
  CategoryAssetsForMetadataProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CategoryAssetsForMetadataQuery, CategoryAssetsForMetadataQueryVariables, CategoryAssetsForMetadataProps<TChildProps>>(CategoryAssetsForMetadataDocument, {
      alias: 'withCategoryAssetsForMetadata',
      ...operationOptions
    });
};
export const NoResultsDepartmentsDocument = gql`
    query NoResultsDepartments {
  departments {
    id
    slug
  }
}
    `;
export type NoResultsDepartmentsComponentProps = Omit<Omit<ReactApollo.QueryProps<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>, 'query'>, 'variables'> & { variables?: NoResultsDepartmentsQueryVariables };

    export const NoResultsDepartmentsComponent = (props: NoResultsDepartmentsComponentProps) => (
      <ReactApollo.Query<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables> query={NoResultsDepartmentsDocument} {...props} />
    );
    
export type NoResultsDepartmentsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables>> & TChildProps;
export function withNoResultsDepartments<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  NoResultsDepartmentsQuery,
  NoResultsDepartmentsQueryVariables,
  NoResultsDepartmentsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, NoResultsDepartmentsQuery, NoResultsDepartmentsQueryVariables, NoResultsDepartmentsProps<TChildProps>>(NoResultsDepartmentsDocument, {
      alias: 'withNoResultsDepartments',
      ...operationOptions
    });
};
export const CustomerRequestExpertCuratedOrderDocument = gql`
    mutation CustomerRequestExpertCuratedOrder($id: ExpertCuratedOrderId!) {
  customerRequestExpertCuratedOrder(input: {id: $id}) {
    expertCuratedOrder {
      id
    }
  }
}
    `;
export type CustomerRequestExpertCuratedOrderMutationFn = ReactApollo.MutationFn<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>;
export type CustomerRequestExpertCuratedOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: CustomerRequestExpertCuratedOrderMutationVariables };

    export const CustomerRequestExpertCuratedOrderComponent = (props: CustomerRequestExpertCuratedOrderComponentProps) => (
      <ReactApollo.Mutation<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables> mutation={CustomerRequestExpertCuratedOrderDocument} {...props} />
    );
    
export type CustomerRequestExpertCuratedOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables>> & TChildProps;
export function withCustomerRequestExpertCuratedOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CustomerRequestExpertCuratedOrderMutation,
  CustomerRequestExpertCuratedOrderMutationVariables,
  CustomerRequestExpertCuratedOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, CustomerRequestExpertCuratedOrderMutation, CustomerRequestExpertCuratedOrderMutationVariables, CustomerRequestExpertCuratedOrderProps<TChildProps>>(CustomerRequestExpertCuratedOrderDocument, {
      alias: 'withCustomerRequestExpertCuratedOrder',
      ...operationOptions
    });
};
export const ExpertCuratedLeadItineraryDocument = gql`
    query ExpertCuratedLeadItinerary($leadId: LeadId!) {
  expertCuratedLeadItinerary(leadId: $leadId) {
    id
    contentfulVariation
  }
}
    `;
export type ExpertCuratedLeadItineraryComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>, 'query'>, 'variables'> & { variables: ExpertCuratedLeadItineraryQueryVariables };

    export const ExpertCuratedLeadItineraryComponent = (props: ExpertCuratedLeadItineraryComponentProps) => (
      <ReactApollo.Query<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables> query={ExpertCuratedLeadItineraryDocument} {...props} />
    );
    
export type ExpertCuratedLeadItineraryProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables>> & TChildProps;
export function withExpertCuratedLeadItinerary<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedLeadItineraryQuery,
  ExpertCuratedLeadItineraryQueryVariables,
  ExpertCuratedLeadItineraryProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertCuratedLeadItineraryQuery, ExpertCuratedLeadItineraryQueryVariables, ExpertCuratedLeadItineraryProps<TChildProps>>(ExpertCuratedLeadItineraryDocument, {
      alias: 'withExpertCuratedLeadItinerary',
      ...operationOptions
    });
};
export const LeadForCurationsDocument = gql`
    query LeadForCurations($id: LeadId!) {
  lead(id: $id) {
    ...LeadForCurations
  }
}
    ${LeadForCurationsFragmentDoc}`;
export type LeadForCurationsComponentProps = Omit<Omit<ReactApollo.QueryProps<LeadForCurationsQuery, LeadForCurationsQueryVariables>, 'query'>, 'variables'> & { variables: LeadForCurationsQueryVariables };

    export const LeadForCurationsComponent = (props: LeadForCurationsComponentProps) => (
      <ReactApollo.Query<LeadForCurationsQuery, LeadForCurationsQueryVariables> query={LeadForCurationsDocument} {...props} />
    );
    
export type LeadForCurationsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LeadForCurationsQuery, LeadForCurationsQueryVariables>> & TChildProps;
export function withLeadForCurations<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LeadForCurationsQuery,
  LeadForCurationsQueryVariables,
  LeadForCurationsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LeadForCurationsQuery, LeadForCurationsQueryVariables, LeadForCurationsProps<TChildProps>>(LeadForCurationsDocument, {
      alias: 'withLeadForCurations',
      ...operationOptions
    });
};
export const ExpertCuratedItemsForSellableDocument = gql`
    query ExpertCuratedItemsForSellable($query: PopularExpertCuratedItemQueryInput!) {
  popularExpertCuratedItemsForSellable(query: $query) {
    edges {
      cursor
      node {
        sellable {
          ...SellableCard
        }
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type ExpertCuratedItemsForSellableComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertCuratedItemsForSellableQuery, ExpertCuratedItemsForSellableQueryVariables>, 'query'>, 'variables'> & { variables: ExpertCuratedItemsForSellableQueryVariables };

    export const ExpertCuratedItemsForSellableComponent = (props: ExpertCuratedItemsForSellableComponentProps) => (
      <ReactApollo.Query<ExpertCuratedItemsForSellableQuery, ExpertCuratedItemsForSellableQueryVariables> query={ExpertCuratedItemsForSellableDocument} {...props} />
    );
    
export type ExpertCuratedItemsForSellableProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedItemsForSellableQuery, ExpertCuratedItemsForSellableQueryVariables>> & TChildProps;
export function withExpertCuratedItemsForSellable<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedItemsForSellableQuery,
  ExpertCuratedItemsForSellableQueryVariables,
  ExpertCuratedItemsForSellableProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertCuratedItemsForSellableQuery, ExpertCuratedItemsForSellableQueryVariables, ExpertCuratedItemsForSellableProps<TChildProps>>(ExpertCuratedItemsForSellableDocument, {
      alias: 'withExpertCuratedItemsForSellable',
      ...operationOptions
    });
};
export const ExpertCuratedOrdersForLeadConnectionDocument = gql`
    query ExpertCuratedOrdersForLeadConnection($query: ExpertCuratedOrdersForLeadQueryInput!, $after: String, $first: Int, $before: String, $last: Int) {
  expertCuratedOrdersForLeadConnection(query: $query, after: $after, first: $first, before: $before, last: $last) {
    edges {
      node {
        ...ExpertCuratedOrder
      }
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type ExpertCuratedOrdersForLeadConnectionComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>, 'query'>, 'variables'> & { variables: ExpertCuratedOrdersForLeadConnectionQueryVariables };

    export const ExpertCuratedOrdersForLeadConnectionComponent = (props: ExpertCuratedOrdersForLeadConnectionComponentProps) => (
      <ReactApollo.Query<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables> query={ExpertCuratedOrdersForLeadConnectionDocument} {...props} />
    );
    
export type ExpertCuratedOrdersForLeadConnectionProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables>> & TChildProps;
export function withExpertCuratedOrdersForLeadConnection<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedOrdersForLeadConnectionQuery,
  ExpertCuratedOrdersForLeadConnectionQueryVariables,
  ExpertCuratedOrdersForLeadConnectionProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertCuratedOrdersForLeadConnectionQuery, ExpertCuratedOrdersForLeadConnectionQueryVariables, ExpertCuratedOrdersForLeadConnectionProps<TChildProps>>(ExpertCuratedOrdersForLeadConnectionDocument, {
      alias: 'withExpertCuratedOrdersForLeadConnection',
      ...operationOptions
    });
};
export const ExpertCuratedOrdersForLeadConnectionChangedDocument = gql`
    subscription ExpertCuratedOrdersForLeadConnectionChanged($query: ExpertCuratedOrdersForLeadQueryInput!) {
  expertCuratedOrdersForLeadConnectionChanged(query: $query) {
    connection {
      edges {
        node {
          ...ExpertCuratedOrder
        }
      }
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type ExpertCuratedOrdersForLeadConnectionChangedComponentProps = Omit<Omit<ReactApollo.SubscriptionProps<ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables>, 'subscription'>, 'variables'> & { variables?: ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables };

    export const ExpertCuratedOrdersForLeadConnectionChangedComponent = (props: ExpertCuratedOrdersForLeadConnectionChangedComponentProps) => (
      <ReactApollo.Subscription<ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables> subscription={ExpertCuratedOrdersForLeadConnectionChangedDocument} {...props} />
    );
    
export type ExpertCuratedOrdersForLeadConnectionChangedProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables>> & TChildProps;
export function withExpertCuratedOrdersForLeadConnectionChanged<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedOrdersForLeadConnectionChangedSubscription,
  ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables,
  ExpertCuratedOrdersForLeadConnectionChangedProps<TChildProps>>) {
    return ReactApollo.withSubscription<TProps, ExpertCuratedOrdersForLeadConnectionChangedSubscription, ExpertCuratedOrdersForLeadConnectionChangedSubscriptionVariables, ExpertCuratedOrdersForLeadConnectionChangedProps<TChildProps>>(ExpertCuratedOrdersForLeadConnectionChangedDocument, {
      alias: 'withExpertCuratedOrdersForLeadConnectionChanged',
      ...operationOptions
    });
};
export const AddExpertCuratedItemToCartDocument = gql`
    mutation AddExpertCuratedItemToCart($id: ExpertCuratedItemId!) {
  addExpertCuratedItemToCart(input: {id: $id}) {
    expertCuratedItem {
      id
      lineItemInCart {
        id
      }
    }
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type AddExpertCuratedItemToCartMutationFn = ReactApollo.MutationFn<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>;
export type AddExpertCuratedItemToCartComponentProps = Omit<Omit<ReactApollo.MutationProps<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>, 'mutation'>, 'variables'> & { variables?: AddExpertCuratedItemToCartMutationVariables };

    export const AddExpertCuratedItemToCartComponent = (props: AddExpertCuratedItemToCartComponentProps) => (
      <ReactApollo.Mutation<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables> mutation={AddExpertCuratedItemToCartDocument} {...props} />
    );
    
export type AddExpertCuratedItemToCartProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables>> & TChildProps;
export function withAddExpertCuratedItemToCart<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AddExpertCuratedItemToCartMutation,
  AddExpertCuratedItemToCartMutationVariables,
  AddExpertCuratedItemToCartProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, AddExpertCuratedItemToCartMutation, AddExpertCuratedItemToCartMutationVariables, AddExpertCuratedItemToCartProps<TChildProps>>(AddExpertCuratedItemToCartDocument, {
      alias: 'withAddExpertCuratedItemToCart',
      ...operationOptions
    });
};
export const RemoveExpertCuratedItemsFromCartDocument = gql`
    mutation RemoveExpertCuratedItemsFromCart($id: OrderLineItemId!) {
  removeItemsFromOrder(input: {lineItemIds: [$id]}) {
    order {
      ...ShoppingCartOrder
    }
  }
}
    ${ShoppingCartOrderFragmentDoc}`;
export type RemoveExpertCuratedItemsFromCartMutationFn = ReactApollo.MutationFn<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>;
export type RemoveExpertCuratedItemsFromCartComponentProps = Omit<Omit<ReactApollo.MutationProps<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>, 'mutation'>, 'variables'> & { variables?: RemoveExpertCuratedItemsFromCartMutationVariables };

    export const RemoveExpertCuratedItemsFromCartComponent = (props: RemoveExpertCuratedItemsFromCartComponentProps) => (
      <ReactApollo.Mutation<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables> mutation={RemoveExpertCuratedItemsFromCartDocument} {...props} />
    );
    
export type RemoveExpertCuratedItemsFromCartProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables>> & TChildProps;
export function withRemoveExpertCuratedItemsFromCart<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RemoveExpertCuratedItemsFromCartMutation,
  RemoveExpertCuratedItemsFromCartMutationVariables,
  RemoveExpertCuratedItemsFromCartProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, RemoveExpertCuratedItemsFromCartMutation, RemoveExpertCuratedItemsFromCartMutationVariables, RemoveExpertCuratedItemsFromCartProps<TChildProps>>(RemoveExpertCuratedItemsFromCartDocument, {
      alias: 'withRemoveExpertCuratedItemsFromCart',
      ...operationOptions
    });
};
export const SelectExpertCuratedOrderVariationOptionDocument = gql`
    mutation SelectExpertCuratedOrderVariationOption($input: SelectExpertCuratedOrderVariationOptionInput!) {
  selectExpertCuratedOrderVariationOption(input: $input) {
    expertCuratedOrder {
      ...ExpertCuratedOrder
    }
  }
}
    ${ExpertCuratedOrderFragmentDoc}`;
export type SelectExpertCuratedOrderVariationOptionMutationFn = ReactApollo.MutationFn<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>;
export type SelectExpertCuratedOrderVariationOptionComponentProps = Omit<Omit<ReactApollo.MutationProps<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SelectExpertCuratedOrderVariationOptionMutationVariables };

    export const SelectExpertCuratedOrderVariationOptionComponent = (props: SelectExpertCuratedOrderVariationOptionComponentProps) => (
      <ReactApollo.Mutation<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables> mutation={SelectExpertCuratedOrderVariationOptionDocument} {...props} />
    );
    
export type SelectExpertCuratedOrderVariationOptionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables>> & TChildProps;
export function withSelectExpertCuratedOrderVariationOption<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SelectExpertCuratedOrderVariationOptionMutation,
  SelectExpertCuratedOrderVariationOptionMutationVariables,
  SelectExpertCuratedOrderVariationOptionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SelectExpertCuratedOrderVariationOptionMutation, SelectExpertCuratedOrderVariationOptionMutationVariables, SelectExpertCuratedOrderVariationOptionProps<TChildProps>>(SelectExpertCuratedOrderVariationOptionDocument, {
      alias: 'withSelectExpertCuratedOrderVariationOption',
      ...operationOptions
    });
};
export const ReportPredictedLifeTimeValueToPlatformDocument = gql`
    mutation ReportPredictedLifeTimeValueToPlatform($input: ReportPredictedLifeTimeValueInput!) {
  reportPredictedLifeTimeValueToPlatform(input: $input) {
    predictedLifeTimeValues {
      id
      userId
      ltvType
      pLTV {
        amount
        currency
      }
    }
  }
}
    `;
export type ReportPredictedLifeTimeValueToPlatformMutationFn = ReactApollo.MutationFn<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>;
export type ReportPredictedLifeTimeValueToPlatformComponentProps = Omit<Omit<ReactApollo.MutationProps<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>, 'mutation'>, 'variables'> & { variables?: ReportPredictedLifeTimeValueToPlatformMutationVariables };

    export const ReportPredictedLifeTimeValueToPlatformComponent = (props: ReportPredictedLifeTimeValueToPlatformComponentProps) => (
      <ReactApollo.Mutation<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables> mutation={ReportPredictedLifeTimeValueToPlatformDocument} {...props} />
    );
    
export type ReportPredictedLifeTimeValueToPlatformProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables>> & TChildProps;
export function withReportPredictedLifeTimeValueToPlatform<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ReportPredictedLifeTimeValueToPlatformMutation,
  ReportPredictedLifeTimeValueToPlatformMutationVariables,
  ReportPredictedLifeTimeValueToPlatformProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, ReportPredictedLifeTimeValueToPlatformMutation, ReportPredictedLifeTimeValueToPlatformMutationVariables, ReportPredictedLifeTimeValueToPlatformProps<TChildProps>>(ReportPredictedLifeTimeValueToPlatformDocument, {
      alias: 'withReportPredictedLifeTimeValueToPlatform',
      ...operationOptions
    });
};
export const ExpertCuratedItemsForLeadDocument = gql`
    query ExpertCuratedItemsForLead($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    byCategories {
      id
      categories {
        ...ExpertCuratedItemByCategory
      }
    }
  }
  lead(id: $leadId) {
    ...CuratedItemsLead
  }
}
    ${ExpertCuratedItemByCategoryFragmentDoc}
${CuratedItemsLeadFragmentDoc}`;
export type ExpertCuratedItemsForLeadComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>, 'query'>, 'variables'> & { variables: ExpertCuratedItemsForLeadQueryVariables };

    export const ExpertCuratedItemsForLeadComponent = (props: ExpertCuratedItemsForLeadComponentProps) => (
      <ReactApollo.Query<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables> query={ExpertCuratedItemsForLeadDocument} {...props} />
    );
    
export type ExpertCuratedItemsForLeadProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables>> & TChildProps;
export function withExpertCuratedItemsForLead<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertCuratedItemsForLeadQuery,
  ExpertCuratedItemsForLeadQueryVariables,
  ExpertCuratedItemsForLeadProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertCuratedItemsForLeadQuery, ExpertCuratedItemsForLeadQueryVariables, ExpertCuratedItemsForLeadProps<TChildProps>>(ExpertCuratedItemsForLeadDocument, {
      alias: 'withExpertCuratedItemsForLead',
      ...operationOptions
    });
};
export const RemoveExpertCuratedItemFromListDocument = gql`
    mutation RemoveExpertCuratedItemFromList($id: ExpertCuratedItemId!, $reason: ExpertCuratedItemRemovedReason!, $otherReason: String) {
  removeExpertCuratedItem(input: {id: $id, reason: $reason, otherReason: $otherReason}) {
    expertCuratedItemsByCategories {
      id
      categories {
        ...ExpertCuratedItemByCategory
      }
    }
  }
}
    ${ExpertCuratedItemByCategoryFragmentDoc}`;
export type RemoveExpertCuratedItemFromListMutationFn = ReactApollo.MutationFn<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>;
export type RemoveExpertCuratedItemFromListComponentProps = Omit<Omit<ReactApollo.MutationProps<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>, 'mutation'>, 'variables'> & { variables?: RemoveExpertCuratedItemFromListMutationVariables };

    export const RemoveExpertCuratedItemFromListComponent = (props: RemoveExpertCuratedItemFromListComponentProps) => (
      <ReactApollo.Mutation<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables> mutation={RemoveExpertCuratedItemFromListDocument} {...props} />
    );
    
export type RemoveExpertCuratedItemFromListProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables>> & TChildProps;
export function withRemoveExpertCuratedItemFromList<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RemoveExpertCuratedItemFromListMutation,
  RemoveExpertCuratedItemFromListMutationVariables,
  RemoveExpertCuratedItemFromListProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, RemoveExpertCuratedItemFromListMutation, RemoveExpertCuratedItemFromListMutationVariables, RemoveExpertCuratedItemFromListProps<TChildProps>>(RemoveExpertCuratedItemFromListDocument, {
      alias: 'withRemoveExpertCuratedItemFromList',
      ...operationOptions
    });
};
export const CurationItemsDocument = gql`
    query CurationItems($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    items {
      id
    }
  }
  expertCuratedOrdersForLeadConnection(query: {leadId: $leadId, showClosed: true}) {
    edges {
      node {
        id
      }
    }
  }
}
    `;
export type CurationItemsComponentProps = Omit<Omit<ReactApollo.QueryProps<CurationItemsQuery, CurationItemsQueryVariables>, 'query'>, 'variables'> & { variables: CurationItemsQueryVariables };

    export const CurationItemsComponent = (props: CurationItemsComponentProps) => (
      <ReactApollo.Query<CurationItemsQuery, CurationItemsQueryVariables> query={CurationItemsDocument} {...props} />
    );
    
export type CurationItemsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CurationItemsQuery, CurationItemsQueryVariables>> & TChildProps;
export function withCurationItems<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CurationItemsQuery,
  CurationItemsQueryVariables,
  CurationItemsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CurationItemsQuery, CurationItemsQueryVariables, CurationItemsProps<TChildProps>>(CurationItemsDocument, {
      alias: 'withCurationItems',
      ...operationOptions
    });
};
export const DepartmentInfoDocument = gql`
    query DepartmentInfo($departmentSlug: String!) {
  departmentBySlug(slug: $departmentSlug) {
    id
    displayName
    sellableSearchFacets(query: {maxFacetTerms: 100}) {
      name
      displayName
      selections {
        ...DepartmentSearchFacetSelections
      }
    }
    topLevelCategory {
      ...DepartmentTopLevelCategory
    }
    mostRecentLeadForConsumer {
      ...DepartmentLead
    }
    ...DepartmentContext
  }
  recommendedLists(first: 20, query: {departmentSlug: $departmentSlug, types: [CUSTOM]}) {
    edges {
      node {
        ...RecommendedList
      }
    }
  }
}
    ${DepartmentSearchFacetSelectionsFragmentDoc}
${DepartmentTopLevelCategoryFragmentDoc}
${DepartmentLeadFragmentDoc}
${DepartmentContextFragmentDoc}
${RecommendedListFragmentDoc}`;
export type DepartmentInfoComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentInfoQuery, DepartmentInfoQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentInfoQueryVariables };

    export const DepartmentInfoComponent = (props: DepartmentInfoComponentProps) => (
      <ReactApollo.Query<DepartmentInfoQuery, DepartmentInfoQueryVariables> query={DepartmentInfoDocument} {...props} />
    );
    
export type DepartmentInfoProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentInfoQuery, DepartmentInfoQueryVariables>> & TChildProps;
export function withDepartmentInfo<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentInfoQuery,
  DepartmentInfoQueryVariables,
  DepartmentInfoProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentInfoQuery, DepartmentInfoQueryVariables, DepartmentInfoProps<TChildProps>>(DepartmentInfoDocument, {
      alias: 'withDepartmentInfo',
      ...operationOptions
    });
};
export const DepartmentSavedSellablesDocument = gql`
    query DepartmentSavedSellables($query: SavedSellableQueryInput!) {
  savedSellablesConnection(query: $query) {
    edges {
      node {
        id
        sellable {
          ...SellableCard
        }
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type DepartmentSavedSellablesComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentSavedSellablesQueryVariables };

    export const DepartmentSavedSellablesComponent = (props: DepartmentSavedSellablesComponentProps) => (
      <ReactApollo.Query<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables> query={DepartmentSavedSellablesDocument} {...props} />
    );
    
export type DepartmentSavedSellablesProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables>> & TChildProps;
export function withDepartmentSavedSellables<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentSavedSellablesQuery,
  DepartmentSavedSellablesQueryVariables,
  DepartmentSavedSellablesProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentSavedSellablesQuery, DepartmentSavedSellablesQueryVariables, DepartmentSavedSellablesProps<TChildProps>>(DepartmentSavedSellablesDocument, {
      alias: 'withDepartmentSavedSellables',
      ...operationOptions
    });
};
export const InfiniteScrollSellablesDocument = gql`
    query InfiniteScrollSellables($categoryIds: [CategoryId!], $after: String, $filters: [SellableSearchFilter!]) {
  searchSellables(query: {categoryIds: $categoryIds, sellableSearchUseCase: CONSUMER_SEARCH, filters: $filters}, first: 10, after: $after) {
    count
    edges {
      cursor
      node {
        ...SellableCard
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${SellableCardFragmentDoc}
${PageInfoFragmentDoc}`;
export type InfiniteScrollSellablesComponentProps = Omit<Omit<ReactApollo.QueryProps<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>, 'query'>, 'variables'> & { variables?: InfiniteScrollSellablesQueryVariables };

    export const InfiniteScrollSellablesComponent = (props: InfiniteScrollSellablesComponentProps) => (
      <ReactApollo.Query<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables> query={InfiniteScrollSellablesDocument} {...props} />
    );
    
export type InfiniteScrollSellablesProps<TChildProps = {}> = Partial<ReactApollo.DataProps<InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables>> & TChildProps;
export function withInfiniteScrollSellables<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  InfiniteScrollSellablesQuery,
  InfiniteScrollSellablesQueryVariables,
  InfiniteScrollSellablesProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, InfiniteScrollSellablesQuery, InfiniteScrollSellablesQueryVariables, InfiniteScrollSellablesProps<TChildProps>>(InfiniteScrollSellablesDocument, {
      alias: 'withInfiniteScrollSellables',
      ...operationOptions
    });
};
export const YachtSearchBarFacetsDocument = gql`
    query YachtSearchBarFacets {
  departmentBySlug(slug: "yacht-charters") {
    id
    sellableSearchFacets(query: {}) {
      name
      displayName
      selections {
        name
        displayName
        bucketValues
        lower
        upper
      }
    }
  }
}
    `;
export type YachtSearchBarFacetsComponentProps = Omit<Omit<ReactApollo.QueryProps<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>, 'query'>, 'variables'> & { variables?: YachtSearchBarFacetsQueryVariables };

    export const YachtSearchBarFacetsComponent = (props: YachtSearchBarFacetsComponentProps) => (
      <ReactApollo.Query<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables> query={YachtSearchBarFacetsDocument} {...props} />
    );
    
export type YachtSearchBarFacetsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables>> & TChildProps;
export function withYachtSearchBarFacets<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  YachtSearchBarFacetsQuery,
  YachtSearchBarFacetsQueryVariables,
  YachtSearchBarFacetsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, YachtSearchBarFacetsQuery, YachtSearchBarFacetsQueryVariables, YachtSearchBarFacetsProps<TChildProps>>(YachtSearchBarFacetsDocument, {
      alias: 'withYachtSearchBarFacets',
      ...operationOptions
    });
};
export const ExpertTopBrandsDocument = gql`
    query ExpertTopBrands($query: ExpertTopRecommendedBrandsInput!) {
  expertTopRecommendedBrands(query: $query) {
    topRecommendedBrands {
      brand {
        id
        displayName
        name
        logo {
          ...MediaFile
        }
      }
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type ExpertTopBrandsComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>, 'query'>, 'variables'> & { variables: ExpertTopBrandsQueryVariables };

    export const ExpertTopBrandsComponent = (props: ExpertTopBrandsComponentProps) => (
      <ReactApollo.Query<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables> query={ExpertTopBrandsDocument} {...props} />
    );
    
export type ExpertTopBrandsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables>> & TChildProps;
export function withExpertTopBrands<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertTopBrandsQuery,
  ExpertTopBrandsQueryVariables,
  ExpertTopBrandsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertTopBrandsQuery, ExpertTopBrandsQueryVariables, ExpertTopBrandsProps<TChildProps>>(ExpertTopBrandsDocument, {
      alias: 'withExpertTopBrands',
      ...operationOptions
    });
};
export const GetExpertProfileDocument = gql`
    query GetExpertProfile($vanityIdOrId: String!) {
  findExpert(vanityIdOrId: $vanityIdOrId) {
    ...ExpertBusinessUser
  }
}
    ${ExpertBusinessUserFragmentDoc}`;
export type GetExpertProfileComponentProps = Omit<Omit<ReactApollo.QueryProps<GetExpertProfileQuery, GetExpertProfileQueryVariables>, 'query'>, 'variables'> & { variables: GetExpertProfileQueryVariables };

    export const GetExpertProfileComponent = (props: GetExpertProfileComponentProps) => (
      <ReactApollo.Query<GetExpertProfileQuery, GetExpertProfileQueryVariables> query={GetExpertProfileDocument} {...props} />
    );
    
export type GetExpertProfileProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetExpertProfileQuery, GetExpertProfileQueryVariables>> & TChildProps;
export function withGetExpertProfile<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  GetExpertProfileQuery,
  GetExpertProfileQueryVariables,
  GetExpertProfileProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, GetExpertProfileQuery, GetExpertProfileQueryVariables, GetExpertProfileProps<TChildProps>>(GetExpertProfileDocument, {
      alias: 'withGetExpertProfile',
      ...operationOptions
    });
};
export const ExpertTopRecommendedSellablesDocument = gql`
    query ExpertTopRecommendedSellables($query: ExpertTopRecommendedSellablesInput!) {
  expertTopRecommendedSellables(query: $query) {
    categoryTopRecommendedSellables {
      ...ExpertTopSellables
    }
  }
}
    ${ExpertTopSellablesFragmentDoc}`;
export type ExpertTopRecommendedSellablesComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>, 'query'>, 'variables'> & { variables: ExpertTopRecommendedSellablesQueryVariables };

    export const ExpertTopRecommendedSellablesComponent = (props: ExpertTopRecommendedSellablesComponentProps) => (
      <ReactApollo.Query<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables> query={ExpertTopRecommendedSellablesDocument} {...props} />
    );
    
export type ExpertTopRecommendedSellablesProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables>> & TChildProps;
export function withExpertTopRecommendedSellables<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertTopRecommendedSellablesQuery,
  ExpertTopRecommendedSellablesQueryVariables,
  ExpertTopRecommendedSellablesProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertTopRecommendedSellablesQuery, ExpertTopRecommendedSellablesQueryVariables, ExpertTopRecommendedSellablesProps<TChildProps>>(ExpertTopRecommendedSellablesDocument, {
      alias: 'withExpertTopRecommendedSellables',
      ...operationOptions
    });
};
export const ExpertFeedDocument = gql`
    query ExpertFeed($query: ConsumerReviewSearchQuery!, $after: String) {
  consumerExpertReviewConnection(query: $query, after: $after, first: 10) {
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        ...ConsumerExpertReview
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ConsumerExpertReviewFragmentDoc}`;
export type ExpertFeedComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertFeedQuery, ExpertFeedQueryVariables>, 'query'>, 'variables'> & { variables: ExpertFeedQueryVariables };

    export const ExpertFeedComponent = (props: ExpertFeedComponentProps) => (
      <ReactApollo.Query<ExpertFeedQuery, ExpertFeedQueryVariables> query={ExpertFeedDocument} {...props} />
    );
    
export type ExpertFeedProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertFeedQuery, ExpertFeedQueryVariables>> & TChildProps;
export function withExpertFeed<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertFeedQuery,
  ExpertFeedQueryVariables,
  ExpertFeedProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertFeedQuery, ExpertFeedQueryVariables, ExpertFeedProps<TChildProps>>(ExpertFeedDocument, {
      alias: 'withExpertFeed',
      ...operationOptions
    });
};
export const MyCurationsDocument = gql`
    query MyCurations($leadId: LeadId!) {
  expertCuratedItemsForLead(leadId: $leadId) {
    items {
      id
      sellable {
        id
        title
        images {
          id
          url
        }
      }
    }
  }
  lead(id: $leadId) {
    id
    expert {
      ...ExpertInfo
    }
    delegateExpert {
      ...ExpertInfo
    }
    category {
      id
      contentAssets {
        bannerImages {
          imageUrl
        }
      }
    }
  }
  expertCuratedOrdersForLeadConnection(query: {leadId: $leadId, showClosed: false}) {
    edges {
      node {
        id
        serviceStartAt
        serviceLocation {
          city
          state
        }
        order {
          id
          title
          primaryImage {
            id
            url
          }
        }
      }
    }
  }
}
    ${ExpertInfoFragmentDoc}`;
export type MyCurationsComponentProps = Omit<Omit<ReactApollo.QueryProps<MyCurationsQuery, MyCurationsQueryVariables>, 'query'>, 'variables'> & { variables: MyCurationsQueryVariables };

    export const MyCurationsComponent = (props: MyCurationsComponentProps) => (
      <ReactApollo.Query<MyCurationsQuery, MyCurationsQueryVariables> query={MyCurationsDocument} {...props} />
    );
    
export type MyCurationsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<MyCurationsQuery, MyCurationsQueryVariables>> & TChildProps;
export function withMyCurations<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  MyCurationsQuery,
  MyCurationsQueryVariables,
  MyCurationsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, MyCurationsQuery, MyCurationsQueryVariables, MyCurationsProps<TChildProps>>(MyCurationsDocument, {
      alias: 'withMyCurations',
      ...operationOptions
    });
};
export const MyFavoritesDocument = gql`
    query MyFavorites {
  savedSellablesConnection(first: 30, query: {}) {
    edges {
      node {
        id
        sellable {
          ...SellableCard
        }
        saved
        savedReason
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type MyFavoritesComponentProps = Omit<Omit<ReactApollo.QueryProps<MyFavoritesQuery, MyFavoritesQueryVariables>, 'query'>, 'variables'> & { variables?: MyFavoritesQueryVariables };

    export const MyFavoritesComponent = (props: MyFavoritesComponentProps) => (
      <ReactApollo.Query<MyFavoritesQuery, MyFavoritesQueryVariables> query={MyFavoritesDocument} {...props} />
    );
    
export type MyFavoritesProps<TChildProps = {}> = Partial<ReactApollo.DataProps<MyFavoritesQuery, MyFavoritesQueryVariables>> & TChildProps;
export function withMyFavorites<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  MyFavoritesQuery,
  MyFavoritesQueryVariables,
  MyFavoritesProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, MyFavoritesQuery, MyFavoritesQueryVariables, MyFavoritesProps<TChildProps>>(MyFavoritesDocument, {
      alias: 'withMyFavorites',
      ...operationOptions
    });
};
export const LatestLeadDocument = gql`
    query LatestLead {
  me {
    id
    user {
      id
      mostRecentLead {
        id
        department {
          id
          slug
        }
      }
    }
  }
}
    `;
export type LatestLeadComponentProps = Omit<Omit<ReactApollo.QueryProps<LatestLeadQuery, LatestLeadQueryVariables>, 'query'>, 'variables'> & { variables?: LatestLeadQueryVariables };

    export const LatestLeadComponent = (props: LatestLeadComponentProps) => (
      <ReactApollo.Query<LatestLeadQuery, LatestLeadQueryVariables> query={LatestLeadDocument} {...props} />
    );
    
export type LatestLeadProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LatestLeadQuery, LatestLeadQueryVariables>> & TChildProps;
export function withLatestLead<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LatestLeadQuery,
  LatestLeadQueryVariables,
  LatestLeadProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LatestLeadQuery, LatestLeadQueryVariables, LatestLeadProps<TChildProps>>(LatestLeadDocument, {
      alias: 'withLatestLead',
      ...operationOptions
    });
};
export const LoggedOutHomeExpertsDocument = gql`
    query LoggedOutHomeExperts($departmentId: DepartmentId!) {
  recommendExpertsForDepartment(departmentId: $departmentId, limit: 2) {
    expert {
      ...LoggedOutHomeExpert
    }
  }
}
    ${LoggedOutHomeExpertFragmentDoc}`;
export type LoggedOutHomeExpertsComponentProps = Omit<Omit<ReactApollo.QueryProps<LoggedOutHomeExpertsQuery, LoggedOutHomeExpertsQueryVariables>, 'query'>, 'variables'> & { variables: LoggedOutHomeExpertsQueryVariables };

    export const LoggedOutHomeExpertsComponent = (props: LoggedOutHomeExpertsComponentProps) => (
      <ReactApollo.Query<LoggedOutHomeExpertsQuery, LoggedOutHomeExpertsQueryVariables> query={LoggedOutHomeExpertsDocument} {...props} />
    );
    
export type LoggedOutHomeExpertsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LoggedOutHomeExpertsQuery, LoggedOutHomeExpertsQueryVariables>> & TChildProps;
export function withLoggedOutHomeExperts<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LoggedOutHomeExpertsQuery,
  LoggedOutHomeExpertsQueryVariables,
  LoggedOutHomeExpertsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LoggedOutHomeExpertsQuery, LoggedOutHomeExpertsQueryVariables, LoggedOutHomeExpertsProps<TChildProps>>(LoggedOutHomeExpertsDocument, {
      alias: 'withLoggedOutHomeExperts',
      ...operationOptions
    });
};
export const LoggedOutHomeFixedExpertsDocument = gql`
    query LoggedOutHomeFixedExperts($ids: [BusinessUserId!]!) {
  businessUsers(ids: $ids) {
    ...LoggedOutHomeFixedExpert
  }
}
    ${LoggedOutHomeFixedExpertFragmentDoc}`;
export type LoggedOutHomeFixedExpertsComponentProps = Omit<Omit<ReactApollo.QueryProps<LoggedOutHomeFixedExpertsQuery, LoggedOutHomeFixedExpertsQueryVariables>, 'query'>, 'variables'> & { variables: LoggedOutHomeFixedExpertsQueryVariables };

    export const LoggedOutHomeFixedExpertsComponent = (props: LoggedOutHomeFixedExpertsComponentProps) => (
      <ReactApollo.Query<LoggedOutHomeFixedExpertsQuery, LoggedOutHomeFixedExpertsQueryVariables> query={LoggedOutHomeFixedExpertsDocument} {...props} />
    );
    
export type LoggedOutHomeFixedExpertsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LoggedOutHomeFixedExpertsQuery, LoggedOutHomeFixedExpertsQueryVariables>> & TChildProps;
export function withLoggedOutHomeFixedExperts<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LoggedOutHomeFixedExpertsQuery,
  LoggedOutHomeFixedExpertsQueryVariables,
  LoggedOutHomeFixedExpertsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LoggedOutHomeFixedExpertsQuery, LoggedOutHomeFixedExpertsQueryVariables, LoggedOutHomeFixedExpertsProps<TChildProps>>(LoggedOutHomeFixedExpertsDocument, {
      alias: 'withLoggedOutHomeFixedExperts',
      ...operationOptions
    });
};
export const LoggedOutHomeDepartmentsDocument = gql`
    query LoggedOutHomeDepartments {
  departmentsForNavigation {
    ...LoggedOutHomeDepartment
  }
}
    ${LoggedOutHomeDepartmentFragmentDoc}`;
export type LoggedOutHomeDepartmentsComponentProps = Omit<Omit<ReactApollo.QueryProps<LoggedOutHomeDepartmentsQuery, LoggedOutHomeDepartmentsQueryVariables>, 'query'>, 'variables'> & { variables?: LoggedOutHomeDepartmentsQueryVariables };

    export const LoggedOutHomeDepartmentsComponent = (props: LoggedOutHomeDepartmentsComponentProps) => (
      <ReactApollo.Query<LoggedOutHomeDepartmentsQuery, LoggedOutHomeDepartmentsQueryVariables> query={LoggedOutHomeDepartmentsDocument} {...props} />
    );
    
export type LoggedOutHomeDepartmentsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LoggedOutHomeDepartmentsQuery, LoggedOutHomeDepartmentsQueryVariables>> & TChildProps;
export function withLoggedOutHomeDepartments<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LoggedOutHomeDepartmentsQuery,
  LoggedOutHomeDepartmentsQueryVariables,
  LoggedOutHomeDepartmentsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LoggedOutHomeDepartmentsQuery, LoggedOutHomeDepartmentsQueryVariables, LoggedOutHomeDepartmentsProps<TChildProps>>(LoggedOutHomeDepartmentsDocument, {
      alias: 'withLoggedOutHomeDepartments',
      ...operationOptions
    });
};
export const LeadsDocument = gql`
    query Leads($consumerId: UserId!, $after: String) {
  leads(query: {consumerId: $consumerId, facetedSearch: false}, first: 50, after: $after) {
    edges {
      node {
        ...LeadOverview
      }
    }
  }
}
    ${LeadOverviewFragmentDoc}`;
export type LeadsComponentProps = Omit<Omit<ReactApollo.QueryProps<LeadsQuery, LeadsQueryVariables>, 'query'>, 'variables'> & { variables: LeadsQueryVariables };

    export const LeadsComponent = (props: LeadsComponentProps) => (
      <ReactApollo.Query<LeadsQuery, LeadsQueryVariables> query={LeadsDocument} {...props} />
    );
    
export type LeadsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<LeadsQuery, LeadsQueryVariables>> & TChildProps;
export function withLeads<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  LeadsQuery,
  LeadsQueryVariables,
  LeadsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, LeadsQuery, LeadsQueryVariables, LeadsProps<TChildProps>>(LeadsDocument, {
      alias: 'withLeads',
      ...operationOptions
    });
};
export const SupportConversationDocument = gql`
    query SupportConversation($consumerId: UserId!) {
  supportConversation(consumerId: $consumerId) {
    ...SupportConversation
  }
}
    ${SupportConversationFragmentDoc}`;
export type SupportConversationComponentProps = Omit<Omit<ReactApollo.QueryProps<SupportConversationQuery, SupportConversationQueryVariables>, 'query'>, 'variables'> & { variables: SupportConversationQueryVariables };

    export const SupportConversationComponent = (props: SupportConversationComponentProps) => (
      <ReactApollo.Query<SupportConversationQuery, SupportConversationQueryVariables> query={SupportConversationDocument} {...props} />
    );
    
export type SupportConversationProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SupportConversationQuery, SupportConversationQueryVariables>> & TChildProps;
export function withSupportConversation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SupportConversationQuery,
  SupportConversationQueryVariables,
  SupportConversationProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SupportConversationQuery, SupportConversationQueryVariables, SupportConversationProps<TChildProps>>(SupportConversationDocument, {
      alias: 'withSupportConversation',
      ...operationOptions
    });
};
export const ExpertByLeadDocument = gql`
    query ExpertByLead($leadId: LeadId!) {
  lead(id: $leadId) {
    id
    latestRequest {
      id
      attributes {
        formatted {
          displayHtml
        }
      }
    }
    department {
      id
      type
    }
    conversation {
      id
    }
    expert {
      id
      firstName
      lastName
      expertAttributes {
        placeholderExpert
      }
      expertProfile {
        id
        profilePhoto {
          ...MediaFile
        }
      }
      expertStats {
        averageRating
        totalReviews
        totalMessages
      }
    }
    category {
      id
      department {
        id
        slug
      }
      slug
      singularDisplayName
      contentAssets {
        modalHeader {
          imageUrl
        }
        fullPageTakeover {
          imageUrl
        }
      }
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type ExpertByLeadComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertByLeadQuery, ExpertByLeadQueryVariables>, 'query'>, 'variables'> & { variables: ExpertByLeadQueryVariables };

    export const ExpertByLeadComponent = (props: ExpertByLeadComponentProps) => (
      <ReactApollo.Query<ExpertByLeadQuery, ExpertByLeadQueryVariables> query={ExpertByLeadDocument} {...props} />
    );
    
export type ExpertByLeadProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertByLeadQuery, ExpertByLeadQueryVariables>> & TChildProps;
export function withExpertByLead<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertByLeadQuery,
  ExpertByLeadQueryVariables,
  ExpertByLeadProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertByLeadQuery, ExpertByLeadQueryVariables, ExpertByLeadProps<TChildProps>>(ExpertByLeadDocument, {
      alias: 'withExpertByLead',
      ...operationOptions
    });
};
export const SetConsumerInitialLeadActionDocument = gql`
    mutation SetConsumerInitialLeadAction($leadId: LeadId!, $action: ConsumerInitialLeadAction!) {
  setConsumerInitialLeadAction(input: {leadId: $leadId, action: $action}) {
    lead {
      id
      conversation {
        id
        externalId
      }
      category {
        id
        slug
      }
    }
  }
}
    `;
export type SetConsumerInitialLeadActionMutationFn = ReactApollo.MutationFn<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>;
export type SetConsumerInitialLeadActionComponentProps = Omit<Omit<ReactApollo.MutationProps<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>, 'mutation'>, 'variables'> & { variables?: SetConsumerInitialLeadActionMutationVariables };

    export const SetConsumerInitialLeadActionComponent = (props: SetConsumerInitialLeadActionComponentProps) => (
      <ReactApollo.Mutation<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables> mutation={SetConsumerInitialLeadActionDocument} {...props} />
    );
    
export type SetConsumerInitialLeadActionProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables>> & TChildProps;
export function withSetConsumerInitialLeadAction<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SetConsumerInitialLeadActionMutation,
  SetConsumerInitialLeadActionMutationVariables,
  SetConsumerInitialLeadActionProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SetConsumerInitialLeadActionMutation, SetConsumerInitialLeadActionMutationVariables, SetConsumerInitialLeadActionProps<TChildProps>>(SetConsumerInitialLeadActionDocument, {
      alias: 'withSetConsumerInitialLeadAction',
      ...operationOptions
    });
};
export const ConversationExpertProfileDocument = gql`
    query ConversationExpertProfile($id: LeadId!) {
  lead(id: $id) {
    ...LeadExpertProfile
  }
  expertCuratedItemsForLead(leadId: $id) {
    items {
      id
    }
  }
}
    ${LeadExpertProfileFragmentDoc}`;
export type ConversationExpertProfileComponentProps = Omit<Omit<ReactApollo.QueryProps<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>, 'query'>, 'variables'> & { variables: ConversationExpertProfileQueryVariables };

    export const ConversationExpertProfileComponent = (props: ConversationExpertProfileComponentProps) => (
      <ReactApollo.Query<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables> query={ConversationExpertProfileDocument} {...props} />
    );
    
export type ConversationExpertProfileProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables>> & TChildProps;
export function withConversationExpertProfile<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ConversationExpertProfileQuery,
  ConversationExpertProfileQueryVariables,
  ConversationExpertProfileProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ConversationExpertProfileQuery, ConversationExpertProfileQueryVariables, ConversationExpertProfileProps<TChildProps>>(ConversationExpertProfileDocument, {
      alias: 'withConversationExpertProfile',
      ...operationOptions
    });
};
export const ConversationDocument = gql`
    query Conversation($id: ConversationId!) {
  conversation(id: $id) {
    ...ConversationWithMetaData
  }
}
    ${ConversationWithMetaDataFragmentDoc}`;
export type ConversationComponentProps = Omit<Omit<ReactApollo.QueryProps<ConversationQuery, ConversationQueryVariables>, 'query'>, 'variables'> & { variables: ConversationQueryVariables };

    export const ConversationComponent = (props: ConversationComponentProps) => (
      <ReactApollo.Query<ConversationQuery, ConversationQueryVariables> query={ConversationDocument} {...props} />
    );
    
export type ConversationProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ConversationQuery, ConversationQueryVariables>> & TChildProps;
export function withConversation<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ConversationQuery,
  ConversationQueryVariables,
  ConversationProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ConversationQuery, ConversationQueryVariables, ConversationProps<TChildProps>>(ConversationDocument, {
      alias: 'withConversation',
      ...operationOptions
    });
};
export const DepartmentSlugByCategorySlugDocument = gql`
    query DepartmentSlugByCategorySlug($categorySlug: String!) {
  categoryBySlug(slug: $categorySlug) {
    department {
      id
      type
      slug
    }
  }
}
    `;
export type DepartmentSlugByCategorySlugComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentSlugByCategorySlugQueryVariables };

    export const DepartmentSlugByCategorySlugComponent = (props: DepartmentSlugByCategorySlugComponentProps) => (
      <ReactApollo.Query<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables> query={DepartmentSlugByCategorySlugDocument} {...props} />
    );
    
export type DepartmentSlugByCategorySlugProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables>> & TChildProps;
export function withDepartmentSlugByCategorySlug<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentSlugByCategorySlugQuery,
  DepartmentSlugByCategorySlugQueryVariables,
  DepartmentSlugByCategorySlugProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentSlugByCategorySlugQuery, DepartmentSlugByCategorySlugQueryVariables, DepartmentSlugByCategorySlugProps<TChildProps>>(DepartmentSlugByCategorySlugDocument, {
      alias: 'withDepartmentSlugByCategorySlug',
      ...operationOptions
    });
};
export const ExpertDepartmentBySlugDocument = gql`
    query ExpertDepartmentBySlug($slug: String!) {
  departmentBySlug(slug: $slug) {
    id
    topLevelCategory {
      id
    }
  }
}
    `;
export type ExpertDepartmentBySlugComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>, 'query'>, 'variables'> & { variables: ExpertDepartmentBySlugQueryVariables };

    export const ExpertDepartmentBySlugComponent = (props: ExpertDepartmentBySlugComponentProps) => (
      <ReactApollo.Query<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables> query={ExpertDepartmentBySlugDocument} {...props} />
    );
    
export type ExpertDepartmentBySlugProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables>> & TChildProps;
export function withExpertDepartmentBySlug<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertDepartmentBySlugQuery,
  ExpertDepartmentBySlugQueryVariables,
  ExpertDepartmentBySlugProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertDepartmentBySlugQuery, ExpertDepartmentBySlugQueryVariables, ExpertDepartmentBySlugProps<TChildProps>>(ExpertDepartmentBySlugDocument, {
      alias: 'withExpertDepartmentBySlug',
      ...operationOptions
    });
};
export const FeaturedExpertsForDepartmentDocument = gql`
    query FeaturedExpertsForDepartment($query: ExpertSearchQuery!, $after: String) {
  expertSearchConnection(query: $query, sortBy: FEATURED, first: 8, last: 8, after: $after) {
    count
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        ...FeaturedExpert
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${FeaturedExpertFragmentDoc}`;
export type FeaturedExpertsForDepartmentComponentProps = Omit<Omit<ReactApollo.QueryProps<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>, 'query'>, 'variables'> & { variables: FeaturedExpertsForDepartmentQueryVariables };

    export const FeaturedExpertsForDepartmentComponent = (props: FeaturedExpertsForDepartmentComponentProps) => (
      <ReactApollo.Query<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables> query={FeaturedExpertsForDepartmentDocument} {...props} />
    );
    
export type FeaturedExpertsForDepartmentProps<TChildProps = {}> = Partial<ReactApollo.DataProps<FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables>> & TChildProps;
export function withFeaturedExpertsForDepartment<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  FeaturedExpertsForDepartmentQuery,
  FeaturedExpertsForDepartmentQueryVariables,
  FeaturedExpertsForDepartmentProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, FeaturedExpertsForDepartmentQuery, FeaturedExpertsForDepartmentQueryVariables, FeaturedExpertsForDepartmentProps<TChildProps>>(FeaturedExpertsForDepartmentDocument, {
      alias: 'withFeaturedExpertsForDepartment',
      ...operationOptions
    });
};
export const InitiateAffirmPaymentForOrderDocument = gql`
    mutation InitiateAffirmPaymentForOrder($input: InitiateAffirmPaymentForOrderInput!) {
  initiateAffirmPaymentForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    checkoutData
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type InitiateAffirmPaymentForOrderMutationFn = ReactApollo.MutationFn<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>;
export type InitiateAffirmPaymentForOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: InitiateAffirmPaymentForOrderMutationVariables };

    export const InitiateAffirmPaymentForOrderComponent = (props: InitiateAffirmPaymentForOrderComponentProps) => (
      <ReactApollo.Mutation<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables> mutation={InitiateAffirmPaymentForOrderDocument} {...props} />
    );
    
export type InitiateAffirmPaymentForOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables>> & TChildProps;
export function withInitiateAffirmPaymentForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  InitiateAffirmPaymentForOrderMutation,
  InitiateAffirmPaymentForOrderMutationVariables,
  InitiateAffirmPaymentForOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, InitiateAffirmPaymentForOrderMutation, InitiateAffirmPaymentForOrderMutationVariables, InitiateAffirmPaymentForOrderProps<TChildProps>>(InitiateAffirmPaymentForOrderDocument, {
      alias: 'withInitiateAffirmPaymentForOrder',
      ...operationOptions
    });
};
export const InitiateAfterpayPaymentForOrderDocument = gql`
    mutation InitiateAfterpayPaymentForOrder($input: InitiateAfterpayPaymentForOrderInput!) {
  initiateAfterpayPaymentForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    orderToken
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type InitiateAfterpayPaymentForOrderMutationFn = ReactApollo.MutationFn<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>;
export type InitiateAfterpayPaymentForOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: InitiateAfterpayPaymentForOrderMutationVariables };

    export const InitiateAfterpayPaymentForOrderComponent = (props: InitiateAfterpayPaymentForOrderComponentProps) => (
      <ReactApollo.Mutation<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables> mutation={InitiateAfterpayPaymentForOrderDocument} {...props} />
    );
    
export type InitiateAfterpayPaymentForOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables>> & TChildProps;
export function withInitiateAfterpayPaymentForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  InitiateAfterpayPaymentForOrderMutation,
  InitiateAfterpayPaymentForOrderMutationVariables,
  InitiateAfterpayPaymentForOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, InitiateAfterpayPaymentForOrderMutation, InitiateAfterpayPaymentForOrderMutationVariables, InitiateAfterpayPaymentForOrderProps<TChildProps>>(InitiateAfterpayPaymentForOrderDocument, {
      alias: 'withInitiateAfterpayPaymentForOrder',
      ...operationOptions
    });
};
export const SyncOrderDocument = gql`
    mutation SyncOrder($input: SyncOrderInput!) {
  syncOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type SyncOrderMutationFn = ReactApollo.MutationFn<SyncOrderMutation, SyncOrderMutationVariables>;
export type SyncOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<SyncOrderMutation, SyncOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: SyncOrderMutationVariables };

    export const SyncOrderComponent = (props: SyncOrderComponentProps) => (
      <ReactApollo.Mutation<SyncOrderMutation, SyncOrderMutationVariables> mutation={SyncOrderDocument} {...props} />
    );
    
export type SyncOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SyncOrderMutation, SyncOrderMutationVariables>> & TChildProps;
export function withSyncOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SyncOrderMutation,
  SyncOrderMutationVariables,
  SyncOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SyncOrderMutation, SyncOrderMutationVariables, SyncOrderProps<TChildProps>>(SyncOrderDocument, {
      alias: 'withSyncOrder',
      ...operationOptions
    });
};
export const GetOrderDocument = gql`
    query GetOrder($id: OrderId!) {
  order(id: $id) {
    ...OrderWithLineItems
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type GetOrderComponentProps = Omit<Omit<ReactApollo.QueryProps<GetOrderQuery, GetOrderQueryVariables>, 'query'>, 'variables'> & { variables: GetOrderQueryVariables };

    export const GetOrderComponent = (props: GetOrderComponentProps) => (
      <ReactApollo.Query<GetOrderQuery, GetOrderQueryVariables> query={GetOrderDocument} {...props} />
    );
    
export type GetOrderProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetOrderQuery, GetOrderQueryVariables>> & TChildProps;
export function withGetOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  GetOrderQuery,
  GetOrderQueryVariables,
  GetOrderProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, GetOrderQuery, GetOrderQueryVariables, GetOrderProps<TChildProps>>(GetOrderDocument, {
      alias: 'withGetOrder',
      ...operationOptions
    });
};
export const PaymentSourceForReviewDocument = gql`
    query PaymentSourceForReview($id: PaymentSourceId!) {
  paymentSource(id: $id) {
    ...PaymentSource
  }
}
    ${PaymentSourceFragmentDoc}`;
export type PaymentSourceForReviewComponentProps = Omit<Omit<ReactApollo.QueryProps<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>, 'query'>, 'variables'> & { variables: PaymentSourceForReviewQueryVariables };

    export const PaymentSourceForReviewComponent = (props: PaymentSourceForReviewComponentProps) => (
      <ReactApollo.Query<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables> query={PaymentSourceForReviewDocument} {...props} />
    );
    
export type PaymentSourceForReviewProps<TChildProps = {}> = Partial<ReactApollo.DataProps<PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables>> & TChildProps;
export function withPaymentSourceForReview<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  PaymentSourceForReviewQuery,
  PaymentSourceForReviewQueryVariables,
  PaymentSourceForReviewProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, PaymentSourceForReviewQuery, PaymentSourceForReviewQueryVariables, PaymentSourceForReviewProps<TChildProps>>(PaymentSourceForReviewDocument, {
      alias: 'withPaymentSourceForReview',
      ...operationOptions
    });
};
export const InitiatePaypalPaymentForOrderDocument = gql`
    mutation InitiatePaypalPaymentForOrder($input: InitiatePaypalPaymentForOrderInput!) {
  initiatePaypalPaymentForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    paymentId
    authorizationUrl
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type InitiatePaypalPaymentForOrderMutationFn = ReactApollo.MutationFn<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>;
export type InitiatePaypalPaymentForOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: InitiatePaypalPaymentForOrderMutationVariables };

    export const InitiatePaypalPaymentForOrderComponent = (props: InitiatePaypalPaymentForOrderComponentProps) => (
      <ReactApollo.Mutation<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables> mutation={InitiatePaypalPaymentForOrderDocument} {...props} />
    );
    
export type InitiatePaypalPaymentForOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables>> & TChildProps;
export function withInitiatePaypalPaymentForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  InitiatePaypalPaymentForOrderMutation,
  InitiatePaypalPaymentForOrderMutationVariables,
  InitiatePaypalPaymentForOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, InitiatePaypalPaymentForOrderMutation, InitiatePaypalPaymentForOrderMutationVariables, InitiatePaypalPaymentForOrderProps<TChildProps>>(InitiatePaypalPaymentForOrderDocument, {
      alias: 'withInitiatePaypalPaymentForOrder',
      ...operationOptions
    });
};
export const AddPromotionToOrderDocument = gql`
    mutation AddPromotionToOrder($id: OrderId!, $promotionCode: String!) {
  addPromotionToOrder(input: {id: $id, promotionCode: $promotionCode}) {
    order {
      ...OrderWithLineItems
    }
    hasError
    errorMessage
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type AddPromotionToOrderMutationFn = ReactApollo.MutationFn<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>;
export type AddPromotionToOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: AddPromotionToOrderMutationVariables };

    export const AddPromotionToOrderComponent = (props: AddPromotionToOrderComponentProps) => (
      <ReactApollo.Mutation<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables> mutation={AddPromotionToOrderDocument} {...props} />
    );
    
export type AddPromotionToOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables>> & TChildProps;
export function withAddPromotionToOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AddPromotionToOrderMutation,
  AddPromotionToOrderMutationVariables,
  AddPromotionToOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, AddPromotionToOrderMutation, AddPromotionToOrderMutationVariables, AddPromotionToOrderProps<TChildProps>>(AddPromotionToOrderDocument, {
      alias: 'withAddPromotionToOrder',
      ...operationOptions
    });
};
export const DeletePaymentSourceDocument = gql`
    mutation DeletePaymentSource($id: PaymentSourceId!) {
  deletePaymentSource(id: $id) {
    error
    success
  }
}
    `;
export type DeletePaymentSourceMutationFn = ReactApollo.MutationFn<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>;
export type DeletePaymentSourceComponentProps = Omit<Omit<ReactApollo.MutationProps<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>, 'mutation'>, 'variables'> & { variables?: DeletePaymentSourceMutationVariables };

    export const DeletePaymentSourceComponent = (props: DeletePaymentSourceComponentProps) => (
      <ReactApollo.Mutation<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables> mutation={DeletePaymentSourceDocument} {...props} />
    );
    
export type DeletePaymentSourceProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>> & TChildProps;
export function withDeletePaymentSource<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DeletePaymentSourceMutation,
  DeletePaymentSourceMutationVariables,
  DeletePaymentSourceProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables, DeletePaymentSourceProps<TChildProps>>(DeletePaymentSourceDocument, {
      alias: 'withDeletePaymentSource',
      ...operationOptions
    });
};
export const UpdateAddressPreferencesDocument = gql`
    mutation UpdateAddressPreferences($input: UpdateAddressPreferencesInput!) {
  updateAddressPreferences(input: $input) {
    updatedAddress {
      ...Address
    }
    error
  }
}
    ${AddressFragmentDoc}`;
export type UpdateAddressPreferencesMutationFn = ReactApollo.MutationFn<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>;
export type UpdateAddressPreferencesComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateAddressPreferencesMutationVariables };

    export const UpdateAddressPreferencesComponent = (props: UpdateAddressPreferencesComponentProps) => (
      <ReactApollo.Mutation<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables> mutation={UpdateAddressPreferencesDocument} {...props} />
    );
    
export type UpdateAddressPreferencesProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables>> & TChildProps;
export function withUpdateAddressPreferences<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateAddressPreferencesMutation,
  UpdateAddressPreferencesMutationVariables,
  UpdateAddressPreferencesProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateAddressPreferencesMutation, UpdateAddressPreferencesMutationVariables, UpdateAddressPreferencesProps<TChildProps>>(UpdateAddressPreferencesDocument, {
      alias: 'withUpdateAddressPreferences',
      ...operationOptions
    });
};
export const UpdateOrderShippingAddressDocument = gql`
    mutation UpdateOrderShippingAddress($input: UpdateOrderShippingAddressInput!) {
  updateOrderShippingAddress(input: $input) {
    order {
      ...OrderWithLineItems
    }
    hasError
    errorMessage
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type UpdateOrderShippingAddressMutationFn = ReactApollo.MutationFn<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>;
export type UpdateOrderShippingAddressComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateOrderShippingAddressMutationVariables };

    export const UpdateOrderShippingAddressComponent = (props: UpdateOrderShippingAddressComponentProps) => (
      <ReactApollo.Mutation<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables> mutation={UpdateOrderShippingAddressDocument} {...props} />
    );
    
export type UpdateOrderShippingAddressProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>> & TChildProps;
export function withUpdateOrderShippingAddress<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateOrderShippingAddressMutation,
  UpdateOrderShippingAddressMutationVariables,
  UpdateOrderShippingAddressProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables, UpdateOrderShippingAddressProps<TChildProps>>(UpdateOrderShippingAddressDocument, {
      alias: 'withUpdateOrderShippingAddress',
      ...operationOptions
    });
};
export const OrderShippingCostDocument = gql`
    query OrderShippingCost($id: OrderId!, $orderShippingCostAddress: OrderShippingCostAddressInput) {
  orderShippingCost(id: $id, orderShippingCostAddress: $orderShippingCostAddress) {
    shippingMethodCosts {
      ...ShippingMethodCost
    }
  }
}
    ${ShippingMethodCostFragmentDoc}`;
export type OrderShippingCostComponentProps = Omit<Omit<ReactApollo.QueryProps<OrderShippingCostQuery, OrderShippingCostQueryVariables>, 'query'>, 'variables'> & { variables: OrderShippingCostQueryVariables };

    export const OrderShippingCostComponent = (props: OrderShippingCostComponentProps) => (
      <ReactApollo.Query<OrderShippingCostQuery, OrderShippingCostQueryVariables> query={OrderShippingCostDocument} {...props} />
    );
    
export type OrderShippingCostProps<TChildProps = {}> = Partial<ReactApollo.DataProps<OrderShippingCostQuery, OrderShippingCostQueryVariables>> & TChildProps;
export function withOrderShippingCost<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  OrderShippingCostQuery,
  OrderShippingCostQueryVariables,
  OrderShippingCostProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, OrderShippingCostQuery, OrderShippingCostQueryVariables, OrderShippingCostProps<TChildProps>>(OrderShippingCostDocument, {
      alias: 'withOrderShippingCost',
      ...operationOptions
    });
};
export const UpdateShippingMethodDocument = gql`
    mutation UpdateShippingMethod($orderId: OrderId!, $shippingMethod: ShippingMethod!) {
  updateShippingMethod(input: {orderId: $orderId, shippingMethod: $shippingMethod}) {
    order {
      id
      shippingMethod
      lineItems {
        ...OrderLineItem
      }
      totalShippingCost: totalCostOnlyIncluding(costComponents: [SHIPMENT]) {
        ...MonetaryAmount
      }
    }
  }
}
    ${OrderLineItemFragmentDoc}
${MonetaryAmountFragmentDoc}`;
export type UpdateShippingMethodMutationFn = ReactApollo.MutationFn<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>;
export type UpdateShippingMethodComponentProps = Omit<Omit<ReactApollo.MutationProps<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>, 'mutation'>, 'variables'> & { variables?: UpdateShippingMethodMutationVariables };

    export const UpdateShippingMethodComponent = (props: UpdateShippingMethodComponentProps) => (
      <ReactApollo.Mutation<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables> mutation={UpdateShippingMethodDocument} {...props} />
    );
    
export type UpdateShippingMethodProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>> & TChildProps;
export function withUpdateShippingMethod<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  UpdateShippingMethodMutation,
  UpdateShippingMethodMutationVariables,
  UpdateShippingMethodProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables, UpdateShippingMethodProps<TChildProps>>(UpdateShippingMethodDocument, {
      alias: 'withUpdateShippingMethod',
      ...operationOptions
    });
};
export const ReusablePaymentSourcesDocument = gql`
    query ReusablePaymentSources {
  reusablePaymentSources {
    ...PaymentSource
  }
}
    ${PaymentSourceFragmentDoc}`;
export type ReusablePaymentSourcesComponentProps = Omit<Omit<ReactApollo.QueryProps<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>, 'query'>, 'variables'> & { variables?: ReusablePaymentSourcesQueryVariables };

    export const ReusablePaymentSourcesComponent = (props: ReusablePaymentSourcesComponentProps) => (
      <ReactApollo.Query<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables> query={ReusablePaymentSourcesDocument} {...props} />
    );
    
export type ReusablePaymentSourcesProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables>> & TChildProps;
export function withReusablePaymentSources<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ReusablePaymentSourcesQuery,
  ReusablePaymentSourcesQueryVariables,
  ReusablePaymentSourcesProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ReusablePaymentSourcesQuery, ReusablePaymentSourcesQueryVariables, ReusablePaymentSourcesProps<TChildProps>>(ReusablePaymentSourcesDocument, {
      alias: 'withReusablePaymentSources',
      ...operationOptions
    });
};
export const InitiateWireTransferForOrderDocument = gql`
    mutation InitiateWireTransferForOrder($input: InitiateWireTransferPaymentForOrderInput!) {
  initiateWireTransferPaymentForOrder(input: $input) {
    paymentSource {
      id
    }
  }
}
    `;
export type InitiateWireTransferForOrderMutationFn = ReactApollo.MutationFn<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>;
export type InitiateWireTransferForOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: InitiateWireTransferForOrderMutationVariables };

    export const InitiateWireTransferForOrderComponent = (props: InitiateWireTransferForOrderComponentProps) => (
      <ReactApollo.Mutation<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables> mutation={InitiateWireTransferForOrderDocument} {...props} />
    );
    
export type InitiateWireTransferForOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables>> & TChildProps;
export function withInitiateWireTransferForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  InitiateWireTransferForOrderMutation,
  InitiateWireTransferForOrderMutationVariables,
  InitiateWireTransferForOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, InitiateWireTransferForOrderMutation, InitiateWireTransferForOrderMutationVariables, InitiateWireTransferForOrderProps<TChildProps>>(InitiateWireTransferForOrderDocument, {
      alias: 'withInitiateWireTransferForOrder',
      ...operationOptions
    });
};
export const SubmitWireOrderDocument = gql`
    mutation SubmitWireOrder($input: SubmitOrderInput!) {
  submitOrder(input: $input) {
    order {
      ...TrackableOrder
    }
  }
}
    ${TrackableOrderFragmentDoc}`;
export type SubmitWireOrderMutationFn = ReactApollo.MutationFn<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>;
export type SubmitWireOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: SubmitWireOrderMutationVariables };

    export const SubmitWireOrderComponent = (props: SubmitWireOrderComponentProps) => (
      <ReactApollo.Mutation<SubmitWireOrderMutation, SubmitWireOrderMutationVariables> mutation={SubmitWireOrderDocument} {...props} />
    );
    
export type SubmitWireOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<SubmitWireOrderMutation, SubmitWireOrderMutationVariables>> & TChildProps;
export function withSubmitWireOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SubmitWireOrderMutation,
  SubmitWireOrderMutationVariables,
  SubmitWireOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, SubmitWireOrderMutation, SubmitWireOrderMutationVariables, SubmitWireOrderProps<TChildProps>>(SubmitWireOrderDocument, {
      alias: 'withSubmitWireOrder',
      ...operationOptions
    });
};
export const AddTipToOrderDocument = gql`
    mutation AddTipToOrder($input: AddTipToOrderInput!) {
  addTipToOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type AddTipToOrderMutationFn = ReactApollo.MutationFn<AddTipToOrderMutation, AddTipToOrderMutationVariables>;
export type AddTipToOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<AddTipToOrderMutation, AddTipToOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: AddTipToOrderMutationVariables };

    export const AddTipToOrderComponent = (props: AddTipToOrderComponentProps) => (
      <ReactApollo.Mutation<AddTipToOrderMutation, AddTipToOrderMutationVariables> mutation={AddTipToOrderDocument} {...props} />
    );
    
export type AddTipToOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<AddTipToOrderMutation, AddTipToOrderMutationVariables>> & TChildProps;
export function withAddTipToOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  AddTipToOrderMutation,
  AddTipToOrderMutationVariables,
  AddTipToOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, AddTipToOrderMutation, AddTipToOrderMutationVariables, AddTipToOrderProps<TChildProps>>(AddTipToOrderDocument, {
      alias: 'withAddTipToOrder',
      ...operationOptions
    });
};
export const RecommendTipPercentagesForOrderDocument = gql`
    query RecommendTipPercentagesForOrder($id: OrderId!) {
  recommendTipPercentagesForOrder(id: $id) {
    ...ExpertTipPercentage
  }
}
    ${ExpertTipPercentageFragmentDoc}`;
export type RecommendTipPercentagesForOrderComponentProps = Omit<Omit<ReactApollo.QueryProps<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>, 'query'>, 'variables'> & { variables: RecommendTipPercentagesForOrderQueryVariables };

    export const RecommendTipPercentagesForOrderComponent = (props: RecommendTipPercentagesForOrderComponentProps) => (
      <ReactApollo.Query<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables> query={RecommendTipPercentagesForOrderDocument} {...props} />
    );
    
export type RecommendTipPercentagesForOrderProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables>> & TChildProps;
export function withRecommendTipPercentagesForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RecommendTipPercentagesForOrderQuery,
  RecommendTipPercentagesForOrderQueryVariables,
  RecommendTipPercentagesForOrderProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RecommendTipPercentagesForOrderQuery, RecommendTipPercentagesForOrderQueryVariables, RecommendTipPercentagesForOrderProps<TChildProps>>(RecommendTipPercentagesForOrderDocument, {
      alias: 'withRecommendTipPercentagesForOrder',
      ...operationOptions
    });
};
export const CancelPaymentRequestForOrderDocument = gql`
    mutation CancelPaymentRequestForOrder($input: CancelPaymentRequestForOrderInput!) {
  cancelPaymentRequestForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type CancelPaymentRequestForOrderMutationFn = ReactApollo.MutationFn<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>;
export type CancelPaymentRequestForOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: CancelPaymentRequestForOrderMutationVariables };

    export const CancelPaymentRequestForOrderComponent = (props: CancelPaymentRequestForOrderComponentProps) => (
      <ReactApollo.Mutation<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables> mutation={CancelPaymentRequestForOrderDocument} {...props} />
    );
    
export type CancelPaymentRequestForOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables>> & TChildProps;
export function withCancelPaymentRequestForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CancelPaymentRequestForOrderMutation,
  CancelPaymentRequestForOrderMutationVariables,
  CancelPaymentRequestForOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, CancelPaymentRequestForOrderMutation, CancelPaymentRequestForOrderMutationVariables, CancelPaymentRequestForOrderProps<TChildProps>>(CancelPaymentRequestForOrderDocument, {
      alias: 'withCancelPaymentRequestForOrder',
      ...operationOptions
    });
};
export const DeleteAddressDocument = gql`
    mutation DeleteAddress($input: DeleteAddressInput!) {
  deleteAddress(input: $input) {
    error
    success
  }
}
    `;
export type DeleteAddressMutationFn = ReactApollo.MutationFn<DeleteAddressMutation, DeleteAddressMutationVariables>;
export type DeleteAddressComponentProps = Omit<Omit<ReactApollo.MutationProps<DeleteAddressMutation, DeleteAddressMutationVariables>, 'mutation'>, 'variables'> & { variables?: DeleteAddressMutationVariables };

    export const DeleteAddressComponent = (props: DeleteAddressComponentProps) => (
      <ReactApollo.Mutation<DeleteAddressMutation, DeleteAddressMutationVariables> mutation={DeleteAddressDocument} {...props} />
    );
    
export type DeleteAddressProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<DeleteAddressMutation, DeleteAddressMutationVariables>> & TChildProps;
export function withDeleteAddress<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DeleteAddressMutation,
  DeleteAddressMutationVariables,
  DeleteAddressProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, DeleteAddressMutation, DeleteAddressMutationVariables, DeleteAddressProps<TChildProps>>(DeleteAddressDocument, {
      alias: 'withDeleteAddress',
      ...operationOptions
    });
};
export const MarkPaymentPreApprovalFailedForOrderDocument = gql`
    mutation MarkPaymentPreApprovalFailedForOrder($input: MarkPaymentPreApprovalFailedForOrderInput!) {
  markPaymentPreApprovalFailedForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type MarkPaymentPreApprovalFailedForOrderMutationFn = ReactApollo.MutationFn<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>;
export type MarkPaymentPreApprovalFailedForOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: MarkPaymentPreApprovalFailedForOrderMutationVariables };

    export const MarkPaymentPreApprovalFailedForOrderComponent = (props: MarkPaymentPreApprovalFailedForOrderComponentProps) => (
      <ReactApollo.Mutation<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables> mutation={MarkPaymentPreApprovalFailedForOrderDocument} {...props} />
    );
    
export type MarkPaymentPreApprovalFailedForOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables>> & TChildProps;
export function withMarkPaymentPreApprovalFailedForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  MarkPaymentPreApprovalFailedForOrderMutation,
  MarkPaymentPreApprovalFailedForOrderMutationVariables,
  MarkPaymentPreApprovalFailedForOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, MarkPaymentPreApprovalFailedForOrderMutation, MarkPaymentPreApprovalFailedForOrderMutationVariables, MarkPaymentPreApprovalFailedForOrderProps<TChildProps>>(MarkPaymentPreApprovalFailedForOrderDocument, {
      alias: 'withMarkPaymentPreApprovalFailedForOrder',
      ...operationOptions
    });
};
export const PayForOrderDocument = gql`
    mutation PayForOrder($input: PayForOrderInput!) {
  payForOrder(input: $input) {
    order {
      ...OrderWithLineItems
    }
    error
  }
}
    ${OrderWithLineItemsFragmentDoc}`;
export type PayForOrderMutationFn = ReactApollo.MutationFn<PayForOrderMutation, PayForOrderMutationVariables>;
export type PayForOrderComponentProps = Omit<Omit<ReactApollo.MutationProps<PayForOrderMutation, PayForOrderMutationVariables>, 'mutation'>, 'variables'> & { variables?: PayForOrderMutationVariables };

    export const PayForOrderComponent = (props: PayForOrderComponentProps) => (
      <ReactApollo.Mutation<PayForOrderMutation, PayForOrderMutationVariables> mutation={PayForOrderDocument} {...props} />
    );
    
export type PayForOrderProps<TChildProps = {}> = Partial<ReactApollo.MutateProps<PayForOrderMutation, PayForOrderMutationVariables>> & TChildProps;
export function withPayForOrder<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  PayForOrderMutation,
  PayForOrderMutationVariables,
  PayForOrderProps<TChildProps>>) {
    return ReactApollo.withMutation<TProps, PayForOrderMutation, PayForOrderMutationVariables, PayForOrderProps<TChildProps>>(PayForOrderDocument, {
      alias: 'withPayForOrder',
      ...operationOptions
    });
};
export const DiamondCertificateUrlDocument = gql`
    query DiamondCertificateUrl($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    certificateUrl
  }
}
    `;
export type DiamondCertificateUrlComponentProps = Omit<Omit<ReactApollo.QueryProps<DiamondCertificateUrlQuery, DiamondCertificateUrlQueryVariables>, 'query'>, 'variables'> & { variables: DiamondCertificateUrlQueryVariables };

    export const DiamondCertificateUrlComponent = (props: DiamondCertificateUrlComponentProps) => (
      <ReactApollo.Query<DiamondCertificateUrlQuery, DiamondCertificateUrlQueryVariables> query={DiamondCertificateUrlDocument} {...props} />
    );
    
export type DiamondCertificateUrlProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DiamondCertificateUrlQuery, DiamondCertificateUrlQueryVariables>> & TChildProps;
export function withDiamondCertificateUrl<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DiamondCertificateUrlQuery,
  DiamondCertificateUrlQueryVariables,
  DiamondCertificateUrlProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DiamondCertificateUrlQuery, DiamondCertificateUrlQueryVariables, DiamondCertificateUrlProps<TChildProps>>(DiamondCertificateUrlDocument, {
      alias: 'withDiamondCertificateUrl',
      ...operationOptions
    });
};
export const ExpertSellableNotesDocument = gql`
    query ExpertSellableNotes($query: SuggestExpertCuratedItemNotesQueryInput!) {
  suggestExpertCuratedItemNotes(query: $query, sort: USAGES) {
    edges {
      node {
        ...ExpertCuratedItemNote
      }
    }
  }
}
    ${ExpertCuratedItemNoteFragmentDoc}`;
export type ExpertSellableNotesComponentProps = Omit<Omit<ReactApollo.QueryProps<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>, 'query'>, 'variables'> & { variables: ExpertSellableNotesQueryVariables };

    export const ExpertSellableNotesComponent = (props: ExpertSellableNotesComponentProps) => (
      <ReactApollo.Query<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables> query={ExpertSellableNotesDocument} {...props} />
    );
    
export type ExpertSellableNotesProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables>> & TChildProps;
export function withExpertSellableNotes<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ExpertSellableNotesQuery,
  ExpertSellableNotesQueryVariables,
  ExpertSellableNotesProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ExpertSellableNotesQuery, ExpertSellableNotesQueryVariables, ExpertSellableNotesProps<TChildProps>>(ExpertSellableNotesDocument, {
      alias: 'withExpertSellableNotes',
      ...operationOptions
    });
};
export const RecommendedProductsByCategoryDocument = gql`
    query RecommendedProductsByCategory($query: RecommendedListsQuery!) {
  recommendedLists(query: $query) {
    edges {
      cursor
      node {
        displayName
        recommendedListDefinition {
          id
          rank
        }
        sellables {
          ...SellableCard
        }
      }
    }
  }
}
    ${SellableCardFragmentDoc}`;
export type RecommendedProductsByCategoryComponentProps = Omit<Omit<ReactApollo.QueryProps<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>, 'query'>, 'variables'> & { variables: RecommendedProductsByCategoryQueryVariables };

    export const RecommendedProductsByCategoryComponent = (props: RecommendedProductsByCategoryComponentProps) => (
      <ReactApollo.Query<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables> query={RecommendedProductsByCategoryDocument} {...props} />
    );
    
export type RecommendedProductsByCategoryProps<TChildProps = {}> = Partial<ReactApollo.DataProps<RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables>> & TChildProps;
export function withRecommendedProductsByCategory<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  RecommendedProductsByCategoryQuery,
  RecommendedProductsByCategoryQueryVariables,
  RecommendedProductsByCategoryProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, RecommendedProductsByCategoryQuery, RecommendedProductsByCategoryQueryVariables, RecommendedProductsByCategoryProps<TChildProps>>(RecommendedProductsByCategoryDocument, {
      alias: 'withRecommendedProductsByCategory',
      ...operationOptions
    });
};
export const Diamond360VideoDocument = gql`
    query Diamond360Video($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    dynamic360ViewUrl
  }
}
    `;
export type Diamond360VideoComponentProps = Omit<Omit<ReactApollo.QueryProps<Diamond360VideoQuery, Diamond360VideoQueryVariables>, 'query'>, 'variables'> & { variables: Diamond360VideoQueryVariables };

    export const Diamond360VideoComponent = (props: Diamond360VideoComponentProps) => (
      <ReactApollo.Query<Diamond360VideoQuery, Diamond360VideoQueryVariables> query={Diamond360VideoDocument} {...props} />
    );
    
export type Diamond360VideoProps<TChildProps = {}> = Partial<ReactApollo.DataProps<Diamond360VideoQuery, Diamond360VideoQueryVariables>> & TChildProps;
export function withDiamond360Video<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  Diamond360VideoQuery,
  Diamond360VideoQueryVariables,
  Diamond360VideoProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, Diamond360VideoQuery, Diamond360VideoQueryVariables, Diamond360VideoProps<TChildProps>>(Diamond360VideoDocument, {
      alias: 'withDiamond360Video',
      ...operationOptions
    });
};
export const ProductByFriendlyIdOrIdDocument = gql`
    query ProductByFriendlyIdOrId($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    ...SellableDetails
  }
}
    ${SellableDetailsFragmentDoc}`;
export type ProductByFriendlyIdOrIdComponentProps = Omit<Omit<ReactApollo.QueryProps<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>, 'query'>, 'variables'> & { variables: ProductByFriendlyIdOrIdQueryVariables };

    export const ProductByFriendlyIdOrIdComponent = (props: ProductByFriendlyIdOrIdComponentProps) => (
      <ReactApollo.Query<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables> query={ProductByFriendlyIdOrIdDocument} {...props} />
    );
    
export type ProductByFriendlyIdOrIdProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables>> & TChildProps;
export function withProductByFriendlyIdOrId<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ProductByFriendlyIdOrIdQuery,
  ProductByFriendlyIdOrIdQueryVariables,
  ProductByFriendlyIdOrIdProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ProductByFriendlyIdOrIdQuery, ProductByFriendlyIdOrIdQueryVariables, ProductByFriendlyIdOrIdProps<TChildProps>>(ProductByFriendlyIdOrIdDocument, {
      alias: 'withProductByFriendlyIdOrId',
      ...operationOptions
    });
};
export const ProductExpertDocument = gql`
    query ProductExpert($consumerId: UserId!, $categoryId: CategoryId!) {
  recommendExpert2(consumerId: $consumerId, categoryId: $categoryId) {
    ...ProductRecommendedExpert
  }
}
    ${ProductRecommendedExpertFragmentDoc}`;
export type ProductExpertComponentProps = Omit<Omit<ReactApollo.QueryProps<ProductExpertQuery, ProductExpertQueryVariables>, 'query'>, 'variables'> & { variables: ProductExpertQueryVariables };

    export const ProductExpertComponent = (props: ProductExpertComponentProps) => (
      <ReactApollo.Query<ProductExpertQuery, ProductExpertQueryVariables> query={ProductExpertDocument} {...props} />
    );
    
export type ProductExpertProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ProductExpertQuery, ProductExpertQueryVariables>> & TChildProps;
export function withProductExpert<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  ProductExpertQuery,
  ProductExpertQueryVariables,
  ProductExpertProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, ProductExpertQuery, ProductExpertQueryVariables, ProductExpertProps<TChildProps>>(ProductExpertDocument, {
      alias: 'withProductExpert',
      ...operationOptions
    });
};
export const CommunityAggregateStatsDocument = gql`
    query CommunityAggregateStats {
  aggregateExpertReport {
    globalStats {
      ...GlobalStats
    }
  }
}
    ${GlobalStatsFragmentDoc}`;
export type CommunityAggregateStatsComponentProps = Omit<Omit<ReactApollo.QueryProps<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>, 'query'>, 'variables'> & { variables?: CommunityAggregateStatsQueryVariables };

    export const CommunityAggregateStatsComponent = (props: CommunityAggregateStatsComponentProps) => (
      <ReactApollo.Query<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables> query={CommunityAggregateStatsDocument} {...props} />
    );
    
export type CommunityAggregateStatsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables>> & TChildProps;
export function withCommunityAggregateStats<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  CommunityAggregateStatsQuery,
  CommunityAggregateStatsQueryVariables,
  CommunityAggregateStatsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, CommunityAggregateStatsQuery, CommunityAggregateStatsQueryVariables, CommunityAggregateStatsProps<TChildProps>>(CommunityAggregateStatsDocument, {
      alias: 'withCommunityAggregateStats',
      ...operationOptions
    });
};
export const DepartmentBySlugDocument = gql`
    query DepartmentBySlug($slug: String!) {
  departmentBySlug(slug: $slug) {
    ...DepartmentContext
    mostRecentLeadForConsumer {
      id
      expert {
        ...CommunityLeadExpert
      }
    }
    topLevelCategories {
      ...TopLevelCategory
    }
  }
}
    ${DepartmentContextFragmentDoc}
${CommunityLeadExpertFragmentDoc}
${TopLevelCategoryFragmentDoc}`;
export type DepartmentBySlugComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentBySlugQueryVariables };

    export const DepartmentBySlugComponent = (props: DepartmentBySlugComponentProps) => (
      <ReactApollo.Query<DepartmentBySlugQuery, DepartmentBySlugQueryVariables> query={DepartmentBySlugDocument} {...props} />
    );
    
export type DepartmentBySlugProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentBySlugQuery, DepartmentBySlugQueryVariables>> & TChildProps;
export function withDepartmentBySlug<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentBySlugQuery,
  DepartmentBySlugQueryVariables,
  DepartmentBySlugProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentBySlugQuery, DepartmentBySlugQueryVariables, DepartmentBySlugProps<TChildProps>>(DepartmentBySlugDocument, {
      alias: 'withDepartmentBySlug',
      ...operationOptions
    });
};
export const DepartmentCuratedActivityFeedDocument = gql`
    query DepartmentCuratedActivityFeed($query: ConsumerReviewSearchQuery!, $after: String, $sortBy: ConsumerReviewSearchSort!) {
  consumerExpertReviewConnection(query: $query, after: $after, first: 10, sortBy: $sortBy) {
    pageInfo {
      ...PageInfo
    }
    count
    facets {
      ... on BucketedDisplayFacet {
        ...ReviewSummaryBuckets
      }
      displayName
      alias
      name
    }
    edges {
      cursor
      node {
        ...ConsumerExpertReview
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ReviewSummaryBucketsFragmentDoc}
${ConsumerExpertReviewFragmentDoc}`;
export type DepartmentCuratedActivityFeedComponentProps = Omit<Omit<ReactApollo.QueryProps<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>, 'query'>, 'variables'> & { variables: DepartmentCuratedActivityFeedQueryVariables };

    export const DepartmentCuratedActivityFeedComponent = (props: DepartmentCuratedActivityFeedComponentProps) => (
      <ReactApollo.Query<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables> query={DepartmentCuratedActivityFeedDocument} {...props} />
    );
    
export type DepartmentCuratedActivityFeedProps<TChildProps = {}> = Partial<ReactApollo.DataProps<DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables>> & TChildProps;
export function withDepartmentCuratedActivityFeed<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  DepartmentCuratedActivityFeedQuery,
  DepartmentCuratedActivityFeedQueryVariables,
  DepartmentCuratedActivityFeedProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, DepartmentCuratedActivityFeedQuery, DepartmentCuratedActivityFeedQueryVariables, DepartmentCuratedActivityFeedProps<TChildProps>>(DepartmentCuratedActivityFeedDocument, {
      alias: 'withDepartmentCuratedActivityFeed',
      ...operationOptions
    });
};
export const SellableByIdDocument = gql`
    query SellableById($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    friendlyId
    slug
    type
  }
}
    `;
export type SellableByIdComponentProps = Omit<Omit<ReactApollo.QueryProps<SellableByIdQuery, SellableByIdQueryVariables>, 'query'>, 'variables'> & { variables: SellableByIdQueryVariables };

    export const SellableByIdComponent = (props: SellableByIdComponentProps) => (
      <ReactApollo.Query<SellableByIdQuery, SellableByIdQueryVariables> query={SellableByIdDocument} {...props} />
    );
    
export type SellableByIdProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SellableByIdQuery, SellableByIdQueryVariables>> & TChildProps;
export function withSellableById<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SellableByIdQuery,
  SellableByIdQueryVariables,
  SellableByIdProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SellableByIdQuery, SellableByIdQueryVariables, SellableByIdProps<TChildProps>>(SellableByIdDocument, {
      alias: 'withSellableById',
      ...operationOptions
    });
};
export const SearchOrderEscalationsDocument = gql`
    query SearchOrderEscalations($pageSize: Int = 100, $userIds: [UserId!]) {
  orderEscalations(query: {userIds: $userIds, facetedSearch: false}, first: $pageSize) {
    edges {
      ...OrderEscalationSearchResult
    }
  }
}
    ${OrderEscalationSearchResultFragmentDoc}`;
export type SearchOrderEscalationsComponentProps = Omit<Omit<ReactApollo.QueryProps<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>, 'query'>, 'variables'> & { variables?: SearchOrderEscalationsQueryVariables };

    export const SearchOrderEscalationsComponent = (props: SearchOrderEscalationsComponentProps) => (
      <ReactApollo.Query<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables> query={SearchOrderEscalationsDocument} {...props} />
    );
    
export type SearchOrderEscalationsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables>> & TChildProps;
export function withSearchOrderEscalations<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SearchOrderEscalationsQuery,
  SearchOrderEscalationsQueryVariables,
  SearchOrderEscalationsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SearchOrderEscalationsQuery, SearchOrderEscalationsQueryVariables, SearchOrderEscalationsProps<TChildProps>>(SearchOrderEscalationsDocument, {
      alias: 'withSearchOrderEscalations',
      ...operationOptions
    });
};
export const SellableDetailsForExpertItemDocument = gql`
    query SellableDetailsForExpertItem($friendlyIdOrId: String!) {
  findSellable(friendlyIdOrId: $friendlyIdOrId) {
    id
    title
    images {
      ...MediaFile
    }
    ...SellablePricing
  }
}
    ${MediaFileFragmentDoc}
${SellablePricingFragmentDoc}`;
export type SellableDetailsForExpertItemComponentProps = Omit<Omit<ReactApollo.QueryProps<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>, 'query'>, 'variables'> & { variables: SellableDetailsForExpertItemQueryVariables };

    export const SellableDetailsForExpertItemComponent = (props: SellableDetailsForExpertItemComponentProps) => (
      <ReactApollo.Query<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables> query={SellableDetailsForExpertItemDocument} {...props} />
    );
    
export type SellableDetailsForExpertItemProps<TChildProps = {}> = Partial<ReactApollo.DataProps<SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables>> & TChildProps;
export function withSellableDetailsForExpertItem<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  SellableDetailsForExpertItemQuery,
  SellableDetailsForExpertItemQueryVariables,
  SellableDetailsForExpertItemProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, SellableDetailsForExpertItemQuery, SellableDetailsForExpertItemQueryVariables, SellableDetailsForExpertItemProps<TChildProps>>(SellableDetailsForExpertItemDocument, {
      alias: 'withSellableDetailsForExpertItem',
      ...operationOptions
    });
};
export const TopicExpertsDocument = gql`
    query TopicExperts($departmentId: DepartmentId!) {
  recommendExpertsForDepartment(departmentId: $departmentId, limit: 6) {
    expert {
      ...TopicPageExpert
    }
  }
}
    ${TopicPageExpertFragmentDoc}`;
export type TopicExpertsComponentProps = Omit<Omit<ReactApollo.QueryProps<TopicExpertsQuery, TopicExpertsQueryVariables>, 'query'>, 'variables'> & { variables: TopicExpertsQueryVariables };

    export const TopicExpertsComponent = (props: TopicExpertsComponentProps) => (
      <ReactApollo.Query<TopicExpertsQuery, TopicExpertsQueryVariables> query={TopicExpertsDocument} {...props} />
    );
    
export type TopicExpertsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<TopicExpertsQuery, TopicExpertsQueryVariables>> & TChildProps;
export function withTopicExperts<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  TopicExpertsQuery,
  TopicExpertsQueryVariables,
  TopicExpertsProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, TopicExpertsQuery, TopicExpertsQueryVariables, TopicExpertsProps<TChildProps>>(TopicExpertsDocument, {
      alias: 'withTopicExperts',
      ...operationOptions
    });
};
export const GetSessionIdDocument = gql`
    query GetSessionId {
  session {
    id
  }
}
    `;
export type GetSessionIdComponentProps = Omit<Omit<ReactApollo.QueryProps<GetSessionIdQuery, GetSessionIdQueryVariables>, 'query'>, 'variables'> & { variables?: GetSessionIdQueryVariables };

    export const GetSessionIdComponent = (props: GetSessionIdComponentProps) => (
      <ReactApollo.Query<GetSessionIdQuery, GetSessionIdQueryVariables> query={GetSessionIdDocument} {...props} />
    );
    
export type GetSessionIdProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetSessionIdQuery, GetSessionIdQueryVariables>> & TChildProps;
export function withGetSessionId<TProps, TChildProps = {}>(operationOptions?: ReactApollo.OperationOption<
  TProps,
  GetSessionIdQuery,
  GetSessionIdQueryVariables,
  GetSessionIdProps<TChildProps>>) {
    return ReactApollo.withQuery<TProps, GetSessionIdQuery, GetSessionIdQueryVariables, GetSessionIdProps<TChildProps>>(GetSessionIdDocument, {
      alias: 'withGetSessionId',
      ...operationOptions
    });
};